import { jsx as u, Fragment as me, jsxs as V } from "react/jsx-runtime";
import * as M from "react";
import o, { forwardRef as W, useLayoutEffect as J0, useEffect as T, useState as q, useMemo as Ut, createContext as O2, useContext as pt, useCallback as Ft, useRef as It, Children as jt, memo as Rt, PureComponent as gt, isValidElement as L6, cloneElement as w6, createRef as Is, useSyncExternalStore as Tx, useId as bl } from "react";
import { cva as Ye } from "class-variance-authority";
import * as b1 from "react-dom";
import M6, { createPortal as yl } from "react-dom";
function Vx(e, t) {
  const n = M.createContext(t), r = (a) => {
    const { children: c, ...d } = a, f = M.useMemo(() => d, Object.values(d));
    return /* @__PURE__ */ u(n.Provider, { value: f, children: c });
  };
  r.displayName = e + "Provider";
  function i(a) {
    const c = M.useContext(n);
    if (c) return c;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [r, i];
}
function Tt(e, t = []) {
  let n = [];
  function r(a, c) {
    const d = M.createContext(c), f = n.length;
    n = [...n, c];
    const p = (v) => {
      var E;
      const { scope: g, children: w, ...x } = v, b = ((E = g == null ? void 0 : g[e]) == null ? void 0 : E[f]) || d, y = M.useMemo(() => x, Object.values(x));
      return /* @__PURE__ */ u(b.Provider, { value: y, children: w });
    };
    p.displayName = a + "Provider";
    function m(v, g) {
      var b;
      const w = ((b = g == null ? void 0 : g[e]) == null ? void 0 : b[f]) || d, x = M.useContext(w);
      if (x) return x;
      if (c !== void 0) return c;
      throw new Error(`\`${v}\` must be used within \`${a}\``);
    }
    return [p, m];
  }
  const i = () => {
    const a = n.map((c) => M.createContext(c));
    return function(d) {
      const f = (d == null ? void 0 : d[e]) || a;
      return M.useMemo(
        () => ({ [`__scope${e}`]: { ...d, [e]: f } }),
        [d, f]
      );
    };
  };
  return i.scopeName = e, [r, Zx(i, ...t)];
}
function Zx(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(a) {
      const c = r.reduce((d, { useScope: f, scopeName: p }) => {
        const v = f(a)[`__scope${p}`];
        return { ...d, ...v };
      }, {});
      return M.useMemo(() => ({ [`__scope${t.scopeName}`]: c }), [c]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function T4(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Cl(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const a = T4(i, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const a = r[i];
          typeof a == "function" ? a() : T4(e[i], null);
        }
      };
  };
}
function ct(...e) {
  return M.useCallback(Cl(...e), e);
}
// @__NO_SIDE_EFFECTS__
function _r(e) {
  const t = /* @__PURE__ */ $x(e), n = M.forwardRef((r, i) => {
    const { children: a, ...c } = r, d = M.Children.toArray(a), f = d.find(Gx);
    if (f) {
      const p = f.props.children, m = d.map((v) => v === f ? M.Children.count(p) > 1 ? M.Children.only(null) : M.isValidElement(p) ? p.props.children : null : v);
      return /* @__PURE__ */ u(t, { ...c, ref: i, children: M.isValidElement(p) ? M.cloneElement(p, void 0, m) : null });
    }
    return /* @__PURE__ */ u(t, { ...c, ref: i, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
var Ei = /* @__PURE__ */ _r("Slot");
// @__NO_SIDE_EFFECTS__
function $x(e) {
  const t = M.forwardRef((n, r) => {
    const { children: i, ...a } = n;
    if (M.isValidElement(i)) {
      const c = jx(i), d = Ux(a, i.props);
      return i.type !== M.Fragment && (d.ref = r ? Cl(r, c) : c), M.cloneElement(i, d);
    }
    return M.Children.count(i) > 1 ? M.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var x6 = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Wx(e) {
  const t = ({ children: n }) => /* @__PURE__ */ u(me, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = x6, t;
}
function Gx(e) {
  return M.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === x6;
}
function Ux(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? i && a ? n[r] = (...d) => {
      const f = a(...d);
      return i(...d), f;
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...a } : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function jx(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function El(e) {
  const t = e + "CollectionProvider", [n, r] = Tt(t), [i, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), c = (b) => {
    const { scope: y, children: E } = b, z = o.useRef(null), k = o.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ u(i, { scope: y, itemMap: k, collectionRef: z, children: E });
  };
  c.displayName = t;
  const d = e + "CollectionSlot", f = /* @__PURE__ */ _r(d), p = o.forwardRef(
    (b, y) => {
      const { scope: E, children: z } = b, k = a(d, E), R = ct(y, k.collectionRef);
      return /* @__PURE__ */ u(f, { ref: R, children: z });
    }
  );
  p.displayName = d;
  const m = e + "CollectionItemSlot", v = "data-radix-collection-item", g = /* @__PURE__ */ _r(m), w = o.forwardRef(
    (b, y) => {
      const { scope: E, children: z, ...k } = b, R = o.useRef(null), F = ct(y, R), _ = a(m, E);
      return o.useEffect(() => (_.itemMap.set(R, { ref: R, ...k }), () => void _.itemMap.delete(R))), /* @__PURE__ */ u(g, { [v]: "", ref: F, children: z });
    }
  );
  w.displayName = m;
  function x(b) {
    const y = a(e + "CollectionConsumer", b);
    return o.useCallback(() => {
      const z = y.collectionRef.current;
      if (!z) return [];
      const k = Array.from(z.querySelectorAll(`[${v}]`));
      return Array.from(y.itemMap.values()).sort(
        (_, P) => k.indexOf(_.ref.current) - k.indexOf(P.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: c, Slot: p, ItemSlot: w },
    x,
    r
  ];
}
function be(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
var yn = globalThis != null && globalThis.document ? M.useLayoutEffect : () => {
}, Kx = M[" useInsertionEffect ".trim().toString()] || yn;
function Kt({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [i, a, c] = Yx({
    defaultProp: t,
    onChange: n
  }), d = e !== void 0, f = d ? e : i;
  {
    const m = M.useRef(e !== void 0);
    M.useEffect(() => {
      const v = m.current;
      v !== d && console.warn(
        `${r} is changing from ${v ? "controlled" : "uncontrolled"} to ${d ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), m.current = d;
    }, [d, r]);
  }
  const p = M.useCallback(
    (m) => {
      var v;
      if (d) {
        const g = qx(m) ? m(e) : m;
        g !== e && ((v = c.current) == null || v.call(c, g));
      } else
        a(m);
    },
    [d, e, a, c]
  );
  return [f, p];
}
function Yx({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = M.useState(e), i = M.useRef(n), a = M.useRef(t);
  return Kx(() => {
    a.current = t;
  }, [t]), M.useEffect(() => {
    var c;
    i.current !== n && ((c = a.current) == null || c.call(a, n), i.current = n);
  }, [n, i]), [n, r, a];
}
function qx(e) {
  return typeof e == "function";
}
var Xx = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], ke = Xx.reduce((e, t) => {
  const n = /* @__PURE__ */ _r(`Primitive.${t}`), r = M.forwardRef((i, a) => {
    const { asChild: c, ...d } = i, f = c ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ u(f, { ...d, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Ts(e, t) {
  e && b1.flushSync(() => e.dispatchEvent(t));
}
function Jx(e, t) {
  return M.useReducer((n, r) => t[n][r] ?? n, e);
}
var Yt = (e) => {
  const { present: t, children: n } = e, r = Qx(t), i = typeof n == "function" ? n({ present: r.isPresent }) : M.Children.only(n), a = ct(r.ref, eb(i));
  return typeof n == "function" || r.isPresent ? M.cloneElement(i, { ref: a }) : null;
};
Yt.displayName = "Presence";
function Qx(e) {
  const [t, n] = M.useState(), r = M.useRef(null), i = M.useRef(e), a = M.useRef("none"), c = e ? "mounted" : "unmounted", [d, f] = Jx(c, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return M.useEffect(() => {
    const p = S0(r.current);
    a.current = d === "mounted" ? p : "none";
  }, [d]), yn(() => {
    const p = r.current, m = i.current;
    if (m !== e) {
      const g = a.current, w = S0(p);
      e ? f("MOUNT") : w === "none" || (p == null ? void 0 : p.display) === "none" ? f("UNMOUNT") : f(m && g !== w ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, f]), yn(() => {
    if (t) {
      let p;
      const m = t.ownerDocument.defaultView ?? window, v = (w) => {
        const b = S0(r.current).includes(w.animationName);
        if (w.target === t && b && (f("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", p = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, g = (w) => {
        w.target === t && (a.current = S0(r.current));
      };
      return t.addEventListener("animationstart", g), t.addEventListener("animationcancel", v), t.addEventListener("animationend", v), () => {
        m.clearTimeout(p), t.removeEventListener("animationstart", g), t.removeEventListener("animationcancel", v), t.removeEventListener("animationend", v);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(d),
    ref: M.useCallback((p) => {
      r.current = p ? getComputedStyle(p) : null, n(p);
    }, [])
  };
}
function S0(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function eb(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var tb = M[" useId ".trim().toString()] || (() => {
}), nb = 0;
function xn(e) {
  const [t, n] = M.useState(tb());
  return yn(() => {
    n((r) => r ?? String(nb++));
  }, [e]), t ? `radix-${t}` : "";
}
var Fl = "Collapsible", [rb, b6] = Tt(Fl), [ib, Vs] = rb(Fl), y6 = M.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: i,
      disabled: a,
      onOpenChange: c,
      ...d
    } = e, [f, p] = Kt({
      prop: r,
      defaultProp: i ?? !1,
      onChange: c,
      caller: Fl
    });
    return /* @__PURE__ */ u(
      ib,
      {
        scope: n,
        disabled: a,
        contentId: xn(),
        open: f,
        onOpenToggle: M.useCallback(() => p((m) => !m), [p]),
        children: /* @__PURE__ */ u(
          ke.div,
          {
            "data-state": $s(f),
            "data-disabled": a ? "" : void 0,
            ...d,
            ref: t
          }
        )
      }
    );
  }
);
y6.displayName = Fl;
var C6 = "CollapsibleTrigger", E6 = M.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, i = Vs(C6, n);
    return /* @__PURE__ */ u(
      ke.button,
      {
        type: "button",
        "aria-controls": i.contentId,
        "aria-expanded": i.open || !1,
        "data-state": $s(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        disabled: i.disabled,
        ...r,
        ref: t,
        onClick: be(e.onClick, i.onOpenToggle)
      }
    );
  }
);
E6.displayName = C6;
var Zs = "CollapsibleContent", F6 = M.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, i = Vs(Zs, e.__scopeCollapsible);
    return /* @__PURE__ */ u(Yt, { present: n || i.open, children: ({ present: a }) => /* @__PURE__ */ u(lb, { ...r, ref: t, present: a }) });
  }
);
F6.displayName = Zs;
var lb = M.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: i, ...a } = e, c = Vs(Zs, n), [d, f] = M.useState(r), p = M.useRef(null), m = ct(t, p), v = M.useRef(0), g = v.current, w = M.useRef(0), x = w.current, b = c.open || d, y = M.useRef(b), E = M.useRef(void 0);
  return M.useEffect(() => {
    const z = requestAnimationFrame(() => y.current = !1);
    return () => cancelAnimationFrame(z);
  }, []), yn(() => {
    const z = p.current;
    if (z) {
      E.current = E.current || {
        transitionDuration: z.style.transitionDuration,
        animationName: z.style.animationName
      }, z.style.transitionDuration = "0s", z.style.animationName = "none";
      const k = z.getBoundingClientRect();
      v.current = k.height, w.current = k.width, y.current || (z.style.transitionDuration = E.current.transitionDuration, z.style.animationName = E.current.animationName), f(r);
    }
  }, [c.open, r]), /* @__PURE__ */ u(
    ke.div,
    {
      "data-state": $s(c.open),
      "data-disabled": c.disabled ? "" : void 0,
      id: c.contentId,
      hidden: !b,
      ...a,
      ref: m,
      style: {
        "--radix-collapsible-content-height": g ? `${g}px` : void 0,
        "--radix-collapsible-content-width": x ? `${x}px` : void 0,
        ...e.style
      },
      children: b && i
    }
  );
});
function $s(e) {
  return e ? "open" : "closed";
}
var ob = y6, ab = E6, sb = F6, cb = M.createContext(void 0);
function Fi(e) {
  const t = M.useContext(cb);
  return e || t || "ltr";
}
var Un = "Accordion", db = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Ws, ub, fb] = El(Un), [zl, iX] = Tt(Un, [
  fb,
  b6
]), Gs = b6(), Us = o.forwardRef(
  (e, t) => {
    const { type: n, ...r } = e, i = r, a = r;
    return /* @__PURE__ */ u(Ws.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ u(vb, { ...a, ref: t }) : /* @__PURE__ */ u(mb, { ...i, ref: t }) });
  }
);
Us.displayName = Un;
var [z6, hb] = zl(Un), [A6, pb] = zl(
  Un,
  { collapsible: !1 }
), mb = o.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: i = () => {
      },
      collapsible: a = !1,
      ...c
    } = e, [d, f] = Kt({
      prop: n,
      defaultProp: r ?? "",
      onChange: i,
      caller: Un
    });
    return /* @__PURE__ */ u(
      z6,
      {
        scope: e.__scopeAccordion,
        value: o.useMemo(() => d ? [d] : [], [d]),
        onItemOpen: f,
        onItemClose: o.useCallback(() => a && f(""), [a, f]),
        children: /* @__PURE__ */ u(A6, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ u(S6, { ...c, ref: t }) })
      }
    );
  }
), vb = o.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: i = () => {
    },
    ...a
  } = e, [c, d] = Kt({
    prop: n,
    defaultProp: r ?? [],
    onChange: i,
    caller: Un
  }), f = o.useCallback(
    (m) => d((v = []) => [...v, m]),
    [d]
  ), p = o.useCallback(
    (m) => d((v = []) => v.filter((g) => g !== m)),
    [d]
  );
  return /* @__PURE__ */ u(
    z6,
    {
      scope: e.__scopeAccordion,
      value: c,
      onItemOpen: f,
      onItemClose: p,
      children: /* @__PURE__ */ u(A6, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ u(S6, { ...a, ref: t }) })
    }
  );
}), [gb, Al] = zl(Un), S6 = o.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: r, dir: i, orientation: a = "vertical", ...c } = e, d = o.useRef(null), f = ct(d, t), p = ub(n), v = Fi(i) === "ltr", g = be(e.onKeyDown, (w) => {
      var O;
      if (!db.includes(w.key)) return;
      const x = w.target, b = p().filter((Z) => {
        var te;
        return !((te = Z.ref.current) != null && te.disabled);
      }), y = b.findIndex((Z) => Z.ref.current === x), E = b.length;
      if (y === -1) return;
      w.preventDefault();
      let z = y;
      const k = 0, R = E - 1, F = () => {
        z = y + 1, z > R && (z = k);
      }, _ = () => {
        z = y - 1, z < k && (z = R);
      };
      switch (w.key) {
        case "Home":
          z = k;
          break;
        case "End":
          z = R;
          break;
        case "ArrowRight":
          a === "horizontal" && (v ? F() : _());
          break;
        case "ArrowDown":
          a === "vertical" && F();
          break;
        case "ArrowLeft":
          a === "horizontal" && (v ? _() : F());
          break;
        case "ArrowUp":
          a === "vertical" && _();
          break;
      }
      const P = z % E;
      (O = b[P].ref.current) == null || O.focus();
    });
    return /* @__PURE__ */ u(
      gb,
      {
        scope: n,
        disabled: r,
        direction: i,
        orientation: a,
        children: /* @__PURE__ */ u(Ws.Slot, { scope: n, children: /* @__PURE__ */ u(
          ke.div,
          {
            ...c,
            "data-orientation": a,
            ref: f,
            onKeyDown: r ? void 0 : g
          }
        ) })
      }
    );
  }
), Q0 = "AccordionItem", [Lb, js] = zl(Q0), Ks = o.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: r, ...i } = e, a = Al(Q0, n), c = hb(Q0, n), d = Gs(n), f = xn(), p = r && c.value.includes(r) || !1, m = a.disabled || e.disabled;
    return /* @__PURE__ */ u(
      Lb,
      {
        scope: n,
        open: p,
        disabled: m,
        triggerId: f,
        children: /* @__PURE__ */ u(
          ob,
          {
            "data-orientation": a.orientation,
            "data-state": _6(p),
            ...d,
            ...i,
            ref: t,
            disabled: m,
            open: p,
            onOpenChange: (v) => {
              v ? c.onItemOpen(r) : c.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
Ks.displayName = Q0;
var k6 = "AccordionHeader", D6 = o.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, i = Al(Un, n), a = js(k6, n);
    return /* @__PURE__ */ u(
      ke.h3,
      {
        "data-orientation": i.orientation,
        "data-state": _6(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
D6.displayName = k6;
var as = "AccordionTrigger", Ys = o.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, i = Al(Un, n), a = js(as, n), c = pb(as, n), d = Gs(n);
    return /* @__PURE__ */ u(Ws.ItemSlot, { scope: n, children: /* @__PURE__ */ u(
      ab,
      {
        "aria-disabled": a.open && !c.collapsible || void 0,
        "data-orientation": i.orientation,
        id: a.triggerId,
        ...d,
        ...r,
        ref: t
      }
    ) });
  }
);
Ys.displayName = as;
var R6 = "AccordionContent", qs = o.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, i = Al(Un, n), a = js(R6, n), c = Gs(n);
    return /* @__PURE__ */ u(
      sb,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": i.orientation,
        ...c,
        ...r,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
qs.displayName = R6;
function _6(e) {
  return e ? "open" : "closed";
}
var wb = Us, Mb = Ks, xb = D6, bb = Ys, yb = qs;
function P6(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = P6(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Cb() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = P6(e)) && (r && (r += " "), r += t);
  return r;
}
const Xs = "-", Eb = (e) => {
  const t = zb(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (c) => {
      const d = c.split(Xs);
      return d[0] === "" && d.length !== 1 && d.shift(), H6(d, t) || Fb(c);
    },
    getConflictingClassGroupIds: (c, d) => {
      const f = n[c] || [];
      return d && r[c] ? [...f, ...r[c]] : f;
    }
  };
}, H6 = (e, t) => {
  var c;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), i = r ? H6(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const a = e.join(Xs);
  return (c = t.validators.find(({
    validator: d
  }) => d(a))) == null ? void 0 : c.classGroupId;
}, V4 = /^\[(.+)\]$/, Fb = (e) => {
  if (V4.test(e)) {
    const t = V4.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, zb = (e) => {
  const {
    theme: t,
    classGroups: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const i in n)
    ss(n[i], r, i, t);
  return r;
}, ss = (e, t, n, r) => {
  e.forEach((i) => {
    if (typeof i == "string") {
      const a = i === "" ? t : Z4(t, i);
      a.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (Ab(i)) {
        ss(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(([a, c]) => {
      ss(c, Z4(t, a), n, r);
    });
  });
}, Z4 = (e, t) => {
  let n = e;
  return t.split(Xs).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, Ab = (e) => e.isThemeGetter, Sb = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const i = (a, c) => {
    n.set(a, c), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let c = n.get(a);
      if (c !== void 0)
        return c;
      if ((c = r.get(a)) !== void 0)
        return i(a, c), c;
    },
    set(a, c) {
      n.has(a) ? n.set(a, c) : i(a, c);
    }
  };
}, cs = "!", ds = ":", kb = ds.length, Db = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: n
  } = e;
  let r = (i) => {
    const a = [];
    let c = 0, d = 0, f = 0, p;
    for (let x = 0; x < i.length; x++) {
      let b = i[x];
      if (c === 0 && d === 0) {
        if (b === ds) {
          a.push(i.slice(f, x)), f = x + kb;
          continue;
        }
        if (b === "/") {
          p = x;
          continue;
        }
      }
      b === "[" ? c++ : b === "]" ? c-- : b === "(" ? d++ : b === ")" && d--;
    }
    const m = a.length === 0 ? i : i.substring(f), v = Rb(m), g = v !== m, w = p && p > f ? p - f : void 0;
    return {
      modifiers: a,
      hasImportantModifier: g,
      baseClassName: v,
      maybePostfixModifierPosition: w
    };
  };
  if (t) {
    const i = t + ds, a = r;
    r = (c) => c.startsWith(i) ? a(c.substring(i.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: c,
      maybePostfixModifierPosition: void 0
    };
  }
  if (n) {
    const i = r;
    r = (a) => n({
      className: a,
      parseClassName: i
    });
  }
  return r;
}, Rb = (e) => e.endsWith(cs) ? e.substring(0, e.length - 1) : e.startsWith(cs) ? e.substring(1) : e, _b = (e) => {
  const t = Object.fromEntries(e.orderSensitiveModifiers.map((r) => [r, !0]));
  return (r) => {
    if (r.length <= 1)
      return r;
    const i = [];
    let a = [];
    return r.forEach((c) => {
      c[0] === "[" || t[c] ? (i.push(...a.sort(), c), a = []) : a.push(c);
    }), i.push(...a.sort()), i;
  };
}, Pb = (e) => ({
  cache: Sb(e.cacheSize),
  parseClassName: Db(e),
  sortModifiers: _b(e),
  ...Eb(e)
}), Hb = /\s+/, Ob = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: i,
    sortModifiers: a
  } = t, c = [], d = e.trim().split(Hb);
  let f = "";
  for (let p = d.length - 1; p >= 0; p -= 1) {
    const m = d[p], {
      isExternal: v,
      modifiers: g,
      hasImportantModifier: w,
      baseClassName: x,
      maybePostfixModifierPosition: b
    } = n(m);
    if (v) {
      f = m + (f.length > 0 ? " " + f : f);
      continue;
    }
    let y = !!b, E = r(y ? x.substring(0, b) : x);
    if (!E) {
      if (!y) {
        f = m + (f.length > 0 ? " " + f : f);
        continue;
      }
      if (E = r(x), !E) {
        f = m + (f.length > 0 ? " " + f : f);
        continue;
      }
      y = !1;
    }
    const z = a(g).join(":"), k = w ? z + cs : z, R = k + E;
    if (c.includes(R))
      continue;
    c.push(R);
    const F = i(E, y);
    for (let _ = 0; _ < F.length; ++_) {
      const P = F[_];
      c.push(k + P);
    }
    f = m + (f.length > 0 ? " " + f : f);
  }
  return f;
};
function Nb() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = O6(t)) && (r && (r += " "), r += n);
  return r;
}
const O6 = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = O6(e[r])) && (n && (n += " "), n += t);
  return n;
};
function Bb(e, ...t) {
  let n, r, i, a = c;
  function c(f) {
    const p = t.reduce((m, v) => v(m), e());
    return n = Pb(p), r = n.cache.get, i = n.cache.set, a = d, d(f);
  }
  function d(f) {
    const p = r(f);
    if (p)
      return p;
    const m = Ob(f, n);
    return i(f, m), m;
  }
  return function() {
    return a(Nb.apply(null, arguments));
  };
}
const St = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, N6 = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, B6 = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Ib = /^\d+\/\d+$/, Tb = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Vb = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Zb = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, $b = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Wb = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, a1 = (e) => Ib.test(e), Ue = (e) => !!e && !Number.isNaN(Number(e)), J2 = (e) => !!e && Number.isInteger(Number(e)), Ma = (e) => e.endsWith("%") && Ue(e.slice(0, -1)), A2 = (e) => Tb.test(e), Gb = () => !0, Ub = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Vb.test(e) && !Zb.test(e)
), I6 = () => !1, jb = (e) => $b.test(e), Kb = (e) => Wb.test(e), Yb = (e) => !Fe(e) && !ze(e), qb = (e) => y1(e, Z6, I6), Fe = (e) => N6.test(e), Ar = (e) => y1(e, $6, Ub), xa = (e) => y1(e, ty, Ue), $4 = (e) => y1(e, T6, I6), Xb = (e) => y1(e, V6, Kb), k0 = (e) => y1(e, W6, jb), ze = (e) => B6.test(e), X1 = (e) => C1(e, $6), Jb = (e) => C1(e, ny), W4 = (e) => C1(e, T6), Qb = (e) => C1(e, Z6), ey = (e) => C1(e, V6), D0 = (e) => C1(e, W6, !0), y1 = (e, t, n) => {
  const r = N6.exec(e);
  return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, C1 = (e, t, n = !1) => {
  const r = B6.exec(e);
  return r ? r[1] ? t(r[1]) : n : !1;
}, T6 = (e) => e === "position" || e === "percentage", V6 = (e) => e === "image" || e === "url", Z6 = (e) => e === "length" || e === "size" || e === "bg-size", $6 = (e) => e === "length", ty = (e) => e === "number", ny = (e) => e === "family-name", W6 = (e) => e === "shadow", ry = () => {
  const e = St("color"), t = St("font"), n = St("text"), r = St("font-weight"), i = St("tracking"), a = St("leading"), c = St("breakpoint"), d = St("container"), f = St("spacing"), p = St("radius"), m = St("shadow"), v = St("inset-shadow"), g = St("text-shadow"), w = St("drop-shadow"), x = St("blur"), b = St("perspective"), y = St("aspect"), E = St("ease"), z = St("animate"), k = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], R = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], F = () => [...R(), ze, Fe], _ = () => ["auto", "hidden", "clip", "visible", "scroll"], P = () => ["auto", "contain", "none"], O = () => [ze, Fe, f], Z = () => [a1, "full", "auto", ...O()], te = () => [J2, "none", "subgrid", ze, Fe], Y = () => ["auto", {
    span: ["full", J2, ze, Fe]
  }, J2, ze, Fe], X = () => [J2, "auto", ze, Fe], re = () => ["auto", "min", "max", "fr", ze, Fe], ee = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], de = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], ae = () => ["auto", ...O()], ge = () => [a1, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...O()], K = () => [e, ze, Fe], J = () => [...R(), W4, $4, {
    position: [ze, Fe]
  }], he = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], ve = () => ["auto", "cover", "contain", Qb, qb, {
    size: [ze, Fe]
  }], Q = () => [Ma, X1, Ar], ie = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    p,
    ze,
    Fe
  ], pe = () => ["", Ue, X1, Ar], U = () => ["solid", "dashed", "dotted", "double"], Me = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], Le = () => [Ue, Ma, W4, $4], xe = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    x,
    ze,
    Fe
  ], Ee = () => ["none", Ue, ze, Fe], ye = () => ["none", Ue, ze, Fe], Be = () => [Ue, ze, Fe], ft = () => [a1, "full", ...O()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [A2],
      breakpoint: [A2],
      color: [Gb],
      container: [A2],
      "drop-shadow": [A2],
      ease: ["in", "out", "in-out"],
      font: [Yb],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [A2],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [A2],
      shadow: [A2],
      spacing: ["px", Ue],
      text: [A2],
      "text-shadow": [A2],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", a1, Fe, ze, y]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Ue, Fe, ze, d]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": k()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": k()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: F()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: _()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": _()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": _()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: P()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": P()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": P()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: Z()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": Z()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": Z()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: Z()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: Z()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: Z()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: Z()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: Z()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: Z()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [J2, "auto", ze, Fe]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [a1, "full", "auto", d, ...O()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [Ue, a1, "auto", "initial", "none", Fe]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", Ue, ze, Fe]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", Ue, ze, Fe]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [J2, "first", "last", "none", ze, Fe]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": te()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: Y()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": X()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": X()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": te()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: Y()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": X()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": X()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": re()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": re()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: O()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": O()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": O()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...ee(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...de(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...de()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...ee()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...de(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...de(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": ee()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...de(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...de()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: O()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: O()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: O()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: O()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: O()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: O()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: O()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: O()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: O()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: ae()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: ae()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: ae()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: ae()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: ae()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: ae()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: ae()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: ae()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: ae()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": O()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": O()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: ge()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [d, "screen", ...ge()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          d,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...ge()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          d,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [c]
          },
          ...ge()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...ge()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...ge()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...ge()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", n, X1, Ar]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [r, ze, xa]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Ma, Fe]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Jb, Fe, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [i, ze, Fe]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [Ue, "none", ze, xa]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          a,
          ...O()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ze, Fe]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", ze, Fe]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: K()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: K()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...U(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [Ue, "from-font", "auto", ze, Ar]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: K()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [Ue, "auto", ze, Fe]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: O()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ze, Fe]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ze, Fe]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: J()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: he()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ve()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, J2, ze, Fe],
          radial: ["", ze, Fe],
          conic: [J2, ze, Fe]
        }, ey, Xb]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: K()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: Q()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: Q()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: Q()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: K()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: K()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: K()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: ie()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": ie()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": ie()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": ie()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": ie()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": ie()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": ie()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": ie()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": ie()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": ie()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": ie()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": ie()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": ie()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": ie()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": ie()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: pe()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": pe()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": pe()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": pe()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": pe()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": pe()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": pe()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": pe()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": pe()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": pe()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": pe()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...U(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...U(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: K()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": K()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": K()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": K()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": K()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": K()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": K()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": K()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": K()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: K()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...U(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Ue, ze, Fe]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", Ue, X1, Ar]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: K()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          m,
          D0,
          k0
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: K()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", v, D0, k0]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": K()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: pe()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: K()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [Ue, Ar]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": K()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": pe()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": K()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", g, D0, k0]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": K()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [Ue, ze, Fe]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Me(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Me()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [Ue]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": Le()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": Le()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": K()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": K()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": Le()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": Le()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": K()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": K()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": Le()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": Le()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": K()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": K()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": Le()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": Le()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": K()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": K()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": Le()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": Le()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": K()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": K()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": Le()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": Le()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": K()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": K()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": Le()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": Le()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": K()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": K()
      }],
      "mask-image-radial": [{
        "mask-radial": [ze, Fe]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": Le()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": Le()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": K()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": K()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": R()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [Ue]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": Le()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": Le()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": K()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": K()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: J()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: he()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: ve()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", ze, Fe]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          ze,
          Fe
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: xe()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [Ue, ze, Fe]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [Ue, ze, Fe]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          w,
          D0,
          k0
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": K()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", Ue, ze, Fe]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [Ue, ze, Fe]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", Ue, ze, Fe]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [Ue, ze, Fe]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", Ue, ze, Fe]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          ze,
          Fe
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": xe()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [Ue, ze, Fe]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [Ue, ze, Fe]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", Ue, ze, Fe]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [Ue, ze, Fe]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", Ue, ze, Fe]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [Ue, ze, Fe]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [Ue, ze, Fe]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", Ue, ze, Fe]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": O()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": O()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": O()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", ze, Fe]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [Ue, "initial", ze, Fe]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", E, ze, Fe]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [Ue, ze, Fe]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", z, ze, Fe]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [b, ze, Fe]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": F()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: Ee()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": Ee()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": Ee()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": Ee()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: ye()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": ye()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": ye()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": ye()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: Be()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": Be()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": Be()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [ze, Fe, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: F()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: ft()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": ft()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": ft()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": ft()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: K()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: K()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ze, Fe]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": O()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": O()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": O()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": O()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": O()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": O()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": O()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": O()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": O()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": O()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": O()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": O()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": O()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": O()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": O()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": O()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": O()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": O()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ze, Fe]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...K()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Ue, X1, Ar, xa]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...K()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, iy = /* @__PURE__ */ Bb(ry);
function S(...e) {
  return iy(Cb(e));
}
const ly = (e) => parseInt(e.replace("px", "")), G4 = (e, t) => {
  e = e.toLowerCase(), t = t.toLowerCase();
  const n = e.length, r = t.length, i = Array.from({ length: n + 1 }, () => Array(r + 1));
  for (let a = 0; a <= n; a++)
    i[a][0] = a;
  for (let a = 0; a <= r; a++)
    i[0][a] = a;
  for (let a = 1; a <= n; a++)
    for (let c = 1; c <= r; c++) {
      const d = e[a - 1] === t[c - 1] ? 0 : 1;
      i[a][c] = Math.min(
        i[a - 1][c] + 1,
        // Deletion
        i[a][c - 1] + 1,
        // Insertion
        i[a - 1][c - 1] + d
        // Substitution
      );
    }
  return i[n][r];
}, H = "currentColor", oy = "0 0 24 24", ay = Ye("inline-flex shrink-0", {
  variants: {
    /** Size of the icon */
    size: {
      xs: "w-3 h-3",
      sm: "w-4 h-4",
      md: "w-5 h-5",
      lg: "w-6 h-6"
    },
    /** Color of the icon */
    color: {
      inherit: "text-inherit",
      default: "text-typography-default",
      muted: "text-typography-muted",
      positive: "text-typography-positive",
      warning: "text-typography-warning",
      negative: "text-typography-negative",
      primary: "text-typography-primary"
    }
  },
  defaultVariants: {
    size: "sm",
    color: "inherit"
  }
});
var sy = /* @__PURE__ */ ((e) => (e.SYSTEM = "System", e.MEANS_OF_TRANSPORT = "Means of Transport", e.TIME = "Time", e.SUSTAINABILITY = "Sustainability", e.DATA = "Data", e.PEOPLE = "People", e.ACTION = "Action", e.LOGISTICS = "Logistics", e.VIEW = "View", e.ALERT = "Alert", e.NOTES = "Notes", e.NAVIGATION = "Navigation", e.LOGOS = "Logos", e))(sy || {});
const fe = ({ size: e = "sm", color: t, ...n }, r, i, a) => /* @__PURE__ */ u(
  "svg",
  {
    ref: r,
    className: S(ay({ size: e, color: t })),
    viewBox: oy,
    role: "img",
    "aria-label": `${a} Icon`,
    ...n,
    children: i
  }
), cy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "m9.615 11.25.216 2.25 1.419-6.864h1.491l1.029 7.614.69-3h5.04v1.5h-3.96l-1.08 3.75h-1.454l-1.182-5.957-1.347 5.389H9.035l-.65-3.182H5.25v-1.5zM21 3H3v18h18zM1.5 1.5v21h21v-21z"
      }
    ),
    "Activity"
  )
), dy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M16.355 6H22.5V1.5H8.465v21h7.89zm-1.5 15V4.5H21V3H9.965v18zM1.5 15h3.822v1.5H1.5zm0-7.5h3.823V9H1.5z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M8.468 3H6v18h2.468zm1.5-1.5v21H4.5v-21zM11.613 21l-.86 1.5H22.5V2L21 4.618V21h-9.386Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M15.25 11a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75m0 6a.75.75 0 0 1 .75-.75h5.75a.75.75 0 0 1 0 1.5H16a.75.75 0 0 1-.75-.75"
        }
      )
    ] }),
    "Agenda"
  )
), uy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          d: "M10.0311 22.4956C9.82374 22.4966 9.62096 22.4344 9.44989 22.3171C9.27883 22.1998 9.14762 22.0332 9.07382 21.8393L7.43973 17.59C7.40663 17.5044 7.356 17.4266 7.29109 17.3617C7.22618 17.2968 7.14841 17.2462 7.06279 17.2131L2.81226 15.5778C2.61864 15.5035 2.45211 15.3722 2.33463 15.2013C2.21716 15.0304 2.15428 14.8278 2.15428 14.6205C2.15428 14.4131 2.21716 14.2105 2.33463 14.0396C2.45211 13.8687 2.61864 13.7374 2.81226 13.6631L7.06156 12.029C7.14718 11.9959 7.22495 11.9453 7.28986 11.8804C7.35477 11.8155 7.4054 11.7377 7.43849 11.6521L9.07382 7.40157C9.14813 7.20795 9.2794 7.04141 9.45032 6.92394C9.62123 6.80647 9.82375 6.74358 10.0311 6.74358C10.2385 6.74358 10.441 6.80647 10.612 6.92394C10.7829 7.04141 10.9141 7.20795 10.9885 7.40157L12.6226 11.6509C12.6556 11.7365 12.7063 11.8143 12.7712 11.8792C12.8361 11.9441 12.9139 11.9947 12.9995 12.0278L17.2242 13.6533C17.4257 13.728 17.5993 13.8629 17.7213 14.0398C17.8434 14.2167 17.908 14.4269 17.9063 14.6418C17.9031 14.8456 17.8389 15.0437 17.7219 15.2106C17.6049 15.3775 17.4405 15.5054 17.25 15.5778L13.0007 17.2119C12.9151 17.245 12.8373 17.2956 12.7724 17.3605C12.7075 17.4254 12.6569 17.5032 12.6238 17.5888L10.9885 21.8393C10.9147 22.0332 10.7834 22.1998 10.6124 22.3171C10.4413 22.4344 10.2385 22.4966 10.0311 22.4956Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M5.10936 8.71436C4.98777 8.71436 4.86903 8.67752 4.7688 8.60869C4.66856 8.53986 4.59153 8.44229 4.54785 8.32881L3.85631 6.53065C3.84132 6.49133 3.81819 6.45561 3.78843 6.42586C3.75867 6.3961 3.72296 6.37296 3.68363 6.35798L1.88548 5.66644C1.77202 5.62275 1.67445 5.54571 1.60564 5.44547C1.53683 5.34524 1.5 5.22651 1.5 5.10493C1.5 4.98334 1.53683 4.86461 1.60564 4.76438C1.67445 4.66414 1.77202 4.5871 1.88548 4.54341L3.68363 3.85188C3.72292 3.83682 3.7586 3.81366 3.78835 3.78391C3.8181 3.75416 3.84125 3.71849 3.85631 3.6792L4.54169 1.89704C4.58035 1.79212 4.64686 1.69972 4.73409 1.62976C4.82131 1.55981 4.92595 1.51495 5.03676 1.5C5.1698 1.48383 5.30442 1.51253 5.41929 1.58156C5.53417 1.65058 5.6227 1.75598 5.67087 1.88104L6.36241 3.6792C6.37747 3.71849 6.40062 3.75416 6.43037 3.78391C6.46012 3.81366 6.4958 3.83682 6.53509 3.85188L8.33324 4.54341C8.4467 4.5871 8.54427 4.66414 8.61308 4.76438C8.68189 4.86461 8.71872 4.98334 8.71872 5.10493C8.71872 5.22651 8.68189 5.34524 8.61308 5.44547C8.54427 5.54571 8.4467 5.62275 8.33324 5.66644L6.53509 6.35798C6.49576 6.37296 6.46005 6.3961 6.43029 6.42586C6.40053 6.45561 6.3774 6.49133 6.36241 6.53065L5.67087 8.32881C5.62719 8.44229 5.55016 8.53986 5.44992 8.60869C5.34969 8.67752 5.23095 8.71436 5.10936 8.71436Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M17.9063 11.9954C17.7736 11.9954 17.6441 11.9551 17.5348 11.88C17.4255 11.8049 17.3415 11.6984 17.2939 11.5746L16.3571 9.13944C16.3406 9.09653 16.3153 9.05756 16.2828 9.02506C16.2503 8.99255 16.2113 8.96724 16.1684 8.95076L13.7333 8.01395C13.6096 7.96628 13.5032 7.88225 13.4282 7.77294C13.3531 7.66363 13.313 7.53416 13.313 7.40157C13.313 7.26899 13.3531 7.13952 13.4282 7.03021C13.5032 6.92089 13.6096 6.83687 13.7333 6.7892L16.1684 5.85239C16.2113 5.83591 16.2503 5.8106 16.2828 5.77809C16.3153 5.74559 16.3406 5.70662 16.3571 5.66371L17.2869 3.2458C17.3294 3.13146 17.402 3.03076 17.4971 2.95442C17.5923 2.87808 17.7063 2.82895 17.8271 2.81226C17.9723 2.79468 18.1192 2.8261 18.2445 2.90152C18.3697 2.97694 18.4662 3.09205 18.5187 3.22857L19.4555 5.66371C19.4719 5.70662 19.4973 5.74559 19.5298 5.77809C19.5623 5.8106 19.6012 5.83591 19.6441 5.85239L22.0793 6.7892C22.203 6.83687 22.3094 6.92089 22.3844 7.03021C22.4594 7.13952 22.4996 7.26899 22.4996 7.40157C22.4996 7.53416 22.4594 7.66363 22.3844 7.77294C22.3094 7.88225 22.203 7.96628 22.0793 8.01395L19.6441 8.95076C19.6012 8.96724 19.5623 8.99255 19.5298 9.02506C19.4973 9.05756 19.4719 9.09653 19.4555 9.13944L18.5187 11.5746C18.4711 11.6984 18.3871 11.8049 18.2778 11.88C18.1684 11.9551 18.0389 11.9954 17.9063 11.9954Z",
          fill: H
        }
      )
    ] }),
    "AI"
  )
), fy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M7.00012 13L13.0001 20L11.3902 21L3.50012 12L11.3902 3L13.0001 4L7.00012 11L21.5001 11L21.5001 13L7.00012 13Z"
      }
    ),
    "ArrowLeft"
  )
), hy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M13.5001 17.5L20.5001 11.5L21.5001 13.1099L12.5001 21L3.50012 13.1099L4.50012 11.5L11.5001 17.5L11.5001 3L13.5001 3L13.5001 17.5Z"
      }
    ),
    "ArrowDown"
  )
), py = W(
  (e, t) => fe(e, t, /* @__PURE__ */ u("path", { fill: H, d: "M19.5 9 12 16.5 4.5 9z" }), "ArrowDropdown")
), my = W(
  (e, t) => fe(e, t, /* @__PURE__ */ u("path", { fill: H, d: "M4.5 16.5 12 9l7.5 7.5z" }), "ArrowDropup")
), vy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M18.0001 11L12.0001 4L13.6101 3L21.5001 12L13.61 21L12.0001 20L18.0001 13L3.50012 13L3.50012 11L18.0001 11Z"
      }
    ),
    "ArrowRight"
  )
), gy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M11.5001 6.5L4.50012 12.5L3.50012 10.8901L12.5001 3L21.5001 10.8901L20.5001 12.5L13.5001 6.5L13.5001 21L11.5001 21L11.5001 6.5Z"
      }
    ),
    "ArrowUp"
  )
), Ly = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M12 2.929A3.57 3.57 0 0 0 8.429 6.5v9.557H7V6.5a5 5 0 0 1 10 0v12.42a3.571 3.571 0 0 1-7.143 0V6.615a2.143 2.143 0 1 1 4.286 0v9.443h-1.429V6.614a.714.714 0 0 0-1.428 0v12.307a2.143 2.143 0 0 0 4.285 0V6.5A3.57 3.57 0 0 0 12 2.929"
      }
    ),
    "Attach"
  )
), wy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M12 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0 1.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12m-4.071 4.333c-2.762 0-5 2.09-5 4.667H1.5c0-3.314 2.878-6 6.429-6h8.142c3.55 0 6.429 2.686 6.429 6h-1.429c0-2.577-2.238-4.667-5-4.667z"
      }
    ),
    "Avatar"
  )
), My = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M3.125 4.5h5.25v18h-5.25zm1.5 1.5v15h2.25V6zm4.75-4.5h5.25v21h-5.25zm1.5 1.5v18h2.25V3zm4.75 4.5h5.25v15h-5.25zm1.5 1.5v12h2.25V9z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M22.5 22.5h-21V21h21z" })
    ] }),
    "BarChart"
  )
), xy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          d: "M21.071 2.929H5.785a2.857 2.857 0 0 0-2.857 2.857v9.071H9.5v1.429h-8v-10.5A4.286 4.286 0 0 1 5.785 1.5H22.5v14.786h-8v-1.429h6.572z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M9.5 19.143H2v-1.429h7.5zm13 0H14v-1.429h8.5zm0 3.286h-21V21h21z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M1.5 21.286V15.57h1.43v5.715H1.5ZM13.429 2.929h-2.857V21h2.857zM9.143 1.5v20.929h5.714V1.5z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M18.157 7.776a3.57 3.57 0 0 1-3.3 4.938v-1.428a2.144 2.144 0 0 0 1.515-3.659A2.14 2.14 0 0 0 14.857 7V5.57a3.57 3.57 0 0 1 3.3 2.205ZM5.843 10.51a3.572 3.572 0 0 1 3.3-4.938V7a2.143 2.143 0 0 0 0 4.286v1.428a3.57 3.57 0 0 1-3.3-2.204"
        }
      )
    ] }),
    "Bill"
  )
), by = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M9.75 19.228V10.9h1.5v8.328zm3 0V10.9h1.5v8.328zM18 6H6v1.5h12zm1.5-1.5V9h-15V4.5z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M16.5 9h-9v12h9zM18 7.5v15H6v-15zM12 3c-.829 0-1.5.669-1.5 1.5H9c0-1.663 1.346-3 3-3s3 1.35 3 3h-1.5c0-.823-.675-1.5-1.5-1.5"
        }
      )
    ] }),
    "Bin"
  )
), yy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M15.209 5.25c.708 0 1.274.577 1.274 1.279v.972h1.747c.708 0 1.275.577 1.275 1.279V9h1.72c.708 0 1.275.578 1.275 1.28l-.001 7.177-1.663 2.794h-7.637l-.223-.247-.032-.035-.089-.099a112 112 0 0 1-1.383-1.568c-.811-.936-1.78-2.087-2.334-2.867l-.004-.006a1.77 1.77 0 0 1 .198-2.27l.028-.029.681-.55a1.27 1.27 0 0 1 1.776.038l.183.185V6.53c0-.702.566-1.28 1.275-1.28zm-1.343 13.501h6.117l1.016-1.707v-6.543h-1.494v2.538h-1.5V9.001h-1.521v4.038h-1.5V6.75H13.5v9.7l-2.605-2.63-.521.42a.27.27 0 0 0-.01.33c.506.713 1.427 1.81 2.241 2.75a122 122 0 0 0 1.261 1.431m-3.122-5.084.003.003zm1.031-8.631-5.479 5.37L4.12 8.26l1.054-1.067L6.3 8.302l4.425-4.338z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M11.25 18.75H22.5v3.75H11.25zm1.5 1.5V21H21v-.75zM1.5 3.75A2.25 2.25 0 0 1 3.75 1.5h10.5a2.25 2.25 0 0 1 2.25 2.25v.75H15v-.75a.75.75 0 0 0-.75-.75H3.75a.75.75 0 0 0-.75.75v7.5c0 .414.336.75.75.75H9v1.5H3.75a2.25 2.25 0 0 1-2.25-2.25z"
        }
      )
    ] }),
    "Booking"
  )
), Cy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M6.066 1.5zh-.008A3.09 3.09 0 0 0 3 4.59v3.187h4.047v-1.5H4.5V4.589c0-.87.7-1.579 1.57-1.59h2.86V1.5zm3.34 6.276H7.048v-1.5h2.36v1.5Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M14.975 17.254 21 22.5V5.52a4 4 0 0 0-4-4H6.066a3.49 3.49 0 0 1 2.863 3.436V22.5zm-4.545 1.958 4.546-3.945 4.524 3.938V5.519a2.5 2.5 0 0 0-2.5-2.5h-6.96a5 5 0 0 1 .39 1.936z"
        }
      )
    ] }),
    "Bookmark"
  )
), Ey = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M9 17.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m4.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m4.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M3 9v12h18V9zm19.5 13.5h-21v-15h21zM9 1.5v3H7.5v-3zm7.5 0v3H15v-3z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M1.5 3h21v6h-21zM3 7.5h18v-3H3z" })
    ] }),
    "Calendar"
  )
), Fy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "m1.5 1.51 21-.01v20.99l-21 .01zM3 21l18-.01V3L3 3.01z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.4697 19.5304L4.46973 5.53039L5.53039 4.46973L19.5304 18.4697L18.4697 19.5304Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.46961 18.4697L18.4696 4.46973L19.5303 5.53039L5.53027 19.5304L4.46961 18.4697Z"
        }
      )
    ] }),
    "Cancel"
  )
), zy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.50012 19.9998V3.5H21.5001V19.9998H3.50012ZM19.5001 18H5.50012L5.50012 15H19.5001V18ZM19.5001 12.9999H5.50012V10.5H19.5001V12.9999ZM19.5001 8.49988H5.50012L5.50012 5.5H19.5001V8.49988Z",
        fill: H
      }
    ),
    "Cards"
  )
), Ay = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M22.5 1.5h-18v8.25h8.885v5.028h1.923l4.07 4.261v-4.26H22.5zM21 3v10.278h-3.122v2.02l-1.929-2.02h-1.064V8.25H6V3z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M6 8.297H1.5v9.925h3.122V22.5l4.071-4.278h6.192v-4.194H6zm-1.5 1.5v5.731h8.885v1.194H8.05l-1.928 2.026v-2.026H3V9.797z"
        }
      )
    ] }),
    "Chat"
  )
), Sy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M21 6.653 9.202 18.859 3 13.282l1.628-1.759L9.095 15.5 19.263 5z"
      }
    ),
    "Check"
  )
), ky = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22.9888 11.9993L21.4888 11.9977C21.4942 6.7541 17.242 2.49951 11.9973 2.49951C6.75399 2.49951 2.49976 6.75528 2.49976 11.9994C2.49976 17.244 6.75155 21.4993 11.9943 21.4993C17.237 21.4993 21.4888 17.2439 21.4888 11.9993H22.9888ZM11.9973 0.999512C18.0705 0.999512 22.995 5.92607 22.9888 11.9993C22.9888 18.0714 18.0664 22.9993 11.9943 22.9993C5.92218 22.9993 0.999756 18.0715 0.999756 11.9994C0.999756 5.92727 5.92514 0.999512 11.9973 0.999512Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.0304 8.03039L9.50006 17.5607L4.96973 13.0304L6.03039 11.9697L9.50006 15.4394L17.9697 6.96973L19.0304 8.03039Z"
        }
      )
    ] }),
    "CheckCircle"
  )
), Dy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "m1.5 1.51 21-.01v20.99l-21 .01zM3 21l18-.01V3L3 3.01z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.0304 8.03039L9.50006 17.5607L4.96973 13.0304L6.03039 11.9697L9.50006 15.4394L17.9697 6.96973L19.0304 8.03039Z"
        }
      )
    ] }),
    "CheckMark"
  )
), Ry = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M3.50012 9.45599L4.50012 8L12.5001 14.0001L20.5001 8L21.5001 9.45598L12.5001 16.5001L3.50012 9.45599Z"
      }
    ),
    "ChevronDown"
  )
), _y = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M15.5442 3L17.0002 4L11.0001 12L17.0002 20L15.5442 21L8.50012 12L15.5442 3Z"
      }
    ),
    "ChevronLeft"
  )
), Py = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M9.95611 21L8.50012 20L14.5003 12L8.50012 4L9.95611 3L17.0002 12L9.95611 21Z"
      }
    ),
    "ChevronRight"
  )
), Hy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M21.5001 15.044L20.5001 16.5L12.5001 10.4999L4.50012 16.5L3.50012 15.044L12.5001 7.99991L21.5001 15.044Z"
      }
    ),
    "ChevronUp"
  )
), Oy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, d: "M12.75 11.0872V7H11.25V13.4998L14.5818 11.8561L13.9182 10.5109L12.75 11.0872Z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.5 12C1.5 6.20213 6.20213 1.5 12 1.5C17.7979 1.5 22.5 6.20213 22.5 12C22.5 17.7979 17.7979 22.5 12 22.5C6.20213 22.5 1.5 17.7979 1.5 12ZM12 3C7.03055 3 3 7.03055 3 12C3 16.9694 7.03056 21 12 21C16.9694 21 21 16.9694 21 12C21 7.03056 16.9694 3 12 3Z"
        }
      )
    ] }),
    "Clock"
  )
), Ny = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M5.01 3 21 18.99 18.99 21 3 5.01z" }),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M21 5.01 5.01 21 3 18.99 18.99 3z" })
    ] }),
    "Close"
  )
), By = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          d: "M8.00028 6.99806L21.5001 6.99805V8.99999L8.00028 9L8.00024 11L3.50068 8L8.00024 5L8.00028 6.99806Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u("path", { d: "M17.0004 13V19L21.5 16L17.0004 13Z", fill: H }),
      /* @__PURE__ */ u("path", { d: "M3.50012 17L17.0001 17V15.0005L3.50012 15.0005V17Z", fill: H })
    ] }),
    "CompareArrows"
  )
), Iy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.9321 14.79C17.958 15.1839 16.8943 15.4011 15.78 15.4011C11.0655 15.4011 7.28 11.5304 7.28 6.80075C7.28 6.49824 7.29548 6.19922 7.32571 5.90447C5.6068 7.29986 4.5 9.45011 4.5 11.871C4.5 16.1046 7.87793 19.5 12 19.5C15.1137 19.5 17.8028 17.5626 18.9321 14.79ZM19.4383 12.8555C18.3737 13.5187 17.1209 13.9011 15.78 13.9011C11.914 13.9011 8.78 10.7222 8.78 6.80075C8.78 6.12651 8.87265 5.47422 9.04574 4.85626C9.23156 4.19283 9.51011 3.56896 9.86626 3C9.14548 3.17775 8.45866 3.44354 7.81749 3.78549C4.95327 5.31306 3 8.36063 3 11.871C3 16.9128 7.02944 21 12 21C16.3419 21 19.9656 17.8813 20.8128 13.732C20.9355 13.1311 21 12.5087 21 11.871C21 11.7596 20.998 11.6487 20.9941 11.5382C20.8931 11.6525 20.7885 11.7635 20.6805 11.871C20.3052 12.2442 19.8886 12.575 19.4383 12.8555Z",
        fill: H
      }
    ),
    "Dark"
  )
), Ty = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M9.333 3H3v6.333h6.333zM1.5 1.5v9.333h9.333V1.5zM21 3h-6.334v6.333H21zm-7.834-1.5v9.333H22.5V1.5zM9.333 14.666H3v6.333h6.333zm-7.833-1.5v9.333h9.333v-9.333zm17.5 1.5h-2.334a2 2 0 0 0-2 2v2.333a2 2 0 0 0 2 2H19a2 2 0 0 0 2-2v-2.333a2 2 0 0 0-2-2m-2.334-1.5a3.5 3.5 0 0 0-3.5 3.5v2.333a3.5 3.5 0 0 0 3.5 3.5H19a3.5 3.5 0 0 0 3.5-3.5v-2.333a3.5 3.5 0 0 0-3.5-3.5z"
      }
    ),
    "Dashboard"
  )
), Vy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M21 22.5H3v-21h11.474L21 7.705zM19.5 8.349 13.875 3H4.5v18h15z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M14.7 3.784v3.375h3.55zm6.3 3.92v.955h-7.8v-7.16h1.275L21 7.705Z"
        }
      )
    ] }),
    "Document"
  )
), Zy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M1.5 1.5h12v21h-12zM3 21h9V3H3z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M6 15v6h3v-6zm-1.5-1.5v9h6v-9zm9 0V21H21v-7.5zM12 12v10.5h10.5V12zm-1.5 0h-6v-1.5h6zm0-3h-6V7.5h6z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M19.5 19.5H15V18h4.5zm0-3H15V15h4.5zM10.5 6h-6V4.5h6z" })
    ] }),
    "Domain"
  )
), $y = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M5.988 5.353A6.59 6.59 0 0 1 12 1.5c3.137 0 5.297 2.18 5.935 5.136h.098c2.159 0 4.467 2.228 4.467 4.432S20.692 15 18.533 15H14.3v-1.444h4.233c1.45 0 2.567-1.147 2.567-2.488S19.483 8.08 18.033 8.08h-1.312l-.072-.639C16.367 4.94 14.694 2.944 12 2.944c-2.275 0-4.186 1.428-4.889 3.381l-.17.471H6.12c-1.81 0-3.22 1.934-3.22 3.63s1.41 3.13 3.22 3.13H9.9V15H6.12c-2.519 0-4.62-2.015-4.62-4.574 0-2.515 2.028-5.004 4.488-5.073"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M11.31 21.5v-15h1.398v15z" }),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "m7.309 17.81.989-.99L12 20.522l3.7-3.702.99.99L12 22.5z" })
    ] }),
    "Download"
  )
), Wy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21 6H3L3.00003 18.0001H21L21 6ZM1.5 4.5L1.50003 19.5001H22.5L22.5 4.5H1.5Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9964 10.3808L21 7V6H3V7L11.9964 10.3808ZM1.5 8L12 12L22.5 8V4.5H1.5L1.5 8Z",
          fill: H
        }
      )
    ] }),
    "Email"
  )
), Gy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M3 9v12h18V9zm19.5 13.5h-21v-15h21zM9 1.5v3H7.5v-3z" }),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M19 12.5H5V11h14zm0 3H5V14h14zm-7 3H5V17h7zm4.5-17v3H15v-3z" }),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M1.5 3h21v6h-21zM3 7.5h18v-3H3z" })
    ] }),
    "EventNote"
  )
), Uy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.6 19.6V16.95H21V21H16.9501V19.6H19.6Z", fill: H }),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.805 20.7946L15.6751 16.6647L16.665 15.6747L20.795 19.8047L19.805 20.7946Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.40003 19.6V16.95H3.00003V21H7.04999V19.6H4.40003Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.20505 19.8047L7.335 15.6747L8.32495 16.6647L4.195 20.7946L3.20505 19.8047Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 3H7.04996V4.4H4.4V7.04996H3V3Z", fill: H }),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.19497 3.20503L8.32492 7.33497L7.33497 8.32492L3.20503 4.19497L4.19497 3.20503Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.5999 4.39961H16.95V2.99961H20.9999V7.04957H19.5999V4.39961Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.3559 4.63359L16.6649 8.32451L15.675 7.33456L19.3659 3.64364L20.3559 4.63359Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.51197 6.5121H17.0492L17.0492 17.0492H6.51203L6.51197 6.5121ZM7.91197 7.9121L7.91203 15.6492H15.6492L15.6492 7.9121H7.91197Z",
          fill: H
        }
      )
    ] }),
    "Expand"
  )
), jy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M15.5 12.75h-7v-1.5h7z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M12 2.965a9.035 9.035 0 1 0 0 18.07 9.035 9.035 0 0 0 0-18.07M1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5 1.5 17.799 1.5 12"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M12.042 4 8 12l4.042 8L16 12zm-.014 3.354L9.68 12l2.347 4.646 2.3-4.646-2.3-4.646Z"
        }
      )
    ] }),
    "Explore"
  )
), Ky = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { d: "M3 20.9999H21V19H3L3 20.9999Z", fill: H }),
      /* @__PURE__ */ u("path", { d: "M3 13L3 20.9999L5 21L5 13H3Z", fill: H }),
      /* @__PURE__ */ u("path", { d: "M19 13V21L21 20.9999V13H19Z", fill: H }),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11 6L6.5 10L5.21985 8.67027L11.9999 3L18.78 8.67027L17.5 10L13 6V17H11V6Z",
          fill: H
        }
      )
    ] }),
    "Export"
  )
), Yy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M5.33267 3.3999H20.75V19H18.7502L18.75 6.6499L5.75012 20.6499L4.25012 19.1499L17.25 5.1499H5.33267V3.3999Z"
      }
    ),
    "External"
  )
), qy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.5 1.50019L1.5 1.5L1.5 11.3776L1.5 17.3983H11.8661H14.1089L18.8575 22.5L18.8575 17.3983H22.5V1.50019ZM20.75 3.29615V15.6023H17.1075V18.0198L14.8573 15.6023H13.6161L3.25 15.6023L3.25 9.58166L3.25 3.29596L20.75 3.29615Z",
        fill: H
      }
    ),
    "Feed"
  )
), Xy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M20.571 13.429H3.43v7.142h17.14V13.43ZM22 12v10H2V12z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M10.568 8.092 3.428 12h2.976l4.938-2.703.08-.06a.47.47 0 0 1 .568 0l.099.074 5.317 2.69h3.165l-7.727-3.909a1.9 1.9 0 0 0-2.276 0"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M10.696 3.765V2h1.429v1.765c0 .702.434 1.28 1.155 2a2.434 2.434 0 0 1-1.716 4.161 2.44 2.44 0 0 1-2.432-2.432v-.423h1.428v.423c0 .547.457 1.003 1.004 1.003a1.005 1.005 0 0 0 .706-1.721c-.714-.715-1.574-1.667-1.574-3.011m2.019 9.663v7.143h-1.429v-7.143z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M21.285 17.714H2.714v-1.428h18.571z" })
    ] }),
    "Fcl"
  )
), Jy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "m6 10.5 6-6h4.5V3h-12v16.5H6zM3 21V1.5h15V6h-5.25L7.5 11.25V21z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M6 22.5h15V4.541L12 4.5l-6 6.158zm1.5-11.232 5.13-5.265 6.87.031V21h-12z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M12 6.973V10.5H8.28zm-6 3.62V12h7.5V4.5h-1.071z" })
    ] }),
    "FileCopy"
  )
), Qy = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M21 3H3v1.74a6.995 6.995 0 0 0 6.995 6.995c.913 0 1.652.74 1.652 1.652v5.91l.706-.588v-5.322c0-.912.74-1.652 1.652-1.652A6.995 6.995 0 0 0 21 4.74zm-7.147 16.412L10.147 22.5v-9.113a.15.15 0 0 0-.152-.152A8.495 8.495 0 0 1 1.5 4.74V1.5h21v3.24a8.495 8.495 0 0 1-8.495 8.495.15.15 0 0 0-.152.152z"
      }
    ),
    "Filter"
  )
), eC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.5146 4.99805H21.5002L21.5001 21H19.5001L19.5146 4.99805Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.50012 19H17.5001V20.9982H3.50012V19Z", fill: H }),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.50012 12L17.5001 12V14L3.50012 14L3.50012 12Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.50012 5L8.50012 5V7L3.50012 7V5Z", fill: H }),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.0001 4.99805L17.6324 4.99805L19.5146 4.99805H21.5002L21.5001 7L14.0001 7L14.0001 4.99805Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.0001 9L10.5001 6L14.0001 3L14.0001 9Z", fill: H })
    ] }),
    "Group"
  )
), tC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { d: "M3.50012 19H21.5001V21H3.50012V19Z", fill: H }),
      /* @__PURE__ */ u("path", { d: "M3.50012 11H21.5001V13H3.50012V11Z", fill: H }),
      /* @__PURE__ */ u("path", { d: "M3.50012 3H21.5001V5H3.50012V3Z", fill: H })
    ] }),
    "HamburgerMenu"
  )
), nC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M11.413 7.429a1.984 1.984 0 0 0-1.984 1.984v1.092H8V9.413A3.413 3.413 0 0 1 11.413 6h2.334a2.824 2.824 0 0 1 2.824 2.824c0 .837-.403 1.623-1.083 2.111l-2.005 1.44a1.16 1.16 0 0 0-.483.942v1.254h-1.429v-1.254c0-.834.402-1.617 1.08-2.103l2.004-1.44a1.17 1.17 0 0 0 .488-.95c0-.77-.625-1.395-1.396-1.395z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, d: "M13 17.429a.714.714 0 1 1-1.429 0 .714.714 0 0 1 1.429 0" }),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M3 21h18V3H3zm19.5 1.5h-21v-21h21z" })
    ] }),
    "Help"
  )
), rC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22.9888 11.9993L21.4888 11.9977C21.4942 6.7541 17.242 2.49951 11.9973 2.49951C6.75399 2.49951 2.49976 6.75528 2.49976 11.9994C2.49976 17.244 6.75155 21.4993 11.9943 21.4993C17.237 21.4993 21.4888 17.2439 21.4888 11.9993H22.9888ZM11.9973 0.999512C18.0705 0.999512 22.995 5.92607 22.9888 11.9993C22.9888 18.0714 18.0664 22.9993 11.9943 22.9993C5.92218 22.9993 0.999756 18.0715 0.999756 11.9994C0.999756 5.92727 5.92514 0.999512 11.9973 0.999512Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.4127 7.42857C10.3169 7.42857 9.42857 8.31689 9.42857 9.4127V10.5055H8L8 9.4127C8 7.52792 9.52792 6 11.4127 6L13.7469 6C15.3069 6 16.5714 7.26457 16.5714 8.82449C16.5714 9.66143 16.1683 10.4471 15.4884 10.9352L13.4835 12.3746C13.18 12.5926 13 12.9434 13 13.3171V14.5714H11.5714V13.3171C11.5714 12.4832 11.9731 11.7005 12.6504 11.2142L14.6553 9.77477C14.9614 9.55502 15.1429 9.20129 15.1429 8.82449C15.1429 8.05355 14.5179 7.42857 13.7469 7.42857L11.4127 7.42857Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M13 17.4286C13 17.8231 12.6802 18.1429 12.2857 18.1429C11.8912 18.1429 11.5714 17.8231 11.5714 17.4286C11.5714 17.0341 11.8912 16.7143 12.2857 16.7143C12.6802 16.7143 13 17.0341 13 17.4286Z",
          fill: H
        }
      )
    ] }),
    "HelpCircle"
  )
), iC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M3.597 12.04c2.07 2.848 5.084 4.604 8.403 4.604s6.333-1.756 8.403-4.603C18.333 9.194 15.319 7.438 12 7.438s-6.332 1.756-8.403 4.603Zm-1.347-.368c2.27-3.355 5.776-5.55 9.75-5.55s7.48 2.195 9.75 5.55l.25.369-.25.368c-2.27 3.356-5.776 5.55-9.75 5.55s-7.479-2.194-9.75-5.55L2 12.041z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M12 14.67a2.63 2.63 0 1 0 0-5.26 2.63 2.63 0 0 0 0 5.26m0 1.316a3.945 3.945 0 1 0 0-7.89 3.945 3.945 0 0 0 0 7.89"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M12 13.356a1.315 1.315 0 1 0 0-2.63 1.315 1.315 0 0 0 0 2.63" }),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M21.457 22.492 1.4 2.436l.93-.93 20.057 20.056z" })
    ] }),
    "Hide"
  )
), lC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "m20.459 5.334.001 11.395h-1.5V5.335c0-1.373-.996-2.395-2.243-2.336H4.651V1.5h12.014c2.222-.093 3.794 1.75 3.794 3.835Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M10.993 17.687c-.375-.262-.855-.35-1.179-.35v-1.5h9.514c1.832 0 3.172 1.575 3.172 3.342 0 1.76-1.334 3.322-3.163 3.322H9.814V21c.324 0 .803-.088 1.179-.35.332-.232.652-.644.652-1.482 0-.839-.32-1.25-.652-1.482ZM12.68 21h6.658c.893 0 1.662-.777 1.662-1.82 0-1.054-.78-1.841-1.672-1.841H12.68c.289.48.465 1.085.465 1.83 0 .747-.176 1.353-.466 1.832Zm-3.296-8.89h5.162v1.5H9.384z"
        }
      ),
      /* @__PURE__ */ u("g", { filter: "url(#a)", children: /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M9.384 9.53h7.744v1.5H9.384z" }) }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M9.384 6.948h7.744v1.5H9.384zM1.5 4.831C1.5 3.155 2.67 1.5 4.401 1.5V3C3.753 3 3 3.706 3 4.831c0 1.138.738 1.832 1.376 1.832h2.426v1.5H4.376C2.636 8.163 1.5 6.495 1.5 4.83Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M4.337 1.5h.893c1.275 0 2.311 1.074 2.311 2.377v14.568c0 1.42 1.112 2.555 2.46 2.555v1.5c-2.227 0-3.96-1.858-3.96-4.055V3.877c0-.514-.404-.877-.811-.877h-.893z"
        }
      ),
      /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ V(
        "filter",
        {
          id: "a",
          width: "15.744",
          height: "9.5",
          x: "5.384",
          y: "9.529",
          colorInterpolationFilters: "sRGB",
          filterUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ u("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            /* @__PURE__ */ u("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            /* @__PURE__ */ u("feOffset", { dy: "4" }),
            /* @__PURE__ */ u("feGaussianBlur", { stdDeviation: "2" }),
            /* @__PURE__ */ u("feComposite", { in2: "hardAlpha", operator: "out" }),
            /* @__PURE__ */ u("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" }),
            /* @__PURE__ */ u("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_55_911" }),
            /* @__PURE__ */ u("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_55_911", result: "shape" })
          ]
        }
      ) })
    ] }),
    "Historic"
  )
), oC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M5.823 21.07V7h-1.37v15.44h15.065V7h-1.37v14.07z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "m11.985 1.5 2.397 1.712V1.557h4.451v4.564L22.5 9l-.856 1.07-4.18-3.29V2.926h-1.712v2.946l-3.767-2.69-9.69 6.931L1.5 9zM8.562 14.483h6.848v6.915h-1.37v-5.545H9.931v5.545h-1.37z"
        }
      )
    ] }),
    "Home"
  )
), aC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M3 21h18V3H3zm19.5 1.5h-21v-21h21z" }),
      /* @__PURE__ */ u("path", { fill: H, stroke: H, d: "M11.5 6a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z" }),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M11 19V9h2v10z" })
    ] }),
    "Info"
  )
), sC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          d: "M11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6C13 6.55229 12.5523 7 12 7C11.4477 7 11 6.55229 11 6Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1641 19V8.5H12.8398V19H11.1641Z", fill: H }),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z",
          fill: H
        }
      )
    ] }),
    "InfoCircle"
  )
), cC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M3.597 11.918c2.07 2.847 5.084 4.603 8.403 4.603s6.333-1.756 8.403-4.603C18.333 9.071 15.319 7.315 12 7.315s-6.332 1.756-8.403 4.603M2.25 11.55C4.52 8.194 8.026 6 12 6s7.48 2.194 9.75 5.55l.25.368-.25.369c-2.27 3.355-5.776 5.55-9.75 5.55s-7.479-2.195-9.75-5.55L2 11.918z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M12 14.548a2.63 2.63 0 1 0 0-5.26 2.63 2.63 0 0 0 0 5.26m0 1.316a3.945 3.945 0 1 0 0-7.891 3.945 3.945 0 0 0 0 7.89Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M12 13.233a1.315 1.315 0 1 0 0-2.63 1.315 1.315 0 0 0 0 2.63m9.594 9.208L14.1 14.947l.93-.93 7.494 7.495-.93.93Z"
        }
      )
    ] }),
    "Inspection"
  )
), dC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "m1.5 21.502 2.789-3 .998.998-2.79 3zm6.302-10.5 1.625-1.625.998.998L8.8 12zm3.75 3.75 1.626-1.625.998.998-1.626 1.625z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "m6.35 11.537-.844.844a4.33 4.33 0 0 0 0 6.121 4.33 4.33 0 0 0 6.122 0l.844-.844zm-1.842-.154 1.843-1.842 8.118 8.117-1.843 1.842a5.743 5.743 0 0 1-8.118 0 5.74 5.74 0 0 1 0-8.117m8.125-6.138-.837.838 6.128 6.127.839-.838a4.34 4.34 0 0 0 0-6.127 4.31 4.31 0 0 0-3.06-1.27h-.01a4.28 4.28 0 0 0-3.055 1.266zm5.291 8.962L9.799 6.082l1.837-1.837a5.7 5.7 0 0 1 4.057-1.682h.01c1.461 0 2.933.558 4.058 1.682a5.75 5.75 0 0 1 0 8.124z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "m22.5 2.498-2.822 2.824-.998-.998L21.502 1.5z" })
    ] }),
    "Integration"
  )
), uC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        d: "M9.5 7L13.5 10.9998H3V12.9998H13.5L9.5 17L10.9643 18.4483L17.25 12L10.9643 5.55176L9.5 7ZM19 4.5V19.5H21.0002V4.5L19 4.5Z",
        fill: H
      }
    ),
    "KeyboardTab"
  )
), fC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M20.571 13.429H3.43v7.142h17.14V13.43ZM22 12v10H2V12z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M10.568 8.092 3.428 12h2.976l4.938-2.703.08-.06a.47.47 0 0 1 .568 0l.099.074 5.317 2.69h3.165l-7.727-3.909a1.9 1.9 0 0 0-2.276 0"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M10.696 3.765V2h1.429v1.765c0 .702.434 1.28 1.155 2a2.434 2.434 0 0 1-1.716 4.161 2.44 2.44 0 0 1-2.432-2.432v-.423h1.428v.423c0 .547.457 1.003 1.004 1.003a1.005 1.005 0 0 0 .706-1.721c-.714-.715-1.574-1.667-1.574-3.011m2.018 9.663v7.143h-1.428v-7.143z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M21.286 17.714H12v-1.428h9.286z" })
    ] }),
    "Lcl"
  )
), hC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", clipRule: "evenodd", d: "M11.25 6V3H12.75V6H11.25Z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.6431 7.29642L17.9395 5L19.0002 6.06066L16.7038 8.35708L15.6431 7.29642Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.06066 5.00004L8.29113 7.2284L7.23047 8.28906L5 6.0607L6.06066 5.00004Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 15.6428C14.0119 15.6428 15.6429 14.0118 15.6429 11.9999C15.6429 9.98804 14.0119 8.35708 12 8.35708C9.98812 8.35708 8.35715 9.98804 8.35715 11.9999C8.35715 14.0118 9.98812 15.6428 12 15.6428ZM12 17.1428C14.8403 17.1428 17.1429 14.8403 17.1429 11.9999C17.1429 9.15962 14.8403 6.85708 12 6.85708C9.15969 6.85708 6.85715 9.15962 6.85715 11.9999C6.85715 14.8403 9.15969 17.1428 12 17.1428Z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", clipRule: "evenodd", d: "M3 11.25H6V12.75H3L3 11.25Z" }),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", clipRule: "evenodd", d: "M18 11.25H21V12.75H18V11.25Z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.93934 17.9393L7.23231 15.705L8.29297 16.7656L6 19L4.93934 17.9393Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.7677 15.7071L19.0002 17.9393L17.9395 19L15.7071 16.7678L16.7677 15.7071Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.25 21.0001V18.0001H12.75V21.0001H11.25Z"
        }
      )
    ] }),
    "Light"
  )
), pC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { d: "M1.49993 8.13045H6.6315V22.5001H1.49993V8.13045Z", fill: H }),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M9.4176 8.51035H13.4447V10.4218H13.5013C14.0612 9.31948 15.43 8.15856 17.4718 8.15856C21.7195 8.15856 22.5 11.055 22.5 14.8251V22.5001H18.3089V15.6987C18.3089 14.0746 18.2806 11.9873 16.1257 11.9873C13.9707 11.9873 13.6087 13.7521 13.6087 15.5814V22.5001H9.4176V8.51035Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M6.69918 4.06106C6.69918 5.47545 5.55817 6.62204 4.15066 6.62204C2.74315 6.62204 1.60214 5.47545 1.60214 4.06106C1.60214 2.64666 2.74315 1.50007 4.15066 1.50007C5.55817 1.50007 6.69918 2.64666 6.69918 4.06106Z",
          fill: H
        }
      )
    ] }),
    "LinkedIn"
  )
), mC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          d: "M3.50012 20.0001H6.50012V18.0002H3.50012V20.0001ZM8.50012 20.0001H21.5001V18.0002H8.50012V20.0001Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M3.50012 12.5002H6.50012V10.5002H3.50012V12.5002ZM8.50012 12.5002H21.5001V10.5002H8.50012V12.5002Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          d: "M3.50012 5.50024H6.50012V3.50049H3.50012V5.50024ZM8.50012 5.50024H21.5001V3.50049H8.50012V5.50024Z",
          fill: H
        }
      )
    ] }),
    "List"
  )
), vC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M14.539 17.299C16.376 14.783 18 11.73 18 8.966 18 5.677 15.32 3 12 3S6 5.678 6 8.967c0 1.092.374 2.41 1.035 3.85.653 1.423 1.537 2.859 2.445 4.157a45 45 0 0 0 2.576 3.328l.016-.018a34 34 0 0 0 2.467-2.985m-1.485 4.132C15.119 19.226 19.5 13.96 19.5 8.967 19.5 4.843 16.142 1.5 12 1.5S4.5 4.843 4.5 8.967c0 4.32 4.462 10.027 6.503 12.411.605.707.997 1.122.997 1.122s.417-.389 1.054-1.07Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M12 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 1.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
        }
      )
    ] }),
    "Location"
  )
), gC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.5388 17.2985C16.3762 14.7833 18 11.7311 18 8.96666C18 5.67766 15.32 3 12 3C8.67999 3 6 5.67766 6 8.96666C6 10.0589 6.37374 11.3777 7.03503 12.8178C7.68798 14.2398 8.57245 15.676 9.47957 16.9742C10.3837 18.2681 11.291 19.3974 11.9734 20.2042C12.0013 20.2372 12.0288 20.2696 12.0559 20.3015C12.0613 20.2958 12.0666 20.2901 12.0719 20.2843C12.7465 19.5568 13.6442 18.5231 14.5388 17.2985ZM13.0539 21.4308C15.1193 19.2256 19.5 13.9598 19.5 8.96666C19.5 4.84294 16.1421 1.5 12 1.5C7.85787 1.5 4.5 4.84294 4.5 8.96666C4.5 13.2862 8.96224 18.9939 11.0029 21.3783C11.6079 22.0852 12 22.5 12 22.5C12 22.5 12.4168 22.111 13.0539 21.4308Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.0714 4.77977H13.942L14.2857 5.99995H14.8207L15.3719 7.99041L16 8.07723L15.0163 12.4971H8.98373L8 8.07723L8.63036 7.99009L9.1787 5.99995H9.72184L10.0714 4.77977ZM13.9757 7L14.2857 7.89491L12 7.52426L9.72184 7.89467L10.0301 7H13.9757ZM11 5.99995H13L12.8669 5.69937H11.1289L11 5.99995ZM9.23787 8.9971L9.97571 11.4971H11.5V8.59023L9.23787 8.9971ZM12.5 8.59165V11.4971H13.9433L14.6812 8.9971L12.5 8.59165Z",
          fill: H
        }
      )
    ] }),
    "ShipLocation"
  )
), LC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20 6.70655L22.5001 1.5L1.51962 1.5L1.51962 12.0002L22.5001 12L20 6.70655ZM20 10.5L18.1512 6.70655L19.9929 3L3.01962 3C3.01962 3 3 6 3.01962 6L3.01962 10.5002L20 10.5Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u("path", { d: "M1.5 11.0002L1.5 22.4998L2.9999 22.5002L2.9999 11.0002H1.5Z", fill: H })
    ] }),
    "Destination"
  )
), wC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M1.5 9.525h21V22.5h-21zM3 21h18v-9.975H3z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M11.994 3c-4.21 0-7.672 3.494-7.672 7.786h-1.5c0-5.102 4.114-9.286 9.172-9.286s9.172 4.184 9.172 9.286h-1.5C19.666 6.494 16.205 3 11.994 3m-.744 16.5v-6.75h1.5v6.75z"
        }
      )
    ] }),
    "Lock"
  )
), MC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.9686 20.9932L8.84412 20.9995L8.93787 12.7841L10.9379 12.7841L10.8441 19.2217H18.9066L18.9379 4.78409L10.9379 4.78417L10.9379 9.22856L8.93787 9.22856L8.93787 3.00635L20.9999 3L20.9686 20.9932Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u("path", { d: "M12.0007 9.22857V12.7841L15.0004 11.0063L12.0007 9.22857Z", fill: H }),
      /* @__PURE__ */ u("path", { d: "M3.00037 10.1175V11.8952L12.0004 11.8952V10.1175L3.00037 10.1175Z", fill: H })
    ] }),
    "LogOut"
  )
), xC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.3941 12.3466L22.5 21.4525L21.4525 22.5L12.3465 13.3941L13.3941 12.3466Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.18536 3C5.32164 3 3.00013 5.32149 3.00013 8.1852C3.00013 11.0489 5.32164 13.3704 8.18536 13.3704C11.0491 13.3704 13.3706 11.0489 13.3706 8.1852C13.3706 5.32149 11.0491 3 8.18536 3ZM1.51864 8.1852C1.51864 4.50329 4.50343 1.51851 8.18536 1.51851C11.8673 1.51851 14.8521 4.50329 14.8521 8.1852C14.8521 11.8671 11.8673 14.8519 8.18536 14.8519C4.50343 14.8519 1.51864 11.8671 1.51864 8.1852Z"
        }
      )
    ] }),
    "MagnifyingLens"
  )
), bC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 11L21 11V13L3 13V11Z", fill: H }),
    "Minus"
  )
), yC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u("path", { fill: H, d: "M10.25 15.5h3.5V19h-3.5zm0-5.25h3.5v3.5h-3.5zm0-5.25h3.5v3.5h-3.5z" }),
    "More"
  )
), CC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, d: "m6.528 18.616-.034-.046-2.708-4.844" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M3.42 13.071a.75.75 0 0 1 1.02.289l2.687 4.806.007.01a.75.75 0 1 1-1.213.881l-.06-.082-2.73-4.883a.75.75 0 0 1 .289-1.02Z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, d: "M3.741 10.355 6.55 5.349l.011-.035" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M6.792 4.6a.75.75 0 0 1 .483.945l-.034.105-2.845 5.072a.75.75 0 1 1-1.309-.734L5.863 5.04a.75.75 0 0 1 .929-.44m1.716-.76a.75.75 0 0 1 .75-.75h5.461a.75.75 0 0 1 0 1.5H9.26a.75.75 0 0 1-.75-.75Zm8.464.83a.75.75 0 0 1 1.02.29l2.91 5.2a.75.75 0 1 1-1.31.733L16.684 5.69a.75.75 0 0 1 .288-1.02m3.642 8.16a.75.75 0 0 1 .287 1.021l-2.909 5.19a.75.75 0 1 1-1.308-.733l2.909-5.19a.75.75 0 0 1 1.02-.288ZM8.33 20.16a.75.75 0 0 1 .75-.75h5.64a.75.75 0 1 1 0 1.5H9.08a.75.75 0 0 1-.75-.75m4.897-5.2a.75.75 0 0 1 1.03.253l1.862 3.073a.75.75 0 0 1-1.283.777l-1.861-3.073a.75.75 0 0 1 .252-1.03"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, d: "M10.15 8.582 8.423 5.36l-.067-.115" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M7.979 4.596a.75.75 0 0 1 1.025.272l.074.126 1.733 3.234a.75.75 0 0 1-1.322.708l-1.721-3.21-.06-.104a.75.75 0 0 1 .27-1.026Z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, d: "m15.532 5.314-.01.035-1.84 3.2" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M15.763 4.6a.75.75 0 0 1 .483.945l-.035.11-1.878 3.267a.75.75 0 0 1-1.3-.748l1.803-3.138a.75.75 0 0 1 .927-.436"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, d: "m10.217 15.567-1.839 3.165-.022.023" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M10.594 14.919a.75.75 0 0 1 .271 1.025L8.98 19.188l-.086.089a.75.75 0 0 1-1.126-.988l1.8-3.098a.75.75 0 0 1 1.026-.272m4.423-2.861a.75.75 0 0 1 .75-.75h3.689a.75.75 0 0 1 0 1.5h-3.69a.75.75 0 0 1-.75-.75Zm-11.045 0a.75.75 0 0 1 .75-.75h3.41a.75.75 0 0 1 0 1.5h-3.41a.75.75 0 0 1-.75-.75"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          d: "M7.497 3.15c.357 0 .647.3.647.668s-.29.668-.647.668a.66.66 0 0 1-.646-.668c0-.368.29-.667.646-.667Zm0-1.15c-.97 0-1.76.817-1.76 1.818s.79 1.818 1.76 1.818 1.761-.817 1.761-1.818S8.467 2 7.498 2Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M8.144 3.818a.66.66 0 0 0-.647-.667.657.657 0 0 0-.646.667c0 .368.29.668.646.668s.647-.3.647-.668m-2.408 0C5.736 2.817 6.528 2 7.497 2c.97 0 1.761.817 1.761 1.818s-.791 1.818-1.76 1.818c-.97 0-1.762-.817-1.762-1.818"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          d: "M16.48 3.15c.357 0 .647.3.647.668s-.29.668-.647.668a.66.66 0 0 1-.646-.668c0-.368.29-.667.646-.667Zm0-1.15c-.97 0-1.76.817-1.76 1.818s.79 1.818 1.76 1.818 1.761-.817 1.761-1.818S17.45 2 16.481 2Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M17.127 3.818a.66.66 0 0 0-.647-.667.657.657 0 0 0-.646.667c0 .368.29.668.646.668s.647-.3.647-.668m-2.408 0C14.72 2.817 15.511 2 16.48 2c.97 0 1.761.817 1.761 1.818s-.791 1.818-1.76 1.818c-.97 0-1.762-.817-1.762-1.818"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          d: "M7.308 19.514c.357 0 .646.3.646.668s-.29.667-.646.667a.66.66 0 0 1-.646-.668c0-.368.29-.667.646-.667m0-1.15c-.97 0-1.76.816-1.76 1.817 0 1.002.79 1.819 1.76 1.819s1.76-.817 1.76-1.819c0-1-.79-1.818-1.76-1.818Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M7.954 20.181a.66.66 0 0 0-.646-.667c-.357 0-.646.3-.646.668s.29.667.646.667.646-.3.646-.668m-2.407 0c0-1 .791-1.818 1.761-1.818s1.76.817 1.76 1.819c0 1-.79 1.818-1.76 1.818s-1.76-.817-1.76-1.819Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          d: "M16.48 19.514c.357 0 .647.3.647.668s-.29.667-.647.667a.66.66 0 0 1-.646-.668c0-.368.29-.667.646-.667m0-1.15c-.97 0-1.76.816-1.76 1.817 0 1.002.79 1.819 1.76 1.819s1.761-.817 1.761-1.819c0-1-.791-1.818-1.76-1.818Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M17.127 20.181a.66.66 0 0 0-.647-.667c-.357 0-.646.3-.646.668s.29.667.646.667.647-.3.647-.668m-2.408 0c0-1 .792-1.818 1.761-1.818.97 0 1.761.817 1.761 1.819 0 1-.791 1.818-1.76 1.818-.97 0-1.762-.817-1.762-1.819"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          d: "M21.117 11.263c.423 0 .769.357.769.794a.783.783 0 0 1-.77.794.783.783 0 0 1-.768-.794c0-.437.345-.794.769-.794m0-1.15c-1.037 0-1.884.874-1.884 1.944s.847 1.945 1.884 1.945S23 13.127 23 12.057s-.847-1.945-1.883-1.945Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M21.886 12.057a.783.783 0 0 0-.77-.794.783.783 0 0 0-.768.794c0 .437.345.794.769.794a.783.783 0 0 0 .769-.794m-2.653 0c0-1.07.847-1.945 1.884-1.945S23 10.987 23 12.057s-.847 1.945-1.883 1.945-1.884-.875-1.884-1.945"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          d: "M2.861 11.287a.76.76 0 0 1 .747.77.76.76 0 0 1-.747.772.76.76 0 0 1-.747-.772.76.76 0 0 1 .747-.77m0-1.151c-1.025 0-1.861.863-1.861 1.921 0 1.06.836 1.922 1.861 1.922s1.861-.863 1.861-1.921c0-1.06-.836-1.922-1.861-1.922"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M3.57 12.299a.75.75 0 0 1-.709.53.75.75 0 0 1-.71-.53.8.8 0 0 1 0-.483.75.75 0 0 1 .71-.53.75.75 0 0 1 .71.53.8.8 0 0 1 0 .483ZM1 12.057c0-1.058.836-1.921 1.861-1.921s1.861.863 1.861 1.921c0 1.06-.836 1.922-1.861 1.922S1 13.116 1 12.058Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          d: "M11.944 9.273c1.493 0 2.697 1.254 2.697 2.785 0 1.53-1.215 2.785-2.697 2.785s-2.697-1.255-2.697-2.785 1.215-2.785 2.697-2.785m0-1.15c-2.106 0-3.812 1.76-3.812 3.935s1.706 3.935 3.812 3.935 3.811-1.76 3.811-3.935-1.705-3.936-3.811-3.936Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M14.641 12.058c0-1.53-1.204-2.785-2.697-2.785-1.482 0-2.697 1.254-2.697 2.785 0 1.53 1.215 2.785 2.697 2.785s2.697-1.255 2.697-2.785m-6.509 0c0-2.175 1.706-3.936 3.812-3.936s3.811 1.76 3.811 3.936c0 2.175-1.705 3.935-3.811 3.935s-3.812-1.76-3.812-3.935"
        }
      )
    ] }),
    "Network"
  )
), EC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M14.807 3.39v.711H9.193v-.71H3V18l4.5 4.5H21V3.39l-.007-.034zM19.5 4.865l-3.193.017v.72H7.693V4.89H4.5v12.49L8.121 21H19.5z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M9.195 3v1.11h5.608V3zm-.072-1.5c-.789 0-1.428.64-1.428 1.429V5.61h8.608V2.93c0-.79-.64-1.429-1.428-1.429H9.123ZM12.8 17v-3.2H16v-1.6h-3.2V9h-1.6v3.2H8v1.6h3.2V17zm-5.3 1h-3v-1.5H9V21H7.5z"
        }
      )
    ] }),
    "NoteAdd"
  )
), FC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M6.444 3.019H2V22.5h12.451l5.327-5.245V7.3l-1.482.834v8.5l-4.451 4.384H3.48V4.5h2.963z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M15.333 18.777H18l.537-1.481h-4.685V22l1.481-.482zM17.5 4.481 18.328 3h-3.81L15 4.48z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M6.444 1.5h8.89v4.444h-8.89zm1.482 1.481v1.482h5.926V2.98z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "m19.904 6.168-1.573-1.573L7.366 15.56l-.632 2.205 2.205-.631zM9.716 18.452l-5.142 1.473 1.473-5.141L18.331 2.5 22 6.168z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "m9.5 18-2.751-2.751L7.796 14.2l2.751 2.752z" })
    ] }),
    "NoteEdit"
  )
), zC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M7.5 18h-3v-1.5H9V21H7.5z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M14.807 3.39v.711H9.193v-.71H3V18l4.5 4.5H21V3.39l-.007-.034zM19.5 4.865l-3.193.017v.72H7.693V4.89H4.5v12.49L8.121 21H19.5z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M9.195 3v1.11h5.608V3zm-.072-1.5c-.789 0-1.428.64-1.428 1.429V5.61h8.608V2.93c0-.79-.64-1.429-1.428-1.429H9.123Z"
        }
      )
    ] }),
    "Note"
  )
), AC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "m18.596 16.701 1.163-.009v1.428l-15.589.009V16.7h1.24V10.33c0-3.054 2.957-5.53 6.593-5.539 3.647 0 6.604 2.476 6.604 5.53v6.372l-.011.01Zm-14.59-1.254V10.33c0-3.875 3.709-6.818 7.993-6.829h.004c4.298 0 8.009 2.944 8.009 6.82v5.13l1.081-.01v3.97l-18.191.009v-3.972h1.103Z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M9.896 1.5h4.248l-.034 3h-1.404V2.79H11.3V4.5H9.896v-3ZM16.075 19c0 2.208-1.808 3.5-4.037 3.5C9.807 22.5 8 21.208 8 19h1.346c0 1.472 1.206 2.167 2.691 2.167 1.486 0 2.692-.695 2.692-2.167h1.346Z"
        }
      )
    ] }),
    "Notification"
  )
), SC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M9.517 16.751 20.38 5.89l-2.27-2.268L7.249 14.483zM22.5 5.89 18.11 1.5 5.129 14.483l4.39 4.39z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "m10.523 17.867-4.389-4.39-1.02 1.02-1.42 5.809 5.809-1.419zm-2.326-.205L6.34 15.803l-.601 2.46 2.46-.601Zm10.94-10.531L20.38 5.89l-2.27-2.268-1.242 1.24 2.268 2.27ZM22.5 5.89 18.11 1.5l-3.362 3.363 4.39 4.39z"
        }
      )
    ] }),
    "Pencil"
  )
), kC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M6.587 16.6a1.4 1.4 0 1 0 0-2.803 1.4 1.4 0 0 0 0 2.802Zm0 1.4a2.802 2.802 0 1 0 0-5.604 2.802 2.802 0 0 0 0 5.604m-1.585 2.399A2.1 2.1 0 0 0 2.901 22.5H1.5a3.5 3.5 0 0 1 3.502-3.502h2.802a3.5 3.5 0 0 1 3.502 3.502h-1.4c0-1.16-.942-2.101-2.102-2.101zm12.8-3.799a1.4 1.4 0 1 0 0-2.803 1.4 1.4 0 0 0 0 2.802Zm0 1.4a2.802 2.802 0 1 0 0-5.604 2.802 2.802 0 0 0 0 5.604m-1.606 2.399c-1.16 0-2.102.94-2.102 2.101h-1.4a3.5 3.5 0 0 1 3.502-3.502h2.801A3.5 3.5 0 0 1 22.5 22.5h-1.401c0-1.16-.941-2.101-2.102-2.101zM6.587 5.703a1.4 1.4 0 1 0 0-2.802 1.4 1.4 0 0 0 0 2.802m0 1.401a2.802 2.802 0 1 0 0-5.604 2.802 2.802 0 0 0 0 5.604M5.002 9.401a2.1 2.1 0 0 0-2.101 2.101H1.5A3.5 3.5 0 0 1 5.002 8h2.802a3.5 3.5 0 0 1 3.502 3.502h-1.4c0-1.16-.942-2.1-2.102-2.1zm11.196 0c-1.16 0-2.102.941-2.102 2.102h-1.4A3.5 3.5 0 0 1 16.197 8H19a3.5 3.5 0 0 1 3.502 3.503H21.1c0-1.16-.94-2.102-2.101-2.102zm1.604-3.58a1.4 1.4 0 1 0 0-2.802 1.4 1.4 0 0 0 0 2.802m0 1.401c1.547 0 2.802-1.175 2.802-2.722s-1.255-3-2.802-3S15 2.873 15 4.42a2.8 2.8 0 0 0 2.802 2.802"
      }
    ),
    "People"
  )
), DC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0 1.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 1.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-3.703 1.28a8.4 8.4 0 0 1 3.707-.83 8.4 8.4 0 0 1 3.694.887c.687.345 1.501 1.063 2.041 1.573l-1.03 1.09c-.551-.52-1.22-1.09-1.684-1.323a6.9 6.9 0 0 0-3.032-.727 6.9 6.9 0 0 0-3.044.68 6.6 6.6 0 0 0-1.874 1.348L6 19.432a8.1 8.1 0 0 1 2.297-1.652"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M4 18.864 17.789 5.076l1.06 1.06L5.061 19.925z" })
    ] }),
    "PersonDisabled"
  )
), RC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0 1.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 1.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-3.703 1.28a8.4 8.4 0 0 1 3.707-.83 8.4 8.4 0 0 1 3.694.887c.687.345 1.501 1.063 2.041 1.573l-1.03 1.09c-.551-.52-1.22-1.09-1.684-1.323a6.9 6.9 0 0 0-3.032-.727 6.9 6.9 0 0 0-3.044.68 6.6 6.6 0 0 0-1.874 1.348L6 19.432a8.1 8.1 0 0 1 2.297-1.652"
        }
      )
    ] }),
    "Person"
  )
), _C = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M12 14.25a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5m0 1.25a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M10.232 9.875h3.536a1.876 1.876 0 0 0-3.536 0m-1.357.625a3.125 3.125 0 1 1 6.25 0v.625h-6.25zm13.818.625H15.75v-1.25h6.943zm-14.443 0H1.3v-1.25h6.95z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M19.5 13a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m-15 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m8.125-10v3.75h-1.25V3zM7.579 18.697c.696-1.54 2.38-2.572 4.275-2.572 1.419 0 2.708.575 3.563 1.505.5-.168 1.04-.26 1.603-.26 1.921 0 3.62 1.058 4.303 2.63l-1.147.5c-.462-1.066-1.674-1.88-3.156-1.88a3.8 3.8 0 0 0-1.543.326l-.465.209-.298-.413c-.581-.804-1.631-1.367-2.86-1.367-1.674 0-2.984 1.03-3.291 2.286l-.182.744-.693-.328a3.8 3.8 0 0 0-1.618-.354c-.954 0-1.804.339-2.407.87l-.827-.937c.84-.74 1.985-1.183 3.234-1.183a5.1 5.1 0 0 1 1.509.224"
        }
      )
    ] }),
    "Plane"
  )
), PC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M10.75 2.75h2.89v18.5h-2.89z" }),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M2.75 10.75h18.5v2.89H2.75z" })
    ] }),
    "Plus"
  )
), HC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M5.5 12.5h13v4H21v-8H3v8h2.5zM7 18H1.5V7h21v11H17v-4H7z" }),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M6 1.5h12v7H6zM7.5 7h9V3h-9zm-2 5.5h13v10h-13zM7 21h10v-7H7z" })
    ] }),
    "Printer"
  )
), OC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M16.5 17.25v-1.5h3v1.5zm-1.5 0v-3h4.5a1.5 1.5 0 0 1 1.5 1.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5m7.5 5.25-.677-2.25H2.177L1.5 22.5h1.566l.226-.75h17.416l.226.75z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M3 18.75V9h1.5v8.25h15V9H21v9.75zM5.017 3.728a2.3 2.3 0 0 0-.35.772H19.33a2.3 2.3 0 0 0-.35-.761C18.72 3.39 18.204 3 16.91 3H7c-1.235 0-1.728.38-1.983.728M20.87 4.5c-.336-1.721-1.393-3-3.96-3H7c-2.497 0-3.538 1.279-3.87 3C3.037 4.972 3 5.478 3 6h18c0-.522-.038-1.028-.13-1.5"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M9 14.25v4.5H3v-4.5zm-4.5 1.5h3v1.5h-3zm15-6.645V6h-15v3.13L12 12zm1.5 1.003L12 13.5l-9-3.392V5.5h18z"
        }
      )
    ] }),
    "Railway"
  )
), NC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, d: "M2 14.7562L7.50252 13.3356L5.48846 16.6969L2 14.7562Z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.96954 14.7639L5.81894 14.2864L5.73482 13.9839C5.31416 12.4712 5.47849 10.8627 6.19755 9.45775C6.91668 8.05266 8.14204 6.94622 9.64646 6.34578C11.151 5.74531 12.831 5.69229 14.3732 6.19671L14.6722 6.29452L15.2902 4.54033L14.9857 4.44073C13.0057 3.79311 10.849 3.86111 8.91708 4.63218C6.98504 5.40329 5.40862 6.82538 4.48262 8.63469C3.55655 10.4441 3.34461 12.5167 3.88666 14.4659L3.96954 14.7639Z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, d: "M22 9.33465L19.2487 10.045L16.4975 10.7553L18.5115 7.39399L22 9.33465Z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.1389 9.23607L18.2894 9.71355L18.3736 10.0161C18.7942 11.5288 18.6299 13.1373 17.9108 14.5422C17.1917 15.9473 15.9664 17.0538 14.4619 17.6542C12.9574 18.2547 11.2774 18.3077 9.7352 17.8033L9.43617 17.7055L8.81818 19.4597L9.12268 19.5593C11.1027 20.2069 13.2594 20.1389 15.1913 19.3678C17.1233 18.5967 18.6998 17.1746 19.6258 15.3653C20.5518 13.5559 20.7638 11.4833 20.2217 9.53412L20.1389 9.23607Z"
        }
      )
    ] }),
    "Refresh"
  )
), BC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.72354 3H14.2765V5.35861C14.5543 5.45362 14.8242 5.56549 15.0862 5.69426L16.7474 4.03306L19.9669 7.25264L18.3071 8.91251C18.4359 9.17469 18.5475 9.44576 18.642 9.72354H21V14.2765H18.6505C18.5555 14.5543 18.4436 14.8242 18.3148 15.0862L19.9748 16.7461L16.7577 19.9773L15.0876 18.3071C14.8276 18.4351 14.5594 18.5459 14.2855 18.6399V21H9.71445V18.6303C9.44064 18.5357 9.17347 18.4246 8.91375 18.2967L7.24228 19.9682L4.02525 16.737L5.68772 15.0745C5.56105 14.8135 5.45013 14.5437 5.35462 14.2674H3V9.71445H5.35861C5.45362 9.43666 5.56549 9.16668 5.69426 8.90475L4.03306 7.24355L7.25264 4.02398L8.91638 5.68772C9.17743 5.56105 9.44722 5.45013 9.72354 5.35462V3ZM11.3599 4.63636V6.59685L10.7455 6.75485C10.1797 6.90033 9.6563 7.11606 9.19614 7.39683L8.64662 7.73213L7.25264 6.33814L6.34723 7.24355L7.74343 8.63975L7.4039 9.19034C7.1138 9.66077 6.90124 10.1713 6.7666 10.7257L6.61479 11.3508H4.63636V12.631H6.59685L6.75485 13.2454C6.90033 13.8112 7.11606 14.3346 7.39683 14.7948L7.73213 15.3443L6.33688 16.7395L7.24482 17.6515L8.64884 16.2475L9.19943 16.587C9.67036 16.8774 10.1818 17.0903 10.7284 17.225L11.3508 17.3783V19.3636H12.6492V17.3874L13.2716 17.234C13.8219 17.0985 14.3396 16.8852 14.7953 16.5994L15.3476 16.253L16.7552 17.6606L17.6631 16.7486L16.2657 15.3512L16.6052 14.8006C16.8953 14.3301 17.1078 13.8196 17.2425 13.2652L17.3943 12.6401H19.3636V11.3599H17.3852L17.2334 10.7348C17.0979 10.1768 16.8849 9.65993 16.5994 9.20467L16.253 8.65239L17.6528 7.25264L16.7474 6.34723L15.3512 7.74343L14.8006 7.4039C14.3301 7.1138 13.8196 6.90124 13.2652 6.7666L12.6401 6.61479V4.63636H11.3599Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9918 9.96254C11.7779 9.96254 11.5815 9.99717 11.4069 10.0572L11.3736 10.0686L11.3394 10.0772C11.2655 10.0957 11.1862 10.1279 11.0801 10.1868L11.0668 10.1942L11.0533 10.2011C10.6941 10.3835 10.3919 10.6834 10.199 11.0575L10.195 11.0654C10.1449 11.16 10.1002 11.2661 10.0673 11.3758L10.0638 11.3877L10.0598 11.3994C9.99736 11.5869 9.96274 11.7941 9.96274 11.9998C9.96274 12.203 9.99655 12.4021 10.0598 12.592L10.0682 12.617L10.0749 12.6425C10.0988 12.7334 10.1372 12.8263 10.177 12.8941L10.1873 12.9114L10.1966 12.9293C10.3924 13.3031 10.6982 13.61 11.0533 13.7903L11.0668 13.7972L11.0801 13.8046C11.1847 13.8627 11.2777 13.903 11.376 13.9325L11.3916 13.9372L11.4069 13.9424C11.5676 13.9977 11.7615 14.0289 11.9918 14.0289C12.2203 14.0289 12.4177 13.9981 12.5922 13.94L12.5983 13.9379L12.6045 13.936C12.711 13.9023 12.8155 13.8581 12.9118 13.8046L12.9205 13.7997L12.9295 13.795C13.2974 13.6023 13.6025 13.2972 13.7952 12.9293L13.8046 12.9114L13.8148 12.8941C13.8547 12.8263 13.893 12.7334 13.9169 12.6425L13.9265 12.6063L13.9393 12.5711C13.999 12.4069 14.0291 12.2261 14.0291 11.9998C14.0291 11.7872 13.9949 11.5881 13.932 11.3994L13.9281 11.3877L13.9245 11.3758C13.8876 11.2527 13.8549 11.1766 13.8137 11.1092L13.7956 11.0795L13.78 11.0484C13.5969 10.6822 13.2984 10.3839 12.9386 10.2011L12.916 10.1897L12.8943 10.1768C12.8265 10.137 12.7336 10.0986 12.6427 10.0747L12.6065 10.0652L12.5713 10.0524C12.4092 9.99341 12.2208 9.96254 11.9918 9.96254ZM10.9072 8.49881C11.2471 8.38588 11.6123 8.32617 11.9918 8.32617C12.3568 8.32617 12.729 8.37403 13.0957 8.5021C13.297 8.55819 13.5084 8.64274 13.7011 8.75317C14.3527 9.08979 14.8906 9.62668 15.2285 10.2868C15.3536 10.4985 15.4303 10.7024 15.4883 10.8939C15.6029 11.2418 15.6655 11.6114 15.6655 11.9998C15.6655 12.3673 15.6169 12.7314 15.4895 13.0956C15.433 13.2985 15.3475 13.5116 15.2358 13.7055C14.8897 14.3579 14.3508 14.8955 13.6976 15.2399C13.504 15.3467 13.3028 15.4311 13.1035 15.4944C12.7399 15.6148 12.3666 15.6653 11.9918 15.6653C11.6219 15.6653 11.2486 15.6161 10.8903 15.4951C10.673 15.4287 10.4803 15.3423 10.2986 15.2423C9.63485 14.9014 9.09828 14.3508 8.756 13.7055C8.64238 13.5083 8.55594 13.2911 8.49944 13.0851C8.3878 12.742 8.32637 12.3768 8.32637 11.9998C8.32637 11.6207 8.38853 11.243 8.50357 10.8937C8.56793 10.6821 8.65211 10.4828 8.74664 10.3037C9.09152 9.63678 9.63439 9.09013 10.2986 8.7491C10.475 8.65203 10.6748 8.56074 10.9072 8.49881Z",
          fill: H
        }
      )
    ] }),
    "Settings"
  )
), IC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M7.117 20.276a1.25 1.25 0 0 1 .877 0c1.247.467 2.62.7 4.006.7s2.76-.233 4.006-.7a1.25 1.25 0 0 1 .877 0 11.5 11.5 0 0 0 4.006.724H22.5v1.5h-1.611a13 13 0 0 1-4.445-.787 13 13 0 0 1-4.444.763c-1.519 0-3.04-.25-4.444-.763a13 13 0 0 1-4.445.787H1.5V21h1.611a11.5 11.5 0 0 0 4.006-.724M7.33 1.5h9.306l1.05 2.787a.75.75 0 0 1-1.438.426L15.517 3H8.459l-.707 1.712a.75.75 0 0 1-1.442-.414z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M5.204 3.75H18.77l1.423 4.263-1.423.474-1.08-3.237H6.285L5.212 8.486l-1.424-.472z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "m11.988 6.558 9.618 1.38-2.366 11.028H4.735L2.37 7.938zM4.173 9.194l1.775 8.272h12.08l1.774-8.272-7.814-1.12z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M12 6.75a.75.75 0 0 1 .75.75V18a.75.75 0 0 1-1.5 0V7.5a.75.75 0 0 1 .75-.75"
        }
      )
    ] }),
    "Shipment"
  )
), TC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u("path", { fill: H, d: "m5.59 12.89 6.205 8.113L18 12.889H5.59ZM18 11.117 11.795 3l-6.204 8.117z" }),
    "Sort"
  )
), VC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ u(
      "path",
      {
        fill: H,
        fillRule: "evenodd",
        d: "M15.18 8.006 12 1.5 8.82 8.006l-7.32.942L6.855 14l-1.344 8.5L12 18.31l6.49 4.189-1.345-8.5L22.5 8.948zm3.986 2.026-4.98-.641L12 4.916 9.813 9.391l-4.979.64 3.626 3.421-.944 5.968L12 16.526l4.483 2.894-.943-5.968z"
      }
    ),
    "Star"
  )
), ZC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "m16.731 1-4.546 5.59c-2.296 2.824-2.297 7.298 0 10.123 1.186 1.458 2.823 2.271 4.546 2.271s3.36-.812 4.546-2.27c2.297-2.824 2.298-7.299 0-10.124zm0 2.474 3.325 4.089c1.836 2.257 1.835 5.922 0 8.178s-4.815 2.256-6.65 0c-1.836-2.257-1.835-5.922 0-8.178z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M1 9v6.027c.106 3.34 2.905 6.111 6.281 6.216 3.089.096 5.612-2.068 6.031-4.973.05-.341-.8-.91-.812-1.27-.023-.71-.378-1.791-.5-2.5-.116-.675 0-.996 0-.996C10.844 10.037 9.065 9.062 7.09 9zm1.619 1.602 4.42-.052c2.55.08 4.685 2.193 4.765 4.715.08 2.524-1.925 4.507-4.474 4.428-2.55-.08-4.683-2.193-4.764-4.715z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M15.948 20.669V9.679h1.567v10.99c0 2.073-2.532 3.11-4.013 1.645l-6.728-6.659 1.109-1.096 6.727 6.658c.494.489 1.338.143 1.338-.548"
        }
      )
    ] }),
    "Sustainability"
  )
), $C = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.4938 21C11.7796 21 12.0511 20.8753 12.2373 20.6586L17.9186 14.2954L19.0563 15.2729L13.3751 21.636C12.9039 22.1845 12.2169 22.5 11.4938 22.5C9.72593 22.5 8.52573 20.7031 9.20286 19.07L10.6141 15.9165H9.19829V14.4165H12.8598L10.5885 19.6445C10.3209 20.2899 10.7952 21 11.4938 21Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.07701 15.916C2.21828 15.916 1.49999 15.2274 1.49999 14.3535V12.7285C1.49999 12.1965 1.77902 11.8395 2.08003 11.6146C2.02696 11.4471 2.00246 11.2736 2.00246 11.1035V9.47856C2.00246 9.09139 2.17801 8.78719 2.38331 8.56653C2.3459 8.46322 2.32488 8.36481 2.31222 8.27958C2.28853 8.12005 2.28845 7.96061 2.28845 7.85358V6.22859C2.28845 5.629 2.6266 5.11663 3.11625 4.85406C3.10306 4.77266 3.0962 4.68902 3.0962 4.60361V3.06249C3.0962 2.18862 3.81449 1.5 4.67323 1.5H14.5792L19.2391 4.0347L19.2391 14.2184H17.9757L17.9186 4.88574L14.1652 3H4.67323C4.64817 3 4.62844 3.00927 4.6143 3.02318C4.6003 3.03694 4.5962 3.05036 4.5962 3.06249V4.60361C4.5962 4.61574 4.6003 4.62915 4.6143 4.64292C4.62844 4.65683 4.64817 4.6661 4.67323 4.6661H6.69259V6.1661H3.86548C3.84043 6.1661 3.8207 6.17537 3.80655 6.18927C3.79255 6.20304 3.78845 6.21646 3.78845 6.22859V7.85358C3.78845 7.87579 3.78851 7.89588 3.78868 7.91436C3.81138 7.91544 3.8369 7.91607 3.86548 7.91607H6.69259V9.41607H3.86548C3.84596 9.41607 3.7989 9.42102 3.73244 9.44279C3.66792 9.46393 3.60472 9.49457 3.5532 9.52885C3.53128 9.54343 3.51466 9.55653 3.50246 9.56721V11.1035C3.50246 11.1311 3.5059 11.1486 3.50889 11.1584C3.52017 11.1616 3.54262 11.166 3.57956 11.166H6.69259L6.69259 12.666H3.57956C3.51373 12.666 3.42023 12.6733 3.31861 12.6926C3.2163 12.7119 3.12475 12.7398 3.05455 12.7718C3.03124 12.7824 3.01337 12.7921 2.99999 12.8001V14.3535C2.99999 14.3657 3.00408 14.3791 3.01809 14.3928C3.03223 14.4067 3.05196 14.416 3.07701 14.416H10.2284V15.916L3.07701 15.916Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.7884 17.3618L17.7885 2.45063L22.2885 2.45053L22.2885 17.3617L17.7884 17.3618ZM20.7885 15.8617L20.7885 3.95056L19.2885 3.9506L19.2884 15.8618L20.7885 15.8617Z",
          fill: H
        }
      )
    ] }),
    "ThumbsDown"
  )
), WC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.2946 3C12.0089 3 11.7374 3.12469 11.5512 3.34143L5.8699 9.70459L4.7321 8.72713L10.4134 2.36397C10.8845 1.81553 11.5716 1.5 12.2946 1.5C14.0625 1.5 15.2627 3.29694 14.5856 4.93003L13.1744 8.0835H14.5902V9.5835H10.9286L13.2 4.35551C13.4676 3.71013 12.9933 3 12.2946 3Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.7114 8.08398C21.5702 8.08398 22.2885 8.7726 22.2885 9.64648V11.2715C22.2885 11.8035 22.0094 12.1605 21.7084 12.3854C21.7615 12.5529 21.786 12.7264 21.786 12.8965V14.5214C21.786 14.9086 21.6104 15.2128 21.4051 15.4335C21.4426 15.5368 21.4636 15.6352 21.4762 15.7204C21.4999 15.8799 21.5 16.0394 21.5 16.1464V17.7714C21.5 18.371 21.1619 18.8834 20.6722 19.1459C20.6854 19.2273 20.6923 19.311 20.6923 19.3964V20.9375C20.6923 21.8114 19.974 22.5 19.1152 22.5H9.20923L4.54938 19.9653L4.54938 9.78157H5.81272L5.8699 19.1143L9.62328 21H19.1152C19.1403 21 19.16 20.9907 19.1742 20.9768C19.1882 20.9631 19.1923 20.9496 19.1923 20.9375V19.3964C19.1923 19.3843 19.1882 19.3708 19.1742 19.3571C19.16 19.3432 19.1403 19.3339 19.1152 19.3339H17.0959V17.8339H19.923C19.948 17.8339 19.9678 17.8246 19.9819 17.8107C19.9959 17.797 20 17.7835 20 17.7714V16.1464C20 16.1242 19.9999 16.1041 19.9998 16.0856C19.9771 16.0846 19.9515 16.0839 19.923 16.0839H17.0959V14.5839H19.923C19.9425 14.5839 19.9896 14.579 20.056 14.5572C20.1205 14.5361 20.1837 14.5054 20.2352 14.4712C20.2572 14.4566 20.2738 14.4435 20.286 14.4328V12.8965C20.286 12.8689 20.2826 12.8514 20.2796 12.8416C20.2683 12.8384 20.2458 12.834 20.2089 12.834H17.0959L17.0959 11.334H20.2089C20.2747 11.334 20.3682 11.3267 20.4698 11.3074C20.5722 11.2881 20.6637 11.2602 20.7339 11.2282C20.7572 11.2176 20.7751 11.2079 20.7885 11.1999V9.64648C20.7885 9.63435 20.7844 9.62093 20.7704 9.60716C20.7562 9.59326 20.7365 9.58398 20.7114 9.58398H13.56V8.08398L20.7114 8.08398Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6 6.63818L6 21.5494L1.5 21.5495L1.5 6.63829L6 6.63818ZM3 8.13825L3 20.0494L4.5 20.0494L4.5 8.13822L3 8.13825Z",
          fill: H
        }
      )
    ] }),
    "ThumbsUp"
  )
), GC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.5 5.50003C16.9478 5.50003 16.5 5.94774 16.5 6.50003C16.5 7.05231 16.9478 7.50003 17.5 7.50003C18.0523 7.50003 18.5 7.05231 18.5 6.50003C18.5 5.94774 18.0523 5.50003 17.5 5.50003ZM17.5 4.00003C16.1193 4.00003 15 5.11931 15 6.50003C15 7.88074 16.1193 9.00003 17.5 9.00003C18.8808 9.00003 20 7.88074 20 6.50003C20 5.11931 18.8808 4.00003 17.5 4.00003Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.7974 11.1564C20.0211 9.57403 21.0001 7.77277 21.0001 6.23242C21.0001 4.53268 19.5068 3 17.4678 3C15.4288 3 13.9355 4.53268 13.9355 6.23242C13.9355 6.79396 14.1438 7.53557 14.5709 8.41423C14.9883 9.27299 15.5604 10.1528 16.1576 10.9601C16.6354 11.606 17.1155 12.187 17.5194 12.6513C17.9033 12.2422 18.3513 11.7331 18.7974 11.1564ZM17.4678 14.8099C17.4678 14.8099 22.5001 10.3733 22.5001 6.23242C22.5001 3.61878 20.247 1.5 17.4678 1.5C14.6886 1.5 12.4355 3.61877 12.4355 6.23242C12.4355 9.78173 17.4678 14.8099 17.4678 14.8099Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.5 18.9643C1.5 17.8126 2.43935 16.9643 3.53571 16.9643H5.03572C6.13208 16.9643 7.07143 17.8126 7.07143 18.9643V20.4643C7.07143 21.5886 6.16001 22.5 5.03571 22.5H3.53571C2.41142 22.5 1.5 21.5886 1.5 20.4643V18.9643ZM3.53571 18.4643C3.21191 18.4643 3 18.6958 3 18.9643V20.4643C3 20.7601 3.23985 21 3.53571 21H5.03571C5.33158 21 5.57143 20.7601 5.57143 20.4643V18.9643C5.57143 18.6958 5.35951 18.4643 5.03572 18.4643H3.53571Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.25005 5.75016C6.14548 5.75016 5.25005 6.64559 5.25005 7.75016V13.5002H3.75005V7.75016C3.75005 5.81717 5.31706 4.25016 7.25005 4.25016C9.18305 4.25016 10.7501 5.81717 10.7501 7.75016V18.0002C10.7501 19.657 12.0932 21.0002 13.7501 21.0002C15.4069 21.0002 16.7501 19.657 16.7501 18.0002V16.0002H18.2501V18.0002C18.2501 20.4854 16.2353 22.5002 13.7501 22.5002C11.2648 22.5002 9.25005 20.4854 9.25005 18.0002V7.75016C9.25005 6.64559 8.35462 5.75016 7.25005 5.75016Z",
          fill: H
        }
      )
    ] }),
    "TransportPlan"
  )
), UC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          d: "M9.375 20.99c-1.19 0-2.381-.147-3.5-.437-1.114.29-2.301.447-3.502.447H1.5v-1.286h.873c1.146 0 2.28-.157 3.33-.447l.17-.046.171.046c1.051.289 2.188.437 3.331.437v1.285ZM6.98 4.286l-.466 2.07a.643.643 0 1 1-1.254-.283L5.95 3h3.425l-.001 1.286H6.979Z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, d: "m5.231 6.868-1.027 3.39a.643.643 0 0 1-1.23-.373l1.303-4.303h5.108l-.002 1.286z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          d: "M3.371 10.814 4.457 16.5h4.92v1.286H3.392L1.88 9.866l7.504-1.904v1.326zm10.148 1.416c.914 0 1.72-.342 2.299-.952.58-.61.968-1.527.968-2.735 0-2.498-1.59-4.257-3.267-4.257V3c2.643 0 4.553 2.62 4.553 5.543 0 1.492-.486 2.74-1.322 3.62-.835.88-1.985 1.353-3.231 1.353z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M15.37 3.51h3.06v1.286h-3.06zm7.15 4.462a4.1 4.1 0 0 1-2.135.604H17.23V7.29h3.155c.518 0 1.023-.146 1.464-.415z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          d: "M14.73 6.975a4.1 4.1 0 0 0-1.21-.183l-.02-1.22a4.9 4.9 0 0 1 1.443.219c.59.17 1.074 1.16 1.123 2.124.058.94-.32 1.513-.862 1.513a1 1 0 0 1-.252-.036 4.9 4.9 0 0 0-1.442-.22l.01-1.208c.542 0 1.074.085 1.597.232V8c-.03-.512-.271-.964-.388-1.025Zm-1.21 9.498c1.254 0 2.59.542 3.423 1.388q.539-.137 1.108-.137c1.821 0 3.368 1.13 4.145 2.708L21.043 21c-.594-1.206-1.731-1.99-2.991-1.99a3 3 0 0 0-1.077.187l-.11.04h-.428l-.193-.233c-.64-.774-1.75-1.245-2.726-1.245z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M12 1.5v21h-1.5v-21z" })
    ] }),
    "Transhipment"
  )
), jC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M5.251 10.5a.75.75 0 0 1 .75.75v5.25h12v-5.25a.75.75 0 0 1 .75-.75l.75 1.5v6h-15v-6z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M6 15h3v1.5H6zm4.5-1.5h-6V18h6zM18 15h-3v1.5h3zm-4.5-1.5h6V18h-6z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M18 18.75h-1.5V18H18zm1.5-2.25H15v2.25c0 .828.504 1.5 1.126 1.5H18a1.5 1.5 0 0 0 1.5-1.5zM6 18.75h1.5V18H6zm3-2.25v2.25c0 .828-.503 1.5-1.124 1.5H6a1.5 1.5 0 0 1-1.5-1.5V16.5zm9.001 0a1.5 1.5 0 0 1 1.5-1.5h1.5V3H3.023l-.02 12h1.498a1.5 1.5 0 0 1 1.5 1.5h-4.5l.024-15h20.976v15z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M16.771 6h-9.54l-.9 4.5h11.34zm1.471-.294a1.5 1.5 0 0 0-1.47-1.206H7.23a1.5 1.5 0 0 0-1.47 1.206L4.5 12h15l-1.259-6.294ZM21 22.5H3V21h18z"
        }
      )
    ] }),
    "Truck"
  )
), KC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M1.5 9.525h21V22.5h-21zM3 21h18v-9.975H3z" }),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M11.25 19.5v-6.75h1.5v6.75zm-6.928-8.714C4.322 6.494 7.783 3 11.994 3c2.441 0 4.63 1.174 6.04 2.998l1.156-.957C17.508 2.89 14.908 1.5 11.994 1.5c-5.058 0-9.172 4.184-9.172 9.286z"
        }
      )
    ] }),
    "Unlock"
  )
), YC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M5.988 5.353A6.59 6.59 0 0 1 12 1.5c3.137 0 5.297 2.18 5.935 5.136h.098c2.159 0 4.467 2.228 4.467 4.432S20.692 15 18.533 15H14.3v-1.444h4.233c1.45 0 2.567-1.147 2.567-2.488S19.483 8.08 18.033 8.08h-1.312l-.072-.639C16.367 4.94 14.694 2.944 12 2.944c-2.275 0-4.186 1.428-4.889 3.381l-.17.471H6.12c-1.81 0-3.22 1.934-3.22 3.63s1.41 3.13 3.22 3.13H9.9V15H6.12c-2.519 0-4.62-2.015-4.62-4.574 0-2.515 2.028-5.004 4.488-5.073"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M12.69 7.5v15h-1.398v-15z" }),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "m16.69 11.19-.988.99L12 8.478 8.298 12.18l-.989-.99L12 6.5z" })
    ] }),
    "Upload"
  )
), qC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M3.597 11.918c2.07 2.847 5.084 4.603 8.403 4.603s6.333-1.756 8.403-4.603C18.333 9.071 15.319 7.315 12 7.315s-6.332 1.756-8.403 4.603M2.25 11.55C4.52 8.194 8.026 6 12 6s7.48 2.194 9.75 5.55l.25.368-.25.369c-2.27 3.355-5.776 5.55-9.75 5.55s-7.479-2.195-9.75-5.55L2 11.918z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M12 14.548a2.63 2.63 0 1 0 0-5.26 2.63 2.63 0 0 0 0 5.26m0 1.316a3.945 3.945 0 1 0 0-7.891 3.945 3.945 0 0 0 0 7.89Z"
        }
      ),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M12 13.233a1.315 1.315 0 1 0 0-2.63 1.315 1.315 0 0 0 0 2.63" })
    ] }),
    "View"
  )
), XC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M21 3H3v18h18zM1.5 1.5h21v21h-21z" }),
      /* @__PURE__ */ u("path", { fill: H, d: "M13 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0" }),
      /* @__PURE__ */ u("path", { fill: H, fillRule: "evenodd", d: "M13 5v10h-2V5z" })
    ] }),
    "Warning"
  )
), JC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          d: "M13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
          fill: H
        }
      ),
      /* @__PURE__ */ u("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 16L11 6H13L13 16H11Z", fill: H })
    ] }),
    "WarningPlain"
  )
), QC = W(
  (e, t) => fe(
    e,
    t,
    /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M9 3.3a1.2 1.2 0 0 0-1.2 1.2v1.2h8.4V4.5A1.2 1.2 0 0 0 15 3.3zM6 4.5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v3H6z"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          fill: H,
          fillRule: "evenodd",
          d: "M3.01 8.054 3 20.447c0 .279.23.553.6.553h16.8c.37 0 .6-.274.6-.553V8.053c0-.28-.23-.553-.6-.553H3.6c-.36 0-.59.265-.59.554M1.5 20.447l.01-12.394C1.51 6.913 2.434 6 3.6 6h16.8c1.166 0 2.1.913 2.1 2.053v12.394c0 1.14-.934 2.053-2.1 2.053H3.6c-1.166 0-2.1-.913-2.1-2.053"
        }
      )
    ] }),
    "Work"
  )
), G6 = {
  Activity: {
    component: cy,
    category: "Alert"
    /* ALERT */
  },
  Agenda: {
    component: dy,
    category: "Notes"
    /* NOTES */
  },
  AI: {
    component: uy,
    category: "Logos"
    /* LOGOS */
  },
  ArrowLeft: {
    component: fy,
    category: "System"
    /* SYSTEM */
  },
  ArrowDown: {
    component: hy,
    category: "System"
    /* SYSTEM */
  },
  ArrowDropdown: {
    component: py,
    category: "System"
    /* SYSTEM */
  },
  ArrowDropup: {
    component: my,
    category: "System"
    /* SYSTEM */
  },
  ArrowRight: {
    component: vy,
    category: "System"
    /* SYSTEM */
  },
  ArrowUp: {
    component: gy,
    category: "System"
    /* SYSTEM */
  },
  Attach: {
    component: Ly,
    category: "Action"
    /* ACTION */
  },
  Avatar: {
    component: wy,
    category: "People"
    /* PEOPLE */
  },
  BarChart: {
    component: My,
    category: "Data"
    /* DATA */
  },
  Bill: {
    component: xy,
    category: "Navigation"
    /* NAVIGATION */
  },
  Bin: {
    component: by,
    category: "Action"
    /* ACTION */
  },
  Booking: {
    component: yy,
    category: "Logistics"
    /* LOGISTICS */
  },
  Bookmark: {
    component: Cy,
    category: "Notes"
    /* NOTES */
  },
  Calendar: {
    component: Ey,
    category: "Time"
    /* TIME */
  },
  Cancel: {
    component: Fy,
    category: "Action"
    /* ACTION */
  },
  Cards: {
    component: zy,
    category: "System"
    /* SYSTEM */
  },
  Chat: {
    component: Ay,
    category: "Alert"
    /* ALERT */
  },
  Check: {
    component: Sy,
    category: "System"
    /* SYSTEM */
  },
  CheckCircle: {
    component: ky,
    category: "Action"
    /* ACTION */
  },
  CheckMark: {
    component: Dy,
    category: "Action"
    /* ACTION */
  },
  ChevronDown: {
    component: Ry,
    category: "System"
    /* SYSTEM */
  },
  ChevronLeft: {
    component: _y,
    category: "System"
    /* SYSTEM */
  },
  ChevronRight: {
    component: Py,
    category: "System"
    /* SYSTEM */
  },
  ChevronUp: {
    component: Hy,
    category: "System"
    /* SYSTEM */
  },
  Clock: {
    component: Oy,
    category: "Time"
    /* TIME */
  },
  Close: {
    component: Ny,
    category: "System"
    /* SYSTEM */
  },
  CompareArrows: {
    component: By,
    category: "System"
    /* SYSTEM */
  },
  Dark: {
    component: Iy,
    category: "System"
    /* SYSTEM */
  },
  Dashboard: {
    component: Ty,
    category: "Navigation"
    /* NAVIGATION */
  },
  Document: {
    component: Vy,
    category: "Notes"
    /* NOTES */
  },
  Domain: {
    component: Zy,
    category: "Navigation"
    /* NAVIGATION */
  },
  Download: {
    component: $y,
    category: "Action"
    /* ACTION */
  },
  Email: {
    component: Wy,
    category: "Alert"
    /* ALERT */
  },
  EventNote: {
    component: Gy,
    category: "Time"
    /* TIME */
  },
  Expand: {
    component: Uy,
    category: "System"
    /* SYSTEM */
  },
  Explore: {
    component: jy,
    category: "Navigation"
    /* NAVIGATION */
  },
  Export: {
    component: Ky,
    category: "System"
    /* SYSTEM */
  },
  External: {
    component: Yy,
    category: "System"
    /* SYSTEM */
  },
  Feed: {
    component: qy,
    category: "Alert"
    /* ALERT */
  },
  Fcl: {
    component: Xy,
    category: "Logistics"
    /* LOGISTICS */
  },
  FileCopy: {
    component: Jy,
    category: "Notes"
    /* NOTES */
  },
  Filter: {
    component: Qy,
    category: "Action"
    /* ACTION */
  },
  Group: {
    component: eC,
    category: "System"
    /* SYSTEM */
  },
  HamburgerMenu: {
    component: tC,
    category: "System"
    /* SYSTEM */
  },
  Help: {
    component: nC,
    category: "Alert"
    /* ALERT */
  },
  HelpCircle: {
    component: rC,
    category: "Alert"
    /* ALERT */
  },
  Hide: {
    component: iC,
    category: "View"
    /* VIEW */
  },
  Historic: {
    component: lC,
    category: "Navigation"
    /* NAVIGATION */
  },
  Home: {
    component: oC,
    category: "Navigation"
    /* NAVIGATION */
  },
  Info: {
    component: aC,
    category: "Alert"
    /* ALERT */
  },
  InfoCircle: {
    component: sC,
    category: "Alert"
    /* ALERT */
  },
  Inspection: {
    component: cC,
    category: "View"
    /* VIEW */
  },
  Integration: {
    component: dC,
    category: "Logistics"
    /* LOGISTICS */
  },
  KeyboardTab: {
    component: uC,
    category: "System"
    /* SYSTEM */
  },
  Lcl: {
    component: fC,
    category: "Logistics"
    /* LOGISTICS */
  },
  Light: {
    component: hC,
    category: "System"
    /* SYSTEM */
  },
  LinkedIn: {
    component: pC,
    category: "Logos"
    /* LOGOS */
  },
  List: {
    component: mC,
    category: "System"
    /* SYSTEM */
  },
  Location: {
    component: vC,
    category: "Navigation"
    /* NAVIGATION */
  },
  ShipLocation: {
    component: gC,
    category: "Navigation"
    /* NAVIGATION */
  },
  Destination: {
    component: LC,
    category: "Navigation"
    /* NAVIGATION */
  },
  Lock: {
    component: wC,
    category: "Action"
    /* ACTION */
  },
  LogOut: {
    component: MC,
    category: "System"
    /* SYSTEM */
  },
  MagnifyingLens: {
    component: xC,
    category: "Action"
    /* ACTION */
  },
  Minus: {
    component: bC,
    category: "System"
    /* SYSTEM */
  },
  More: {
    component: yC,
    category: "System"
    /* SYSTEM */
  },
  Network: {
    component: CC,
    category: "Navigation"
    /* NAVIGATION */
  },
  NoteAdd: {
    component: EC,
    category: "Notes"
    /* NOTES */
  },
  NoteEdit: {
    component: FC,
    category: "Notes"
    /* NOTES */
  },
  Note: {
    component: zC,
    category: "Notes"
    /* NOTES */
  },
  Notification: {
    component: AC,
    category: "Alert"
    /* ALERT */
  },
  Pencil: {
    component: SC,
    category: "Action"
    /* ACTION */
  },
  People: {
    component: kC,
    category: "People"
    /* PEOPLE */
  },
  PersonDisabled: {
    component: DC,
    category: "People"
    /* PEOPLE */
  },
  Person: {
    component: RC,
    category: "People"
    /* PEOPLE */
  },
  Plane: {
    component: _C,
    category: "Means of Transport"
    /* MEANS_OF_TRANSPORT */
  },
  Plus: {
    component: PC,
    category: "System"
    /* SYSTEM */
  },
  Printer: {
    component: HC,
    category: "Action"
    /* ACTION */
  },
  Railway: {
    component: OC,
    category: "Means of Transport"
    /* MEANS_OF_TRANSPORT */
  },
  Refresh: {
    component: NC,
    category: "System"
    /* SYSTEM */
  },
  Settings: {
    component: BC,
    category: "System"
    /* SYSTEM */
  },
  Shipment: {
    component: IC,
    category: "Means of Transport"
    /* MEANS_OF_TRANSPORT */
  },
  Sort: {
    component: TC,
    category: "System"
    /* SYSTEM */
  },
  Star: {
    component: VC,
    category: "Notes"
    /* NOTES */
  },
  Sustainability: {
    component: ZC,
    category: "Sustainability"
    /* SUSTAINABILITY */
  },
  ThumbsDown: {
    component: $C,
    category: "People"
    /* PEOPLE */
  },
  ThumbsUp: {
    component: WC,
    category: "People"
    /* PEOPLE */
  },
  TransportPlan: {
    component: GC,
    category: "Navigation"
    /* NAVIGATION */
  },
  Transhipment: {
    component: UC,
    category: "Means of Transport"
    /* MEANS_OF_TRANSPORT */
  },
  Truck: {
    component: jC,
    category: "Means of Transport"
    /* MEANS_OF_TRANSPORT */
  },
  Unlock: {
    component: KC,
    category: "Action"
    /* ACTION */
  },
  Upload: {
    component: YC,
    category: "Action"
    /* ACTION */
  },
  View: {
    component: qC,
    category: "View"
    /* VIEW */
  },
  Warning: {
    component: XC,
    category: "Alert"
    /* ALERT */
  },
  WarningPlain: {
    component: JC,
    category: "Alert"
    /* ALERT */
  },
  Work: {
    component: QC,
    category: "Navigation"
    /* NAVIGATION */
  }
}, lX = (e) => typeof e == "string" && Object.prototype.hasOwnProperty.call(G6, e), Re = W(({ name: e, ...t }, n) => {
  const r = G6[e].component;
  return /* @__PURE__ */ u(r, { ref: n, ...t });
});
Re.displayName = "Icon";
const eE = W(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u(wb, { ref: n, ...t })
);
eE.displayName = "Accordion";
const tE = W(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u(Mb, { ref: n, className: S("border-accordion-border border-b", e), ...t })
);
tE.displayName = "AccordionItem";
const nE = W(
  ({ className: e, children: t, icon: n, description: r, suffix: i, ...a }, c) => /* @__PURE__ */ u(xb, { className: "flex", children: /* @__PURE__ */ V(
    bb,
    {
      ref: c,
      className: S(
        "flex flex-1 items-center justify-between gap-8 px-2 py-4 transition-all",
        "[&[data-state=open]>.indicator]:rotate-180",
        "focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-hidden",
        "disabled:cursor-not-allowed",
        e
      ),
      ...a,
      children: [
        /* @__PURE__ */ V("div", { className: S("flex flex-1 flex-col", "sm:flex-row sm:items-center sm:gap-8"), children: [
          /* @__PURE__ */ V("div", { className: S("text-accordion-label flex items-center gap-8"), children: [
            n,
            /* @__PURE__ */ u("div", { children: t })
          ] }),
          /* @__PURE__ */ V("div", { className: S("text-accordion-label flex flex-1 items-center gap-8"), children: [
            r ? /* @__PURE__ */ u("div", { className: S("text-accordion-description text-sm"), children: r }) : null,
            i ? /* @__PURE__ */ u("div", { className: S("text-accordion-tag text-md ml-auto"), children: i }) : null
          ] })
        ] }),
        /* @__PURE__ */ u("div", { className: "indicator flex transition-transform duration-200", children: /* @__PURE__ */ u(Re, { size: "md", name: "ChevronDown" }) })
      ]
    }
  ) })
);
nE.displayName = "AccordionTrigger";
const rE = W(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ u(
    yb,
    {
      ref: r,
      className: S(
        "overflow-hidden text-sm transition-all duration-500",
        "data-[state=closed]:animate-accordion-up",
        "data-[state=open]:animate-accordion-down"
      ),
      ...n,
      children: /* @__PURE__ */ u("div", { className: S("px-2 pb-4", e), children: t })
    }
  )
);
rE.displayName = "AccordionContent";
const iE = Ye(S("flex rounded-md p-3 text-sm gap-8 border"), {
  variants: {
    /**
     * Optional feedback state for the alert instance.
     * @default neutral
     */
    variant: {
      muted: "bg-alert-muted-background border-alert-muted-border text-alert-muted-text",
      primary: "bg-alert-primary-background border-alert-primary-border text-alert-primary-text",
      negative: "bg-alert-negative-background border-alert-negative-border text-alert-negative-text",
      warning: "bg-alert-warning-background border-alert-warning-border text-alert-warning-text",
      positive: "bg-alert-positive-background border-alert-positive-border text-alert-positive-text"
    }
  },
  defaultVariants: {
    variant: "muted"
  }
}), lE = Ye("", {
  variants: {
    variant: {
      muted: "text-alert-muted-title",
      primary: "text-alert-primary-title",
      negative: "text-alert-negative-title",
      warning: "text-alert-warning-title",
      positive: "text-alert-positive-title"
    }
  },
  defaultVariants: {
    variant: "muted"
  }
}), oE = Ye("text-xs", {
  variants: {
    variant: {
      muted: "text-alert-muted-description",
      primary: "text-alert-primary-description",
      negative: "text-alert-negative-description",
      warning: "text-alert-warning-description",
      positive: "text-alert-positive-description"
    }
  },
  defaultVariants: {
    variant: "muted"
  }
}), aE = Ye(S("flex mt-0.5 shrink-0"), {
  variants: {
    variant: {
      muted: "text-alert-muted-start-icon",
      primary: "text-alert-primary-start-icon",
      negative: "text-alert-negative-start-icon",
      warning: "text-alert-warning-start-icon",
      positive: "text-alert-positive-start-icon"
    }
  },
  defaultVariants: {
    variant: "muted"
  }
}), sE = ({ variant: e = "muted", title: t, description: n, children: r, ...i }) => /* @__PURE__ */ V("div", { role: "alert", className: S(iE({ variant: e })), ...i, children: [
  /* @__PURE__ */ u("div", { className: S(aE({ variant: e })), children: /* @__PURE__ */ u(Re, { size: "sm", name: "Info" }) }),
  /* @__PURE__ */ V("div", { className: S("flex min-w-0 shrink flex-col gap-4"), children: [
    /* @__PURE__ */ u("div", { className: S(lE({ variant: e })), children: t }),
    n ? /* @__PURE__ */ u("div", { className: S(oE({ variant: e })), children: n }) : null,
    r
  ] })
] });
sE.displayName = "Alert";
function tn(e) {
  const t = M.useRef(e);
  return M.useEffect(() => {
    t.current = e;
  }), M.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
var R0 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, _0 = { exports: {} }, ba = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var U4;
function cE() {
  if (U4) return ba;
  U4 = 1;
  var e = o;
  function t(v, g) {
    return v === g && (v !== 0 || 1 / v === 1 / g) || v !== v && g !== g;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, a = e.useLayoutEffect, c = e.useDebugValue;
  function d(v, g) {
    var w = g(), x = r({ inst: { value: w, getSnapshot: g } }), b = x[0].inst, y = x[1];
    return a(
      function() {
        b.value = w, b.getSnapshot = g, f(b) && y({ inst: b });
      },
      [v, w, g]
    ), i(
      function() {
        return f(b) && y({ inst: b }), v(function() {
          f(b) && y({ inst: b });
        });
      },
      [v]
    ), c(w), w;
  }
  function f(v) {
    var g = v.getSnapshot;
    v = v.value;
    try {
      var w = g();
      return !n(v, w);
    } catch {
      return !0;
    }
  }
  function p(v, g) {
    return g();
  }
  var m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? p : d;
  return ba.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : m, ba;
}
var ya = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var j4;
function dE() {
  return j4 || (j4 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(w, x) {
      return w === x && (w !== 0 || 1 / w === 1 / x) || w !== w && x !== x;
    }
    function t(w, x) {
      m || i.startTransition === void 0 || (m = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var b = x();
      if (!v) {
        var y = x();
        a(b, y) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), v = !0);
      }
      y = c({
        inst: { value: b, getSnapshot: x }
      });
      var E = y[0].inst, z = y[1];
      return f(
        function() {
          E.value = b, E.getSnapshot = x, n(E) && z({ inst: E });
        },
        [w, b, x]
      ), d(
        function() {
          return n(E) && z({ inst: E }), w(function() {
            n(E) && z({ inst: E });
          });
        },
        [w]
      ), p(b), b;
    }
    function n(w) {
      var x = w.getSnapshot;
      w = w.value;
      try {
        var b = x();
        return !a(w, b);
      } catch {
        return !0;
      }
    }
    function r(w, x) {
      return x();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = o, a = typeof Object.is == "function" ? Object.is : e, c = i.useState, d = i.useEffect, f = i.useLayoutEffect, p = i.useDebugValue, m = !1, v = !1, g = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    ya.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : g, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), ya;
}
var K4;
function uE() {
  return K4 || (K4 = 1, process.env.NODE_ENV === "production" ? _0.exports = cE() : _0.exports = dE()), _0.exports;
}
var fE = uE();
function hE() {
  return fE.useSyncExternalStore(
    pE,
    () => !0,
    () => !1
  );
}
function pE() {
  return () => {
  };
}
var Js = "Avatar", [mE, oX] = Tt(Js), [vE, U6] = mE(Js), j6 = M.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, ...r } = e, [i, a] = M.useState("idle");
    return /* @__PURE__ */ u(
      vE,
      {
        scope: n,
        imageLoadingStatus: i,
        onImageLoadingStatusChange: a,
        children: /* @__PURE__ */ u(ke.span, { ...r, ref: t })
      }
    );
  }
);
j6.displayName = Js;
var K6 = "AvatarImage", Y6 = M.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, src: r, onLoadingStatusChange: i = () => {
    }, ...a } = e, c = U6(K6, n), d = gE(r, a), f = tn((p) => {
      i(p), c.onImageLoadingStatusChange(p);
    });
    return yn(() => {
      d !== "idle" && f(d);
    }, [d, f]), d === "loaded" ? /* @__PURE__ */ u(ke.img, { ...a, ref: t, src: r }) : null;
  }
);
Y6.displayName = K6;
var q6 = "AvatarFallback", X6 = M.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, delayMs: r, ...i } = e, a = U6(q6, n), [c, d] = M.useState(r === void 0);
    return M.useEffect(() => {
      if (r !== void 0) {
        const f = window.setTimeout(() => d(!0), r);
        return () => window.clearTimeout(f);
      }
    }, [r]), c && a.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ u(ke.span, { ...i, ref: t }) : null;
  }
);
X6.displayName = q6;
function Y4(e, t) {
  return e ? t ? (e.src !== t && (e.src = t), e.complete && e.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function gE(e, { referrerPolicy: t, crossOrigin: n }) {
  const r = hE(), i = M.useRef(null), a = r ? (i.current || (i.current = new window.Image()), i.current) : null, [c, d] = M.useState(
    () => Y4(a, e)
  );
  return yn(() => {
    d(Y4(a, e));
  }, [a, e]), yn(() => {
    const f = (v) => () => {
      d(v);
    };
    if (!a) return;
    const p = f("loaded"), m = f("error");
    return a.addEventListener("load", p), a.addEventListener("error", m), t && (a.referrerPolicy = t), typeof n == "string" && (a.crossOrigin = n), () => {
      a.removeEventListener("load", p), a.removeEventListener("error", m);
    };
  }, [a, n, t]), c;
}
var LE = j6, wE = Y6, ME = X6;
const xE = Ye(
  "relative flex h-8 w-8 items-center justify-center shrink-0 overflow-hidden rounded-full bg-avatar-background border border-avatar-border text-avatar-text ",
  {
    variants: {
      /**
       * The size of the avatar consist of 4 sizes: sm, md, lg, xl
       * @default md
       * @type 'xs' |'sm' | 'md' | 'lg'
       **/
      size: {
        xs: "h-4 w-4",
        sm: "h-6 w-6",
        md: "h-8 w-8",
        lg: "h-10 w-10"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), J6 = W(
  ({ size: e, className: t, ...n }, r) => /* @__PURE__ */ u(LE, { ref: r, className: S(xE({ size: e })), ...n })
);
J6.displayName = "Avatar";
const Q6 = W(({ className: e, ...t }, n) => /* @__PURE__ */ u(wE, { ref: n, className: S("aspect-square h-full w-full", e), ...t }));
Q6.displayName = "AvatarImage";
const e7 = W(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  ME,
  {
    ref: n,
    className: S("flex h-full w-full items-center justify-center rounded-full text-xs", e),
    ...t
  }
));
e7.displayName = "AvatarFallback";
const bE = Ye("flex", {
  variants: {
    gap: {
      0: "gap-0",
      2: "gap-2",
      4: "gap-4",
      8: "gap-8",
      12: "gap-12",
      16: "gap-16",
      24: "gap-24"
    },
    x: {
      start: "justify-start",
      center: "justify-center",
      end: "justify-end",
      between: "justify-between"
    },
    y: {
      start: "items-start",
      center: "items-center",
      end: "items-end",
      baseline: "items-baseline"
    },
    /** Breakpoint up to which elements are displayed below each other on a vertical axis for responsive reasons. */
    breakpoint: {
      sm: "max-sm:flex-col max-sm:items-start",
      md: "max-md:flex-col max-md:items-start",
      lg: "max-lg:flex-col max-lg:items-start",
      xl: "max-xl:flex-col max-xl:items-start"
    },
    fullWidth: {
      true: "w-full"
    },
    fullHeight: {
      true: "h-full"
    }
  },
  defaultVariants: {
    gap: 0,
    x: "start",
    y: "start"
  }
}), sr = ({
  children: e,
  gap: t = 0,
  x: n = "start",
  y: r = "start",
  breakpoint: i,
  wrap: a,
  fullWidth: c,
  fullHeight: d,
  ...f
}) => /* @__PURE__ */ u(
  "div",
  {
    className: S(bE({ gap: t, x: n, y: r, breakpoint: i, fullWidth: c, fullHeight: d }), {
      "flex-wrap": a,
      "[&>.card_+_.card]:border-s-0": t === 0
    }),
    ...f,
    children: e
  }
);
sr.displayName = "Cluster";
function yE(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = tn(e);
  M.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var CE = "DismissableLayer", us = "dismissableLayer.update", EE = "dismissableLayer.pointerDownOutside", FE = "dismissableLayer.focusOutside", q4, t7 = M.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), E1 = M.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: a,
      onInteractOutside: c,
      onDismiss: d,
      ...f
    } = e, p = M.useContext(t7), [m, v] = M.useState(null), g = (m == null ? void 0 : m.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, w] = M.useState({}), x = ct(t, (P) => v(P)), b = Array.from(p.layers), [y] = [...p.layersWithOutsidePointerEventsDisabled].slice(-1), E = b.indexOf(y), z = m ? b.indexOf(m) : -1, k = p.layersWithOutsidePointerEventsDisabled.size > 0, R = z >= E, F = AE((P) => {
      const O = P.target, Z = [...p.branches].some((te) => te.contains(O));
      !R || Z || (i == null || i(P), c == null || c(P), P.defaultPrevented || d == null || d());
    }, g), _ = SE((P) => {
      const O = P.target;
      [...p.branches].some((te) => te.contains(O)) || (a == null || a(P), c == null || c(P), P.defaultPrevented || d == null || d());
    }, g);
    return yE((P) => {
      z === p.layers.size - 1 && (r == null || r(P), !P.defaultPrevented && d && (P.preventDefault(), d()));
    }, g), M.useEffect(() => {
      if (m)
        return n && (p.layersWithOutsidePointerEventsDisabled.size === 0 && (q4 = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), p.layersWithOutsidePointerEventsDisabled.add(m)), p.layers.add(m), X4(), () => {
          n && p.layersWithOutsidePointerEventsDisabled.size === 1 && (g.body.style.pointerEvents = q4);
        };
    }, [m, g, n, p]), M.useEffect(() => () => {
      m && (p.layers.delete(m), p.layersWithOutsidePointerEventsDisabled.delete(m), X4());
    }, [m, p]), M.useEffect(() => {
      const P = () => w({});
      return document.addEventListener(us, P), () => document.removeEventListener(us, P);
    }, []), /* @__PURE__ */ u(
      ke.div,
      {
        ...f,
        ref: x,
        style: {
          pointerEvents: k ? R ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: be(e.onFocusCapture, _.onFocusCapture),
        onBlurCapture: be(e.onBlurCapture, _.onBlurCapture),
        onPointerDownCapture: be(
          e.onPointerDownCapture,
          F.onPointerDownCapture
        )
      }
    );
  }
);
E1.displayName = CE;
var zE = "DismissableLayerBranch", n7 = M.forwardRef((e, t) => {
  const n = M.useContext(t7), r = M.useRef(null), i = ct(t, r);
  return M.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ u(ke.div, { ...e, ref: i });
});
n7.displayName = zE;
function AE(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = tn(e), r = M.useRef(!1), i = M.useRef(() => {
  });
  return M.useEffect(() => {
    const a = (d) => {
      if (d.target && !r.current) {
        let f = function() {
          r7(
            EE,
            n,
            p,
            { discrete: !0 }
          );
        };
        const p = { originalEvent: d };
        d.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = f, t.addEventListener("click", i.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, c = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(c), t.removeEventListener("pointerdown", a), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function SE(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = tn(e), r = M.useRef(!1);
  return M.useEffect(() => {
    const i = (a) => {
      a.target && !r.current && r7(FE, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function X4() {
  const e = new CustomEvent(us);
  document.dispatchEvent(e);
}
function r7(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? Ts(i, a) : i.dispatchEvent(a);
}
var kE = E1, DE = n7, Ca = 0;
function Qs() {
  M.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? J4()), document.body.insertAdjacentElement("beforeend", e[1] ?? J4()), Ca++, () => {
      Ca === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Ca--;
    };
  }, []);
}
function J4() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ea = "focusScope.autoFocusOnMount", Fa = "focusScope.autoFocusOnUnmount", Q4 = { bubbles: !1, cancelable: !0 }, RE = "FocusScope", Sl = M.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: a,
    ...c
  } = e, [d, f] = M.useState(null), p = tn(i), m = tn(a), v = M.useRef(null), g = ct(t, (b) => f(b)), w = M.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  M.useEffect(() => {
    if (r) {
      let b = function(k) {
        if (w.paused || !d) return;
        const R = k.target;
        d.contains(R) ? v.current = R : er(v.current, { select: !0 });
      }, y = function(k) {
        if (w.paused || !d) return;
        const R = k.relatedTarget;
        R !== null && (d.contains(R) || er(v.current, { select: !0 }));
      }, E = function(k) {
        if (document.activeElement === document.body)
          for (const F of k)
            F.removedNodes.length > 0 && er(d);
      };
      document.addEventListener("focusin", b), document.addEventListener("focusout", y);
      const z = new MutationObserver(E);
      return d && z.observe(d, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", b), document.removeEventListener("focusout", y), z.disconnect();
      };
    }
  }, [r, d, w.paused]), M.useEffect(() => {
    if (d) {
      td.add(w);
      const b = document.activeElement;
      if (!d.contains(b)) {
        const E = new CustomEvent(Ea, Q4);
        d.addEventListener(Ea, p), d.dispatchEvent(E), E.defaultPrevented || (_E(BE(i7(d)), { select: !0 }), document.activeElement === b && er(d));
      }
      return () => {
        d.removeEventListener(Ea, p), setTimeout(() => {
          const E = new CustomEvent(Fa, Q4);
          d.addEventListener(Fa, m), d.dispatchEvent(E), E.defaultPrevented || er(b ?? document.body, { select: !0 }), d.removeEventListener(Fa, m), td.remove(w);
        }, 0);
      };
    }
  }, [d, p, m, w]);
  const x = M.useCallback(
    (b) => {
      if (!n && !r || w.paused) return;
      const y = b.key === "Tab" && !b.altKey && !b.ctrlKey && !b.metaKey, E = document.activeElement;
      if (y && E) {
        const z = b.currentTarget, [k, R] = PE(z);
        k && R ? !b.shiftKey && E === R ? (b.preventDefault(), n && er(k, { select: !0 })) : b.shiftKey && E === k && (b.preventDefault(), n && er(R, { select: !0 })) : E === z && b.preventDefault();
      }
    },
    [n, r, w.paused]
  );
  return /* @__PURE__ */ u(ke.div, { tabIndex: -1, ...c, ref: g, onKeyDown: x });
});
Sl.displayName = RE;
function _E(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (er(r, { select: t }), document.activeElement !== n) return;
}
function PE(e) {
  const t = i7(e), n = ed(t, e), r = ed(t.reverse(), e);
  return [n, r];
}
function i7(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function ed(e, t) {
  for (const n of e)
    if (!HE(n, { upTo: t })) return n;
}
function HE(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function OE(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function er(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && OE(e) && t && e.select();
  }
}
var td = NE();
function NE() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = nd(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = nd(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function nd(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function BE(e) {
  return e.filter((t) => t.tagName !== "A");
}
const IE = ["top", "right", "bottom", "left"], cr = Math.min, Ln = Math.max, el = Math.round, P0 = Math.floor, u2 = (e) => ({
  x: e,
  y: e
}), TE = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, VE = {
  start: "end",
  end: "start"
};
function fs(e, t, n) {
  return Ln(e, cr(t, n));
}
function P2(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function H2(e) {
  return e.split("-")[0];
}
function F1(e) {
  return e.split("-")[1];
}
function e3(e) {
  return e === "x" ? "y" : "x";
}
function t3(e) {
  return e === "y" ? "height" : "width";
}
function dr(e) {
  return ["top", "bottom"].includes(H2(e)) ? "y" : "x";
}
function n3(e) {
  return e3(dr(e));
}
function ZE(e, t, n) {
  n === void 0 && (n = !1);
  const r = F1(e), i = n3(e), a = t3(i);
  let c = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (c = tl(c)), [c, tl(c)];
}
function $E(e) {
  const t = tl(e);
  return [hs(e), t, hs(t)];
}
function hs(e) {
  return e.replace(/start|end/g, (t) => VE[t]);
}
function WE(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], a = ["top", "bottom"], c = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? a : c;
    default:
      return [];
  }
}
function GE(e, t, n, r) {
  const i = F1(e);
  let a = WE(H2(e), n === "start", r);
  return i && (a = a.map((c) => c + "-" + i), t && (a = a.concat(a.map(hs)))), a;
}
function tl(e) {
  return e.replace(/left|right|bottom|top/g, (t) => TE[t]);
}
function UE(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function l7(e) {
  return typeof e != "number" ? UE(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function nl(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function rd(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const a = dr(t), c = n3(t), d = t3(c), f = H2(t), p = a === "y", m = r.x + r.width / 2 - i.width / 2, v = r.y + r.height / 2 - i.height / 2, g = r[d] / 2 - i[d] / 2;
  let w;
  switch (f) {
    case "top":
      w = {
        x: m,
        y: r.y - i.height
      };
      break;
    case "bottom":
      w = {
        x: m,
        y: r.y + r.height
      };
      break;
    case "right":
      w = {
        x: r.x + r.width,
        y: v
      };
      break;
    case "left":
      w = {
        x: r.x - i.width,
        y: v
      };
      break;
    default:
      w = {
        x: r.x,
        y: r.y
      };
  }
  switch (F1(t)) {
    case "start":
      w[c] -= g * (n && p ? -1 : 1);
      break;
    case "end":
      w[c] += g * (n && p ? -1 : 1);
      break;
  }
  return w;
}
const jE = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: c
  } = n, d = a.filter(Boolean), f = await (c.isRTL == null ? void 0 : c.isRTL(t));
  let p = await c.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: m,
    y: v
  } = rd(p, r, f), g = r, w = {}, x = 0;
  for (let b = 0; b < d.length; b++) {
    const {
      name: y,
      fn: E
    } = d[b], {
      x: z,
      y: k,
      data: R,
      reset: F
    } = await E({
      x: m,
      y: v,
      initialPlacement: r,
      placement: g,
      strategy: i,
      middlewareData: w,
      rects: p,
      platform: c,
      elements: {
        reference: e,
        floating: t
      }
    });
    m = z ?? m, v = k ?? v, w = {
      ...w,
      [y]: {
        ...w[y],
        ...R
      }
    }, F && x <= 50 && (x++, typeof F == "object" && (F.placement && (g = F.placement), F.rects && (p = F.rects === !0 ? await c.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : F.rects), {
      x: m,
      y: v
    } = rd(p, g, f)), b = -1);
  }
  return {
    x: m,
    y: v,
    placement: g,
    strategy: i,
    middlewareData: w
  };
};
async function hi(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: a,
    rects: c,
    elements: d,
    strategy: f
  } = e, {
    boundary: p = "clippingAncestors",
    rootBoundary: m = "viewport",
    elementContext: v = "floating",
    altBoundary: g = !1,
    padding: w = 0
  } = P2(t, e), x = l7(w), y = d[g ? v === "floating" ? "reference" : "floating" : v], E = nl(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(y))) == null || n ? y : y.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(d.floating)),
    boundary: p,
    rootBoundary: m,
    strategy: f
  })), z = v === "floating" ? {
    x: r,
    y: i,
    width: c.floating.width,
    height: c.floating.height
  } : c.reference, k = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(d.floating)), R = await (a.isElement == null ? void 0 : a.isElement(k)) ? await (a.getScale == null ? void 0 : a.getScale(k)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, F = nl(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: d,
    rect: z,
    offsetParent: k,
    strategy: f
  }) : z);
  return {
    top: (E.top - F.top + x.top) / R.y,
    bottom: (F.bottom - E.bottom + x.bottom) / R.y,
    left: (E.left - F.left + x.left) / R.x,
    right: (F.right - E.right + x.right) / R.x
  };
}
const KE = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: a,
      platform: c,
      elements: d,
      middlewareData: f
    } = t, {
      element: p,
      padding: m = 0
    } = P2(e, t) || {};
    if (p == null)
      return {};
    const v = l7(m), g = {
      x: n,
      y: r
    }, w = n3(i), x = t3(w), b = await c.getDimensions(p), y = w === "y", E = y ? "top" : "left", z = y ? "bottom" : "right", k = y ? "clientHeight" : "clientWidth", R = a.reference[x] + a.reference[w] - g[w] - a.floating[x], F = g[w] - a.reference[w], _ = await (c.getOffsetParent == null ? void 0 : c.getOffsetParent(p));
    let P = _ ? _[k] : 0;
    (!P || !await (c.isElement == null ? void 0 : c.isElement(_))) && (P = d.floating[k] || a.floating[x]);
    const O = R / 2 - F / 2, Z = P / 2 - b[x] / 2 - 1, te = cr(v[E], Z), Y = cr(v[z], Z), X = te, re = P - b[x] - Y, ee = P / 2 - b[x] / 2 + O, de = fs(X, ee, re), ae = !f.arrow && F1(i) != null && ee !== de && a.reference[x] / 2 - (ee < X ? te : Y) - b[x] / 2 < 0, ge = ae ? ee < X ? ee - X : ee - re : 0;
    return {
      [w]: g[w] + ge,
      data: {
        [w]: de,
        centerOffset: ee - de - ge,
        ...ae && {
          alignmentOffset: ge
        }
      },
      reset: ae
    };
  }
}), YE = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: a,
        rects: c,
        initialPlacement: d,
        platform: f,
        elements: p
      } = t, {
        mainAxis: m = !0,
        crossAxis: v = !0,
        fallbackPlacements: g,
        fallbackStrategy: w = "bestFit",
        fallbackAxisSideDirection: x = "none",
        flipAlignment: b = !0,
        ...y
      } = P2(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const E = H2(i), z = dr(d), k = H2(d) === d, R = await (f.isRTL == null ? void 0 : f.isRTL(p.floating)), F = g || (k || !b ? [tl(d)] : $E(d)), _ = x !== "none";
      !g && _ && F.push(...GE(d, b, x, R));
      const P = [d, ...F], O = await hi(t, y), Z = [];
      let te = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (m && Z.push(O[E]), v) {
        const ee = ZE(i, c, R);
        Z.push(O[ee[0]], O[ee[1]]);
      }
      if (te = [...te, {
        placement: i,
        overflows: Z
      }], !Z.every((ee) => ee <= 0)) {
        var Y, X;
        const ee = (((Y = a.flip) == null ? void 0 : Y.index) || 0) + 1, de = P[ee];
        if (de)
          return {
            data: {
              index: ee,
              overflows: te
            },
            reset: {
              placement: de
            }
          };
        let ae = (X = te.filter((ge) => ge.overflows[0] <= 0).sort((ge, K) => ge.overflows[1] - K.overflows[1])[0]) == null ? void 0 : X.placement;
        if (!ae)
          switch (w) {
            case "bestFit": {
              var re;
              const ge = (re = te.filter((K) => {
                if (_) {
                  const J = dr(K.placement);
                  return J === z || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  J === "y";
                }
                return !0;
              }).map((K) => [K.placement, K.overflows.filter((J) => J > 0).reduce((J, he) => J + he, 0)]).sort((K, J) => K[1] - J[1])[0]) == null ? void 0 : re[0];
              ge && (ae = ge);
              break;
            }
            case "initialPlacement":
              ae = d;
              break;
          }
        if (i !== ae)
          return {
            reset: {
              placement: ae
            }
          };
      }
      return {};
    }
  };
};
function id(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function ld(e) {
  return IE.some((t) => e[t] >= 0);
}
const qE = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...i
      } = P2(e, t);
      switch (r) {
        case "referenceHidden": {
          const a = await hi(t, {
            ...i,
            elementContext: "reference"
          }), c = id(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: c,
              referenceHidden: ld(c)
            }
          };
        }
        case "escaped": {
          const a = await hi(t, {
            ...i,
            altBoundary: !0
          }), c = id(a, n.floating);
          return {
            data: {
              escapedOffsets: c,
              escaped: ld(c)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function XE(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), c = H2(n), d = F1(n), f = dr(n) === "y", p = ["left", "top"].includes(c) ? -1 : 1, m = a && f ? -1 : 1, v = P2(t, e);
  let {
    mainAxis: g,
    crossAxis: w,
    alignmentAxis: x
  } = typeof v == "number" ? {
    mainAxis: v,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: v.mainAxis || 0,
    crossAxis: v.crossAxis || 0,
    alignmentAxis: v.alignmentAxis
  };
  return d && typeof x == "number" && (w = d === "end" ? x * -1 : x), f ? {
    x: w * m,
    y: g * p
  } : {
    x: g * p,
    y: w * m
  };
}
const JE = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: a,
        placement: c,
        middlewareData: d
      } = t, f = await XE(t, e);
      return c === ((n = d.offset) == null ? void 0 : n.placement) && (r = d.arrow) != null && r.alignmentOffset ? {} : {
        x: i + f.x,
        y: a + f.y,
        data: {
          ...f,
          placement: c
        }
      };
    }
  };
}, QE = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: a = !0,
        crossAxis: c = !1,
        limiter: d = {
          fn: (y) => {
            let {
              x: E,
              y: z
            } = y;
            return {
              x: E,
              y: z
            };
          }
        },
        ...f
      } = P2(e, t), p = {
        x: n,
        y: r
      }, m = await hi(t, f), v = dr(H2(i)), g = e3(v);
      let w = p[g], x = p[v];
      if (a) {
        const y = g === "y" ? "top" : "left", E = g === "y" ? "bottom" : "right", z = w + m[y], k = w - m[E];
        w = fs(z, w, k);
      }
      if (c) {
        const y = v === "y" ? "top" : "left", E = v === "y" ? "bottom" : "right", z = x + m[y], k = x - m[E];
        x = fs(z, x, k);
      }
      const b = d.fn({
        ...t,
        [g]: w,
        [v]: x
      });
      return {
        ...b,
        data: {
          x: b.x - n,
          y: b.y - r,
          enabled: {
            [g]: a,
            [v]: c
          }
        }
      };
    }
  };
}, eF = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: a,
        middlewareData: c
      } = t, {
        offset: d = 0,
        mainAxis: f = !0,
        crossAxis: p = !0
      } = P2(e, t), m = {
        x: n,
        y: r
      }, v = dr(i), g = e3(v);
      let w = m[g], x = m[v];
      const b = P2(d, t), y = typeof b == "number" ? {
        mainAxis: b,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...b
      };
      if (f) {
        const k = g === "y" ? "height" : "width", R = a.reference[g] - a.floating[k] + y.mainAxis, F = a.reference[g] + a.reference[k] - y.mainAxis;
        w < R ? w = R : w > F && (w = F);
      }
      if (p) {
        var E, z;
        const k = g === "y" ? "width" : "height", R = ["top", "left"].includes(H2(i)), F = a.reference[v] - a.floating[k] + (R && ((E = c.offset) == null ? void 0 : E[v]) || 0) + (R ? 0 : y.crossAxis), _ = a.reference[v] + a.reference[k] + (R ? 0 : ((z = c.offset) == null ? void 0 : z[v]) || 0) - (R ? y.crossAxis : 0);
        x < F ? x = F : x > _ && (x = _);
      }
      return {
        [g]: w,
        [v]: x
      };
    }
  };
}, tF = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        rects: a,
        platform: c,
        elements: d
      } = t, {
        apply: f = () => {
        },
        ...p
      } = P2(e, t), m = await hi(t, p), v = H2(i), g = F1(i), w = dr(i) === "y", {
        width: x,
        height: b
      } = a.floating;
      let y, E;
      v === "top" || v === "bottom" ? (y = v, E = g === (await (c.isRTL == null ? void 0 : c.isRTL(d.floating)) ? "start" : "end") ? "left" : "right") : (E = v, y = g === "end" ? "top" : "bottom");
      const z = b - m.top - m.bottom, k = x - m.left - m.right, R = cr(b - m[y], z), F = cr(x - m[E], k), _ = !t.middlewareData.shift;
      let P = R, O = F;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (O = k), (r = t.middlewareData.shift) != null && r.enabled.y && (P = z), _ && !g) {
        const te = Ln(m.left, 0), Y = Ln(m.right, 0), X = Ln(m.top, 0), re = Ln(m.bottom, 0);
        w ? O = x - 2 * (te !== 0 || Y !== 0 ? te + Y : Ln(m.left, m.right)) : P = b - 2 * (X !== 0 || re !== 0 ? X + re : Ln(m.top, m.bottom));
      }
      await f({
        ...t,
        availableWidth: O,
        availableHeight: P
      });
      const Z = await c.getDimensions(d.floating);
      return x !== Z.width || b !== Z.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function kl() {
  return typeof window < "u";
}
function z1(e) {
  return o7(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function bn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function h2(e) {
  var t;
  return (t = (o7(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function o7(e) {
  return kl() ? e instanceof Node || e instanceof bn(e).Node : !1;
}
function Wn(e) {
  return kl() ? e instanceof Element || e instanceof bn(e).Element : !1;
}
function f2(e) {
  return kl() ? e instanceof HTMLElement || e instanceof bn(e).HTMLElement : !1;
}
function od(e) {
  return !kl() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof bn(e).ShadowRoot;
}
function zi(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = Gn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function nF(e) {
  return ["table", "td", "th"].includes(z1(e));
}
function Dl(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function r3(e) {
  const t = i3(), n = Wn(e) ? Gn(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function rF(e) {
  let t = ur(e);
  for (; f2(t) && !L1(t); ) {
    if (r3(t))
      return t;
    if (Dl(t))
      return null;
    t = ur(t);
  }
  return null;
}
function i3() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function L1(e) {
  return ["html", "body", "#document"].includes(z1(e));
}
function Gn(e) {
  return bn(e).getComputedStyle(e);
}
function Rl(e) {
  return Wn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ur(e) {
  if (z1(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    od(e) && e.host || // Fallback.
    h2(e)
  );
  return od(t) ? t.host : t;
}
function a7(e) {
  const t = ur(e);
  return L1(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : f2(t) && zi(t) ? t : a7(t);
}
function pi(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = a7(e), a = i === ((r = e.ownerDocument) == null ? void 0 : r.body), c = bn(i);
  if (a) {
    const d = ps(c);
    return t.concat(c, c.visualViewport || [], zi(i) ? i : [], d && n ? pi(d) : []);
  }
  return t.concat(i, pi(i, [], n));
}
function ps(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function s7(e) {
  const t = Gn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = f2(e), a = i ? e.offsetWidth : n, c = i ? e.offsetHeight : r, d = el(n) !== a || el(r) !== c;
  return d && (n = a, r = c), {
    width: n,
    height: r,
    $: d
  };
}
function l3(e) {
  return Wn(e) ? e : e.contextElement;
}
function m1(e) {
  const t = l3(e);
  if (!f2(t))
    return u2(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: a
  } = s7(t);
  let c = (a ? el(n.width) : n.width) / r, d = (a ? el(n.height) : n.height) / i;
  return (!c || !Number.isFinite(c)) && (c = 1), (!d || !Number.isFinite(d)) && (d = 1), {
    x: c,
    y: d
  };
}
const iF = /* @__PURE__ */ u2(0);
function c7(e) {
  const t = bn(e);
  return !i3() || !t.visualViewport ? iF : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function lF(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== bn(e) ? !1 : t;
}
function Pr(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), a = l3(e);
  let c = u2(1);
  t && (r ? Wn(r) && (c = m1(r)) : c = m1(e));
  const d = lF(a, n, r) ? c7(a) : u2(0);
  let f = (i.left + d.x) / c.x, p = (i.top + d.y) / c.y, m = i.width / c.x, v = i.height / c.y;
  if (a) {
    const g = bn(a), w = r && Wn(r) ? bn(r) : r;
    let x = g, b = ps(x);
    for (; b && r && w !== x; ) {
      const y = m1(b), E = b.getBoundingClientRect(), z = Gn(b), k = E.left + (b.clientLeft + parseFloat(z.paddingLeft)) * y.x, R = E.top + (b.clientTop + parseFloat(z.paddingTop)) * y.y;
      f *= y.x, p *= y.y, m *= y.x, v *= y.y, f += k, p += R, x = bn(b), b = ps(x);
    }
  }
  return nl({
    width: m,
    height: v,
    x: f,
    y: p
  });
}
function o3(e, t) {
  const n = Rl(e).scrollLeft;
  return t ? t.left + n : Pr(h2(e)).left + n;
}
function d7(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), i = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    o3(e, r)
  )), a = r.top + t.scrollTop;
  return {
    x: i,
    y: a
  };
}
function oF(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const a = i === "fixed", c = h2(r), d = t ? Dl(t.floating) : !1;
  if (r === c || d && a)
    return n;
  let f = {
    scrollLeft: 0,
    scrollTop: 0
  }, p = u2(1);
  const m = u2(0), v = f2(r);
  if ((v || !v && !a) && ((z1(r) !== "body" || zi(c)) && (f = Rl(r)), f2(r))) {
    const w = Pr(r);
    p = m1(r), m.x = w.x + r.clientLeft, m.y = w.y + r.clientTop;
  }
  const g = c && !v && !a ? d7(c, f, !0) : u2(0);
  return {
    width: n.width * p.x,
    height: n.height * p.y,
    x: n.x * p.x - f.scrollLeft * p.x + m.x + g.x,
    y: n.y * p.y - f.scrollTop * p.y + m.y + g.y
  };
}
function aF(e) {
  return Array.from(e.getClientRects());
}
function sF(e) {
  const t = h2(e), n = Rl(e), r = e.ownerDocument.body, i = Ln(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = Ln(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let c = -n.scrollLeft + o3(e);
  const d = -n.scrollTop;
  return Gn(r).direction === "rtl" && (c += Ln(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: a,
    x: c,
    y: d
  };
}
function cF(e, t) {
  const n = bn(e), r = h2(e), i = n.visualViewport;
  let a = r.clientWidth, c = r.clientHeight, d = 0, f = 0;
  if (i) {
    a = i.width, c = i.height;
    const p = i3();
    (!p || p && t === "fixed") && (d = i.offsetLeft, f = i.offsetTop);
  }
  return {
    width: a,
    height: c,
    x: d,
    y: f
  };
}
function dF(e, t) {
  const n = Pr(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = f2(e) ? m1(e) : u2(1), c = e.clientWidth * a.x, d = e.clientHeight * a.y, f = i * a.x, p = r * a.y;
  return {
    width: c,
    height: d,
    x: f,
    y: p
  };
}
function ad(e, t, n) {
  let r;
  if (t === "viewport")
    r = cF(e, n);
  else if (t === "document")
    r = sF(h2(e));
  else if (Wn(t))
    r = dF(t, n);
  else {
    const i = c7(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return nl(r);
}
function u7(e, t) {
  const n = ur(e);
  return n === t || !Wn(n) || L1(n) ? !1 : Gn(n).position === "fixed" || u7(n, t);
}
function uF(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = pi(e, [], !1).filter((d) => Wn(d) && z1(d) !== "body"), i = null;
  const a = Gn(e).position === "fixed";
  let c = a ? ur(e) : e;
  for (; Wn(c) && !L1(c); ) {
    const d = Gn(c), f = r3(c);
    !f && d.position === "fixed" && (i = null), (a ? !f && !i : !f && d.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || zi(c) && !f && u7(e, c)) ? r = r.filter((m) => m !== c) : i = d, c = ur(c);
  }
  return t.set(e, r), r;
}
function fF(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const c = [...n === "clippingAncestors" ? Dl(t) ? [] : uF(t, this._c) : [].concat(n), r], d = c[0], f = c.reduce((p, m) => {
    const v = ad(t, m, i);
    return p.top = Ln(v.top, p.top), p.right = cr(v.right, p.right), p.bottom = cr(v.bottom, p.bottom), p.left = Ln(v.left, p.left), p;
  }, ad(t, d, i));
  return {
    width: f.right - f.left,
    height: f.bottom - f.top,
    x: f.left,
    y: f.top
  };
}
function hF(e) {
  const {
    width: t,
    height: n
  } = s7(e);
  return {
    width: t,
    height: n
  };
}
function pF(e, t, n) {
  const r = f2(t), i = h2(t), a = n === "fixed", c = Pr(e, !0, a, t);
  let d = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const f = u2(0);
  if (r || !r && !a)
    if ((z1(t) !== "body" || zi(i)) && (d = Rl(t)), r) {
      const g = Pr(t, !0, a, t);
      f.x = g.x + t.clientLeft, f.y = g.y + t.clientTop;
    } else i && (f.x = o3(i));
  const p = i && !r && !a ? d7(i, d) : u2(0), m = c.left + d.scrollLeft - f.x - p.x, v = c.top + d.scrollTop - f.y - p.y;
  return {
    x: m,
    y: v,
    width: c.width,
    height: c.height
  };
}
function za(e) {
  return Gn(e).position === "static";
}
function sd(e, t) {
  if (!f2(e) || Gn(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return h2(e) === n && (n = n.ownerDocument.body), n;
}
function f7(e, t) {
  const n = bn(e);
  if (Dl(e))
    return n;
  if (!f2(e)) {
    let i = ur(e);
    for (; i && !L1(i); ) {
      if (Wn(i) && !za(i))
        return i;
      i = ur(i);
    }
    return n;
  }
  let r = sd(e, t);
  for (; r && nF(r) && za(r); )
    r = sd(r, t);
  return r && L1(r) && za(r) && !r3(r) ? n : r || rF(e) || n;
}
const mF = async function(e) {
  const t = this.getOffsetParent || f7, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: pF(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function vF(e) {
  return Gn(e).direction === "rtl";
}
const gF = {
  convertOffsetParentRelativeRectToViewportRelativeRect: oF,
  getDocumentElement: h2,
  getClippingRect: fF,
  getOffsetParent: f7,
  getElementRects: mF,
  getClientRects: aF,
  getDimensions: hF,
  getScale: m1,
  isElement: Wn,
  isRTL: vF
};
function LF(e, t) {
  let n = null, r;
  const i = h2(e);
  function a() {
    var d;
    clearTimeout(r), (d = n) == null || d.disconnect(), n = null;
  }
  function c(d, f) {
    d === void 0 && (d = !1), f === void 0 && (f = 1), a();
    const {
      left: p,
      top: m,
      width: v,
      height: g
    } = e.getBoundingClientRect();
    if (d || t(), !v || !g)
      return;
    const w = P0(m), x = P0(i.clientWidth - (p + v)), b = P0(i.clientHeight - (m + g)), y = P0(p), z = {
      rootMargin: -w + "px " + -x + "px " + -b + "px " + -y + "px",
      threshold: Ln(0, cr(1, f)) || 1
    };
    let k = !0;
    function R(F) {
      const _ = F[0].intersectionRatio;
      if (_ !== f) {
        if (!k)
          return c();
        _ ? c(!1, _) : r = setTimeout(() => {
          c(!1, 1e-7);
        }, 1e3);
      }
      k = !1;
    }
    try {
      n = new IntersectionObserver(R, {
        ...z,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(R, z);
    }
    n.observe(e);
  }
  return c(!0), a;
}
function wF(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: c = typeof ResizeObserver == "function",
    layoutShift: d = typeof IntersectionObserver == "function",
    animationFrame: f = !1
  } = r, p = l3(e), m = i || a ? [...p ? pi(p) : [], ...pi(t)] : [];
  m.forEach((E) => {
    i && E.addEventListener("scroll", n, {
      passive: !0
    }), a && E.addEventListener("resize", n);
  });
  const v = p && d ? LF(p, n) : null;
  let g = -1, w = null;
  c && (w = new ResizeObserver((E) => {
    let [z] = E;
    z && z.target === p && w && (w.unobserve(t), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var k;
      (k = w) == null || k.observe(t);
    })), n();
  }), p && !f && w.observe(p), w.observe(t));
  let x, b = f ? Pr(e) : null;
  f && y();
  function y() {
    const E = Pr(e);
    b && (E.x !== b.x || E.y !== b.y || E.width !== b.width || E.height !== b.height) && n(), b = E, x = requestAnimationFrame(y);
  }
  return n(), () => {
    var E;
    m.forEach((z) => {
      i && z.removeEventListener("scroll", n), a && z.removeEventListener("resize", n);
    }), v == null || v(), (E = w) == null || E.disconnect(), w = null, f && cancelAnimationFrame(x);
  };
}
const MF = JE, xF = QE, bF = YE, yF = tF, CF = qE, cd = KE, EF = eF, FF = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: gF,
    ...n
  }, a = {
    ...i.platform,
    _c: r
  };
  return jE(e, t, {
    ...i,
    platform: a
  });
};
var K0 = typeof document < "u" ? J0 : T;
function rl(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!rl(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = i[r];
      if (!(a === "_owner" && e.$$typeof) && !rl(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function h7(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function dd(e, t) {
  const n = h7(e);
  return Math.round(t * n) / n;
}
function Aa(e) {
  const t = M.useRef(e);
  return K0(() => {
    t.current = e;
  }), t;
}
function zF(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: a,
      floating: c
    } = {},
    transform: d = !0,
    whileElementsMounted: f,
    open: p
  } = e, [m, v] = M.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [g, w] = M.useState(r);
  rl(g, r) || w(r);
  const [x, b] = M.useState(null), [y, E] = M.useState(null), z = M.useCallback((K) => {
    K !== _.current && (_.current = K, b(K));
  }, []), k = M.useCallback((K) => {
    K !== P.current && (P.current = K, E(K));
  }, []), R = a || x, F = c || y, _ = M.useRef(null), P = M.useRef(null), O = M.useRef(m), Z = f != null, te = Aa(f), Y = Aa(i), X = Aa(p), re = M.useCallback(() => {
    if (!_.current || !P.current)
      return;
    const K = {
      placement: t,
      strategy: n,
      middleware: g
    };
    Y.current && (K.platform = Y.current), FF(_.current, P.current, K).then((J) => {
      const he = {
        ...J,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: X.current !== !1
      };
      ee.current && !rl(O.current, he) && (O.current = he, b1.flushSync(() => {
        v(he);
      }));
    });
  }, [g, t, n, Y, X]);
  K0(() => {
    p === !1 && O.current.isPositioned && (O.current.isPositioned = !1, v((K) => ({
      ...K,
      isPositioned: !1
    })));
  }, [p]);
  const ee = M.useRef(!1);
  K0(() => (ee.current = !0, () => {
    ee.current = !1;
  }), []), K0(() => {
    if (R && (_.current = R), F && (P.current = F), R && F) {
      if (te.current)
        return te.current(R, F, re);
      re();
    }
  }, [R, F, re, te, Z]);
  const de = M.useMemo(() => ({
    reference: _,
    floating: P,
    setReference: z,
    setFloating: k
  }), [z, k]), ae = M.useMemo(() => ({
    reference: R,
    floating: F
  }), [R, F]), ge = M.useMemo(() => {
    const K = {
      position: n,
      left: 0,
      top: 0
    };
    if (!ae.floating)
      return K;
    const J = dd(ae.floating, m.x), he = dd(ae.floating, m.y);
    return d ? {
      ...K,
      transform: "translate(" + J + "px, " + he + "px)",
      ...h7(ae.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: J,
      top: he
    };
  }, [n, d, ae.floating, m.x, m.y]);
  return M.useMemo(() => ({
    ...m,
    update: re,
    refs: de,
    elements: ae,
    floatingStyles: ge
  }), [m, re, de, ae, ge]);
}
const AF = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? cd({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? cd({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, SF = (e, t) => ({
  ...MF(e),
  options: [e, t]
}), kF = (e, t) => ({
  ...xF(e),
  options: [e, t]
}), DF = (e, t) => ({
  ...EF(e),
  options: [e, t]
}), RF = (e, t) => ({
  ...bF(e),
  options: [e, t]
}), _F = (e, t) => ({
  ...yF(e),
  options: [e, t]
}), PF = (e, t) => ({
  ...CF(e),
  options: [e, t]
}), HF = (e, t) => ({
  ...AF(e),
  options: [e, t]
});
var OF = "Arrow", p7 = M.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...a } = e;
  return /* @__PURE__ */ u(
    ke.svg,
    {
      ...a,
      ref: t,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ u("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
p7.displayName = OF;
var NF = p7;
function a3(e) {
  const [t, n] = M.useState(void 0);
  return yn(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const a = i[0];
        let c, d;
        if ("borderBoxSize" in a) {
          const f = a.borderBoxSize, p = Array.isArray(f) ? f[0] : f;
          c = p.inlineSize, d = p.blockSize;
        } else
          c = e.offsetWidth, d = e.offsetHeight;
        n({ width: c, height: d });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var s3 = "Popper", [m7, A1] = Tt(s3), [BF, v7] = m7(s3), g7 = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = M.useState(null);
  return /* @__PURE__ */ u(BF, { scope: t, anchor: r, onAnchorChange: i, children: n });
};
g7.displayName = s3;
var L7 = "PopperAnchor", w7 = M.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...i } = e, a = v7(L7, n), c = M.useRef(null), d = ct(t, c);
    return M.useEffect(() => {
      a.onAnchorChange((r == null ? void 0 : r.current) || c.current);
    }), r ? null : /* @__PURE__ */ u(ke.div, { ...i, ref: d });
  }
);
w7.displayName = L7;
var c3 = "PopperContent", [IF, TF] = m7(c3), M7 = M.forwardRef(
  (e, t) => {
    var Le, xe, Ee, ye, Be, ft;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: a = "center",
      alignOffset: c = 0,
      arrowPadding: d = 0,
      avoidCollisions: f = !0,
      collisionBoundary: p = [],
      collisionPadding: m = 0,
      sticky: v = "partial",
      hideWhenDetached: g = !1,
      updatePositionStrategy: w = "optimized",
      onPlaced: x,
      ...b
    } = e, y = v7(c3, n), [E, z] = M.useState(null), k = ct(t, (Et) => z(Et)), [R, F] = M.useState(null), _ = a3(R), P = (_ == null ? void 0 : _.width) ?? 0, O = (_ == null ? void 0 : _.height) ?? 0, Z = r + (a !== "center" ? "-" + a : ""), te = typeof m == "number" ? m : { top: 0, right: 0, bottom: 0, left: 0, ...m }, Y = Array.isArray(p) ? p : [p], X = Y.length > 0, re = {
      padding: te,
      boundary: Y.filter(ZF),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: X
    }, { refs: ee, floatingStyles: de, placement: ae, isPositioned: ge, middlewareData: K } = zF({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: Z,
      whileElementsMounted: (...Et) => wF(...Et, {
        animationFrame: w === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        SF({ mainAxis: i + O, alignmentAxis: c }),
        f && kF({
          mainAxis: !0,
          crossAxis: !1,
          limiter: v === "partial" ? DF() : void 0,
          ...re
        }),
        f && RF({ ...re }),
        _F({
          ...re,
          apply: ({ elements: Et, rects: Lt, availableWidth: je, availableHeight: B2 }) => {
            const { width: _t, height: m2 } = Lt.reference, cn = Et.floating.style;
            cn.setProperty("--radix-popper-available-width", `${je}px`), cn.setProperty("--radix-popper-available-height", `${B2}px`), cn.setProperty("--radix-popper-anchor-width", `${_t}px`), cn.setProperty("--radix-popper-anchor-height", `${m2}px`);
          }
        }),
        R && HF({ element: R, padding: d }),
        $F({ arrowWidth: P, arrowHeight: O }),
        g && PF({ strategy: "referenceHidden", ...re })
      ]
    }), [J, he] = y7(ae), ve = tn(x);
    yn(() => {
      ge && (ve == null || ve());
    }, [ge, ve]);
    const Q = (Le = K.arrow) == null ? void 0 : Le.x, ie = (xe = K.arrow) == null ? void 0 : xe.y, pe = ((Ee = K.arrow) == null ? void 0 : Ee.centerOffset) !== 0, [U, Me] = M.useState();
    return yn(() => {
      E && Me(window.getComputedStyle(E).zIndex);
    }, [E]), /* @__PURE__ */ u(
      "div",
      {
        ref: ee.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...de,
          transform: ge ? de.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: U,
          "--radix-popper-transform-origin": [
            (ye = K.transformOrigin) == null ? void 0 : ye.x,
            (Be = K.transformOrigin) == null ? void 0 : Be.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ft = K.hide) == null ? void 0 : ft.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ u(
          IF,
          {
            scope: n,
            placedSide: J,
            onArrowChange: F,
            arrowX: Q,
            arrowY: ie,
            shouldHideArrow: pe,
            children: /* @__PURE__ */ u(
              ke.div,
              {
                "data-side": J,
                "data-align": he,
                ...b,
                ref: k,
                style: {
                  ...b.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: ge ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
M7.displayName = c3;
var x7 = "PopperArrow", VF = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, b7 = M.forwardRef(function(t, n) {
  const { __scopePopper: r, ...i } = t, a = TF(x7, r), c = VF[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ u(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [c]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ u(
          NF,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
b7.displayName = x7;
function ZF(e) {
  return e !== null;
}
var $F = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var y, E, z;
    const { placement: n, rects: r, middlewareData: i } = t, c = ((y = i.arrow) == null ? void 0 : y.centerOffset) !== 0, d = c ? 0 : e.arrowWidth, f = c ? 0 : e.arrowHeight, [p, m] = y7(n), v = { start: "0%", center: "50%", end: "100%" }[m], g = (((E = i.arrow) == null ? void 0 : E.x) ?? 0) + d / 2, w = (((z = i.arrow) == null ? void 0 : z.y) ?? 0) + f / 2;
    let x = "", b = "";
    return p === "bottom" ? (x = c ? v : `${g}px`, b = `${-f}px`) : p === "top" ? (x = c ? v : `${g}px`, b = `${r.floating.height + f}px`) : p === "right" ? (x = `${-f}px`, b = c ? v : `${w}px`) : p === "left" && (x = `${r.floating.width + f}px`, b = c ? v : `${w}px`), { data: { x, y: b } };
  }
});
function y7(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var _l = g7, Pl = w7, d3 = M7, u3 = b7, WF = "Portal", S1 = M.forwardRef((e, t) => {
  var d;
  const { container: n, ...r } = e, [i, a] = M.useState(!1);
  yn(() => a(!0), []);
  const c = n || i && ((d = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : d.body);
  return c ? M6.createPortal(/* @__PURE__ */ u(ke.div, { ...r, ref: t }), c) : null;
});
S1.displayName = WF;
var Sa = "rovingFocusGroup.onEntryFocus", GF = { bubbles: !1, cancelable: !0 }, Ai = "RovingFocusGroup", [ms, C7, UF] = El(Ai), [jF, k1] = Tt(
  Ai,
  [UF]
), [KF, YF] = jF(Ai), E7 = M.forwardRef(
  (e, t) => /* @__PURE__ */ u(ms.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ u(ms.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ u(qF, { ...e, ref: t }) }) })
);
E7.displayName = Ai;
var qF = M.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: i = !1,
    dir: a,
    currentTabStopId: c,
    defaultCurrentTabStopId: d,
    onCurrentTabStopIdChange: f,
    onEntryFocus: p,
    preventScrollOnEntryFocus: m = !1,
    ...v
  } = e, g = M.useRef(null), w = ct(t, g), x = Fi(a), [b, y] = Kt({
    prop: c,
    defaultProp: d ?? null,
    onChange: f,
    caller: Ai
  }), [E, z] = M.useState(!1), k = tn(p), R = C7(n), F = M.useRef(!1), [_, P] = M.useState(0);
  return M.useEffect(() => {
    const O = g.current;
    if (O)
      return O.addEventListener(Sa, k), () => O.removeEventListener(Sa, k);
  }, [k]), /* @__PURE__ */ u(
    KF,
    {
      scope: n,
      orientation: r,
      dir: x,
      loop: i,
      currentTabStopId: b,
      onItemFocus: M.useCallback(
        (O) => y(O),
        [y]
      ),
      onItemShiftTab: M.useCallback(() => z(!0), []),
      onFocusableItemAdd: M.useCallback(
        () => P((O) => O + 1),
        []
      ),
      onFocusableItemRemove: M.useCallback(
        () => P((O) => O - 1),
        []
      ),
      children: /* @__PURE__ */ u(
        ke.div,
        {
          tabIndex: E || _ === 0 ? -1 : 0,
          "data-orientation": r,
          ...v,
          ref: w,
          style: { outline: "none", ...e.style },
          onMouseDown: be(e.onMouseDown, () => {
            F.current = !0;
          }),
          onFocus: be(e.onFocus, (O) => {
            const Z = !F.current;
            if (O.target === O.currentTarget && Z && !E) {
              const te = new CustomEvent(Sa, GF);
              if (O.currentTarget.dispatchEvent(te), !te.defaultPrevented) {
                const Y = R().filter((ae) => ae.focusable), X = Y.find((ae) => ae.active), re = Y.find((ae) => ae.id === b), de = [X, re, ...Y].filter(
                  Boolean
                ).map((ae) => ae.ref.current);
                A7(de, m);
              }
            }
            F.current = !1;
          }),
          onBlur: be(e.onBlur, () => z(!1))
        }
      )
    }
  );
}), F7 = "RovingFocusGroupItem", z7 = M.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: i = !1,
      tabStopId: a,
      children: c,
      ...d
    } = e, f = xn(), p = a || f, m = YF(F7, n), v = m.currentTabStopId === p, g = C7(n), { onFocusableItemAdd: w, onFocusableItemRemove: x, currentTabStopId: b } = m;
    return M.useEffect(() => {
      if (r)
        return w(), () => x();
    }, [r, w, x]), /* @__PURE__ */ u(
      ms.ItemSlot,
      {
        scope: n,
        id: p,
        focusable: r,
        active: i,
        children: /* @__PURE__ */ u(
          ke.span,
          {
            tabIndex: v ? 0 : -1,
            "data-orientation": m.orientation,
            ...d,
            ref: t,
            onMouseDown: be(e.onMouseDown, (y) => {
              r ? m.onItemFocus(p) : y.preventDefault();
            }),
            onFocus: be(e.onFocus, () => m.onItemFocus(p)),
            onKeyDown: be(e.onKeyDown, (y) => {
              if (y.key === "Tab" && y.shiftKey) {
                m.onItemShiftTab();
                return;
              }
              if (y.target !== y.currentTarget) return;
              const E = QF(y, m.orientation, m.dir);
              if (E !== void 0) {
                if (y.metaKey || y.ctrlKey || y.altKey || y.shiftKey) return;
                y.preventDefault();
                let k = g().filter((R) => R.focusable).map((R) => R.ref.current);
                if (E === "last") k.reverse();
                else if (E === "prev" || E === "next") {
                  E === "prev" && k.reverse();
                  const R = k.indexOf(y.currentTarget);
                  k = m.loop ? ez(k, R + 1) : k.slice(R + 1);
                }
                setTimeout(() => A7(k));
              }
            }),
            children: typeof c == "function" ? c({ isCurrentTabStop: v, hasTabStop: b != null }) : c
          }
        )
      }
    );
  }
);
z7.displayName = F7;
var XF = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function JF(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function QF(e, t, n) {
  const r = JF(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return XF[r];
}
function A7(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function ez(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var f3 = E7, h3 = z7, tz = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, s1 = /* @__PURE__ */ new WeakMap(), H0 = /* @__PURE__ */ new WeakMap(), O0 = {}, ka = 0, S7 = function(e) {
  return e && (e.host || S7(e.parentNode));
}, nz = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = S7(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, rz = function(e, t, n, r) {
  var i = nz(t, Array.isArray(e) ? e : [e]);
  O0[n] || (O0[n] = /* @__PURE__ */ new WeakMap());
  var a = O0[n], c = [], d = /* @__PURE__ */ new Set(), f = new Set(i), p = function(v) {
    !v || d.has(v) || (d.add(v), p(v.parentNode));
  };
  i.forEach(p);
  var m = function(v) {
    !v || f.has(v) || Array.prototype.forEach.call(v.children, function(g) {
      if (d.has(g))
        m(g);
      else
        try {
          var w = g.getAttribute(r), x = w !== null && w !== "false", b = (s1.get(g) || 0) + 1, y = (a.get(g) || 0) + 1;
          s1.set(g, b), a.set(g, y), c.push(g), b === 1 && x && H0.set(g, !0), y === 1 && g.setAttribute(n, "true"), x || g.setAttribute(r, "true");
        } catch (E) {
          console.error("aria-hidden: cannot operate on ", g, E);
        }
    });
  };
  return m(t), d.clear(), ka++, function() {
    c.forEach(function(v) {
      var g = s1.get(v) - 1, w = a.get(v) - 1;
      s1.set(v, g), a.set(v, w), g || (H0.has(v) || v.removeAttribute(r), H0.delete(v)), w || v.removeAttribute(n);
    }), ka--, ka || (s1 = /* @__PURE__ */ new WeakMap(), s1 = /* @__PURE__ */ new WeakMap(), H0 = /* @__PURE__ */ new WeakMap(), O0 = {});
  };
}, Hl = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = tz(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), rz(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, a2 = function() {
  return a2 = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, a2.apply(this, arguments);
};
function k7(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function iz(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var Y0 = "right-scroll-bar-position", q0 = "width-before-scroll-bar", lz = "with-scroll-bars-hidden", oz = "--removed-body-scroll-bar-size";
function Da(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function az(e, t) {
  var n = q(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var sz = typeof window < "u" ? M.useLayoutEffect : M.useEffect, ud = /* @__PURE__ */ new WeakMap();
function cz(e, t) {
  var n = az(null, function(r) {
    return e.forEach(function(i) {
      return Da(i, r);
    });
  });
  return sz(function() {
    var r = ud.get(n);
    if (r) {
      var i = new Set(r), a = new Set(e), c = n.current;
      i.forEach(function(d) {
        a.has(d) || Da(d, null);
      }), a.forEach(function(d) {
        i.has(d) || Da(d, c);
      });
    }
    ud.set(n, e);
  }, [e]), n;
}
function dz(e) {
  return e;
}
function uz(e, t) {
  t === void 0 && (t = dz);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var c = t(a, r);
      return n.push(c), function() {
        n = n.filter(function(d) {
          return d !== c;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var c = n;
        n = [], c.forEach(a);
      }
      n = {
        push: function(d) {
          return a(d);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var c = [];
      if (n.length) {
        var d = n;
        n = [], d.forEach(a), c = n;
      }
      var f = function() {
        var m = c;
        c = [], m.forEach(a);
      }, p = function() {
        return Promise.resolve().then(f);
      };
      p(), n = {
        push: function(m) {
          c.push(m), p();
        },
        filter: function(m) {
          return c = c.filter(m), n;
        }
      };
    }
  };
  return i;
}
function fz(e) {
  e === void 0 && (e = {});
  var t = uz(null);
  return t.options = a2({ async: !0, ssr: !1 }, e), t;
}
var D7 = function(e) {
  var t = e.sideCar, n = k7(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return M.createElement(r, a2({}, n));
};
D7.isSideCarExport = !0;
function hz(e, t) {
  return e.useMedium(t), D7;
}
var R7 = fz(), Ra = function() {
}, Ol = M.forwardRef(function(e, t) {
  var n = M.useRef(null), r = M.useState({
    onScrollCapture: Ra,
    onWheelCapture: Ra,
    onTouchMoveCapture: Ra
  }), i = r[0], a = r[1], c = e.forwardProps, d = e.children, f = e.className, p = e.removeScrollBar, m = e.enabled, v = e.shards, g = e.sideCar, w = e.noIsolation, x = e.inert, b = e.allowPinchZoom, y = e.as, E = y === void 0 ? "div" : y, z = e.gapMode, k = k7(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), R = g, F = cz([n, t]), _ = a2(a2({}, k), i);
  return M.createElement(
    M.Fragment,
    null,
    m && M.createElement(R, { sideCar: R7, removeScrollBar: p, shards: v, noIsolation: w, inert: x, setCallbacks: a, allowPinchZoom: !!b, lockRef: n, gapMode: z }),
    c ? M.cloneElement(M.Children.only(d), a2(a2({}, _), { ref: F })) : M.createElement(E, a2({}, _, { className: f, ref: F }), d)
  );
});
Ol.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ol.classNames = {
  fullWidth: q0,
  zeroRight: Y0
};
var pz = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function mz() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = pz();
  return t && e.setAttribute("nonce", t), e;
}
function vz(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function gz(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Lz = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = mz()) && (vz(t, n), gz(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, wz = function() {
  var e = Lz();
  return function(t, n) {
    M.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, _7 = function() {
  var e = wz(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, Mz = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, _a = function(e) {
  return parseInt(e || "", 10) || 0;
}, xz = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [_a(n), _a(r), _a(i)];
}, bz = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Mz;
  var t = xz(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, yz = _7(), v1 = "data-scroll-locked", Cz = function(e, t, n, r) {
  var i = e.left, a = e.top, c = e.right, d = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(lz, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(d, "px ").concat(r, `;
  }
  body[`).concat(v1, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(c, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(d, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(d, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Y0, ` {
    right: `).concat(d, "px ").concat(r, `;
  }
  
  .`).concat(q0, ` {
    margin-right: `).concat(d, "px ").concat(r, `;
  }
  
  .`).concat(Y0, " .").concat(Y0, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(q0, " .").concat(q0, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(v1, `] {
    `).concat(oz, ": ").concat(d, `px;
  }
`);
}, fd = function() {
  var e = parseInt(document.body.getAttribute(v1) || "0", 10);
  return isFinite(e) ? e : 0;
}, Ez = function() {
  M.useEffect(function() {
    return document.body.setAttribute(v1, (fd() + 1).toString()), function() {
      var e = fd() - 1;
      e <= 0 ? document.body.removeAttribute(v1) : document.body.setAttribute(v1, e.toString());
    };
  }, []);
}, Fz = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  Ez();
  var a = M.useMemo(function() {
    return bz(i);
  }, [i]);
  return M.createElement(yz, { styles: Cz(a, !t, i, n ? "" : "!important") });
}, vs = !1;
if (typeof window < "u")
  try {
    var N0 = Object.defineProperty({}, "passive", {
      get: function() {
        return vs = !0, !0;
      }
    });
    window.addEventListener("test", N0, N0), window.removeEventListener("test", N0, N0);
  } catch {
    vs = !1;
  }
var c1 = vs ? { passive: !1 } : !1, zz = function(e) {
  return e.tagName === "TEXTAREA";
}, P7 = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !zz(e) && n[t] === "visible")
  );
}, Az = function(e) {
  return P7(e, "overflowY");
}, Sz = function(e) {
  return P7(e, "overflowX");
}, hd = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = H7(e, r);
    if (i) {
      var a = O7(e, r), c = a[1], d = a[2];
      if (c > d)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, kz = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Dz = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, H7 = function(e, t) {
  return e === "v" ? Az(t) : Sz(t);
}, O7 = function(e, t) {
  return e === "v" ? kz(t) : Dz(t);
}, Rz = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, _z = function(e, t, n, r, i) {
  var a = Rz(e, window.getComputedStyle(t).direction), c = a * r, d = n.target, f = t.contains(d), p = !1, m = c > 0, v = 0, g = 0;
  do {
    var w = O7(e, d), x = w[0], b = w[1], y = w[2], E = b - y - a * x;
    (x || E) && H7(e, d) && (v += E, g += x), d instanceof ShadowRoot ? d = d.host : d = d.parentNode;
  } while (
    // portaled content
    !f && d !== document.body || // self content
    f && (t.contains(d) || t === d)
  );
  return (m && Math.abs(v) < 1 || !m && Math.abs(g) < 1) && (p = !0), p;
}, B0 = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, pd = function(e) {
  return [e.deltaX, e.deltaY];
}, md = function(e) {
  return e && "current" in e ? e.current : e;
}, Pz = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Hz = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Oz = 0, d1 = [];
function Nz(e) {
  var t = M.useRef([]), n = M.useRef([0, 0]), r = M.useRef(), i = M.useState(Oz++)[0], a = M.useState(_7)[0], c = M.useRef(e);
  M.useEffect(function() {
    c.current = e;
  }, [e]), M.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var b = iz([e.lockRef.current], (e.shards || []).map(md), !0).filter(Boolean);
      return b.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), b.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var d = M.useCallback(function(b, y) {
    if ("touches" in b && b.touches.length === 2 || b.type === "wheel" && b.ctrlKey)
      return !c.current.allowPinchZoom;
    var E = B0(b), z = n.current, k = "deltaX" in b ? b.deltaX : z[0] - E[0], R = "deltaY" in b ? b.deltaY : z[1] - E[1], F, _ = b.target, P = Math.abs(k) > Math.abs(R) ? "h" : "v";
    if ("touches" in b && P === "h" && _.type === "range")
      return !1;
    var O = hd(P, _);
    if (!O)
      return !0;
    if (O ? F = P : (F = P === "v" ? "h" : "v", O = hd(P, _)), !O)
      return !1;
    if (!r.current && "changedTouches" in b && (k || R) && (r.current = F), !F)
      return !0;
    var Z = r.current || F;
    return _z(Z, y, b, Z === "h" ? k : R);
  }, []), f = M.useCallback(function(b) {
    var y = b;
    if (!(!d1.length || d1[d1.length - 1] !== a)) {
      var E = "deltaY" in y ? pd(y) : B0(y), z = t.current.filter(function(F) {
        return F.name === y.type && (F.target === y.target || y.target === F.shadowParent) && Pz(F.delta, E);
      })[0];
      if (z && z.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!z) {
        var k = (c.current.shards || []).map(md).filter(Boolean).filter(function(F) {
          return F.contains(y.target);
        }), R = k.length > 0 ? d(y, k[0]) : !c.current.noIsolation;
        R && y.cancelable && y.preventDefault();
      }
    }
  }, []), p = M.useCallback(function(b, y, E, z) {
    var k = { name: b, delta: y, target: E, should: z, shadowParent: Bz(E) };
    t.current.push(k), setTimeout(function() {
      t.current = t.current.filter(function(R) {
        return R !== k;
      });
    }, 1);
  }, []), m = M.useCallback(function(b) {
    n.current = B0(b), r.current = void 0;
  }, []), v = M.useCallback(function(b) {
    p(b.type, pd(b), b.target, d(b, e.lockRef.current));
  }, []), g = M.useCallback(function(b) {
    p(b.type, B0(b), b.target, d(b, e.lockRef.current));
  }, []);
  M.useEffect(function() {
    return d1.push(a), e.setCallbacks({
      onScrollCapture: v,
      onWheelCapture: v,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", f, c1), document.addEventListener("touchmove", f, c1), document.addEventListener("touchstart", m, c1), function() {
      d1 = d1.filter(function(b) {
        return b !== a;
      }), document.removeEventListener("wheel", f, c1), document.removeEventListener("touchmove", f, c1), document.removeEventListener("touchstart", m, c1);
    };
  }, []);
  var w = e.removeScrollBar, x = e.inert;
  return M.createElement(
    M.Fragment,
    null,
    x ? M.createElement(a, { styles: Hz(i) }) : null,
    w ? M.createElement(Fz, { gapMode: e.gapMode }) : null
  );
}
function Bz(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Iz = hz(R7, Nz);
var Si = M.forwardRef(function(e, t) {
  return M.createElement(Ol, a2({}, e, { ref: t, sideCar: Iz }));
});
Si.classNames = Ol.classNames;
var gs = ["Enter", " "], Tz = ["ArrowDown", "PageUp", "Home"], N7 = ["ArrowUp", "PageDown", "End"], Vz = [...Tz, ...N7], Zz = {
  ltr: [...gs, "ArrowRight"],
  rtl: [...gs, "ArrowLeft"]
}, $z = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, ki = "Menu", [mi, Wz, Gz] = El(ki), [Vr, B7] = Tt(ki, [
  Gz,
  A1,
  k1
]), Di = A1(), I7 = k1(), [T7, pr] = Vr(ki), [Uz, Ri] = Vr(ki), V7 = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: i, onOpenChange: a, modal: c = !0 } = e, d = Di(t), [f, p] = M.useState(null), m = M.useRef(!1), v = tn(a), g = Fi(i);
  return M.useEffect(() => {
    const w = () => {
      m.current = !0, document.addEventListener("pointerdown", x, { capture: !0, once: !0 }), document.addEventListener("pointermove", x, { capture: !0, once: !0 });
    }, x = () => m.current = !1;
    return document.addEventListener("keydown", w, { capture: !0 }), () => {
      document.removeEventListener("keydown", w, { capture: !0 }), document.removeEventListener("pointerdown", x, { capture: !0 }), document.removeEventListener("pointermove", x, { capture: !0 });
    };
  }, []), /* @__PURE__ */ u(_l, { ...d, children: /* @__PURE__ */ u(
    T7,
    {
      scope: t,
      open: n,
      onOpenChange: v,
      content: f,
      onContentChange: p,
      children: /* @__PURE__ */ u(
        Uz,
        {
          scope: t,
          onClose: M.useCallback(() => v(!1), [v]),
          isUsingKeyboardRef: m,
          dir: g,
          modal: c,
          children: r
        }
      )
    }
  ) });
};
V7.displayName = ki;
var jz = "MenuAnchor", p3 = M.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, i = Di(n);
    return /* @__PURE__ */ u(Pl, { ...i, ...r, ref: t });
  }
);
p3.displayName = jz;
var m3 = "MenuPortal", [Kz, Z7] = Vr(m3, {
  forceMount: void 0
}), $7 = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: i } = e, a = pr(m3, t);
  return /* @__PURE__ */ u(Kz, { scope: t, forceMount: n, children: /* @__PURE__ */ u(Yt, { present: n || a.open, children: /* @__PURE__ */ u(S1, { asChild: !0, container: i, children: r }) }) });
};
$7.displayName = m3;
var Hn = "MenuContent", [Yz, v3] = Vr(Hn), W7 = M.forwardRef(
  (e, t) => {
    const n = Z7(Hn, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, a = pr(Hn, e.__scopeMenu), c = Ri(Hn, e.__scopeMenu);
    return /* @__PURE__ */ u(mi.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ u(Yt, { present: r || a.open, children: /* @__PURE__ */ u(mi.Slot, { scope: e.__scopeMenu, children: c.modal ? /* @__PURE__ */ u(qz, { ...i, ref: t }) : /* @__PURE__ */ u(Xz, { ...i, ref: t }) }) }) });
  }
), qz = M.forwardRef(
  (e, t) => {
    const n = pr(Hn, e.__scopeMenu), r = M.useRef(null), i = ct(t, r);
    return M.useEffect(() => {
      const a = r.current;
      if (a) return Hl(a);
    }, []), /* @__PURE__ */ u(
      g3,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: be(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), Xz = M.forwardRef((e, t) => {
  const n = pr(Hn, e.__scopeMenu);
  return /* @__PURE__ */ u(
    g3,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Jz = /* @__PURE__ */ _r("MenuContent.ScrollLock"), g3 = M.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: i,
      onOpenAutoFocus: a,
      onCloseAutoFocus: c,
      disableOutsidePointerEvents: d,
      onEntryFocus: f,
      onEscapeKeyDown: p,
      onPointerDownOutside: m,
      onFocusOutside: v,
      onInteractOutside: g,
      onDismiss: w,
      disableOutsideScroll: x,
      ...b
    } = e, y = pr(Hn, n), E = Ri(Hn, n), z = Di(n), k = I7(n), R = Wz(n), [F, _] = M.useState(null), P = M.useRef(null), O = ct(t, P, y.onContentChange), Z = M.useRef(0), te = M.useRef(""), Y = M.useRef(0), X = M.useRef(null), re = M.useRef("right"), ee = M.useRef(0), de = x ? Si : M.Fragment, ae = x ? { as: Jz, allowPinchZoom: !0 } : void 0, ge = (J) => {
      var Le, xe;
      const he = te.current + J, ve = R().filter((Ee) => !Ee.disabled), Q = document.activeElement, ie = (Le = ve.find((Ee) => Ee.ref.current === Q)) == null ? void 0 : Le.textValue, pe = ve.map((Ee) => Ee.textValue), U = dA(pe, he, ie), Me = (xe = ve.find((Ee) => Ee.textValue === U)) == null ? void 0 : xe.ref.current;
      (function Ee(ye) {
        te.current = ye, window.clearTimeout(Z.current), ye !== "" && (Z.current = window.setTimeout(() => Ee(""), 1e3));
      })(he), Me && setTimeout(() => Me.focus());
    };
    M.useEffect(() => () => window.clearTimeout(Z.current), []), Qs();
    const K = M.useCallback((J) => {
      var ve, Q;
      return re.current === ((ve = X.current) == null ? void 0 : ve.side) && fA(J, (Q = X.current) == null ? void 0 : Q.area);
    }, []);
    return /* @__PURE__ */ u(
      Yz,
      {
        scope: n,
        searchRef: te,
        onItemEnter: M.useCallback(
          (J) => {
            K(J) && J.preventDefault();
          },
          [K]
        ),
        onItemLeave: M.useCallback(
          (J) => {
            var he;
            K(J) || ((he = P.current) == null || he.focus(), _(null));
          },
          [K]
        ),
        onTriggerLeave: M.useCallback(
          (J) => {
            K(J) && J.preventDefault();
          },
          [K]
        ),
        pointerGraceTimerRef: Y,
        onPointerGraceIntentChange: M.useCallback((J) => {
          X.current = J;
        }, []),
        children: /* @__PURE__ */ u(de, { ...ae, children: /* @__PURE__ */ u(
          Sl,
          {
            asChild: !0,
            trapped: i,
            onMountAutoFocus: be(a, (J) => {
              var he;
              J.preventDefault(), (he = P.current) == null || he.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: c,
            children: /* @__PURE__ */ u(
              E1,
              {
                asChild: !0,
                disableOutsidePointerEvents: d,
                onEscapeKeyDown: p,
                onPointerDownOutside: m,
                onFocusOutside: v,
                onInteractOutside: g,
                onDismiss: w,
                children: /* @__PURE__ */ u(
                  f3,
                  {
                    asChild: !0,
                    ...k,
                    dir: E.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: F,
                    onCurrentTabStopIdChange: _,
                    onEntryFocus: be(f, (J) => {
                      E.isUsingKeyboardRef.current || J.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ u(
                      d3,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": a8(y.open),
                        "data-radix-menu-content": "",
                        dir: E.dir,
                        ...z,
                        ...b,
                        ref: O,
                        style: { outline: "none", ...b.style },
                        onKeyDown: be(b.onKeyDown, (J) => {
                          const ve = J.target.closest("[data-radix-menu-content]") === J.currentTarget, Q = J.ctrlKey || J.altKey || J.metaKey, ie = J.key.length === 1;
                          ve && (J.key === "Tab" && J.preventDefault(), !Q && ie && ge(J.key));
                          const pe = P.current;
                          if (J.target !== pe || !Vz.includes(J.key)) return;
                          J.preventDefault();
                          const Me = R().filter((Le) => !Le.disabled).map((Le) => Le.ref.current);
                          N7.includes(J.key) && Me.reverse(), sA(Me);
                        }),
                        onBlur: be(e.onBlur, (J) => {
                          J.currentTarget.contains(J.target) || (window.clearTimeout(Z.current), te.current = "");
                        }),
                        onPointerMove: be(
                          e.onPointerMove,
                          vi((J) => {
                            const he = J.target, ve = ee.current !== J.clientX;
                            if (J.currentTarget.contains(he) && ve) {
                              const Q = J.clientX > ee.current ? "right" : "left";
                              re.current = Q, ee.current = J.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
W7.displayName = Hn;
var Qz = "MenuGroup", L3 = M.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ u(ke.div, { role: "group", ...r, ref: t });
  }
);
L3.displayName = Qz;
var eA = "MenuLabel", G7 = M.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ u(ke.div, { ...r, ref: t });
  }
);
G7.displayName = eA;
var il = "MenuItem", vd = "menu.itemSelect", Nl = M.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...i } = e, a = M.useRef(null), c = Ri(il, e.__scopeMenu), d = v3(il, e.__scopeMenu), f = ct(t, a), p = M.useRef(!1), m = () => {
      const v = a.current;
      if (!n && v) {
        const g = new CustomEvent(vd, { bubbles: !0, cancelable: !0 });
        v.addEventListener(vd, (w) => r == null ? void 0 : r(w), { once: !0 }), Ts(v, g), g.defaultPrevented ? p.current = !1 : c.onClose();
      }
    };
    return /* @__PURE__ */ u(
      U7,
      {
        ...i,
        ref: f,
        disabled: n,
        onClick: be(e.onClick, m),
        onPointerDown: (v) => {
          var g;
          (g = e.onPointerDown) == null || g.call(e, v), p.current = !0;
        },
        onPointerUp: be(e.onPointerUp, (v) => {
          var g;
          p.current || (g = v.currentTarget) == null || g.click();
        }),
        onKeyDown: be(e.onKeyDown, (v) => {
          const g = d.searchRef.current !== "";
          n || g && v.key === " " || gs.includes(v.key) && (v.currentTarget.click(), v.preventDefault());
        })
      }
    );
  }
);
Nl.displayName = il;
var U7 = M.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: i, ...a } = e, c = v3(il, n), d = I7(n), f = M.useRef(null), p = ct(t, f), [m, v] = M.useState(!1), [g, w] = M.useState("");
    return M.useEffect(() => {
      const x = f.current;
      x && w((x.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ u(
      mi.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: i ?? g,
        children: /* @__PURE__ */ u(h3, { asChild: !0, ...d, focusable: !r, children: /* @__PURE__ */ u(
          ke.div,
          {
            role: "menuitem",
            "data-highlighted": m ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...a,
            ref: p,
            onPointerMove: be(
              e.onPointerMove,
              vi((x) => {
                r ? c.onItemLeave(x) : (c.onItemEnter(x), x.defaultPrevented || x.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: be(
              e.onPointerLeave,
              vi((x) => c.onItemLeave(x))
            ),
            onFocus: be(e.onFocus, () => v(!0)),
            onBlur: be(e.onBlur, () => v(!1))
          }
        ) })
      }
    );
  }
), tA = "MenuCheckboxItem", j7 = M.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...i } = e;
    return /* @__PURE__ */ u(J7, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ u(
      Nl,
      {
        role: "menuitemcheckbox",
        "aria-checked": ll(n) ? "mixed" : n,
        ...i,
        ref: t,
        "data-state": x3(n),
        onSelect: be(
          i.onSelect,
          () => r == null ? void 0 : r(ll(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
j7.displayName = tA;
var K7 = "MenuRadioGroup", [nA, rA] = Vr(
  K7,
  { value: void 0, onValueChange: () => {
  } }
), Y7 = M.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...i } = e, a = tn(r);
    return /* @__PURE__ */ u(nA, { scope: e.__scopeMenu, value: n, onValueChange: a, children: /* @__PURE__ */ u(L3, { ...i, ref: t }) });
  }
);
Y7.displayName = K7;
var q7 = "MenuRadioItem", X7 = M.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, i = rA(q7, e.__scopeMenu), a = n === i.value;
    return /* @__PURE__ */ u(J7, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ u(
      Nl,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...r,
        ref: t,
        "data-state": x3(a),
        onSelect: be(
          r.onSelect,
          () => {
            var c;
            return (c = i.onValueChange) == null ? void 0 : c.call(i, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
X7.displayName = q7;
var w3 = "MenuItemIndicator", [J7, iA] = Vr(
  w3,
  { checked: !1 }
), Q7 = M.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...i } = e, a = iA(w3, n);
    return /* @__PURE__ */ u(
      Yt,
      {
        present: r || ll(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ u(
          ke.span,
          {
            ...i,
            ref: t,
            "data-state": x3(a.checked)
          }
        )
      }
    );
  }
);
Q7.displayName = w3;
var lA = "MenuSeparator", e8 = M.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ u(
      ke.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
e8.displayName = lA;
var oA = "MenuArrow", t8 = M.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, i = Di(n);
    return /* @__PURE__ */ u(u3, { ...i, ...r, ref: t });
  }
);
t8.displayName = oA;
var M3 = "MenuSub", [aA, n8] = Vr(M3), r8 = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: i } = e, a = pr(M3, t), c = Di(t), [d, f] = M.useState(null), [p, m] = M.useState(null), v = tn(i);
  return M.useEffect(() => (a.open === !1 && v(!1), () => v(!1)), [a.open, v]), /* @__PURE__ */ u(_l, { ...c, children: /* @__PURE__ */ u(
    T7,
    {
      scope: t,
      open: r,
      onOpenChange: v,
      content: p,
      onContentChange: m,
      children: /* @__PURE__ */ u(
        aA,
        {
          scope: t,
          contentId: xn(),
          triggerId: xn(),
          trigger: d,
          onTriggerChange: f,
          children: n
        }
      )
    }
  ) });
};
r8.displayName = M3;
var oi = "MenuSubTrigger", i8 = M.forwardRef(
  (e, t) => {
    const n = pr(oi, e.__scopeMenu), r = Ri(oi, e.__scopeMenu), i = n8(oi, e.__scopeMenu), a = v3(oi, e.__scopeMenu), c = M.useRef(null), { pointerGraceTimerRef: d, onPointerGraceIntentChange: f } = a, p = { __scopeMenu: e.__scopeMenu }, m = M.useCallback(() => {
      c.current && window.clearTimeout(c.current), c.current = null;
    }, []);
    return M.useEffect(() => m, [m]), M.useEffect(() => {
      const v = d.current;
      return () => {
        window.clearTimeout(v), f(null);
      };
    }, [d, f]), /* @__PURE__ */ u(p3, { asChild: !0, ...p, children: /* @__PURE__ */ u(
      U7,
      {
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": i.contentId,
        "data-state": a8(n.open),
        ...e,
        ref: Cl(t, i.onTriggerChange),
        onClick: (v) => {
          var g;
          (g = e.onClick) == null || g.call(e, v), !(e.disabled || v.defaultPrevented) && (v.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: be(
          e.onPointerMove,
          vi((v) => {
            a.onItemEnter(v), !v.defaultPrevented && !e.disabled && !n.open && !c.current && (a.onPointerGraceIntentChange(null), c.current = window.setTimeout(() => {
              n.onOpenChange(!0), m();
            }, 100));
          })
        ),
        onPointerLeave: be(
          e.onPointerLeave,
          vi((v) => {
            var w, x;
            m();
            const g = (w = n.content) == null ? void 0 : w.getBoundingClientRect();
            if (g) {
              const b = (x = n.content) == null ? void 0 : x.dataset.side, y = b === "right", E = y ? -5 : 5, z = g[y ? "left" : "right"], k = g[y ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: v.clientX + E, y: v.clientY },
                  { x: z, y: g.top },
                  { x: k, y: g.top },
                  { x: k, y: g.bottom },
                  { x: z, y: g.bottom }
                ],
                side: b
              }), window.clearTimeout(d.current), d.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(v), v.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: be(e.onKeyDown, (v) => {
          var w;
          const g = a.searchRef.current !== "";
          e.disabled || g && v.key === " " || Zz[r.dir].includes(v.key) && (n.onOpenChange(!0), (w = n.content) == null || w.focus(), v.preventDefault());
        })
      }
    ) });
  }
);
i8.displayName = oi;
var l8 = "MenuSubContent", o8 = M.forwardRef(
  (e, t) => {
    const n = Z7(Hn, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, a = pr(Hn, e.__scopeMenu), c = Ri(Hn, e.__scopeMenu), d = n8(l8, e.__scopeMenu), f = M.useRef(null), p = ct(t, f);
    return /* @__PURE__ */ u(mi.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ u(Yt, { present: r || a.open, children: /* @__PURE__ */ u(mi.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ u(
      g3,
      {
        id: d.contentId,
        "aria-labelledby": d.triggerId,
        ...i,
        ref: p,
        align: "start",
        side: c.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (m) => {
          var v;
          c.isUsingKeyboardRef.current && ((v = f.current) == null || v.focus()), m.preventDefault();
        },
        onCloseAutoFocus: (m) => m.preventDefault(),
        onFocusOutside: be(e.onFocusOutside, (m) => {
          m.target !== d.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: be(e.onEscapeKeyDown, (m) => {
          c.onClose(), m.preventDefault();
        }),
        onKeyDown: be(e.onKeyDown, (m) => {
          var w;
          const v = m.currentTarget.contains(m.target), g = $z[c.dir].includes(m.key);
          v && g && (a.onOpenChange(!1), (w = d.trigger) == null || w.focus(), m.preventDefault());
        })
      }
    ) }) }) });
  }
);
o8.displayName = l8;
function a8(e) {
  return e ? "open" : "closed";
}
function ll(e) {
  return e === "indeterminate";
}
function x3(e) {
  return ll(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function sA(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function cA(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function dA(e, t, n) {
  const i = t.length > 1 && Array.from(t).every((p) => p === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let c = cA(e, Math.max(a, 0));
  i.length === 1 && (c = c.filter((p) => p !== n));
  const f = c.find(
    (p) => p.toLowerCase().startsWith(i.toLowerCase())
  );
  return f !== n ? f : void 0;
}
function uA(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let a = 0, c = t.length - 1; a < t.length; c = a++) {
    const d = t[a], f = t[c], p = d.x, m = d.y, v = f.x, g = f.y;
    m > r != g > r && n < (v - p) * (r - m) / (g - m) + p && (i = !i);
  }
  return i;
}
function fA(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return uA(n, t);
}
function vi(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var hA = V7, pA = p3, mA = $7, vA = W7, gA = L3, LA = G7, wA = Nl, MA = j7, xA = Y7, bA = X7, yA = Q7, CA = e8, EA = t8, FA = r8, zA = i8, AA = o8, Bl = "DropdownMenu", [SA, aX] = Tt(
  Bl,
  [B7]
), qt = B7(), [kA, s8] = SA(Bl), c8 = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: i,
    defaultOpen: a,
    onOpenChange: c,
    modal: d = !0
  } = e, f = qt(t), p = M.useRef(null), [m, v] = Kt({
    prop: i,
    defaultProp: a ?? !1,
    onChange: c,
    caller: Bl
  });
  return /* @__PURE__ */ u(
    kA,
    {
      scope: t,
      triggerId: xn(),
      triggerRef: p,
      contentId: xn(),
      open: m,
      onOpenChange: v,
      onOpenToggle: M.useCallback(() => v((g) => !g), [v]),
      modal: d,
      children: /* @__PURE__ */ u(hA, { ...f, open: m, onOpenChange: v, dir: r, modal: d, children: n })
    }
  );
};
c8.displayName = Bl;
var d8 = "DropdownMenuTrigger", u8 = M.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...i } = e, a = s8(d8, n), c = qt(n);
    return /* @__PURE__ */ u(pA, { asChild: !0, ...c, children: /* @__PURE__ */ u(
      ke.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...i,
        ref: Cl(t, a.triggerRef),
        onPointerDown: be(e.onPointerDown, (d) => {
          !r && d.button === 0 && d.ctrlKey === !1 && (a.onOpenToggle(), a.open || d.preventDefault());
        }),
        onKeyDown: be(e.onKeyDown, (d) => {
          r || (["Enter", " "].includes(d.key) && a.onOpenToggle(), d.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(d.key) && d.preventDefault());
        })
      }
    ) });
  }
);
u8.displayName = d8;
var DA = "DropdownMenuPortal", f8 = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = qt(t);
  return /* @__PURE__ */ u(mA, { ...r, ...n });
};
f8.displayName = DA;
var h8 = "DropdownMenuContent", p8 = M.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = s8(h8, n), a = qt(n), c = M.useRef(!1);
    return /* @__PURE__ */ u(
      vA,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...a,
        ...r,
        ref: t,
        onCloseAutoFocus: be(e.onCloseAutoFocus, (d) => {
          var f;
          c.current || (f = i.triggerRef.current) == null || f.focus(), c.current = !1, d.preventDefault();
        }),
        onInteractOutside: be(e.onInteractOutside, (d) => {
          const f = d.detail.originalEvent, p = f.button === 0 && f.ctrlKey === !0, m = f.button === 2 || p;
          (!i.modal || m) && (c.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
p8.displayName = h8;
var RA = "DropdownMenuGroup", _A = M.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = qt(n);
    return /* @__PURE__ */ u(gA, { ...i, ...r, ref: t });
  }
);
_A.displayName = RA;
var PA = "DropdownMenuLabel", m8 = M.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = qt(n);
    return /* @__PURE__ */ u(LA, { ...i, ...r, ref: t });
  }
);
m8.displayName = PA;
var HA = "DropdownMenuItem", v8 = M.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = qt(n);
    return /* @__PURE__ */ u(wA, { ...i, ...r, ref: t });
  }
);
v8.displayName = HA;
var OA = "DropdownMenuCheckboxItem", NA = M.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = qt(n);
  return /* @__PURE__ */ u(MA, { ...i, ...r, ref: t });
});
NA.displayName = OA;
var BA = "DropdownMenuRadioGroup", IA = M.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = qt(n);
  return /* @__PURE__ */ u(xA, { ...i, ...r, ref: t });
});
IA.displayName = BA;
var TA = "DropdownMenuRadioItem", VA = M.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = qt(n);
  return /* @__PURE__ */ u(bA, { ...i, ...r, ref: t });
});
VA.displayName = TA;
var ZA = "DropdownMenuItemIndicator", $A = M.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = qt(n);
  return /* @__PURE__ */ u(yA, { ...i, ...r, ref: t });
});
$A.displayName = ZA;
var WA = "DropdownMenuSeparator", g8 = M.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = qt(n);
  return /* @__PURE__ */ u(CA, { ...i, ...r, ref: t });
});
g8.displayName = WA;
var GA = "DropdownMenuArrow", UA = M.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, i = qt(n);
    return /* @__PURE__ */ u(EA, { ...i, ...r, ref: t });
  }
);
UA.displayName = GA;
var jA = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: i, defaultOpen: a } = e, c = qt(t), [d, f] = Kt({
    prop: r,
    defaultProp: a ?? !1,
    onChange: i,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ u(FA, { ...c, open: d, onOpenChange: f, children: n });
}, KA = "DropdownMenuSubTrigger", L8 = M.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = qt(n);
  return /* @__PURE__ */ u(zA, { ...i, ...r, ref: t });
});
L8.displayName = KA;
var YA = "DropdownMenuSubContent", w8 = M.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = qt(n);
  return /* @__PURE__ */ u(
    AA,
    {
      ...i,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
w8.displayName = YA;
var qA = c8, XA = u8, M8 = f8, JA = p8, QA = m8, eS = v8, tS = g8, nS = jA, rS = L8, iS = w8;
const Il = qA;
Il.displayName = "DropdownMenu";
const b3 = W(
  ({ className: e, icon: t, children: n, ...r }, i) => {
    const a = !r.disabled && (r.onClick || r.asChild);
    return /* @__PURE__ */ u(
      eS,
      {
        ref: i,
        className: S(
          "bg-dropdown-default-background border-dropdown-default-border text-dropdown-default-text group outline-hidden",
          "data-[state=open]:bg-dropdown-selected-background data-[state=open]:border-dropdown-selected-border data-[state=open]:text-dropdown-selected-text",
          "first:rounded-t-md",
          "last:rounded-b-md",
          {
            "hover:bg-dropdown-hover-background hover:border-dropdown-hover-border hover:text-dropdown-hover-text": a,
            "focus-visible:bg-dropdown-hover-background focus-visible:border-dropdown-hover-border focus-visible:text-dropdown-hover-text": a,
            "active:bg-dropdown-active-background active:border-dropdown-active-border active:text-dropdown-active-text": a,
            "bg-dropdown-disabled-background border-dropdown-disabled-border text-dropdown-disabled-text": r.disabled,
            "cursor-default": !a,
            "cursor-not-allowed": r.disabled,
            "cursor-pointer": a,
            "bg-dropdown-negative-background border-dropdown-negative-border text-dropdown-negative-text": r.state === "negative"
          }
        ),
        ...r,
        children: /* @__PURE__ */ V("div", { className: S("flex flex-1 items-center gap-8 p-2 text-sm"), children: [
          t ? /* @__PURE__ */ u(
            "div",
            {
              className: S("text-dropdown-default-icon flex", {
                "group-hover:text-dropdown-hover-icon": a,
                "group-active:text-dropdown-active-icon": a,
                "text-dropdown-disabled-icon": r.disabled
              }),
              children: t
            }
          ) : null,
          /* @__PURE__ */ u(
            "div",
            {
              className: S("text-dropdown-text flex", {
                "group-hover:text-dropdown-hover-text": a,
                "group-active:text-dropdown-active-text": a,
                "text-dropdown-disabled-text": r.disabled
              }),
              children: n
            }
          )
        ] })
      }
    );
  }
);
b3.displayName = "DropdownMenuItem";
const lS = ({ children: e, ...t }) => /* @__PURE__ */ u(nS, { ...t, children: e });
lS.displayName = "DropdownMenuSub";
const oS = W(({ className: e, icon: t, children: n, ...r }, i) => {
  const a = !r.disabled && (r.onClick || r.asChild);
  return /* @__PURE__ */ V(
    rS,
    {
      ref: i,
      className: S(
        "bg-dropdown-default-background border-dropdown-default-border text-dropdown-default-text group flex flex-1 cursor-default cursor-pointer items-center gap-8 p-2 text-sm outline-hidden",
        "data-[state=open]:bg-dropdown-selected-background data-[state=open]:border-dropdown-selected-border data-[state=open]:text-dropdown-selected-text",
        "first:rounded-t-md",
        "last:rounded-b-md",
        "hover:bg-dropdown-hover-background hover:border-dropdown-hover-border hover:text-dropdown-hover-text",
        "focus-visible:bg-dropdown-hover-background hover:border-dropdown-hover-border hover:text-dropdown-hover-text",
        "active:bg-dropdown-active-background active:border-dropdown-active-border active:text-dropdown-active-text"
      ),
      ...r,
      children: [
        t ? /* @__PURE__ */ u(
          "div",
          {
            className: S("text-dropdown-default-icon flex", {
              "group-hover:text-dropdown-hover-icon": a,
              "group-active:text-dropdown-active-icon": a
            }),
            children: t
          }
        ) : null,
        /* @__PURE__ */ u(
          "div",
          {
            className: S("text-dropdown-text flex", {
              "group-hover:text-dropdown-hover-text": a,
              "group-active:text-dropdown-active-text": a
            }),
            children: n
          }
        ),
        /* @__PURE__ */ u(
          "div",
          {
            className: S("text-dropdown-default-icon ml-auto flex", {
              "group-hover:text-dropdown-hover-icon": a,
              "group-active:text-dropdown-active-icon": a
            }),
            children: /* @__PURE__ */ u(Re, { name: "ChevronRight", size: "xs" })
          }
        )
      ]
    }
  );
});
oS.displayName = "DropdownMenuSubTrigger";
const aS = W(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ u(M8, { children: /* @__PURE__ */ u(
  iS,
  {
    ref: r,
    className: S("bg-base-white border-dropdown-default-border relative z-30 m-2 rounded-md border shadow-md"),
    ...n,
    children: t
  }
) }));
aS.displayName = "DropdownMenuSubContent";
const Tl = W(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ u(XA, { ref: r, className: S("flex flex-1 items-center gap-8"), ...n, children: t }));
Tl.displayName = "DropdownMenuTrigger";
const Vl = W(({ className: e, children: t, align: n = "start", ...r }, i) => /* @__PURE__ */ u(M8, { children: /* @__PURE__ */ u(
  JA,
  {
    ref: i,
    align: n,
    className: S(
      "bg-base-white border-dropdown-default-border relative z-30 my-2 max-w-96 min-w-32 rounded-md border shadow-md"
    ),
    ...r,
    children: t
  }
) }));
Vl.displayName = "DropdownMenuContent";
const sS = W(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ u(
    QA,
    {
      ref: r,
      className: S("text-dropdown-default-hint px-2 py-1 text-xs", "first:rounded-t-md", "last:rounded-b-md"),
      ...n,
      children: t
    }
  )
);
sS.displayName = "DropdownMenuLabel";
const cS = W(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ u(tS, { ref: r, className: S("bg-dropdown-default-border h-px w-full"), ...n }));
cS.displayName = "DropdownMenuSeparator";
var dS = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), uS = "VisuallyHidden", Zl = M.forwardRef(
  (e, t) => /* @__PURE__ */ u(
    ke.span,
    {
      ...e,
      ref: t,
      style: { ...dS, ...e.style }
    }
  )
);
Zl.displayName = uS;
var x8 = Zl, [$l, sX] = Tt("Tooltip", [
  A1
]), Wl = A1(), b8 = "TooltipProvider", fS = 700, Ls = "tooltip.open", [hS, y3] = $l(b8), y8 = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = fS,
    skipDelayDuration: r = 300,
    disableHoverableContent: i = !1,
    children: a
  } = e, c = M.useRef(!0), d = M.useRef(!1), f = M.useRef(0);
  return M.useEffect(() => {
    const p = f.current;
    return () => window.clearTimeout(p);
  }, []), /* @__PURE__ */ u(
    hS,
    {
      scope: t,
      isOpenDelayedRef: c,
      delayDuration: n,
      onOpen: M.useCallback(() => {
        window.clearTimeout(f.current), c.current = !1;
      }, []),
      onClose: M.useCallback(() => {
        window.clearTimeout(f.current), f.current = window.setTimeout(
          () => c.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: d,
      onPointerInTransitChange: M.useCallback((p) => {
        d.current = p;
      }, []),
      disableHoverableContent: i,
      children: a
    }
  );
};
y8.displayName = b8;
var gi = "Tooltip", [pS, _i] = $l(gi), C8 = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: a,
    disableHoverableContent: c,
    delayDuration: d
  } = e, f = y3(gi, e.__scopeTooltip), p = Wl(t), [m, v] = M.useState(null), g = xn(), w = M.useRef(0), x = c ?? f.disableHoverableContent, b = d ?? f.delayDuration, y = M.useRef(!1), [E, z] = Kt({
    prop: r,
    defaultProp: i ?? !1,
    onChange: (P) => {
      P ? (f.onOpen(), document.dispatchEvent(new CustomEvent(Ls))) : f.onClose(), a == null || a(P);
    },
    caller: gi
  }), k = M.useMemo(() => E ? y.current ? "delayed-open" : "instant-open" : "closed", [E]), R = M.useCallback(() => {
    window.clearTimeout(w.current), w.current = 0, y.current = !1, z(!0);
  }, [z]), F = M.useCallback(() => {
    window.clearTimeout(w.current), w.current = 0, z(!1);
  }, [z]), _ = M.useCallback(() => {
    window.clearTimeout(w.current), w.current = window.setTimeout(() => {
      y.current = !0, z(!0), w.current = 0;
    }, b);
  }, [b, z]);
  return M.useEffect(() => () => {
    w.current && (window.clearTimeout(w.current), w.current = 0);
  }, []), /* @__PURE__ */ u(_l, { ...p, children: /* @__PURE__ */ u(
    pS,
    {
      scope: t,
      contentId: g,
      open: E,
      stateAttribute: k,
      trigger: m,
      onTriggerChange: v,
      onTriggerEnter: M.useCallback(() => {
        f.isOpenDelayedRef.current ? _() : R();
      }, [f.isOpenDelayedRef, _, R]),
      onTriggerLeave: M.useCallback(() => {
        x ? F() : (window.clearTimeout(w.current), w.current = 0);
      }, [F, x]),
      onOpen: R,
      onClose: F,
      disableHoverableContent: x,
      children: n
    }
  ) });
};
C8.displayName = gi;
var ws = "TooltipTrigger", E8 = M.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = _i(ws, n), a = y3(ws, n), c = Wl(n), d = M.useRef(null), f = ct(t, d, i.onTriggerChange), p = M.useRef(!1), m = M.useRef(!1), v = M.useCallback(() => p.current = !1, []);
    return M.useEffect(() => () => document.removeEventListener("pointerup", v), [v]), /* @__PURE__ */ u(Pl, { asChild: !0, ...c, children: /* @__PURE__ */ u(
      ke.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...r,
        ref: f,
        onPointerMove: be(e.onPointerMove, (g) => {
          g.pointerType !== "touch" && !m.current && !a.isPointerInTransitRef.current && (i.onTriggerEnter(), m.current = !0);
        }),
        onPointerLeave: be(e.onPointerLeave, () => {
          i.onTriggerLeave(), m.current = !1;
        }),
        onPointerDown: be(e.onPointerDown, () => {
          i.open && i.onClose(), p.current = !0, document.addEventListener("pointerup", v, { once: !0 });
        }),
        onFocus: be(e.onFocus, () => {
          p.current || i.onOpen();
        }),
        onBlur: be(e.onBlur, i.onClose),
        onClick: be(e.onClick, i.onClose)
      }
    ) });
  }
);
E8.displayName = ws;
var C3 = "TooltipPortal", [mS, vS] = $l(C3, {
  forceMount: void 0
}), F8 = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: i } = e, a = _i(C3, t);
  return /* @__PURE__ */ u(mS, { scope: t, forceMount: n, children: /* @__PURE__ */ u(Yt, { present: n || a.open, children: /* @__PURE__ */ u(S1, { asChild: !0, container: i, children: r }) }) });
};
F8.displayName = C3;
var w1 = "TooltipContent", z8 = M.forwardRef(
  (e, t) => {
    const n = vS(w1, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...a } = e, c = _i(w1, e.__scopeTooltip);
    return /* @__PURE__ */ u(Yt, { present: r || c.open, children: c.disableHoverableContent ? /* @__PURE__ */ u(A8, { side: i, ...a, ref: t }) : /* @__PURE__ */ u(gS, { side: i, ...a, ref: t }) });
  }
), gS = M.forwardRef((e, t) => {
  const n = _i(w1, e.__scopeTooltip), r = y3(w1, e.__scopeTooltip), i = M.useRef(null), a = ct(t, i), [c, d] = M.useState(null), { trigger: f, onClose: p } = n, m = i.current, { onPointerInTransitChange: v } = r, g = M.useCallback(() => {
    d(null), v(!1);
  }, [v]), w = M.useCallback(
    (x, b) => {
      const y = x.currentTarget, E = { x: x.clientX, y: x.clientY }, z = xS(E, y.getBoundingClientRect()), k = bS(E, z), R = yS(b.getBoundingClientRect()), F = ES([...k, ...R]);
      d(F), v(!0);
    },
    [v]
  );
  return M.useEffect(() => () => g(), [g]), M.useEffect(() => {
    if (f && m) {
      const x = (y) => w(y, m), b = (y) => w(y, f);
      return f.addEventListener("pointerleave", x), m.addEventListener("pointerleave", b), () => {
        f.removeEventListener("pointerleave", x), m.removeEventListener("pointerleave", b);
      };
    }
  }, [f, m, w, g]), M.useEffect(() => {
    if (c) {
      const x = (b) => {
        const y = b.target, E = { x: b.clientX, y: b.clientY }, z = (f == null ? void 0 : f.contains(y)) || (m == null ? void 0 : m.contains(y)), k = !CS(E, c);
        z ? g() : k && (g(), p());
      };
      return document.addEventListener("pointermove", x), () => document.removeEventListener("pointermove", x);
    }
  }, [f, m, c, p, g]), /* @__PURE__ */ u(A8, { ...e, ref: a });
}), [LS, wS] = $l(gi, { isInside: !1 }), MS = /* @__PURE__ */ Wx("TooltipContent"), A8 = M.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": i,
      onEscapeKeyDown: a,
      onPointerDownOutside: c,
      ...d
    } = e, f = _i(w1, n), p = Wl(n), { onClose: m } = f;
    return M.useEffect(() => (document.addEventListener(Ls, m), () => document.removeEventListener(Ls, m)), [m]), M.useEffect(() => {
      if (f.trigger) {
        const v = (g) => {
          const w = g.target;
          w != null && w.contains(f.trigger) && m();
        };
        return window.addEventListener("scroll", v, { capture: !0 }), () => window.removeEventListener("scroll", v, { capture: !0 });
      }
    }, [f.trigger, m]), /* @__PURE__ */ u(
      E1,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: c,
        onFocusOutside: (v) => v.preventDefault(),
        onDismiss: m,
        children: /* @__PURE__ */ V(
          d3,
          {
            "data-state": f.stateAttribute,
            ...p,
            ...d,
            ref: t,
            style: {
              ...d.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ u(MS, { children: r }),
              /* @__PURE__ */ u(LS, { scope: n, isInside: !0, children: /* @__PURE__ */ u(x8, { id: f.contentId, role: "tooltip", children: i || r }) })
            ]
          }
        )
      }
    );
  }
);
z8.displayName = w1;
var S8 = "TooltipArrow", k8 = M.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, i = Wl(n);
    return wS(
      S8,
      n
    ).isInside ? null : /* @__PURE__ */ u(u3, { ...i, ...r, ref: t });
  }
);
k8.displayName = S8;
function xS(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(n, r, i, a)) {
    case a:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function bS(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function yS(e) {
  const { top: t, right: n, bottom: r, left: i } = e;
  return [
    { x: i, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: i, y: r }
  ];
}
function CS(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let a = 0, c = t.length - 1; a < t.length; c = a++) {
    const d = t[a], f = t[c], p = d.x, m = d.y, v = f.x, g = f.y;
    m > r != g > r && n < (v - p) * (r - m) / (g - m) + p && (i = !i);
  }
  return i;
}
function ES(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), FS(t);
}
function FS(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], c = t[t.length - 2];
      if ((a.x - c.x) * (i.y - c.y) >= (a.y - c.y) * (i.x - c.x)) t.pop();
      else break;
    }
    t.push(i);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], c = n[n.length - 2];
      if ((a.x - c.x) * (i.y - c.y) >= (a.y - c.y) * (i.x - c.x)) n.pop();
      else break;
    }
    n.push(i);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var zS = y8, AS = C8, SS = E8, kS = F8, DS = z8, RS = k8;
const Gl = ({ children: e, ...t }) => /* @__PURE__ */ u(zS, { delayDuration: 0, children: /* @__PURE__ */ u(AS, { ...t, children: e }) });
Gl.displayName = "Tooltip";
const Ul = ({ children: e }) => /* @__PURE__ */ u(SS, { asChild: !0, children: e });
Ul.displayName = "TooltipTrigger";
const jl = ({ children: e }) => /* @__PURE__ */ u(kS, { children: /* @__PURE__ */ V(
  DS,
  {
    className: S("text-tooltip-typography bg-tooltip-background z-50 max-w-60 min-w-10 rounded-md p-1 text-xs"),
    sideOffset: 5,
    children: [
      e,
      /* @__PURE__ */ u(RS, { className: S("fill-tooltip-background") })
    ]
  }
) });
jl.displayName = "TooltipContent";
const _S = Ye(
  "bg-avatar-more-background border-avatar-more-border text-avatar-text relative flex grow-0 items-center justify-center rounded-r-full border outline-hidden gap-2",
  {
    variants: {
      size: {
        sm: "-ml-3 pl-4 pr-2",
        md: "-ml-4 pl-5 pr-2",
        lg: "-ml-5 pl-7 pr-3"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), PS = ({ items: e, max: t = 1 / 0, size: n, ...r }) => {
  const i = Ut(() => e.slice(0, t), [e, t]), a = Ut(() => e.slice(t), [e, t]), c = (d, f) => /* @__PURE__ */ u(J6, { ...f, children: d.imageUrl ? /* @__PURE__ */ u(Q6, { src: d.imageUrl, alt: d.name }) : d.icon ? /* @__PURE__ */ u(Re, { name: d.icon }) : /* @__PURE__ */ u(e7, { children: d.fallback || d.name }) });
  return /* @__PURE__ */ V("div", { className: S("flex items-stretch"), ...r, children: [
    /* @__PURE__ */ u("div", { className: S("relative flex items-center -space-x-2"), children: i.map((d) => /* @__PURE__ */ u(
      "div",
      {
        className: S("bg-base-white relative z-10 flex shrink-0 rounded-full p-px", "hover:z-20"),
        children: /* @__PURE__ */ V(Gl, { children: [
          /* @__PURE__ */ u(Ul, { children: c(d, {
            size: n
          }) }),
          /* @__PURE__ */ u(jl, { children: d.name })
        ] })
      },
      d.id
    )) }),
    a.length > 0 ? /* @__PURE__ */ V(Il, { children: [
      /* @__PURE__ */ u(Tl, { asChild: !0, children: /* @__PURE__ */ V(
        "button",
        {
          className: S(
            _S({ size: n || "md" }),
            "focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-hidden",
            "[&[data-state=open]>.avatar-group-indicator]:rotate-180"
          ),
          children: [
            /* @__PURE__ */ V("div", { className: S("text-sm"), children: [
              "+",
              a.length
            ] }),
            /* @__PURE__ */ u("div", { className: S("avatar-group-indicator flex transition-transform duration-200"), children: /* @__PURE__ */ u(Re, { size: "xs", name: "ChevronDown" }) })
          ]
        }
      ) }),
      /* @__PURE__ */ u(Vl, { align: "end", children: a.map((d) => /* @__PURE__ */ u(b3, { children: /* @__PURE__ */ V(sr, { gap: 8, y: "center", children: [
        c(d, {
          size: "sm"
        }),
        /* @__PURE__ */ u("div", { children: d.name })
      ] }) }, d.id)) })
    ] }) : null
  ] });
};
PS.displayName = "AvatarGroup";
const Ms = {
  primary: S(
    "bg-button-primary-default-background text-button-primary-default-text",
    "hover:bg-button-primary-hover-background hover:border-button-primary-hover-border hover:text-button-primary-hover-text",
    "disabled:bg-button-primary-disabled-background disabled:border-button-primary-disabled-border disabled:text-button-primary-disabled-text"
  ),
  secondary: S(
    "border bg-button-secondary-default-background border-button-secondary-default-border text-button-secondary-default-text",
    "hover:bg-button-secondary-hover-background hover:border-button-secondary-hover-border hover:text-button-secondary-hover-text",
    "disabled:bg-button-secondary-disabled-background disabled:border-button-secondary-disabled-border disabled:text-button-secondary-disabled-text"
  ),
  "outline-primary": S(
    "border border-button-outline-primary-default-border bg-button-outline-primary-default-background text-button-outline-primary-default-text",
    "hover:bg-button-outline-primary-hover-background hover:border-button-outline-primary-hover-border hover:text-button-outline-primary-hover-text",
    "disabled:bg-button-outline-primary-disabled-background disabled:border-button-outline-primary-disabled-border disabled:text-button-outline-primary-disabled-text"
  ),
  "outline-secondary": S(
    "border border-button-outline-secondary-default-border bg-button-outline-secondary-default-background text-button-outline-secondary-default-text",
    "hover:bg-button-outline-secondary-hover-background hover:text-button-outline-secondary-hover-text",
    "disabled:bg-button-outline-secondary-disabled-background disabled:border-button-outline-secondary-disabled-border disabled:text-button-outline-secondary-disabled-text"
  ),
  ghost: S(
    "bg-button-ghost-default-background text-button-ghost-default-text",
    "hover:bg-button-ghost-hover-background hover:text-button-ghost-hover-text",
    "disabled:bg-button-ghost-disabled-background disabled:text-button-ghost-disabled-text"
  ),
  negative: S(
    "bg-button-negative-default-background text-button-negative-default-text",
    "hover:bg-button-negative-hover-background hover:text-button-negative-hover-text",
    "disabled:bg-button-negative-disabled-background disabled:text-button-negative-disabled-text"
  )
}, Hr = Ye(
  "inline-flex w-fit items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: Ms,
      size: {
        default: "h-8 px-3 py-2",
        sm: "h-6 px-3 py-1",
        lg: "h-9 px-3 py-2",
        icon: "h-10 w-10",
        action: "h-5 w-5"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "default"
    }
  }
), E3 = W(
  ({ className: e, variant: t = "primary", size: n, asChild: r = !1, type: i = "button", ...a }, c) => /* @__PURE__ */ u(r ? Ei : "button", { className: S(Hr({ variant: t, size: n })), role: "button", ref: c, type: i, ...a })
);
E3.displayName = "Button";
const Pa = {}, ai = {};
function di(e, t) {
  try {
    const r = (Pa[e] || (Pa[e] = new Intl.DateTimeFormat("en-GB", {
      timeZone: e,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format))(t).split("GMT")[1] || "";
    return r in ai ? ai[r] : gd(r, r.split(":"));
  } catch {
    if (e in ai) return ai[e];
    const n = e == null ? void 0 : e.match(HS);
    return n ? gd(e, n.slice(1)) : NaN;
  }
}
const HS = /([+-]\d\d):?(\d\d)?/;
function gd(e, t) {
  const n = +t[0], r = +(t[1] || 0);
  return ai[e] = n > 0 ? n * 60 + r : n * 60 - r;
}
class c2 extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(di(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), D8(this), xs(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new c2(...n, t) : new c2(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new c2(+this, t);
  }
  getTimezoneOffset() {
    return -di(this.timeZone, this);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), xs(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new c2(+new Date(t), this.timeZone);
  }
  //#endregion
}
const Ld = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!Ld.test(e)) return;
  const t = e.replace(Ld, "$1UTC");
  c2.prototype[t] && (e.startsWith("get") ? c2.prototype[e] = function() {
    return this.internal[t]();
  } : (c2.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), OS(this), +this;
  }, c2.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), xs(this), +this;
  }));
});
function xs(e) {
  e.internal.setTime(+e), e.internal.setUTCMinutes(e.internal.getUTCMinutes() - e.getTimezoneOffset());
}
function OS(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), D8(e);
}
function D8(e) {
  const t = di(e.timeZone, e), n = /* @__PURE__ */ new Date(+e);
  n.setUTCHours(n.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), a = r - i, c = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  a && c && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + a);
  const d = r - t;
  d && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + d);
  const f = di(e.timeZone, e), m = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - f, v = f !== t, g = m - d;
  if (v && g) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + g);
    const w = di(e.timeZone, e), x = f - w;
    x && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + x), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + x));
  }
}
class Gt extends c2 {
  //#region static
  static tz(t, ...n) {
    return n.length ? new Gt(...n, t) : new Gt(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), i = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + i;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, i] = this.internal.toUTCString().split(" ");
    return `${t == null ? void 0 : t.slice(0, -1)} ${r} ${n} ${i}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, i] = this.tzComponents();
    return `${t} GMT${n}${r}${i} (${NS(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), i = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, i];
  }
  //#endregion
  withTimeZone(t) {
    return new Gt(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Gt(+new Date(t), this.timeZone);
  }
  //#endregion
}
function NS(e, t) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: e,
    timeZoneName: "long"
  }).format(t).slice(12);
}
var Se;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(Se || (Se = {}));
var xt;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(xt || (xt = {}));
var Zn;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(Zn || (Zn = {}));
var gn;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(gn || (gn = {}));
const R8 = 6048e5, BS = 864e5, wd = Symbol.for("constructDateFrom");
function kt(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && wd in e ? e[wd](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function dt(e, t) {
  return kt(t || e, e);
}
function _8(e, t, n) {
  const r = dt(e, n == null ? void 0 : n.in);
  return isNaN(t) ? kt(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function P8(e, t, n) {
  const r = dt(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return kt(e, NaN);
  if (!t)
    return r;
  const i = r.getDate(), a = kt(e, r.getTime());
  a.setMonth(r.getMonth() + t + 1, 0);
  const c = a.getDate();
  return i >= c ? a : (r.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    i
  ), r);
}
let IS = {};
function Pi() {
  return IS;
}
function M1(e, t) {
  var d, f, p, m;
  const n = Pi(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((f = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? n.weekStartsOn ?? ((m = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : m.weekStartsOn) ?? 0, i = dt(e, t == null ? void 0 : t.in), a = i.getDay(), c = (a < r ? 7 : 0) + a - r;
  return i.setDate(i.getDate() - c), i.setHours(0, 0, 0, 0), i;
}
function Li(e, t) {
  return M1(e, { ...t, weekStartsOn: 1 });
}
function H8(e, t) {
  const n = dt(e, t == null ? void 0 : t.in), r = n.getFullYear(), i = kt(n, 0);
  i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const a = Li(i), c = kt(n, 0);
  c.setFullYear(r, 0, 4), c.setHours(0, 0, 0, 0);
  const d = Li(c);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= d.getTime() ? r : r - 1;
}
function Md(e) {
  const t = dt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function D1(e, ...t) {
  const n = kt.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function wi(e, t) {
  const n = dt(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function O8(e, t, n) {
  const [r, i] = D1(
    n == null ? void 0 : n.in,
    e,
    t
  ), a = wi(r), c = wi(i), d = +a - Md(a), f = +c - Md(c);
  return Math.round((d - f) / BS);
}
function TS(e, t) {
  const n = H8(e, t), r = kt(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Li(r);
}
function VS(e, t, n) {
  return _8(e, t * 7, n);
}
function ZS(e, t, n) {
  return P8(e, t * 12, n);
}
function $S(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((i) => {
    !r && typeof i == "object" && (r = kt.bind(null, i));
    const a = dt(i, r);
    (!n || n < a || isNaN(+a)) && (n = a);
  }), kt(r, n || NaN);
}
function WS(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((i) => {
    !r && typeof i == "object" && (r = kt.bind(null, i));
    const a = dt(i, r);
    (!n || n > a || isNaN(+a)) && (n = a);
  }), kt(r, n || NaN);
}
function GS(e, t, n) {
  const [r, i] = D1(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +wi(r) == +wi(i);
}
function N8(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function US(e) {
  return !(!N8(e) && typeof e != "number" || isNaN(+dt(e)));
}
function jS(e, t, n) {
  const [r, i] = D1(
    n == null ? void 0 : n.in,
    e,
    t
  ), a = r.getFullYear() - i.getFullYear(), c = r.getMonth() - i.getMonth();
  return a * 12 + c;
}
function KS(e, t) {
  const n = dt(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function YS(e, t) {
  const [n, r] = D1(e, t.start, t.end);
  return { start: n, end: r };
}
function qS(e, t) {
  const { start: n, end: r } = YS(t == null ? void 0 : t.in, e);
  let i = +n > +r;
  const a = i ? +n : +r, c = i ? r : n;
  c.setHours(0, 0, 0, 0), c.setDate(1);
  let d = 1;
  const f = [];
  for (; +c <= a; )
    f.push(kt(n, c)), c.setMonth(c.getMonth() + d);
  return i ? f.reverse() : f;
}
function XS(e, t) {
  const n = dt(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function JS(e, t) {
  const n = dt(e, t == null ? void 0 : t.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function B8(e, t) {
  const n = dt(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function I8(e, t) {
  var d, f, p, m;
  const n = Pi(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((f = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? n.weekStartsOn ?? ((m = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : m.weekStartsOn) ?? 0, i = dt(e, t == null ? void 0 : t.in), a = i.getDay(), c = (a < r ? -7 : 0) + 6 - (a - r);
  return i.setDate(i.getDate() + c), i.setHours(23, 59, 59, 999), i;
}
function QS(e, t) {
  return I8(e, { ...t, weekStartsOn: 1 });
}
const ek = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, tk = (e, t, n) => {
  let r;
  const i = ek[e];
  return typeof i == "string" ? r = i : t === 1 ? r = i.one : r = i.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Ha(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const nk = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, rk = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ik = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, lk = {
  date: Ha({
    formats: nk,
    defaultWidth: "full"
  }),
  time: Ha({
    formats: rk,
    defaultWidth: "full"
  }),
  dateTime: Ha({
    formats: ik,
    defaultWidth: "full"
  })
}, ok = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ak = (e, t, n, r) => ok[e];
function J1(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (r === "formatting" && e.formattingValues) {
      const c = e.defaultFormattingWidth || e.defaultWidth, d = n != null && n.width ? String(n.width) : c;
      i = e.formattingValues[d] || e.formattingValues[c];
    } else {
      const c = e.defaultWidth, d = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[d] || e.values[c];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[a];
  };
}
const sk = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, ck = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, dk = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, uk = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, fk = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, hk = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, pk = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, mk = {
  ordinalNumber: pk,
  era: J1({
    values: sk,
    defaultWidth: "wide"
  }),
  quarter: J1({
    values: ck,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: J1({
    values: dk,
    defaultWidth: "wide"
  }),
  day: J1({
    values: uk,
    defaultWidth: "wide"
  }),
  dayPeriod: J1({
    values: fk,
    defaultWidth: "wide",
    formattingValues: hk,
    defaultFormattingWidth: "wide"
  })
};
function Q1(e) {
  return (t, n = {}) => {
    const r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
    if (!a)
      return null;
    const c = a[0], d = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], f = Array.isArray(d) ? gk(d, (v) => v.test(c)) : (
      // [TODO] -- I challenge you to fix the type
      vk(d, (v) => v.test(c))
    );
    let p;
    p = e.valueCallback ? e.valueCallback(f) : f, p = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(p)
    ) : p;
    const m = t.slice(c.length);
    return { value: p, rest: m };
  };
}
function vk(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function gk(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Lk(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const i = r[0], a = t.match(e.parsePattern);
    if (!a) return null;
    let c = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    c = n.valueCallback ? n.valueCallback(c) : c;
    const d = t.slice(i.length);
    return { value: c, rest: d };
  };
}
const wk = /^(\d+)(th|st|nd|rd)?/i, Mk = /\d+/i, xk = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, bk = {
  any: [/^b/i, /^(a|c)/i]
}, yk = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Ck = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ek = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Fk = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, zk = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Ak = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Sk = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, kk = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Dk = {
  ordinalNumber: Lk({
    matchPattern: wk,
    parsePattern: Mk,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Q1({
    matchPatterns: xk,
    defaultMatchWidth: "wide",
    parsePatterns: bk,
    defaultParseWidth: "any"
  }),
  quarter: Q1({
    matchPatterns: yk,
    defaultMatchWidth: "wide",
    parsePatterns: Ck,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Q1({
    matchPatterns: Ek,
    defaultMatchWidth: "wide",
    parsePatterns: Fk,
    defaultParseWidth: "any"
  }),
  day: Q1({
    matchPatterns: zk,
    defaultMatchWidth: "wide",
    parsePatterns: Ak,
    defaultParseWidth: "any"
  }),
  dayPeriod: Q1({
    matchPatterns: Sk,
    defaultMatchWidth: "any",
    parsePatterns: kk,
    defaultParseWidth: "any"
  })
}, F3 = {
  code: "en-US",
  formatDistance: tk,
  formatLong: lk,
  formatRelative: ak,
  localize: mk,
  match: Dk,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Rk(e, t) {
  const n = dt(e, t == null ? void 0 : t.in);
  return O8(n, B8(n)) + 1;
}
function T8(e, t) {
  const n = dt(e, t == null ? void 0 : t.in), r = +Li(n) - +TS(n);
  return Math.round(r / R8) + 1;
}
function V8(e, t) {
  var m, v, g, w;
  const n = dt(e, t == null ? void 0 : t.in), r = n.getFullYear(), i = Pi(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((v = (m = t == null ? void 0 : t.locale) == null ? void 0 : m.options) == null ? void 0 : v.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((w = (g = i.locale) == null ? void 0 : g.options) == null ? void 0 : w.firstWeekContainsDate) ?? 1, c = kt((t == null ? void 0 : t.in) || e, 0);
  c.setFullYear(r + 1, 0, a), c.setHours(0, 0, 0, 0);
  const d = M1(c, t), f = kt((t == null ? void 0 : t.in) || e, 0);
  f.setFullYear(r, 0, a), f.setHours(0, 0, 0, 0);
  const p = M1(f, t);
  return +n >= +d ? r + 1 : +n >= +p ? r : r - 1;
}
function _k(e, t) {
  var d, f, p, m;
  const n = Pi(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((m = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, i = V8(e, t), a = kt((t == null ? void 0 : t.in) || e, 0);
  return a.setFullYear(i, 0, r), a.setHours(0, 0, 0, 0), M1(a, t);
}
function Z8(e, t) {
  const n = dt(e, t == null ? void 0 : t.in), r = +M1(n, t) - +_k(n, t);
  return Math.round(r / R8) + 1;
}
function st(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Q2 = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return st(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : st(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return st(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return st(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return st(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return st(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return st(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return st(i, t.length);
  }
}, u1 = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, xd = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return Q2.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const i = V8(e, r), a = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const c = a % 100;
      return st(c, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : st(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = H8(e);
    return st(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return st(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return st(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return st(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Q2.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return st(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const i = Z8(e, r);
    return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : st(i, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = T8(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : st(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Q2.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = Rk(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : st(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return st(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return st(a, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), i = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return st(i, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r === 12 ? i = u1.noon : r === 0 ? i = u1.midnight : i = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let i;
    switch (r >= 17 ? i = u1.evening : r >= 12 ? i = u1.afternoon : r >= 4 ? i = u1.morning : i = u1.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Q2.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Q2.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : st(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : st(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Q2.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Q2.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Q2.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return yd(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return kr(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return kr(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return yd(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return kr(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return kr(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + bd(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + kr(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + bd(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + kr(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return st(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return st(+e, t.length);
  }
};
function bd(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? n + String(i) : n + String(i) + t + st(a, 2);
}
function yd(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + st(Math.abs(e) / 60, 2) : kr(e, t);
}
function kr(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), i = st(Math.trunc(r / 60), 2), a = st(r % 60, 2);
  return n + i + t + a;
}
const Cd = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, $8 = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Pk = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return Cd(e, t);
  let a;
  switch (r) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", Cd(r, t)).replace("{{time}}", $8(i, t));
}, Hk = {
  p: $8,
  P: Pk
}, Ok = /^D+$/, Nk = /^Y+$/, Bk = ["D", "DD", "YY", "YYYY"];
function Ik(e) {
  return Ok.test(e);
}
function Tk(e) {
  return Nk.test(e);
}
function Vk(e, t, n) {
  const r = Zk(e, t, n);
  if (console.warn(r), Bk.includes(e)) throw new RangeError(r);
}
function Zk(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const $k = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Wk = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Gk = /^'([^]*?)'?$/, Uk = /''/g, jk = /[a-zA-Z]/;
function R2(e, t, n) {
  var m, v, g, w, x, b, y, E;
  const r = Pi(), i = (n == null ? void 0 : n.locale) ?? r.locale ?? F3, a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((v = (m = n == null ? void 0 : n.locale) == null ? void 0 : m.options) == null ? void 0 : v.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((w = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : w.firstWeekContainsDate) ?? 1, c = (n == null ? void 0 : n.weekStartsOn) ?? ((b = (x = n == null ? void 0 : n.locale) == null ? void 0 : x.options) == null ? void 0 : b.weekStartsOn) ?? r.weekStartsOn ?? ((E = (y = r.locale) == null ? void 0 : y.options) == null ? void 0 : E.weekStartsOn) ?? 0, d = dt(e, n == null ? void 0 : n.in);
  if (!US(d))
    throw new RangeError("Invalid time value");
  let f = t.match(Wk).map((z) => {
    const k = z[0];
    if (k === "p" || k === "P") {
      const R = Hk[k];
      return R(z, i.formatLong);
    }
    return z;
  }).join("").match($k).map((z) => {
    if (z === "''")
      return { isToken: !1, value: "'" };
    const k = z[0];
    if (k === "'")
      return { isToken: !1, value: Kk(z) };
    if (xd[k])
      return { isToken: !0, value: z };
    if (k.match(jk))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + k + "`"
      );
    return { isToken: !1, value: z };
  });
  i.localize.preprocessor && (f = i.localize.preprocessor(d, f));
  const p = {
    firstWeekContainsDate: a,
    weekStartsOn: c,
    locale: i
  };
  return f.map((z) => {
    if (!z.isToken) return z.value;
    const k = z.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Tk(k) || !(n != null && n.useAdditionalDayOfYearTokens) && Ik(k)) && Vk(k, t, String(e));
    const R = xd[k[0]];
    return R(d, k, i.localize, p);
  }).join("");
}
function Kk(e) {
  const t = e.match(Gk);
  return t ? t[1].replace(Uk, "'") : e;
}
function Yk(e, t) {
  const n = dt(e, t == null ? void 0 : t.in), r = n.getFullYear(), i = n.getMonth(), a = kt(n, 0);
  return a.setFullYear(r, i + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function qk(e, t) {
  return dt(e, t == null ? void 0 : t.in).getMonth();
}
function Xk(e, t) {
  return dt(e, t == null ? void 0 : t.in).getFullYear();
}
function Jk(e, t) {
  return +dt(e) > +dt(t);
}
function Qk(e, t) {
  return +dt(e) < +dt(t);
}
function eD(e, t, n) {
  const [r, i] = D1(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth();
}
function tD(e, t, n) {
  const [r, i] = D1(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === i.getFullYear();
}
function nD(e, t, n) {
  const r = dt(e, n == null ? void 0 : n.in), i = r.getFullYear(), a = r.getDate(), c = kt(e, 0);
  c.setFullYear(i, t, 15), c.setHours(0, 0, 0, 0);
  const d = Yk(c);
  return r.setMonth(t, Math.min(a, d)), r;
}
function rD(e, t, n) {
  const r = dt(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? kt(e, NaN) : (r.setFullYear(t), r);
}
const Ed = 5, iD = 4;
function lD(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, i = t.addDays(e, -r + 1), a = t.addDays(i, Ed * 7 - 1);
  return t.getMonth(e) === t.getMonth(a) ? Ed : iD;
}
function W8(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -1 * 6) : t.addDays(n, -1 * (r - 1));
}
function oD(e, t) {
  const n = W8(e, t), r = lD(e, t);
  return t.addDays(n, r * 7 - 1);
}
class N2 {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.today = () => {
      var r;
      return (r = this.overrides) != null && r.today ? this.overrides.today() : this.options.timeZone ? Gt.tz(this.options.timeZone) : new this.Date();
    }, this.newDate = (r, i, a) => {
      var c;
      return (c = this.overrides) != null && c.newDate ? this.overrides.newDate(r, i, a) : this.options.timeZone ? new Gt(r, i, a, this.options.timeZone) : new Date(r, i, a);
    }, this.addDays = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.addDays ? this.overrides.addDays(r, i) : _8(r, i);
    }, this.addMonths = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.addMonths ? this.overrides.addMonths(r, i) : P8(r, i);
    }, this.addWeeks = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.addWeeks ? this.overrides.addWeeks(r, i) : VS(r, i);
    }, this.addYears = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.addYears ? this.overrides.addYears(r, i) : ZS(r, i);
    }, this.differenceInCalendarDays = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, i) : O8(r, i);
    }, this.differenceInCalendarMonths = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, i) : jS(r, i);
    }, this.eachMonthOfInterval = (r) => {
      var i;
      return (i = this.overrides) != null && i.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : qS(r);
    }, this.endOfBroadcastWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : oD(r, this);
    }, this.endOfISOWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfISOWeek ? this.overrides.endOfISOWeek(r) : QS(r);
    }, this.endOfMonth = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfMonth ? this.overrides.endOfMonth(r) : KS(r);
    }, this.endOfWeek = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.endOfWeek ? this.overrides.endOfWeek(r, i) : I8(r, this.options);
    }, this.endOfYear = (r) => {
      var i;
      return (i = this.overrides) != null && i.endOfYear ? this.overrides.endOfYear(r) : JS(r);
    }, this.format = (r, i, a) => {
      var d;
      const c = (d = this.overrides) != null && d.format ? this.overrides.format(r, i, this.options) : R2(r, i, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(c) : c;
    }, this.getISOWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.getISOWeek ? this.overrides.getISOWeek(r) : T8(r);
    }, this.getMonth = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.getMonth ? this.overrides.getMonth(r, this.options) : qk(r, this.options);
    }, this.getYear = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.getYear ? this.overrides.getYear(r, this.options) : Xk(r, this.options);
    }, this.getWeek = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.getWeek ? this.overrides.getWeek(r, this.options) : Z8(r, this.options);
    }, this.isAfter = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.isAfter ? this.overrides.isAfter(r, i) : Jk(r, i);
    }, this.isBefore = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.isBefore ? this.overrides.isBefore(r, i) : Qk(r, i);
    }, this.isDate = (r) => {
      var i;
      return (i = this.overrides) != null && i.isDate ? this.overrides.isDate(r) : N8(r);
    }, this.isSameDay = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.isSameDay ? this.overrides.isSameDay(r, i) : GS(r, i);
    }, this.isSameMonth = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.isSameMonth ? this.overrides.isSameMonth(r, i) : eD(r, i);
    }, this.isSameYear = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.isSameYear ? this.overrides.isSameYear(r, i) : tD(r, i);
    }, this.max = (r) => {
      var i;
      return (i = this.overrides) != null && i.max ? this.overrides.max(r) : $S(r);
    }, this.min = (r) => {
      var i;
      return (i = this.overrides) != null && i.min ? this.overrides.min(r) : WS(r);
    }, this.setMonth = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.setMonth ? this.overrides.setMonth(r, i) : nD(r, i);
    }, this.setYear = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.setYear ? this.overrides.setYear(r, i) : rD(r, i);
    }, this.startOfBroadcastWeek = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : W8(r, this);
    }, this.startOfDay = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfDay ? this.overrides.startOfDay(r) : wi(r);
    }, this.startOfISOWeek = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfISOWeek ? this.overrides.startOfISOWeek(r) : Li(r);
    }, this.startOfMonth = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfMonth ? this.overrides.startOfMonth(r) : XS(r);
    }, this.startOfWeek = (r, i) => {
      var a;
      return (a = this.overrides) != null && a.startOfWeek ? this.overrides.startOfWeek(r, this.options) : M1(r, this.options);
    }, this.startOfYear = (r) => {
      var i;
      return (i = this.overrides) != null && i.startOfYear ? this.overrides.startOfYear(r) : B8(r);
    }, this.options = { locale: F3, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let i = 0; i < 10; i++)
      r[i.toString()] = n.format(i);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
}
const p2 = new N2();
class G8 {
  constructor(t, n, r = p2) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r;
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class aD {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class sD {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function k2(e, t, n = !1, r = p2) {
  let { from: i, to: a } = e;
  const { differenceInCalendarDays: c, isSameDay: d } = r;
  return i && a ? (c(a, i) < 0 && ([i, a] = [a, i]), c(t, i) >= (n ? 1 : 0) && c(a, t) >= (n ? 1 : 0)) : !n && a ? d(a, t) : !n && i ? d(i, t) : !1;
}
function U8(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function z3(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function j8(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function K8(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function Y8(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function q8(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function D2(e, t, n = p2) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: i, differenceInCalendarDays: a, isAfter: c } = n;
  return r.some((d) => {
    if (typeof d == "boolean")
      return d;
    if (n.isDate(d))
      return i(e, d);
    if (q8(d, n))
      return d.includes(e);
    if (z3(d))
      return k2(d, e, !1, n);
    if (Y8(d))
      return Array.isArray(d.dayOfWeek) ? d.dayOfWeek.includes(e.getDay()) : d.dayOfWeek === e.getDay();
    if (U8(d)) {
      const f = a(d.before, e), p = a(d.after, e), m = f > 0, v = p < 0;
      return c(d.before, d.after) ? v && m : m || v;
    }
    return j8(d) ? a(e, d.after) > 0 : K8(d) ? a(d.before, e) > 0 : typeof d == "function" ? d(e) : !1;
  });
}
function cD(e, t, n) {
  const { disabled: r, hidden: i, modifiers: a, showOutsideDays: c, broadcastCalendar: d, today: f } = t, { isSameDay: p, isSameMonth: m, startOfMonth: v, isBefore: g, endOfMonth: w, isAfter: x } = n, b = t.startMonth && v(t.startMonth), y = t.endMonth && w(t.endMonth), E = {
    [xt.focused]: [],
    [xt.outside]: [],
    [xt.disabled]: [],
    [xt.hidden]: [],
    [xt.today]: []
  }, z = {};
  for (const k of e) {
    const { date: R, displayMonth: F } = k, _ = !!(F && !m(R, F)), P = !!(b && g(R, b)), O = !!(y && x(R, y)), Z = !!(r && D2(R, r, n)), te = !!(i && D2(R, i, n)) || P || O || // Broadcast calendar will show outside days as default
    !d && !c && _ || d && c === !1 && _, Y = p(R, f ?? n.today());
    _ && E.outside.push(k), Z && E.disabled.push(k), te && E.hidden.push(k), Y && E.today.push(k), a && Object.keys(a).forEach((X) => {
      const re = a == null ? void 0 : a[X];
      re && D2(R, re, n) && (z[X] ? z[X].push(k) : z[X] = [k]);
    });
  }
  return (k) => {
    const R = {
      [xt.focused]: !1,
      [xt.disabled]: !1,
      [xt.hidden]: !1,
      [xt.outside]: !1,
      [xt.today]: !1
    }, F = {};
    for (const _ in E) {
      const P = E[_];
      R[_] = P.some((O) => O === k);
    }
    for (const _ in z)
      F[_] = z[_].some((P) => P === k);
    return {
      ...R,
      // custom modifiers should override all the previous ones
      ...F
    };
  };
}
function dD(e, t, n = {}) {
  return Object.entries(e).filter(([, i]) => i === !0).reduce((i, [a]) => (n[a] ? i.push(n[a]) : t[xt[a]] ? i.push(t[xt[a]]) : t[Zn[a]] && i.push(t[Zn[a]]), i), [t[Se.Day]]);
}
function uD(e) {
  return o.createElement("button", { ...e });
}
function fD(e) {
  return o.createElement("span", { ...e });
}
function hD(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return o.createElement(
    "svg",
    { className: r, width: t, height: t, viewBox: "0 0 24 24" },
    n === "up" && o.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && o.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && o.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && o.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
  );
}
function pD(e) {
  const { day: t, modifiers: n, ...r } = e;
  return o.createElement("td", { ...r });
}
function mD(e) {
  const { day: t, modifiers: n, ...r } = e, i = o.useRef(null);
  return o.useEffect(() => {
    var a;
    n.focused && ((a = i.current) == null || a.focus());
  }, [n.focused]), o.createElement("button", { ref: i, ...r });
}
function vD(e) {
  const { options: t, className: n, components: r, classNames: i, ...a } = e, c = [i[Se.Dropdown], n].join(" "), d = t == null ? void 0 : t.find(({ value: f }) => f === a.value);
  return o.createElement(
    "span",
    { "data-disabled": a.disabled, className: i[Se.DropdownRoot] },
    o.createElement(r.Select, { className: c, ...a }, t == null ? void 0 : t.map(({ value: f, label: p, disabled: m }) => o.createElement(r.Option, { key: f, value: f, disabled: m }, p))),
    o.createElement(
      "span",
      { className: i[Se.CaptionLabel], "aria-hidden": !0 },
      d == null ? void 0 : d.label,
      o.createElement(r.Chevron, { orientation: "down", size: 18, className: i[Se.Chevron] })
    )
  );
}
function gD(e) {
  return o.createElement("div", { ...e });
}
function LD(e) {
  return o.createElement("div", { ...e });
}
function wD(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return o.createElement("div", { ...r }, e.children);
}
function MD(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return o.createElement("div", { ...r });
}
function xD(e) {
  return o.createElement("table", { ...e });
}
function bD(e) {
  return o.createElement("div", { ...e });
}
const X8 = O2(void 0);
function Hi() {
  const e = pt(X8);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function yD(e) {
  const { components: t } = Hi();
  return o.createElement(t.Dropdown, { ...e });
}
function CD(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: i, ...a } = e, { components: c, classNames: d, labels: { labelPrevious: f, labelNext: p } } = Hi(), m = Ft((g) => {
    i && (n == null || n(g));
  }, [i, n]), v = Ft((g) => {
    r && (t == null || t(g));
  }, [r, t]);
  return o.createElement(
    "nav",
    { ...a },
    o.createElement(
      c.PreviousMonthButton,
      { type: "button", className: d[Se.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": f(r), onClick: v },
      o.createElement(c.Chevron, { disabled: r ? void 0 : !0, className: d[Se.Chevron], orientation: "left" })
    ),
    o.createElement(
      c.NextMonthButton,
      { type: "button", className: d[Se.NextMonthButton], tabIndex: i ? void 0 : -1, "aria-disabled": i ? void 0 : !0, "aria-label": p(i), onClick: m },
      o.createElement(c.Chevron, { disabled: i ? void 0 : !0, orientation: "right", className: d[Se.Chevron] })
    )
  );
}
function ED(e) {
  const { components: t } = Hi();
  return o.createElement(t.Button, { ...e });
}
function FD(e) {
  return o.createElement("option", { ...e });
}
function zD(e) {
  const { components: t } = Hi();
  return o.createElement(t.Button, { ...e });
}
function AD(e) {
  const { rootRef: t, ...n } = e;
  return o.createElement("div", { ...n, ref: t });
}
function SD(e) {
  return o.createElement("select", { ...e });
}
function kD(e) {
  const { week: t, ...n } = e;
  return o.createElement("tr", { ...n });
}
function DD(e) {
  return o.createElement("th", { ...e });
}
function RD(e) {
  return o.createElement(
    "thead",
    { "aria-hidden": !0 },
    o.createElement("tr", { ...e })
  );
}
function _D(e) {
  const { week: t, ...n } = e;
  return o.createElement("th", { ...n });
}
function PD(e) {
  return o.createElement("th", { ...e });
}
function HD(e) {
  return o.createElement("tbody", { ...e });
}
function OD(e) {
  const { components: t } = Hi();
  return o.createElement(t.Dropdown, { ...e });
}
const ND = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: uD,
  CaptionLabel: fD,
  Chevron: hD,
  Day: pD,
  DayButton: mD,
  Dropdown: vD,
  DropdownNav: gD,
  Footer: LD,
  Month: wD,
  MonthCaption: MD,
  MonthGrid: xD,
  Months: bD,
  MonthsDropdown: yD,
  Nav: CD,
  NextMonthButton: ED,
  Option: FD,
  PreviousMonthButton: zD,
  Root: AD,
  Select: SD,
  Week: kD,
  WeekNumber: _D,
  WeekNumberHeader: PD,
  Weekday: DD,
  Weekdays: RD,
  Weeks: HD,
  YearsDropdown: OD
}, Symbol.toStringTag, { value: "Module" }));
function BD(e) {
  return {
    ...ND,
    ...e
  };
}
function ID(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function TD() {
  const e = {};
  for (const t in Se)
    e[Se[t]] = `rdp-${Se[t]}`;
  for (const t in xt)
    e[xt[t]] = `rdp-${xt[t]}`;
  for (const t in Zn)
    e[Zn[t]] = `rdp-${Zn[t]}`;
  for (const t in gn)
    e[gn[t]] = `rdp-${gn[t]}`;
  return e;
}
function J8(e, t, n) {
  return (n ?? new N2(t)).format(e, "LLLL y");
}
const VD = J8;
function ZD(e, t, n) {
  return (n ?? new N2(t)).format(e, "d");
}
function $D(e, t = p2) {
  return t.format(e, "LLLL");
}
function WD(e, t = p2) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function GD() {
  return "";
}
function UD(e, t, n) {
  return (n ?? new N2(t)).format(e, "cccccc");
}
function Q8(e, t = p2) {
  return t.format(e, "yyyy");
}
const jD = Q8, KD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: J8,
  formatDay: ZD,
  formatMonthCaption: VD,
  formatMonthDropdown: $D,
  formatWeekNumber: WD,
  formatWeekNumberHeader: GD,
  formatWeekdayName: UD,
  formatYearCaption: jD,
  formatYearDropdown: Q8
}, Symbol.toStringTag, { value: "Module" }));
function YD(e) {
  return e != null && e.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e != null && e.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...KD,
    ...e
  };
}
function qD(e, t, n, r, i) {
  const { startOfMonth: a, startOfYear: c, endOfYear: d, eachMonthOfInterval: f, getMonth: p } = i;
  return f({
    start: c(e),
    end: d(e)
  }).map((g) => {
    const w = r.formatMonthDropdown(g, i), x = p(g), b = t && g < a(t) || n && g > a(n) || !1;
    return { value: x, label: w, disabled: b };
  });
}
function XD(e, t = {}, n = {}) {
  let r = { ...t == null ? void 0 : t[Se.Day] };
  return Object.entries(e).filter(([, i]) => i === !0).forEach(([i]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[i]
    };
  }), r;
}
function JD(e, t, n) {
  const r = e.today(), i = t ? e.startOfISOWeek(r) : e.startOfWeek(r), a = [];
  for (let c = 0; c < 7; c++) {
    const d = e.addDays(i, c);
    a.push(d);
  }
  return a;
}
function QD(e, t, n, r) {
  if (!e || !t)
    return;
  const { startOfYear: i, endOfYear: a, addYears: c, getYear: d, isBefore: f, isSameYear: p } = r, m = i(e), v = a(t), g = [];
  let w = m;
  for (; f(w, v) || p(w, v); )
    g.push(w), w = c(w, 1);
  return g.map((x) => {
    const b = n.formatYearDropdown(x, r);
    return {
      value: d(x),
      label: b,
      disabled: !1
    };
  });
}
function e9(e, t, n) {
  return (n ?? new N2(t)).format(e, "LLLL y");
}
const eR = e9;
function tR(e, t, n, r) {
  let i = (r ?? new N2(n)).format(e, "PPPP");
  return t != null && t.today && (i = `Today, ${i}`), i;
}
function t9(e, t, n, r) {
  let i = (r ?? new N2(n)).format(e, "PPPP");
  return t.today && (i = `Today, ${i}`), t.selected && (i = `${i}, selected`), i;
}
const nR = t9;
function rR() {
  return "";
}
function iR(e) {
  return "Choose the Month";
}
function lR(e) {
  return "Go to the Next Month";
}
function oR(e) {
  return "Go to the Previous Month";
}
function aR(e, t, n) {
  return (n ?? new N2(t)).format(e, "cccc");
}
function sR(e, t) {
  return `Week ${e}`;
}
function cR(e) {
  return "Week Number";
}
function dR(e) {
  return "Choose the Year";
}
const uR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: eR,
  labelDay: nR,
  labelDayButton: t9,
  labelGrid: e9,
  labelGridcell: tR,
  labelMonthDropdown: iR,
  labelNav: rR,
  labelNext: lR,
  labelPrevious: oR,
  labelWeekNumber: sR,
  labelWeekNumberHeader: cR,
  labelWeekday: aR,
  labelYearDropdown: dR
}, Symbol.toStringTag, { value: "Module" })), Oi = (e) => e instanceof HTMLElement ? e : null, Oa = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], fR = (e) => Oi(e.querySelector("[data-animated-month]")), Na = (e) => Oi(e.querySelector("[data-animated-caption]")), Ba = (e) => Oi(e.querySelector("[data-animated-weeks]")), hR = (e) => Oi(e.querySelector("[data-animated-nav]")), pR = (e) => Oi(e.querySelector("[data-animated-weekdays]"));
function mR(e, t, { classNames: n, months: r, focused: i, dateLib: a }) {
  const c = It(null), d = It(r), f = It(!1);
  J0(() => {
    const p = d.current;
    if (d.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || p.length === 0 || r.length !== p.length)
      return;
    const m = a.isSameMonth(r[0].date, p[0].date), v = a.isAfter(r[0].date, p[0].date), g = v ? n[gn.caption_after_enter] : n[gn.caption_before_enter], w = v ? n[gn.weeks_after_enter] : n[gn.weeks_before_enter], x = c.current, b = e.current.cloneNode(!0);
    if (b instanceof HTMLElement ? (Oa(b).forEach((k) => {
      if (!(k instanceof HTMLElement))
        return;
      const R = fR(k);
      R && k.contains(R) && k.removeChild(R);
      const F = Na(k);
      F && F.classList.remove(g);
      const _ = Ba(k);
      _ && _.classList.remove(w);
    }), c.current = b) : c.current = null, f.current || m || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    i)
      return;
    const y = x instanceof HTMLElement ? Oa(x) : [], E = Oa(e.current);
    if (E && E.every((z) => z instanceof HTMLElement) && y && y.every((z) => z instanceof HTMLElement)) {
      f.current = !0, e.current.style.isolation = "isolate";
      const z = hR(e.current);
      z && (z.style.zIndex = "1"), E.forEach((k, R) => {
        const F = y[R];
        if (!F)
          return;
        k.style.position = "relative", k.style.overflow = "hidden";
        const _ = Na(k);
        _ && _.classList.add(g);
        const P = Ba(k);
        P && P.classList.add(w);
        const O = () => {
          f.current = !1, e.current && (e.current.style.isolation = ""), z && (z.style.zIndex = ""), _ && _.classList.remove(g), P && P.classList.remove(w), k.style.position = "", k.style.overflow = "", k.contains(F) && k.removeChild(F);
        };
        F.style.pointerEvents = "none", F.style.position = "absolute", F.style.overflow = "hidden", F.setAttribute("aria-hidden", "true");
        const Z = pR(F);
        Z && (Z.style.opacity = "0");
        const te = Na(F);
        te && (te.classList.add(v ? n[gn.caption_before_exit] : n[gn.caption_after_exit]), te.addEventListener("animationend", O));
        const Y = Ba(F);
        Y && Y.classList.add(v ? n[gn.weeks_before_exit] : n[gn.weeks_after_exit]), k.insertBefore(F, k.firstChild);
      });
    }
  });
}
function vR(e, t, n, r) {
  const i = e[0], a = e[e.length - 1], { ISOWeek: c, fixedWeeks: d, broadcastCalendar: f } = n ?? {}, { addDays: p, differenceInCalendarDays: m, differenceInCalendarMonths: v, endOfBroadcastWeek: g, endOfISOWeek: w, endOfMonth: x, endOfWeek: b, isAfter: y, startOfBroadcastWeek: E, startOfISOWeek: z, startOfWeek: k } = r, R = f ? E(i, r) : c ? z(i) : k(i), F = f ? g(a) : c ? w(x(a)) : b(x(a)), _ = m(F, R), P = v(a, i) + 1, O = [];
  for (let Y = 0; Y <= _; Y++) {
    const X = p(R, Y);
    if (t && y(X, t))
      break;
    O.push(X);
  }
  const te = (f ? 35 : 42) * P;
  if (d && O.length < te) {
    const Y = te - O.length;
    for (let X = 0; X < Y; X++) {
      const re = p(O[O.length - 1], 1);
      O.push(re);
    }
  }
  return O;
}
function gR(e) {
  const t = [];
  return e.reduce((n, r) => {
    const i = r.weeks.reduce((a, c) => [...a, ...c.days], t);
    return [...n, ...i];
  }, t);
}
function LR(e, t, n, r) {
  const { numberOfMonths: i = 1 } = n, a = [];
  for (let c = 0; c < i; c++) {
    const d = r.addMonths(e, c);
    if (t && d > t)
      break;
    a.push(d);
  }
  return a;
}
function Fd(e, t) {
  const { month: n, defaultMonth: r, today: i = t.today(), numberOfMonths: a = 1, endMonth: c, startMonth: d } = e;
  let f = n || r || i;
  const { differenceInCalendarMonths: p, addMonths: m, startOfMonth: v } = t;
  if (c && p(c, f) < 0) {
    const g = -1 * (a - 1);
    f = m(c, g);
  }
  return d && p(f, d) < 0 && (f = d), v(f);
}
function wR(e, t, n, r) {
  const { addDays: i, endOfBroadcastWeek: a, endOfISOWeek: c, endOfMonth: d, endOfWeek: f, getISOWeek: p, getWeek: m, startOfBroadcastWeek: v, startOfISOWeek: g, startOfWeek: w } = r, x = e.reduce((b, y) => {
    const E = n.broadcastCalendar ? v(y, r) : n.ISOWeek ? g(y) : w(y), z = n.broadcastCalendar ? a(y) : n.ISOWeek ? c(d(y)) : f(d(y)), k = t.filter((P) => P >= E && P <= z), R = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && k.length < R) {
      const P = t.filter((O) => {
        const Z = R - k.length;
        return O > z && O <= i(z, Z);
      });
      k.push(...P);
    }
    const F = k.reduce((P, O) => {
      const Z = n.ISOWeek ? p(O) : m(O), te = P.find((X) => X.weekNumber === Z), Y = new G8(O, y, r);
      return te ? te.days.push(Y) : P.push(new sD(Z, [Y])), P;
    }, []), _ = new aD(y, F);
    return b.push(_), b;
  }, []);
  return n.reverseMonths ? x.reverse() : x;
}
function MR(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: i, startOfDay: a, startOfMonth: c, endOfMonth: d, addYears: f, endOfYear: p, newDate: m, today: v } = t, { fromYear: g, toYear: w, fromMonth: x, toMonth: b } = e;
  !n && x && (n = x), !n && g && (n = t.newDate(g, 0, 1)), !r && b && (r = b), !r && w && (r = m(w, 11, 31));
  const y = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = c(n) : g ? n = m(g, 0, 1) : !n && y && (n = i(f(e.today ?? v(), -100))), r ? r = d(r) : w ? r = m(w, 11, 31) : !r && y && (r = p(e.today ?? v())), [
    n && a(n),
    r && a(r)
  ];
}
function xR(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: a = 1 } = n, { startOfMonth: c, addMonths: d, differenceInCalendarMonths: f } = r, p = i ? a : 1, m = c(e);
  if (!t)
    return d(m, p);
  if (!(f(t, e) < a))
    return d(m, p);
}
function bR(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: a } = n, { startOfMonth: c, addMonths: d, differenceInCalendarMonths: f } = r, p = i ? a ?? 1 : 1, m = c(e);
  if (!t)
    return d(m, -p);
  if (!(f(m, t) <= 0))
    return d(m, -p);
}
function yR(e) {
  const t = [];
  return e.reduce((n, r) => [...n, ...r.weeks], t);
}
function Kl(e, t) {
  const [n, r] = q(e);
  return [t === void 0 ? n : t, r];
}
function CR(e, t) {
  const [n, r] = MR(e, t), { startOfMonth: i, endOfMonth: a } = t, c = Fd(e, t), [d, f] = Kl(
    c,
    // initialMonth is always computed from props.month if provided
    e.month ? c : void 0
  );
  T(() => {
    const _ = Fd(e, t);
    f(_);
  }, [e.timeZone]);
  const p = LR(d, r, e, t), m = vR(p, e.endMonth ? a(e.endMonth) : void 0, e, t), v = wR(p, m, e, t), g = yR(v), w = gR(v), x = bR(d, n, e, t), b = xR(d, r, e, t), { disableNavigation: y, onMonthChange: E } = e, z = (_) => g.some((P) => P.days.some((O) => O.isEqualTo(_))), k = (_) => {
    if (y)
      return;
    let P = i(_);
    n && P < i(n) && (P = i(n)), r && P > i(r) && (P = i(r)), f(P), E == null || E(P);
  };
  return {
    months: v,
    weeks: g,
    days: w,
    navStart: n,
    navEnd: r,
    previousMonth: x,
    nextMonth: b,
    goToMonth: k,
    goToDay: (_) => {
      z(_) || k(_.date);
    }
  };
}
var o2;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(o2 || (o2 = {}));
function zd(e) {
  return !e[xt.disabled] && !e[xt.hidden] && !e[xt.outside];
}
function ER(e, t, n, r) {
  let i, a = -1;
  for (const c of e) {
    const d = t(c);
    zd(d) && (d[xt.focused] && a < o2.FocusedModifier ? (i = c, a = o2.FocusedModifier) : r != null && r.isEqualTo(c) && a < o2.LastFocused ? (i = c, a = o2.LastFocused) : n(c.date) && a < o2.Selected ? (i = c, a = o2.Selected) : d[xt.today] && a < o2.Today && (i = c, a = o2.Today));
  }
  return i || (i = e.find((c) => zd(t(c)))), i;
}
function FR(e, t, n, r, i, a, c) {
  const { ISOWeek: d, broadcastCalendar: f } = a, { addDays: p, addMonths: m, addWeeks: v, addYears: g, endOfBroadcastWeek: w, endOfISOWeek: x, endOfWeek: b, max: y, min: E, startOfBroadcastWeek: z, startOfISOWeek: k, startOfWeek: R } = c;
  let _ = {
    day: p,
    week: v,
    month: m,
    year: g,
    startOfWeek: (P) => f ? z(P, c) : d ? k(P) : R(P),
    endOfWeek: (P) => f ? w(P) : d ? x(P) : b(P)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? _ = y([r, _]) : t === "after" && i && (_ = E([i, _])), _;
}
function n9(e, t, n, r, i, a, c, d = 0) {
  if (d > 365)
    return;
  const f = FR(e, t, n.date, r, i, a, c), p = !!(a.disabled && D2(f, a.disabled, c)), m = !!(a.hidden && D2(f, a.hidden, c)), v = f, g = new G8(f, v, c);
  return !p && !m ? g : n9(e, t, g, r, i, a, c, d + 1);
}
function zR(e, t, n, r, i) {
  const { autoFocus: a } = e, [c, d] = q(), f = ER(t.days, n, r || (() => !1), c), [p, m] = q(a ? f : void 0);
  return {
    isFocusTarget: (b) => !!(f != null && f.isEqualTo(b)),
    setFocused: m,
    focused: p,
    blur: () => {
      d(p), m(void 0);
    },
    moveFocus: (b, y) => {
      if (!p)
        return;
      const E = n9(b, y, p, t.navStart, t.navEnd, e, i);
      E && (t.goToDay(E), m(E));
    }
  };
}
function AR(e, t) {
  const { selected: n, required: r, onSelect: i } = e, [a, c] = Kl(n, i ? n : void 0), d = i ? n : a, { isSameDay: f } = t, p = (w) => (d == null ? void 0 : d.some((x) => f(x, w))) ?? !1, { min: m, max: v } = e;
  return {
    selected: d,
    select: (w, x, b) => {
      let y = [...d ?? []];
      if (p(w)) {
        if ((d == null ? void 0 : d.length) === m || r && (d == null ? void 0 : d.length) === 1)
          return;
        y = d == null ? void 0 : d.filter((E) => !f(E, w));
      } else
        (d == null ? void 0 : d.length) === v ? y = [w] : y = [...y, w];
      return i || c(y), i == null || i(y, w, x, b), y;
    },
    isSelected: p
  };
}
function SR(e, t, n = 0, r = 0, i = !1, a = p2) {
  const { from: c, to: d } = t || {}, { isSameDay: f, isAfter: p, isBefore: m } = a;
  let v;
  if (!c && !d)
    v = { from: e, to: n > 0 ? void 0 : e };
  else if (c && !d)
    f(c, e) ? i ? v = { from: c, to: void 0 } : v = void 0 : m(e, c) ? v = { from: e, to: c } : v = { from: c, to: e };
  else if (c && d)
    if (f(c, e) && f(d, e))
      i ? v = { from: c, to: d } : v = void 0;
    else if (f(c, e))
      v = { from: c, to: n > 0 ? void 0 : e };
    else if (f(d, e))
      v = { from: e, to: n > 0 ? void 0 : e };
    else if (m(e, c))
      v = { from: e, to: d };
    else if (p(e, c))
      v = { from: c, to: e };
    else if (p(e, d))
      v = { from: c, to: e };
    else
      throw new Error("Invalid range");
  if (v != null && v.from && (v != null && v.to)) {
    const g = a.differenceInCalendarDays(v.to, v.from);
    r > 0 && g > r ? v = { from: e, to: void 0 } : n > 1 && g < n && (v = { from: e, to: void 0 });
  }
  return v;
}
function kR(e, t, n = p2) {
  const r = Array.isArray(t) ? t : [t];
  let i = e.from;
  const a = n.differenceInCalendarDays(e.to, e.from), c = Math.min(a, 6);
  for (let d = 0; d <= c; d++) {
    if (r.includes(i.getDay()))
      return !0;
    i = n.addDays(i, 1);
  }
  return !1;
}
function Ad(e, t, n = p2) {
  return k2(e, t.from, !1, n) || k2(e, t.to, !1, n) || k2(t, e.from, !1, n) || k2(t, e.to, !1, n);
}
function DR(e, t, n = p2) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((d) => typeof d != "function").some((d) => typeof d == "boolean" ? d : n.isDate(d) ? k2(e, d, !1, n) : q8(d, n) ? d.some((f) => k2(e, f, !1, n)) : z3(d) ? d.from && d.to ? Ad(e, { from: d.from, to: d.to }, n) : !1 : Y8(d) ? kR(e, d.dayOfWeek, n) : U8(d) ? n.isAfter(d.before, d.after) ? Ad(e, {
    from: n.addDays(d.after, 1),
    to: n.addDays(d.before, -1)
  }, n) : D2(e.from, d, n) || D2(e.to, d, n) : j8(d) || K8(d) ? D2(e.from, d, n) || D2(e.to, d, n) : !1))
    return !0;
  const c = r.filter((d) => typeof d == "function");
  if (c.length) {
    let d = e.from;
    const f = n.differenceInCalendarDays(e.to, e.from);
    for (let p = 0; p <= f; p++) {
      if (c.some((m) => m(d)))
        return !0;
      d = n.addDays(d, 1);
    }
  }
  return !1;
}
function RR(e, t) {
  const { disabled: n, excludeDisabled: r, selected: i, required: a, onSelect: c } = e, [d, f] = Kl(i, c ? i : void 0), p = c ? i : d;
  return {
    selected: p,
    select: (g, w, x) => {
      const { min: b, max: y } = e, E = g ? SR(g, p, b, y, a, t) : void 0;
      return r && n && (E != null && E.from) && E.to && DR({ from: E.from, to: E.to }, n, t) && (E.from = g, E.to = void 0), c || f(E), c == null || c(E, g, w, x), E;
    },
    isSelected: (g) => p && k2(p, g, !1, t)
  };
}
function _R(e, t) {
  const { selected: n, required: r, onSelect: i } = e, [a, c] = Kl(n, i ? n : void 0), d = i ? n : a, { isSameDay: f } = t;
  return {
    selected: d,
    select: (v, g, w) => {
      let x = v;
      return !r && d && d && f(v, d) && (x = void 0), i || c(x), i == null || i(x, v, g, w), x;
    },
    isSelected: (v) => d ? f(d, v) : !1
  };
}
function PR(e, t) {
  const n = _R(e, t), r = AR(e, t), i = RR(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return i;
    default:
      return;
  }
}
function HR(e) {
  var Lr;
  let t = e;
  t.timeZone && (t = {
    ...e
  }, t.today && (t.today = new Gt(t.today, t.timeZone)), t.month && (t.month = new Gt(t.month, t.timeZone)), t.defaultMonth && (t.defaultMonth = new Gt(t.defaultMonth, t.timeZone)), t.startMonth && (t.startMonth = new Gt(t.startMonth, t.timeZone)), t.endMonth && (t.endMonth = new Gt(t.endMonth, t.timeZone)), t.mode === "single" && t.selected ? t.selected = new Gt(t.selected, t.timeZone) : t.mode === "multiple" && t.selected ? t.selected = (Lr = t.selected) == null ? void 0 : Lr.map((Ie) => new Gt(Ie, t.timeZone)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? new Gt(t.selected.from, t.timeZone) : void 0,
    to: t.selected.to ? new Gt(t.selected.to, t.timeZone) : void 0
  }));
  const { components: n, formatters: r, labels: i, dateLib: a, locale: c, classNames: d } = Ut(() => {
    const Ie = { ...F3, ...t.locale };
    return {
      dateLib: new N2({
        locale: Ie,
        weekStartsOn: t.broadcastCalendar ? 1 : t.weekStartsOn,
        firstWeekContainsDate: t.firstWeekContainsDate,
        useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
        timeZone: t.timeZone,
        numerals: t.numerals
      }, t.dateLib),
      components: BD(t.components),
      formatters: YD(t.formatters),
      labels: { ...uR, ...t.labels },
      locale: Ie,
      classNames: { ...TD(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]), { captionLayout: f, mode: p, navLayout: m, numberOfMonths: v = 1, onDayBlur: g, onDayClick: w, onDayFocus: x, onDayKeyDown: b, onDayMouseEnter: y, onDayMouseLeave: E, onNextClick: z, onPrevClick: k, showWeekNumber: R, styles: F } = t, { formatCaption: _, formatDay: P, formatMonthDropdown: O, formatWeekNumber: Z, formatWeekNumberHeader: te, formatWeekdayName: Y, formatYearDropdown: X } = r, re = CR(t, a), { days: ee, months: de, navStart: ae, navEnd: ge, previousMonth: K, nextMonth: J, goToMonth: he } = re, ve = cD(ee, t, a), { isSelected: Q, select: ie, selected: pe } = PR(t, a) ?? {}, { blur: U, focused: Me, isFocusTarget: Le, moveFocus: xe, setFocused: Ee } = zR(t, re, ve, Q ?? (() => !1), a), { labelDayButton: ye, labelGridcell: Be, labelGrid: ft, labelMonthDropdown: Et, labelNav: Lt, labelPrevious: je, labelNext: B2, labelWeekday: _t, labelWeekNumber: m2, labelWeekNumberHeader: cn, labelYearDropdown: qn } = i, Pt = Ut(() => JD(a, t.ISOWeek), [a, t.ISOWeek]), On = p !== void 0 || w !== void 0, dn = Ft(() => {
    K && (he(K), k == null || k(K));
  }, [K, he, k]), I2 = Ft(() => {
    J && (he(J), z == null || z(J));
  }, [he, J, z]), Xn = Ft((Ie, ot) => (nt) => {
    nt.preventDefault(), nt.stopPropagation(), Ee(Ie), ie == null || ie(Ie.date, ot, nt), w == null || w(Ie.date, ot, nt);
  }, [ie, w, Ee]), Gr = Ft((Ie, ot) => (nt) => {
    Ee(Ie), x == null || x(Ie.date, ot, nt);
  }, [x, Ee]), En = Ft((Ie, ot) => (nt) => {
    U(), g == null || g(Ie.date, ot, nt);
  }, [U, g]), Nn = Ft((Ie, ot) => (nt) => {
    const nn = {
      ArrowLeft: ["day", t.dir === "rtl" ? "after" : "before"],
      ArrowRight: ["day", t.dir === "rtl" ? "before" : "after"],
      ArrowDown: ["week", "after"],
      ArrowUp: ["week", "before"],
      PageUp: [nt.shiftKey ? "year" : "month", "before"],
      PageDown: [nt.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (nn[nt.key]) {
      nt.preventDefault(), nt.stopPropagation();
      const [Ht, g2] = nn[nt.key];
      xe(Ht, g2);
    }
    b == null || b(Ie.date, ot, nt);
  }, [xe, b, t.dir]), Jn = Ft((Ie, ot) => (nt) => {
    y == null || y(Ie.date, ot, nt);
  }, [y]), T2 = Ft((Ie, ot) => (nt) => {
    E == null || E(Ie.date, ot, nt);
  }, [E]), Qn = Ft((Ie) => (ot) => {
    const nt = Number(ot.target.value), nn = a.setMonth(a.startOfMonth(Ie), nt);
    he(nn);
  }, [a, he]), V2 = Ft((Ie) => (ot) => {
    const nt = Number(ot.target.value), nn = a.setYear(a.startOfMonth(Ie), nt);
    he(nn);
  }, [a, he]), { className: e2, style: Z2 } = Ut(() => ({
    className: [d[Se.Root], t.className].filter(Boolean).join(" "),
    style: { ...F == null ? void 0 : F[Se.Root], ...t.style }
  }), [d, t.className, t.style, F]), t2 = ID(t), v2 = It(null);
  mR(v2, !!t.animate, {
    classNames: d,
    months: de,
    focused: Me,
    dateLib: a
  });
  const n2 = {
    dayPickerProps: t,
    selected: pe,
    select: ie,
    isSelected: Q,
    months: de,
    nextMonth: J,
    previousMonth: K,
    goToMonth: he,
    getModifiers: ve,
    components: n,
    classNames: d,
    styles: F,
    labels: i,
    formatters: r
  };
  return o.createElement(
    X8.Provider,
    { value: n2 },
    o.createElement(
      n.Root,
      { rootRef: t.animate ? v2 : void 0, className: e2, style: Z2, dir: t.dir, id: t.id, lang: t.lang, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], ...t2 },
      o.createElement(
        n.Months,
        { className: d[Se.Months], style: F == null ? void 0 : F[Se.Months] },
        !t.hideNavigation && !m && o.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: d[Se.Nav], style: F == null ? void 0 : F[Se.Nav], "aria-label": Lt(), onPreviousClick: dn, onNextClick: I2, previousMonth: K, nextMonth: J }),
        de.map((Ie, ot) => {
          const nt = qD(Ie.date, ae, ge, r, a), nn = QD(ae, ge, r, a);
          return o.createElement(
            n.Month,
            { "data-animated-month": t.animate ? "true" : void 0, className: d[Se.Month], style: F == null ? void 0 : F[Se.Month], key: ot, displayIndex: ot, calendarMonth: Ie },
            m === "around" && !t.hideNavigation && ot === 0 && o.createElement(
              n.PreviousMonthButton,
              { type: "button", className: d[Se.PreviousMonthButton], tabIndex: K ? void 0 : -1, "aria-disabled": K ? void 0 : !0, "aria-label": je(K), onClick: dn, "data-animated-button": t.animate ? "true" : void 0 },
              o.createElement(n.Chevron, { disabled: K ? void 0 : !0, className: d[Se.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
            ),
            o.createElement(n.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: d[Se.MonthCaption], style: F == null ? void 0 : F[Se.MonthCaption], calendarMonth: Ie, displayIndex: ot }, f != null && f.startsWith("dropdown") ? o.createElement(
              n.DropdownNav,
              { className: d[Se.Dropdowns], style: F == null ? void 0 : F[Se.Dropdowns] },
              f === "dropdown" || f === "dropdown-months" ? o.createElement(n.MonthsDropdown, { className: d[Se.MonthsDropdown], "aria-label": Et(), classNames: d, components: n, disabled: !!t.disableNavigation, onChange: Qn(Ie.date), options: nt, style: F == null ? void 0 : F[Se.Dropdown], value: a.getMonth(Ie.date) }) : o.createElement("span", null, O(Ie.date, a)),
              f === "dropdown" || f === "dropdown-years" ? o.createElement(n.YearsDropdown, { className: d[Se.YearsDropdown], "aria-label": qn(a.options), classNames: d, components: n, disabled: !!t.disableNavigation, onChange: V2(Ie.date), options: nn, style: F == null ? void 0 : F[Se.Dropdown], value: a.getYear(Ie.date) }) : o.createElement("span", null, X(Ie.date, a)),
              o.createElement("span", { role: "status", "aria-live": "polite", style: {
                border: 0,
                clip: "rect(0 0 0 0)",
                height: "1px",
                margin: "-1px",
                overflow: "hidden",
                padding: 0,
                position: "absolute",
                width: "1px",
                whiteSpace: "nowrap",
                wordWrap: "normal"
              } }, _(Ie.date, a.options, a))
            ) : o.createElement(n.CaptionLabel, { className: d[Se.CaptionLabel], role: "status", "aria-live": "polite" }, _(Ie.date, a.options, a))),
            m === "around" && !t.hideNavigation && ot === v - 1 && o.createElement(
              n.NextMonthButton,
              { type: "button", className: d[Se.NextMonthButton], tabIndex: J ? void 0 : -1, "aria-disabled": J ? void 0 : !0, "aria-label": B2(J), onClick: I2, "data-animated-button": t.animate ? "true" : void 0 },
              o.createElement(n.Chevron, { disabled: J ? void 0 : !0, className: d[Se.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
            ),
            ot === v - 1 && m === "after" && !t.hideNavigation && o.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: d[Se.Nav], style: F == null ? void 0 : F[Se.Nav], "aria-label": Lt(), onPreviousClick: dn, onNextClick: I2, previousMonth: K, nextMonth: J }),
            o.createElement(
              n.MonthGrid,
              { role: "grid", "aria-multiselectable": p === "multiple" || p === "range", "aria-label": ft(Ie.date, a.options, a) || void 0, className: d[Se.MonthGrid], style: F == null ? void 0 : F[Se.MonthGrid] },
              !t.hideWeekdays && o.createElement(
                n.Weekdays,
                { "data-animated-weekdays": t.animate ? "true" : void 0, className: d[Se.Weekdays], style: F == null ? void 0 : F[Se.Weekdays] },
                R && o.createElement(n.WeekNumberHeader, { "aria-label": cn(a.options), className: d[Se.WeekNumberHeader], style: F == null ? void 0 : F[Se.WeekNumberHeader], scope: "col" }, te()),
                Pt.map((Ht, g2) => o.createElement(n.Weekday, { "aria-label": _t(Ht, a.options, a), className: d[Se.Weekday], key: g2, style: F == null ? void 0 : F[Se.Weekday], scope: "col" }, Y(Ht, a.options, a)))
              ),
              o.createElement(n.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: d[Se.Weeks], style: F == null ? void 0 : F[Se.Weeks] }, Ie.weeks.map((Ht, g2) => o.createElement(
                n.Week,
                { className: d[Se.Week], key: Ht.weekNumber, style: F == null ? void 0 : F[Se.Week], week: Ht },
                R && o.createElement(n.WeekNumber, { week: Ht, style: F == null ? void 0 : F[Se.WeekNumber], "aria-label": m2(Ht.weekNumber, {
                  locale: c
                }), className: d[Se.WeekNumber], scope: "row", role: "rowheader" }, Z(Ht.weekNumber, a)),
                Ht.days.map((wt) => {
                  const { date: Xt } = wt, qe = ve(wt);
                  if (qe[xt.focused] = !qe.hidden && !!(Me != null && Me.isEqualTo(wt)), qe[Zn.selected] = (Q == null ? void 0 : Q(Xt)) || qe.selected, z3(pe)) {
                    const { from: _e, to: H1 } = pe;
                    qe[Zn.range_start] = !!(_e && H1 && a.isSameDay(Xt, _e)), qe[Zn.range_end] = !!(_e && H1 && a.isSameDay(Xt, H1)), qe[Zn.range_middle] = k2(pe, Xt, !0, a);
                  }
                  const Ur = XD(qe, F, t.modifiersStyles), P1 = dD(qe, d, t.modifiersClassNames), L2 = !On && !qe.hidden ? Be(Xt, qe, a.options, a) : void 0;
                  return o.createElement(n.Day, { key: `${a.format(Xt, "yyyy-MM-dd")}_${a.format(wt.displayMonth, "yyyy-MM")}`, day: wt, modifiers: qe, className: P1.join(" "), style: Ur, role: "gridcell", "aria-selected": qe.selected || void 0, "aria-label": L2, "data-day": a.format(Xt, "yyyy-MM-dd"), "data-month": wt.outside ? a.format(Xt, "yyyy-MM") : void 0, "data-selected": qe.selected || void 0, "data-disabled": qe.disabled || void 0, "data-hidden": qe.hidden || void 0, "data-outside": wt.outside || void 0, "data-focused": qe.focused || void 0, "data-today": qe.today || void 0 }, !qe.hidden && On ? o.createElement(n.DayButton, { className: d[Se.DayButton], style: F == null ? void 0 : F[Se.DayButton], type: "button", day: wt, modifiers: qe, disabled: qe.disabled || void 0, tabIndex: Le(wt) ? 0 : -1, "aria-label": ye(Xt, qe, a.options, a), onClick: Xn(wt, qe), onBlur: En(wt, qe), onFocus: Gr(wt, qe), onKeyDown: Nn(wt, qe), onMouseEnter: Jn(wt, qe), onMouseLeave: T2(wt, qe) }, P(Xt, a.options, a)) : !qe.hidden && P(wt.date, a.options, a));
                })
              )))
            )
          );
        })
      ),
      t.footer && o.createElement(n.Footer, { className: d[Se.Footer], style: F == null ? void 0 : F[Se.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
const Yl = ({ seamless: e, showOutsideDays: t, ...n }) => /* @__PURE__ */ u(
  HR,
  {
    showOutsideDays: !1,
    fixedWeeks: !0,
    className: S("p-3", {
      "bg-calendar-background border-calendar-border rounded-lg border": !e
    }),
    classNames: {
      months: "flex flex-col sm:flex-row relative gap-16",
      month: "space-y-4",
      month_caption: "flex justify-center pt-1 items-center",
      caption_label: "text-sm font-medium",
      nav: "space-x-1 flex items-center h-7 z-10 absolute inset-x-0 inset-y-0",
      button_previous: S(
        Hr({ variant: "ghost" }),
        "focus-visible:ring-ring focus-visible:outline-hidden focus-visible:ring-2",
        "h-7 w-7 bg-transparent p-0 absolute left-1"
      ),
      button_next: S(
        Hr({ variant: "ghost" }),
        "focus-visible:ring-ring focus-visible:outline-hidden focus-visible:ring-2",
        "h-7 w-7 bg-transparent p-0 absolute right-1"
      ),
      month_grid: "w-full border-collapse space-y-1",
      weekdays: "flex",
      weekday: "text-calendar-disabled-text rounded-md w-8 font-normal text-[0.8rem]",
      week: "flex w-full mt-2",
      day: "h-8 w-8 text-center text-sm p-0 relative focus-within:relative focus-within:z-20",
      day_button: S(
        "inline-flex w-fit items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none",
        "focus-visible:ring-ring focus-visible:outline-hidden focus-visible:ring-2",
        "h-8 w-8 p-0 font-normal hover:bg-calendar-hover-background hover:text-calendar-hover-text"
      ),
      range_start: "rounded-l-md rounded-none",
      range_end: "rounded-r-md rounded-none",
      range_middle: "!rounded-none !bg-calendar-hover-background !text-calendar-hover-text",
      selected: S(
        "inline-flex w-fit items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none",
        "focus-visible:ring-ring focus-visible:outline-hidden focus-visible:ring-2",
        "h-8 w-8 p-0 font-normal hover:bg-calendar-hover-background hover:text-calendar-hover-text",
        "bg-calendar-selected-background text-calendar-selected-text"
      ),
      today: "text-calendar-default-today",
      outside: "day-outside text-calendar-disabled-text aria-selected:bg-calendar-selected-background ",
      disabled: "text-calendar-disabled-text",
      hidden: "invisible"
    },
    components: {
      Chevron: (r) => r.orientation === "left" ? /* @__PURE__ */ u(Re, { name: "ChevronLeft" }) : /* @__PURE__ */ u(Re, { name: "ChevronRight" })
    },
    ...n
  }
);
Yl.displayName = "Calendar";
const OR = Ye(
  "card relative flex w-full flex-col overflow-hidden border shadow-xs focus-visible:ring-ring focus-visible:outline-hidden focus-visible:ring-2",
  {
    variants: {
      variant: {
        default: "bg-card-background text-card-text border-card-border",
        muted: "bg-card-muted-background text-card-muted-text border-card-muted-border"
      },
      state: {
        default: "",
        selected: "border-border-primary"
      }
    },
    defaultVariants: {
      variant: "default",
      state: "default"
    }
  }
), r9 = W(
  ({ prefix: e, href: t, target: n, rel: r, onClick: i, children: a, state: c, variant: d, ...f }, p) => {
    const m = t ? "a" : "button";
    return /* @__PURE__ */ V("div", { ref: p, className: S(OR({ variant: d, state: c })), ...f, children: [
      e,
      /* @__PURE__ */ u(
        "div",
        {
          ref: p,
          className: S("flex flex-col gap-16 p-4", {
            // Ensure nested buttons in content are clickable although the card is area-clickable
            "[&_button]:relative [&_button]:z-10": t || i
          }),
          children: a
        }
      ),
      t || i ? /* @__PURE__ */ u(
        m,
        {
          className: S("absolute inset-0 z-0"),
          href: t,
          target: n,
          rel: r,
          onClick: () => i == null ? void 0 : i()
        }
      ) : null
    ] });
  }
);
r9.displayName = "Card";
const NR = W(({ children: e }, t) => /* @__PURE__ */ u("div", { ref: t, className: S("flex flex-col gap-4"), children: e }));
NR.displayName = "CardHeader";
const BR = W(({ children: e }, t) => /* @__PURE__ */ u("h3", { ref: t, className: S("text-md leading-none font-semibold tracking-tight"), children: e }));
BR.displayName = "CardTitle";
const IR = W(({ children: e }, t) => /* @__PURE__ */ u("p", { ref: t, className: S("text-card-description text-sm"), children: e }));
IR.displayName = "CardDescription";
const TR = W(({ children: e }, t) => /* @__PURE__ */ u("div", { ref: t, children: e }));
TR.displayName = "CardContent";
const VR = W(({ children: e }, t) => /* @__PURE__ */ u("div", { ref: t, className: S("flex items-center justify-end gap-8"), children: e }));
VR.displayName = "CardFooter";
function i9(e) {
  const t = M.useRef({ value: e, previous: e });
  return M.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var ql = "Checkbox", [ZR, cX] = Tt(ql), [$R, A3] = ZR(ql);
function WR(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: r,
    defaultChecked: i,
    disabled: a,
    form: c,
    name: d,
    onCheckedChange: f,
    required: p,
    value: m = "on",
    // @ts-expect-error
    internal_do_not_use_render: v
  } = e, [g, w] = Kt({
    prop: n,
    defaultProp: i ?? !1,
    onChange: f,
    caller: ql
  }), [x, b] = M.useState(null), [y, E] = M.useState(null), z = M.useRef(!1), k = x ? !!c || !!x.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), R = {
    checked: g,
    disabled: a,
    setChecked: w,
    control: x,
    setControl: b,
    name: d,
    form: c,
    value: m,
    hasConsumerStoppedPropagationRef: z,
    required: p,
    defaultChecked: or(i) ? !1 : i,
    isFormControl: k,
    bubbleInput: y,
    setBubbleInput: E
  };
  return /* @__PURE__ */ u(
    $R,
    {
      scope: t,
      ...R,
      children: GR(v) ? v(R) : r
    }
  );
}
var l9 = "CheckboxTrigger", o9 = M.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: n, ...r }, i) => {
    const {
      control: a,
      value: c,
      disabled: d,
      checked: f,
      required: p,
      setControl: m,
      setChecked: v,
      hasConsumerStoppedPropagationRef: g,
      isFormControl: w,
      bubbleInput: x
    } = A3(l9, e), b = ct(i, m), y = M.useRef(f);
    return M.useEffect(() => {
      const E = a == null ? void 0 : a.form;
      if (E) {
        const z = () => v(y.current);
        return E.addEventListener("reset", z), () => E.removeEventListener("reset", z);
      }
    }, [a, v]), /* @__PURE__ */ u(
      ke.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": or(f) ? "mixed" : f,
        "aria-required": p,
        "data-state": f9(f),
        "data-disabled": d ? "" : void 0,
        disabled: d,
        value: c,
        ...r,
        ref: b,
        onKeyDown: be(t, (E) => {
          E.key === "Enter" && E.preventDefault();
        }),
        onClick: be(n, (E) => {
          v((z) => or(z) ? !0 : !z), x && w && (g.current = E.isPropagationStopped(), g.current || E.stopPropagation());
        })
      }
    );
  }
);
o9.displayName = l9;
var a9 = M.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: i,
      defaultChecked: a,
      required: c,
      disabled: d,
      value: f,
      onCheckedChange: p,
      form: m,
      ...v
    } = e;
    return /* @__PURE__ */ u(
      WR,
      {
        __scopeCheckbox: n,
        checked: i,
        defaultChecked: a,
        disabled: d,
        required: c,
        onCheckedChange: p,
        name: r,
        form: m,
        value: f,
        internal_do_not_use_render: ({ isFormControl: g }) => /* @__PURE__ */ V(me, { children: [
          /* @__PURE__ */ u(
            o9,
            {
              ...v,
              ref: t,
              __scopeCheckbox: n
            }
          ),
          g && /* @__PURE__ */ u(
            u9,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
a9.displayName = ql;
var s9 = "CheckboxIndicator", c9 = M.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...i } = e, a = A3(s9, n);
    return /* @__PURE__ */ u(
      Yt,
      {
        present: r || or(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ u(
          ke.span,
          {
            "data-state": f9(a.checked),
            "data-disabled": a.disabled ? "" : void 0,
            ...i,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
c9.displayName = s9;
var d9 = "CheckboxBubbleInput", u9 = M.forwardRef(
  ({ __scopeCheckbox: e, ...t }, n) => {
    const {
      control: r,
      hasConsumerStoppedPropagationRef: i,
      checked: a,
      defaultChecked: c,
      required: d,
      disabled: f,
      name: p,
      value: m,
      form: v,
      bubbleInput: g,
      setBubbleInput: w
    } = A3(d9, e), x = ct(n, w), b = i9(a), y = a3(r);
    M.useEffect(() => {
      const z = g;
      if (!z) return;
      const k = window.HTMLInputElement.prototype, F = Object.getOwnPropertyDescriptor(
        k,
        "checked"
      ).set, _ = !i.current;
      if (b !== a && F) {
        const P = new Event("click", { bubbles: _ });
        z.indeterminate = or(a), F.call(z, or(a) ? !1 : a), z.dispatchEvent(P);
      }
    }, [g, b, a, i]);
    const E = M.useRef(or(a) ? !1 : a);
    return /* @__PURE__ */ u(
      ke.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: c ?? E.current,
        required: d,
        disabled: f,
        name: p,
        value: m,
        form: v,
        ...t,
        tabIndex: -1,
        ref: x,
        style: {
          ...t.style,
          ...y,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
u9.displayName = d9;
function GR(e) {
  return typeof e == "function";
}
function or(e) {
  return e === "indeterminate";
}
function f9(e) {
  return or(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const UR = Ye(
  S(
    "ring-offset-background group peer h-4 w-4 shrink-0 rounded-xs border flex items-center justify-center border-checkbox-unchecked-default-shape transition-all cursor-pointer"
  ),
  {
    variants: {
      /** Size of the checkbox */
      size: {
        sm: "w-4 h-4 rounded-xs",
        lg: "w-6 h-6 rounded-md"
      },
      /**
       * The feedback state of the checkbox
       */
      state: {
        negative: "border-checkbox-unchecked-negative-shape"
      }
    },
    defaultVariants: {
      size: "sm"
    }
  }
), jR = Ye(
  S(
    "text-checkbox-unchecked-default-text text-sm font-medium",
    "peer-disabled:text-checkbox-unchecked-disabled-text",
    "peer-data-[state=checked]:text-checkbox-checked-default-text",
    "peer-data-[state=indeterminate]:text-checkbox-checked-default-text"
  ),
  {
    variants: {
      state: {
        negative: S(
          "text-checkbox-unchecked-negative-label",
          "peer-data-[state=checked]:text-checkbox-checked-negative-label",
          "peer-data-[state=indeterminate]:text-checkbox-checked-negative-label"
        )
      }
    }
  }
), Rr = W(
  ({ size: e, state: t, children: n, alignTop: r, ...i }, a) => /* @__PURE__ */ V("div", { className: S("flex flex-col gap-12"), children: [
    /* @__PURE__ */ V(
      "label",
      {
        htmlFor: i.id,
        className: S("flex items-center gap-8", {
          "items-start": r
        }),
        children: [
          /* @__PURE__ */ u(
            a9,
            {
              checked: i.checked,
              disabled: i.disabled,
              required: i.required,
              ref: a,
              className: S(
                UR({ size: e, state: t }),
                "[&:not(:disabled)]:data-[state=checked]:bg-checkbox-checked-default-shape [&:not(:disabled)]:data-[state=checked]:border-checkbox-checked-default-shape [&:not(:disabled)]:data-[state=checked]:text-base-white",
                "[&:not(:disabled)]:data-[state=indeterminate]:bg-checkbox-checked-default-shape [&:not(:disabled)]:data-[state=indeterminate]:border-checkbox-checked-default-shape data-[state=indeterminate]:text-base-white",
                "disabled:border-checkbox-unchecked-disabled-shape disabled:cursor-not-allowed",
                "disabled:data-[state=checked]:bg-checkbox-checked-disabled-shape disabled:data-[state=checked]:border-checkbox-checked-disabled-shape disabled:data-[state=checked]:text-base-white",
                "disabled:data-[state=indeterminate]:bg-checkbox-checked-disabled-shape disabled:data-[state=indeterminate]:border-checkbox-checked-disabled-shape disabled:text-base-white",
                "focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden"
              ),
              onCheckedChange: i.onCheckedChange,
              ...i,
              children: /* @__PURE__ */ V(c9, { className: S("flex items-center justify-center text-current"), children: [
                /* @__PURE__ */ u("span", { className: "hidden group-data-[state=checked]:flex", children: /* @__PURE__ */ u(Re, { name: "Check", size: "xs" }) }),
                /* @__PURE__ */ u("span", { className: "hidden group-data-[state=indeterminate]:flex", children: /* @__PURE__ */ u(Re, { name: "Minus", size: "xs" }) })
              ] })
            }
          ),
          /* @__PURE__ */ V(
            "span",
            {
              className: S(jR({ state: t }), {
                "text-checkbox-unchecked-disabled-text": i.disabled,
                "peer-data-[state=checked]:text-checkbox-checked-default-text": i.disabled,
                "peer-data-[state=indeterminate]:text-checkbox-checked-default-text": i.disabled
              }),
              children: [
                i.required ? /* @__PURE__ */ u("span", { className: S("text-label-required mr-1"), "aria-hidden": "true", children: "*" }) : null,
                i.label
              ]
            }
          )
        ]
      }
    ),
    n ? /* @__PURE__ */ u("div", { className: S("pl-6 text-sm"), children: n }) : null
  ] })
);
Rr.displayName = "Checkbox";
const KR = Ye("w-fit py-1 px-2 border rounded-full text-xs whitespace-nowrap", {
  variants: {
    variant: {
      primary: "bg-chip-primary-background text-chip-primary-text border-chip-primary-border",
      positive: "bg-chip-positive-background text-chip-positive-text border-chip-positive-border",
      warning: "bg-chip-warning-background text-chip-warning-text border-chip-warning-border",
      negative: "bg-chip-negative-background text-chip-negative-text border-chip-negative-border",
      neutral: "bg-chip-neutral-background text-chip-neutral-text border-chip-neutral-border",
      muted: "bg-chip-muted-background text-chip-muted-text border-chip-muted-border"
    }
  },
  defaultVariants: {
    variant: "primary"
  }
}), YR = W(
  ({ children: e, variant: t, ...n }, r) => {
    const i = n.onClick ? "button" : "div";
    return /* @__PURE__ */ u(
      i,
      {
        ref: r,
        className: S(KR({ variant: t }), {
          "cursor-pointer": n.onClick
        }),
        ...n,
        children: e
      }
    );
  }
);
YR.displayName = "Chip";
var h9 = "Toggle", S3 = M.forwardRef((e, t) => {
  const { pressed: n, defaultPressed: r, onPressedChange: i, ...a } = e, [c, d] = Kt({
    prop: n,
    onChange: i,
    defaultProp: r ?? !1,
    caller: h9
  });
  return /* @__PURE__ */ u(
    ke.button,
    {
      type: "button",
      "aria-pressed": c,
      "data-state": c ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...a,
      ref: t,
      onClick: be(e.onClick, () => {
        e.disabled || d(!c);
      })
    }
  );
});
S3.displayName = h9;
var qR = S3, mr = "ToggleGroup", [p9, dX] = Tt(mr, [
  k1
]), m9 = k1(), k3 = o.forwardRef((e, t) => {
  const { type: n, ...r } = e;
  if (n === "single")
    return /* @__PURE__ */ u(XR, { ...r, ref: t });
  if (n === "multiple")
    return /* @__PURE__ */ u(JR, { ...r, ref: t });
  throw new Error(`Missing prop \`type\` expected on \`${mr}\``);
});
k3.displayName = mr;
var [v9, g9] = p9(mr), XR = o.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: i = () => {
    },
    ...a
  } = e, [c, d] = Kt({
    prop: n,
    defaultProp: r ?? "",
    onChange: i,
    caller: mr
  });
  return /* @__PURE__ */ u(
    v9,
    {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: o.useMemo(() => c ? [c] : [], [c]),
      onItemActivate: d,
      onItemDeactivate: o.useCallback(() => d(""), [d]),
      children: /* @__PURE__ */ u(L9, { ...a, ref: t })
    }
  );
}), JR = o.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: i = () => {
    },
    ...a
  } = e, [c, d] = Kt({
    prop: n,
    defaultProp: r ?? [],
    onChange: i,
    caller: mr
  }), f = o.useCallback(
    (m) => d((v = []) => [...v, m]),
    [d]
  ), p = o.useCallback(
    (m) => d((v = []) => v.filter((g) => g !== m)),
    [d]
  );
  return /* @__PURE__ */ u(
    v9,
    {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: c,
      onItemActivate: f,
      onItemDeactivate: p,
      children: /* @__PURE__ */ u(L9, { ...a, ref: t })
    }
  );
});
k3.displayName = mr;
var [QR, e_] = p9(mr), L9 = o.forwardRef(
  (e, t) => {
    const {
      __scopeToggleGroup: n,
      disabled: r = !1,
      rovingFocus: i = !0,
      orientation: a,
      dir: c,
      loop: d = !0,
      ...f
    } = e, p = m9(n), m = Fi(c), v = { role: "group", dir: m, ...f };
    return /* @__PURE__ */ u(QR, { scope: n, rovingFocus: i, disabled: r, children: i ? /* @__PURE__ */ u(
      f3,
      {
        asChild: !0,
        ...p,
        orientation: a,
        dir: m,
        loop: d,
        children: /* @__PURE__ */ u(ke.div, { ...v, ref: t })
      }
    ) : /* @__PURE__ */ u(ke.div, { ...v, ref: t }) });
  }
), ol = "ToggleGroupItem", w9 = o.forwardRef(
  (e, t) => {
    const n = g9(ol, e.__scopeToggleGroup), r = e_(ol, e.__scopeToggleGroup), i = m9(e.__scopeToggleGroup), a = n.value.includes(e.value), c = r.disabled || e.disabled, d = { ...e, pressed: a, disabled: c }, f = o.useRef(null);
    return r.rovingFocus ? /* @__PURE__ */ u(
      h3,
      {
        asChild: !0,
        ...i,
        focusable: !c,
        active: a,
        ref: f,
        children: /* @__PURE__ */ u(Sd, { ...d, ref: t })
      }
    ) : /* @__PURE__ */ u(Sd, { ...d, ref: t });
  }
);
w9.displayName = ol;
var Sd = o.forwardRef(
  (e, t) => {
    const { __scopeToggleGroup: n, value: r, ...i } = e, a = g9(ol, n), c = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, d = a.type === "single" ? c : void 0;
    return /* @__PURE__ */ u(
      S3,
      {
        ...d,
        ...i,
        ref: t,
        onPressedChange: (f) => {
          f ? a.onItemActivate(r) : a.onItemDeactivate(r);
        }
      }
    );
  }
), M9 = k3, x9 = w9, t_ = "Label", b9 = M.forwardRef((e, t) => /* @__PURE__ */ u(
  ke.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var i;
      n.target.closest("button, input, select, textarea") || ((i = e.onMouseDown) == null || i.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
b9.displayName = t_;
var n_ = b9;
const jn = W(
  ({ className: e, required: t, optional: n, children: r, ...i }, a) => /* @__PURE__ */ V(
    n_,
    {
      ref: a,
      className: S("color-label-text relative text-xs", "peer-disabled:cursor-not-allowed peer-disabled:opacity-70"),
      ...i,
      children: [
        t ? /* @__PURE__ */ u("span", { className: S("text-label-required mr-1"), "aria-hidden": "true", children: "*" }) : null,
        r,
        n ? /* @__PURE__ */ u("span", { className: S("text-label-optional ml-1"), children: "(optional)" }) : null
      ]
    }
  )
);
jn.displayName = "Label";
const y9 = ({ size: e = "full", ...t }) => /* @__PURE__ */ u("div", { className: S("text-brand-logo block grow-0 self-start"), ...t, children: e === "full" ? /* @__PURE__ */ u("svg", { width: "78", height: "19", fill: "none", children: /* @__PURE__ */ u(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 9.36a9.36 9.36 0 1 1 18.72 0A9.36 9.36 0 0 1 0 9.36Zm16.25 0a6.89 6.89 0 1 0-13.78 0 6.89 6.89 0 0 0 13.78 0Zm-11.57 0a4.68 4.68 0 1 1 9.36 0 4.68 4.68 0 0 1-9.36 0Zm6.89 0a2.21 2.21 0 1 0-4.42 0 2.21 2.21 0 0 0 4.42 0Zm15.188-5.55a1.604 1.604 0 0 1 1.18-.483h2.057V.255h-2.057c-1.506 0-2.725.427-3.656 1.282-.922.847-1.384 2.04-1.384 3.58V18.46h3.352l.025-10.042h3.72V5.46h-3.72v-.495c0-.449.161-.834.483-1.155Zm11.07 1.447c-1.854 0-3.437.66-4.748 1.98-1.303 1.312-1.955 2.886-1.955 4.723 0 1.837.652 3.415 1.955 4.735 1.312 1.312 2.894 1.968 4.748 1.968 1.853 0 3.432-.656 4.735-1.968 1.312-1.32 1.968-2.898 1.968-4.735 0-1.837-.656-3.41-1.968-4.723-1.303-1.32-2.882-1.98-4.735-1.98Zm2.336 4.392c-.635-.643-1.414-.964-2.336-.964-.922 0-1.701.321-2.336.964-.626.644-.94 1.423-.94 2.336 0 .914.318 1.689.953 2.323.643.636 1.421.953 2.335.953a3.12 3.12 0 0 0 2.324-.978c.643-.651.965-1.426.965-2.323s-.322-1.667-.965-2.31Zm13.71-.964V5.46h-1.827c-1.11 0-2.01.288-2.704.863V5.46h-2.704v13h3.389v-7.643c0-.609.216-1.117.647-1.523.433-.407.961-.61 1.588-.61h1.612Zm9.142 6.373v3.402h-2.374c-1.54 0-2.751-.432-3.631-1.295-.872-.871-1.308-2.128-1.308-3.77V1.32h3.44V5.46h3.974v2.958h-3.973v5.002c0 .465.148.855.444 1.168.304.313.685.47 1.142.47h2.286Zm8.074-9.8c-1.854 0-3.437.659-4.748 1.98-1.304 1.311-1.956 2.885-1.956 4.722 0 1.837.652 3.415 1.956 4.735 1.311 1.312 2.894 1.968 4.748 1.968 1.853 0 3.432-.656 4.735-1.968 1.312-1.32 1.968-2.898 1.968-4.735 0-1.837-.656-3.41-1.968-4.723-1.303-1.32-2.882-1.98-4.735-1.98Zm2.335 4.391c-.634-.643-1.413-.964-2.335-.964-.923 0-1.701.321-2.336.964-.627.644-.94 1.423-.94 2.336 0 .914.318 1.689.953 2.323.643.636 1.421.953 2.335.953.915 0 1.689-.326 2.323-.978.644-.651.966-1.426.966-2.323s-.322-1.667-.966-2.31Z",
    clipRule: "evenodd"
  }
) }) : /* @__PURE__ */ u("svg", { width: "19", height: "19", children: /* @__PURE__ */ u(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 9.36a9.36 9.36 0 1 1 18.72 0A9.36 9.36 0 0 1 0 9.36Zm16.25 0a6.89 6.89 0 1 0-13.78 0 6.89 6.89 0 0 0 13.78 0Zm-11.57 0a4.68 4.68 0 1 1 9.36 0 4.68 4.68 0 0 1-9.36 0Zm6.89 0a2.21 2.21 0 1 0-4.42 0 2.21 2.21 0 0 0 4.42 0Z"
  }
) }) });
y9.displayName = "Logo";
const r_ = ({ suffix: e, ...t }) => /* @__PURE__ */ V("div", { className: "flex items-center gap-8", ...t, children: [
  /* @__PURE__ */ u("div", { className: S("flex"), children: /* @__PURE__ */ u(y9, {}) }),
  /* @__PURE__ */ u("div", { className: "align-center flex h-5 justify-center", children: /* @__PURE__ */ u(eo, { orientation: "vertical" }) }),
  /* @__PURE__ */ u("div", { className: S("flex [&_img]:block [&_img]:h-5"), children: e })
] });
r_.displayName = "Brand";
const i_ = "data:image/svg+xml,%3csvg%20viewBox='0%200%20313%20480'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M208.256%20480a.579.579%200%200%201-.261-.069l-103.686-59.825a.52.52%200%200%201%20.516-.902l103.686%2059.826a.52.52%200%200%201-.255.97ZM215.354%20475.899a.594.594%200%200%201-.262-.068l-110.788-63.925a.52.52%200%200%201-.193-.709.525.525%200%200%201%20.709-.192l110.789%2063.924a.52.52%200%200%201-.255.97ZM223.01%20471.48a.597.597%200%200%201-.262-.068l-118.444-68.341a.52.52%200%200%201-.193-.709.525.525%200%200%201%20.709-.192l118.445%2068.34a.52.52%200%200%201-.255.97ZM230.33%20467.258a.59.59%200%200%201-.261-.068l-125.765-72.57a.52.52%200%201%201%20.516-.902l125.765%2072.57a.52.52%200%200%201-.255.97ZM237.763%20462.961a.59.59%200%200%201-.262-.068l-133.197-76.862a.52.52%200%200%201-.193-.709.525.525%200%200%201%20.709-.192l133.198%2076.861a.52.52%200%200%201-.255.97ZM245.088%20458.73a.59.59%200%200%201-.261-.068l-140.518-81.091a.52.52%200%200%201-.193-.709.526.526%200%200%201%20.709-.192l140.518%2081.09a.52.52%200%200%201-.255.97ZM252.409%20454.508a.582.582%200%200%201-.262-.069l-147.838-85.313a.52.52%200%201%201%20.516-.902l147.839%2085.314a.52.52%200%200%201-.255.97ZM259.953%20450.154a.579.579%200%200%201-.261-.069l-155.383-89.673a.52.52%200%201%201%20.516-.902l155.383%2089.674a.52.52%200%200%201-.255.97ZM267.273%20445.924a.59.59%200%200%201-.261-.068l-162.703-93.897a.52.52%200%201%201%20.516-.902l162.703%2093.897a.52.52%200%200%201-.255.97ZM274.595%20441.7a.59.59%200%200%201-.261-.068l-170.03-98.126a.52.52%200%201%201%20.516-.902l170.03%2098.126a.52.52%200%200%201-.255.97ZM282.139%20437.341a.59.59%200%200%201-.261-.068l-177.574-102.48a.52.52%200%201%201%20.516-.902l177.574%20102.48a.52.52%200%200%201-.255.97ZM289.241%20433.239a.577.577%200%200%201-.261-.068L104.309%20326.593a.52.52%200%201%201%20.516-.902l184.671%20106.578a.52.52%200%200%201-.255.97ZM296.78%20428.886a.597.597%200%200%201-.262-.068L104.304%20317.886a.52.52%200%201%201%20.516-.902l192.215%20110.932a.52.52%200%200%201-.255.97ZM304.105%20424.66a.59.59%200%200%201-.261-.068L104.309%20309.431a.52.52%200%201%201%20.516-.902L304.361%20423.69a.52.52%200%200%201-.256.97ZM311.751%20420.248a.579.579%200%200%201-.261-.069L104.262%20300.64a.52.52%200%201%201%20.516-.902l207.228%20119.54a.52.52%200%200%201-.255.97ZM311.848%20411.962a.579.579%200%200%201-.261-.069L111.536%20296.434a.52.52%200%201%201%20.516-.902l200.051%20115.459a.52.52%200%200%201-.255.971ZM311.848%20403.257a.59.59%200%200%201-.261-.068l-192.514-111.1a.52.52%200%200%201%20.517-.902l192.513%20111.1a.52.52%200%200%201-.255.97ZM311.85%20394.805a.59.59%200%200%201-.261-.068L126.402%20287.86a.52.52%200%201%201%20.516-.901l185.187%20106.876a.52.52%200%200%201-.255.97ZM311.852%20386.346a.582.582%200%200%201-.262-.069L133.724%20283.63a.52.52%200%201%201%20.516-.902l177.867%20102.648a.519.519%200%200%201-.255.97ZM311.851%20377.893a.579.579%200%200%201-.261-.069l-170.546-98.418a.52.52%200%201%201%20.516-.902l170.546%2098.418a.52.52%200%200%201-.255.971ZM311.85%20369.44a.59.59%200%200%201-.261-.068l-163.225-94.195a.52.52%200%201%201%20.516-.902l163.225%2094.195a.52.52%200%200%201-.255.97ZM311.851%20360.73a.579.579%200%200%201-.261-.069l-155.681-89.835a.52.52%200%200%201-.193-.709.525.525%200%200%201%20.709-.192l155.681%2089.835a.52.52%200%200%201-.255.97ZM311.85%20352.014a.579.579%200%200%201-.261-.069l-148.137-85.481a.52.52%200%201%201%20.517-.902l148.136%2085.482a.52.52%200%200%201-.255.97ZM311.85%20343.554a.594.594%200%200%201-.262-.068l-140.804-81.253a.52.52%200%201%201%20.517-.901l140.804%2081.252a.519.519%200%200%201-.255.97ZM311.848%20335.095a.59.59%200%200%201-.261-.068l-133.483-77.023a.52.52%200%201%201%20.516-.902l133.483%2077.023a.52.52%200%200%201-.255.97ZM311.848%20326.641a.59.59%200%200%201-.261-.068L185.423%20253.78a.521.521%200%200%201-.192-.71.525.525%200%200%201%20.709-.192l126.163%2072.793a.52.52%200%200%201-.255.97ZM311.851%20318.182a.59.59%200%200%201-.261-.068l-118.837-68.571a.52.52%200%201%201%20.516-.902l118.837%2068.571a.52.52%200%200%201-.255.97ZM311.851%20309.729a.579.579%200%200%201-.261-.069l-111.516-64.341a.52.52%200%201%201%20.516-.901l111.516%2064.341a.52.52%200%200%201-.255.97ZM311.851%20301.02a.577.577%200%200%201-.261-.068l-103.972-59.981a.52.52%200%200%201%20.516-.902l103.972%2059.981a.52.52%200%200%201-.255.97Z'%20fill='%230226F4'/%3e%3cpath%20d='m104.829%20420-43.571-25.159a121.61%20121.61%200%200%201-44.467-44.466A121.678%20121.678%200%200%201%20.517%20289.633v-50.299l.772.445%20103.391%2059.777.142%20120.438.007.006ZM1.549%20241.12v48.507c0%2021.112%205.579%2041.94%2016.138%2060.229a120.617%20120.617%200%200%200%2044.09%2044.09l42.02%2024.263-.142-118.054-102.1-59.035h-.007Z'%20fill='%230226F4'/%3e%3cpath%20d='m103.798%20419.995-.142-120.439%20104.454-60.228v120.438l-.259.149-104.053%2060.08Zm.89-119.845.142%20118.053%20102.248-59.036V241.114l-102.39%2059.036Z'%20fill='%230226F4'/%3e%3cpath%20d='M104.17%20300.457%200%20240.228%20104.312%20180l.26.148%20104.052%2060.08-104.454%2060.229ZM2.07%20240.228l102.106%2059.036%20102.391-59.036-102.243-59.036L2.076%20240.228H2.07Z'%20fill='%230226F4'/%3e%3cpath%20d='m311.621%2059.933-103.666%2059.933L104%2059.933%20207.807%200l103.814%2059.933Z'%20fill='%2300DF9D'/%3e%3cpath%20d='M207.955%20120.134%20207.807%20240%20104%20180.067V60.201l103.955%2059.933Z'%20fill='%230226F4'/%3e%3c/svg%3e", l_ = "data:image/svg+xml,%3csvg%20width='517'%20height='744'%20viewBox='0%200%20517%20744'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_81_14352)'%3e%3cpath%20d='M517%20140L378%20220.032'%20stroke='%2300DC91'%20stroke-width='0.994409'%20stroke-miterlimit='10'%20stroke-linecap='round'/%3e%3cpath%20d='M216%20283.267L404.577%20389.702C409.171%20392.3%20409.133%20398.839%20404.508%20401.384L314.963%20450.56'%20stroke='%2300DC91'%20stroke-miterlimit='10'%20stroke-linecap='round'/%3e%3cpath%20d='M313%20432.462L333%20443.331L352%20432.462L332.505%20420.605L313%20432.462Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M313%20432.462V454.199L333%20465.068L332.971%20443.331L313%20432.462Z'%20fill='%233A56F6'/%3e%3cpath%20d='M333%20443.331L333.028%20465.068L352%20454.199V432.462L333%20443.331Z'%20fill='%237286F9'/%3e%3cpath%20d='M343%20448.271L517%20546.133'%20stroke='%2300DC91'%20stroke-miterlimit='10'%20stroke-linecap='round'/%3e%3cpath%20d='M322%20450.247L91%20583.634'%20stroke='%2300DC91'%20stroke-miterlimit='10'%20stroke-linecap='round'/%3e%3cg%20style='mix-blend-mode:multiply'%20opacity='0.3'%3e%3cpath%20d='M313%20467.044L332.476%20477.912L352%20467.044L332.505%20456.175L313%20467.044Z'%20fill='%23ABB7FB'/%3e%3c/g%3e%3cpath%20d='M13.4535%20711.957L13.4531%20650.789C13.4933%20645.522%2016.3982%20640.68%2021.0566%20638.111L92.9009%20598.454'%20stroke='%2300DC91'%20stroke-miterlimit='10'%20stroke-linecap='round'/%3e%3cpath%20d='M320.008%20215.3L320.01%20216.312L194.218%20288.091L194.216%20287.081L320.008%20215.3Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M197.791%20285.693L197.807%20290.699L196.913%20291.209L196.897%20286.203L197.791%20285.693Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M201.912%20283.342L201.926%20288.349L201.037%20288.856L201.021%20283.85L201.912%20283.342Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M206.033%20280.991L206.047%20285.998L205.155%20286.505L205.142%20281.499L206.033%20280.991Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M210.157%20278.638L210.17%20283.645L209.279%20284.152L209.266%20279.146L210.157%20278.638Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M214.276%20276.287L214.292%20281.294L213.4%20281.801L213.387%20276.795L214.276%20276.287Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M218.397%20273.937L218.413%20278.943L217.522%20279.451L217.506%20274.444L218.397%20273.937Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M222.521%20271.583L222.536%20276.59L221.645%20277.097L221.629%20272.091L222.521%20271.583Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M226.641%20269.233L226.655%20274.239L225.766%20274.747L225.75%20269.74L226.641%20269.233Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M230.762%20266.882L230.776%20271.888L229.884%20272.396L229.871%20267.389L230.762%20266.882Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M234.886%20264.528L234.899%20269.535L234.008%20270.042L233.995%20265.036L234.886%20264.528Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M239.005%20262.178L239.021%20267.184L238.13%20267.692L238.116%20262.685L239.005%20262.178Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M243.128%20259.824L243.144%20264.831L242.253%20265.338L242.24%20260.332L243.128%20259.824Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M247.249%20257.474L247.262%20262.477L246.374%20262.988L246.358%20257.981L247.249%20257.474Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M251.37%20255.12L251.384%20260.127L250.493%20260.637L250.479%20255.63L251.37%20255.12Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M255.494%20252.767L255.507%20257.774L254.616%20258.284L254.603%20253.277L255.494%20252.767Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M259.612%20250.417L259.628%20255.423L258.737%20255.93L258.724%20250.927L259.612%20250.417Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M263.734%20248.065L263.75%20253.072L262.858%20253.579L262.842%20248.573L263.734%20248.065Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M267.857%20245.712L267.873%20250.719L266.982%20251.226L266.966%20246.222L267.857%20245.712Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M271.978%20243.362L271.991%20248.368L271.103%20248.876L271.087%20243.869L271.978%20243.362Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M276.102%20241.008L276.115%20246.015L275.227%20246.522L275.211%20241.516L276.102%20241.008Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M280.223%20238.657L280.237%20243.664L279.345%20244.171L279.332%20239.165L280.223%20238.657Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M284.342%20236.307L284.358%20241.313L283.466%20241.821L283.453%20236.814L284.342%20236.307Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M288.465%20233.953L288.481%20238.96L287.59%20239.467L287.577%20234.461L288.465%20233.953Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M292.586%20231.603L292.6%20236.609L291.711%20237.116L291.695%20232.11L292.586%20231.603Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M296.707%20229.252L296.721%20234.258L295.829%20234.766L295.816%20229.759L296.707%20229.252Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M300.831%20226.898L300.844%20231.905L299.953%20232.412L299.94%20227.406L300.831%20226.898Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M304.95%20224.548L304.966%20229.554L304.074%20230.062L304.061%20225.055L304.95%20224.548Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M309.073%20222.194L309.089%20227.201L308.196%20227.711L308.18%20222.704L309.073%20222.194Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M313.194%20219.844L313.21%20224.85L312.319%20225.357L312.303%20220.351L313.194%20219.844Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M317.315%20217.493L317.329%20222.497L316.44%20223.007L316.424%20218L317.315%20217.493Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M170.165%20393.763L118.366%20364.011C117.626%20363.585%20117.089%20362.804%20116.849%20361.705C115.336%20354.671%20111.853%20349.591%20107.019%20346.814L158.818%20376.566C163.652%20379.343%20167.135%20384.423%20168.649%20391.457C168.885%20392.556%20169.423%20393.337%20170.165%20393.763Z'%20fill='%23566EF8'/%3e%3cpath%20d='M309.975%20226.625L195.232%20292.098C193.628%20293.013%20192.106%20293.144%20190.994%20292.508L242.793%20322.26C243.905%20322.899%20245.427%20322.768%20247.031%20321.85L361.775%20256.377L309.975%20226.625Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M177.564%20277.431C176.598%20276.876%20175.278%20276.989%20173.879%20277.788L85.2932%20328.337L137.093%20358.089L225.681%20307.538C227.08%20306.741%20228.4%20306.628%20229.365%20307.18L177.566%20277.428L177.564%20277.431Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M376.455%20233.212L324.655%20203.459L377.205%20173.473L429.004%20203.225L376.455%20233.212Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M376.452%20233.209C374.587%20234.277%20372.852%20236.335%20371.825%20238.691L366.563%20250.758C365.531%20253.132%20363.778%20255.207%20361.894%20256.282L310.095%20226.53C311.978%20225.455%20313.731%20223.38%20314.764%20221.006L320.026%20208.939C321.05%20206.583%20322.788%20204.527%20324.653%20203.457L376.452%20233.209Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M136.731%20375.609L84.9342%20345.857C83.7556%20345.179%2083.0372%20343.732%2083.0319%20341.723L83%20332.255C83%20330.814%2084.0243%20329.063%2085.2907%20328.337L137.09%20358.089C135.824%20358.815%20134.799%20360.566%20134.799%20362.007L134.831%20371.476C134.837%20373.485%20135.555%20374.931%20136.733%20375.609H136.731Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M430.803%20205.465L413.565%20255.485C413.233%20256.45%20412.541%20257.339%20411.78%20257.773L174.126%20393.384C171.484%20394.893%20169.215%20394.07%20168.648%20391.454C165.562%20377.118%20154.3%20370.902%20140.08%20375.748C137.031%20376.784%20134.836%20375.002%20134.823%20371.473L134.796%20362.01C134.791%20360.569%20135.821%20358.812%20137.09%20358.086L225.675%20307.535C227.415%20306.544%20229.035%20306.612%20229.999%20307.704L242.173%20321.561C243.285%20322.82%20245.153%20322.891%20247.148%20321.755L361.889%20256.277C363.772%20255.201%20365.525%20253.129%20366.56%20250.752L371.82%20238.683C372.844%20236.327%20374.582%20234.271%20376.449%20233.211L426.615%20204.584L428.999%20203.222C429.055%20203.194%20429.111%20203.165%20429.164%20203.138C429.228%20203.104%20429.297%20203.08%20429.355%20203.054H429.361C429.424%20203.028%20429.488%20203.012%20429.552%20202.996C429.611%20202.981%20429.672%20202.967%20429.73%20202.962C429.786%20202.954%20429.842%20202.949%20429.895%20202.949C429.933%20202.949%20429.975%20202.954%20430.018%20202.957C430.047%20202.957%20430.076%20202.962%20430.108%20202.97C430.137%20202.975%20430.167%20202.983%20430.199%20202.991C430.228%20202.999%20430.255%20203.007%20430.284%20203.02C430.31%20203.028%20430.34%20203.041%20430.364%20203.057C430.97%20203.357%20431.204%20204.274%20430.795%20205.463L430.803%20205.465Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M417.261%20244.931L413.605%20255.519C413.273%20256.49%20412.581%20257.373%20411.818%20257.807L174.169%20393.418C171.527%20394.925%20169.257%20394.112%20168.696%20391.491C168.388%20390.055%20167.996%20388.701%20167.528%20387.434L417.264%20244.931H417.261Z'%20fill='%233A56F6'/%3e%3cpath%20d='M408.817%20221.9C409.242%20221.658%20409.586%20221.855%20409.588%20222.339L409.594%20224.434C409.594%20224.918%20409.253%20225.507%20408.827%20225.752C408.402%20225.994%20408.053%20225.799%20408.053%20225.315L408.048%20223.22C408.048%20222.736%20408.391%20222.144%20408.819%20221.9H408.817Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M412.031%20220.064C412.456%20219.822%20412.799%20220.02%20412.802%20220.503L412.807%20222.599C412.807%20223.083%20412.467%20223.672%20412.041%20223.916C411.616%20224.158%20411.267%20223.964%20411.267%20223.48L411.262%20221.384C411.262%20220.9%20411.605%20220.309%20412.033%20220.064H412.031Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M415.244%20218.231C415.67%20217.989%20416.019%20218.184%20416.019%20218.668L416.024%20220.764C416.024%20221.247%20415.681%20221.839%20415.252%20222.084C414.827%20222.325%20414.478%20222.131%20414.478%20221.647L414.473%20219.551C414.473%20219.068%20414.816%20218.476%20415.244%20218.231Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M418.458%20216.399C418.884%20216.157%20419.233%20216.352%20419.233%20216.835L419.238%20218.931C419.238%20219.415%20418.895%20220.006%20418.466%20220.251C418.041%20220.493%20417.692%20220.298%20417.692%20219.815L417.687%20217.719C417.687%20217.235%20418.03%20216.643%20418.458%20216.399Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M430.42%20203.083C430.404%20203.076%20430.39%20203.068%20430.372%20203.062C430.345%20203.047%20430.316%20203.033%20430.292%20203.026C430.263%20203.012%20430.236%20203.005%20430.207%20202.997C430.178%20202.989%20430.148%20202.981%20430.116%20202.976C430.087%20202.968%20430.058%20202.962%20430.026%20202.962C429.983%20202.957%20429.941%20202.955%20429.904%20202.955C429.848%20202.955%20429.792%20202.96%20429.739%20202.968C429.68%20202.973%20429.619%20202.984%20429.56%20203.002C429.496%20203.018%20429.433%20203.036%20429.369%20203.06H429.363C429.305%20203.086%20429.236%20203.11%20429.172%20203.144C429.116%20203.17%20429.06%20203.199%20429.007%20203.228L426.623%20204.59L374.646%20174.93L377.173%20173.476L377.484%20173.3L377.532%20173.326C377.963%20173.158%20378.338%20173.171%20378.623%20173.334L430.422%20203.086L430.42%20203.083Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M154.271%20355.002C153.194%20355.618%20152.321%20357.106%20152.326%20358.329C152.329%20359.551%20153.207%20360.04%20154.285%20359.428C155.357%20358.815%20156.229%20357.327%20156.227%20356.104C156.224%20354.881%20155.346%20354.392%20154.271%20355.002Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M163.455%20349.762C162.378%20350.377%20161.51%20351.863%20161.513%20353.085C161.516%20354.308%20162.391%20354.8%20163.468%20354.187C164.546%20353.572%20165.413%20352.086%20165.411%20350.864C165.408%20349.641%20164.533%20349.149%20163.455%20349.762Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M172.641%20344.519C171.564%20345.134%20170.691%20346.622%20170.697%20347.845C170.699%20349.068%20171.577%20349.557%20172.655%20348.944C173.732%20348.329%20174.6%20346.843%20174.597%20345.62C174.594%20344.398%20173.719%20343.906%20172.641%20344.519Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M154.284%20360.043C152.909%20360.829%20151.789%20360.193%20151.783%20358.634C151.778%20357.074%20152.89%20355.171%20154.268%20354.387C155.641%20353.603%20156.761%20354.235%20156.764%20355.794C156.769%20357.353%20155.657%20359.262%20154.284%20360.043ZM154.268%20354.137C152.773%20354.989%20151.56%20357.064%20151.565%20358.762C151.571%20360.458%20152.792%20361.145%20154.287%20360.29C155.782%20359.436%20156.993%20357.366%20156.987%20355.668C156.982%20353.969%20155.761%20353.285%20154.268%20354.137Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M163.468%20354.802C162.096%20355.586%20160.975%20354.95%20160.973%20353.393C160.967%20351.834%20162.08%20349.93%20163.452%20349.147C164.825%20348.363%20165.948%20348.991%20165.953%20350.551C165.959%20352.11%20164.841%20354.019%20163.468%20354.802ZM163.452%20348.897C161.957%20349.749%20160.747%20351.821%20160.752%20353.519C160.757%20355.215%20161.976%20355.902%20163.471%20355.05C164.966%20354.198%20166.177%20352.126%20166.171%20350.427C166.166%20348.731%20164.948%20348.045%20163.452%20348.897Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M172.657%20349.562C171.282%20350.348%20170.162%20349.712%20170.157%20348.153C170.151%20346.593%20171.263%20344.69%20172.642%20343.906C174.014%20343.122%20175.134%20343.754%20175.137%20345.313C175.142%20346.872%20174.03%20348.781%20172.657%20349.562ZM172.639%20343.654C171.144%20344.506%20169.933%20346.578%20169.938%20348.276C169.944%20349.972%20171.162%20350.658%20172.657%20349.806C174.153%20348.955%20175.363%20346.883%20175.358%20345.184C175.353%20343.488%20174.131%20342.802%20172.639%20343.654Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M367.505%20248.641L363.762%20250.787L363.775%20254.865C363.491%20255.144%20363.19%20255.404%20362.884%20255.641L362.871%20251.297L359.641%20253.143L359.654%20257.584L358.763%20258.089L358.75%20253.653L355.522%20255.501L355.536%20259.929L354.642%20260.442L354.628%20256.009L351.399%20257.857L351.412%20262.28L350.521%20262.79L350.507%20258.367L347.278%20260.216L347.294%20264.631L346.402%20265.141L346.389%20260.726L343.154%20262.575L343.167%20266.987L342.276%20267.497L342.263%20263.085L339.036%20264.933L339.049%20269.335L338.158%20269.84L338.144%20265.441L334.914%20267.287L334.928%20271.686L334.036%20272.196L334.023%20267.797L330.788%20269.65L330.804%20274.036L329.913%20274.546L329.899%20270.161L326.67%20272.006L326.683%20276.392L325.792%20276.897L325.778%20272.517L322.549%20274.365L322.562%20278.743L321.676%20279.248L321.66%20274.875L318.43%20276.724L318.443%20281.091L317.552%20281.601L317.539%20277.234L314.309%20279.082L314.322%20283.447L313.437%20283.952L313.421%20279.592L310.191%20281.441L310.204%20285.798L309.313%20286.308L309.299%20281.951L306.07%20283.8L306.083%20288.146L305.197%20288.651L305.181%20284.307L301.954%20286.153L301.967%20290.497L301.076%20291.007L301.063%20286.663L297.828%20288.511L297.841%20292.85L296.955%20293.355L296.939%20289.019L293.712%20290.867L293.725%20295.198L292.834%20295.703L292.821%20291.378L289.591%20293.226L289.604%20297.549L288.713%20298.059L288.699%20293.736L285.47%20295.585L285.483%20299.9L284.592%20300.41L284.578%20296.095L281.349%20297.943L281.362%20302.253L280.471%20302.758L280.457%20298.453L277.228%20300.302L277.241%20304.604L276.35%20305.114L276.336%20300.812L273.106%20302.661L273.12%20306.954L272.229%20307.465L272.215%20303.168L268.985%20305.017L269.001%20309.305L268.11%20309.815L268.097%20305.527L264.862%20307.375L264.875%20311.659L263.984%20312.169L263.97%20307.885L260.741%20309.734L260.757%20314.009L259.865%20314.514L259.852%20310.241L256.622%20312.09L256.636%20316.357L255.744%20316.867L255.731%20312.6L252.496%20314.448L252.512%20318.708L251.621%20319.218L251.607%20314.958L248.377%20316.807L248.391%20321.061L247.499%20321.566L247.486%20317.314L244.256%20319.16L244.27%20322.539C243.953%20322.523%20243.652%20322.46%20243.376%20322.35L243.368%20319.676L241.5%20320.741L240.907%20320.067L367.992%20247.545L367.524%20248.62L367.505%20248.641Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M393.367%20175.019L375.311%20185.337L357.206%20175.019L375.287%20164.701L393.367%20175.019Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M393.367%20175.019V195.655L375.287%20205.971L375.311%20185.337L393.367%20175.019Z'%20fill='%238092F3'/%3e%3cpath%20d='M375.311%20185.337L375.287%20205.971L357.206%20195.655V175.019L375.311%20185.337Z'%20fill='%2300DF9D'/%3e%3cpath%20d='M411.475%20185.337L393.418%20195.653L375.311%20185.337L393.391%20175.019L411.475%20185.337Z'%20fill='%23E3E7FE'/%3e%3cpath%20d='M411.474%20185.337V205.971L393.391%20216.289L393.418%20195.653L411.474%20185.337Z'%20fill='%23566EF8'/%3e%3cpath%20d='M393.418%20195.653L393.391%20216.289L375.311%20205.971V185.337L393.418%20195.653Z'%20fill='%238092F3'/%3e%3cpath%20d='M375.287%20185.337L357.23%20195.653L339.123%20185.337L357.206%20175.019L375.287%20185.337Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M375.287%20185.337V205.971L357.206%20216.289L357.23%20195.653L375.287%20185.337Z'%20fill='%236077F1'/%3e%3cpath%20d='M357.23%20195.653L357.206%20216.289L339.123%20205.971V185.337L357.23%20195.653Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M393.391%20195.655L375.335%20205.97L357.23%20195.655L375.311%20185.337L393.391%20195.655Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M393.391%20195.655V216.288L375.311%20226.606L375.335%20205.97L393.391%20195.655Z'%20fill='%23E6E9FE'/%3e%3cpath%20d='M375.335%20205.97L375.311%20226.606L357.23%20216.288V195.655L375.335%20205.97Z'%20fill='%23566EF8'/%3e%3cpath%20d='M333.214%20222.573L315.16%20232.891L297.053%20222.573L315.134%20212.255L333.214%20222.573Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M333.214%20222.573V243.209L315.134%20253.524L315.16%20232.891L333.214%20222.573Z'%20fill='%236077F1'/%3e%3cpath%20d='M315.16%20232.891L315.134%20253.524L297.053%20243.209V222.573L315.16%20232.891Z'%20fill='%238092F3'/%3e%3cpath%20d='M332.647%20202.234L314.591%20212.552L296.486%20202.234L314.567%20191.916L332.647%20202.234Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M332.647%20202.234V222.87L314.567%20233.185L314.591%20212.552L332.647%20202.234Z'%20fill='%2300DF9D'/%3e%3cpath%20d='M314.591%20212.552L314.567%20233.185L296.486%20222.87V202.234L314.591%20212.552Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M350.728%20232.893L332.672%20243.208L314.567%20232.893L332.648%20222.575L350.728%20232.893Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M350.728%20232.893V253.527L332.648%20263.845L332.672%20243.209L350.728%20232.893Z'%20fill='%237286F9'/%3e%3cpath%20d='M332.672%20243.209L332.648%20263.845L314.567%20253.527V232.893L332.672%20243.209Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M350.728%20212.552L332.672%20222.87L314.567%20212.552L332.648%20202.234L350.728%20212.552Z'%20fill='%23566EF8'/%3e%3cpath%20d='M350.728%20212.552V233.185L332.648%20243.503L332.672%20222.87L350.728%20212.552Z'%20fill='%237286F9'/%3e%3cpath%20d='M332.672%20222.87L332.648%20243.503L314.567%20233.185V212.552L332.672%20222.87Z'%20fill='%238092F3'/%3e%3cpath%20d='M287.882%20185.589L269.868%20195.884L251.806%20185.589L269.844%20175.298L287.882%20185.589Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M287.883%20185.589V206.175L269.845%20216.47L269.869%20195.884L287.883%20185.589Z'%20fill='%238092F3'/%3e%3cpath%20d='M269.868%20195.884L269.844%20216.47L251.806%20206.175V185.589L269.868%20195.884Z'%20fill='%23405CEE'/%3e%3cpath%20d='M305.896%20237.058L287.882%20247.352L269.821%20237.058L287.859%20226.764L305.896%20237.058Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M287.882%20247.352L287.859%20267.938L269.821%20257.644V237.058L287.882%20247.352Z'%20fill='%23405CEE'/%3e%3cpath%20d='M305.872%20216.422L287.858%20226.717L269.794%20216.422L287.834%20206.131L305.872%20216.422Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M305.872%20216.422V237.011L287.834%20247.303L287.858%20226.717L305.872%20216.422Z'%20fill='%236077F1'/%3e%3cpath%20d='M287.858%20226.717L287.834%20247.303L269.794%20237.011V216.422L287.858%20226.717Z'%20fill='%23405CEE'/%3e%3cpath%20d='M323.9%20247.232L305.886%20257.523L287.821%20247.232L305.859%20236.937L323.9%20247.232Z'%20fill='%23BFC9F9'/%3e%3cpath%20d='M305.886%20257.523L305.859%20278.109L287.821%20267.817V247.231L305.886%20257.523Z'%20fill='%23405CEE'/%3e%3cpath%20d='M323.9%20226.588L305.886%20236.882L287.821%20226.588L305.859%20216.293L323.9%20226.588Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M323.9%20226.585L305.886%20236.882L305.859%20278.109L323.9%20267.817V247.229L323.671%20247.305L323.9%20247.174V226.585Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M305.886%20236.882L305.859%20257.468L287.821%20247.173V226.587L305.886%20236.882Z'%20fill='%23405CEE'/%3e%3cpath%20d='M305.921%20195.884L287.907%20206.175L269.845%20195.884L287.883%20185.589L305.921%20195.884Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M305.921%20195.884V216.469L287.883%20226.761L287.907%20206.175L305.921%20195.884Z'%20fill='%238092F3'/%3e%3cpath%20d='M287.907%20206.175L287.883%20226.761L269.845%20216.469V195.884L287.907%20206.175Z'%20fill='%23405CEE'/%3e%3cpath%20d='M323.9%20206.162L305.886%20216.456L287.821%20206.162L305.859%20195.87L323.9%20206.162Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M323.9%20206.162V226.748L305.859%20237.042L305.886%20216.456L323.9%20206.162Z'%20fill='%238092F3'/%3e%3cpath%20d='M305.886%20216.456L305.859%20237.042L287.821%20226.748V206.162L305.886%20216.456Z'%20fill='%23405CEE'/%3e%3cpath%20d='M341.938%20216.351L323.924%20226.645L305.859%20216.351L323.9%20206.059L341.938%20216.351Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M341.938%20216.351V236.937L323.9%20247.231L323.924%20226.645L341.938%20216.351Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M323.924%20226.645L323.9%20247.231L305.859%20236.937V216.351L323.924%20226.645Z'%20fill='%23405CEE'/%3e%3cpath%20d='M301.15%20197.704C304.322%20199.592%20304.215%20202.597%20300.908%20204.419C297.601%20206.241%20292.35%20206.189%20289.176%20204.301C286.004%20202.413%20286.111%20199.408%20289.418%20197.585C292.725%20195.763%20297.976%20195.816%20301.15%20197.704Z'%20fill='%236077F1'/%3e%3cpath%20d='M303.46%20200.98C303.457%20199.799%20302.688%20198.621%20301.15%20197.703L301.11%20183.678C302.651%20184.593%20303.417%20185.773%20303.42%20186.954C303.433%20191.161%20303.449%20196.772%20303.46%20200.98Z'%20fill='%236077F1'/%3e%3cpath%20d='M286.824%20187.002C286.821%20185.75%20287.675%20184.498%20289.378%20183.56C292.685%20181.737%20297.937%20181.79%20301.11%20183.678L301.15%20197.703C297.979%20195.816%20292.725%20195.763%20289.418%20197.585C287.715%20198.524%20286.861%20199.775%20286.864%20201.027C286.85%20196.82%20286.834%20191.209%20286.824%20187.002Z'%20fill='%236077F1'/%3e%3cpath%20d='M286.864%20201.027L286.824%20187.002C286.826%20188.182%20287.595%20189.36%20289.133%20190.278C292.304%20192.166%20297.559%20192.219%20300.866%20190.396C302.568%20189.458%20303.422%20188.206%20303.42%20186.954L303.46%20200.98C303.462%20202.231%20302.608%20203.483%20300.906%20204.422C297.599%20206.244%20292.347%20206.191%20289.173%20204.303C287.633%20203.388%20286.866%20202.208%20286.864%20201.027Z'%20fill='%23566EF8'/%3e%3cpath%20d='M301.111%20183.678C304.282%20185.566%20304.176%20188.571%20300.869%20190.394C297.562%20192.216%20292.31%20192.163%20289.136%20190.275C285.965%20188.387%20286.071%20185.382%20289.378%20183.56C292.685%20181.737%20297.937%20181.79%20301.111%20183.678Z'%20fill='%236077F1'/%3e%3cpath%20d='M301.11%20183.678C304.281%20185.566%20304.175%20188.571%20300.868%20190.394C297.561%20192.216%20292.309%20192.163%20289.135%20190.275C285.964%20188.387%20286.071%20185.382%20289.377%20183.56C292.684%20181.737%20297.936%20181.79%20301.11%20183.678Z'%20fill='%239FADF6'/%3e%3cpath%20d='M303.42%20186.954C303.417%20185.774%20302.648%20184.596%20301.11%20183.678L301.097%20178.895C302.637%20179.81%20303.404%20180.991%20303.406%20182.171C303.412%20183.607%20303.417%20185.519%20303.42%20186.954Z'%20fill='%239FADF6'/%3e%3cpath%20d='M286.81%20182.219C286.808%20180.967%20287.662%20179.715%20289.364%20178.777C292.671%20176.955%20297.923%20177.007%20301.097%20178.895L301.11%20183.678C297.939%20181.79%20292.685%20181.737%20289.378%20183.56C287.675%20184.498%20286.821%20185.75%20286.824%20187.002C286.818%20185.566%20286.813%20183.654%20286.81%20182.219Z'%20fill='%239FADF6'/%3e%3cpath%20d='M286.824%20187.002L286.81%20182.219C286.813%20183.399%20287.582%20184.577%20289.12%20185.495C292.291%20187.383%20297.545%20187.436%20300.852%20185.613C302.555%20184.675%20303.409%20183.423%20303.406%20182.171L303.42%20186.954C303.422%20188.206%20302.568%20189.458%20300.866%20190.396C297.559%20192.219%20292.307%20192.166%20289.133%20190.278C287.592%20189.363%20286.826%20188.182%20286.824%20187.002Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M301.097%20178.895C304.269%20180.783%20304.162%20183.788%20300.855%20185.611C297.548%20187.433%20292.297%20187.38%20289.123%20185.492C285.951%20183.604%20286.058%20180.599%20289.365%20178.777C292.672%20176.955%20297.923%20177.007%20301.097%20178.895Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M317.23%20206.728L317.222%20209.946C317.222%20210.811%20316.642%20211.676%20315.493%20212.339C313.176%20213.67%20309.409%20213.67%20307.075%20212.339C305.902%20211.669%20305.317%20210.79%20305.317%20209.912L305.325%20206.694C305.325%20207.572%20305.907%20208.45%20307.083%20209.121C309.417%20210.451%20313.184%20210.451%20315.501%20209.121C316.653%20208.461%20317.228%20207.596%20317.23%20206.728Z'%20fill='%23566EF8'/%3e%3cpath%20d='M315.472%20204.301C317.805%20205.631%20317.816%20207.787%20315.498%20209.121C313.181%20210.451%20309.414%20210.451%20307.081%20209.121C304.747%20207.79%20304.737%20205.634%20307.054%20204.301C309.371%20202.97%20313.138%20202.97%20315.472%20204.301Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M311.952%20206.147C312.436%20206.436%20312.42%20206.896%20311.915%20207.175C311.409%20207.454%20310.606%20207.446%20310.119%20207.157C309.635%20206.867%20309.651%20206.407%20310.156%20206.128C310.662%20205.85%20311.465%20205.858%20311.952%20206.147Z'%20fill='%236077F1'/%3e%3cpath%20d='M312.305%20206.646C312.305%20206.465%20312.188%20206.286%20311.952%20206.144L311.946%20197.57C312.183%20197.709%20312.3%20197.89%20312.3%20198.072C312.3%20198.716%20312.305%20206.005%20312.305%20206.646Z'%20fill='%236077F1'/%3e%3cpath%20d='M309.76%20198.08C309.76%20197.888%20309.89%20197.696%20310.151%20197.554C310.656%20197.276%20311.46%20197.284%20311.947%20197.573L311.952%20206.148C311.468%20205.858%20310.662%20205.85%20310.156%20206.129C309.896%20206.274%20309.765%20206.463%20309.765%20206.655C309.765%20206.011%20309.76%20198.722%20309.76%20198.08Z'%20fill='%236077F1'/%3e%3cpath%20d='M309.765%20206.655L309.76%20198.08C309.76%20198.261%20309.877%20198.44%20310.113%20198.582C310.598%20198.871%20311.404%20198.879%20311.909%20198.601C312.17%20198.456%20312.3%20198.267%20312.3%20198.075L312.306%20206.649C312.306%20206.841%20312.175%20207.033%20311.915%20207.175C311.409%20207.454%20310.606%20207.446%20310.119%20207.157C309.882%20207.017%20309.765%20206.836%20309.765%20206.655Z'%20fill='%23566EF8'/%3e%3cpath%20d='M311.944%20197.57C312.428%20197.859%20312.412%20198.319%20311.907%20198.598C311.401%20198.877%20310.598%20198.869%20310.111%20198.579C309.627%20198.29%20309.643%20197.83%20310.148%20197.551C310.654%20197.273%20311.457%20197.28%20311.944%20197.57Z'%20fill='%236077F1'/%3e%3cpath%20d='M312.873%20195.994C313.846%20196.576%20313.814%20197.498%20312.798%20198.059C311.782%20198.619%20310.169%20198.603%20309.193%20198.022C308.219%20197.441%20308.251%20196.518%20309.268%20195.958C310.284%20195.398%20311.896%20195.413%20312.873%20195.994Z'%20fill='%239FADF6'/%3e%3cpath%20d='M313.583%20197.002C313.583%20196.639%20313.346%20196.276%20312.872%20195.995L312.867%20194.525C313.341%20194.806%20313.575%20195.169%20313.577%20195.532C313.577%20195.974%20313.58%20196.56%20313.583%20197.002Z'%20fill='%239FADF6'/%3e%3cpath%20d='M308.48%20195.545C308.48%20195.161%20308.741%20194.777%20309.265%20194.488C310.281%20193.928%20311.893%20193.944%20312.87%20194.525L312.875%20195.995C311.901%20195.414%20310.286%20195.398%20309.27%20195.958C308.746%20196.247%20308.485%20196.631%20308.485%20197.015C308.485%20196.573%20308.483%20195.987%20308.48%20195.545Z'%20fill='%239FADF6'/%3e%3cpath%20d='M308.485%20197.015L308.48%20195.545C308.48%20195.908%20308.717%20196.271%20309.19%20196.552C310.164%20197.133%20311.779%20197.149%20312.795%20196.589C313.319%20196.3%20313.58%20195.916%20313.58%20195.532L313.585%20197.002C313.585%20197.385%20313.325%20197.769%20312.801%20198.059C311.784%20198.619%20310.172%20198.603%20309.196%20198.022C308.722%20197.74%20308.488%20197.378%20308.485%20197.015Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M312.795%20196.586C311.779%20197.146%20310.164%20197.13%20309.193%20196.549C308.217%20195.971%20308.251%20195.045%20309.268%20194.485C310.284%20193.925%20311.899%20193.941%20312.87%20194.522C313.846%20195.1%20313.812%20196.026%20312.795%20196.586Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M285.153%20188.003L285.145%20191.222C285.145%20192.087%20284.565%20192.952%20283.416%20193.615C281.099%20194.945%20277.331%20194.945%20274.998%20193.615C273.825%20192.944%20273.24%20192.066%20273.24%20191.188L273.247%20187.969C273.247%20188.847%20273.83%20189.726%20275.006%20190.396C277.339%20191.727%20281.107%20191.727%20283.424%20190.396C284.576%20189.736%20285.15%20188.871%20285.153%20188.003Z'%20fill='%23566EF8'/%3e%3cpath%20d='M283.397%20185.576C285.73%20186.907%20285.741%20189.063%20283.424%20190.396C281.107%20191.727%20277.339%20191.727%20275.006%20190.396C272.673%20189.066%20272.662%20186.91%20274.979%20185.576C277.297%20184.246%20281.064%20184.246%20283.397%20185.576Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M279.875%20187.422C280.359%20187.711%20280.343%20188.172%20279.837%20188.45C279.332%20188.729%20278.528%20188.721%20278.041%20188.432C277.557%20188.143%20277.573%20187.683%20278.079%20187.404C278.584%20187.125%20279.388%20187.133%20279.875%20187.422Z'%20fill='%236077F1'/%3e%3cpath%20d='M280.229%20187.922C280.229%20187.74%20280.111%20187.562%20279.875%20187.42L279.869%20178.845C280.106%20178.984%20280.223%20179.166%20280.223%20179.347C280.223%20179.991%20280.229%20187.28%20280.229%20187.922Z'%20fill='%236077F1'/%3e%3cpath%20d='M277.682%20179.356C277.682%20179.164%20277.813%20178.972%20278.073%20178.83C278.579%20178.551%20279.382%20178.559%20279.869%20178.848L279.874%20187.423C279.39%20187.134%20278.584%20187.126%20278.079%20187.405C277.818%20187.549%20277.688%20187.738%20277.688%20187.93C277.688%20187.286%20277.682%20179.997%20277.682%20179.356Z'%20fill='%236077F1'/%3e%3cpath%20d='M277.688%20187.93L277.682%20179.355C277.682%20179.537%20277.799%20179.716%20278.036%20179.858C278.52%20180.147%20279.326%20180.155%20279.832%20179.876C280.093%20179.731%20280.223%20179.542%20280.223%20179.35L280.228%20187.925C280.228%20188.117%20280.098%20188.309%20279.837%20188.451C279.332%20188.729%20278.528%20188.721%20278.041%20188.432C277.805%20188.293%20277.688%20188.111%20277.688%20187.93Z'%20fill='%23566EF8'/%3e%3cpath%20d='M279.869%20178.845C280.353%20179.134%20280.337%20179.594%20279.832%20179.873C279.326%20180.152%20278.523%20180.144%20278.036%20179.855C277.552%20179.566%20277.568%20179.105%20278.073%20178.827C278.579%20178.548%20279.382%20178.556%20279.869%20178.845Z'%20fill='%236077F1'/%3e%3cpath%20d='M280.798%20177.27C281.771%20177.851%20281.739%20178.774%20280.723%20179.334C279.707%20179.894%20278.095%20179.878%20277.118%20179.297C276.145%20178.716%20276.176%20177.793%20277.193%20177.233C278.209%20176.673%20279.821%20176.689%20280.798%20177.27Z'%20fill='%239FADF6'/%3e%3cpath%20d='M281.508%20178.277C281.508%20177.914%20281.271%20177.551%20280.798%20177.27L280.792%20175.8C281.266%20176.081%20281.5%20176.444%20281.503%20176.807C281.503%20177.249%20281.505%20177.835%20281.508%20178.277Z'%20fill='%239FADF6'/%3e%3cpath%20d='M276.403%20176.823C276.403%20176.439%20276.663%20176.055%20277.187%20175.766C278.204%20175.206%20279.816%20175.222%20280.792%20175.803L280.798%20177.273C279.824%20176.692%20278.209%20176.676%20277.193%20177.236C276.669%20177.525%20276.408%20177.909%20276.408%20178.293C276.408%20177.851%20276.405%20177.265%20276.403%20176.823Z'%20fill='%239FADF6'/%3e%3cpath%20d='M276.408%20178.29L276.403%20176.82C276.403%20177.183%20276.639%20177.546%20277.113%20177.827C278.087%20178.408%20279.702%20178.424%20280.718%20177.864C281.242%20177.575%20281.503%20177.191%20281.503%20176.807L281.508%20178.277C281.508%20178.661%20281.247%20179.045%20280.723%20179.334C279.707%20179.894%20278.095%20179.878%20277.118%20179.297C276.645%20179.016%20276.411%20178.653%20276.408%20178.29Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M280.718%20177.864C279.702%20178.424%20278.087%20178.409%20277.116%20177.827C276.139%20177.249%20276.174%20176.323%20277.19%20175.763C278.206%20175.203%20279.821%20175.219%20280.792%20175.8C281.769%20176.379%20281.734%20177.304%20280.718%20177.864Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M257.718%20198.495C258.17%20198.752%20258.535%20199.378%20258.535%20199.891L258.53%20202.118C258.53%20202.631%20258.16%20202.839%20257.708%20202.581C257.255%20202.323%20256.891%20201.697%20256.891%20201.185L256.896%20198.957C256.896%20198.445%20257.266%20198.237%20257.718%20198.495Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M261.132%20200.441C261.584%20200.698%20261.948%20201.324%20261.948%20201.837L261.943%20204.064C261.943%20204.577%20261.573%20204.784%20261.121%20204.527C260.669%20204.269%20260.304%20203.643%20260.304%20203.13L260.31%20200.903C260.31%20200.391%20260.679%20200.183%20261.132%20200.441Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M264.542%20202.389C264.995%20202.647%20265.359%20203.272%20265.359%20203.785L265.354%20206.012C265.354%20206.525%20264.984%20206.733%20264.532%20206.475C264.079%20206.217%20263.715%20205.592%20263.715%20205.079L263.72%20202.852C263.72%20202.339%20264.09%20202.131%20264.542%20202.389Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M267.956%20204.335C268.408%20204.592%20268.772%20205.218%20268.772%20205.731L268.767%20207.958C268.767%20208.471%20268.397%20208.679%20267.945%20208.421C267.493%20208.163%20267.128%20207.537%20267.128%20207.025L267.133%20204.798C267.133%20204.285%20267.503%20204.077%20267.956%20204.335Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M305.923%20225.483C306.375%20225.741%20306.74%20226.367%20306.74%20226.88L306.735%20229.107C306.735%20229.62%20306.365%20229.827%20305.912%20229.57C305.46%20229.312%20305.096%20228.686%20305.096%20228.173L305.101%20225.946C305.101%20225.434%20305.471%20225.226%20305.923%20225.483Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M309.334%20227.432C309.786%20227.69%20310.151%20228.315%20310.151%20228.828L310.145%20231.055C310.145%20231.568%20309.775%20231.776%20309.323%20231.518C308.871%20231.26%20308.506%20230.635%20308.506%20230.122L308.512%20227.895C308.512%20227.382%20308.881%20227.174%20309.334%20227.432Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M312.747%20229.378C313.2%20229.635%20313.564%20230.261%20313.564%20230.774L313.559%20233.001C313.559%20233.514%20313.189%20233.722%20312.737%20233.464C312.284%20233.206%20311.92%20232.58%20311.92%20232.068L311.925%20229.841C311.925%20229.328%20312.295%20229.12%20312.747%20229.378Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M316.158%20231.324C316.61%20231.581%20316.975%20232.207%20316.975%20232.72L316.97%20234.947C316.97%20235.46%20316.6%20235.667%20316.147%20235.41C315.695%20235.152%20315.331%20234.526%20315.331%20234.013L315.336%20231.786C315.336%20231.274%20315.706%20231.066%20316.158%20231.324Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M282.636%20213.336C283.089%20213.593%20283.453%20214.219%20283.453%20214.732L283.448%20216.959C283.448%20217.472%20283.078%20217.679%20282.626%20217.422C282.173%20217.164%20281.809%20216.538%20281.809%20216.025L281.814%20213.798C281.814%20213.286%20282.184%20213.078%20282.636%20213.336Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M286.047%20215.284C286.499%20215.541%20286.864%20216.167%20286.864%20216.68L286.858%20218.907C286.858%20219.42%20286.489%20219.628%20286.036%20219.37C285.584%20219.112%20285.22%20218.486%20285.22%20217.974L285.225%20215.747C285.225%20215.234%20285.595%20215.026%20286.047%20215.284Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M289.46%20217.23C289.913%20217.488%20290.277%20218.113%20290.277%20218.626L290.272%20220.853C290.272%20221.366%20289.902%20221.574%20289.45%20221.316C288.998%20221.058%20288.633%20220.432%20288.633%20219.92L288.638%20217.693C288.638%20217.18%20289.008%20216.972%20289.46%20217.23Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M292.871%20219.178C293.324%20219.436%20293.688%20220.062%20293.688%20220.574L293.683%20222.801C293.683%20223.314%20293.313%20223.522%20292.861%20223.264C292.408%20223.007%20292.044%20222.381%20292.044%20221.868L292.049%20219.641C292.049%20219.128%20292.419%20218.92%20292.871%20219.178Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M140.948%20325.653L125.387%20334.59L109.725%20325.653L125.283%20316.715L140.948%20325.653Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M140.948%20325.653L140.929%20331.624L125.368%20340.562L125.387%20334.59L140.948%20325.653Z'%20fill='%23566EF8'/%3e%3cpath%20d='M125.387%20334.59L125.368%20340.562L109.706%20331.624L109.725%20325.653L125.387%20334.59Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M126.549%20325.395C127.193%20325.776%20127.169%20326.386%20126.498%20326.757C125.828%20327.128%20124.764%20327.114%20124.12%20326.733C123.476%20326.352%20123.5%20325.742%20124.17%20325.371C124.841%20325%20125.905%20325.014%20126.549%20325.395Z'%20fill='%236077F1'/%3e%3cpath%20d='M127.017%20326.06C127.017%20325.821%20126.86%20325.581%20126.549%20325.395L126.541%20293.705C126.852%20293.891%20127.009%20294.131%20127.009%20294.37C127.009%20295.222%20127.015%20325.205%20127.017%20326.06Z'%20fill='%239FADF6'/%3e%3cpath%20d='M123.644%20294.38C123.644%20294.128%20123.817%20293.873%20124.163%20293.684C124.833%20293.313%20125.897%20293.326%20126.541%20293.707L126.549%20325.397C125.905%20325.016%20124.841%20325.003%20124.171%20325.374C123.825%20325.563%20123.652%20325.818%20123.652%20326.071C123.652%20325.219%20123.647%20295.235%20123.644%20294.38Z'%20fill='%239FADF6'/%3e%3cpath%20d='M123.652%20326.068L123.644%20294.378C123.644%20294.617%20123.801%20294.856%20124.112%20295.043C124.756%20295.424%20125.82%20295.437%20126.491%20295.067C126.836%20294.877%20127.009%20294.622%20127.009%20294.37L127.017%20326.06C127.017%20326.312%20126.844%20326.567%20126.499%20326.757C125.828%20327.128%20124.764%20327.114%20124.12%20326.733C123.809%20326.546%20123.652%20326.307%20123.652%20326.068Z'%20fill='%23566EF8'/%3e%3cpath%20d='M126.542%20293.707C127.185%20294.089%20127.161%20294.699%20126.491%20295.069C125.821%20295.44%20124.756%20295.427%20124.113%20295.046C123.469%20294.664%20123.493%20294.054%20124.163%20293.684C124.833%20293.313%20125.898%20293.326%20126.542%20293.707Z'%20fill='%239FADF6'/%3e%3cpath%20d='M130.189%20295.28C132.762%20296.81%20132.674%20299.248%20129.992%20300.725C127.31%20302.203%20123.051%20302.161%20120.478%20300.631C117.905%20299.1%20117.993%20296.663%20120.675%20295.185C123.357%20293.707%20127.616%20293.749%20130.189%20295.28Z'%20fill='%239FADF6'/%3e%3cpath%20d='M132.061%20297.938C132.059%20296.981%20131.436%20296.024%20130.188%20295.282L130.178%20291.404C131.426%20292.145%20132.048%20293.102%20132.051%20294.06C132.053%20295.222%20132.059%20296.773%20132.061%20297.938Z'%20fill='%239FADF6'/%3e%3cpath%20d='M118.592%20294.096C118.589%20293.082%20119.281%20292.067%20120.662%20291.307C123.344%20289.829%20127.603%20289.871%20130.176%20291.401L130.186%20295.28C127.614%20293.749%20123.354%20293.707%20120.672%20295.185C119.292%20295.945%20118.6%20296.96%20118.603%20297.975C118.6%20296.813%20118.595%20295.261%20118.592%20294.096Z'%20fill='%239FADF6'/%3e%3cpath%20d='M118.602%20297.975L118.592%20294.096C118.594%20295.053%20119.217%20296.011%20120.465%20296.752C123.037%20298.282%20127.297%20298.324%20129.978%20296.847C131.359%20296.087%20132.051%20295.072%20132.048%20294.057L132.059%20297.935C132.062%20298.95%20131.37%20299.965%20129.989%20300.725C127.307%20302.203%20123.048%20302.161%20120.475%20300.631C119.228%20299.889%20118.605%20298.932%20118.602%20297.975Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M130.175%20291.401C132.748%20292.932%20132.66%20295.369%20129.979%20296.847C127.297%20298.325%20123.037%20298.283%20120.465%20296.752C117.892%20295.222%20117.98%20292.784%20120.662%20291.307C123.343%20289.829%20127.603%20289.871%20130.175%20291.401Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M126.27%20293.878C126.768%20294.173%20126.749%20294.643%20126.233%20294.93C125.717%20295.214%20124.895%20295.206%20124.397%20294.911C123.9%20294.617%20123.918%20294.146%20124.434%20293.86C124.951%20293.576%20125.773%20293.584%20126.27%20293.878Z'%20fill='%236077F1'/%3e%3cpath%20d='M126.632%20294.391C126.632%20294.207%20126.512%20294.022%20126.27%20293.878L126.265%20269.421C126.507%20269.563%20126.627%20269.75%20126.627%20269.934C126.627%20270.591%20126.632%20293.733%20126.632%20294.391Z'%20fill='%239FADF6'/%3e%3cpath%20d='M124.027%20269.942C124.027%20269.748%20124.16%20269.55%20124.426%20269.403C124.943%20269.119%20125.765%20269.127%20126.262%20269.422L126.267%20293.878C125.77%20293.584%20124.951%20293.576%20124.432%20293.86C124.166%20294.007%20124.033%20294.201%20124.033%20294.399C124.033%20293.741%20124.027%20270.6%20124.027%20269.942Z'%20fill='%239FADF6'/%3e%3cpath%20d='M124.035%20294.399L124.03%20269.942C124.03%20270.126%20124.15%20270.31%20124.392%20270.455C124.889%20270.749%20125.709%20270.757%20126.228%20270.473C126.494%20270.326%20126.627%20270.132%20126.627%20269.934L126.632%20294.391C126.632%20294.585%20126.499%20294.783%20126.233%20294.93C125.717%20295.214%20124.895%20295.206%20124.397%20294.911C124.155%20294.769%20124.035%20294.583%20124.035%20294.399Z'%20fill='%23566EF8'/%3e%3cpath%20d='M126.262%20269.422C126.76%20269.716%20126.741%20270.187%20126.225%20270.473C125.709%20270.757%20124.887%20270.749%20124.389%20270.455C123.892%20270.16%20123.91%20269.69%20124.426%20269.403C124.943%20269.117%20125.765%20269.127%20126.262%20269.422Z'%20fill='%239FADF6'/%3e%3cpath%20d='M129.08%20270.636C131.064%20271.817%20130.998%20273.7%20128.928%20274.841C126.858%20275.982%20123.57%20275.948%20121.585%20274.767C119.6%20273.587%20119.667%20271.704%20121.737%20270.563C123.807%20269.422%20127.095%20269.456%20129.08%20270.636Z'%20fill='%239FADF6'/%3e%3cpath%20d='M130.525%20272.688C130.525%20271.949%20130.043%20271.21%20129.08%20270.637L129.072%20267.644C130.035%20268.218%20130.517%20268.956%20130.517%20269.695C130.517%20270.592%20130.522%20271.791%20130.525%20272.688Z'%20fill='%239FADF6'/%3e%3cpath%20d='M120.13%20269.724C120.13%20268.941%20120.662%20268.157%20121.729%20267.571C123.799%20266.429%20127.087%20266.464%20129.072%20267.644L129.08%20270.637C127.095%20269.456%20123.807%20269.422%20121.737%20270.563C120.673%20271.149%20120.138%20271.933%20120.138%20272.716C120.138%20271.82%20120.133%20270.621%20120.13%20269.724Z'%20fill='%239FADF6'/%3e%3cpath%20d='M120.138%20272.716L120.13%20269.724C120.13%20270.463%20120.612%20271.202%20121.575%20271.775C123.559%20272.956%20126.848%20272.99%20128.918%20271.849C129.982%20271.262%20130.516%20270.479%20130.516%20269.695L130.524%20272.687C130.524%20273.471%20129.992%20274.255%20128.926%20274.841C126.856%20275.982%20123.567%20275.948%20121.583%20274.767C120.62%20274.194%20120.138%20273.455%20120.138%20272.716Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M129.069%20267.644C131.054%20268.825%20130.987%20270.708%20128.917%20271.849C126.848%20272.99%20123.559%20272.956%20121.575%20271.775C119.59%20270.595%20119.656%20268.712%20121.726%20267.571C123.796%20266.429%20127.084%20266.464%20129.069%20267.644Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M126.262%20269.422C126.76%20269.716%20126.741%20270.187%20126.225%20270.474C125.709%20270.758%20124.887%20270.75%20124.389%20270.455C123.892%20270.161%20123.91%20269.69%20124.426%20269.403C124.943%20269.119%20125.765%20269.127%20126.262%20269.422Z'%20fill='%236077F1'/%3e%3cpath%20d='M126.624%20269.934C126.624%20269.75%20126.504%20269.566%20126.262%20269.422L126.257%20262.057C126.499%20262.199%20126.619%20262.385%20126.619%20262.569C126.619%20263.227%20126.624%20269.277%20126.624%20269.934Z'%20fill='%239FADF6'/%3e%3cpath%20d='M124.022%20262.577C124.022%20262.383%20124.155%20262.185%20124.421%20262.038C124.937%20261.754%20125.759%20261.762%20126.257%20262.057L126.262%20269.422C125.765%20269.127%20124.945%20269.119%20124.426%20269.403C124.16%20269.55%20124.027%20269.745%20124.027%20269.942C124.027%20269.285%20124.022%20263.235%20124.022%20262.577Z'%20fill='%239FADF6'/%3e%3cpath%20d='M124.027%20269.942L124.022%20262.577C124.022%20262.761%20124.142%20262.945%20124.384%20263.09C124.881%20263.384%20125.701%20263.392%20126.22%20263.108C126.486%20262.961%20126.619%20262.766%20126.619%20262.569L126.624%20269.934C126.624%20270.129%20126.491%20270.326%20126.225%20270.473C125.709%20270.757%20124.887%20270.749%20124.389%20270.455C124.147%20270.313%20124.027%20270.126%20124.027%20269.942Z'%20fill='%23566EF8'/%3e%3cpath%20d='M126.257%20262.057C126.754%20262.351%20126.736%20262.822%20126.22%20263.108C125.704%20263.392%20124.882%20263.384%20124.384%20263.09C123.886%20262.795%20123.905%20262.325%20124.421%20262.038C124.937%20261.754%20125.759%20261.762%20126.257%20262.057Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M297.008%20260.621L278.951%20270.939L260.847%20260.621L278.927%20250.303L297.008%20260.621Z'%20fill='%23BFC9F9'/%3e%3cpath%20d='M297.008%20260.621V281.257L278.927%20291.575L278.951%20270.939L297.008%20260.621Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M278.951%20270.939L278.927%20291.575L260.847%20281.257V260.621L278.951%20270.939Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M278.951%20229.775L260.895%20240.093L242.79%20229.775L260.871%20219.457L278.951%20229.775Z'%20fill='%23E6E9FE'/%3e%3cpath%20d='M278.951%20229.775V250.411L260.871%20260.726L260.895%20240.093L278.951%20229.775Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M260.895%20240.093L260.871%20260.726L242.79%20250.411V229.775L260.895%20240.093Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M242.766%20271.044L224.71%20281.362L206.603%20271.044L224.683%20260.726L242.766%20271.044Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M242.766%20271.044V291.68L224.683%20301.998L224.71%20281.362L242.766%20271.044Z'%20fill='%236077F1'/%3e%3cpath%20d='M224.71%20281.362L224.683%20301.998L206.603%20291.68V271.044L224.71%20281.362Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M278.927%20270.939L260.871%20281.257L242.766%20270.939L260.847%20260.621L278.927%20270.939Z'%20fill='%238092F3'/%3e%3cpath%20d='M278.927%20270.939V291.575L260.847%20301.89L260.871%20281.257L278.927%20270.939Z'%20fill='%23566EF8'/%3e%3cpath%20d='M260.871%20281.257L260.847%20301.89L242.766%20291.575V270.939L260.871%20281.257Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M260.823%20240.093L242.766%20250.411L224.659%20240.093L242.74%20229.775L260.823%20240.093Z'%20fill='%237286F9'/%3e%3cpath%20d='M260.823%20240.093V260.729L242.74%20271.044L242.766%20250.411L260.823%20240.093Z'%20fill='%238092F3'/%3e%3cpath%20d='M242.766%20250.411L242.74%20271.044L224.659%20260.729V240.093L242.766%20250.411Z'%20fill='%238092F3'/%3e%3cpath%20d='M242.766%20250.411L224.71%20260.726L206.603%20250.411L224.683%20240.093L242.766%20250.411Z'%20fill='%233A56F6'/%3e%3cpath%20d='M242.766%20250.411V271.044L224.683%20281.362L224.71%20260.726L242.766%20250.411Z'%20fill='%236077F1'/%3e%3cpath%20d='M224.71%20260.726L224.683%20281.362L206.603%20271.044V250.411L224.71%20260.726Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M296.984%20240.093L278.928%20250.411L260.823%20240.093L278.904%20229.775L296.984%20240.093Z'%20fill='%23FEFDFC'/%3e%3cpath%20d='M296.984%20240.093V260.726L278.904%20271.044L278.928%20250.411L296.984%20240.093Z'%20fill='%237286F9'/%3e%3cpath%20d='M278.928%20250.411L278.904%20271.044L260.823%20260.726V240.093L278.928%20250.411Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M260.847%20281.362L242.79%20291.68L224.683%20281.362L242.766%20271.044L260.847%20281.362Z'%20fill='%23BFC9F9'/%3e%3cpath%20d='M260.847%20281.362V301.997L242.766%20312.315L242.79%20291.68L260.847%20281.362Z'%20fill='%23566EF8'/%3e%3cpath%20d='M242.79%20291.68L242.766%20312.315L224.683%20301.997V281.362L242.79%20291.68Z'%20fill='%237286F9'/%3e%3cpath%20d='M278.904%20250.411L260.847%20260.726L242.74%20250.411L260.823%20240.093L278.904%20250.411Z'%20fill='%233A56F6'/%3e%3cpath%20d='M278.904%20250.411V271.044L260.823%20281.362L260.847%20260.726L278.904%20250.411Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M260.847%20260.726L260.823%20281.362L242.74%20271.044V250.411L260.847%20260.726Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M260.847%20260.729L242.79%20271.044L224.683%20260.729L242.766%20250.411L260.847%20260.729Z'%20fill='%237286F9'/%3e%3cpath%20d='M260.847%20260.729V281.362L242.766%20291.68L242.79%20271.044L260.847%20260.729Z'%20fill='%23E6E9FE'/%3e%3cpath%20d='M242.79%20271.044L242.766%20291.68L224.683%20281.362V260.729L242.79%20271.044Z'%20fill='%23566EF8'/%3e%3cpath%20d='M170.697%20288.451L152.641%20298.769L134.533%20288.451L152.617%20278.133L170.697%20288.451Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M170.697%20288.451V309.087L152.617%20319.405L152.641%20298.769L170.697%20288.451Z'%20fill='%236077F1'/%3e%3cpath%20d='M152.641%20298.769L152.617%20319.405L134.533%20309.087V288.451L152.641%20298.769Z'%20fill='%23566EF8'/%3e%3cpath%20d='M188.777%20257.5L170.721%20267.818L152.616%20257.5L170.697%20247.182L188.777%20257.5Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M188.777%20257.5V278.133L170.697%20288.451L170.721%20267.818L188.777%20257.5Z'%20fill='%236077F1'/%3e%3cpath%20d='M170.721%20267.818L170.697%20288.451L152.616%20278.133V257.5L170.721%20267.818Z'%20fill='%23566EF8'/%3e%3cpath%20d='M206.847%20288.38L188.791%20298.698L170.684%20288.38L188.767%20278.062L206.847%20288.38Z'%20fill='%23BFC9F9'/%3e%3cpath%20d='M206.847%20288.38V309.013L188.767%20319.331L188.791%20298.698L206.847%20288.38Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M188.791%20298.698L188.767%20319.331L170.684%20309.013V288.38L188.791%20298.698Z'%20fill='%2300DF9D'/%3e%3cpath%20d='M188.801%20298.769L170.745%20309.087L152.64%20298.769L170.721%20288.451L188.801%20298.769Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M188.801%20298.769V319.404L170.721%20329.722L170.745%20309.087L188.801%20298.769Z'%20fill='%23566EF8'/%3e%3cpath%20d='M170.745%20309.087L170.721%20329.722L152.64%20319.404V298.769L170.745%20309.087Z'%20fill='%23E6E9FE'/%3e%3cpath%20d='M206.858%20267.818L188.802%20278.133L170.697%20267.818L188.778%20257.5L206.858%20267.818Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M206.858%20267.818V288.451L188.777%20298.769L188.801%20278.133L206.858%20267.818Z'%20fill='%23566EF8'/%3e%3cpath%20d='M188.802%20278.133L188.778%20298.769L170.697%20288.451V267.818L188.802%20278.133Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M194.27%20514.891L270.701%20558.65L280.421%20553.096V551.215L203.935%20510.398L194.27%20513.01V514.891Z'%20fill='%230226F4'/%3e%3cpath%20d='M194.27%20513.01L270.701%20556.769L280.421%20551.215L203.935%20507.485L194.27%20513.01Z'%20fill='%233A56F6'/%3e%3cpath%20d='M280.42%20540.335L270.917%20545.777L261.388%20540.335L270.902%20534.897L280.42%20540.335Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M280.42%20540.335V551.22L270.902%20556.663L270.916%20545.778L280.42%20540.335Z'%20fill='%233A56F6'/%3e%3cpath%20d='M270.917%20545.778L270.902%20556.663L261.388%20551.22V540.335L270.917%20545.778Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M213.302%20502.198L203.798%20507.64L194.27%20502.198L203.788%20496.76L213.302%20502.198Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M213.302%20502.198V513.083L203.788%20518.526L203.798%20507.64L213.302%20502.198Z'%20fill='%233A56F6'/%3e%3cpath%20d='M203.798%20507.64L203.788%20518.526L194.27%20513.083V502.198L203.798%20507.64Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M194.27%20502.328L270.701%20546.088L280.421%20540.533V538.653L203.935%20497.836L194.27%20500.448V502.328Z'%20fill='%230226F4'/%3e%3cpath%20d='M194.27%20500.448L270.701%20544.207L280.421%20538.653L203.935%20494.923L194.27%20500.448Z'%20fill='%233A56F6'/%3e%3cpath%20d='M128.399%20552.645L204.831%20596.404L214.55%20590.85V588.97L138.064%20548.147L128.399%20550.76V552.645Z'%20fill='%230226F4'/%3e%3cpath%20d='M128.399%20550.76L204.83%20594.519L214.549%20588.97L138.064%20545.24L128.399%20550.76Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M214.55%20578.089L205.046%20583.532L195.518%20578.089L205.036%20572.646L214.55%20578.089Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M214.549%20578.089V588.974L205.036%20594.412L205.046%20583.532L214.549%20578.089Z'%20fill='%233A56F6'/%3e%3cpath%20d='M205.046%20583.532L205.036%20594.412L195.518%20588.974V578.089L205.046%20583.532Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M147.431%20539.952L137.927%20545.395L128.399%20539.952L137.918%20534.51L147.431%20539.952Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M147.431%20539.952V550.837L137.917%20556.28L137.927%20545.395L147.431%20539.952Z'%20fill='%233A56F6'/%3e%3cpath%20d='M137.927%20545.395L137.918%20556.28L128.399%20550.837V539.952L137.927%20545.395Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M128.399%20540.083L204.831%20583.842L214.55%20578.288V576.407L138.064%20535.59L128.399%20538.202V540.083Z'%20fill='%230226F4'/%3e%3cpath%20d='M128.399%20538.203L204.831%20581.962L214.55%20576.408L138.064%20532.677L128.399%20538.203Z'%20fill='%237286F9'/%3e%3cpath%20d='M263.375%20528.926L187.776%20572.21L178.159%20566.719V563.84L253.813%20523.464L263.375%20526.047V528.926Z'%20fill='%233A56F6'/%3e%3cpath%20d='M263.375%20526.047L187.776%20569.331L178.159%20563.84L253.813%20520.58L263.375%20526.047Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M246.795%20519.456L171.195%20562.74L161.579%20557.249V554.366L237.237%20513.989L246.795%20516.572V519.456Z'%20fill='%233A56F6'/%3e%3cpath%20d='M246.795%20516.572L171.195%20559.857L161.579%20554.366L237.237%20511.11L246.795%20516.572Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M230.454%20509.981L154.855%20553.265L145.238%20547.774V544.895L220.892%20504.519L230.454%20507.102V509.981Z'%20fill='%233A56F6'/%3e%3cpath%20d='M230.454%20507.102L154.855%20550.387L145.238%20544.896L220.892%20501.64L230.454%20507.102Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M213.615%20500.511L138.015%20543.795L128.399%20538.304V535.425L204.057%20495.049L213.615%20497.632V500.511Z'%20fill='%233A56F6'/%3e%3cpath%20d='M213.615%20497.632L138.015%20540.916L128.399%20535.425L204.057%20492.17L213.615%20497.632Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M280.474%20538.653L204.875%20581.937L195.258%20576.446V573.567L270.912%20533.191L280.474%20535.774V538.653Z'%20fill='%233A56F6'/%3e%3cpath%20d='M280.474%20535.774L204.875%20579.059L195.258%20573.567L270.912%20530.312L280.474%20535.774Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M118.871%20558.088L195.297%20601.847L205.022%20596.293V594.412L128.536%20553.59L118.871%20556.202V558.088Z'%20fill='%230226F4'/%3e%3cpath%20d='M118.871%20556.202L195.297%20599.961L205.022%20594.412L128.536%20550.677L118.871%20556.202Z'%20fill='%233A56F6'/%3e%3cpath%20d='M205.021%20583.532L195.518%20588.974L185.989%20583.532L195.503%20578.089L205.021%20583.532Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M205.022%20583.532V594.417L195.503%20599.855L195.518%20588.974L205.022%20583.532Z'%20fill='%233A56F6'/%3e%3cpath%20d='M195.518%20588.974L195.503%20599.855L185.989%20594.417V583.532L195.518%20588.974Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M137.903%20545.395L128.399%20550.837L118.871%20545.395L128.384%20539.952L137.903%20545.395Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M137.902%20545.395V556.28L128.384%20561.718L128.399%20550.837L137.902%20545.395Z'%20fill='%233A56F6'/%3e%3cpath%20d='M128.399%20550.837L128.384%20561.718L118.871%20556.28V545.395L128.399%20550.837Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M118.871%20545.525L195.297%20589.284L205.022%20583.73V581.85L128.536%20541.028L118.871%20543.64V545.525Z'%20fill='%230226F4'/%3e%3cpath%20d='M118.871%20543.64L195.297%20587.399L205.022%20581.85L128.536%20538.12L118.871%20543.64Z'%20fill='%233A56F6'/%3e%3cpath%20d='M53%20595.837L129.432%20639.596L139.151%20634.047V632.167L62.6653%20591.344L53%20593.957V595.837Z'%20fill='%230226F4'/%3e%3cpath%20d='M53%20593.957L129.432%20637.716L139.151%20632.167L62.6653%20588.432L53%20593.957Z'%20fill='%231E3EF5'/%3e%3cpath%20d='M139.151%20621.286L129.647%20626.729L120.119%20621.286L129.632%20615.844L139.151%20621.286Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M139.151%20621.286V632.167L129.632%20637.609L129.647%20626.729L139.151%20621.286Z'%20fill='%233A56F6'/%3e%3cpath%20d='M129.647%20626.729L129.632%20637.609L120.119%20632.167V621.286L129.647%20626.729Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M72.032%20583.149L62.5283%20588.592L53%20583.149L62.5185%20577.706L72.032%20583.149Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M72.0318%20583.149V594.029L62.5182%20599.472L62.528%20588.592L72.0318%20583.149Z'%20fill='%233A56F6'/%3e%3cpath%20d='M62.5283%20588.592L62.5185%20599.472L53%20594.029V583.149L62.5283%20588.592Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M53%20583.275L129.432%20627.034L139.151%20621.485V619.604L62.6653%20578.782L53%20581.394V583.275Z'%20fill='%230226F4'/%3e%3cpath%20d='M53%20581.394L129.432%20625.154L139.151%20619.604L62.6653%20575.869L53%20581.394Z'%20fill='%237286F9'/%3e%3cpath%20d='M187.977%20572.123L112.377%20615.407L102.761%20609.916V607.033L178.414%20566.656L187.977%20569.239V572.123Z'%20fill='%233A56F6'/%3e%3cpath%20d='M187.977%20569.239L112.377%20612.524L102.761%20607.032L178.414%20563.777L187.977%20569.239Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M171.396%20562.648L95.7965%20605.932L86.1802%20600.441V597.562L161.839%20557.186L171.396%20559.769V562.648Z'%20fill='%233A56F6'/%3e%3cpath%20d='M171.396%20559.769L95.7965%20603.053L86.1802%20597.562L161.839%20554.307L171.396%20559.769Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M155.056%20553.178L79.4559%20596.462L69.8396%20590.971V588.092L145.493%20547.716L155.056%20550.299V553.178Z'%20fill='%233A56F6'/%3e%3cpath%20d='M155.056%20550.299L79.4559%20593.584L69.8396%20588.092L145.493%20544.833L155.056%20550.299Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M138.216%20543.708L62.6163%20586.992L53%20581.501V578.618L128.653%20538.241L138.216%20540.829V543.708Z'%20fill='%233A56F6'/%3e%3cpath%20d='M138.216%20540.829L62.6163%20584.113L53%20578.617L128.653%20535.362L138.216%20540.829Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M205.075%20581.85L129.47%20625.134L119.859%20619.643V616.764L195.512%20576.388L205.075%20578.971V581.85Z'%20fill='%233A56F6'/%3e%3cpath%20d='M205.075%20578.971L129.47%20622.256L119.859%20616.764L195.512%20573.504L205.075%20578.971Z'%20fill='%238F9FFA'/%3e%3cpath%20d='M169.125%20474.107L204.238%20494.211L239.449%20474.107L204.287%20453.999L169.125%20474.107Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M169.125%20474.107V514.314L204.287%20534.417L204.238%20494.211L169.125%20474.107Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M204.238%20494.211L204.287%20534.417L239.449%20514.314V474.107L204.238%20494.211Z'%20fill='%23E6E9FE'/%3e%3cpath%20d='M226.216%20510.868V512.365C226.226%20513.451%20226.951%20513.926%20227.875%20513.509L227.885%20516.092L227.068%20516.558C226.951%20516.625%20226.858%20516.785%20226.858%20516.916C226.858%20517.047%20226.951%20517.1%20227.068%20517.037L229.084%20515.884C229.202%20515.816%20229.295%20515.656%20229.295%20515.525C229.295%20515.394%20229.202%20515.341%20229.084%20515.404L228.272%20515.869L228.262%20513.286C229.187%20512.646%20229.906%20511.343%20229.906%20510.257V508.76L228.933%20509.312L228.654%20510.306L229.148%20510.005L228.404%20512.549L228.644%20510.722L228.154%20510.984L228.389%20509.622L226.212%20510.868H226.216Z'%20fill='%233A56F6'/%3e%3cpath%20d='M176.172%20506.593L176.711%20505.842L175.389%20502.464L174.181%20504.146L173.632%20503.472L174.332%20506.545L176.716%20507.267L176.172%20506.593Z'%20fill='%233A56F6'/%3e%3cpath%20d='M173.143%20505.551L171.426%20507.945L172.747%20511.323L175.135%20508.004L173.143%20505.551Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.57%20510.485L174.499%20509.87L173.158%20511.726L175.565%20513.102V513.824L177.249%20512.753L175.575%20509.763L175.57%20510.485Z'%20fill='%233A56F6'/%3e%3cpath%20d='M179.618%20512.308L182.275%20513.829L181.076%20510.771L181.629%20510.723L179.246%20508.716L178.531%20510.984L179.079%20510.941L179.618%20512.308Z'%20fill='%233A56F6'/%3e%3cpath%20d='M181.012%20516.224L182.348%20514.362L177.606%20511.648L177.597%20514.27L181.012%20516.224Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.727%20502.333L178.086%20508.367L180.082%20508.198L178.384%20503.85L175.727%20502.333Z'%20fill='%233A56F6'/%3e%3cpath%20d='M237.115%20510.413L231.849%20513.417L231.854%20514.363L237.115%20511.358V510.413Z'%20fill='%233A56F6'/%3e%3cpath%20d='M236.131%20510.422L236.121%20506.569L236.581%20506.307L235.681%20505.527L234.795%20507.325L235.255%20507.063L235.265%20510.921L236.131%20510.422Z'%20fill='%233A56F6'/%3e%3cpath%20d='M233.694%20511.818L233.684%20507.96L234.145%20507.698L233.249%20506.918L232.358%20508.716L232.818%20508.454L232.828%20512.312L233.694%20511.818Z'%20fill='%233A56F6'/%3e%3cpath%20d='M221.18%20514.716C219.702%20515.598%20218.523%20517.222%20218.528%20518.385C218.543%20518.365%20218.836%20517.949%20219.213%20517.73C219.595%20517.512%20219.888%20517.595%20219.903%20517.595C219.918%20517.575%20220.211%20517.159%20220.588%20516.94C220.843%20516.795%20221.068%20516.785%20221.185%20516.795L221.195%20519.587C221.195%20519.95%20221.454%20520.096%20221.777%20519.916C222.1%20519.737%20222.355%20519.291%20222.355%20518.928C222.355%20518.869%20222.316%20518.845%20222.262%20518.874C222.208%20518.903%20222.169%20518.971%20222.169%20519.029C222.169%20519.277%20221.993%20519.582%20221.773%20519.708C221.552%20519.834%20221.376%20519.732%20221.376%20519.485L221.366%20516.693C221.484%20516.548%20221.704%20516.306%20221.963%20516.16C222.345%20515.942%20222.639%20516.025%20222.653%20516.025C222.668%20516.005%20222.962%20515.588%20223.339%20515.37C223.715%20515.152%20224.014%20515.235%20224.029%20515.235C224.029%20514.071%20222.839%20513.8%20221.366%20514.609V514.328L221.18%20514.435V514.716Z'%20fill='%233A56F6'/%3e%3cpath%20d='M219.648%20515.254C219.746%20515.138%20219.776%20514.978%20219.722%20514.9C219.668%20514.823%20219.374%20514.871%20219.374%20514.876C219.374%20514.895%20219.316%20515.249%20219.374%20515.327C219.414%20515.38%20219.477%20515.38%20219.551%20515.341C219.585%20515.322%20219.619%20515.293%20219.648%20515.254Z'%20fill='%233A56F6'/%3e%3cpath%20d='M223.094%20513.287C223.192%20513.17%20223.221%20513.01%20223.168%20512.933C223.114%20512.855%20222.82%20512.904%20222.82%20512.909C222.82%20512.928%20222.761%20513.282%20222.82%20513.359C222.859%20513.413%20222.923%20513.413%20222.996%20513.374C223.031%20513.354%20223.065%20513.325%20223.094%20513.287Z'%20fill='%233A56F6'/%3e%3cpath%20d='M222.517%20512.826C222.615%20512.71%20222.644%20512.55%20222.59%20512.472C222.536%20512.395%20222.257%20512.443%20222.243%20512.448C222.243%20512.467%20222.184%20512.826%20222.243%20512.899C222.282%20512.952%20222.346%20512.952%20222.419%20512.913C222.453%20512.894%20222.487%20512.865%20222.517%20512.826Z'%20fill='%233A56F6'/%3e%3cpath%20d='M221.944%20513.941C222.042%20513.824%20222.071%20513.664%20222.017%20513.587C221.963%20513.509%20221.684%20513.558%20221.67%20513.563C221.67%20513.582%20221.611%20513.936%20221.67%20514.018C221.709%20514.071%20221.773%20514.071%20221.846%20514.033C221.88%20514.013%20221.914%20513.984%20221.944%20513.945V513.941Z'%20fill='%233A56F6'/%3e%3cpath%20d='M221.366%20513.485C221.464%20513.369%20221.494%20513.209%20221.44%20513.131C221.386%20513.053%20221.092%20513.102%20221.092%20513.107C221.092%20513.126%20221.034%20513.485%20221.092%20513.558C221.132%20513.611%20221.195%20513.611%20221.269%20513.572C221.303%20513.553%20221.337%20513.524%20221.366%20513.485Z'%20fill='%233A56F6'/%3e%3cpath%20d='M220.794%20514.6C220.892%20514.483%20220.921%20514.324%20220.867%20514.246C220.814%20514.168%20220.535%20514.217%20220.52%20514.222C220.52%20514.241%20220.461%20514.595%20220.52%20514.673C220.559%20514.726%20220.623%20514.726%20220.696%20514.687C220.73%20514.668%20220.765%20514.639%20220.794%20514.6Z'%20fill='%233A56F6'/%3e%3cpath%20d='M220.221%20514.139C220.319%20514.023%20220.349%20513.863%20220.295%20513.786C220.241%20513.708%20219.962%20513.756%20219.947%20513.761C219.947%20513.781%20219.889%20514.139%20219.947%20514.212C219.987%20514.265%20220.05%20514.265%20220.124%20514.227C220.158%20514.207%20220.192%20514.178%20220.221%20514.139Z'%20fill='%233A56F6'/%3e%3cpath%20d='M235.108%20473.724L205.026%20491.167'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M232.539%20472.261L202.423%20489.713'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M229.97%20470.802L199.815%20488.259'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M227.396%20469.343L197.211%20486.805'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M224.827%20467.884L194.607%20485.351'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M222.253%20466.426L192.004%20483.897'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M219.683%20464.967L189.396%20482.443'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M217.109%20463.508L186.792%20480.989'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M214.54%20462.044L184.189%20479.535'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M211.97%20460.585L181.585%20478.081'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M209.396%20459.127L178.976%20476.627'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M206.827%20457.668L176.373%20475.173'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M204.253%20456.209L173.769%20473.724'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M182.994%20485.414L182.97%20493.755L183.298%20493.939L183.322%20485.603L182.994%20485.414Z'%20fill='%233A56F6'/%3e%3cpath%20d='M182.202%20484.963L182.177%20492.156L182.334%20492.243L182.353%20485.051L182.202%20484.963Z'%20fill='%233A56F6'/%3e%3cpath%20d='M181.321%20484.459L181.297%20491.651L181.453%20491.739L181.473%20484.546L181.321%20484.459Z'%20fill='%233A56F6'/%3e%3cpath%20d='M180.371%20483.917L180.351%20491.109L180.635%20491.274L180.66%20484.081L180.371%20483.917Z'%20fill='%233A56F6'/%3e%3cpath%20d='M177.729%20482.405L177.709%20489.597L177.993%20489.762L178.013%20482.569L177.729%20482.405Z'%20fill='%233A56F6'/%3e%3cpath%20d='M179.554%20483.451L179.534%20490.643L179.691%20490.731L179.71%20483.538L179.554%20483.451Z'%20fill='%233A56F6'/%3e%3cpath%20d='M178.424%20482.802L178.404%20489.999L179.06%20490.372L179.079%20483.18L178.424%20482.802Z'%20fill='%233A56F6'/%3e%3cpath%20d='M171.538%20478.866L171.513%20487.202L171.846%20487.391L171.866%20479.055L171.538%20478.866Z'%20fill='%233A56F6'/%3e%3cpath%20d='M172.507%20479.419L172.487%20486.611L172.639%20486.703L172.664%20479.506L172.507%20479.419Z'%20fill='%233A56F6'/%3e%3cpath%20d='M173.388%20479.923L173.368%20487.115L173.52%20487.207L173.544%20480.01L173.388%20479.923Z'%20fill='%233A56F6'/%3e%3cpath%20d='M174.058%20480.306L174.039%20487.498L174.616%20487.833L174.636%20480.635L174.058%20480.306Z'%20fill='%233A56F6'/%3e%3cpath%20d='M176.848%20481.9L176.828%20489.093L177.112%20489.257L177.132%20482.065L176.848%20481.9Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.149%20480.931L175.13%20488.123L175.286%20488.215L175.306%20481.018L175.149%20480.931Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.781%20481.29L175.761%20488.487L176.417%20488.86L176.436%20481.668L175.781%20481.29Z'%20fill='%233A56F6'/%3e%3cpath%20d='M218.778%20485.642L218.793%20497.215L228.913%20491.429V479.855L218.778%20485.642Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M183.631%20465.616L218.778%20485.719L228.913%20479.933L193.751%20459.829L183.631%20465.616Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M206.744%20495.034L241.857%20515.138L277.068%20495.034L241.906%20474.926L206.744%20495.034Z'%20fill='%23929FF4'/%3e%3cpath%20d='M206.744%20495.034V535.241L241.906%20555.344L241.857%20515.138L206.744%20495.034Z'%20fill='%234055ED'/%3e%3cpath%20d='M241.857%20515.138L241.906%20555.344L277.068%20535.241V495.034L241.857%20515.138Z'%20fill='%237685F1'/%3e%3cpath%20d='M213.791%20527.521L214.33%20526.77L213.008%20523.392L211.8%20525.073L211.251%20524.4L211.951%20527.472L214.339%20528.194L213.791%20527.521Z'%20fill='%233A56F6'/%3e%3cpath%20d='M210.762%20526.479L209.044%20528.873L210.37%20532.251L212.754%20528.931L210.762%20526.479Z'%20fill='%233A56F6'/%3e%3cpath%20d='M213.194%20531.412L212.117%20530.797L210.781%20532.653L213.184%20534.029V534.752L214.867%20533.68L213.194%20530.69V531.412Z'%20fill='%233A56F6'/%3e%3cpath%20d='M217.236%20533.235L219.894%20534.756L218.699%20531.693L219.248%20531.65L216.864%20529.643L216.15%20531.911L216.703%20531.863L217.236%20533.235Z'%20fill='%233A56F6'/%3e%3cpath%20d='M218.636%20537.151L219.967%20535.289L215.225%20532.575L215.215%20535.197L218.636%20537.151Z'%20fill='%233A56F6'/%3e%3cpath%20d='M213.346%20523.26L215.705%20529.294L217.701%20529.125L216.003%20524.777L213.346%20523.26Z'%20fill='%233A56F6'/%3e%3cpath%20d='M272.732%20494.647L242.645%20512.094'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M270.158%20493.188L240.042%20510.64'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M267.589%20491.729L237.438%20509.186'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M265.014%20490.27L234.829%20507.732'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M262.445%20488.812L232.226%20506.278'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M259.871%20487.353L229.622%20504.824'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M257.302%20485.894L227.019%20503.371'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M254.733%20484.43L224.411%20501.916'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M252.159%20482.971L221.807%20500.462'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M249.589%20481.513L219.204%20499.009'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M247.015%20480.054L216.6%20497.554'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M244.446%20478.595L213.992%20496.101'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M241.871%20477.136L211.388%20494.647'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M220.613%20506.341L220.594%20514.682L220.917%20514.866L220.941%20506.53L220.613%20506.341Z'%20fill='%233A56F6'/%3e%3cpath%20d='M219.82%20505.886L219.801%20513.083L219.952%20513.17L219.977%20505.978L219.82%20505.886Z'%20fill='%233A56F6'/%3e%3cpath%20d='M218.939%20505.382L218.92%20512.579L219.072%20512.666L219.096%20505.474L218.939%20505.382Z'%20fill='%233A56F6'/%3e%3cpath%20d='M217.99%20504.844L217.97%20512.036L218.259%20512.201L218.278%20505.009L217.99%20504.844Z'%20fill='%233A56F6'/%3e%3cpath%20d='M215.347%20503.332L215.328%20510.524L215.612%20510.689L215.636%20503.497L215.347%20503.332Z'%20fill='%233A56F6'/%3e%3cpath%20d='M217.177%20504.379L217.153%20511.571L217.309%20511.658L217.329%20504.466L217.177%20504.379Z'%20fill='%233A56F6'/%3e%3cpath%20d='M216.047%20503.729L216.023%20510.926L216.678%20511.299L216.703%20504.107L216.047%20503.729Z'%20fill='%233A56F6'/%3e%3cpath%20d='M209.157%20499.794L209.137%20508.13L209.465%20508.319L209.489%20499.983L209.157%20499.794Z'%20fill='%233A56F6'/%3e%3cpath%20d='M210.126%20500.346L210.106%20507.538L210.263%20507.631L210.282%20500.433L210.126%20500.346Z'%20fill='%233A56F6'/%3e%3cpath%20d='M211.007%20500.85L210.987%20508.043L211.144%20508.135L211.163%20500.938L211.007%20500.85Z'%20fill='%233A56F6'/%3e%3cpath%20d='M211.677%20501.233L211.658%20508.425L212.235%20508.76L212.26%20501.563L211.677%20501.233Z'%20fill='%233A56F6'/%3e%3cpath%20d='M214.466%20502.828L214.447%20510.02L214.731%20510.185L214.75%20502.992L214.466%20502.828Z'%20fill='%233A56F6'/%3e%3cpath%20d='M212.768%20501.858L212.749%20509.05L212.905%20509.142L212.925%20501.945L212.768%20501.858Z'%20fill='%233A56F6'/%3e%3cpath%20d='M213.4%20502.217L213.38%20509.414L214.036%20509.787L214.055%20502.595L213.4%20502.217Z'%20fill='%233A56F6'/%3e%3cpath%20d='M256.402%20506.569L256.411%20518.142L266.537%20512.356V500.782L256.402%20506.569Z'%20fill='%234055ED'/%3e%3cpath%20d='M221.249%20486.544L256.402%20506.647L266.537%20500.86L231.375%20480.757L221.249%20486.544Z'%20fill='%234055ED'/%3e%3cpath%20d='M169.125%20431.816L204.238%20451.92L239.449%20431.816L204.287%20411.713L169.125%20431.816Z'%20fill='%23929FF4'/%3e%3cpath%20d='M169.125%20431.816V472.028L204.287%20492.131L204.238%20451.92L169.125%20431.816Z'%20fill='%234055ED'/%3e%3cpath%20d='M204.238%20451.92L204.287%20492.132L239.449%20472.028V431.817L204.238%20451.92Z'%20fill='%237685F1'/%3e%3cpath%20d='M226.216%20468.582V470.08C226.226%20471.165%20226.951%20471.64%20227.875%20471.223L227.885%20473.807L227.068%20474.272C226.951%20474.34%20226.858%20474.5%20226.858%20474.631C226.858%20474.761%20226.951%20474.815%20227.068%20474.752L229.084%20473.598C229.202%20473.53%20229.295%20473.37%20229.295%20473.24C229.295%20473.109%20229.202%20473.055%20229.084%20473.118L228.272%20473.584L228.262%20471.001C229.187%20470.361%20229.906%20469.057%20229.906%20467.971V466.474L228.933%20467.026L228.654%20468.02L229.148%20467.719L228.404%20470.264L228.644%20468.437L228.154%20468.698L228.389%20467.337L226.212%20468.582H226.216Z'%20fill='%233A56F6'/%3e%3cpath%20d='M176.172%20464.308L176.711%20463.552L175.389%20460.174L174.181%20461.855L173.632%20461.182L174.332%20464.259L176.716%20464.981L176.172%20464.308Z'%20fill='%233A56F6'/%3e%3cpath%20d='M173.143%20463.265L171.426%20465.655L172.747%20469.033L175.135%20465.713L173.143%20463.265Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.57%20468.194L174.499%20467.579L173.158%20469.44L175.565%20470.816V471.534L177.249%20470.467L175.575%20467.477L175.57%20468.194Z'%20fill='%233A56F6'/%3e%3cpath%20d='M179.618%20470.022L182.275%20471.539L181.076%20468.48L181.629%20468.432L179.246%20466.43L178.531%20468.699L179.079%20468.65L179.618%20470.022Z'%20fill='%233A56F6'/%3e%3cpath%20d='M181.012%20473.933L182.348%20472.077L177.606%20469.363L177.597%20471.98L181.012%20473.933Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.727%20460.047L178.086%20466.076L180.082%20465.907L178.384%20461.564L175.727%20460.047Z'%20fill='%233A56F6'/%3e%3cpath%20d='M237.115%20468.122L231.849%20471.132L231.854%20472.077L237.115%20469.067V468.122Z'%20fill='%233A56F6'/%3e%3cpath%20d='M236.131%20468.136L236.121%20464.278L236.581%20464.017L235.681%20463.236L234.795%20465.039L235.255%20464.778L235.265%20468.631L236.131%20468.136Z'%20fill='%233A56F6'/%3e%3cpath%20d='M233.694%20469.527L233.684%20465.674L234.145%20465.408L233.249%20464.632L232.358%20466.43L232.818%20466.168L232.828%20470.026L233.694%20469.527Z'%20fill='%233A56F6'/%3e%3cpath%20d='M221.18%20472.43C219.702%20473.312%20218.523%20474.936%20218.528%20476.099C218.543%20476.08%20218.836%20475.663%20219.213%20475.445C219.595%20475.227%20219.888%20475.309%20219.903%20475.309C219.918%20475.29%20220.211%20474.873%20220.588%20474.655C220.843%20474.509%20221.068%20474.5%20221.185%20474.509L221.195%20477.301C221.195%20477.665%20221.454%20477.81%20221.777%20477.631C222.1%20477.451%20222.355%20477.005%20222.355%20476.642C222.355%20476.584%20222.316%20476.56%20222.262%20476.589C222.208%20476.618%20222.169%20476.686%20222.169%20476.744C222.169%20476.991%20221.993%20477.296%20221.773%20477.422C221.552%20477.548%20221.376%20477.446%20221.376%20477.199L221.366%20474.408C221.484%20474.262%20221.704%20474.02%20221.963%20473.875C222.345%20473.656%20222.639%20473.739%20222.653%20473.739C222.668%20473.719%20222.962%20473.303%20223.339%20473.085C223.715%20472.866%20224.014%20472.949%20224.029%20472.949C224.029%20471.786%20222.839%20471.514%20221.366%20472.324V472.043L221.18%20472.149V472.43Z'%20fill='%233A56F6'/%3e%3cpath%20d='M219.648%20472.968C219.746%20472.852%20219.776%20472.692%20219.722%20472.614C219.668%20472.537%20219.374%20472.585%20219.374%20472.59C219.374%20472.61%20219.316%20472.963%20219.374%20473.041C219.414%20473.094%20219.477%20473.094%20219.551%20473.055C219.585%20473.036%20219.619%20473.007%20219.648%20472.968Z'%20fill='%233A56F6'/%3e%3cpath%20d='M223.094%20470.996C223.192%20470.879%20223.221%20470.72%20223.168%20470.642C223.114%20470.564%20222.82%20470.613%20222.82%20470.618C222.82%20470.637%20222.761%20470.991%20222.82%20471.069C222.859%20471.122%20222.923%20471.122%20222.996%20471.083C223.031%20471.064%20223.065%20471.035%20223.094%20470.996Z'%20fill='%233A56F6'/%3e%3cpath%20d='M222.517%20470.54C222.615%20470.424%20222.644%20470.264%20222.59%20470.186C222.536%20470.109%20222.257%20470.157%20222.243%20470.162C222.243%20470.182%20222.184%20470.54%20222.243%20470.613C222.282%20470.666%20222.346%20470.666%20222.419%20470.627C222.453%20470.608%20222.487%20470.579%20222.517%20470.54Z'%20fill='%233A56F6'/%3e%3cpath%20d='M221.944%20471.655C222.042%20471.538%20222.071%20471.378%20222.017%20471.301C221.963%20471.223%20221.684%20471.272%20221.67%20471.277C221.67%20471.296%20221.611%20471.65%20221.67%20471.732C221.709%20471.786%20221.773%20471.786%20221.846%20471.747C221.88%20471.727%20221.914%20471.698%20221.944%20471.66V471.655Z'%20fill='%233A56F6'/%3e%3cpath%20d='M221.366%20471.194C221.464%20471.078%20221.494%20470.918%20221.44%20470.841C221.386%20470.763%20221.092%20470.811%20221.092%20470.816C221.092%20470.836%20221.034%20471.194%20221.092%20471.267C221.132%20471.32%20221.195%20471.32%20221.269%20471.282C221.303%20471.262%20221.337%20471.233%20221.366%20471.194Z'%20fill='%233A56F6'/%3e%3cpath%20d='M220.794%20472.309C220.892%20472.193%20220.921%20472.033%20220.867%20471.955C220.814%20471.878%20220.535%20471.926%20220.52%20471.931C220.52%20471.95%20220.461%20472.304%20220.52%20472.382C220.559%20472.435%20220.623%20472.435%20220.696%20472.396C220.73%20472.377%20220.765%20472.348%20220.794%20472.309Z'%20fill='%233A56F6'/%3e%3cpath%20d='M220.221%20471.853C220.319%20471.737%20220.349%20471.577%20220.295%20471.5C220.241%20471.422%20219.962%20471.471%20219.947%20471.475C219.947%20471.495%20219.889%20471.853%20219.947%20471.926C219.987%20471.979%20220.05%20471.979%20220.124%20471.941C220.158%20471.921%20220.192%20471.892%20220.221%20471.853Z'%20fill='%233A56F6'/%3e%3cpath%20d='M182.994%20443.128L182.97%20451.464L183.298%20451.653L183.322%20443.313L182.994%20443.128Z'%20fill='%233A56F6'/%3e%3cpath%20d='M182.202%20442.673L182.177%20449.865L182.334%20449.957L182.353%20442.76L182.202%20442.673Z'%20fill='%233A56F6'/%3e%3cpath%20d='M181.321%20442.169L181.297%20449.361L181.453%20449.453L181.473%20442.256L181.321%20442.169Z'%20fill='%233A56F6'/%3e%3cpath%20d='M180.371%20441.626L180.351%20448.823L180.635%20448.988L180.66%20441.791L180.371%20441.626Z'%20fill='%233A56F6'/%3e%3cpath%20d='M177.729%20440.114L177.709%20447.311L177.993%20447.476L178.013%20440.279L177.729%20440.114Z'%20fill='%233A56F6'/%3e%3cpath%20d='M179.554%20441.16L179.534%20448.357L179.691%20448.445L179.71%20441.248L179.554%20441.16Z'%20fill='%233A56F6'/%3e%3cpath%20d='M178.424%20440.516L178.404%20447.708L179.06%20448.086L179.079%20440.889L178.424%20440.516Z'%20fill='%233A56F6'/%3e%3cpath%20d='M171.538%20436.576L171.513%20444.917L171.846%20445.101L171.866%20436.765L171.538%20436.576Z'%20fill='%233A56F6'/%3e%3cpath%20d='M172.507%20437.128L172.487%20444.325L172.639%20444.412L172.664%20437.22L172.507%20437.128Z'%20fill='%233A56F6'/%3e%3cpath%20d='M173.388%20437.632L173.368%20444.829L173.52%20444.916L173.544%20437.724L173.388%20437.632Z'%20fill='%233A56F6'/%3e%3cpath%20d='M174.058%20438.015L174.039%20445.212L174.616%20445.542L174.636%20438.35L174.058%20438.015Z'%20fill='%233A56F6'/%3e%3cpath%20d='M176.848%20439.615L176.828%20446.807L177.112%20446.972L177.132%20439.774L176.848%20439.615Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.149%20438.64L175.13%20445.837L175.286%20445.925L175.306%20438.732L175.149%20438.64Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.781%20439.004L175.761%20446.196L176.417%20446.574L176.436%20439.377L175.781%20439.004Z'%20fill='%233A56F6'/%3e%3cpath%20d='M218.778%20443.351L218.793%20454.925L228.913%20449.138V437.565L218.778%20443.351Z'%20fill='%234055ED'/%3e%3cpath%20d='M183.631%20423.33L218.778%20443.434L228.913%20437.647L193.751%20417.543L183.631%20423.33Z'%20fill='%234055ED'/%3e%3cpath%20d='M206.744%20452.744L241.857%20472.847L277.068%20452.744L241.906%20432.64L206.744%20452.744Z'%20fill='%23929FF4'/%3e%3cpath%20d='M206.744%20452.744V492.955L241.906%20513.059L241.857%20472.847L206.744%20452.744Z'%20fill='%234055ED'/%3e%3cpath%20d='M241.857%20472.847L241.906%20513.059L277.068%20492.955V452.744L241.857%20472.847Z'%20fill='%237685F1'/%3e%3cpath%20d='M213.791%20485.235L214.33%20484.479L213.008%20481.101L211.8%20482.783L211.251%20482.109L211.951%20485.182L214.339%20485.909L213.791%20485.235Z'%20fill='%233A56F6'/%3e%3cpath%20d='M210.762%20484.193L209.044%20486.582L210.37%20489.96L212.754%20486.64L210.762%20484.193Z'%20fill='%233A56F6'/%3e%3cpath%20d='M213.194%20489.122L212.117%20488.506L210.781%20490.367L213.184%20491.744V492.461L214.867%20491.395L213.194%20488.404V489.122Z'%20fill='%233A56F6'/%3e%3cpath%20d='M217.236%20490.944L219.894%20492.466L218.699%20489.408L219.248%20489.359L216.864%20487.358L216.15%20489.626L216.703%20489.577L217.236%20490.944Z'%20fill='%233A56F6'/%3e%3cpath%20d='M218.636%20494.86L219.967%20492.999L215.225%20490.29L215.215%20492.907L218.636%20494.86Z'%20fill='%233A56F6'/%3e%3cpath%20d='M213.346%20480.975L215.705%20487.004L217.701%20486.834L216.003%20482.492L213.346%20480.975Z'%20fill='%233A56F6'/%3e%3cpath%20d='M220.613%20464.055L220.594%20472.391L220.917%20472.58L220.941%20464.24L220.613%20464.055Z'%20fill='%233A56F6'/%3e%3cpath%20d='M219.82%20463.6L219.801%20470.792L219.952%20470.884L219.977%20463.687L219.82%20463.6Z'%20fill='%233A56F6'/%3e%3cpath%20d='M218.939%20463.096L218.92%20470.288L219.072%20470.38L219.096%20463.183L218.939%20463.096Z'%20fill='%233A56F6'/%3e%3cpath%20d='M217.99%20462.553L217.97%20469.75L218.259%20469.915L218.278%20462.718L217.99%20462.553Z'%20fill='%233A56F6'/%3e%3cpath%20d='M215.347%20461.041L215.328%20468.238L215.612%20468.403L215.636%20461.206L215.347%20461.041Z'%20fill='%233A56F6'/%3e%3cpath%20d='M217.177%20462.088L217.153%20469.285L217.309%20469.372L217.329%20462.175L217.177%20462.088Z'%20fill='%233A56F6'/%3e%3cpath%20d='M216.047%20461.443L216.023%20468.635L216.678%20469.013L216.703%20461.816L216.047%20461.443Z'%20fill='%233A56F6'/%3e%3cpath%20d='M209.157%20457.503L209.137%20465.844L209.465%20466.028L209.489%20457.692L209.157%20457.503Z'%20fill='%233A56F6'/%3e%3cpath%20d='M210.126%20458.056L210.106%20465.253L210.263%20465.34L210.282%20458.148L210.126%20458.056Z'%20fill='%233A56F6'/%3e%3cpath%20d='M211.007%20458.56L210.987%20465.757L211.144%20465.844L211.163%20458.652L211.007%20458.56Z'%20fill='%233A56F6'/%3e%3cpath%20d='M211.677%20458.942L211.658%20466.139L212.235%20466.469L212.26%20459.277L211.677%20458.942Z'%20fill='%233A56F6'/%3e%3cpath%20d='M214.466%20460.537L214.447%20467.734L214.731%20467.899L214.75%20460.702L214.466%20460.537Z'%20fill='%233A56F6'/%3e%3cpath%20d='M212.768%20459.568L212.749%20466.765L212.905%20466.852L212.925%20459.66L212.768%20459.568Z'%20fill='%233A56F6'/%3e%3cpath%20d='M213.4%20459.931L213.38%20467.123L214.036%20467.501L214.055%20460.304L213.4%20459.931Z'%20fill='%233A56F6'/%3e%3cpath%20d='M256.402%20464.278L256.411%20475.852L266.537%20470.065V458.492L256.402%20464.278Z'%20fill='%234055ED'/%3e%3cpath%20d='M221.249%20444.258L256.402%20464.361L266.537%20458.574L231.375%20438.471L221.249%20444.258Z'%20fill='%234055ED'/%3e%3cpath%20d='M131.477%20495.509L166.59%20515.613L201.801%20495.509L166.639%20475.406L131.477%20495.509Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M131.477%20495.509V535.721L166.639%20555.824L166.59%20515.613L131.477%20495.509Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M166.59%20515.613L166.639%20555.824L201.801%20535.721V495.509L166.59%20515.613Z'%20fill='%23E6E9FE'/%3e%3cpath%20d='M188.568%20532.275V533.773C188.578%20534.858%20189.302%20535.333%20190.227%20534.917L190.237%20537.5L189.42%20537.965C189.302%20538.033%20189.209%20538.193%20189.209%20538.324C189.209%20538.455%20189.302%20538.508%20189.42%20538.445L191.436%20537.291C191.553%20537.224%20191.646%20537.064%20191.646%20536.933C191.646%20536.802%20191.553%20536.749%20191.436%20536.812L190.623%20537.277L190.614%20534.694C191.539%20534.054%20192.258%20532.75%20192.258%20531.665V530.167L191.284%20530.719L191.005%20531.713L191.499%20531.413L190.756%20533.957L190.995%20532.13L190.506%20532.392L190.741%20531.03L188.563%20532.275H188.568Z'%20fill='%233A56F6'/%3e%3cpath%20d='M138.524%20528.001L139.063%20527.244L137.741%20523.866L136.532%20525.548L135.984%20524.875L136.684%20527.947L139.072%20528.674L138.524%20528.001Z'%20fill='%233A56F6'/%3e%3cpath%20d='M135.495%20526.958L133.777%20529.348L135.099%20532.726L137.487%20529.406L135.495%20526.958Z'%20fill='%233A56F6'/%3e%3cpath%20d='M137.927%20531.887L136.851%20531.272L135.515%20533.133L137.918%20534.509V535.226L139.601%20534.16L137.927%20531.17V531.887Z'%20fill='%233A56F6'/%3e%3cpath%20d='M141.969%20533.709L144.626%20535.231L143.432%20532.173L143.98%20532.125L141.597%20530.123L140.883%20532.391L141.431%20532.343L141.969%20533.709Z'%20fill='%233A56F6'/%3e%3cpath%20d='M143.369%20537.625L144.7%20535.764L139.958%20533.055L139.948%20535.672L143.369%20537.625Z'%20fill='%233A56F6'/%3e%3cpath%20d='M138.079%20523.74L140.438%20529.769L142.434%20529.6L140.736%20525.257L138.079%20523.74Z'%20fill='%233A56F6'/%3e%3cpath%20d='M199.467%20531.815L194.201%20534.824L194.206%20535.769L199.467%20532.76V531.815Z'%20fill='%233A56F6'/%3e%3cpath%20d='M198.483%20531.829L198.473%20527.971L198.933%20527.71L198.033%20526.929L197.147%20528.732L197.607%20528.466L197.617%20532.324L198.483%20531.829Z'%20fill='%233A56F6'/%3e%3cpath%20d='M196.051%20533.22L196.036%20529.362L196.496%20529.101L195.601%20528.32L194.71%20530.123L195.17%20529.862L195.18%20533.714L196.051%20533.22Z'%20fill='%233A56F6'/%3e%3cpath%20d='M183.533%20536.123C182.055%20537.005%20180.876%20538.629%20180.881%20539.792C180.895%20539.773%20181.189%20539.356%20181.566%20539.138C181.947%20538.92%20182.241%20539.002%20182.256%20539.002C182.27%20538.983%20182.564%20538.566%20182.941%20538.348C183.195%20538.202%20183.421%20538.193%20183.538%20538.202L183.548%20540.994C183.548%20541.357%20183.807%20541.503%20184.13%20541.323C184.453%20541.144%20184.708%20540.698%20184.708%20540.335C184.708%20540.277%20184.668%20540.252%20184.615%20540.281C184.561%20540.311%20184.522%20540.378%20184.522%20540.437C184.522%20540.684%20184.345%20540.989%20184.125%20541.115C183.905%20541.241%20183.729%20541.139%20183.729%20540.892L183.719%20538.101C183.836%20537.955%20184.057%20537.713%20184.316%20537.567C184.698%20537.349%20184.991%20537.432%20185.006%20537.432C185.021%20537.412%20185.314%20536.996%20185.691%20536.777C186.068%20536.559%20186.367%20536.642%20186.381%20536.642C186.381%20535.479%20185.192%20535.207%20183.719%20536.017V535.735L183.533%20535.842V536.123Z'%20fill='%233A56F6'/%3e%3cpath%20d='M182.001%20536.661C182.099%20536.545%20182.128%20536.385%20182.074%20536.307C182.021%20536.23%20181.727%20536.278%20181.727%20536.283C181.727%20536.302%20181.668%20536.656%20181.727%20536.734C181.766%20536.787%20181.83%20536.787%20181.903%20536.748C181.937%20536.729%20181.972%20536.7%20182.001%20536.661Z'%20fill='%233A56F6'/%3e%3cpath%20d='M185.446%20534.689C185.544%20534.572%20185.573%20534.412%20185.519%20534.335C185.465%20534.257%20185.172%20534.306%20185.172%20534.311C185.172%20534.33%20185.113%20534.684%20185.172%20534.761C185.211%20534.815%20185.275%20534.815%20185.348%20534.776C185.382%20534.757%20185.417%20534.727%20185.446%20534.689Z'%20fill='%233A56F6'/%3e%3cpath%20d='M184.869%20534.233C184.966%20534.117%20184.996%20533.957%20184.942%20533.879C184.888%20533.802%20184.609%20533.85%20184.594%20533.855C184.594%20533.874%20184.536%20534.233%20184.594%20534.306C184.634%20534.359%20184.697%20534.359%20184.771%20534.32C184.805%20534.301%20184.839%20534.272%20184.869%20534.233Z'%20fill='%233A56F6'/%3e%3cpath%20d='M184.296%20535.348C184.394%20535.231%20184.423%20535.071%20184.37%20534.994C184.316%20534.916%20184.037%20534.965%20184.022%20534.97C184.022%20534.989%20183.963%20535.343%20184.022%20535.425C184.061%20535.478%20184.125%20535.478%20184.198%20535.44C184.232%20535.42%20184.267%20535.391%20184.296%20535.352V535.348Z'%20fill='%233A56F6'/%3e%3cpath%20d='M183.719%20534.887C183.817%20534.771%20183.846%20534.611%20183.792%20534.534C183.738%20534.456%20183.445%20534.505%20183.445%20534.509C183.445%20534.529%20183.386%20534.887%20183.445%20534.96C183.484%20535.013%20183.547%20535.013%20183.621%20534.975C183.655%20534.955%20183.689%20534.926%20183.719%20534.887Z'%20fill='%233A56F6'/%3e%3cpath%20d='M183.151%20536.002C183.249%20535.886%20183.278%20535.726%20183.224%20535.648C183.17%20535.571%20182.891%20535.619%20182.877%20535.624C182.877%20535.644%20182.818%20535.997%20182.877%20536.075C182.916%20536.128%20182.979%20536.128%20183.053%20536.089C183.087%20536.07%20183.121%20536.041%20183.151%20536.002Z'%20fill='%233A56F6'/%3e%3cpath%20d='M182.573%20535.546C182.671%20535.43%20182.701%20535.27%20182.647%20535.193C182.593%20535.115%20182.314%20535.163%20182.299%20535.168C182.299%20535.188%20182.241%20535.546%20182.299%20535.619C182.338%20535.672%20182.402%20535.672%20182.475%20535.634C182.51%20535.614%20182.544%20535.585%20182.573%20535.546Z'%20fill='%233A56F6'/%3e%3cpath%20d='M197.465%20495.127L167.378%20512.569'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M194.891%20493.668L164.775%20511.115'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M192.322%20492.209L162.171%20509.661'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M189.748%20490.75L159.563%20508.212'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M187.178%20489.287L156.959%20506.758'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M184.604%20487.828L154.356%20505.304'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M182.035%20486.369L151.752%20503.85'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M179.466%20484.91L149.144%20502.396'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M176.892%20483.451L146.541%20500.942'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M174.322%20481.992L143.937%20499.488'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M171.748%20480.529L141.333%20498.034'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M169.179%20479.07L138.725%20496.581'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M166.605%20477.611L136.122%20495.126'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M145.346%20506.821L145.327%20515.157L145.65%20515.346L145.674%20507.005L145.346%20506.821Z'%20fill='%233A56F6'/%3e%3cpath%20d='M144.553%20506.366L144.534%20513.558L144.685%20513.65L144.71%20506.453L144.553%20506.366Z'%20fill='%233A56F6'/%3e%3cpath%20d='M143.673%20505.862L143.648%20513.054L143.805%20513.146L143.824%20505.949L143.673%20505.862Z'%20fill='%233A56F6'/%3e%3cpath%20d='M142.723%20505.319L142.703%20512.516L142.992%20512.681L143.012%20505.484L142.723%20505.319Z'%20fill='%233A56F6'/%3e%3cpath%20d='M140.08%20503.807L140.061%20511.004L140.345%20511.169L140.369%20503.972L140.08%20503.807Z'%20fill='%233A56F6'/%3e%3cpath%20d='M141.911%20504.854L141.886%20512.046L142.043%20512.138L142.063%20504.941L141.911%20504.854Z'%20fill='%233A56F6'/%3e%3cpath%20d='M140.78%20504.209L140.756%20511.401L141.412%20511.774L141.436%20504.582L140.78%20504.209Z'%20fill='%233A56F6'/%3e%3cpath%20d='M133.89%20500.269L133.87%20508.605L134.198%20508.794L134.223%20500.458L133.89%20500.269Z'%20fill='%233A56F6'/%3e%3cpath%20d='M134.859%20500.821L134.839%20508.018L134.996%20508.106L135.016%20500.913L134.859%20500.821Z'%20fill='%233A56F6'/%3e%3cpath%20d='M135.74%20501.325L135.72%20508.523L135.877%20508.61L135.896%20501.418L135.74%20501.325Z'%20fill='%233A56F6'/%3e%3cpath%20d='M136.41%20501.708L136.391%20508.905L136.968%20509.235L136.988%20502.042L136.41%20501.708Z'%20fill='%233A56F6'/%3e%3cpath%20d='M139.2%20503.303L139.18%20510.5L139.464%20510.665L139.483%20503.468L139.2%20503.303Z'%20fill='%233A56F6'/%3e%3cpath%20d='M137.501%20502.333L137.482%20509.53L137.638%20509.618L137.658%20502.425L137.501%20502.333Z'%20fill='%233A56F6'/%3e%3cpath%20d='M138.132%20502.697L138.113%20509.889L138.769%20510.267L138.788%20503.07L138.132%20502.697Z'%20fill='%233A56F6'/%3e%3cpath%20d='M181.135%20507.044L181.145%20518.618L191.265%20512.831V501.257L181.135%20507.044Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M145.983%20487.023L181.135%20507.126L191.265%20501.34L156.108%20481.236L145.983%20487.023Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M169.096%20516.437L204.209%20536.54L239.42%20516.437L204.258%20496.333L169.096%20516.437Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M169.096%20516.437V556.648L204.258%20576.752L204.209%20536.54L169.096%20516.437Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M204.209%20536.54L204.258%20576.752L239.42%20556.648V516.437L204.209%20536.54Z'%20fill='%23E6E9FE'/%3e%3cpath%20d='M176.143%20548.928L176.686%20548.172L175.365%20544.794L174.151%20546.475L173.608%20545.802L174.303%20548.874L176.691%20549.601L176.143%20548.928Z'%20fill='%233A56F6'/%3e%3cpath%20d='M173.119%20547.886L171.396%20550.275L172.722%20553.653L175.106%20550.333L173.119%20547.886Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.546%20552.815L174.469%20552.199L173.133%20554.06L175.536%20555.437V556.154L177.219%20555.083L175.546%20552.097V552.815Z'%20fill='%233A56F6'/%3e%3cpath%20d='M179.588%20554.637L182.245%20556.159L181.051%20553.101L181.599%20553.052L179.216%20551.051L178.502%20553.319L179.055%20553.27L179.588%20554.637Z'%20fill='%233A56F6'/%3e%3cpath%20d='M180.988%20558.553L182.324%20556.692L177.577%20553.983L177.567%20556.6L180.988%20558.553Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.698%20544.663L178.057%20550.697L180.053%20550.527L178.355%20546.185L175.698%20544.663Z'%20fill='%233A56F6'/%3e%3cpath%20d='M235.084%20516.054L204.997%20533.496'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M232.51%20514.595L202.393%20532.042'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M229.94%20513.136L199.79%20530.589'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M227.372%20511.673L197.182%20529.135'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M224.797%20510.214L194.578%20527.685'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M222.228%20508.755L191.974%20526.231'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M219.654%20507.296L189.371%20524.778'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M217.085%20505.837L186.767%20523.323'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M214.511%20504.379L184.159%20521.87'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M211.941%20502.92L181.555%20520.416'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M209.367%20501.456L178.952%20518.962'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M206.797%20499.997L176.348%20517.508'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M204.229%20498.539L173.74%20516.054'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M182.97%20527.748L182.946%20536.084L183.269%20536.273L183.293%20527.932L182.97%20527.748Z'%20fill='%233A56F6'/%3e%3cpath%20d='M182.172%20527.293L182.152%20534.485L182.309%20534.577L182.328%20527.38L182.172%20527.293Z'%20fill='%233A56F6'/%3e%3cpath%20d='M181.291%20526.789L181.271%20533.981L181.423%20534.073L181.448%20526.876L181.291%20526.789Z'%20fill='%233A56F6'/%3e%3cpath%20d='M180.342%20526.246L180.322%20533.443L180.611%20533.603L180.63%20526.411L180.342%20526.246Z'%20fill='%233A56F6'/%3e%3cpath%20d='M177.699%20524.734L177.68%20531.931L177.968%20532.096L177.988%20524.899L177.699%20524.734Z'%20fill='%233A56F6'/%3e%3cpath%20d='M179.529%20525.781L179.51%20532.973L179.662%20533.065L179.686%20525.868L179.529%20525.781Z'%20fill='%233A56F6'/%3e%3cpath%20d='M178.399%20525.136L178.379%20532.328L179.035%20532.701L179.055%20525.509L178.399%20525.136Z'%20fill='%233A56F6'/%3e%3cpath%20d='M171.513%20521.196L171.489%20529.532L171.817%20529.721L171.841%20521.385L171.513%20521.196Z'%20fill='%233A56F6'/%3e%3cpath%20d='M172.478%20521.748L172.458%20528.945L172.615%20529.033L172.634%20521.84L172.478%20521.748Z'%20fill='%233A56F6'/%3e%3cpath%20d='M173.358%20522.252L173.339%20529.45L173.495%20529.537L173.515%20522.345L173.358%20522.252Z'%20fill='%233A56F6'/%3e%3cpath%20d='M174.029%20522.635L174.009%20529.833L174.587%20530.162L174.611%20522.97L174.029%20522.635Z'%20fill='%233A56F6'/%3e%3cpath%20d='M176.818%20524.23L176.799%20531.427L177.083%20531.592L177.107%20524.395L176.818%20524.23Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.12%20523.26L175.1%20530.458L175.257%20530.545L175.277%20523.353L175.12%20523.26Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.756%20523.624L175.732%20530.816L176.387%20531.194L176.412%20523.997L175.756%20523.624Z'%20fill='%233A56F6'/%3e%3cpath%20d='M218.754%20527.971L218.768%20539.545L228.889%20533.758V522.185L218.754%20527.971Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M183.606%20507.951L218.753%20528.054L228.889%20522.267L193.726%20502.164L183.606%20507.951Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M131.477%20453.223L166.59%20473.327L201.801%20453.223L166.639%20433.115L131.477%20453.223Z'%20fill='%23929FF4'/%3e%3cpath%20d='M131.477%20453.224V493.43L166.639%20513.534L166.59%20473.327L131.477%20453.224Z'%20fill='%234055ED'/%3e%3cpath%20d='M166.59%20473.327L166.639%20513.534L201.801%20493.43V453.224L166.59%20473.327Z'%20fill='%237685F1'/%3e%3cpath%20d='M188.568%20489.984V491.482C188.578%20492.568%20189.302%20493.043%20190.227%20492.626L190.237%20495.209L189.42%20495.674C189.302%20495.742%20189.209%20495.902%20189.209%20496.033C189.209%20496.164%20189.302%20496.217%20189.42%20496.154L191.436%20495.001C191.553%20494.933%20191.646%20494.773%20191.646%20494.642C191.646%20494.511%20191.553%20494.458%20191.436%20494.521L190.623%20494.986L190.614%20492.403C191.539%20491.763%20192.258%20490.459%20192.258%20489.374V487.876L191.284%20488.429L191.005%20489.422L191.499%20489.122L190.756%20491.666L190.995%20489.839L190.506%20490.101L190.741%20488.739L188.563%20489.984H188.568Z'%20fill='%233A56F6'/%3e%3cpath%20d='M138.524%20485.71L139.063%20484.958L137.741%20481.58L136.532%20483.262L135.984%20482.588L136.684%20485.661L139.072%20486.383L138.524%20485.71Z'%20fill='%233A56F6'/%3e%3cpath%20d='M135.495%20484.668L133.777%20487.062L135.099%20490.44L137.487%20487.12L135.495%20484.668Z'%20fill='%233A56F6'/%3e%3cpath%20d='M137.927%20489.601L136.851%20488.986L135.515%20490.842L137.918%20492.218V492.941L139.601%20491.869L137.927%20488.879V489.601Z'%20fill='%233A56F6'/%3e%3cpath%20d='M141.969%20491.424L144.626%20492.946L143.432%20489.883L143.98%20489.839L141.597%20487.833L140.883%20490.101L141.431%20490.052L141.969%20491.424Z'%20fill='%233A56F6'/%3e%3cpath%20d='M143.369%20495.34L144.7%20493.479L139.958%20490.765L139.948%20493.387L143.369%20495.34Z'%20fill='%233A56F6'/%3e%3cpath%20d='M138.079%20481.449L140.438%20487.483L142.434%20487.314L140.736%20482.966L138.079%20481.449Z'%20fill='%233A56F6'/%3e%3cpath%20d='M199.467%20489.529L194.201%20492.534L194.206%20493.479L199.467%20490.469V489.529Z'%20fill='%233A56F6'/%3e%3cpath%20d='M198.483%20489.539L198.473%20485.686L198.933%20485.424L198.033%20484.644L197.147%20486.442L197.607%20486.18L197.617%20490.038L198.483%20489.539Z'%20fill='%233A56F6'/%3e%3cpath%20d='M196.051%20490.934L196.036%20487.076L196.496%20486.815L195.601%20486.034L194.71%20487.832L195.17%20487.571L195.18%20491.429L196.051%20490.934Z'%20fill='%233A56F6'/%3e%3cpath%20d='M183.533%20493.832C182.055%20494.714%20180.876%20496.338%20180.881%20497.501C180.895%20497.482%20181.189%20497.065%20181.566%20496.847C181.947%20496.629%20182.241%20496.711%20182.256%20496.711C182.27%20496.692%20182.564%20496.275%20182.941%20496.057C183.195%20495.912%20183.421%20495.902%20183.538%20495.912L183.548%20498.703C183.548%20499.067%20183.807%20499.212%20184.13%20499.033C184.453%20498.853%20184.708%20498.408%20184.708%20498.044C184.708%20497.986%20184.668%20497.962%20184.615%20497.991C184.561%20498.02%20184.522%20498.088%20184.522%20498.146C184.522%20498.393%20184.345%20498.698%20184.125%20498.824C183.905%20498.95%20183.729%20498.849%20183.729%20498.601L183.719%20495.81C183.836%20495.664%20184.057%20495.422%20184.316%20495.277C184.698%20495.059%20184.991%20495.141%20185.006%20495.141C185.021%20495.122%20185.314%20494.705%20185.691%20494.487C186.068%20494.269%20186.367%20494.351%20186.381%20494.351C186.381%20493.188%20185.192%20492.916%20183.719%20493.726V493.445L183.533%20493.551V493.832Z'%20fill='%233A56F6'/%3e%3cpath%20d='M182.001%20494.37C182.099%20494.254%20182.128%20494.094%20182.074%20494.017C182.021%20493.939%20181.727%20493.987%20181.727%20493.992C181.727%20494.012%20181.668%20494.365%20181.727%20494.443C181.766%20494.496%20181.83%20494.496%20181.903%20494.458C181.937%20494.438%20181.972%20494.409%20182.001%20494.37Z'%20fill='%233A56F6'/%3e%3cpath%20d='M185.446%20492.403C185.544%20492.286%20185.573%20492.127%20185.519%20492.049C185.465%20491.971%20185.172%20492.02%20185.172%20492.025C185.172%20492.044%20185.113%20492.398%20185.172%20492.475C185.211%20492.529%20185.275%20492.529%20185.348%20492.49C185.382%20492.471%20185.417%20492.442%20185.446%20492.403Z'%20fill='%233A56F6'/%3e%3cpath%20d='M184.869%20491.942C184.966%20491.826%20184.996%20491.666%20184.942%20491.589C184.888%20491.511%20184.609%20491.559%20184.594%20491.564C184.594%20491.584%20184.536%20491.942%20184.594%20492.015C184.634%20492.068%20184.697%20492.068%20184.771%20492.03C184.805%20492.01%20184.839%20491.981%20184.869%20491.942Z'%20fill='%233A56F6'/%3e%3cpath%20d='M184.296%20493.057C184.394%20492.941%20184.423%20492.781%20184.37%20492.703C184.316%20492.626%20184.037%20492.674%20184.022%20492.679C184.022%20492.698%20183.963%20493.052%20184.022%20493.135C184.061%20493.188%20184.125%20493.188%20184.198%20493.149C184.232%20493.13%20184.267%20493.101%20184.296%20493.062V493.057Z'%20fill='%233A56F6'/%3e%3cpath%20d='M183.719%20492.602C183.817%20492.485%20183.846%20492.325%20183.792%20492.248C183.738%20492.17%20183.445%20492.219%20183.445%20492.223C183.445%20492.243%20183.386%20492.602%20183.445%20492.674C183.484%20492.728%20183.547%20492.728%20183.621%20492.689C183.655%20492.669%20183.689%20492.64%20183.719%20492.602Z'%20fill='%233A56F6'/%3e%3cpath%20d='M183.151%20493.716C183.249%20493.6%20183.278%20493.44%20183.224%20493.362C183.17%20493.285%20182.891%20493.333%20182.877%20493.338C182.877%20493.357%20182.818%20493.711%20182.877%20493.789C182.916%20493.842%20182.979%20493.842%20183.053%20493.803C183.087%20493.784%20183.121%20493.755%20183.151%20493.716Z'%20fill='%233A56F6'/%3e%3cpath%20d='M182.573%20493.256C182.671%20493.139%20182.701%20492.979%20182.647%20492.902C182.593%20492.824%20182.314%20492.873%20182.299%20492.878C182.299%20492.897%20182.241%20493.256%20182.299%20493.328C182.338%20493.382%20182.402%20493.382%20182.475%20493.343C182.51%20493.323%20182.544%20493.294%20182.573%20493.256Z'%20fill='%233A56F6'/%3e%3cpath%20d='M145.346%20464.531L145.327%20472.871L145.65%20473.056L145.674%20464.72L145.346%20464.531Z'%20fill='%233A56F6'/%3e%3cpath%20d='M144.553%20464.075L144.534%20471.272L144.685%20471.359L144.71%20464.167L144.553%20464.075Z'%20fill='%233A56F6'/%3e%3cpath%20d='M143.673%20463.571L143.648%20470.768L143.805%20470.855L143.824%20463.663L143.673%20463.571Z'%20fill='%233A56F6'/%3e%3cpath%20d='M142.723%20463.033L142.703%20470.225L142.992%20470.39L143.012%20463.198L142.723%20463.033Z'%20fill='%233A56F6'/%3e%3cpath%20d='M140.08%20461.521L140.061%20468.713L140.345%20468.878L140.369%20461.685L140.08%20461.521Z'%20fill='%233A56F6'/%3e%3cpath%20d='M141.911%20462.568L141.886%20469.76L142.043%20469.847L142.063%20462.655L141.911%20462.568Z'%20fill='%233A56F6'/%3e%3cpath%20d='M140.78%20461.918L140.756%20469.115L141.412%20469.488L141.436%20462.296L140.78%20461.918Z'%20fill='%233A56F6'/%3e%3cpath%20d='M133.89%20457.983L133.87%20466.319L134.198%20466.508L134.223%20458.172L133.89%20457.983Z'%20fill='%233A56F6'/%3e%3cpath%20d='M134.859%20458.535L134.839%20465.728L134.996%20465.82L135.016%20458.623L134.859%20458.535Z'%20fill='%233A56F6'/%3e%3cpath%20d='M135.74%20459.039L135.72%20466.232L135.877%20466.324L135.896%20459.127L135.74%20459.039Z'%20fill='%233A56F6'/%3e%3cpath%20d='M136.41%20459.422L136.391%20466.615L136.968%20466.949L136.988%20459.752L136.41%20459.422Z'%20fill='%233A56F6'/%3e%3cpath%20d='M139.2%20461.017L139.18%20468.209L139.464%20468.374L139.483%20461.182L139.2%20461.017Z'%20fill='%233A56F6'/%3e%3cpath%20d='M137.501%20460.047L137.482%20467.24L137.638%20467.332L137.658%20460.135L137.501%20460.047Z'%20fill='%233A56F6'/%3e%3cpath%20d='M138.132%20460.406L138.113%20467.603L138.769%20467.977L138.788%20460.784L138.132%20460.406Z'%20fill='%233A56F6'/%3e%3cpath%20d='M181.135%20464.758L181.145%20476.332L191.265%20470.545V458.971L181.135%20464.758Z'%20fill='%234055ED'/%3e%3cpath%20d='M145.983%20444.733L181.135%20464.836L191.265%20459.049L156.108%20438.946L145.983%20444.733Z'%20fill='%234055ED'/%3e%3cpath%20d='M169.096%20474.151L204.209%20494.254L239.42%20474.151L204.258%20454.043L169.096%20474.151Z'%20fill='%23929FF4'/%3e%3cpath%20d='M169.096%20474.151V514.358L204.258%20534.461L204.209%20494.254L169.096%20474.151Z'%20fill='%234055ED'/%3e%3cpath%20d='M204.209%20494.254L204.258%20534.461L239.42%20514.358V474.151L204.209%20494.254Z'%20fill='%237685F1'/%3e%3cpath%20d='M176.143%20506.637L176.686%20505.886L175.365%20502.508L174.151%20504.19L173.608%20503.516L174.303%20506.589L176.691%20507.311L176.143%20506.637Z'%20fill='%233A56F6'/%3e%3cpath%20d='M173.119%20505.595L171.396%20507.984L172.722%20511.367L175.106%20508.047L173.119%20505.595Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.546%20510.529L174.469%20509.913L173.133%20511.769L175.536%20513.146V513.868L177.219%20512.797L175.546%20509.807V510.529Z'%20fill='%233A56F6'/%3e%3cpath%20d='M179.588%20512.351L182.245%20513.873L181.051%20510.81L181.599%20510.766L179.216%20508.76L178.502%20511.028L179.055%20510.979L179.588%20512.351Z'%20fill='%233A56F6'/%3e%3cpath%20d='M180.988%20516.267L182.324%20514.406L177.577%20511.692L177.567%20514.314L180.988%20516.267Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.698%20502.377L178.057%20508.406L180.053%20508.236L178.355%20503.894L175.698%20502.377Z'%20fill='%233A56F6'/%3e%3cpath%20d='M182.97%20485.458L182.946%20493.799L183.269%20493.983L183.293%20485.647L182.97%20485.458Z'%20fill='%233A56F6'/%3e%3cpath%20d='M182.172%20485.002L182.152%20492.199L182.309%20492.286L182.328%20485.094L182.172%20485.002Z'%20fill='%233A56F6'/%3e%3cpath%20d='M181.291%20484.498L181.271%20491.695L181.423%20491.783L181.448%20484.59L181.291%20484.498Z'%20fill='%233A56F6'/%3e%3cpath%20d='M180.342%20483.96L180.322%20491.152L180.611%20491.317L180.63%20484.125L180.342%20483.96Z'%20fill='%233A56F6'/%3e%3cpath%20d='M177.699%20482.448L177.68%20489.64L177.968%20489.805L177.988%20482.613L177.699%20482.448Z'%20fill='%233A56F6'/%3e%3cpath%20d='M179.529%20483.495L179.51%20490.687L179.662%20490.774L179.686%20483.582L179.529%20483.495Z'%20fill='%233A56F6'/%3e%3cpath%20d='M178.399%20482.845L178.379%20490.043L179.035%20490.416L179.055%20483.223L178.399%20482.845Z'%20fill='%233A56F6'/%3e%3cpath%20d='M171.513%20478.91L171.489%20487.246L171.817%20487.435L171.841%20479.099L171.513%20478.91Z'%20fill='%233A56F6'/%3e%3cpath%20d='M172.478%20479.463L172.458%20486.655L172.615%20486.747L172.634%20479.55L172.478%20479.463Z'%20fill='%233A56F6'/%3e%3cpath%20d='M173.358%20479.967L173.339%20487.159L173.495%20487.251L173.515%20480.054L173.358%20479.967Z'%20fill='%233A56F6'/%3e%3cpath%20d='M174.029%20480.349L174.009%20487.542L174.587%20487.876L174.611%20480.679L174.029%20480.349Z'%20fill='%233A56F6'/%3e%3cpath%20d='M176.818%20481.944L176.799%20489.136L177.083%20489.301L177.107%20482.109L176.818%20481.944Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.12%20480.975L175.1%20488.167L175.257%20488.254L175.277%20481.062L175.12%20480.975Z'%20fill='%233A56F6'/%3e%3cpath%20d='M175.756%20481.333L175.732%20488.531L176.387%20488.904L176.412%20481.712L175.756%20481.333Z'%20fill='%233A56F6'/%3e%3cpath%20d='M218.754%20485.685L218.768%20497.259L228.889%20491.472V479.899L218.754%20485.685Z'%20fill='%234055ED'/%3e%3cpath%20d='M183.606%20465.66L218.753%20485.763L228.889%20479.976L193.726%20459.873L183.606%20465.66Z'%20fill='%234055ED'/%3e%3cpath%20d='M93.4867%20516.979L128.6%20537.083L163.811%20516.979L128.649%20496.876L93.4867%20516.979Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M93.4867%20516.979V557.191L128.649%20577.294L128.6%20537.083L93.4867%20516.979Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M128.6%20537.083L128.649%20577.294L163.811%20557.191V516.979L128.6%20537.083Z'%20fill='%23E6E9FE'/%3e%3cpath%20d='M150.578%20553.745V555.243C150.588%20556.328%20151.312%20556.803%20152.237%20556.387L152.247%20558.97L151.43%20559.435C151.312%20559.503%20151.219%20559.663%20151.219%20559.794C151.219%20559.925%20151.312%20559.978%20151.43%20559.915L153.446%20558.761C153.563%20558.693%20153.656%20558.534%20153.656%20558.403C153.656%20558.272%20153.563%20558.219%20153.446%20558.282L152.634%20558.747L152.624%20556.164C153.549%20555.524%20154.268%20554.22%20154.268%20553.135V551.637L153.294%20552.189L153.015%20553.183L153.51%20552.883L152.766%20555.427L153.005%20553.6L152.516%20553.862L152.751%20552.5L150.573%20553.745H150.578Z'%20fill='%233A56F6'/%3e%3cpath%20d='M100.533%20549.471L101.072%20548.714L99.7503%20545.336L98.5415%20547.018L97.9934%20546.345L98.6932%20549.417L101.077%20550.144L100.533%20549.471Z'%20fill='%233A56F6'/%3e%3cpath%20d='M97.5042%20548.428L95.7865%20550.818L97.1078%20554.196L99.496%20550.876L97.5042%20548.428Z'%20fill='%233A56F6'/%3e%3cpath%20d='M99.9314%20553.357L98.8597%20552.742L97.5188%20554.603L99.9266%20555.979V556.697L101.61%20555.626L99.9363%20552.635L99.9314%20553.357Z'%20fill='%233A56F6'/%3e%3cpath%20d='M103.979%20555.18L106.636%20556.701L105.437%20553.643L105.99%20553.595L103.607%20551.593L102.893%20553.861L103.441%20553.813L103.979%20555.18Z'%20fill='%233A56F6'/%3e%3cpath%20d='M105.373%20559.096L106.709%20557.235L101.967%20554.525L101.958%20557.143L105.373%20559.096Z'%20fill='%233A56F6'/%3e%3cpath%20d='M100.088%20545.206L102.447%20551.239L104.444%20551.07L102.745%20546.727L100.088%20545.206Z'%20fill='%233A56F6'/%3e%3cpath%20d='M161.476%20553.285L156.21%20556.294L156.215%20557.239L161.476%20554.23V553.285Z'%20fill='%233A56F6'/%3e%3cpath%20d='M160.493%20553.299L160.483%20549.441L160.943%20549.18L160.042%20548.399L159.156%20550.202L159.617%20549.936L159.626%20553.794L160.493%20553.299Z'%20fill='%233A56F6'/%3e%3cpath%20d='M158.055%20554.69L158.045%20550.833L158.505%20550.571L157.61%20549.791L156.719%20551.593L157.179%20551.332L157.189%20555.185L158.055%20554.69Z'%20fill='%233A56F6'/%3e%3cpath%20d='M145.542%20557.593C144.064%20558.475%20142.885%20560.099%20142.89%20561.262C142.904%20561.243%20143.198%20560.826%20143.575%20560.608C143.956%20560.39%20144.25%20560.472%20144.265%20560.472C144.279%20560.453%20144.573%20560.036%20144.95%20559.818C145.204%20559.673%20145.429%20559.663%20145.547%20559.673L145.557%20562.464C145.557%20562.828%20145.816%20562.973%20146.139%20562.794C146.462%20562.614%20146.717%20562.168%20146.717%20561.805C146.717%20561.747%20146.677%20561.723%20146.624%20561.752C146.57%20561.781%20146.531%20561.849%20146.531%20561.907C146.531%20562.154%20146.354%20562.459%20146.134%20562.585C145.914%20562.711%20145.738%20562.61%20145.738%20562.362L145.728%20559.571C145.845%20559.425%20146.066%20559.183%20146.325%20559.038C146.707%20558.82%20147%20558.902%20147.015%20558.902C147.03%20558.883%20147.323%20558.466%20147.7%20558.248C148.077%20558.03%20148.376%20558.112%20148.39%20558.112C148.39%20556.949%20147.201%20556.677%20145.728%20557.487V557.206L145.542%20557.312V557.593Z'%20fill='%233A56F6'/%3e%3cpath%20d='M144.01%20558.126C144.108%20558.01%20144.137%20557.85%20144.083%20557.773C144.03%20557.695%20143.736%20557.744%20143.736%20557.748C143.736%20557.768%20143.677%20558.122%20143.736%20558.199C143.775%20558.252%20143.839%20558.252%20143.912%20558.214C143.946%20558.194%20143.981%20558.165%20144.01%20558.126Z'%20fill='%233A56F6'/%3e%3cpath%20d='M147.456%20556.159C147.553%20556.042%20147.583%20555.882%20147.529%20555.805C147.475%20555.727%20147.181%20555.776%20147.181%20555.781C147.181%20555.8%20147.123%20556.154%20147.181%20556.231C147.221%20556.285%20147.284%20556.285%20147.358%20556.246C147.392%20556.227%20147.426%20556.197%20147.456%20556.159Z'%20fill='%233A56F6'/%3e%3cpath%20d='M146.878%20555.703C146.976%20555.587%20147.005%20555.427%20146.952%20555.349C146.898%20555.272%20146.619%20555.32%20146.604%20555.325C146.604%20555.344%20146.545%20555.703%20146.604%20555.776C146.643%20555.829%20146.707%20555.829%20146.78%20555.79C146.815%20555.771%20146.849%20555.742%20146.878%20555.703Z'%20fill='%233A56F6'/%3e%3cpath%20d='M146.306%20556.813C146.403%20556.697%20146.433%20556.537%20146.379%20556.459C146.325%20556.382%20146.046%20556.43%20146.031%20556.435C146.031%20556.455%20145.973%20556.808%20146.031%20556.891C146.071%20556.944%20146.134%20556.944%20146.208%20556.905C146.242%20556.886%20146.276%20556.857%20146.306%20556.818V556.813Z'%20fill='%233A56F6'/%3e%3cpath%20d='M145.728%20556.357C145.826%20556.241%20145.855%20556.081%20145.802%20556.004C145.748%20555.926%20145.454%20555.975%20145.454%20555.979C145.454%20555.999%20145.395%20556.357%20145.454%20556.43C145.493%20556.483%20145.557%20556.483%20145.63%20556.445C145.665%20556.425%20145.699%20556.396%20145.728%20556.357Z'%20fill='%233A56F6'/%3e%3cpath%20d='M145.155%20557.472C145.253%20557.356%20145.283%20557.196%20145.229%20557.118C145.175%20557.041%20144.896%20557.089%20144.881%20557.094C144.881%20557.113%20144.823%20557.467%20144.881%20557.545C144.92%20557.598%20144.984%20557.598%20145.058%20557.559C145.092%20557.54%20145.126%20557.511%20145.155%20557.472Z'%20fill='%233A56F6'/%3e%3cpath%20d='M144.583%20557.016C144.681%20556.9%20144.71%20556.74%20144.657%20556.663C144.603%20556.585%20144.324%20556.633%20144.309%20556.638C144.309%20556.658%20144.25%20557.016%20144.309%20557.089C144.348%20557.142%20144.412%20557.142%20144.485%20557.104C144.519%20557.084%20144.554%20557.055%20144.583%20557.016Z'%20fill='%233A56F6'/%3e%3cpath%20d='M159.47%20516.597L129.388%20534.039'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M156.9%20515.138L126.784%20532.585'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M154.331%20513.679L124.176%20531.131'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M151.757%20512.215L121.572%20529.677'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M149.188%20510.756L118.968%20528.223'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M146.614%20509.298L116.365%20526.774'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M144.044%20507.839L113.757%20525.32'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M141.471%20506.38L111.153%20523.866'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M138.901%20504.921L108.55%20522.412'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M136.332%20503.462L105.946%20520.958'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M133.758%20501.999L103.338%20519.504'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M131.188%20500.54L100.734%20518.051'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M128.615%20499.081L98.131%20516.597'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M107.356%20528.291L107.331%20536.627L107.659%20536.811L107.684%20528.475L107.356%20528.291Z'%20fill='%233A56F6'/%3e%3cpath%20d='M106.563%20527.836L106.538%20535.028L106.695%20535.12L106.714%20527.923L106.563%20527.836Z'%20fill='%233A56F6'/%3e%3cpath%20d='M105.682%20527.332L105.657%20534.524L105.814%20534.616L105.834%20527.419L105.682%20527.332Z'%20fill='%233A56F6'/%3e%3cpath%20d='M104.733%20526.789L104.713%20533.986L104.997%20534.146L105.021%20526.954L104.733%20526.789Z'%20fill='%233A56F6'/%3e%3cpath%20d='M102.09%20525.277L102.07%20532.474L102.354%20532.638L102.373%20525.441L102.09%20525.277Z'%20fill='%233A56F6'/%3e%3cpath%20d='M103.915%20526.324L103.896%20533.516L104.052%20533.608L104.072%20526.411L103.915%20526.324Z'%20fill='%233A56F6'/%3e%3cpath%20d='M102.789%20525.679L102.765%20532.871L103.421%20533.244L103.44%20526.052L102.789%20525.679Z'%20fill='%233A56F6'/%3e%3cpath%20d='M95.8992%20521.739L95.8748%20530.075L96.2075%20530.264L96.2271%20521.928L95.8992%20521.739Z'%20fill='%233A56F6'/%3e%3cpath%20d='M96.868%20522.291L96.8484%20529.488L97.0001%20529.576L97.0246%20522.383L96.868%20522.291Z'%20fill='%233A56F6'/%3e%3cpath%20d='M97.7488%20522.795L97.7292%20529.992L97.881%20530.08L97.9054%20522.887L97.7488%20522.795Z'%20fill='%233A56F6'/%3e%3cpath%20d='M98.4191%20523.178L98.3995%20530.375L98.977%20530.705L98.9966%20523.513L98.4191%20523.178Z'%20fill='%233A56F6'/%3e%3cpath%20d='M101.209%20524.773L101.189%20531.97L101.473%20532.135L101.493%20524.937L101.209%20524.773Z'%20fill='%233A56F6'/%3e%3cpath%20d='M99.5108%20523.803L99.4912%20531L99.6478%20531.088L99.6674%20523.89L99.5108%20523.803Z'%20fill='%233A56F6'/%3e%3cpath%20d='M100.142%20524.167L100.123%20531.359L100.778%20531.732L100.798%20524.54L100.142%20524.167Z'%20fill='%233A56F6'/%3e%3cpath%20d='M143.139%20528.514L143.154%20540.088L153.274%20534.301V522.727L143.139%20528.514Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M107.992%20508.493L143.139%20528.597L153.274%20522.81L118.112%20502.707L107.992%20508.493Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M131.105%20537.907L166.218%20558.01L201.429%20537.907L166.267%20517.803L131.105%20537.907Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M131.105%20537.907V578.118L166.267%20598.222L166.218%20558.01L131.105%20537.907Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M166.219%20558.01L166.267%20598.222L201.429%20578.118V537.907L166.219%20558.01Z'%20fill='%23E6E9FE'/%3e%3cpath%20d='M138.152%20570.398L138.691%20569.642L137.369%20566.264L136.161%20567.945L135.612%20567.272L136.312%20570.344L138.7%20571.071L138.152%20570.398Z'%20fill='%233A56F6'/%3e%3cpath%20d='M135.123%20569.356L133.405%20571.745L134.731%20575.123L137.115%20571.803L135.123%20569.356Z'%20fill='%233A56F6'/%3e%3cpath%20d='M137.555%20574.285L136.479%20573.669L135.143%20575.53L137.546%20576.907V577.624L139.229%20576.553L137.555%20573.562V574.285Z'%20fill='%233A56F6'/%3e%3cpath%20d='M141.598%20576.107L144.255%20577.628L143.061%20574.57L143.609%20574.522L141.226%20572.52L140.511%20574.784L141.064%20574.74L141.598%20576.107Z'%20fill='%233A56F6'/%3e%3cpath%20d='M142.997%20580.023L144.328%20578.162L139.586%20575.452L139.576%20578.07L142.997%20580.023Z'%20fill='%233A56F6'/%3e%3cpath%20d='M137.707%20566.133L140.066%20572.167L142.062%20571.997L140.364%20567.65L137.707%20566.133Z'%20fill='%233A56F6'/%3e%3cpath%20d='M197.093%20537.524L167.006%20554.967'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M194.519%20536.065L164.403%20553.513'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M191.95%20534.606L161.799%20552.058'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M189.376%20533.142L159.191%20550.604'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M186.806%20531.684L156.587%20549.151'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M184.237%20530.225L153.984%20547.697'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M181.663%20528.766L151.38%20546.248'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M179.094%20527.307L148.772%20544.794'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M176.52%20525.849L146.168%20543.34'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M173.951%20524.385L143.565%20541.886'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M171.376%20522.926L140.961%20540.432'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M168.807%20521.467L138.353%20538.978'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M166.233%20520.009L135.75%20537.524'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M144.974%20549.219L144.955%20557.555L145.278%20557.739L145.302%20549.403L144.974%20549.219Z'%20fill='%233A56F6'/%3e%3cpath%20d='M144.182%20548.763L144.162%20555.955L144.314%20556.047L144.338%20548.85L144.182%20548.763Z'%20fill='%233A56F6'/%3e%3cpath%20d='M143.301%20548.259L143.281%20555.451L143.433%20555.543L143.457%20548.346L143.301%20548.259Z'%20fill='%233A56F6'/%3e%3cpath%20d='M142.351%20547.716L142.332%20554.913L142.621%20555.073L142.64%20547.881L142.351%20547.716Z'%20fill='%233A56F6'/%3e%3cpath%20d='M139.708%20546.204L139.689%20553.401L139.973%20553.561L139.997%20546.369L139.708%20546.204Z'%20fill='%233A56F6'/%3e%3cpath%20d='M141.539%20547.251L141.515%20554.443L141.671%20554.535L141.691%20547.338L141.539%20547.251Z'%20fill='%233A56F6'/%3e%3cpath%20d='M140.409%20546.606L140.389%20553.798L141.04%20554.172L141.064%20546.979L140.409%20546.606Z'%20fill='%233A56F6'/%3e%3cpath%20d='M133.518%20542.666L133.498%20551.002L133.826%20551.191L133.851%20542.855L133.518%20542.666Z'%20fill='%233A56F6'/%3e%3cpath%20d='M134.487%20543.219L134.467%20550.416L134.624%20550.503L134.644%20543.311L134.487%20543.219Z'%20fill='%233A56F6'/%3e%3cpath%20d='M135.368%20543.723L135.348%20550.92L135.505%20551.007L135.524%20543.81L135.368%20543.723Z'%20fill='%233A56F6'/%3e%3cpath%20d='M136.038%20544.105L136.019%20551.303L136.596%20551.632L136.62%20544.44L136.038%20544.105Z'%20fill='%233A56F6'/%3e%3cpath%20d='M138.827%20545.7L138.808%20552.897L139.092%20553.057L139.116%20545.865L138.827%20545.7Z'%20fill='%233A56F6'/%3e%3cpath%20d='M137.129%20544.73L137.11%20551.923L137.266%20552.015L137.286%20544.818L137.129%20544.73Z'%20fill='%233A56F6'/%3e%3cpath%20d='M137.761%20545.094L137.741%20552.286L138.397%20552.66L138.417%20545.467L137.761%20545.094Z'%20fill='%233A56F6'/%3e%3cpath%20d='M180.763%20549.441L180.772%20561.015L190.898%20555.228V543.655L180.763%20549.441Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M145.61%20529.421L180.763%20549.524L190.898%20543.737L155.736%20523.634L145.61%20529.421Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M93.4867%20474.694L128.6%20494.797L163.811%20474.694L128.649%20454.585L93.4867%20474.694Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M93.4867%20474.694V514.9L128.649%20535.004L128.6%20494.797L93.4867%20474.694Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M128.6%20494.797L128.649%20535.004L163.811%20514.9V474.694L128.6%20494.797Z'%20fill='%23E6E9FE'/%3e%3cpath%20d='M150.578%20511.454V512.952C150.588%20514.038%20151.312%20514.513%20152.237%20514.096L152.247%20516.679L151.43%20517.144C151.312%20517.212%20151.219%20517.372%20151.219%20517.503C151.219%20517.634%20151.312%20517.687%20151.43%20517.624L153.446%20516.471C153.563%20516.403%20153.656%20516.243%20153.656%20516.112C153.656%20515.981%20153.563%20515.928%20153.446%20515.991L152.634%20516.456L152.624%20513.873C153.549%20513.233%20154.268%20511.929%20154.268%20510.844V509.346L153.294%20509.899L153.015%20510.892L153.51%20510.592L152.766%20513.136L153.005%20511.309L152.516%20511.571L152.751%20510.209L150.573%20511.454H150.578Z'%20fill='%233A56F6'/%3e%3cpath%20d='M100.533%20507.179L101.072%20506.428L99.7503%20503.045L98.5415%20504.732L97.9934%20504.058L98.6932%20507.131L101.077%20507.853L100.533%20507.179Z'%20fill='%233A56F6'/%3e%3cpath%20d='M97.5042%20506.138L95.7865%20508.527L97.1078%20511.91L99.496%20508.59L97.5042%20506.138Z'%20fill='%233A56F6'/%3e%3cpath%20d='M99.9314%20511.071L98.8597%20510.456L97.5188%20512.312L99.9266%20513.689V514.411L101.61%20513.34L99.9363%20510.349L99.9314%20511.071Z'%20fill='%233A56F6'/%3e%3cpath%20d='M103.979%20512.894L106.636%20514.411L105.437%20511.353L105.99%20511.309L103.607%20509.303L102.893%20511.571L103.441%20511.522L103.979%20512.894Z'%20fill='%233A56F6'/%3e%3cpath%20d='M105.373%20516.81L106.709%20514.949L101.967%20512.235L101.958%20514.857L105.373%20516.81Z'%20fill='%233A56F6'/%3e%3cpath%20d='M100.088%20502.92L102.447%20508.949L104.444%20508.779L102.745%20504.437L100.088%20502.92Z'%20fill='%233A56F6'/%3e%3cpath%20d='M161.476%20510.999L156.21%20514.004L156.215%20514.949L161.476%20511.939V510.999Z'%20fill='%233A56F6'/%3e%3cpath%20d='M160.493%20511.009L160.483%20507.156L160.943%20506.889L160.042%20506.114L159.156%20507.912L159.617%20507.65L159.626%20511.508L160.493%20511.009Z'%20fill='%233A56F6'/%3e%3cpath%20d='M158.055%20512.404L158.045%20508.547L158.505%20508.285L157.61%20507.505L156.719%20509.303L157.179%20509.041L157.189%20512.899L158.055%20512.404Z'%20fill='%233A56F6'/%3e%3cpath%20d='M145.542%20515.303C144.064%20516.185%20142.885%20517.808%20142.89%20518.971C142.904%20518.952%20143.198%20518.535%20143.575%20518.317C143.956%20518.099%20144.25%20518.181%20144.265%20518.181C144.279%20518.162%20144.573%20517.745%20144.95%20517.527C145.204%20517.382%20145.429%20517.372%20145.547%20517.382L145.557%20520.173C145.557%20520.537%20145.816%20520.682%20146.139%20520.503C146.462%20520.324%20146.717%20519.878%20146.717%20519.514C146.717%20519.456%20146.677%20519.432%20146.624%20519.461C146.57%20519.49%20146.531%20519.558%20146.531%20519.616C146.531%20519.863%20146.354%20520.169%20146.134%20520.295C145.914%20520.421%20145.738%20520.319%20145.738%20520.072L145.728%20517.28C145.845%20517.135%20146.066%20516.892%20146.325%20516.747C146.707%20516.529%20147%20516.611%20147.015%20516.611C147.03%20516.592%20147.323%20516.175%20147.7%20515.957C148.077%20515.739%20148.376%20515.821%20148.39%20515.821C148.39%20514.658%20147.201%20514.387%20145.728%20515.196V514.915L145.542%20515.022V515.303Z'%20fill='%233A56F6'/%3e%3cpath%20d='M144.01%20515.841C144.108%20515.724%20144.137%20515.564%20144.083%20515.487C144.03%20515.409%20143.736%20515.458%20143.736%20515.463C143.736%20515.482%20143.677%20515.836%20143.736%20515.913C143.775%20515.967%20143.839%20515.967%20143.912%20515.928C143.946%20515.908%20143.981%20515.879%20144.01%20515.841Z'%20fill='%233A56F6'/%3e%3cpath%20d='M147.456%20513.868C147.553%20513.752%20147.583%20513.592%20147.529%20513.514C147.475%20513.437%20147.181%20513.485%20147.181%20513.49C147.181%20513.509%20147.123%20513.863%20147.181%20513.941C147.221%20513.994%20147.284%20513.994%20147.358%20513.955C147.392%20513.936%20147.426%20513.907%20147.456%20513.868Z'%20fill='%233A56F6'/%3e%3cpath%20d='M146.878%20513.413C146.976%20513.296%20147.005%20513.136%20146.952%20513.059C146.898%20512.981%20146.619%20513.03%20146.604%20513.035C146.604%20513.054%20146.545%20513.413%20146.604%20513.485C146.643%20513.539%20146.707%20513.539%20146.78%20513.5C146.815%20513.48%20146.849%20513.451%20146.878%20513.413Z'%20fill='%233A56F6'/%3e%3cpath%20d='M146.306%20514.527C146.403%20514.411%20146.433%20514.251%20146.379%20514.174C146.325%20514.096%20146.046%20514.144%20146.031%20514.149C146.031%20514.169%20145.973%20514.522%20146.031%20514.605C146.071%20514.658%20146.134%20514.658%20146.208%20514.619C146.242%20514.6%20146.276%20514.571%20146.306%20514.532V514.527Z'%20fill='%233A56F6'/%3e%3cpath%20d='M145.728%20514.072C145.826%20513.955%20145.855%20513.795%20145.802%20513.718C145.748%20513.64%20145.454%20513.689%20145.454%20513.694C145.454%20513.713%20145.395%20514.072%20145.454%20514.144C145.493%20514.198%20145.557%20514.198%20145.63%20514.159C145.665%20514.14%20145.699%20514.111%20145.728%20514.072Z'%20fill='%233A56F6'/%3e%3cpath%20d='M145.155%20515.181C145.253%20515.065%20145.283%20514.905%20145.229%20514.828C145.175%20514.75%20144.896%20514.798%20144.881%20514.803C144.881%20514.823%20144.823%20515.177%20144.881%20515.254C144.92%20515.307%20144.984%20515.307%20145.058%20515.269C145.092%20515.249%20145.126%20515.22%20145.155%20515.181Z'%20fill='%233A56F6'/%3e%3cpath%20d='M144.583%20514.726C144.681%20514.609%20144.71%20514.45%20144.657%20514.372C144.603%20514.294%20144.324%20514.343%20144.309%20514.348C144.309%20514.367%20144.25%20514.726%20144.309%20514.798C144.348%20514.852%20144.412%20514.852%20144.485%20514.813C144.519%20514.794%20144.554%20514.765%20144.583%20514.726Z'%20fill='%233A56F6'/%3e%3cpath%20d='M107.356%20486L107.331%20494.341L107.659%20494.526L107.684%20486.19L107.356%20486Z'%20fill='%233A56F6'/%3e%3cpath%20d='M106.563%20485.545L106.538%20492.742L106.695%20492.829L106.714%20485.637L106.563%20485.545Z'%20fill='%233A56F6'/%3e%3cpath%20d='M105.682%20485.041L105.657%20492.238L105.814%20492.325L105.834%20485.133L105.682%20485.041Z'%20fill='%233A56F6'/%3e%3cpath%20d='M104.733%20484.503L104.713%20491.695L104.997%20491.86L105.021%20484.663L104.733%20484.503Z'%20fill='%233A56F6'/%3e%3cpath%20d='M102.09%20482.991L102.07%20490.183L102.354%20490.348L102.373%20483.156L102.09%20482.991Z'%20fill='%233A56F6'/%3e%3cpath%20d='M103.915%20484.033L103.896%20491.23L104.052%20491.317L104.072%20484.125L103.915%20484.033Z'%20fill='%233A56F6'/%3e%3cpath%20d='M102.789%20483.388L102.765%20490.585L103.421%20490.958L103.44%20483.761L102.789%20483.388Z'%20fill='%233A56F6'/%3e%3cpath%20d='M95.8992%20479.453L95.8748%20487.789L96.2075%20487.978L96.2271%20479.637L95.8992%20479.453Z'%20fill='%233A56F6'/%3e%3cpath%20d='M96.868%20480.005L96.8484%20487.198L97.0001%20487.29L97.0246%20480.093L96.868%20480.005Z'%20fill='%233A56F6'/%3e%3cpath%20d='M97.7488%20480.509L97.7292%20487.702L97.881%20487.789L97.9054%20480.597L97.7488%20480.509Z'%20fill='%233A56F6'/%3e%3cpath%20d='M98.4191%20480.892L98.3995%20488.085L98.977%20488.419L98.9966%20481.222L98.4191%20480.892Z'%20fill='%233A56F6'/%3e%3cpath%20d='M101.209%20482.487L101.189%20489.679L101.473%20489.844L101.493%20482.652L101.209%20482.487Z'%20fill='%233A56F6'/%3e%3cpath%20d='M99.5108%20481.518L99.4912%20488.71L99.6478%20488.797L99.6674%20481.605L99.5108%20481.518Z'%20fill='%233A56F6'/%3e%3cpath%20d='M100.142%20481.876L100.123%20489.073L100.778%20489.446L100.798%20482.254L100.142%20481.876Z'%20fill='%233A56F6'/%3e%3cpath%20d='M143.139%20486.228L143.154%20497.802L153.274%20492.015V480.442L143.139%20486.228Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M107.992%20466.203L143.139%20486.306L153.274%20480.519L118.112%20460.416L107.992%20466.203Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M131.105%20495.621L166.218%20515.724L201.429%20495.621L166.267%20475.513L131.105%20495.621Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M131.105%20495.621V535.828L166.267%20555.931L166.218%20515.724L131.105%20495.621Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M166.219%20515.724L166.267%20555.931L201.429%20535.828V495.621L166.219%20515.724Z'%20fill='%23E6E9FE'/%3e%3cpath%20d='M138.152%20528.107L138.691%20527.356L137.369%20523.973L136.161%20525.66L135.612%20524.986L136.312%20528.059L138.7%20528.781L138.152%20528.107Z'%20fill='%233A56F6'/%3e%3cpath%20d='M135.123%20527.065L133.405%20529.454L134.731%20532.832L137.115%20529.517L135.123%20527.065Z'%20fill='%233A56F6'/%3e%3cpath%20d='M137.555%20531.999L136.479%20531.383L135.143%20533.24L137.546%20534.616V535.338L139.229%20534.267L137.555%20531.277V531.999Z'%20fill='%233A56F6'/%3e%3cpath%20d='M141.598%20533.821L144.255%20535.338L143.061%20532.28L143.609%20532.236L141.226%20530.23L140.511%20532.498L141.064%20532.449L141.598%20533.821Z'%20fill='%233A56F6'/%3e%3cpath%20d='M142.997%20537.737L144.328%20535.876L139.586%20533.162L139.576%20535.779L142.997%20537.737Z'%20fill='%233A56F6'/%3e%3cpath%20d='M137.707%20523.847L140.066%20529.876L142.062%20529.706L140.364%20525.364L137.707%20523.847Z'%20fill='%233A56F6'/%3e%3cpath%20d='M144.974%20506.928L144.955%20515.264L145.278%20515.453L145.302%20507.117L144.974%20506.928Z'%20fill='%233A56F6'/%3e%3cpath%20d='M144.182%20506.472L144.162%20513.669L144.314%20513.756L144.338%20506.564L144.182%20506.472Z'%20fill='%233A56F6'/%3e%3cpath%20d='M143.301%20505.968L143.281%20513.165L143.433%20513.252L143.457%20506.06L143.301%20505.968Z'%20fill='%233A56F6'/%3e%3cpath%20d='M142.351%20505.43L142.332%20512.622L142.621%20512.787L142.64%20505.59L142.351%20505.43Z'%20fill='%233A56F6'/%3e%3cpath%20d='M139.708%20503.918L139.689%20511.11L139.973%20511.275L139.997%20504.083L139.708%20503.918Z'%20fill='%233A56F6'/%3e%3cpath%20d='M141.539%20504.96L141.515%20512.157L141.671%20512.245L141.691%20505.052L141.539%20504.96Z'%20fill='%233A56F6'/%3e%3cpath%20d='M140.409%20504.315L140.389%20511.512L141.04%20511.886L141.064%20504.689L140.409%20504.315Z'%20fill='%233A56F6'/%3e%3cpath%20d='M133.518%20500.38L133.498%20508.716L133.826%20508.905L133.851%20500.564L133.518%20500.38Z'%20fill='%233A56F6'/%3e%3cpath%20d='M134.487%20500.933L134.467%20508.125L134.624%20508.212L134.644%20501.02L134.487%20500.933Z'%20fill='%233A56F6'/%3e%3cpath%20d='M135.368%20501.437L135.348%20508.629L135.505%20508.716L135.524%20501.524L135.368%20501.437Z'%20fill='%233A56F6'/%3e%3cpath%20d='M136.038%20501.82L136.019%20509.012L136.596%20509.346L136.62%20502.149L136.038%20501.82Z'%20fill='%233A56F6'/%3e%3cpath%20d='M138.827%20503.414L138.808%20510.606L139.092%20510.771L139.116%20503.579L138.827%20503.414Z'%20fill='%233A56F6'/%3e%3cpath%20d='M137.129%20502.445L137.11%20509.637L137.266%20509.724L137.286%20502.532L137.129%20502.445Z'%20fill='%233A56F6'/%3e%3cpath%20d='M137.761%20502.803L137.741%20510.001L138.397%20510.374L138.417%20503.181L137.761%20502.803Z'%20fill='%233A56F6'/%3e%3cpath%20d='M180.763%20507.151L180.772%20518.729L190.898%20512.942V501.369L180.763%20507.151Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M145.61%20487.13L180.763%20507.233L190.898%20501.446L155.736%20481.343L145.61%20487.13Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M55.8387%20538.387L90.9518%20558.49L126.163%20538.387L91.0008%20518.278L55.8387%20538.387Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M55.8387%20538.386V578.593L91.0008%20598.697L90.9518%20558.49L55.8387%20538.386Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M90.9514%20558.49L91.0004%20598.697L126.162%20578.593V538.386L90.9514%20558.49Z'%20fill='%23E6E9FE'/%3e%3cpath%20d='M109.807%20577.561C109.905%20577.444%20109.935%20577.284%20109.881%20577.207C109.827%20577.129%20109.533%20577.178%20109.533%20577.183C109.533%20577.202%20109.475%20577.556%20109.533%20577.633C109.573%20577.687%20109.636%20577.687%20109.71%20577.648C109.744%20577.629%20109.778%20577.6%20109.807%20577.561Z'%20fill='%233A56F6'/%3e%3cpath%20d='M109.23%20577.105C109.328%20576.989%20109.357%20576.829%20109.303%20576.751C109.25%20576.674%20108.971%20576.722%20108.956%20576.727C108.956%20576.747%20108.897%20577.105%20108.956%20577.178C108.995%20577.231%20109.059%20577.231%20109.132%20577.192C109.166%20577.173%20109.201%20577.144%20109.23%20577.105Z'%20fill='%233A56F6'/%3e%3cpath%20d='M108.657%20578.22C108.755%20578.104%20108.785%20577.944%20108.731%20577.866C108.677%20577.789%20108.398%20577.837%20108.383%20577.842C108.383%20577.861%20108.325%20578.215%20108.383%20578.297C108.423%20578.351%20108.486%20578.351%20108.56%20578.312C108.594%20578.293%20108.628%20578.264%20108.657%20578.225V578.22Z'%20fill='%233A56F6'/%3e%3cpath%20d='M108.08%20577.765C108.178%20577.648%20108.207%20577.488%20108.153%20577.411C108.099%20577.333%20107.806%20577.382%20107.806%20577.387C107.806%20577.406%20107.747%20577.765%20107.806%20577.837C107.845%20577.891%20107.908%20577.891%20107.982%20577.852C108.016%20577.832%20108.05%20577.803%20108.08%20577.765Z'%20fill='%233A56F6'/%3e%3cpath%20d='M107.512%20578.874C107.61%20578.758%20107.639%20578.598%20107.585%20578.521C107.532%20578.443%20107.253%20578.492%20107.238%20578.496C107.238%20578.516%20107.179%20578.87%20107.238%20578.947C107.277%20579%20107.341%20579%20107.414%20578.962C107.448%20578.942%20107.483%20578.913%20107.512%20578.874Z'%20fill='%233A56F6'/%3e%3cpath%20d='M106.935%20578.419C107.033%20578.302%20107.062%20578.142%20107.008%20578.065C106.954%20577.987%20106.675%20578.036%20106.661%20578.041C106.661%20578.06%20106.602%20578.419%20106.661%20578.491C106.7%20578.545%20106.763%20578.545%20106.837%20578.506C106.871%20578.487%20106.905%20578.457%20106.935%20578.419Z'%20fill='%233A56F6'/%3e%3cpath%20d='M121.827%20537.999L91.7396%20555.446'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M119.252%20536.54L89.1357%20553.992'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M116.683%20535.081L86.5322%20552.538'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M114.109%20533.622L83.924%20551.084'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M111.539%20532.164L81.3201%20549.63'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M108.965%20530.705L78.7168%20548.176'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M106.397%20529.241L76.1136%20546.723'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M103.827%20527.782L73.5054%20545.268'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M101.253%20526.324L70.9015%20543.815'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M98.684%20524.865L68.2983%20542.361'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M96.1094%20523.406L65.6943%20540.907'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M93.54%20521.947L63.0858%20539.453'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M90.9661%20520.488L60.4825%20537.999'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M105.496%20549.916L105.506%20561.495L115.631%20555.708V544.13L105.496%20549.916Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M70.3438%20529.895L105.496%20549.999L115.631%20544.212L80.469%20524.109L70.3438%20529.895Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M93.4573%20559.314L128.57%20579.417L163.781%20559.314L128.619%20539.206L93.4573%20559.314Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M93.4573%20559.314V599.52L128.619%20619.624L128.57%20579.417L93.4573%20559.314Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M128.57%20579.417L128.619%20619.624L163.781%20599.52V559.314L128.57%20579.417Z'%20fill='%23E6E9FE'/%3e%3cpath%20d='M159.445%20558.926L129.358%20576.374'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M156.871%20557.467L126.754%20574.92'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M154.302%20556.008L124.151%20573.465'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M151.732%20554.55L121.547%20572.012'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M149.158%20553.091L118.939%20570.558'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M146.589%20551.632L116.336%20569.104'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M144.015%20550.168L113.732%20567.65'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M141.446%20548.71L111.129%20566.196'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M138.872%20547.251L108.52%20564.742'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M136.303%20545.792L105.917%20563.288'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M133.733%20544.333L103.313%20561.834'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M131.159%20542.874L100.71%20560.38'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M128.59%20541.411L98.1012%20558.926'%20stroke='%23ABB7FB'%20stroke-width='0.452235'%20stroke-miterlimit='10'/%3e%3cpath%20d='M143.115%20570.844L143.129%20582.417L153.25%20576.63V565.057L143.115%20570.844Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M107.967%20550.823L143.114%20570.926L153.249%20565.139L118.087%20545.036L107.967%20550.823Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M55.8387%20496.096L90.9518%20516.199L126.163%20496.096L91.0008%20475.992L55.8387%20496.096Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M55.8387%20496.096V536.307L91.0008%20556.411L90.9518%20516.199L55.8387%20496.096Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M90.9514%20516.199L91.0004%20556.411L126.162%20536.307V496.096L90.9514%20516.199Z'%20fill='%23E6E9FE'/%3e%3cpath%20d='M112.93%20532.861V534.359C112.939%20535.445%20113.664%20535.92%20114.589%20535.503L114.598%20538.086L113.781%20538.551C113.664%20538.619%20113.571%20538.779%20113.571%20538.91C113.571%20539.041%20113.664%20539.094%20113.781%20539.031L115.797%20537.878C115.915%20537.81%20116.008%20537.65%20116.008%20537.519C116.008%20537.388%20115.915%20537.335%20115.797%20537.398L114.985%20537.863L114.975%20535.28C115.9%20534.64%20116.62%20533.336%20116.62%20532.251V530.753L115.646%20531.306L115.367%20532.299L115.861%20531.999L115.117%20534.543L115.357%20532.716L114.868%20532.978L115.103%20531.616L112.925%20532.861H112.93Z'%20fill='%233A56F6'/%3e%3cpath%20d='M123.828%20532.401L118.562%20535.411L118.567%20536.356L123.828%20533.346V532.401Z'%20fill='%233A56F6'/%3e%3cpath%20d='M122.845%20532.416L122.835%20528.558L123.295%20528.296L122.399%20527.516L121.509%20529.319L121.969%20529.052L121.979%20532.91L122.845%20532.416Z'%20fill='%233A56F6'/%3e%3cpath%20d='M120.412%20533.807L120.398%20529.949L120.858%20529.687L119.962%20528.907L119.072%20530.71L119.532%20530.448L119.541%20534.301L120.412%20533.807Z'%20fill='%233A56F6'/%3e%3cpath%20d='M109.807%20535.275C109.905%20535.159%20109.935%20534.999%20109.881%20534.921C109.827%20534.844%20109.533%20534.892%20109.533%20534.897C109.533%20534.916%20109.475%20535.27%20109.533%20535.348C109.573%20535.401%20109.636%20535.401%20109.71%20535.362C109.744%20535.343%20109.778%20535.314%20109.807%20535.275Z'%20fill='%233A56F6'/%3e%3cpath%20d='M109.23%20534.819C109.328%20534.703%20109.357%20534.543%20109.303%20534.466C109.25%20534.388%20108.971%20534.436%20108.956%20534.441C108.956%20534.461%20108.897%20534.819%20108.956%20534.892C108.995%20534.945%20109.059%20534.945%20109.132%20534.907C109.166%20534.887%20109.201%20534.858%20109.23%20534.819Z'%20fill='%233A56F6'/%3e%3cpath%20d='M108.657%20535.929C108.755%20535.813%20108.785%20535.653%20108.731%20535.575C108.677%20535.498%20108.398%20535.546%20108.383%20535.551C108.383%20535.571%20108.325%20535.924%20108.383%20536.007C108.423%20536.06%20108.486%20536.06%20108.56%20536.021C108.594%20536.002%20108.628%20535.973%20108.657%20535.934V535.929Z'%20fill='%233A56F6'/%3e%3cpath%20d='M108.08%20535.474C108.178%20535.358%20108.207%20535.198%20108.153%20535.12C108.099%20535.042%20107.806%20535.091%20107.806%20535.096C107.806%20535.115%20107.747%20535.474%20107.806%20535.547C107.845%20535.6%20107.908%20535.6%20107.982%20535.561C108.016%20535.542%20108.05%20535.513%20108.08%20535.474Z'%20fill='%233A56F6'/%3e%3cpath%20d='M107.512%20536.589C107.61%20536.472%20107.639%20536.312%20107.585%20536.235C107.532%20536.157%20107.253%20536.206%20107.238%20536.211C107.238%20536.23%20107.179%20536.584%20107.238%20536.661C107.277%20536.715%20107.341%20536.715%20107.414%20536.676C107.448%20536.656%20107.483%20536.627%20107.512%20536.589Z'%20fill='%233A56F6'/%3e%3cpath%20d='M106.935%20536.133C107.033%20536.017%20107.062%20535.857%20107.008%20535.779C106.954%20535.702%20106.675%20535.75%20106.661%20535.755C106.661%20535.774%20106.602%20536.133%20106.661%20536.206C106.7%20536.259%20106.763%20536.259%20106.837%20536.22C106.871%20536.201%20106.905%20536.172%20106.935%20536.133Z'%20fill='%233A56F6'/%3e%3cpath%20d='M105.496%20507.63L105.506%20519.204L115.631%20513.417V501.844L105.496%20507.63Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M70.3438%20487.609L105.496%20507.713L115.631%20501.926L80.469%20481.823L70.3438%20487.609Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M93.4573%20517.023L128.57%20537.126L163.781%20517.023L128.619%20496.92L93.4573%20517.023Z'%20fill='%23C7CFFD'/%3e%3cpath%20d='M93.4574%20517.023V557.234L128.619%20577.338L128.57%20537.126L93.4574%20517.023Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M128.57%20537.126L128.619%20577.338L163.781%20557.234V517.023L128.57%20537.126Z'%20fill='%23E6E9FE'/%3e%3cpath%20d='M143.115%20528.558L143.129%20540.131L153.25%20534.345V522.771L143.115%20528.558Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M107.967%20508.537L143.114%20528.64L153.249%20522.853L118.087%20502.75L107.967%20508.537Z'%20fill='%23ABB7FB'/%3e%3cpath%20d='M13.4548%20709.778L13.4547%20787.612C13.3773%20792.883%2016.1682%20797.789%2020.7652%20800.457C20.7652%20800.457%2064.598%20823.887%20101.317%20845.635'%20stroke='%2300DC91'%20stroke-miterlimit='10'%20stroke-linecap='round'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_81_14352'%3e%3crect%20width='517'%20height='744'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", si = S("max-w-screen-3xl mx-auto w-full");
var o_ = /* @__PURE__ */ ((e) => (e.Wizard = "wizard", e.Notification = "notification", e))(o_ || {});
const a_ = ({ main: e }) => /* @__PURE__ */ u(
  "div",
  {
    className: "flex w-full grow flex-col bg-fixed bg-right-bottom bg-no-repeat md:flex-row",
    style: {
      backgroundImage: `url("${l_}")`
    },
    children: /* @__PURE__ */ u("div", { className: S(si, "md:px-16"), children: /* @__PURE__ */ u("div", { className: "flex w-full flex-col gap-8 p-4 md:max-w-screen-md md:px-0", children: e }) })
  }
), s_ = ({
  sidebar: e,
  isSidebarSticky: t,
  main: n
}) => /* @__PURE__ */ V(me, { children: [
  /* @__PURE__ */ u("aside", { className: "max-md:hidden md:mr-4 md:w-72 md:shrink-0 md:border-r md:pt-4 md:pr-4", children: /* @__PURE__ */ u("div", { className: S({ "xl:sticky xl:top-16": t }), children: e }) }),
  /* @__PURE__ */ u("main", { className: "flex w-full flex-col gap-8 overflow-x-auto py-4", children: n })
] }), c_ = ({
  sidebar: e,
  isSidebarSticky: t,
  context: n,
  visual: r,
  main: i
}) => /* @__PURE__ */ V(me, { children: [
  e ? /* @__PURE__ */ u(
    "aside",
    {
      className: S("max-md:hidden", "md:mr-4 md:w-48 md:shrink-0 md:py-4", {
        "md:border-r md:pr-4": !n,
        "xl:w-56": !n,
        "xl:w-72": n
      }),
      children: /* @__PURE__ */ u("div", { className: S({ "xl:sticky xl:top-16": t }), children: e })
    }
  ) : null,
  /* @__PURE__ */ u(
    "main",
    {
      className: S("flex w-full flex-col gap-8 overflow-x-auto p-4", "md:px-0", {
        "max-w-screen-md lg:mr-auto lg:self-center": r
      }),
      children: i
    }
  ),
  n ? /* @__PURE__ */ u(
    "aside",
    {
      className: S(
        "flex w-full flex-col gap-8 overflow-x-auto p-4",
        "max-md:border-t",
        "md:ml-4 md:w-48 md:shrink-0 md:border-l md:py-4 md:pr-0 md:pl-4",
        "xl:w-64"
      ),
      children: n
    }
  ) : r ? /* @__PURE__ */ u(
    "aside",
    {
      className: S(
        "flex w-full flex-col gap-8 overflow-x-auto p-4",
        "max-md:hidden",
        "md:ml-4 md:w-64 md:shrink-0 md:self-center md:py-4 md:pr-0 md:pl-4",
        "xl:w-96",
        "[&_img]:block [&_img]:h-auto [&_img]:w-full"
      ),
      children: r
    }
  ) : null
] }), d_ = ({
  sidebar: e,
  isSidebarSticky: t,
  context: n,
  visual: r,
  main: i,
  type: a
}) => {
  switch (a) {
    case "wizard":
      return a_({ main: i });
    case "notification":
      return s_({ sidebar: e, isSidebarSticky: t, main: i });
    default:
      return c_({ sidebar: e, isSidebarSticky: t, context: n, visual: r, main: i });
  }
}, u_ = ({
  header: e,
  navigation: t,
  title: n,
  sidebar: r,
  isSidebarSticky: i = !0,
  main: a,
  type: c,
  context: d,
  footer: f,
  visual: p,
  ...m
}) => {
  const v = c === "wizard";
  return /* @__PURE__ */ V("div", { className: S("bg-surface-background-default flex min-h-screen grow flex-col"), ...m, children: [
    /* @__PURE__ */ u(
      "div",
      {
        className: S(
          "bg-surface-background-card relative flex items-center justify-between gap-16",
          "max-sm:border max-sm:border-b"
        ),
        children: /* @__PURE__ */ u(
          "div",
          {
            className: S(
              "flex h-14 flex-col gap-16",
              si,
              "px-4",
              "max-sm:justify-center",
              "sm:flex-row sm:items-center sm:justify-between",
              "md:px-16"
            ),
            children: e
          }
        )
      }
    ),
    /* @__PURE__ */ u(
      "nav",
      {
        className: S(
          "bg-surface-background-card z-20",
          "sm:sticky sm:top-0",
          "max-sm:fixed max-sm:right-0 max-sm:bottom-0 max-sm:left-0"
        ),
        children: t
      }
    ),
    n ? /* @__PURE__ */ u(
      "div",
      {
        className: S(
          "bg-surface-background-card relative flex min-h-20 flex-col justify-center overflow-hidden border-b"
        ),
        children: /* @__PURE__ */ V("div", { className: S(si, "relative z-10 p-4", "md:p-4 md:px-16"), children: [
          n,
          /* @__PURE__ */ u(
            "img",
            {
              src: i_,
              alt: "",
              className: S("pointer-events-none absolute top-0 right-0 z-[-1] h-[300px] -translate-y-1/2 transform")
            }
          )
        ] })
      }
    ) : null,
    /* @__PURE__ */ u(
      "div",
      {
        className: S("flex grow flex-col md:flex-row", !v && si, {
          "md:px-16": !v
        }),
        children: d_({ sidebar: r, context: d, visual: p, main: a, type: c, isSidebarSticky: i })
      }
    ),
    /* @__PURE__ */ u("footer", { className: S("flex border-t text-neutral-500", "max-md:pb-14"), children: /* @__PURE__ */ u(
      "div",
      {
        className: S(
          "flex flex-row items-center justify-between gap-16",
          si,
          "p-4",
          "max-sm:flex-col max-sm:items-start",
          "md:p-4 md:px-16"
        ),
        children: f
      }
    ) })
  ] });
};
u_.displayName = "Layout";
const f_ = ({ children: e, ...t }) => /* @__PURE__ */ u(
  "div",
  {
    className: S("bg-surface-background-card border-separator-border", "max-sm:border-t", "sm:border-b"),
    ...t,
    children: e
  }
);
f_.displayName = "Navigation";
const h_ = ({ action: e, children: t }) => {
  const n = jt.count(t), r = jt.toArray(t), i = r.slice(0, Math.ceil(n / 2)), a = r.slice(Math.ceil(n / 2), n);
  return /* @__PURE__ */ V(
    "div",
    {
      className: S(
        "max-w-screen-3xl mx-auto flex w-full items-center gap-8 px-4",
        "max-sm:justify-center",
        "sm:gap-16",
        "md:px-16"
      ),
      children: [
        i,
        e ? /* @__PURE__ */ u(
          "button",
          {
            className: S(
              "sm:hidden",
              "bg-button-primary-default-background text-button-primary-default-text flex cursor-pointer items-center rounded-md p-2 transition-all",
              "hover:bg-button-primary-hover-background hover:text-button-primary-hover-text"
            ),
            onClick: () => e.onClick(),
            children: /* @__PURE__ */ u(Re, { name: "Plus", size: "sm" })
          }
        ) : null,
        a
      ]
    }
  );
};
h_.displayName = "NavigationList";
const p_ = ({ icon: e, children: t, disabled: n, active: r, onClick: i, ...a }) => /* @__PURE__ */ V(
  "button",
  {
    className: S(
      "relative flex flex-col items-center gap-4 text-xs opacity-50 transition-all",
      "max-sm:p-2",
      "sm:h-11 sm:flex-row sm:text-sm",
      {
        "cursor-pointer": !n,
        "cursor-not-allowed": n,
        "hover:opacity-100": !n,
        "opacity-100": r,
        "sm:after:bg-surface-deep-800 sm:after:absolute sm:after:right-0 sm:after:-bottom-px sm:after:left-0 sm:after:h-0.5 sm:after:w-full": r
      }
    ),
    onClick: () => i == null ? void 0 : i(),
    ...a,
    children: [
      e ? /* @__PURE__ */ u("div", { className: S("flex"), children: /* @__PURE__ */ u(Re, { name: e, size: "sm" }) }) : null,
      /* @__PURE__ */ u("div", { children: t })
    ]
  }
);
p_.displayName = "NavigationItem";
const m_ = ({ children: e, ...t }) => /* @__PURE__ */ u("div", { className: S("flex max-h-[calc(100vh-254px)] w-full max-w-96 flex-col gap-16"), ...t, children: e });
m_.displayName = "Notifications";
const v_ = ({ children: e }) => /* @__PURE__ */ u("div", { className: S("grow-0"), children: e });
v_.displayName = "NotificationsHeader";
const g_ = ({ nested: e, scrollable: t, children: n }) => /* @__PURE__ */ u(
  "div",
  {
    role: "list",
    className: S("flex w-full flex-col", {
      "max-h-64 overflow-y-auto overscroll-contain": e,
      "overflow-y-auto overscroll-contain": t
    }),
    children: n
  }
);
g_.displayName = "NotificationsList";
const L_ = ({ children: e }) => /* @__PURE__ */ u("div", { className: S("bg-surface-base-white sticky bottom-0 -mr-4 grow-0 px-4 py-2 text-xs"), children: e });
L_.displayName = "NotificationsFooter";
const w_ = ({ status: e, children: t, onClick: n }) => /* @__PURE__ */ u(
  "button",
  {
    role: "listitem",
    "aria-current": e === "active" ? "true" : void 0,
    className: S(
      "relative flex w-full shrink-0 flex-col gap-8 overflow-hidden border p-2 text-left shadow-xs",
      "hover:bg-surface-primary-50",
      "focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-hidden",
      "[&:not(:first-child)]:border-t-0",
      {
        "bg-surface-primary-50 text-typography-default": e === "active",
        "bg-surface-deep-50 text-typography-muted": e === "read",
        "bg-surface-base-white text-typography-default": e === "unread"
      }
    ),
    onClick: () => n == null ? void 0 : n(),
    onKeyDown: (r) => {
      (r.key === "Enter" || r.key === " ") && (r.preventDefault(), n == null || n());
    },
    children: t
  }
);
w_.displayName = "Notification";
const M_ = {
  h1: "font-inter font-normal text-[48px] font-extrabold leading-[1] tracking-[0px]",
  h2: "font-inter font-normal text-[30px] font-semibold leading-[1] tracking-[0px]",
  h3: "font-inter font-normal text-[24px] font-semibold leading-[1] tracking-[0px]",
  h4: "font-inter font-normal text-[20px] font-semibold leading-[1] tracking-[0px]",
  h5: "font-inter font-normal text-[18px] font-semibold leading-[1] tracking-[0px]",
  h6: "font-inter font-normal text-[16px] font-semibold leading-[1] tracking-[0px]",
  body: "font-inter font-normal text-[14px] font-normal leading-[24px] tracking-[0px]",
  "body-bold": "font-inter font-normal text-[14px] font-semibold leading-[24px] tracking-[0px]",
  small: "font-inter font-normal text-[12px] font-normal leading-[14px] tracking-[0px]",
  "small-bold": "font-inter font-normal text-[12px] font-semibold leading-[14px] tracking-[0px]",
  tiny: "font-inter font-normal text-[10px] font-normal leading-[14px] tracking-[0px]",
  "tiny-bold": "font-inter font-normal text-[10px] font-semibold leading-[14px] tracking-[0px]"
}, x_ = Ye("tracking-tight", {
  variants: {
    /** Variant of the typography */
    variant: M_,
    /** Color of the typography */
    color: {
      default: "text-typography-default",
      muted: "text-typography-muted",
      positive: "text-typography-positive",
      warning: "text-typography-warning",
      negative: "text-typography-negative",
      primary: "text-typography-primary"
    },
    /** Whether the text should be truncated */
    truncate: {
      true: "truncate"
    },
    /** Whether the text should be preformatted */
    preformatted: {
      true: "whitespace-pre-wrap break-words"
    }
  },
  defaultVariants: {
    variant: "body",
    preformatted: !1
  }
}), tt = W(({ variant: e, color: t, as: n, children: r, truncate: i, preformatted: a, ...c }, d) => /* @__PURE__ */ u(a && !n ? "pre" : i ? "div" : n || "span", { ref: d, className: S(x_({ variant: e, color: t, truncate: i, preformatted: a })), ...c, children: r }));
tt.displayName = "Typography";
const b_ = ({ isSelected: e, isExpanded: t, expandedContent: n, children: r }) => /* @__PURE__ */ V(r9, { state: e ? "selected" : "default", children: [
  /* @__PURE__ */ u("div", { children: r }),
  t && /* @__PURE__ */ u("div", { className: "bg-surface-background-default -mx-4 -mb-4 border-t p-4", children: n })
] });
b_.displayName = "QuoteExpandable";
const y_ = Ye("inline-flex shrink-0 w-4 h-4 items-center justify-center", {
  variants: {
    /** Feedback color of the status-icon */
    color: {
      muted: "bg-surface-neutral-300 text-icon-default",
      positive: "bg-surface-positive-50 text-icon-default",
      warning: "bg-surface-warning-50 text-surface-warning-500",
      negative: "bg-surface-negative-50 text-icon-negative"
    }
  },
  defaultVariants: {
    color: "muted"
  }
}), C_ = ({ icon: e, color: t = "muted", ...n }) => /* @__PURE__ */ u("div", { className: S(y_({ color: t })), ...n, children: /* @__PURE__ */ u(Re, { name: e, size: "sm" }) });
C_.displayName = "StatusIcon";
const C9 = O2({
  orientation: void 0
}), kd = "TS", E9 = O2({
  index: -1,
  total: 0
}), Mn = "—", E_ = (e) => {
  switch (e) {
    case "active":
    case "completed":
      return "ArrowRight";
    case "negative":
      return "Warning";
  }
}, D3 = ({ orientation: e = "vertical", children: t, ...n }) => /* @__PURE__ */ u(
  C9.Provider,
  {
    value: {
      orientation: e
    },
    children: /* @__PURE__ */ u(
      "div",
      {
        className: S("w flex w-full flex-col", {
          "flex-row": e === "horizontal",
          "gap-16": e === "vertical",
          "gap-4": e === "horizontal"
        }),
        ...n,
        children: jt.map(t, (r, i) => /* @__PURE__ */ u(
          E9.Provider,
          {
            value: {
              index: i,
              total: jt.count(t)
            },
            children: r
          }
        ))
      }
    )
  }
);
D3.displayName = "Timeline";
const s2 = ({
  title: e,
  state: t,
  label: n,
  bar: r = "solid",
  progress: i,
  transhipment: a,
  transhipmentData: c,
  delayText: d,
  children: f,
  size: p
}) => {
  const { orientation: m } = pt(C9), { index: v, total: g } = pt(E9), w = v === g - 1, x = E_(t), b = typeof i == "number" ? Math.max(0, Math.min(100, i)) : t === "completed" ? 100 : 0, y = m === "horizontal", E = m === "vertical";
  return /* @__PURE__ */ V(
    "div",
    {
      className: S("relative flex max-w-64 min-w-0 flex-1 gap-8", {
        "flex-col": y
      }),
      children: [
        /* @__PURE__ */ V(
          "div",
          {
            className: S("flex flex-col items-start gap-4", {
              "w-full flex-row items-center": y
            }),
            children: [
              /* @__PURE__ */ u(
                "div",
                {
                  className: S("flex h-3 w-3 items-center justify-center rounded-md", {
                    "bg-primary-500 text-base-white": t === "completed" || t === "active",
                    "bg-negative-50 text-icon-negative": t === "negative",
                    "bg-deep-300 text-neutral-500": t === "upcoming",
                    "rotate-90": E && (t === "completed" || t === "active") && !c,
                    "bg-surface-primary-50 text-typography-default w-max px-1 py-0.5 text-sm": c && E,
                    "bg-surface-deep-100 text-typography-muted": c && c.completed === 0 && E
                  }),
                  children: c && E ? /* @__PURE__ */ u(
                    tt,
                    {
                      variant: "tiny",
                      children: `${kd} ${c.completed}/${c.total}`
                    }
                  ) : x ? /* @__PURE__ */ u(Re, { size: "xs", name: x }) : null
                }
              ),
              w ? null : /* @__PURE__ */ V(
                "div",
                {
                  role: "separator",
                  className: S("border-deep-300 relative flex-1", {
                    "ml-[5px] h-full border-l-2": E,
                    "w-full border-t-2 border-l-0": y,
                    "border-negative-50": t === "negative",
                    "border-dashed": r === "dashed"
                  }),
                  style: {
                    // @ts-expect-error - Custom CSS variable
                    "--timeline-item-progress": `${b}%`
                  },
                  children: [
                    /* @__PURE__ */ u(
                      "div",
                      {
                        className: S("border-primary-500 absolute", {
                          "top-0 right-full border-l-2": E,
                          "bottom-0 left-0 w-full border-t-2 border-l-0": y,
                          "h-[var(--timeline-item-progress)]": E,
                          "w-[var(--timeline-item-progress)]": y,
                          "border-negative-500": t === "negative",
                          "border-dashed": r === "dashed"
                        })
                      }
                    ),
                    c && y ? /* @__PURE__ */ u("div", { className: "bg-surface-primary-50 text-typography-default absolute bottom-[-5px] left-[calc(50%-12px)] z-5 flex h-3 w-max items-center justify-center rounded-md px-1 py-0.5 text-sm", children: /* @__PURE__ */ u(
                      tt,
                      {
                        variant: "tiny",
                        children: `${kd} ${c.completed}/${c.total}`
                      }
                    ) }) : null
                  ]
                }
              )
            ]
          }
        ),
        E ? f ? /* @__PURE__ */ u(Us, { type: "multiple", orientation: m, className: "min-h-8 w-full", children: /* @__PURE__ */ u(Ks, { value: "0", children: /* @__PURE__ */ V(yi, { gap: 8, children: [
          /* @__PURE__ */ V("div", { className: S("inline-grid w-full flex-col gap-2", "[&_*]:truncate"), children: [
            /* @__PURE__ */ u(Ys, { className: S("group"), children: /* @__PURE__ */ V("div", { className: "items-between flex w-full justify-between", children: [
              /* @__PURE__ */ u(tt, { variant: a ? "small" : "small-bold", children: e || Mn }),
              /* @__PURE__ */ u("div", { className: "inline-flex transition-transform duration-200 group-data-[state=open]:rotate-180", children: /* @__PURE__ */ u(Re, { size: "sm", name: "ChevronDown" }) })
            ] }) }),
            a ? null : /* @__PURE__ */ u(Dd, { label: n, delayText: d })
          ] }),
          /* @__PURE__ */ u(
            qs,
            {
              className: S(
                "overflow-hidden transition-all duration-500",
                "data-[state=closed]:animate-accordion-up",
                "data-[state=open]:animate-accordion-down",
                {
                  "ml-[-20px]": a
                }
              ),
              children: /* @__PURE__ */ u(yi, { gap: 4, children: f })
            }
          )
        ] }) }) }) : /* @__PURE__ */ V("div", { className: S("inline-grid w-full flex-col gap-2", "[&_*]:truncate"), children: [
          /* @__PURE__ */ u("div", { className: "items-between flex w-full justify-between", children: /* @__PURE__ */ u(tt, { variant: a ? "small" : "small-bold", children: e }) }),
          a ? null : /* @__PURE__ */ u(Dd, { label: n, delayText: d })
        ] }) : /* @__PURE__ */ V("div", { className: S("text-typography-default flex w-full min-w-0 flex-col gap-4", "[&_*]:truncate"), children: [
          /* @__PURE__ */ u(tt, { variant: "small-bold", children: e }),
          n
        ] })
      ]
    }
  );
};
s2.displayName = "TimelineItem";
const F9 = ({ delayText: e }) => e ? /* @__PURE__ */ V("div", { className: "flex gap-2", children: [
  /* @__PURE__ */ u(Re, { size: "xs", name: "Refresh", color: "negative" }),
  /* @__PURE__ */ u(tt, { variant: "small", color: "negative", children: e })
] }) : null, Dd = ({ label: e, delayText: t }) => /* @__PURE__ */ V(yi, { gap: 4, children: [
  e,
  /* @__PURE__ */ u(F9, { delayText: t })
] }), I0 = ({ label: e, delayText: t }) => /* @__PURE__ */ V(sr, { gap: 4, y: "center", children: [
  /* @__PURE__ */ u("span", { children: e }),
  /* @__PURE__ */ u("div", { className: S("!overflow-visible !whitespace-normal"), children: /* @__PURE__ */ u(F9, { delayText: t }) })
] }), F_ = ({ children: e }) => /* @__PURE__ */ u("div", { className: "bg-surface-deep-100 flex flex-col gap-8 rounded-md p-2", children: e }), T0 = ({ tooltip: e, title: t }) => e ? /* @__PURE__ */ V(Gl, { children: [
  /* @__PURE__ */ u(Ul, { children: /* @__PURE__ */ u(tt, { variant: "small-bold", children: t || Mn }) }),
  /* @__PURE__ */ u(jl, { children: e })
] }) : /* @__PURE__ */ u(tt, { variant: "small-bold", children: t || Mn });
var z_ = /* @__PURE__ */ ((e) => (e.Address = "Adress", e.LabelValue = "LabelValue", e))(z_ || {});
const A_ = ({ timeline: { origin: e, departure: t, arrival: n, delivery: r } }) => {
  const [i, a] = q(!1), c = () => {
    a(window.innerWidth <= ly("1512px"));
  };
  T(() => {
    if (!(typeof window > "u"))
      return c(), window.addEventListener("resize", c), () => {
        window.removeEventListener("resize", c);
      };
  }, []);
  const d = i ? "xs" : "sm", f = i ? "vertical" : "horizontal";
  return /* @__PURE__ */ V(D3, { orientation: "horizontal", children: [
    /* @__PURE__ */ u(
      s2,
      {
        title: /* @__PURE__ */ V(sr, { gap: 4, y: "start", children: [
          e.flag && /* @__PURE__ */ u(Mi, { country: e.flag.toUpperCase() }),
          /* @__PURE__ */ u(T0, { tooltip: e.titleTooltip, title: e.title })
        ] }),
        state: e.state,
        label: /* @__PURE__ */ u(
          d2,
          {
            size: "xs",
            label: e.label,
            value: e.labelValue ? /* @__PURE__ */ u(I0, { label: e.labelValue, delayText: e.delayText }) : null,
            orientation: f,
            placeholder: Mn
          }
        ),
        progress: e.progress,
        size: d
      }
    ),
    /* @__PURE__ */ u(
      s2,
      {
        title: /* @__PURE__ */ u(T0, { tooltip: t.titleTooltip, title: t.title }),
        state: t.state,
        label: /* @__PURE__ */ u(
          d2,
          {
            size: "xs",
            label: t.label,
            value: t.labelValue ? /* @__PURE__ */ u(I0, { label: t.labelValue, delayText: t.delayText }) : null,
            orientation: f,
            placeholder: Mn
          }
        ),
        transhipment: !!t.transhipmentData,
        transhipmentData: t.transhipmentData,
        progress: t.progress,
        size: d
      }
    ),
    /* @__PURE__ */ u(
      s2,
      {
        title: /* @__PURE__ */ u(T0, { tooltip: n.titleTooltip, title: n.title }),
        state: n.state,
        label: /* @__PURE__ */ u(
          d2,
          {
            size: "xs",
            label: n.label,
            value: n.labelValue ? /* @__PURE__ */ u(I0, { label: n.labelValue, delayText: n.delayText }) : null,
            orientation: f,
            placeholder: Mn
          }
        ),
        progress: n.progress,
        size: d
      }
    ),
    /* @__PURE__ */ u(
      s2,
      {
        title: /* @__PURE__ */ V(sr, { gap: 4, y: "start", children: [
          r.flag && /* @__PURE__ */ u(Mi, { country: r.flag.toUpperCase() }),
          /* @__PURE__ */ u(T0, { tooltip: r.titleTooltip, title: r.title })
        ] }),
        state: r.state,
        label: /* @__PURE__ */ u(
          d2,
          {
            size: "xs",
            label: r.label,
            value: r.labelValue ? /* @__PURE__ */ u(I0, { label: r.labelValue, delayText: r.delayText }) : null,
            orientation: f,
            placeholder: Mn
          }
        ),
        progress: r.progress,
        size: d
      }
    )
  ] });
};
A_.displayName = "HorizontalTimeline";
const S_ = ({ timelineItem: e }) => {
  const t = e.type === "Adress" ? e.address || Mn : e.value || Mn, n = e.truncate ? /* @__PURE__ */ V(Gl, { children: [
    /* @__PURE__ */ u(Ul, { children: /* @__PURE__ */ u(tt, { variant: "small", truncate: e.truncate, children: t }) }),
    /* @__PURE__ */ u(jl, { children: t })
  ] }) : t;
  return e.type === "Adress" ? e.truncate ? n : /* @__PURE__ */ u(tt, { variant: "small", children: n }) : /* @__PURE__ */ u(
    d2,
    {
      size: "xs",
      label: e.label,
      truncate: e.truncate,
      value: e.url ? /* @__PURE__ */ u(gf, { target: "_blank", href: e.url, children: n }) : n,
      orientation: "horizontal"
    }
  );
}, ei = (e) => e.map((t, n) => /* @__PURE__ */ u(F_, { children: t.map((r, i) => /* @__PURE__ */ u(S_, { timelineItem: r }, i)) }, n)), k_ = ({ timeline: { origin: e, departure: t, transhipment: n, arrival: r, delivery: i } }) => /* @__PURE__ */ V(D3, { orientation: "vertical", children: [
  /* @__PURE__ */ u(
    s2,
    {
      title: /* @__PURE__ */ V(sr, { gap: 4, y: "start", children: [
        e.flag && /* @__PURE__ */ u(Mi, { country: e.flag.toUpperCase() }),
        /* @__PURE__ */ u(tt, { variant: "small-bold", children: e.title })
      ] }),
      state: e.state,
      progress: e.progress,
      label: /* @__PURE__ */ u(
        d2,
        {
          size: "xs",
          label: e.label,
          value: e.labelValue,
          orientation: "horizontal",
          placeholder: Mn
        }
      ),
      delayText: e.delayText,
      children: e.originData && ei(e.originData)
    }
  ),
  /* @__PURE__ */ u(
    s2,
    {
      title: t.title,
      state: t.state,
      progress: t.progress,
      label: /* @__PURE__ */ u(
        d2,
        {
          size: "xs",
          label: t.label,
          value: t.labelValue,
          orientation: "horizontal",
          placeholder: Mn
        }
      ),
      delayText: t.delayText,
      children: t.departureData && ei(t.departureData)
    }
  ),
  n && /* @__PURE__ */ u(
    s2,
    {
      title: "Transshipment stops",
      state: n.completed === 0 ? "upcoming" : n.completed === n.total ? "completed" : "active",
      progress: n.completed / n.total * 100,
      transhipment: !0,
      transhipmentData: { total: n.total, completed: n.completed },
      children: n.transhipmentData && ei(n.transhipmentData)
    }
  ),
  /* @__PURE__ */ u(
    s2,
    {
      title: r.title,
      state: r.state,
      progress: r.progress,
      label: /* @__PURE__ */ u(
        d2,
        {
          size: "xs",
          label: r.label,
          value: r.labelValue,
          orientation: "horizontal",
          placeholder: Mn
        }
      ),
      delayText: r.delayText,
      children: r.arrivalData && ei(r.arrivalData)
    }
  ),
  /* @__PURE__ */ u(
    s2,
    {
      title: /* @__PURE__ */ V(sr, { gap: 4, y: "start", children: [
        i.flag && /* @__PURE__ */ u(Mi, { country: i.flag.toUpperCase() }),
        /* @__PURE__ */ u(tt, { variant: "small-bold", children: i.title })
      ] }),
      state: i.state,
      progress: i.progress,
      label: /* @__PURE__ */ u(
        d2,
        {
          size: "xs",
          label: i.label,
          value: i.labelValue,
          orientation: "horizontal",
          placeholder: Mn
        }
      ),
      delayText: i.delayText,
      children: i.deliveryData && ei(i.deliveryData)
    }
  )
] });
k_.displayName = "VerticalTimeline";
const D_ = Ye(
  S(
    "relative w-full min-h-20 border shadow-xs flex flex-col p-3 gap-8",
    "focus-visible:ring-ring focus-visible:outline-hidden focus-visible:ring-2"
  ),
  {
    variants: {
      variant: {
        primary: "bg-card-background border-border-default text-typography-primary",
        neutral: "bg-card-background border-border-default text-typography-default",
        negative: "bg-card-background border-border-negative text-typography-negative",
        positive: "bg-surface-positive-50 border-border-positive text-typography-positive",
        warning: "bg-card-background border-border-warning text-typography-warning"
      }
    },
    defaultVariants: {
      variant: "primary"
    }
  }
), R_ = W(
  ({ variant: e, href: t, target: n, rel: r, onClick: i, children: a, ...c }, d) => {
    const f = t ? "a" : "button";
    return /* @__PURE__ */ V("div", { ref: d, className: S(D_({ variant: e })), ...c, children: [
      a,
      t || i ? /* @__PURE__ */ u(
        f,
        {
          className: S("absolute inset-0 z-0"),
          href: t,
          target: n,
          rel: r,
          onClick: () => i == null ? void 0 : i()
        }
      ) : null
    ] });
  }
);
R_.displayName = "Widget";
const __ = W(({ children: e }, t) => /* @__PURE__ */ u("div", { ref: t, className: S("flex flex-col gap-2"), children: e }));
__.displayName = "WidgetHeader";
const P_ = W(
  ({ children: e, ...t }, n) => /* @__PURE__ */ u(tt, { variant: "small", ref: n, ...t, children: e })
);
P_.displayName = "WidgetTitle";
const H_ = W(({ children: e }, t) => /* @__PURE__ */ u("div", { ref: t, className: S("flex flex-col gap-8"), children: e }));
H_.displayName = "WidgetContent";
const O_ = W(({ children: e }, t) => /* @__PURE__ */ u("div", { ref: t, className: S("mt-auto flex items-end justify-between"), children: e }));
O_.displayName = "WidgetFooter";
const N_ = W(
  ({ title: e, description: t, date: n, state: r, onClick: i, children: a }, c) => /* @__PURE__ */ V(
    i ? "button" : "div",
    {
      ref: c,
      className: S(
        "border-border-default bg-surface-neutral-50 text-typography-default flex flex-col gap-2 border border-l-4 p-2",
        "[&_*]:truncate",
        {
          "border-border-negative": r === "negative",
          "inline-block text-left": i
        }
      ),
      onClick: () => i == null ? void 0 : i(),
      children: [
        /* @__PURE__ */ u(tt, { variant: "small-bold", truncate: !0, children: e }),
        /* @__PURE__ */ u(tt, { variant: "small", color: "muted", truncate: !0, children: t }),
        a,
        /* @__PURE__ */ u(tt, { variant: "tiny", color: "muted", children: n })
      ]
    }
  )
);
N_.displayName = "WidgetActionItem";
const B_ = Ye(
  S(
    "bg-toggle-default-background text-typography-default border border-border-default flex gap-4 items-center justify-center rounded-md transition-colors whitespace-nowrap w-44 bg-surface-neutral-50 h-20 px-3",
    "disabled:cursor-not-allowed disabled:bg-surface-deep-100 data-[state=on]:disabled:bg-surface-deep-100 disabled:text-icon-muted [&>span]:disabled:text-typography-disabled [&>span.radio]:disabled:border-radio-select-disabled-shape [&>span]:data-[state=on]:disabled:border-radio-select-disabled-shape data-[state=on]:disabled:text-typography-muted data-[state=on]:disabled:border-border-disabled",
    "hover:bg-toggle-hover-background hover:text-typography-hover-icon",
    "data-[state=on]:bg-toggle-selected-background data-[state=on]:text-typography-primary data-[state=on]:border-border-primary"
  )
), I_ = W(
  ({ className: e, children: t, id: n, label: r, hint: i, state: a, required: c, disabled: d, ...f }, p) => /* @__PURE__ */ V("div", { className: "flex flex-col gap-2", children: [
    r && /* @__PURE__ */ u(jn, { htmlFor: n, required: c, children: r }),
    /* @__PURE__ */ u(
      M9,
      {
        ref: p,
        id: n,
        type: "single",
        className: S(
          "flex w-full items-center",
          {
            "cursor-not-allowed": d
          },
          e
        ),
        ...f,
        orientation: "horizontal",
        disabled: d,
        "aria-required": c,
        "aria-invalid": a === "negative",
        children: t
      }
    ),
    i && /* @__PURE__ */ u(
      "div",
      {
        className: S("text-hint-default-text text-xs", {
          "text-hint-negative-text": a === "negative"
        }),
        children: i
      }
    )
  ] })
);
I_.displayName = "Choice";
const T_ = W(
  ({ icon: e, children: t, className: n, ...r }, i) => /* @__PURE__ */ V(
    x9,
    {
      ref: i,
      className: S(
        B_(),
        "relative mr-4 rounded-lg",
        "last:mr-0",
        "data-[state=on]:[&>span.radio]:border-radio-select-default-shape data-[state=on]:[&>span.radio]:border-4",
        n
      ),
      ...r,
      children: [
        /* @__PURE__ */ u(
          "span",
          {
            className: S("radio border-radio-deselect-default-shape absolute top-2 left-2 h-4 w-4 rounded-lg border-1")
          }
        ),
        e ? /* @__PURE__ */ u("div", { className: S("flex"), children: /* @__PURE__ */ u(Re, { name: e, size: "lg" }) }) : null,
        /* @__PURE__ */ u(tt, { variant: "h6", children: t })
      ]
    }
  )
);
T_.displayName = "ChoiceItem";
var Xl = "Popover", [z9, uX] = Tt(Xl, [
  A1
]), Ni = A1(), [V_, vr] = z9(Xl), A9 = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: a,
    modal: c = !1
  } = e, d = Ni(t), f = M.useRef(null), [p, m] = M.useState(!1), [v, g] = Kt({
    prop: r,
    defaultProp: i ?? !1,
    onChange: a,
    caller: Xl
  });
  return /* @__PURE__ */ u(_l, { ...d, children: /* @__PURE__ */ u(
    V_,
    {
      scope: t,
      contentId: xn(),
      triggerRef: f,
      open: v,
      onOpenChange: g,
      onOpenToggle: M.useCallback(() => g((w) => !w), [g]),
      hasCustomAnchor: p,
      onCustomAnchorAdd: M.useCallback(() => m(!0), []),
      onCustomAnchorRemove: M.useCallback(() => m(!1), []),
      modal: c,
      children: n
    }
  ) });
};
A9.displayName = Xl;
var S9 = "PopoverAnchor", k9 = M.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = vr(S9, n), a = Ni(n), { onCustomAnchorAdd: c, onCustomAnchorRemove: d } = i;
    return M.useEffect(() => (c(), () => d()), [c, d]), /* @__PURE__ */ u(Pl, { ...a, ...r, ref: t });
  }
);
k9.displayName = S9;
var D9 = "PopoverTrigger", R9 = M.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = vr(D9, n), a = Ni(n), c = ct(t, i.triggerRef), d = /* @__PURE__ */ u(
      ke.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": I9(i.open),
        ...r,
        ref: c,
        onClick: be(e.onClick, i.onOpenToggle)
      }
    );
    return i.hasCustomAnchor ? d : /* @__PURE__ */ u(Pl, { asChild: !0, ...a, children: d });
  }
);
R9.displayName = D9;
var R3 = "PopoverPortal", [Z_, $_] = z9(R3, {
  forceMount: void 0
}), _9 = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: i } = e, a = vr(R3, t);
  return /* @__PURE__ */ u(Z_, { scope: t, forceMount: n, children: /* @__PURE__ */ u(Yt, { present: n || a.open, children: /* @__PURE__ */ u(S1, { asChild: !0, container: i, children: r }) }) });
};
_9.displayName = R3;
var x1 = "PopoverContent", P9 = M.forwardRef(
  (e, t) => {
    const n = $_(x1, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, a = vr(x1, e.__scopePopover);
    return /* @__PURE__ */ u(Yt, { present: r || a.open, children: a.modal ? /* @__PURE__ */ u(G_, { ...i, ref: t }) : /* @__PURE__ */ u(U_, { ...i, ref: t }) });
  }
);
P9.displayName = x1;
var W_ = /* @__PURE__ */ _r("PopoverContent.RemoveScroll"), G_ = M.forwardRef(
  (e, t) => {
    const n = vr(x1, e.__scopePopover), r = M.useRef(null), i = ct(t, r), a = M.useRef(!1);
    return M.useEffect(() => {
      const c = r.current;
      if (c) return Hl(c);
    }, []), /* @__PURE__ */ u(Si, { as: W_, allowPinchZoom: !0, children: /* @__PURE__ */ u(
      H9,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: be(e.onCloseAutoFocus, (c) => {
          var d;
          c.preventDefault(), a.current || (d = n.triggerRef.current) == null || d.focus();
        }),
        onPointerDownOutside: be(
          e.onPointerDownOutside,
          (c) => {
            const d = c.detail.originalEvent, f = d.button === 0 && d.ctrlKey === !0, p = d.button === 2 || f;
            a.current = p;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: be(
          e.onFocusOutside,
          (c) => c.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), U_ = M.forwardRef(
  (e, t) => {
    const n = vr(x1, e.__scopePopover), r = M.useRef(!1), i = M.useRef(!1);
    return /* @__PURE__ */ u(
      H9,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var c, d;
          (c = e.onCloseAutoFocus) == null || c.call(e, a), a.defaultPrevented || (r.current || (d = n.triggerRef.current) == null || d.focus(), a.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (a) => {
          var f, p;
          (f = e.onInteractOutside) == null || f.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const c = a.target;
          ((p = n.triggerRef.current) == null ? void 0 : p.contains(c)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && i.current && a.preventDefault();
        }
      }
    );
  }
), H9 = M.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: i,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: c,
      onEscapeKeyDown: d,
      onPointerDownOutside: f,
      onFocusOutside: p,
      onInteractOutside: m,
      ...v
    } = e, g = vr(x1, n), w = Ni(n);
    return Qs(), /* @__PURE__ */ u(
      Sl,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: i,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ u(
          E1,
          {
            asChild: !0,
            disableOutsidePointerEvents: c,
            onInteractOutside: m,
            onEscapeKeyDown: d,
            onPointerDownOutside: f,
            onFocusOutside: p,
            onDismiss: () => g.onOpenChange(!1),
            children: /* @__PURE__ */ u(
              d3,
              {
                "data-state": I9(g.open),
                role: "dialog",
                id: g.contentId,
                ...w,
                ...v,
                ref: t,
                style: {
                  ...v.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), O9 = "PopoverClose", N9 = M.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = vr(O9, n);
    return /* @__PURE__ */ u(
      ke.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: be(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
N9.displayName = O9;
var j_ = "PopoverArrow", B9 = M.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, i = Ni(n);
    return /* @__PURE__ */ u(u3, { ...i, ...r, ref: t });
  }
);
B9.displayName = j_;
function I9(e) {
  return e ? "open" : "closed";
}
var T9 = A9, V9 = R9, Z9 = _9, $9 = P9, K_ = N9, Y_ = B9;
const Zr = ({ children: e, ...t }) => /* @__PURE__ */ u(T9, { ...t, children: e });
Zr.displayName = "Popover";
const R1 = ({ children: e }) => /* @__PURE__ */ u(V9, { asChild: !0, children: e });
R1.displayName = "PopoverTrigger";
const $r = W(
  ({ children: e, align: t = "start", sideOffset: n, className: r, closable: i, indicator: a, popoverFooter: c, ...d }, f) => /* @__PURE__ */ u(Z9, { children: /* @__PURE__ */ V(
    $9,
    {
      ref: f,
      align: t,
      sideOffset: n,
      className: S(
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-auto max-w-96 min-w-32 rounded-lg border bg-neutral-50 shadow-md outline-hidden",
        r
      ),
      onWheel: (p) => {
        p.stopPropagation();
      },
      ...d,
      children: [
        e,
        i && /* @__PURE__ */ u(K_, { className: S("absolute top-2 right-2 cursor-pointer"), children: /* @__PURE__ */ u(Re, { size: "xs", name: "Close" }) }),
        a && /* @__PURE__ */ u(Y_, { className: S("fill-neutral-200") }),
        c && /* @__PURE__ */ u("div", { className: "border-spotlight-body-border bg-spotlight-body-background text-spotlight-body-text relative border-t p-2", children: c })
      ]
    }
  ) })
);
$r.displayName = "PopoverContent";
const q_ = W(
  ({
    value: e,
    onChange: t,
    defaultOpen: n,
    label: r,
    disabled: i,
    required: a,
    hint: c,
    state: d,
    disabledDates: f,
    placeholder: p = "Pick a date",
    ...m
  }, v) => {
    const [g, w] = q(n), x = (b) => {
      t(b), w(!1);
    };
    return /* @__PURE__ */ V(Zr, { open: g, onOpenChange: w, children: [
      /* @__PURE__ */ V("div", { className: "flex flex-col gap-2", children: [
        r && /* @__PURE__ */ u(jn, { required: a, children: r }),
        /* @__PURE__ */ u(R1, { children: /* @__PURE__ */ V(
          "button",
          {
            disabled: i,
            type: "button",
            className: S(
              Hr({ variant: "outline-secondary" }),
              "w-auto justify-start !p-2 text-sm font-normal",
              {
                "hover:bg-datepicker-hover-background hover:border-datepicker-hover-border hover:text-datepicker-hover-text": !g,
                "border-datepicker-active-border text-datepicker-active-text": g,
                "background-datepicker-disabled-background border-datepicker-disabled-border text-datepicker-disabled-text": i,
                "border-datepicker-negative-border text-datepicker-negative-text": d === "negative"
              }
            ),
            "aria-label": r || "Date picker",
            "aria-expanded": g,
            "aria-haspopup": "dialog",
            "aria-invalid": d === "negative",
            children: [
              /* @__PURE__ */ u(
                "span",
                {
                  className: S("mr-2 flex", {
                    "text-datepicker-active-icon": g,
                    "text-datepicker-disabled-icon": i
                  }),
                  children: /* @__PURE__ */ u(Re, { name: "Calendar" })
                }
              ),
              e ? R2(e, "dd.MM.yyyy") : p
            ]
          }
        ) }),
        c && /* @__PURE__ */ u(
          "div",
          {
            className: S("text-hint-default-text text-xs", {
              "text-hint-negative-text": d === "negative"
            }),
            children: c
          }
        )
      ] }),
      /* @__PURE__ */ V($r, { align: "start", sideOffset: 5, className: "max-w-64", children: [
        /* @__PURE__ */ u(
          "input",
          {
            ref: v,
            type: "datetime-local",
            value: e ? R2(e, "yyyy-MM-dd") : void 0,
            onChange: (b) => b.target.value ? t(new Date(b.target.value)) : t(void 0),
            hidden: !0
          }
        ),
        /* @__PURE__ */ u(
          Yl,
          {
            ...m,
            mode: "single",
            selected: e,
            onSelect: x,
            autoFocus: !0,
            defaultMonth: e,
            seamless: !0,
            disabled: f
          }
        )
      ] })
    ] });
  }
);
q_.displayName = "DatePicker";
const X_ = ({
  value: e,
  label: t,
  onChange: n,
  disabled: r,
  required: i,
  hint: a,
  state: c,
  disabledDates: d,
  placeholder: f = "Pick a date",
  ...p
}) => {
  const [m, v] = q(!1);
  return /* @__PURE__ */ V(Zr, { open: m, onOpenChange: v, children: [
    /* @__PURE__ */ V("div", { className: "flex flex-col gap-2", children: [
      t && /* @__PURE__ */ u(jn, { required: i, children: t }),
      /* @__PURE__ */ u(R1, { children: /* @__PURE__ */ V(
        "button",
        {
          disabled: r,
          type: "button",
          className: S(
            Hr({ variant: "outline-secondary" }),
            "w-auto justify-start !p-2 text-sm font-normal",
            {
              "hover:bg-datepicker-hover-background hover:border-datepicker-hover-border hover:text-datepicker-hover-text": !m,
              "border-datepicker-active-border text-datepicker-active-text": m,
              "background-datepicker-disabled-background border-datepicker-disabled-border text-datepicker-disabled-text": r,
              "border-datepicker-negative-border text-datepicker-negative-text": c === "negative"
            }
          ),
          "aria-label": t || "Date range picker",
          "aria-expanded": m,
          "aria-haspopup": "dialog",
          "aria-invalid": c === "negative",
          children: [
            /* @__PURE__ */ u(
              "span",
              {
                className: S("mr-2 flex h-4 w-4", {
                  "text-datepicker-active-icon": m,
                  "text-datepicker-disabled-icon": r
                }),
                children: /* @__PURE__ */ u(Re, { name: "Calendar" })
              }
            ),
            e != null && e.from ? e.to ? /* @__PURE__ */ V(me, { children: [
              R2(e.from, "dd.MM.yyyy"),
              " – ",
              R2(e.to, "dd.MM.yyyy")
            ] }) : R2(e.from, "dd.MM.yyyy") : f
          ]
        }
      ) }),
      a && /* @__PURE__ */ u(
        "div",
        {
          className: S("text-hint-default-text text-xs", {
            "text-hint-negative-text": c === "negative"
          }),
          children: a
        }
      )
    ] }),
    /* @__PURE__ */ u($r, { align: "start", sideOffset: 5, className: "max-w-none", children: /* @__PURE__ */ u(
      Yl,
      {
        ...p,
        autoFocus: !0,
        mode: "range",
        defaultMonth: e == null ? void 0 : e.from,
        selected: e,
        onSelect: n,
        numberOfMonths: 2,
        seamless: !0,
        disabled: d
      }
    ) })
  ] });
};
X_.displayName = "DateRangePicker";
const W9 = ({ date: e, setDate: t }) => /* @__PURE__ */ V(
  "div",
  {
    className: S(
      "bg-calendar-background border-calendar-border flex items-center justify-between gap-8 rounded-none rounded-b-lg border-t p-3"
    ),
    children: [
      /* @__PURE__ */ u(
        "input",
        {
          name: "time",
          type: "time",
          step: "1",
          value: e ? R2(e, "HH:mm:ss") : void 0,
          onChange: (n) => {
            const r = n.target.value;
            if (!e) return;
            const [i = 0, a = 0, c = 0] = r.split(":").map((f) => parseInt(f, 10) || 0), d = new Date(e);
            d.setHours(i, a, c), t(d);
          },
          className: S(
            "w-full border-none bg-transparent outline-offset-2",
            "[&::-webkit-calendar-picker-indicator]:hidden"
          )
        }
      ),
      /* @__PURE__ */ u(Re, { name: "Clock", size: "lg" })
    ]
  }
);
W9.displayName = "TimePicker";
const J_ = W(
  ({ value: e, label: t, onChange: n, disabled: r, required: i, hint: a, state: c, disabledDates: d, placeholder: f = "Pick a date", ...p }, m) => {
    const [v, g] = q(!1);
    return /* @__PURE__ */ V(Zr, { open: v, onOpenChange: g, children: [
      /* @__PURE__ */ V("div", { className: "flex flex-col gap-2", children: [
        t && /* @__PURE__ */ u(jn, { required: i, children: t }),
        /* @__PURE__ */ u(R1, { children: /* @__PURE__ */ V(
          "button",
          {
            disabled: r,
            type: "button",
            className: S(
              Hr({ variant: "outline-secondary" }),
              "w-auto justify-start !p-2 text-sm font-normal",
              {
                "hover:bg-datepicker-hover-background hover:border-datepicker-hover-border hover:text-datepicker-hover-text": !v,
                "border-datepicker-active-border text-datepicker-active-text": v,
                "background-datepicker-disabled-background border-datepicker-disabled-border text-datepicker-disabled-text": r,
                "border-datepicker-negative-border text-datepicker-negative-text": c === "negative"
              }
            ),
            "aria-label": t || "Date time picker",
            "aria-expanded": v,
            "aria-haspopup": "dialog",
            "aria-invalid": c === "negative",
            children: [
              /* @__PURE__ */ u(
                "span",
                {
                  className: S("mr-2 flex", {
                    "text-datepicker-active-icon": v,
                    "text-datepicker-disabled-icon": r
                  }),
                  children: /* @__PURE__ */ u(Re, { name: "Calendar" })
                }
              ),
              e ? R2(e, "dd.MM.yyyy - p") : f
            ]
          }
        ) }),
        a && /* @__PURE__ */ u(
          "div",
          {
            className: S("text-hint-default-text text-xs", {
              "text-hint-negative-text": c === "negative"
            }),
            children: a
          }
        )
      ] }),
      /* @__PURE__ */ V($r, { align: "start", sideOffset: 5, className: "max-w-64", children: [
        /* @__PURE__ */ u(
          "input",
          {
            ref: m,
            type: "datetime-local",
            value: e ? R2(e, "yyyy-MM-dd'T'hh:mm") : void 0,
            onChange: (w) => w.target.value ? n(new Date(w.target.value)) : n(void 0),
            hidden: !0
          }
        ),
        /* @__PURE__ */ u(
          Yl,
          {
            ...p,
            mode: "single",
            selected: e,
            onSelect: n,
            autoFocus: !0,
            defaultMonth: e,
            seamless: !0,
            disabled: d
          }
        ),
        /* @__PURE__ */ u(W9, { setDate: n, date: e })
      ] })
    ] });
  }
);
J_.displayName = "DateTimePicker";
var Jl = "Dialog", [G9, fX] = Tt(Jl), [Q_, Kn] = G9(Jl), U9 = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: a,
    modal: c = !0
  } = e, d = M.useRef(null), f = M.useRef(null), [p, m] = Kt({
    prop: r,
    defaultProp: i ?? !1,
    onChange: a,
    caller: Jl
  });
  return /* @__PURE__ */ u(
    Q_,
    {
      scope: t,
      triggerRef: d,
      contentRef: f,
      contentId: xn(),
      titleId: xn(),
      descriptionId: xn(),
      open: p,
      onOpenChange: m,
      onOpenToggle: M.useCallback(() => m((v) => !v), [m]),
      modal: c,
      children: n
    }
  );
};
U9.displayName = Jl;
var j9 = "DialogTrigger", K9 = M.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Kn(j9, n), a = ct(t, i.triggerRef);
    return /* @__PURE__ */ u(
      ke.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": H3(i.open),
        ...r,
        ref: a,
        onClick: be(e.onClick, i.onOpenToggle)
      }
    );
  }
);
K9.displayName = j9;
var _3 = "DialogPortal", [eP, Y9] = G9(_3, {
  forceMount: void 0
}), q9 = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, a = Kn(_3, t);
  return /* @__PURE__ */ u(eP, { scope: t, forceMount: n, children: M.Children.map(r, (c) => /* @__PURE__ */ u(Yt, { present: n || a.open, children: /* @__PURE__ */ u(S1, { asChild: !0, container: i, children: c }) })) });
};
q9.displayName = _3;
var al = "DialogOverlay", X9 = M.forwardRef(
  (e, t) => {
    const n = Y9(al, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = Kn(al, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ u(Yt, { present: r || a.open, children: /* @__PURE__ */ u(nP, { ...i, ref: t }) }) : null;
  }
);
X9.displayName = al;
var tP = /* @__PURE__ */ _r("DialogOverlay.RemoveScroll"), nP = M.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Kn(al, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ u(Si, { as: tP, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ u(
        ke.div,
        {
          "data-state": H3(i.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Or = "DialogContent", J9 = M.forwardRef(
  (e, t) => {
    const n = Y9(Or, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = Kn(Or, e.__scopeDialog);
    return /* @__PURE__ */ u(Yt, { present: r || a.open, children: a.modal ? /* @__PURE__ */ u(rP, { ...i, ref: t }) : /* @__PURE__ */ u(iP, { ...i, ref: t }) });
  }
);
J9.displayName = Or;
var rP = M.forwardRef(
  (e, t) => {
    const n = Kn(Or, e.__scopeDialog), r = M.useRef(null), i = ct(t, n.contentRef, r);
    return M.useEffect(() => {
      const a = r.current;
      if (a) return Hl(a);
    }, []), /* @__PURE__ */ u(
      Q9,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: be(e.onCloseAutoFocus, (a) => {
          var c;
          a.preventDefault(), (c = n.triggerRef.current) == null || c.focus();
        }),
        onPointerDownOutside: be(e.onPointerDownOutside, (a) => {
          const c = a.detail.originalEvent, d = c.button === 0 && c.ctrlKey === !0;
          (c.button === 2 || d) && a.preventDefault();
        }),
        onFocusOutside: be(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), iP = M.forwardRef(
  (e, t) => {
    const n = Kn(Or, e.__scopeDialog), r = M.useRef(!1), i = M.useRef(!1);
    return /* @__PURE__ */ u(
      Q9,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var c, d;
          (c = e.onCloseAutoFocus) == null || c.call(e, a), a.defaultPrevented || (r.current || (d = n.triggerRef.current) == null || d.focus(), a.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (a) => {
          var f, p;
          (f = e.onInteractOutside) == null || f.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const c = a.target;
          ((p = n.triggerRef.current) == null ? void 0 : p.contains(c)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && i.current && a.preventDefault();
        }
      }
    );
  }
), Q9 = M.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, ...c } = e, d = Kn(Or, n), f = M.useRef(null), p = ct(t, f);
    return Qs(), /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        Sl,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ u(
            E1,
            {
              role: "dialog",
              id: d.contentId,
              "aria-describedby": d.descriptionId,
              "aria-labelledby": d.titleId,
              "data-state": H3(d.open),
              ...c,
              ref: p,
              onDismiss: () => d.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ V(me, { children: [
        /* @__PURE__ */ u(lP, { titleId: d.titleId }),
        /* @__PURE__ */ u(aP, { contentRef: f, descriptionId: d.descriptionId })
      ] })
    ] });
  }
), P3 = "DialogTitle", ef = M.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Kn(P3, n);
    return /* @__PURE__ */ u(ke.h2, { id: i.titleId, ...r, ref: t });
  }
);
ef.displayName = P3;
var tf = "DialogDescription", nf = M.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Kn(tf, n);
    return /* @__PURE__ */ u(ke.p, { id: i.descriptionId, ...r, ref: t });
  }
);
nf.displayName = tf;
var rf = "DialogClose", lf = M.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Kn(rf, n);
    return /* @__PURE__ */ u(
      ke.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: be(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
lf.displayName = rf;
function H3(e) {
  return e ? "open" : "closed";
}
var of = "DialogTitleWarning", [hX, af] = Vx(of, {
  contentName: Or,
  titleName: P3,
  docsSlug: "dialog"
}), lP = ({ titleId: e }) => {
  const t = af(of), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return M.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, oP = "DialogDescriptionWarning", aP = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${af(oP).contentName}}.`;
  return M.useEffect(() => {
    var a;
    const i = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, O3 = U9, N3 = K9, B3 = q9, I3 = X9, T3 = J9, sf = ef, cf = nf, Ql = lf;
const sP = O3;
sP.displayName = "Dialog";
const cP = N3;
cP.displayName = "DialogTrigger";
const df = B3;
df.displayName = "DialogPortal";
const dP = Ql;
dP.displayName = "DialogClose";
const uf = W(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  I3,
  {
    ref: n,
    className: S(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 bg-overlay-background fixed inset-0 z-40 opacity-80"
    ),
    ...t
  }
));
uf.displayName = "DialogOverlay";
const uP = Ye("dialog", {
  variants: {
    maxWidth: {
      "screen-sm": "max-w-screen-sm",
      "screen-md": "max-w-screen-md",
      "screen-lg": "max-w-screen-lg",
      full: "max-w-[95%]"
    },
    maxHeight: {
      default: "max-h-[65%]",
      // For standard dialogs with forms or text
      large: "max-h-[80%]",
      // For content-heavy dialogs like tables or grids
      full: "max-h-[95%]"
      // For document previews or full-screen experiences
    }
  },
  defaultVariants: {
    maxWidth: "screen-sm",
    maxHeight: "default"
  }
}), fP = W(
  ({ children: e, maxWidth: t, maxHeight: n, ...r }, i) => /* @__PURE__ */ V(df, { children: [
    /* @__PURE__ */ u(uf, {}),
    /* @__PURE__ */ u(
      T3,
      {
        ref: i,
        className: S(
          "fixed top-[50%] left-[50%] z-40 flex h-full w-full translate-x-[-50%] translate-y-[-50%] duration-200",
          "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
          "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%]",
          "sm:h-auto sm:p-4",
          uP({ maxWidth: t, maxHeight: n })
        ),
        ...r,
        children: /* @__PURE__ */ V(
          "div",
          {
            className: S(
              "border-dialog-border bg-dialog-background relative mx-auto flex w-full flex-col gap-16 border p-4 shadow-lg",
              "sm:rounded-lg"
            ),
            children: [
              e,
              /* @__PURE__ */ V(
                Ql,
                {
                  className: S(
                    "ring-offset-background absolute top-4 right-4 rounded-xs opacity-70 transition-opacity",
                    "hover:opacity-100",
                    "focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden",
                    "disabled:pointer-events-none"
                  ),
                  children: [
                    /* @__PURE__ */ u(Re, { name: "Close" }),
                    /* @__PURE__ */ u("span", { className: "sr-only", children: "Close" })
                  ]
                }
              )
            ]
          }
        )
      }
    )
  ] })
);
fP.displayName = "DialogContent";
const hP = ({ className: e, ...t }) => /* @__PURE__ */ u("div", { className: S("flex grow-0 flex-col gap-4"), ...t });
hP.displayName = "DialogHeader";
const pP = ({ className: e, ...t }) => /* @__PURE__ */ u("div", { className: S("mt-auto flex grow-0 flex-col-reverse gap-8 sm:flex-row sm:justify-end"), ...t });
pP.displayName = "DialogFooter";
const mP = W(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  sf,
  {
    ref: n,
    className: S("text-dialog-title text-lg leading-none font-semibold tracking-tight"),
    ...t
  }
));
mP.displayName = "DialogTitle";
const vP = W(({ className: e, ...t }, n) => /* @__PURE__ */ u(cf, { ref: n, className: S("text-dialog-description text-sm"), ...t }));
vP.displayName = "DialogDescription";
const gP = ({ children: e }) => /* @__PURE__ */ u("div", { className: "overflow-y-auto", children: e });
gP.displayName = "DialogBody";
const LP = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='160'%20height='200'%20fill='none'%3e%3cpath%20fill='%23E6E9FE'%20d='M160%20154.107V62.602L81.029%2016.849%202.053%2062.602v91.505L81.03%20199.86%20160%20154.107Z'/%3e%3cpath%20fill='%238F9FFA'%20d='M140.947%2072.016v71.655l-61.838%2035.825.084-71.659%2061.754-35.821Z'/%3e%3cpath%20fill='%23ABB7FB'%20d='m140.953%2072.015-61.755%2035.821-61.927-35.82L79.114%2036.18l61.839%2035.834Z'/%3e%3cpath%20fill='%23ABB7FB'%20d='m79.198%20107.836-.084%2071.66-61.843-35.825V72.015l61.927%2035.821Z'/%3e%3cpath%20fill='%23EFF2FF'%20d='m128.558%20129.909-.951-1.342%202.326-6.02%202.126%202.993.96-1.202-1.226%205.478-4.2%201.291.965-1.202v.004ZM133.876%20128.047l3.021%204.266-2.321%206.02-4.2-5.917%203.5-4.369ZM129.611%20136.841l1.888-1.1%202.349%203.317-4.228%202.446v1.282l-2.96-1.909%202.942-5.323v1.282l.009.005ZM122.493%20140.092l-4.671%202.703%202.102-5.449-.965-.084%204.191-3.569%201.254%204.041-.97-.084-.941%202.442ZM120.036%20147.066l-2.344-3.316%208.344-4.837.014%204.668-6.009%203.48-.005.005ZM129.34%20122.313l-4.148%2010.749-3.51-.305%202.983-7.741%204.675-2.703Z'/%3e%3cpath%20fill='%233A56F6'%20d='m121.509%2089.374.028%2011.389-.438.258-.037-11.39.443-.257h.004ZM122.586%2088.751l.028%209.832-.215.117-.023-9.827.205-.126.005.004ZM123.771%2088.06l.028%209.832-.215.117-.028-9.828.215-.126v.004ZM125.047%2087.325l.028%209.832-.387.22-.028-9.832.387-.22ZM128.619%2085.258l.023%209.832-.387.22-.028-9.828.392-.224ZM126.148%2086.684l.028%209.832-.205.126-.028-9.832.205-.126ZM127.676%2085.805l.023%209.832-.881.51-.028-9.833.886-.51ZM136.957%2080.421l.038%2011.394-.443.258-.028-11.395.438-.257h-.005ZM135.652%2081.178l.028%209.833-.205.117-.028-9.828.205-.126v.004ZM134.473%2081.866l.023%209.832-.205.117-.028-9.827.214-.127-.004.005ZM133.564%2082.389l.028%209.832-.788.454-.023-9.828.783-.458ZM129.797%2084.569l.028%209.832-.387.225-.028-9.832.387-.225ZM132.086%2083.241l.028%209.832-.214.117-.023-9.832.205-.117h.004ZM131.243%2083.737l.028%209.832-.886.51-.023-9.832.881-.51Z'/%3e%3cpath%20fill='%23C7CFFD'%20d='M17.266%2072.015%200%2035.118%2062.072.285l17.032%2035.9-61.838%2035.83Z'/%3e%3cpath%20fill='%238F9FFA'%20d='m78.107%2036.78%201.091%2071.056-61.932-35.821%2060.836-35.24.005.005Z'/%3e%3cpath%20fill='%237286F9'%20d='m140.953%2072.015%2017.163-35.834-61.755%2035.867-17.163%2035.783%2061.754-35.82.001.004Z'/%3e%3cpath%20fill='%233A56F6'%20d='m158.111%2036.186-4.293%209.008-61.47%2035.232%204.008-8.373%2061.755-35.867Z'/%3e%3cpath%20fill='%23EFF2FF'%20d='m17.266%2072.015%201.082-.632%2060.482%2034.993-.467.982.83.479-61.927-35.822Z'/%3e%3cpath%20fill='%238F9FFA'%20d='m78.102%2036.78%201.007-.594L118.661%2059.1l-.969.566-38.583-22.303-1.007-.58v-.004ZM96.356%2072.053l-.792-.702-17.2%2036.012.83.477%2017.163-35.783v-.004Z'/%3e%3cpath%20fill='%23fff'%20d='m95.559%2071.35%2061.363-35.773%201.184.608-61.755%2035.867-.792-.701Z'/%3e%3cpath%20fill='%23ABB7FB'%20d='M18.348%2071.383%201.341%2035.47%200%2035.118l17.266%2036.897%201.082-.632Z'/%3e%3cpath%20fill='%23EFF2FF'%20d='M1.342%2035.47%2062.072.285%2061.022%200%200%2035.118l1.342.352Z'/%3e%3cpath%20fill='%23fff'%20d='M44.675%20102.503c9.583%205.548%2017.326%2019%2017.293%2030.044-.032%2011.043-7.821%2015.496-17.405%209.949-9.584-5.548-17.327-19.005-17.294-30.044.032-11.044%207.826-15.501%2017.41-9.954l-.005.005Z'/%3e%3cpath%20fill='%230226F2'%20d='M50.572%20118.534c.527%201.276.79%202.569.786%203.88-.002.884-.123%201.604-.362%202.161-.24.556-.578.975-1.015%201.257-.438.281-.957.457-1.557.525-.527.072-.96.217-1.296.435-.337.218-.586.561-.746%201.028-.161.467-.246%201.11-.255%201.928v.303l-3.251-1.948v-.302c.01-1.4.126-2.45.346-3.15.22-.7.533-1.182.938-1.449.405-.266.897-.44%201.478-.519a3.369%203.369%200%200%200%201.072-.331c.316-.164.566-.411.75-.74.183-.329.276-.765.277-1.309a4.765%204.765%200%200%200-.357-1.81%206.17%206.17%200%200%200-.968-1.629%205.292%205.292%200%200%200-1.36-1.188c-.462-.277-.9-.42-1.315-.431a1.256%201.256%200%200%200-1.028.457c-.272.314-.424.828-.459%201.537l-3.475-2.082c.037-1.454.342-2.507.913-3.159.573-.652%201.33-.945%202.272-.878.94.066%201.981.442%203.12%201.124a13.565%2013.565%200%200%201%203.283%202.747%2012.883%2012.883%200%200%201%202.21%203.544l-.001-.001ZM44.443%20131.589c.51.306.95.793%201.324%201.457.374.664.56%201.305.558%201.923-.001.418-.09.746-.265.984a.964.964%200%200%201-.688.405c-.284.031-.597-.056-.94-.263-.516-.31-.958-.797-1.329-1.46-.37-.663-.555-1.31-.553-1.941.002-.631.19-1.034.562-1.249.373-.215.816-.167%201.331.144Z'/%3e%3c/svg%3e", wP = ({ title: e, description: t, actions: n, ...r }) => /* @__PURE__ */ V("div", { className: S("flex flex-col items-center justify-center gap-16", "lg:min-h-96"), ...r, children: [
  /* @__PURE__ */ u("img", { src: LP, className: S("block h-auto w-40"), alt: "" }),
  /* @__PURE__ */ V("div", { className: S("flex flex-col items-center gap-4"), children: [
    /* @__PURE__ */ u("div", { className: S("text-emptystate-title text-center"), children: /* @__PURE__ */ u(tt, { variant: "h4", children: e }) }),
    /* @__PURE__ */ u("div", { className: S("text-emptystate-description text-center text-sm"), children: t })
  ] }),
  n ? /* @__PURE__ */ u("div", { className: S("flex"), children: n }) : null
] });
wP.displayName = "EmptyState";
const MP = (e) => {
  switch (e) {
    case "person":
      return "Avatar";
    case "update":
      return "Refresh";
    case "message":
      return "Feed";
    case "positive":
      return "Check";
    case "negative":
      return "WarningPlain";
    case "warning":
      return "WarningPlain";
  }
}, xP = ({ children: e, ...t }) => /* @__PURE__ */ u("div", { className: S("border-default flex w-full flex-col border border-t-0 px-4 pt-8 pb-0"), ...t, children: e });
xP.displayName = "Feed";
const bP = ({ title: e, name: t, action: n, date: r, suffix: i, type: a, children: c }) => {
  const d = MP(a);
  return /* @__PURE__ */ V("div", { className: S("group flex flex-col gap-2 pb-8"), children: [
    /* @__PURE__ */ V("div", { className: S("flex items-center gap-8"), children: [
      /* @__PURE__ */ u(
        "div",
        {
          className: S("text-icon-muted flex h-4 w-4 shrink-0 items-center justify-center rounded-md", {
            "bg-negative-50 border-border-negative text-icon-negative border": a === "negative"
          }),
          children: /* @__PURE__ */ u(Re, { size: "sm", name: d })
        }
      ),
      t ? /* @__PURE__ */ V("div", { className: S("flex gap-2"), children: [
        /* @__PURE__ */ u(tt, { variant: "body-bold", children: t }),
        n ? /* @__PURE__ */ u(tt, { variant: "body", children: n }) : null
      ] }) : /* @__PURE__ */ u(tt, { variant: "body-bold", children: e })
    ] }),
    /* @__PURE__ */ V("div", { className: S("flex-stretch flex gap-8"), children: [
      /* @__PURE__ */ u("div", { className: S("-mb-8 flex w-4 shrink-0 justify-center"), role: "separator", children: /* @__PURE__ */ u("div", { className: S("bg-separator-border h-full w-px group-last:hidden") }) }),
      /* @__PURE__ */ V("div", { className: S("flex min-w-0 grow flex-col gap-8"), children: [
        r || i ? /* @__PURE__ */ V("div", { className: S("text-typography-muted flex gap-8"), children: [
          r ? /* @__PURE__ */ u(tt, { variant: "small", children: r }) : null,
          r && i ? /* @__PURE__ */ u(tt, { variant: "small", children: "•" }) : null,
          r ? /* @__PURE__ */ u(tt, { variant: "small", children: i }) : null
        ] }) : null,
        c
      ] })
    ] })
  ] });
};
bP.displayName = "FeedItem";
var yP = "Separator", Rd = "horizontal", CP = ["horizontal", "vertical"], ff = M.forwardRef((e, t) => {
  const { decorative: n, orientation: r = Rd, ...i } = e, a = EP(r) ? r : Rd, d = n ? { role: "none" } : { "aria-orientation": a === "vertical" ? a : void 0, role: "separator" };
  return /* @__PURE__ */ u(
    ke.div,
    {
      "data-orientation": a,
      ...d,
      ...i,
      ref: t
    }
  );
});
ff.displayName = yP;
function EP(e) {
  return CP.includes(e);
}
var FP = ff;
const zP = Ye(S("shrink-0 bg-separator-border"), {
  variants: {
    /** The orientation of the separator */
    orientation: {
      horizontal: "h-[1px] w-full",
      vertical: "min-h-4 h-full w-[1px]"
    }
  },
  defaultVariants: {
    /** Default version of the separator */
    orientation: "vertical"
  }
}), eo = W(
  ({ orientation: e, ...t }, n) => /* @__PURE__ */ u(
    FP,
    {
      ref: n,
      orientation: e,
      className: S(zP({ orientation: e })),
      ...t
    }
  )
);
eo.displayName = "Separator";
const AP = Ye(
  S(
    "flex flex-none items-center justify-center rounded-md border border-radio-deselect-default-shape transition-all cursor-pointer rounded-full"
  ),
  {
    variants: {
      /** Size of the radio button */
      size: {
        sm: "w-4 h-4 !mr-2",
        lg: "w-6 h-6 !mr-3"
      }
    },
    defaultVariants: {
      size: "sm"
    }
  }
), hf = W(
  ({ size: e, id: t, name: n, checked: r, disabled: i, required: a, label: c, onChange: d, children: f, ...p }, m) => /* @__PURE__ */ V("div", { className: S("flex flex-col gap-12"), children: [
    /* @__PURE__ */ V("label", { className: S("relative w-fit"), children: [
      /* @__PURE__ */ u(
        "input",
        {
          ...p,
          ref: m,
          id: t,
          type: "radio",
          className: S("peer absolute opacity-0", {
            "cursor-pointer": !i,
            "cursor-not-allowed": i
          }),
          name: n,
          checked: r,
          disabled: i,
          required: a,
          onChange: (v) => d == null ? void 0 : d(v.target.checked)
        }
      ),
      /* @__PURE__ */ V(
        "span",
        {
          className: S(
            "flex items-center",
            "peer-focus-visible:ring-ring peer-focus-visible:ring-2 peer-focus-visible:outline-hidden",
            {
              "cursor-pointer": !i,
              "cursor-not-allowed": i
            }
          ),
          children: [
            /* @__PURE__ */ u(
              "div",
              {
                className: S(AP({ size: e }), {
                  "bg-radio-select-default-shape border-radio-select-default-shape text-base-white": r,
                  "border-radio-deselect-disabled-shape": i && !r,
                  "bg-radio-deselect-disabled-shape border-radio-deselect-disabled-shape text-base-white": i && r
                }),
                children: r ? /* @__PURE__ */ u("div", { className: S("bg-base-white flex h-1.5 w-1.5 grow-0 rounded-full") }) : null
              }
            ),
            /* @__PURE__ */ u(
              "span",
              {
                className: S("text-radio-select-default-label text-sm font-medium", {
                  "text-radio-deselect-default-label": r,
                  "text-radio-select-disabled-label": i && !r,
                  "text-radio-deselect-disabled-label": i && r
                }),
                children: c
              }
            )
          ]
        }
      )
    ] }),
    f ? /* @__PURE__ */ u("div", { className: S("pl-6"), children: f }) : null
  ] })
);
hf.displayName = "Radio";
const SP = ({ children: e, ...t }) => /* @__PURE__ */ u(T9, { ...t, children: e });
SP.displayName = "Filter";
const kP = ({ startButton: e, endButton: t }) => /* @__PURE__ */ u(V9, { asChild: !0, children: /* @__PURE__ */ V("div", { className: S("gap-8", Hr({ variant: "outline-secondary" })), children: [
  e,
  t && /* @__PURE__ */ V(me, { children: [
    /* @__PURE__ */ u(eo, {}),
    " ",
    t
  ] })
] }) });
kP.displayName = "FilterTrigger";
const DP = ({ children: e, className: t, ...n }) => /* @__PURE__ */ u("button", { className: "text-button-outline-secondary-default-text", ...n, children: e });
DP.displayName = "FilterTriggerButton";
const RP = W(
  ({ children: e, align: t = "start", sideOffset: n = 5, className: r, ...i }, a) => /* @__PURE__ */ u(Z9, { children: /* @__PURE__ */ u(
    $9,
    {
      ref: a,
      align: t,
      sideOffset: n,
      className: S(
        "bg-surface-base-white z-50 w-auto rounded-lg border shadow-md outline-hidden",
        "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
        "data-[side=bottom]:slide-in-from-top-2",
        "data-[side=left]:slide-in-from-right-2",
        "data-[side=right]:slide-in-from-left-2",
        "data-[side=top]:slide-in-from-bottom-2",
        r
      ),
      onWheel: (c) => {
        c.stopPropagation();
      },
      ...i,
      children: e
    }
  ) })
);
RP.displayName = "FilterContent";
const _P = ({ children: e, ...t }) => /* @__PURE__ */ u("div", { className: S("flex max-h-80"), ...t, children: e });
_P.displayName = "FilterBody";
const PP = ({ children: e, activeItem: t, ...n }) => /* @__PURE__ */ u("div", { className: S("flex w-full flex-col overflow-y-auto overscroll-contain", "md:w-72"), ...n, children: e });
PP.displayName = "FilterList";
const HP = ({ label: e, children: t, ...n }) => /* @__PURE__ */ V("div", { className: S("shrink-0"), ...n, children: [
  /* @__PURE__ */ u("div", { className: S("cursor-default truncate px-4 py-3 [&_*]:truncate"), children: /* @__PURE__ */ u(tt, { variant: "small-bold", as: "div", children: e }) }),
  /* @__PURE__ */ u("div", { className: S(""), children: t })
] });
HP.displayName = "FilterGroup";
const OP = ({ value: e, label: t, suffix: n, active: r, onSelect: i, ...a }) => /* @__PURE__ */ V(
  "button",
  {
    className: S("flex w-full shrink-0 cursor-pointer items-center justify-between gap-4 px-4 py-3", {
      "bg-surface-primary-50": r
    }),
    onClick: () => i(e),
    "data-value": e,
    ...a,
    children: [
      /* @__PURE__ */ u(tt, { variant: "small", as: "div", children: t }),
      n ? /* @__PURE__ */ u("div", { className: S("text-typography-primary w-full truncate text-left [&_*]:truncate"), children: /* @__PURE__ */ V(tt, { variant: "small", as: "div", children: [
        "(",
        n,
        ")"
      ] }) }) : null,
      /* @__PURE__ */ u("div", { className: S("flex"), children: /* @__PURE__ */ u(Re, { name: "ChevronRight", size: "xs", color: r ? "primary" : "muted" }) })
    ]
  }
);
OP.displayName = "FilterItem";
const NP = ({ children: e, ...t }) => /* @__PURE__ */ u("div", { className: S("flex w-full flex-col overflow-y-auto overscroll-contain border-l", "md:w-72"), ...t, children: e });
NP.displayName = "FilterValues";
const BP = ({ name: e, label: t, type: n, selected: r, value: i, onSelect: a, ...c }) => /* @__PURE__ */ u(
  "div",
  {
    className: S("shrink-0 cursor-pointer truncate px-4 py-3", {
      "bg-surface-primary-50 text-typography-primary": r
    }),
    ...c,
    children: n === "checkbox" ? /* @__PURE__ */ u(
      Rr,
      {
        name: e,
        checked: r,
        label: /* @__PURE__ */ u(tt, { variant: "small", as: "div", children: t }),
        onCheckedChange: a
      }
    ) : /* @__PURE__ */ u(
      hf,
      {
        name: e,
        checked: r,
        label: /* @__PURE__ */ u(tt, { variant: "small", as: "div", children: t }),
        onChange: a
      }
    )
  }
);
BP.displayName = "FilterValue";
const IP = ({ className: e, placeholder: t, ...n }) => /* @__PURE__ */ V("div", { className: S("flex items-center gap-8 border-b p-2"), children: [
  /* @__PURE__ */ u(Re, { name: "MagnifyingLens", size: "sm", color: "muted" }),
  /* @__PURE__ */ u("input", { className: S("flex w-full text-xs outline-hidden"), placeholder: t, ...n })
] });
IP.displayName = "FilterSearch";
const TP = ({ children: e, ...t }) => /* @__PURE__ */ u("div", { className: S("flex justify-end gap-8 border-t p-2"), ...t, children: e });
TP.displayName = "FilterFooter";
const VP = ({ ...e }) => /* @__PURE__ */ u(eo, { orientation: "horizontal", ...e });
VP.displayName = "FilterSeparator";
var ZP = ["title"], $P = ["title"], WP = ["title"], GP = ["title"], UP = ["title"], jP = ["title"], KP = ["title"], YP = ["title"], qP = ["title"], XP = ["title"], JP = ["title"], QP = ["title"], eH = ["title"], tH = ["title"], nH = ["title"], rH = ["title"], iH = ["title"], lH = ["title"], oH = ["title"], aH = ["title"], sH = ["title"], cH = ["title"], dH = ["title"], uH = ["title"], fH = ["title"], hH = ["title"], pH = ["title"], mH = ["title"], vH = ["title"], gH = ["title"], LH = ["title"], wH = ["title"], MH = ["title"], xH = ["title"], bH = ["title"], yH = ["title"], CH = ["title"], EH = ["title"], FH = ["title"], zH = ["title"], AH = ["title"], SH = ["title"], kH = ["title"], DH = ["title"], RH = ["title"], _H = ["title"], PH = ["title"], HH = ["title"], OH = ["title"], NH = ["title"], BH = ["title"], IH = ["title"], TH = ["title"], VH = ["title"], ZH = ["title"], $H = ["title"], WH = ["title"], GH = ["title"], UH = ["title"], jH = ["title"], KH = ["title"], YH = ["title"], qH = ["title"], XH = ["title"], JH = ["title"], QH = ["title"], eO = ["title"], tO = ["title"], nO = ["title"], rO = ["title"], iO = ["title"], lO = ["title"], oO = ["title"], aO = ["title"], sO = ["title"], cO = ["title"], dO = ["title"], uO = ["title"], fO = ["title"], hO = ["title"], pO = ["title"], mO = ["title"], vO = ["title"], gO = ["title"], LO = ["title"], wO = ["title"], MO = ["title"], xO = ["title"], bO = ["title"], yO = ["title"], CO = ["title"], EO = ["title"], FO = ["title"], zO = ["title"], AO = ["title"], SO = ["title"], kO = ["title"], DO = ["title"], RO = ["title"], _O = ["title"], PO = ["title"], HO = ["title"], OO = ["title"], NO = ["title"], BO = ["title"], IO = ["title"], TO = ["title"], VO = ["title"], ZO = ["title"], $O = ["title"], WO = ["title"], GO = ["title"], UO = ["title"], jO = ["title"], KO = ["title"], YO = ["title"], qO = ["title"], XO = ["title"], JO = ["title"], QO = ["title"], eN = ["title"], tN = ["title"], nN = ["title"], rN = ["title"], iN = ["title"], lN = ["title"], oN = ["title"], aN = ["title"], sN = ["title"], cN = ["title"], dN = ["title"], uN = ["title"], fN = ["title"], hN = ["title"], pN = ["title"], mN = ["title"], vN = ["title"], gN = ["title"], LN = ["title"], wN = ["title"], MN = ["title"], xN = ["title"], bN = ["title"], yN = ["title"], CN = ["title"], EN = ["title"], FN = ["title"], zN = ["title"], AN = ["title"], SN = ["title"], kN = ["title"], DN = ["title"], RN = ["title"], _N = ["title"], PN = ["title"], HN = ["title"], ON = ["title"], NN = ["title"], BN = ["title"], IN = ["title"], TN = ["title"], VN = ["title"], ZN = ["title"], $N = ["title"], WN = ["title"], GN = ["title"], UN = ["title"], jN = ["title"], KN = ["title"], YN = ["title"], qN = ["title"], XN = ["title"], JN = ["title"], QN = ["title"], eB = ["title"], tB = ["title"], nB = ["title"], rB = ["title"], iB = ["title"], lB = ["title"], oB = ["title"], aB = ["title"], sB = ["title"], cB = ["title"], dB = ["title"], uB = ["title"], fB = ["title"], hB = ["title"], pB = ["title"], mB = ["title"], vB = ["title"], gB = ["title"], LB = ["title"], wB = ["title"], MB = ["title"], xB = ["title"], bB = ["title"], yB = ["title"], CB = ["title"], EB = ["title"], FB = ["title"], zB = ["title"], AB = ["title"], SB = ["title"], kB = ["title"], DB = ["title"], RB = ["title"], _B = ["title"], PB = ["title"], HB = ["title"], OB = ["title"], NB = ["title"], BB = ["title"], IB = ["title"], TB = ["title"], VB = ["title"], ZB = ["title"], $B = ["title"], WB = ["title"], GB = ["title"], UB = ["title"], jB = ["title"], KB = ["title"], YB = ["title"], qB = ["title"], XB = ["title"], JB = ["title"], QB = ["title"], eI = ["title"], tI = ["title"], nI = ["title"], rI = ["title"], iI = ["title"], lI = ["title"], oI = ["title"], aI = ["title"], sI = ["title"], cI = ["title"], dI = ["title"], uI = ["title"], fI = ["title"], hI = ["title"], pI = ["title"], mI = ["title"], vI = ["title"], gI = ["title"], LI = ["title"], wI = ["title"], MI = ["title"], xI = ["title"], bI = ["title"], yI = ["title"], CI = ["title"], EI = ["title"];
function N() {
  return N = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, N.apply(this, arguments);
}
function B(e, t) {
  if (e == null) return {};
  var n = FI(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function FI(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var zI = function(t) {
  var n = t.title, r = B(t, ZP);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M440.1 181.1c-.1 39.2-6.4 81.4-57.4 101.5-51.1-20.1-57.3-62.3-57.4-101.5h114.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#29DBFF",
    d: "M439.6 197.7c-2.8 34.9-12.4 67.4-57 85-44.4-17.6-54.5-51.2-56.9-84.9"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M437.8 214.1c-3.2 24.3-16.7 53.5-55.1 68.6-38.4-15.1-50.5-42.5-55.1-68.4"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#29DBFF",
    d: "M434.2 230.3c-5.7 17.7-19.3 39.4-51.3 52.8-32-12.6-45.2-33.8-51.4-53"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M426.7 246.9c-6.5 11.3-17.7 25.4-44 35.9-27.5-11.5-37.4-25.3-44-36.1"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#29DBFF",
    d: "M412.4 265.1c-8.1 7.2-12 11.2-29.6 17.9-20.1-7.9-22.6-11.6-29.2-17.5"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#5CC85C",
    d: "M383.3 231.6c-.2-.2-27.9 35.7-27.9 35.7-1.8-1.3-10-9.5-13.3-15l41.3-50.1 40.2 49.7c-3.9 6.5-11.4 13.6-13.2 15M382.6 85.3l-26.5 45h53z"
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-82.3 291.431 225.686)",
    fill: "#F7A226",
    cx: 291.4,
    cy: 225.7,
    rx: 48.7,
    ry: 15.7
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-68.099 303.087 164.67)",
    fill: "#DDC7AB",
    cx: 303.1,
    cy: 164.7,
    rx: 11.7,
    ry: 7.2
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-81.738 291.697 271.697)",
    fill: "#DDC7AB",
    cx: 291.7,
    cy: 271.7,
    rx: 11.4,
    ry: 3.3
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "matrix(.9986 -.05353 .05353 .9986 -13.992 16.424)",
    fill: "#DDC7AB",
    cx: 299.6,
    cy: 269.4,
    rx: 3.3,
    ry: 11
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-21.518 314.54 201.06)",
    fill: "#DDC7AB",
    cx: 314.5,
    cy: 201.1,
    rx: 4.1,
    ry: 13.7
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-21.518 317.511 178.077)",
    fill: "#DDC7AB",
    cx: 317.5,
    cy: 178.1,
    rx: 13.7,
    ry: 4.1
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-7.7 473.781 225.857)",
    fill: "#F7A226",
    cx: 473.6,
    cy: 225.9,
    rx: 15.7,
    ry: 48.7
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-21.901 462.057 164.866)",
    fill: "#DDC7AB",
    cx: 462,
    cy: 164.9,
    rx: 7.2,
    ry: 11.7
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-8.27 473.27 271.908)",
    fill: "#DDC7AB",
    cx: 473.4,
    cy: 271.9,
    rx: 3.3,
    ry: 11.4
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "matrix(.05353 -.9986 .9986 .05353 171.34 719.998)",
    fill: "#DDC7AB",
    cx: 465.5,
    cy: 269.6,
    rx: 11,
    ry: 3.3
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-68.482 450.552 201.247)",
    fill: "#DDC7AB",
    cx: 450.6,
    cy: 201.2,
    rx: 13.7,
    ry: 4.1
  }), /* @__PURE__ */ o.createElement("ellipse", {
    transform: "rotate(-68.482 447.58 178.265)",
    fill: "#DDC7AB",
    cx: 447.6,
    cy: 178.3,
    rx: 4.1,
    ry: 13.7
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#B0C6CC",
    d: "M373.3 130.3 356.1 155l17.8 26.1H396l4.7-25.4-5.4-25.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }));
}, AI = function(t) {
  var n = t.title, r = B(t, $P);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342zM198.9 113.6H256v64.8h-57.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M267.6 113.6v64.7m16.6-64.7v64.7m16.6-64.7v64.7",
    stroke: "#D80027",
    strokeWidth: 7
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M247.4 178.4v64.7m-13.3-64.7v64.7m-13.3-64.6v53.9m-13.7-53.9v47.1",
    stroke: "#D80027",
    strokeWidth: 5
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m199.9 146 27.6-32.4 28.5 32.3-28.1 32.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#BC8B00",
    d: "M182.2 95.9v92.2c0 34.3 27.3 54.2 48.6 64.5-.8 1.4 25.1 8.3 25.1 8.3s25.9-6.9 25.1-8.3c21.4-10.3 48.6-30.1 48.6-64.5V95.9H182.2zm129.9 92.2c0 16.9-10 29.4-32.8 43.9-8.6 5.5-17.5 9-23.3 11-5.8-2-14.7-5.5-23.3-11-22.8-14.5-32.8-28-32.8-43.9v-74.5h112.2v74.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M264.4 188.9h29.5v8.6h-29.5zm0 17.6h29.5v8.6h-29.5z"
  }));
}, SI = function(t) {
  var n = t.title, r = B(t, WP);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#009e49",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h171v342H0z"
  }));
}, kI = function(t) {
  var n = t.title, r = B(t, GP);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#DB3E00",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#479900",
    d: "M331 0h182v342H331z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h181.8v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 126.7c-19.4 0-35.2 15.8-35.2 35.2v52.8h70.4v-52.8c0-19.5-15.8-35.2-35.2-35.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 84.3c-47.7 0-86.4 38.7-86.4 86.4S208.3 257 256 257s86.4-38.7 86.4-86.4-38.7-86.3-86.4-86.3zm0 157.7c-39.4 0-71.4-32-71.4-71.4 0-39.4 32-71.4 71.4-71.4 39.4 0 71.4 32 71.4 71.4 0 39.5-32 71.4-71.4 71.4z"
  }));
}, DI = function(t) {
  var n = t.title, r = B(t, UP);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0072c6",
    d: "M88.8 136.5c-2.2 12.9-3.4 26.2-3.4 39.8 0 13.6 1.2 27 3.4 39.8L256 228.3l167.2-12.1c2.2-12.9 3.4-26.2 3.4-39.8s-1.2-27-3.4-39.8"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M423.2 219H88.8c15.8 69.8 84.7 122.3 167.2 122.3S407.4 288.8 423.2 219z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M365.9 136.5H146.1l44.9-21.1-23.9-43.5 48.8 9.4L222 32l34 36.2L290 32l6.1 49.3 48.8-9.4-23.9 43.5z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#ce1126"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M256.5 342 0 0v342z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M513 342V0L256 342z"
  })));
}, RI = function(t) {
  var n = t.title, r = B(t, jP);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#00318b",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M454.8 265.38c7.94-10.93 13.24-24.27 13.24-40.42V104.89a59.754 59.754 0 0 1-36.02 12.01c-19.64 0-37.07-9.43-48.03-24.01-10.95 14.58-28.39 24.01-48.03 24.01-13.52 0-25.99-4.47-36.02-12v120.06c0 16.16 5.3 29.5 13.24 40.42H454.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#8DCCFF",
    d: "M310.23 260.98C332.65 296.96 384 309 384 309s51.35-12.04 73.77-48.02H310.23z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D87B00",
    d: "M396.66 172.21c.32 1.42 8.72 10.17 17.56 20.15 1.39 1.57-8.74 12.63-6.91 12.59 4.75-.12 19.27-17.26 19.34 6.65.05 15.94-30 27.51-30 27.51h17.47l.65 14.96s4.97-13.34 7.59-16.57c8.1-9.97 20.18-30.07 34.59-27.1 14.41 2.97-13.66-13.92-13.66-13.92s-5.2-15.19-16.63-16.97c-10.06-1.57-14.29-2.51-26.64-7.3-1.68-.65-3.88-2.32-3.36 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D87B00",
    d: "M359.69 198.69c1.07-.99 4.46-12.63 8.69-25.28.67-1.99 15.31 1.27 14.35-.3-2.47-4.06-24.58-8.08-3.9-20.08 13.79-8 38.82 12.27 38.82 12.27l-8.72-15.14 12.64-8.03s-14.05 2.35-18.14 1.69c-12.68-2.04-36.13-2.48-40.75-16.45-4.62-13.97-5.25 18.79-5.25 18.79s-10.56 12.08-6.4 22.88c3.66 9.5 4.96 13.64 6.97 26.73.29 1.79-.06 4.53 1.69 2.92z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D87B00",
    d: "M395.67 219.87c-1.39-.43-13.16 2.49-26.22 5.18-2.06.42-6.59-13.88-7.47-12.26-2.27 4.17 5.36 25.31-15.41 13.45-13.84-7.91-8.89-39.73-8.89-39.73l-8.71 15.14-13.29-6.9s9.09 10.96 10.57 14.84c4.6 11.99 16 32.49 6.24 43.49-9.76 11.01 18.88-4.9 18.88-4.9s15.76 3.07 23-5.96c6.38-7.94 9.3-11.14 19.61-19.45 1.43-1.12 3.97-2.19 1.69-2.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256.5 0h-23.1L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1V171h22.6L96 121.8V171h64v-49.2l73.4 49.2h23.1v-22.9l-46.6-30.7h46.6v-64h-46.6l46.6-30.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112V171h32v-69.6h112.5v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 171v-11.3l62.5-42.3h22.6L7.3 171zM7.3.1l77.8 53.2H62.5L0 11.1V.1zm249.2 0v11l-63 42.3h-22.6L248.7.1zM248.7 171l-77.8-53.6h22.6l63 42.3V171z"
  }));
}, _I = function(t) {
  var n = t.title, r = B(t, KP);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#ED2024",
    d: "M0 0h90v60H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#212121",
    d: "M32.5 12.2v16l7.1 2.5-5 4.9 2.4 3 5.3-5.5 1.2 2.3-3 4.9 3.6 5.6-1.8 2.6 2.8 3.6 2.7-3.7-1.5-2.6 3-5.8-2.7-4.6 1.2-2.3 5.2 5.5 2.5-2.9-5.2-5.1 7.2-2.6V12.2l-5.2 1.9-.1 3.8-3.3.3v-2.6l1.7-2.3 5.6-2.2-2.3-.4 1.4-1.2.9.4-.8-1.4L54 9l-1-1.1L47.5 9l1.4 1.1-3.8 4.9-3.8-4.8 1.3-1.1-5-1.2L36.2 9l-1.5-.4-.8 1.4.9-.6 1.6 1.1-2.3.5 5.5 2 1.6 2.3v2.9l-3.3-.3v-3.6z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M26.2 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM57.4 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM53.4 36.1h6.4V38h-6.4zm-23.2 0h6.4V38h-6.4z",
    fill: "#212121"
  }));
}, PI = function(t) {
  var n = t.title, r = B(t, YP);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF9811",
    d: "M0 228h513v114H0z"
  }));
}, HI = function(t) {
  var n = t.title, r = B(t, qP);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    d: "M0 171h513v171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m332.7 135.6 17.5-8.6-7.4-19-18.7 6.2zm-45.6-56 5.5-18.8-19.1-7.2-8 18zm29.4 23.2 12.2-15.3-14.9-13.9-14.2 13.6zm19.4 68.9 19.5-.8v-21.3l-22.9.2zm-12.6 38.1 18.8 5.5 7.3-19-18-8zm-29 32.4 14.9 12.7 14.4-14.4-13.1-14.7zm-47-147.7 9.8 19.9 21.9 3.3-15.9 15.5 3.6 21.9-19.6-10.4-19.7 10.2 3.8-21.9-15.8-15.5 22-3.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m250.8 61.3-2.7 18.3c43.1 3.2 77 39.2 77 83.1 0 46-37.3 82.9-83.4 83.4-29.2.3-51.3-14.8-67-33.7l-13.9 12.3c15 19 40.8 39.9 80.9 39.9 56.3 0 101.9-45.6 101.9-101.9.1-53.2-40.7-96.9-92.8-101.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#000",
    d: "m291.9 223.4-11.8 14s51.9 38.9 53.6 40.4c1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-2-1.5-51.8-42-51.8-42z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M206.1 157.2c-7.7 10.3-7.5 23.1 2.8 30.9 0 0 135.2 101.5 136.9 103 1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-1.9-1.5-149.7-121.5-149.7-121.5zm47.7 99.1 7.3 18.2 19.5-6-4.8-19.1zm-40.4-3.7-2 19.5 20.1 3.6 4.5-19.1zm-35.7-21.2L167.4 248l16.4 12.1 12.5-15.2z"
  })));
}, OI = function(t) {
  var n = t.title, r = B(t, XP);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 744 496"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#3A7DCE",
    d: "M0 0h744v496H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#fff",
    d: "m120 125 90 63 54-14 23-81 61-36 92 14 105 55 6 90 34 12v92l-65 115-78 24-72-17 18-30-8-32-10 9-162-25-49-85 20-46-49-62z"
  }));
}, NI = function(t) {
  var n = t.title, r = B(t, JP);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h512v114H0zm0 228h512v114H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFDA44",
    stroke: "#d6ab00",
    strokeWidth: 5,
    cx: 256.5,
    cy: 171,
    r: 40
  }));
}, BI = function(t) {
  var n = t.title, r = B(t, QP);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#10338c",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M513 33 95.3 171 513 310.76V342L0 171 513 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M513 287.18v24.58L81.72 171 513 30v24.16"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "m476.98 140.21-21.89 10.68-3.18-15.32 31.19-29.77s-9.42-40.65-13.75-44.98l-112.32 55.82-6.84 36.76-31.9 28.59-.4 34.2 34.29-22.76 67.23-2.66-1.51 38.11h22.23l11.9-44.64 31.55-24.61-6.6-19.42z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#EFC100",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "m317.89 238.41-22.24-11.11 22.24-11.11h144.46v22.22z"
  }));
}, II = function(t) {
  var n = t.title, r = B(t, eH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0zm0 228h513v114H0z"
  }));
}, TI = function(t) {
  var n = t.title, r = B(t, tH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#10338c",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M222.2 170.7c.3-.3.5-.6.8-.9-.2.3-.5.6-.8.9zM188 212.6l11 22.9 24.7-5.7-11 22.8 19.9 15.8-24.8 5.6.1 25.4-19.9-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9L332 136zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm42.5 49.7 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.4-7.6-9.5 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zM398 166.5l4.1 12.7h13.3l-10.8 7.8 4.2 12.7-10.8-7.9-10.8 7.9 4.1-12.7-10.7-7.8h13.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M254.8 0v30.6l-45.1 25.1h45.1V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9H99v-48.6l-87.4 48.6H-1.2v-30.6L44 115H-1.2V55.7h59.1L-1.2 22.8V0h26.7L99 40.8V0h55.6v48.6L242.1 0z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M142.8 0h-32v69.3h-112v32h112v69.4h32v-69.4h112v-32h-112z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "m154.6 115 100.2 55.7v-15.8L183 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m154.6 115 100.2 55.7v-15.8L183 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m154.6 115 100.2 55.7v-15.8L183 115zm-83.9 0-71.9 39.9v15.8L99 115z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M99 55.7-1.2 0v15.7l71.9 40z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M99 55.7-1.2 0v15.7l71.9 40z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M99 55.7-1.2 0v15.7l71.9 40zm84 0 71.8-40V0L154.6 55.7z",
    fill: "#D80027"
  }));
}, VI = function(t) {
  var n = t.title, r = B(t, nH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 363 242"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h363v242H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M57 96.9 14.7 78.2 57 59.6l18.6-42.2 18.6 42.2 42.3 18.6-42.3 18.7-18.6 42.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f30028",
    d: "m75.6 40.6 11.5 26.1 26.1 11.5-26.1 11.5-11.5 26.1-11.5-26.1L38 78.2l26.1-11.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 152.2h363v15.7H0zm0 31.4h363v15.7H0z",
    fill: "#FFDA44"
  }));
}, ZI = function(t) {
  var n = t.title, r = B(t, rH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M513 210.9H202.2V342h-79.8V210.9H0v-79.8h122.4V0h79.8v131.1H513v61.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M513 149.7v42.6H183.7V342H141V192.3H0v-42.6h141V0h42.7v149.7z"
  }));
}, $I = function(t) {
  var n = t.title, r = B(t, iH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#ef3340",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00b5e2",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#509e2f",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M265.6 212.6c-23 0-41.6-18.6-41.6-41.6s18.6-41.6 41.6-41.6c7.2 0 13.9 1.8 19.8 5-9.2-9-21.9-14.6-35.8-14.6-28.3 0-51.2 22.9-51.2 51.2s22.9 51.2 51.2 51.2c13.9 0 26.6-5.6 35.8-14.6-5.9 3.2-12.6 5-19.8 5z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m297.6 142.2 5.5 15.5 14.9-7.1-7.1 14.9 15.5 5.5-15.5 5.5 7.1 14.9-14.9-7.1-5.5 15.5-5.5-15.5-14.9 7.1 7.1-14.9-15.5-5.5 15.5-5.5-7.1-14.9 14.9 7.1z"
  })));
}, WI = function(t) {
  var n = t.title, r = B(t, lH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#10338C",
    d: "M0 0h513.1v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#F6C500",
    d: "M99.9 0h342v342"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M19.9 21.1 40.3 6.2 60.9 21 54 0H26.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M92.3 25.5 84.4 1.3l-7.8 24.2H51.3l20.5 14.8-7.8 24 20.4-14.8L105 64.3l-7.9-24 20.5-14.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m136.3 69.2-7.8-24-7.8 24H95.5l20.4 14.9-7.8 24 20.4-14.8 20.6 14.8-7.8-24 20.4-14.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m179.4 112.3-7.8-24.1-7.8 24.1h-25.3l20.5 14.9-7.8 24 20.4-14.8 20.6 14.8-7.9-24 20.5-15z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m222.5 155.3-7.8-24-7.8 24h-25.4l20.6 15-7.8 24 20.4-14.9 20.4 14.9-7.8-24 20.6-15z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m265.6 198.4-7.8-24-7.8 24h-25.4l20.6 14.9-7.8 24.1 20.4-14.9 20.4 14.9-7.8-24.2 20.5-14.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m308.7 241.5-7.9-24-7.8 24h-25.3l20.5 14.8-7.9 24.2 20.6-14.9 20.4 14.8-7.8-24.1 20.5-14.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m351.7 284.6-7.8-24.2-7.8 24.2h-25.3l20.4 14.8-7.8 24.1 20.5-14.9 20.5 14.9-7.8-24.1 20.4-14.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m387 303.5-7.9 24.1-25.3.1 19.8 14.3h26.6l19.9-14.4h-25.3z"
  })));
}, GI = function(t) {
  var n = t.title, r = B(t, oH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#ffc726",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h171v342H0zm342 0h171v342H342z",
    fill: "#00267f"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m325.74 101.02-31.97 12.4c-.68 1.35-5.79 7.54-8.18 53.06h-17.05v-60.42L256 78.68l-12.54 27v60.8H226.4c-2.39-45.53-7.8-52.48-8.47-53.84l-31.68-11.63c.15.31 15.4 31.34 15.4 78.01v12.54h41.81v71.07h25.08v-71.07h41.81v-12.54c0-24.13 4.17-44.02 7.68-56.46 3.82-13.57 7.7-21.49 7.74-21.57l-.03.03z"
  }));
}, UI = function(t) {
  var n = t.title, r = B(t, aH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#2d6e41",
    d: "M0 85.331h513v342H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#F40B32",
    cx: 218.902,
    cy: 256.5,
    r: 115
  }));
}, jI = function(t) {
  var n = t.title, r = B(t, sH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#fdda25",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ef3340",
    d: "M342 0h171v342H342z"
  }));
}, KI = function(t) {
  var n = t.title, r = B(t, cH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#3d944f",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ef2b2d",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m256 102.6 16.9 52h54.7l-44.2 32.2 16.8 52-44.2-32.1-44.2 32.1 16.8-52-44.2-32.2h54.7z"
  }));
}, YI = function(t) {
  var n = t.title, r = B(t, dH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#00966e",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#d62612",
    d: "M0 228h513v114H0z"
  }));
}, qI = function(t) {
  var n = t.title, r = B(t, uH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m222.8 34.3-85.2 34.2 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.8H0V0h137.6z"
  }));
}, XI = function(t) {
  var n = t.title, r = B(t, fH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M215.9 170.7 0 314.6V26.8zM513 26.8v287.8L297.1 170.7z",
    fill: "#47a644"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M513 26.8 296.1 170.7 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M513 26.8 297.1 170.7 513 314.6V342h-40L256 197.4 39 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 251.6,
    cy: 170.7,
    r: 100.2
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m251.4 103.6 7.4 12.9h14.8l-7.4 12.8 7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8H244zm38.8 66.7 7.4 12.9h14.8L305 196l7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.9l7.4-12.8-7.4-12.8h14.9zm-77.2 0 7.4 12.9h14.9l-7.4 12.8 7.4 12.8h-14.9l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8h14.8z",
    fill: "#D80027",
    stroke: "#47a644",
    strokeWidth: 3
  }));
}, JI = function(t) {
  var n = t.title, r = B(t, hH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#008751",
    d: "M0 85.333h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#fcd116",
    d: "M196.666 85.333H513v171H196.666z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#e8112d",
    d: "M196.666 256H513v171H196.666z"
  }));
}, QI = function(t) {
  var n = t.title, r = B(t, pH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E6BC00",
    d: "M157.31 199.76s-9.04 43.93-19.31 40.39c-10.62-3.54-17.53-18.76-17.53-18.76l-14.52 21.24s38.18 8.48 41.01 5.47c1.22-1.14 8.21-15.1 10.34-26.05v-22.29zm-56.13 60.57s-2.48 20.18-1.06 22.66c1.24 2.3 39.48 11.33 39.48 11.33s-24.96 16.46-29.74 20.54L91.8 284.94l-.71-24.61h10.09zm11.33-165.69s39.65 41.6 40.36 45.5c.71 3.72-4.25 3.19-4.25 3.19s-44.79-37.53-49.92-41.07c-5.31-3.55 13.81-7.62 13.81-7.62z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ADADAD",
    d: "M99.41 104.73s16.99-.71 16.64-11.51c-.35-10.62-11.15-14.87-19.12-12.39-7.97 2.3-23.01 13.45-13.63 35.05 9.38 21.42 23.37 29.39 26.2 47.8 0 0-5.46 9.86-19.12.35-16.9-11.77-6.2-38.24-10.44-44.96-4.25-7.08-40.95-38.92-40.95-38.92s-30.24 39.37-18 74.92c16.95 49.21 51.74 31.98 64.61 36.76 0 0-42.13 61.96-49.57 67.09 0 0 24.08 8.32 47.8-18.76 0 0 5.84 9.74 7.08 20.18h10.27c4.78-26.2 51.51-64.26 49.92-82.32-1.77-21.25-49.21-49.39-51.69-73.29z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E6BC00",
    d: "M359.17 201.27s8.96 42.43 19.23 38.89c10.62-3.54 17.53-18.76 17.53-18.76l14.52 21.24s-37 8.48-39.83 5.47c-1.21-1.14-9.32-13.79-11.52-24.66l.07-22.18zm56.05 59.06s2.48 20.18 1.06 22.66c-1.24 2.3-39.48 11.33-39.48 11.33s24.96 16.46 29.74 20.54l18.06-29.92.71-24.61h-10.09zM403.89 94.64s-39.65 41.6-40.36 45.5c-.71 3.72 4.25 3.19 4.25 3.19s44.79-37.53 49.92-41.07c5.14-3.55-13.81-7.62-13.81-7.62z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#125ECC",
    d: "M157.31 87.06H359.1v145.46c0 16.06-9.69 21.39-21.91 31.85l-45.92 39.41c-18.25 15.62-47.91 15.57-66.07 0l-46.01-39.43c-12.08-10.35-21.88-15.71-21.88-31.82V87.06z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFE600",
    d: "M200.55 147.71c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65-3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zM214.96 274.43c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c.01 7.96-6.45 14.41-14.41 14.41zm43.24 14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c0 7.95-6.45 14.41-14.41 14.41zm43.24-14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D60537",
    d: "M157.31 175.36H359.1v57.65H157.31v-57.65z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#EACE00",
    d: "M142.9 43.82s57.65-14.41 115.31-14.41 115.31 14.41 115.31 14.41l-14.41 57.65s-50.45-14.41-100.89-14.41-100.89 14.41-100.89 14.41L142.9 43.82z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#7A6920",
    d: "M258.2 72.65c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 5c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm-115.3 0c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ADADAD",
    d: "M365.08 178.02c-1.59 18.06 45.14 56.12 49.92 82.32h10.27c1.24-10.44 7.08-20.18 7.08-20.18 23.72 27.09 47.8 18.76 47.8 18.76-7.44-5.13-49.57-67.09-49.57-67.09 12.88-4.78 47.67 12.45 64.61-36.76 12.24-35.55-18-74.92-18-74.92s-36.7 31.84-40.95 38.92c-4.25 6.73 6.46 33.2-10.44 44.96-13.66 9.51-19.12-.35-19.12-.35 2.83-18.41 16.82-26.38 26.2-47.8 9.38-21.6-5.66-32.75-13.63-35.05-7.97-2.48-18.76 1.77-19.12 12.39-.35 10.8 16.64 11.51 16.64 11.51-2.48 23.9-49.92 52.04-51.69 73.29z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 258.2,
    cy: 204.19,
    r: 16.93
  }));
}, eT = function(t) {
  var n = t.title, r = B(t, mH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#c8102e",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#012169",
    d: "M0 .1h256.5v171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0h-22.6L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1v22.6h22.6L96 121.8v48.9h64v-48.9l73.4 48.9H256v-22.6l-46.1-30.7H256v-64h-46.1L256 22.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#c8102e",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#c8102e",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }), /* @__PURE__ */ o.createElement("g", {
    transform: "translate(13 5)"
  }, /* @__PURE__ */ o.createElement("path", {
    fill: "#fff",
    d: "M303.9 94.94v99.69c0 59.81 79.75 99.69 79.75 99.69s79.75-39.88 79.75-99.69V94.94H303.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2F8F22",
    d: "M436.37 254.44H330.93c23.13 25.08 52.72 39.88 52.72 39.88s29.59-14.8 52.72-39.88z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#65B5D2",
    cx: 383.65,
    cy: 214.56,
    r: 39.88
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#c8102e",
    cx: 343.77,
    cy: 194.63,
    r: 19.94
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#c8102e",
    cx: 423.52,
    cy: 194.63,
    r: 19.94
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#c8102e",
    cx: 383.65,
    cy: 154.75,
    r: 19.94
  })));
}, tT = function(t) {
  var n = t.title, r = B(t, vH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m0 193.74 513 127.19V214.26L0 97.08z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M513 234.26v-86.67L0 20.41v86.67"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027",
    stroke: "#231F20",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M306.4 134.01a50.28 50.28 0 0 1 6.07 24.02c0 21.55-13.51 39.94-32.52 47.19v-59.51c5.7-1.19 10-6.37 10-12.59 6.9 0 12.5-5.75 12.5-12.85h-.42c6.9 0 12.91-5.75 12.91-12.85h-34.99V76.58l-14.99-27.71-15 27.71v30.84h-34.99c0 7.1 6.01 12.85 12.91 12.85h-.42c0 7.1 5.6 12.85 12.5 12.85 0 6.22 4.29 11.4 9.99 12.59v61.37c-22.09-5.39-38.48-25.3-38.48-49.05 0-8.7 2.2-16.88 6.07-24.02-10.96 11.21-17.72 26.53-17.72 43.44 0 34.32 27.82 62.15 62.15 62.15s62.15-27.83 62.15-62.15c0-16.91-6.77-32.24-17.72-43.44z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M198.46 226.81s20.69 27.71 66.5 27.71 66.5-27.71 66.5-27.71l13.47 28.37s-21.03 27.71-79.97 27.71-79.97-27.71-79.97-27.71l13.47-28.37zm-69.22-93.63h20.88l24.93 27.26v73.45h-26.28v-68.37zm270.76 0h-20.88l-24.93 27.26v73.45h26.27v-68.37z"
  })));
}, nT = function(t) {
  var n = t.title, r = B(t, gH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#d52b1e",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f9e300",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#007934",
    d: "M0 228h513v114H0z"
  }));
}, rT = function(t) {
  var n = t.title, r = B(t, LH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#012a87",
    d: "M0 342h513V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f9d90f",
    d: "M250.4 0H0v166.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#dc171d",
    d: "m140.4 118.3 12.2 21.2h24.5l-12.3 21.1 12.3 21.2h-24.5L140.4 203l-12.2-21.2h-24.5l12.3-21.2-12.3-21.1h24.5z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    cx: 140.4,
    cy: 160.6,
    r: 57.7
  }));
}, iT = function(t) {
  var n = t.title, r = B(t, wH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#009b3a",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#fedf00",
    d: "m256.5 19.3 204.9 151.4L256.5 322 50.6 170.7z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 80.4
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#002776",
    d: "M215.9 165.7c-13.9 0-27.4 2.1-40.1 6 .6 43.9 36.3 79.3 80.3 79.3 27.2 0 51.3-13.6 65.8-34.3-24.9-31-63.2-51-106-51zm119 20.3c.9-5 1.5-10.1 1.5-15.4 0-44.4-36-80.4-80.4-80.4-33.1 0-61.5 20.1-73.9 48.6 10.9-2.2 22.1-3.4 33.6-3.4 46.8.1 89 19.5 119.2 50.6z"
  }));
}, lT = function(t) {
  var n = t.title, r = B(t, MH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#ffc72c",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0z",
    fill: "#00778b"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M256 171 0 342V0z"
  }));
}, oT = function(t) {
  var n = t.title, r = B(t, xH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF7415",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M513 0H0v342"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 42,
    strokeMiterlimit: 10,
    d: "M128.7 255.5s35 54 67.3 32.4c56.9-37.9-68.9-108.6-2.9-152.6 58.3-38.8 76.6 103.5 137.6 62.8 59-39.3-64.7-111.4-9.2-148.4 33.4-22.2 67.1 32.6 67.1 32.6"
  }));
}, aT = function(t) {
  var n = t.title, r = B(t, bH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 33.333 1100 733.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#ef2b2d",
    d: "M0 0h1100v800H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#fff",
    d: "M300 0h200v800H300z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#fff",
    d: "M0 300h1100v200H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#002868",
    d: "M350 0h100v800H350z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#002868",
    d: "M0 350h1100v100H0z"
  }));
}, sT = function(t) {
  var n = t.title, r = B(t, yH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 238h513v104H0zM0 0h513v104H0z",
    fill: "#6da9d2"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 125.5h513v89.656H0z"
  }));
}, cT = function(t) {
  var n = t.title, r = B(t, CH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#007C30",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#CE1720",
    d: "M0 230h513V0H0"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M100 230V0H0v342h513-413z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M28 159.6 8.6 128.2 28 97.4l19.3 30.8zm44.6 0-19.3-31.4 19.3-30.8L92 128.2zM28 241.2 8.6 209.8 28 179l19.3 30.8zm44.6 0-19.3-31.4L72.6 179 92 209.8z",
    fill: "#CE1720"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m28 73.8-16.1-26L28 22.2l16 25.6zm44.6 0-16-26 16-25.6 16.1 25.6zM28 318l-16.1-26.1L28 266.3l16 25.6zm44.6 0-16-26.1 16-25.6 16.1 25.6z",
    fill: "none",
    stroke: "#CE1720",
    strokeWidth: 7
  }));
}, dT = function(t) {
  var n = t.title, r = B(t, EH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#003e87",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 260.9,
    cy: 170.9,
    r: 118.9
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "none",
    stroke: "#6DA544",
    strokeWidth: 18,
    strokeMiterlimit: 10,
    cx: 261.9,
    cy: 173.1,
    r: 94.5
  }), /* @__PURE__ */ o.createElement("g", {
    stroke: "#000"
  }, /* @__PURE__ */ o.createElement("path", {
    fill: "#003e87",
    d: "m261.9 151.5-50.6 23.4v20c0 11.8 6.1 22.8 16.2 28.9L262 239l34.5-15.2c10-6.2 16.2-17.1 16.2-28.9v-20l-50.8-23.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M211.3 128.1h101.3v46.7H211.3z"
  })), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v35H0zm0 306h513v35H0z",
    fill: "#ce1127"
  }));
}, uT = function(t) {
  var n = t.title, r = B(t, FH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h142v342H0zm371 0h142v342H371zm-64.5 206 50.4-25.2-25.2-12.6V143l-50.4 25.2 25.2-50.4h-25.2L256.1 80l-25.2 37.8h-25.2l25.2 50.4-50.4-25.2v25.2l-25.2 12.6 50.4 25.2-12.6 25.2h50.4V269h25.2v-37.8h50.4z",
    fill: "red"
  }));
}, fT = function(t) {
  var n = t.title, r = B(t, zH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "green",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m422.7 252.4 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.2V301l-11.1-8.9-11.1 8.9v-14.2l-13.8-3.2 11.1-8.8-6.2-12.8 13.9 3.2zm-46.6-136.3 6.2 12.9 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.1v14.3l-11.1-8.9-11.1 8.9.1-14.3-13.9-3.1 11.1-8.8-6.2-12.8L370 129zm37-77.8 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.9-13.9 3.1v14.2L413.1 78 402 86.9l.1-14.2-13.9-3.1 11.1-8.9-6.2-12.8 13.9 3.2zm51.8 58.4 6.2 12.8 13.9-3.2-6.3 12.8 11.2 8.9-13.9 3.1.1 14.2-11.2-8.9-11.1 8.9.1-14.2L440 128l11.2-8.9-6.3-12.8 13.9 3.2zm-28 68.1 4.9 14.8h15.6l-12.6 9.2 4.8 14.9-12.7-9.2-12.6 9.2 4.8-14.9-12.6-9.2h15.6zM306.8 254.7c-49.2 0-89.1-39.9-89.1-89.1s39.9-89.1 89.1-89.1c15.3 0 29.8 3.9 42.4 10.7C329.4 67.9 302.3 56 272.5 56c-60.5 0-109.6 49.1-109.6 109.6S212 275.3 272.5 275.3c29.8 0 56.9-11.9 76.6-31.3-12.6 6.8-27 10.7-42.3 10.7zM140.4 59.5C129.7 41 109.7 28.6 86.8 28.6S44 41 33.3 59.5h107.1zm.2.4-53.8 53.8-53.7-53.8C28 68.9 25 79.3 25 90.5c0 34.2 27.7 61.9 61.9 61.9s61.9-27.7 61.9-61.9c-.1-11.2-3.1-21.6-8.2-30.6z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M71.4 98.2v52.2c4.9 1.3 10.1 1.9 15.5 1.9s10.5-.7 15.5-1.9V98.2h-31z"
  }));
}, hT = function(t) {
  var n = t.title, r = B(t, AH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M513 66.9V0H411.7L0 274.4V342h100.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M513 0v40.1L60.2 342H0v-40.8L451.8 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m93.6 31.2 16.3 50.4H163l-42.9 31.2 16.4 50.5-42.9-31.2-43 31.2L67 112.8 24.1 81.6h53.1z"
  }));
}, pT = function(t) {
  var n = t.title, r = B(t, SH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#d21034",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 171h211.5v85.3H0zm300.5 0H512v85.3H300.5z",
    fill: "#3a9927"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#003082",
    d: "M0 0v85.3h211.5V0h89v85.3H513V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M300.5 85.3H512v85.3H300.5zM0 85.3h211.5v85.3H0z",
    fill: "#FFF"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M300.5 342h-89v-86H0v86h513v-86H300.5zM105.7 8.6l8.6 26.2h27.5L119.5 51l8.6 26.2L105.7 61 83.4 77.2 91.9 51 69.6 34.8h27.6z",
    fill: "#ffce00"
  }));
}, mT = function(t) {
  var n = t.title, r = B(t, kH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#da1a35",
    d: "M0 85.331h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#009543",
    d: "M443.726 85.331 102.4 426.657H0V85.331z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#fbde4a",
    d: "M500.124 85.331 158.798 426.657H11.876L353.202 85.331z"
  }));
}, vT = function(t) {
  var n = t.title, r = B(t, DH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "red",
    d: "M0 85.337h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M356.174 222.609h-66.783v-66.783h-66.782v66.783h-66.783v66.782h66.783v66.783h66.782v-66.783h66.783z"
  }));
}, gT = function(t) {
  var n = t.title, r = B(t, RH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#009e60",
    d: "M342 0h171v342H342z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f77f00",
    d: "M0 0h171v342H0z"
  }));
}, LT = function(t) {
  var n = t.title, r = B(t, _H);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#01237a",
    d: "M0 85.332h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m384 156.705 5.283 16.254h17.089l-13.826 10.045 5.281 16.254L384 189.211l-13.825 10.047 5.28-16.254-13.825-10.045h17.089zm-70.209 29.081 15.228 7.758 12.084-12.083-2.673 16.879 15.227 7.759-16.879 2.673-2.674 16.88-7.76-15.227-16.878 2.673 12.086-12.084zm-29.081 70.209 16.254-5.281.001-17.089 10.044 13.825 16.254-5.282-10.046 13.827 10.046 13.826-16.254-5.28-10.044 13.825v-17.09zm29.081 70.209 7.759-15.229-12.084-12.084 16.881 2.674 7.757-15.227 2.674 16.879 16.879 2.672-15.227 7.759 2.673 16.882-12.084-12.087zM384 355.284l-5.281-16.253h-17.091l13.827-10.045-5.28-16.254L384 322.776l13.827-10.044-5.281 16.254 13.826 10.045h-17.089zm70.209-29.08-15.229-7.758-12.083 12.084 2.673-16.882-15.227-7.756 16.879-2.675 2.675-16.879 7.756 15.227 16.881-2.674-12.086 12.085zm29.081-70.209-16.254 5.281v17.09l-10.045-13.826-16.254 5.281 10.046-13.826-10.046-13.827 16.254 5.282 10.045-13.825v17.089zm-29.081-70.207-7.757 15.226 12.082 12.084-16.881-2.673-7.756 15.227-2.675-16.88-16.879-2.675 15.227-7.757-2.673-16.878 12.084 12.082zM0 186.665v16h46.069L0 233.377v7.539l57.377-38.252H80L0 255.998h112v-69.334H0zm96 69.331H22.628L96 207.083v48.913zm80-117.331 80-53.334H144v69.334h112v-16h-46.069L256 107.951v-7.539l-57.377 38.251H176v.002zm-16-53.332h73.372L160 134.246V85.333zm-16 170.665h112l-80-53.334h22.623L256 240.917v-7.539l-46.069-30.713H256v-16H144v69.333zm16-48.915 73.372 48.913H160v-48.913zM112 85.331H0l80 53.334H57.377L0 100.413v7.539l46.069 30.712H0v16h112V85.331zm-16 48.915L22.628 85.333H96v48.913z",
    fill: "#FFF"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144 85.331h-32v69.334H0v32h112v69.333h32v-69.333h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M80 138.665 0 85.331v15.082l57.377 38.252zm96 0h22.623L256 100.413V85.331zm-118.623 64L0 240.917v15.081l80-53.333zm118.623 0 80 53.333v-15.081l-57.377-38.252z"
  })));
}, wT = function(t) {
  var n = t.title, r = B(t, PH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M196 0h317v171H196z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0037A1",
    d: "M0 0h196v171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M98 24.5 113.1 71H162l-39.6 28.7 15.2 46.5L98 117.5l-39.6 28.7 15.2-46.5L34 71h48.9z"
  }));
}, MT = function(t) {
  var n = t.title, r = B(t, HH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#007a5e",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M342 0h171v342H342zm-86 102.2 17.2 53H329L283.9 188l17.2 53-45.1-32.7-45.1 32.7 17.2-53-45.1-32.8h55.8z",
    fill: "#fcd116"
  }));
}, xT = function(t) {
  var n = t.title, r = B(t, OH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m226.8 239.2-9.7-15.6-17.9 4.4 11.9-14.1-9.7-15.6 17.1 6.9 11.8-14.1-1.3 18.4 17.1 6.9-17.9 4.4zM290.6 82l-10.1 15.4 11.6 14.3-17.7-4.8-10.1 15.5-1-18.4-17.7-4.8 17.2-6.6-1-18.4 11.6 14.3zm-54.4-56.6-2 18.3 16.8 7.6-18 3.8-2 18.3-9.2-16-17.9 3.8 12.3-13.7-9.2-15.9 16.8 7.5zm56.6 136.4-14.9 10.9 5.8 17.5-14.9-10.8-14.9 11 5.6-17.6-14.9-10.7 18.4-.1 5.6-17.6 5.8 17.5zM115 46.3l17.3 53.5h56.2l-45.4 32.9 17.3 53.5-45.4-33-45.5 33 17.4-53.5-45.5-32.9h56.3z",
    fill: "#FFDA44"
  }));
}, bT = function(t) {
  var n = t.title, r = B(t, NH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 256.5h513V342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 171h513v85.5H0z"
  }));
}, yT = function(t) {
  var n = t.title, r = B(t, BH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 285h513v57H0zM0 0h513v57H0z"
  }));
}, CT = function(t) {
  var n = t.title, r = B(t, IH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF9811",
    d: "M0-40.8v422.9-211.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v68.3H0zm0 136.5h513v68.3H0zm0 136.6h513v68.3H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M256 170.7 0 342V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m86.5 111.4 12.7 39.2h41.3l-33.4 24.2 12.8 39.3-33.4-24.2-33.4 24.2 12.8-39.3-33.4-24.2h41.2z"
  }));
}, ET = function(t) {
  var n = t.title, r = B(t, TH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#003893",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#cf2027",
    d: "M0 182.2h513v41.4H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 140.8h513v41.4H0zm0 82.8h513V265H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m150.4 70 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13.1-17.9 13.1 6.8-21.1-17.9-13.1h22.2zm0 209.7 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13h22.2zm-97.6-70.9 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13H46zM90.1 91l6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-18-13h22.3zm-66.3 71H46l6.8-21.1 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13-17.9 13 6.8-21.1zm48.4 148.9 6.8-21.1-18-13h22.3l6.8-21.2 6.9 21.2h22.2l-18 13 6.9 21.1-18-13zM248 208.8l-6.9 21.1h-22.2l18 13-6.9 21.2 18-13.1 18 13.1-6.9-21.2 18-13h-22.2zM210.7 91l-6.8 21.1h-22.2l17.9 13-6.8 21.2 17.9-13.1 18 13.1-6.9-21.2 18-13h-22.2zm66.4 71h-22.2l-6.9-21.1-6.9 21.1h-22.2l18 13.1-6.9 21.1 18-13 18 13-6.9-21.1zm-48.4 148.9-6.9-21.1 18-13h-22.2l-6.9-21.2-6.8 21.2h-22.2l17.9 13-6.8 21.1 17.9-13z",
    fill: "#f7d116",
    stroke: "#000"
  }));
}, FT = function(t) {
  var n = t.title, r = B(t, VH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#002b7f",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f9e814",
    d: "M0 233.5h513v51H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m168.7 86.5 12.9 39.8h41.8l-33.8 24.5 12.9 39.7-33.8-24.5-33.8 24.5 12.9-39.7-33.8-24.5h41.8zm-83.3-54 7.8 23.9h25L97.9 71.1l7.8 23.8-20.3-14.7-20.3 14.7 7.8-23.8-20.3-14.7h25.1z",
    fill: "#FFF"
  }));
}, zT = function(t) {
  var n = t.title, r = B(t, ZH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0021ad",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1c8a42",
    d: "M0 0h513v342"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m77.6 272 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9V317l-10.3-8.3-10.2 8.3v-13.2l-12.8-2.9 10.3-8.1-5.8-11.9 12.9 3zm-37.1-98.9 5.7 11.9 12.8-3-5.7 11.8 10.3 8.2-12.9 2.9.1 13.2-10.3-8.3-10.3 8.3.1-13.2-12.9-2.9 10.4-8.2L22 182l12.8 3zm37.1-80.9 5.7 11.8 12.8-2.9-5.7 11.8 10.3 8.2-12.8 2.9v13.1l-10.3-8.2-10.2 8.2V124l-12.8-2.9 10.3-8.2-5.8-11.8L72 104zm46.1 62.9 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9v13.2l-10.3-8.2-10.2 8.2v-13.2l-12.8-2.9 10.3-8.1-5.7-11.9 12.8 3zm-32.9 54 4.4 13.7h14.5L98 231.3l4.5 13.7-11.7-8.4-11.7 8.4 4.5-13.7-11.7-8.5h14.4z",
    fill: "#FFF"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#ffc639",
    cx: 267.1,
    cy: 170.7,
    r: 74.5
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1c8a42",
    d: "M267.1 220.3h24.8s10.8-19 0-37.2l24.8-24.8-12.4-24.8h-12.4s-6.2 18.6-31 18.6-31-18.6-31-18.6h-12.4l12.4 24.8-12.4 24.8 12.4 12.4s12.4-24.8 37.2-12.4c0 0 10.5 15.5 0 37.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ffc639",
    d: "M464.4 92.2c.6-2.9-.2-17.6-.2-20.7 0-21.3-13.9-39.4-33.2-45.7 5.9 12 9.2 25.4 9.2 39.7 0 4.8-.4 9.5-1.1 14.1-2.9-4.7-6.6-8.9-11.2-12.6-17.1-13.6-40.6-14-57.9-2.5 13.4 2.9 26.3 8.9 37.7 18 9 7.1 16.2 16.8 21.7 26.1 0 0-17.8 10.9-31 15.1s-42.3 7.9-42.3 7.9c72 12 132-36 132-36-6.5-13.4-15.8-4-23.7-3.4z"
  }));
}, AT = function(t) {
  var n = t.title, r = B(t, $H);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#DB7D00",
    d: "M141.7 154.7s.2 67.1 74.7 65.3l4.5 13.9h8.9s-7.4-41.1 60.1-41.5c0 0 0-27.6 27.6-27.6H359s-66-51.8 58.9-118l1.8-13.1s-129.9 71-198.9 57.2c0 0 10.7 42.5-10.8 42.5-10.8 0-9.7-8.1-32.3-8.1-18.7 0-17.3 19.7-26.3 19.5-8.9-.2-18.8-12.3-19.6-10.2-.7 2.1 9.9 20.1 9.9 20.1z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#006651"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M237.2 308.1c6.9-5 13-6.6 22.4-8.3s19.4-4.4 24.6-5.8-17.7 6.6-23.5 8.3c-5.8 1.6-23.5 5.8-23.5 5.8zm37.9-14.7c-1.9-11.9 2.8-24.3 13.5-29.3 2.5 8.6-5.2 23.2-13.5 29.3zm18.2-6.2c-5.8-9.8 4-22.6 11.1-28.8 3.3 6-2.5 23.7-11.1 28.8zm16.9-7.6c-6.2-8.4 1.1-23.2 8.8-29 3.1 8.2.1 23.2-8.8 29zm16.9-10.6c-5.6-8-1.7-20.4 6.3-28.4 5.8 6.6.9 21-6.3 28.4zm13.5-10.7c-4.7-7.5 1.1-25.4 8.6-30.4 3.3 6.6.8 25.4-8.6 30.4zm10.8-2.8c-1.4-10.8 17.4-22.7 25.2-22.4-.9 8.9-8.9 18.6-25.2 22.4zm-10.5 12.2c8.8-9.1 26-9.1 32.1-7.2-1.7 5.3-21.9 16.9-32.1 7.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M328.7 276.8c12.4-3.3 20.5-6.1 27.9 1.7-5.2 6.6-25.4 4.7-27.9-1.7zm-17.7 8c11.9-6.4 26.3 3 28.5 8.6-13.3 5.5-28.7-7.2-28.5-8.6zm-16.3 9.2c10.8-4.1 23.2 1.4 28.2 7.5-5.8 2.7-21 5.7-28.2-7.5zm-14.9 4.7c12.4-1.4 24.4 8 27 13.4-15.9 1.5-22-3.2-27-13.4zm-4 9.4c-6.9-5-13-6.6-22.4-8.3-9.4-1.7-19.4-4.4-24.6-5.8-5.3-1.4 17.7 6.6 23.5 8.3 5.8 1.6 23.5 5.8 23.5 5.8zm-37.9-14.7c1.9-11.9-2.8-24.3-13.5-29.3-2.5 8.6 5.2 23.2 13.5 29.3zm-18.2-6.2c5.8-9.8-4-22.6-11.1-28.8-3.3 6 2.5 23.7 11.1 28.8zm-16.9-7.6c6.2-8.4-1.1-23.2-8.8-29-3.1 8.2-.1 23.2 8.8 29zM185.9 269c5.6-8 1.7-20.4-6.3-28.4-5.8 6.6-.9 21 6.3 28.4zm-13.5-10.7c4.7-7.5-1.1-25.4-8.6-30.4-3.3 6.6-.8 25.4 8.6 30.4zm-10.8-2.8c1.4-10.8-17.4-22.7-25.2-22.4.9 8.9 8.9 18.6 25.2 22.4zm10.5 12.2c-8.8-9.1-26-9.1-32.1-7.2 1.7 5.3 21.9 16.9 32.1 7.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M184.3 276.8c-12.4-3.3-20.5-6.1-27.9 1.7 5.2 6.6 25.4 4.7 27.9-1.7zm17.7 8c-11.9-6.4-26.3 3-28.5 8.6 13.3 5.5 28.7-7.2 28.5-8.6zm16.3 9.2c-10.8-4.1-23.2 1.4-28.2 7.5 5.8 2.7 21 5.7 28.2-7.5zm14.9 4.7c-12.4-1.4-24.4 8-27 13.4 15.9 1.5 22-3.2 27-13.4z"
  })));
}, ST = function(t) {
  var n = t.title, r = B(t, WH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#11457e",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#d7141a",
    d: "M513 171v171H0l256.5-171z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M513 0v171H256.5L0 0z"
  }));
}, kT = function(t) {
  var n = t.title, r = B(t, GH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 228h513v114H0z"
  }));
}, DT = function(t) {
  var n = t.title, r = B(t, UH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#12ad2b",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6ab2e7",
    d: "M513 0v166.7L0 170.8V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 170.7 0 342V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#d7141a",
    d: "m89.8 92.5 17 52.4H162l-44.6 32.5 17 52.4-44.6-32.4-44.6 32.4 17-52.4-44.6-32.5h55.2z"
  }));
}, RT = function(t) {
  var n = t.title, r = B(t, jH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#c60c30",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M190 0h-60v140H0v60h130v142h60V200h323v-60H190z"
  }));
}, _T = function(t) {
  var n = t.title, r = B(t, KH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 110.7v120h513v-120z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 110.7h513v40H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 190.7h513v40H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M196 0h120v342H196z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M196 0h40v342h-40z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M274.7 0h40v342h-40z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#D80027",
    cx: 256,
    cy: 170.7,
    r: 123.1
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m256 58.6 4.6 14.2h15l-12.1 8.9 4.6 14.2-12.1-8.8-12.1 8.8 4.6-14.2-12.1-8.9h15zM190.1 80l12.2 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15l-4.6 14.2-4.7-14.2h-15l12.1-8.8zm-40.7 56h15l4.6-14.2 4.7 14.2h15l-12.2 8.8 4.7 14.3-12.2-8.8-12.1 8.8 4.6-14.3zm0 69.3 12.1-8.8-4.6-14.3L169 191l12.2-8.8-4.7 14.3 12.2 8.8h-15l-4.7 14.3-4.6-14.3zm40.7 56.1 4.6-14.3-12.1-8.8h15l4.7-14.3 4.6 14.3h15l-12.1 8.8 4.6 14.3-12.1-8.9zm65.9 21.4-4.6-14.3h-15l12.1-8.8-4.6-14.3 12.1 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15zm65.9-21.4-12.2-8.9-12.1 8.9 4.6-14.3-12.1-8.8h15l4.6-14.3 4.7 14.3h15l-12.1 8.8zm40.7-56.1h-15l-4.6 14.3-4.7-14.3h-15l12.2-8.8-4.7-14.3L343 191l12.1-8.8-4.6 14.3zm0-69.3-12.1 8.8 4.6 14.3-12.1-8.8-12.2 8.8 4.7-14.3-12.2-8.8h15l4.7-14.2 4.6 14.2zm-40.7-56-4.6 14.3 12.1 8.8h-15l-4.7 14.2-4.6-14.2h-15l12.1-8.8-4.6-14.3 12.1 8.8zM279.3 168.7c-11-21.1-14.5-25.1-14.5-25.1s.4-9.7.4-15.6c0-8.8-7.4-15.8-16.5-15.8-8.6 0-15.7 2.9-16.5 11-4.2.9-8.6 4.1-8.6 10.7 0 4.8 1 7.3 5.2 9.3 2.1-4.6 4.3-4.8 9.3-6.4.8.6 1.7 3 2.6 3.4l.3 1s-13.3 6.6-13.3 30.9c0 29.5 22 45.4 22 45.4l-1.8.3-1.9 7.1h22v-7.2l11 17.5c.3-.3 10.2-47.6.3-66.5z",
    fill: "#496E2D"
  }));
}, PT = function(t) {
  var n = t.title, r = B(t, YH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 215.2h211.5v126.1H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h211.5v126.2H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M300.5 0H512v126.2H300.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M300.5 215.2H512v126.1H300.5z"
  }), /* @__PURE__ */ o.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }, /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M256 130h-49.9v49.4s19.5 6 49.9 6V130z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M206.1 179.4v6c0 27.5 22.3 49.9 49.9 49.9v-49.9c-30.4 0-49.9-6-49.9-6z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M256 235.3c27.5 0 49.9-22.3 49.9-49.9v-6s-19.5 6-49.9 6v49.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M256 130v55.4c30.4 0 49.9-6 49.9-6V130H256z"
  })));
}, HT = function(t) {
  var n = t.title, r = B(t, qH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#41662E",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256.5 0H513v342H256.5z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m341.5 105.3-29.4 40.4-47.5-15.4 29.4 40.4-29.4 40.4 47.5-15.4 29.4 40.4v-50l47.5-15.5-47.5-15.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M309.9 276.7c-58.5 0-106-47.5-106-106s47.5-106 106-106c18.3 0 35.4 4.6 50.4 12.7-23.5-23-55.7-37.2-91.2-37.2-72 0-130.4 58.4-130.4 130.4S197.1 301 269.1 301c35.5 0 67.7-14.2 91.2-37.2-14.9 8.2-32.1 12.9-50.4 12.9z"
  })));
}, OT = function(t) {
  var n = t.title, r = B(t, XH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 170.7h513V256H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 256h513v85.3H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFDA44",
    cx: 256,
    cy: 171,
    r: 60
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#4C1F00",
    d: "M369.2 79.9s-27.2-13.8-33.9-16c-6.7-2.2-49.1-13.2-49.1-7 0 10.3-13.5 12-15.5 12s-2-5.3-14.8-5.3-13.7 4.8-15.8 4.8c-2.2 0-14.5-1-14.5-11.5 0-5.2-42.9 4-49.1 7-6.1 3.1-33.9 16-33.9 16s45.8 2.7 53.9 6.2 43.8 16.5 43.8 16.5l-2.8 13.3h37.8l-3.8-13.3s35.1-12.7 43.8-16.5 53.9-6.2 53.9-6.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#57BA17",
    d: "M217.7 171.7c0 21.1 17.2 38.3 38.3 38.3 21.1 0 38.3-17.2 38.3-38.3v-11.5h-76.5v11.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M256 110.5c-21.1 0-38.3 17.2-38.3 38.3v11.5h76.5v-11.5c.1-21.1-17.1-38.3-38.2-38.3z"
  }));
}, NT = function(t) {
  var n = t.title, r = B(t, JH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#111",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#368FD8",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 228h513v114H0z"
  }));
}, BT = function(t) {
  var n = t.title, r = B(t, QH);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#C09300",
    d: "M220.3 204.4s0-58.4 4.5-64.7c3.1-4.3 16.8 5.2 22.7 4.5 0 0 4.2-7.5 4.5-12 .3-4.6-1.1-7.6-4.9-6.2 0 0-1.2-2.1.5-3.3 1.6-1.2 5.6.1 5.6.1s-.5-1 1.6-.9c2.9.2 7.2 1.4 7.4 5.6.2 3.1.3 7.7.4 8.7.7 6.8 2.7 8.7 2.7 8.7s18.4-9.2 22-5.2c3.3 3.8 4.5 64.7 4.5 64.7l-18.1-16.8 12.1 29.5s-14.4 2.4-28.9 2.4c-14.5 0-31.1-4.2-31.1-4.2l13.8-28.2-19.3 17.3z"
  }));
}, IT = function(t) {
  var n = t.title, r = B(t, eO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#428823",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M256 171 0 342V0zm53.1 0c0-22.9 13.1-42.1 34.6-46.8-3.3-.7-6.7-1.1-10.3-1.1-26.4 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9c3.5 0 7-.4 10.3-1.1-21.5-5.1-34.6-24.2-34.6-46.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m365 129.2 10.3 31.7h33.3l-27 19.6 10.3 31.7-26.9-19.6-27 19.6 10.3-31.7-27-19.6h33.4z"
  })));
}, TT = function(t) {
  var n = t.title, r = B(t, tO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#56AF35",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "m0 342 513-171L0 0v342z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#ffc945"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M134.7 231.5c33.6 0 60.8-27.2 60.8-60.8s-27.2-60.8-60.8-60.8-60.8 27.2-60.8 60.8 27.2 60.8 60.8 60.8zm0 24.3c-47 0-85.2-38.1-85.2-85.2s38.1-85.2 85.2-85.2 85.2 38.1 85.2 85.2-38.2 85.2-85.2 85.2z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 119.5,
    cy: 148.3,
    r: 17.5
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 148.9,
    cy: 158.5,
    r: 17.5
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 134.7,
    cy: 135.2,
    r: 17.5
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 119.5,
    cy: 172.7,
    r: 17.5
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 149.9,
    cy: 182.8,
    r: 17.5
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 122.5,
    cy: 198,
    r: 17.5
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 145.9,
    cy: 205.2,
    r: 17.5
  })));
}, VT = function(t) {
  var n = t.title, r = B(t, nO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h22.5v15H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D03433",
    d: "M0 0h22.5v4H0V0zm0 11h22.5v4H0v-4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FBCA46",
    d: "M0 4h22.5v7H0V4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M7.8 7h1v.5h-1V7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A41517",
    d: "M7.2 8.5c0 .3.3.5.6.5s.6-.2.6-.5L8.5 7H7.1l.1 1.5zM6.6 7c0-.3.2-.5.4-.5h1.5c.3 0 .5.2.5.4V7l-.1 1.5c-.1.6-.5 1-1.1 1-.6 0-1-.4-1.1-1L6.6 7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A41517",
    d: "M6.8 7.5h2V8h-.5l-.5 1-.5-1h-.5v-.5zM5.3 6h1v3.5h-1V6zm4 0h1v3.5h-1V6zm-2.5-.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v.2c0 .2-.1.3-.3.3H7c-.1 0-.2-.1-.2-.2v-.3z"
  }));
}, ZT = function(t) {
  var n = t.title, r = B(t, rO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#20AA46",
    d: "M0 0h22.5v5H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E92F3B",
    d: "M0 10h22.5v5H0v-5z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FADF50",
    d: "M0 5h22.5v5H0V5z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#205CCA",
    cx: 11.3,
    cy: 7.5,
    r: 5.2
  }), /* @__PURE__ */ o.createElement("g", {
    stroke: "#FFDB3D",
    fill: "none"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m11.3 8.8-2.1 1.5.8-2.4-2-1.5h2.5l.8-2.3.8 2.3h2.6l-2.1 1.5.8 2.4-2.1-1.5zm-1-2.4h1.9M9.9 7.8l1.3 1m.8-2.6.7 1.8M10 7.9l.6-1.8M11 9l1.6-1.1",
    strokeWidth: 0.5
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m8.7 3.9 1.1 1.6m4-1.7-1 1.6m-1.5 4.7V12M8.9 8.3 7.1 9m8.4 0-1.8-.7",
    strokeWidth: 0.25
  })));
}, $T = function(t) {
  var n = t.title, r = B(t, iO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 810 540"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#039",
    d: "M0 0h810v540H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FC0",
    d: "m404.951 59.865 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-90 24 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-66 66 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-24 89.999 6.735 20.719h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm24 90.001 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm66 66 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm180-312 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm66 66 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm24 90 6.735 20.718h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm-24 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm-156 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm90-24.001 6.735 20.719h21.894l-17.633 12.812 6.639 20.74-17.635-12.812-17.633 12.812 6.735-20.73-17.633-12.811h21.797z"
  }));
}, WT = function(t) {
  var n = t.title, r = B(t, lO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M513 129.3V212H203.7v130H121V212H0v-82.7h121V0h82.7v129.3z"
  }));
}, GT = function(t) {
  var n = t.title, r = B(t, oO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#62B5E5",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#F3F3F3",
    d: "M307.1 127.1v92c0 61.6 80.5 80.5 80.5 80.5s80.4-19 80.4-80.6v-92l-80.5-23-80.4 23.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M468 132.8V98.3H307.1v34.5h69v69h-69v23h69V296c6.9 2.5 11.5 3.5 11.5 3.5s4.6-1.1 11.5-3.5v-71.2h69v-23h-69v-69H468z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h256.5v170.6H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m155.9 115 100.6 55.6v-15.8L184.6 115h-28.7zm-55.7-59.3L0 0v15.8l71.8 39.9h28.4z"
  })), /* @__PURE__ */ o.createElement("path", {
    d: "m196.9 115 59.6 32.9V115h-59.6zm-41 0 100.6 55.6v-15.8L184.6 115h-28.7zm73.4 55.6-73.5-40.9v40.9h73.5zM45.2 115 0 140.1V115h45.2zm55 7.1v48.6H12.8l87.4-48.6zM59.1 55.7 0 22.8v32.8s59.1 0 59.1.1zm41.1 0L0 0v15.8l71.8 39.9h28.4zM26.7 0l73.5 40.8V0H26.7zm184.2 55.7 45.6-25.1v25.1h-45.6zm-55-7.2V0h87.4l-87.4 48.5z",
    fill: "#0052B4"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144.3-.2h-32.1v69.5H0v32.1h112.2v69.5h32.1v-69.5h112.2V69.3H144.3V-.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m155.9 115 100.6 55.6v-15.8L184.6 115h-28.7zm-84.1 0L0 154.9v15.8L100.2 115H71.8zm28.4-59.3L0 0v15.8l71.8 39.9h28.4zm83.9 0 72.4-39.9V0L155.9 55.7h28.2z"
  })));
}, UT = function(t) {
  var n = t.title, r = B(t, aO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1F8BDE",
    d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3zm79.6 86.3c7.9-4.5 15.9-10 23.2-16.7 20.5-18.5 32.6-41.4 32.6-69.7v-90c0-.3-120.4-.3-120.4-.3v90.3c0 28.3 12.1 51.2 32.6 69.7 8.3 7.5 17.6 13.9 27.6 19 1.4-.6 2.8-1.4 4.4-2.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#187536",
    d: "M347.1 193.4c-2.6-7.9 1.7-14.3 10.1-14.3h60.5c8.2 0 12.8 6.3 10.1 14.3l-5.5 16.5c-2.6 7.9-8.9 9.2-15.8 4 0 0 2.6-4.8-19.1-4.8-21.7 0-19.1 4.8-19.1 4.8-6.1 5.7-13.1 4-15.8-4 .1.1-5.4-16.5-5.4-16.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M357.4 179.1c8.1 1.6 17.8-15 30.1-15 13.1 0 21.8 17.1 30.1 15 7.4-1.8 15-22.2 15-30.1 0-16.6-20.2-30.1-45.1-30.1-24.9 0-45.1 13.5-45.1 30.1-.1 8.5 6.6 28.5 15 30.1zm-1.4 91.6c6.2.4 12.5-1.8 17.2-6.5l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c4.7 4.7 11 6.9 17.1 6.5 5.3-.3 32.5-33.5 25.7-32.6-4.6.6-9.1 2.8-12.7 6.3l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-3.5-3.5-7.8-5.6-12.3-6.3-6.7-1.1 20.1 32.2 25.3 32.5zM322.1 210c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0 0 0 5.5-14.8 2.5-15.9-7.9-2.9-17.2-1.2-23.5 5.2l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-6.2-6.2-15.1-8-22.8-5.5-3.1 1.1 1.9 16.1 1.9 16.1z"
  }));
}, jT = function(t) {
  var n = t.title, r = B(t, sO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m256 37.9 10.1 31.2H299l-26.6 19.3 10.2 31.2-26.6-19.3-26.6 19.3 10.2-31.2L213 69.1h32.9zM123.2 170.7l31.2-10.2v-32.8l19.3 26.6 31.2-10.2-19.3 26.6 19.3 26.5-31.2-10.1-19.3 26.5v-32.8zM256 303.5l-10.1-31.2H213l26.6-19.3-10.2-31.3L256 241l26.6-19.3-10.2 31.3 26.6 19.3h-32.9zm132.8-132.8-31.2 10.1v32.8l-19.3-26.5-31.2 10.1 19.3-26.5-19.3-26.6 31.2 10.2 19.3-26.6v32.8z",
    fill: "#FFF"
  }));
}, KT = function(t) {
  var n = t.title, r = B(t, cO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0F61A5",
    d: "M513 214.5H206.2V342h-87.8V214.5H0v-87.7h118.4V0h87.8v126.8H513V192z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E50E3D",
    d: "M513 149.3V192H183.7v150H141V192H0v-42.7h141V0h42.7v149.3z"
  }));
}, YT = function(t) {
  var n = t.title, r = B(t, dO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00318A",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, qT = function(t) {
  var n = t.title, r = B(t, uO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 228h513v114H0z"
  }));
}, XT = function(t) {
  var n = t.title, r = B(t, fO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v341.3H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M311.7 230 513 341.3v-31.5L369.3 230h-57.6zM200.3 111.3 0 0v31.5l143.7 79.8h56.6z"
  })), /* @__PURE__ */ o.createElement("path", {
    d: "M393.8 230 513 295.7V230H393.8zm-82.1 0L513 341.3v-31.5L369.3 230h-57.6zm146.9 111.3-147-81.7v81.7h147zM90.3 230 0 280.2V230h90.3zm110 14.2v97.2H25.5l174.8-97.2zm-82.1-132.9L0 45.6v65.7h118.2zm82.1 0L0 0v31.5l143.7 79.8h56.6zM53.4 0l147 81.7V0h-147zm368.3 111.3L513 61.1v50.2h-91.3zm-110-14.2V0h174.9L311.7 97.1z",
    fill: "#0052B4"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M288 0h-64v138.7H0v64h224v138.7h64V202.7h224v-64H288V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M311.7 230 513 341.3v-31.5L369.3 230h-57.6zm-168 0L0 309.9v31.5L200.3 230h-56.6zm56.6-118.7L0 0v31.5l143.7 79.8h56.6zm168 0L513 31.5V0L311.7 111.3h56.6z"
  })));
}, JT = function(t) {
  var n = t.title, r = B(t, hO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#c60a0a",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#3E8446",
    d: "m256.5 170.7-212 126.1V44.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m256.5 170.7 211 126.1h-423zm211-126.2-211 126.2-212-126.2z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#3E8446",
    d: "M467.5 44.5v252.3l-211-126.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m256.5 10.4 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm-85.4 293.8 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#c60a0a",
    cx: 244.5,
    cy: 170.7,
    r: 76.2
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m244.5 110.1 13.6 41.8h44l-35.6 25.8 13.6 41.8-35.6-25.8-35.5 25.8 13.6-41.8-35.6-25.8h44zm-136.8 57.7c4.4 6.9 2.3 16.1-4.6 20.5s-16.1 2.3-20.5-4.6c-7.9-12.5-3.3-33-3.3-33s20.4 4.6 28.4 17.1z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#A2001D",
    cx: 99.1,
    cy: 182.1,
    r: 7.4
  }));
}, QT = function(t) {
  var n = t.title, r = B(t, pO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M.8 0h21v15H.8V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#eb000e",
    d: "M9.8 6H0v3h9.8v6h3V9h9.8V6h-9.8V0h-3v6z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#eb000e",
    d: "m17.3 2.7-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm-12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm0 9-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2z"
  }));
}, eV = function(t) {
  var n = t.title, r = B(t, mO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FDEB01",
    d: "m0 0 90 60H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#58A846",
    d: "M90 0v60L0 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ED3D24",
    d: "m50.7 33.3 9.3-6.7H48.5L45 15.7l-3.5 10.9H30l9.3 6.7-3.6 11 9.3-6.7 9.3 6.7z"
  }));
}, tV = function(t) {
  var n = t.title, r = B(t, vO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M308 0H204v118.7H0v104h204V342h104V222.7h205v-104H308z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m368.6 188 26 17.3V136l-26 17.3h-95.3V58.1l17.3-26h-69.2l17.3 26v95.2h-95.3l-26-17.3v69.3l26-17.3h95.3v95.2l-17.3 26h69.2l-17.3-26V188z"
  }));
}, nV = function(t) {
  var n = t.title, r = B(t, gO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m255.9 113.8 14.1 43.4 40.4 3.2-37 26.9 19.5 40.3-37-26.9-37 26.9 14.1-43.5-36.9-26.9h45.7z"
  }));
}, rV = function(t) {
  var n = t.title, r = B(t, LO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 230h513v112H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M363.1 131.8V99.1H374V77.3h-21.9v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7h-21.8V55.5h10.9V33.7h-21.8v10.9h-10.9V33.7H254v10.9h-10.9V33.7h-21.8v21.8h10.9v76.3h-21.8V99.1h10.9V77.3h-21.8v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7H145V219h239.9v-87.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "m264.9 235.5-24.2 18.2 19.1 14.3v31.3h-23.2v9h23v7.9h-23v9.3H270V268l19.1-14.3-24.2-18.2zm0 25.3-10.1-7.1 10.1-7.1 10.1 7.1-10.1 7.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M239.6 209.7v-27.9s.1-22.3 25-22.3c24.8 0 25.7 22 25.7 22v28.2h-50.7zm-69.1 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M169.1 209.7v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm151.8 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm8.4-77.7v-15.7s.1-12.1 11.3-12.1c11.3 0 11.7 11.9 11.7 11.9V132h-23zm-78.8 0v-23.7s.1-18.3 14.3-18.3c14.2 0 14.7 18 14.7 18v24h-29zm-73 0v-15.7s.1-12.1 11.3-12.1 11.7 11.9 11.7 11.9V132h-23z"
  }));
}, iV = function(t) {
  var n = t.title, r = B(t, wO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M513 0v171H0V0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 185.8,
    cy: 171.2,
    r: 117.8
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M68 171c0-65.1 52.8-117.8 117.8-117.8 65.1 0 117.8 52.8 117.8 117.8"
  }));
}, lV = function(t) {
  var n = t.title, r = B(t, MO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#cf0d19",
    d: "M0 0h513v100H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 121h513v100H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1a7e25",
    d: "M0 242h513v100H0z"
  }));
}, oV = function(t) {
  var n = t.title, r = B(t, xO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M342 0h171v342H342z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h171v342H0z"
  }));
}, aV = function(t) {
  var n = t.title, r = B(t, bO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00318A",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, sV = function(t) {
  var n = t.title, r = B(t, yO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v113.8H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 227.6h513V342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0070C8",
    d: "M126 171 0 342V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M233.8 139.4v40.4c0 35.6 35.6 35.6 35.6 35.6s35.6 0 35.6-35.6v-40.4h-71.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#786145",
    d: "M264.5 179.8h9.8l4 25.8h-17.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M287.2 162c0-9.8-8-14.8-17.8-14.8s-17.8 5-17.8 14.8c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9h35.6c4.9 0 8.9-4 8.9-8.9s-4-8.9-8.9-8.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m230.7 120 1.9 3.3h3.8l-1.9 3.3 1.9 3.2h-3.8l-1.9 3.3-1.9-3.3H225l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.8 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H279l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm16 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H295l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm15 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2H310l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8z",
    fill: "#FFDA00",
    stroke: "#000",
    strokeMiterlimit: 10
  }));
}, cV = function(t) {
  var n = t.title, r = B(t, CO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#0d5eaf"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h190v190H0z"
  })), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M0 76h190v38H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M76 0h38v190H76z"
  })));
}, dV = function(t) {
  var n = t.title, r = B(t, EO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#FFF",
    cx: 443.4,
    cy: 233.6,
    rx: 29,
    ry: 43.5
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#FFCE00",
    cx: 406.9,
    cy: 317.7,
    rx: 22,
    ry: 9.3
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#FFCE00",
    cx: 364,
    cy: 317.7,
    rx: 22,
    ry: 9.3
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#39B200",
    d: "m342 190.1 43.4 86.9 43.5-86.9z"
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#9B9B9B",
    cx: 327.5,
    cy: 233.6,
    rx: 29,
    ry: 43.5
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#757575",
    d: "m371 175.6-14.5 14.5h57.9l-14.5-14.5 14.5-43.5s-13-29-29-29-29 29-29 29l14.6 43.5z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#C6B56F",
    cx: 385.4,
    cy: 67,
    r: 29
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#A54A00",
    cx: 386,
    cy: 88.7,
    r: 29
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 443.4,
    cy: 117.7,
    r: 29
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#0049FF",
    cx: 342.2,
    cy: 146.7,
    r: 29
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#0041F9",
    cx: 429.8,
    cy: 146.7,
    r: 29
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#F7D71E",
    cx: 386,
    cy: 233.6,
    r: 29
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#CEC851",
    cx: 457.9,
    cy: 190.1,
    r: 29
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 385.4,
    cy: 289.5,
    r: 29
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#7C0B29",
    d: "m371 135.7 14.5-3.5 14.5 3.5c0 7.5-14.5 11-14.5 11s-14.5-3.5-14.5-11z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 327.5,
    cy: 117.4,
    r: 29
  }));
}, uV = function(t) {
  var n = t.title, r = B(t, FO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h171v342H0zm342 0h171v342H342z",
    fill: "#338AF3"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#DCC26D",
    cx: 256,
    cy: 155.8,
    r: 25.5
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#628A40",
    d: "M194.2 155.9c0 22.1 11.8 42.5 30.8 53.5 5.9 3.4 13.5 1.4 16.9-4.5 3.4-5.9 1.4-13.5-4.5-16.9-11.5-6.6-18.5-18.9-18.5-32.1 0-6.8-5.5-12.4-12.4-12.4s-12.3 5.5-12.3 12.4zm95.1 52.1c17.8-11.4 28.6-31 28.5-52.1 0-6.8-5.5-12.4-12.4-12.4-6.8 0-12.4 5.5-12.4 12.4 0 12.7-6.5 24.5-17.1 31.3-5.8 3.6-7.7 11.2-4.1 17 3.6 5.8 11.2 7.7 17 4.1.2-.1.3-.2.5-.3z"
  }));
}, fV = function(t) {
  var n = t.title, r = B(t, zO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M11.1 11.1h489.7v319.1H11.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#7DBEF1",
    d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1C8AE6",
    d: "M179.8 180.7h152.6l-29.3 64.9h-95.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF042",
    d: "M192.3 205.9s40.5 38.2 51 38.2c12.4 0 12.6-18.4 25.5-25.5 20.2-11.1 51-12.7 51-12.7L297 248.7l-41 36.6-46.8-39.7-16.9-39.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#259C7B",
    d: "m256 157.5-22.5 15.6 7.9-26.2-21.8-16.5 27.4-.5 9-25.9 9 25.9 27.4.5-21.8 16.6 7.9 26.2-22.5-15.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#8E5715",
    d: "M249.7 144.6c-.9 9.2-1.5 18.4-1.7 27.6-.3 11.9.3 20.7 2 26 2.2 6.6 7.2 12.9 14.2 18.9 5.3 4.6 10.6 8.1 14.2 10.1 3.1 1.7 7 .6 8.7-2.4 1.7-3.1.6-7-2.4-8.7-4.3-2.5-8.4-5.4-12.2-8.7-5.4-4.6-9.1-9.2-10.4-13.3-1.1-3.4-1.6-11.3-1.4-21.7.2-8.9.8-17.8 1.7-26.6.4-3.5-2.2-6.6-5.7-7-3.6-.3-6.7 2.3-7 5.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m217.8 170.7 25.5 38.2h-25.5v-38.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "none",
    stroke: "#D80027",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
  }));
}, hV = function(t) {
  var n = t.title, r = B(t, AO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h512v171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h182v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m98.3 109.8 15.1 46.5h48.9L122.8 185l15.1 46.5-39.6-28.7-39.5 28.7L73.9 185l-39.6-28.7h48.9z"
  }));
}, pV = function(t) {
  var n = t.title, r = B(t, SO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#009E49",
    d: "M0 0h900v600H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m0 0 947 300L0 600V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFD00D",
    d: "M0 26.1 870 300 0 573.9V26.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2D2D2D",
    d: "m0 0 450 300L0 600V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D3132F",
    d: "m0 35 397.5 265L0 565V35z"
  }));
}, mV = function(t) {
  var n = t.title, r = B(t, kO);
  return /* @__PURE__ */ o.createElement("svg", N({
    viewBox: "0 0.5 21 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h21v15H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ee1c25",
    d: "M0 0h21v15H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M12 7.19c-.798-.5-1 .409-1 0 0-.828.895-1.5 2-1.5s2 .672 2 1.5c-.949 0-1.044.5-1.5.5-.56 0-.702 0-1.5-.5zM13.25 7a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5zm-1.81 1.962c.228-.913-.698-.824-.31-.95.788-.257 1.703.387 2.045 1.438.341 1.05-.021 2.11-.809 2.366-.293-.903-.798-.838-.939-1.272-.173-.533-.217-.668.012-1.582zm.566 1.13a.25.25 0 1 0 .476-.154.25.25 0 0 0-.476.154zM9.58 8.977c.94-.065.57-.919.81-.588.486.67.157 1.74-.737 2.389-.894.65-2.013.632-2.5-.038.768-.558.55-1.018.92-1.286.453-.33.568-.413 1.507-.477zm-.899.888a.25.25 0 1 0 .294.405.25.25 0 0 0-.294-.405zm.312-2.652c.351.874 1.049.258.809.588-.487.67-1.606.687-2.5.038-.894-.65-1.223-1.719-.736-2.39.767.559 1.138.21 1.507.478.453.33.568.413.92 1.286zm-1.124-.58a.25.25 0 1 0-.293.404.25.25 0 0 0 .293-.404zm2.619-.524c-.722.605.08 1.078-.309.951-.788-.256-1.15-1.315-.809-2.365.342-1.05 1.257-1.695 2.045-1.439-.293.903.153 1.147.012 1.581-.173.533-.217.668-.939 1.272zm.205-1.247a.25.25 0 1 0-.475-.155.25.25 0 0 0 .475.155z",
    fill: "#FFF"
  })));
}, vV = function(t) {
  var n = t.title, r = B(t, DO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M223.4 170.7c.3-.3.5-.6.8-.9-.3.3-.5.6-.8.9zm-34.2 41.9 11 22.9 24.7-5.7-11.1 22.8 19.9 15.8L209 274v25.4l-19.8-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.9-2.6 9.5-7.5-5.3-10.9 11.9 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6v-12.1l-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9 11.9 2.7zm42.4 49.7 5.3 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.5-7.6-9.4 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-30.3 57.9 4.1 12.7h13.3l-10.8 7.8 4.1 12.6-10.7-7.8-10.8 7.8 4.1-12.6-10.7-7.8h13.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z",
    fill: "#D80027"
  }));
}, gV = function(t) {
  var n = t.title, r = B(t, RO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0zm203.5-110.1 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zM256 147.6l6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm-52.5 29.7 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1z",
    fill: "#338AF3"
  }));
}, LV = function(t) {
  var n = t.title, r = B(t, _O);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M309.3 113.2v-44l17.5-14.4 17.7 14.4v44zm-105.6 0v-44l-17.3-14.4-17.9 14.4v44zm35.2 0v-44l17.6-14.4 17.6 14.4v44z",
    fill: "#338AF3"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M309.3 113.2h-35.2v-44l17.5-14.4 17.7 14.4zm-70.4 0h-35.2v-44l17.5-14.4 17.7 14.4z",
    fill: "#0052B4"
  }), /* @__PURE__ */ o.createElement("path", {
    stroke: "#D80027",
    fill: "#FFF",
    d: "M168.5 113.2v101.9c0 24.3 14.4 46.2 35.4 59.4 21.3 13.4 42.1 14.7 52.6 14.7s31.4-1.7 52.6-14.8c21-13 35.4-35.1 35.4-59.3V113.2h-176z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M168.5 113.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm35.2 35.2h35.2V254h-35.2zm35.2-35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-35.2 35.2h35.2V254h-35.2zm35.2 55.5c8.6-5.4 16.2-12.3 22-20.3h-22v20.3zM181.7 254c5.8 8 13.3 14.9 22 20.4V254h-22zm57.2 0v33.7c7.2 1.2 13.3 1.5 17.6 1.5 4.3 0 10.4-.3 17.6-1.6V254h-35.2z",
    fill: "#D80027"
  }));
}, wV = function(t) {
  var n = t.title, r = B(t, PO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M0 0h513v172H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 172h513v172H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m381.4 251.5-110.7-13.8-110.8 13.8V85.4h221.5z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#0052B4",
    cx: 270.7,
    cy: 182.3,
    r: 55.4
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#A2001D",
    cx: 270.7,
    cy: 182.3,
    r: 27.7
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M229.1 113.1h83.1l-41.5 41.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M256.8 140.8h27.7v83h-27.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M314.9 215.5h-88.5l-66.5 36h221.5z"
  }));
}, MV = function(t) {
  var n = t.title, r = B(t, HO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 228h513v114H0z"
  }));
}, xV = function(t) {
  var n = t.title, r = B(t, OO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 200"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#fc0",
    d: "M0 0h300v200H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0768a9",
    d: "M0 0h200v200H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v200H0z"
  }));
}, bV = function(t) {
  var n = t.title, r = B(t, NO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E00",
    d: "M0 0h513v171H0z"
  }));
}, yV = function(t) {
  var n = t.title, r = B(t, BO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF9811",
    d: "M342 0h171v342H342z"
  }));
}, CV = function(t) {
  var n = t.title, r = B(t, IO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M340.6 122.4h-56.1l-28-48.6-28 48.6h-56.1l28 48.6-28 48.6h56.1l28 48.6 28-48.6h56.1l-28-48.6 28-48.6zM293.2 171 276 204.2h-38.9L219.8 171l17.2-33.2h38.9l17.3 33.2zm-36.7-71.8 11.9 23.3h-23.9l12-23.3zm-58.3 38.6h23.9l-10.8 21-13.1-21zm0 66.4 13-22.1 11.9 22.1h-24.9zm58.3 37.5-11.9-22.1h23.9l-12 22.1zm59.4-37.5h-25l11.9-22.1 13.1 22.1zm-26.1-66.4h26.1l-13 22.1-13.1-22.1zM0 21.3h512V64H0zm0 256h512V320H0z",
    fill: "#2E52B2"
  }));
}, EV = function(t) {
  var n = t.title, r = B(t, TO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#E52D42",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M393.3 68.2h-45.8l-33.8 80.2-34.4-22.9s-24.7-59.1-34.4-68.2c-9.7-9.7-18.7-.6-48.9 7.8-29.6 8.4-30.8 18.7-42.2 18.7-4.8 0-19.9-17.5-27.7-22.3-12.1-7.8-16.9-4.2-13.9 7.2 1.2 4.8 10.9 10.9 16.9 19.9 7.8 11.5 12.7 25.9 12.7 25.9s10.9-10.3 16.9-12.1c9-2.4 19.3 1.8 31.4 0 15.1-2.4 31.4-10.9 31.4-10.9l4.2 43.4s-54.3 50.7-49.5 70.6 56.1 44.6 68.2 62.7c12.1 17.5-7.2 24.1-7.2 32.6s-1.8 19.9 7.2 16.3c9-3.6 10.3-18.1 18.7-31.4 6-9 10.3-13.9 11.5-17.5 1.8-9-23.5-32-37.4-48.9-6.6-7.8-19.9-18.7-19.9-18.7l39.2-29.6s67.6 27.7 82.6 18.7c15.1-9 19.3-98.3 19.3-98.3l47-11.5-12.1-11.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#F8DD4E",
    d: "M279.3 262.4c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.8-182.8c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm0 91.1c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6 0 11.5 4.8 11.5 11.5-.6 6.7-5.5 11.5-11.5 11.5zm-136.9 45.8c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.2-136.9c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-4.8 11.5-11.5 11.5zm22.9 91.1c-6 0-11.5-10.3-11.5-22.9s4.8-22.9 11.5-22.9c6 0 11.5 10.3 11.5 22.9s-4.8 22.9-11.5 22.9zm-114-45.2c-6 0-11.5-4.8-11.5-11.5 0-6.6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5 0 6.6-4.8 11.5-11.5 11.5z"
  }));
}, FV = function(t) {
  var n = t.title, r = B(t, VO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#F93",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#fff",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#138808",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 256.5,
    cy: 171,
    r: 34.2,
    stroke: "navy",
    strokeWidth: 4,
    fill: "none"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 256.5,
    cy: 171,
    r: 3.42,
    fill: "navy"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m265.3 138.159-17.6 65.682m17.6-65.682-17.6 65.682m25.8-62.286-34 58.89m41.042-53.487-48.084 48.084M285.945 154l-58.89 34m62.286-25.8-65.682 17.6M290.5 171h-68m66.841 8.8-65.682-17.6m62.286 25.8-58.89-34m53.487 41.042-48.084-48.084m41.042 53.487-34-58.89m25.8 62.286-17.6-65.682M256.5 205v-68m-8.8 66.841 17.6-65.682m-25.8 62.286 34-58.89m-41.042 53.487 48.084-48.084M227.055 188l58.89-34m-62.286 25.8 65.682-17.6M222.5 171h68m-66.841-8.8 65.682 17.6M227.055 154l58.89 34m-53.487-41.042 48.084 48.084M239.5 141.555l34 58.89m-25.8-62.286 17.6 65.682",
    stroke: "navy",
    strokeWidth: 2
  }));
}, zV = function(t) {
  var n = t.title, r = B(t, ZO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0-.3h513V342H0V-.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M462.9 198.1c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zM0 31.7l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 1-20 6-30.1 12-7 4-16 9-20 9s-14-5-21-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-11-30.1-12v22zm462.9 55.2c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 3.9-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 1 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-8 19-9v-23zm-50.1 133.3c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 0 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-9 19-9v-23z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0-.3h256v171H0V-.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M389.8 119.9H408v78.8h-18.3l.1-78.8zm0 117.8H408v75.1h-18.3l.1-75.1z",
    fill: "#A2001D"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144-.3h-32v70H0v32h112v69h32v-69h112v-32H144v-70z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54zM0 170.7v-15l57-38h23l-80 53zm256 0v-15l-57-38h-23l80 53z"
  })), /* @__PURE__ */ o.createElement("g", {
    fill: "#2E52B2"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73zM0 147.7v-30h46l-46 30zm96 23v-49l-73 49h73zm160-23v-30h-46l46 30zm-96 23v-49l73 49h-73z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#5DA51E",
    stroke: "#45602C",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M462.8 91.5h-29.1l25.7-25.7c4.5-4.4 4.5-11.4 0-15.8l-3.4-3.4c-4.4-4.4-11.4-4.4-15.8 0l-25.9 25.9V37.4c0-6.2-5.1-11.3-11.3-11.3h-4.7c-6.2 0-11.3 5.1-11.3 11.3v31.7l-23.5-23.8c-4.7-4.7-12.2-4.7-16.9 0l-3.6 3.6c-4.7 4.7-4.7 12.4 0 17.2l25 25.4h-30.6c-6 0-10.9 4.9-10.9 10.9v4.6c0 6 4.9 10.9 10.9 10.9H369l-20.7 20.7c-4.4 4.4-4.4 11.4 0 15.8l3.4 3.4c4.4 4.4 11.4 4.4 15.8 0l19.6-19.6V167c0 6.1 5.1 11.1 11.3 11.3h4.7c6.2 0 11.3-5.1 11.3-11.3v-28.3l22.2 22.6c4.7 4.7 12.4 4.7 17.1 0l3.6-3.6c4.7-4.7 4.7-12.4 0-17.2L435.2 118h27.6c5.9 0 10.7-4.9 10.9-10.9v-4.6c0-6.1-4.9-11-10.9-11z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E2DD24",
    stroke: "#525625",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M439.2 249.1h-79.8s-.9-13.4-6-21.8c-6.2-10.4-13.9-28.1-1.4-36.7 15.9-10.9 33.7.8 48.2.8 11.8.1 26.9-14 45-.8 12.2 8.9 3.9 28.2-1.3 36.7-7 11.5-4.7 21.8-4.7 21.8z"
  }));
}, AV = function(t) {
  var n = t.title, r = B(t, $O);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#CE1126",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M219.2 160.7h-29.3c1.5-5.7 6.6-9.9 12.8-9.9v-19.9c-18.3 0-33.1 14.9-33.1 33.1v16.5h49.6c1.8 0 3.3 1.5 3.3 3.3v6.6h-66.2v19.9h86.1v-26.5c0-12.7-10.4-23.1-23.2-23.1zm49.6 29.8v-59.6H249v79.5h33.1v-19.9zm66.2 0v-59.6h-19.8v59.6h-6.6v-19.8h-19.9v39.7h59.6v-19.9z",
    fill: "#547C31"
  }));
}, SV = function(t) {
  var n = t.title, r = B(t, WO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 227.9h513v114H0zm278.8-93.1c.1 2 8.7 26.2 4.4 39.4-6.6 20.3-15.8 21.8-19.8 24.5V134l-6.9-4.2-6.9 4.2v64.7c-4-2.7-12.4-2.4-19.8-24.5-4.3-12.7 5.7-37.3 5.8-39.2 0 0-9.5 8.1-15.8 24-5.9 14.8 1.9 49.6 29.5 54.8 2.3.4 4.7 5.6 7.2 5.6 2.1 0 4.1-5.2 6-5.5 28.4-4.6 35-41.7 29.9-55.6-5.4-14.6-13.6-23.5-13.6-23.5z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M44.6 98.9h22.3v24.4H44.6zM0 98.9h22.3v24.4H0zm89.2 0h22.3v24.4H89.2zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4H223zm44.7 0H290v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0H513v24.4h-22.3zm-446.1 118h22.3v25.5H44.6zm-44.6 0h22.3v25.5H0zm89.2 0h22.3v25.5H89.2zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5H223zm44.7 0H290v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0H513v25.5h-22.3z",
    fill: "#FFF",
    opacity: 0.5
  }));
}, kV = function(t) {
  var n = t.title, r = B(t, GO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M513 210.6H202.2v130.7h-79.8V210.6H0v-79.8h122.4V0h79.8v130.8H513v18.5l-1 42.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M513 149.3V192H183.7v149.3H141V192H0v-42.7h141V0h42.7v149.3z"
  }));
}, DV = function(t) {
  var n = t.title, r = B(t, UO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#F4F5F0",
    d: "M342 0H0v341.3h512V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#008C45",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#CD212A",
    d: "M342 0h171v342H342z"
  }));
}, RV = function(t) {
  var n = t.title, r = B(t, jO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M301.8 171 513 30.2V0h-45.3L256.5 140.8 45.3 0H0v30.2L211.2 171 0 311.8V342h45.3l211.2-140.8L467.7 342H513v-30.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m233.7 44.6 22.3 5.6 22.3-5.6 4-20.9-14.9 6.5L256 14.8l-11.4 15.4-14.9-6.5z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M233.7 44.6s-4 12.9-4 29.9c0 27.9 26.3 41.3 26.3 41.3s26.3-15.5 26.3-41.3c0-15.4-4-29.9-4-29.9s-8.1-5-22.3-5-22.3 5-22.3 5z"
  }));
}, _V = function(t) {
  var n = t.title, r = B(t, KO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M215.9 171 0 314.6V26.8zM513 26.8v287.8L296.1 171z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }));
}, PV = function(t) {
  var n = t.title, r = B(t, YO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M256.5 170.7 0 341.3V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m77.9 139.5 7.9 16.4 17.8-4.1-8 16.5 14.3 11.3-17.8 4 .1 18.3-14.3-11.5-14.2 11.5v-18.3l-17.8-4 14.3-11.3-7.9-16.5 17.7 4.1z"
  }));
}, HV = function(t) {
  var n = t.title, r = B(t, qO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#D80027",
    cx: 256.5,
    cy: 171,
    r: 96
  }));
}, OV = function(t) {
  var n = t.title, r = B(t, XO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h512v90.579H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 251h513v91H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m323.3 54.5-25.6-11.8L256 137l-41.7-94.3-25.6 11.8 51.8 116.2-51.8 116.2 25.6 11.8 41.7-94.4 41.7 94.4 25.6-11.8-51.8-116.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M273.4 65.6c-9.9-10.8-17.4-17-17.4-17s-7.5 6.2-17.4 17v210.1c9.9 10.8 17.4 17 17.4 17s7.5-6.2 17.4-17V65.6z"
  })), /* @__PURE__ */ o.createElement("path", {
    d: "M209 105.9v129.5c10.5 18.5 23.3 33.7 32.9 43.8V62.1c-9.6 10.1-22.4 25.3-32.9 43.8zm94 0c-10.5-18.5-23.3-33.7-32.9-43.8v217.2c9.6-10.1 22.4-25.3 32.9-43.8V105.9z",
    fill: "#A2001D"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M303 105.9v129.5c10.6-18.8 18.8-41 18.8-64.8s-8.2-45.9-18.8-64.7zm-94 0v129.5c-10.6-18.8-18.8-41-18.8-64.8s8.2-45.9 18.8-64.7z"
  }));
}, NV = function(t) {
  var n = t.title, r = B(t, JO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 256,
    cy: 170.7,
    r: 170.7
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M382.4 170.7 330.8 195l27.5 50-56.1-10.7-7.1 56.6-39.1-41.7-39.1 41.7-7.1-56.6-56.1 10.7 27.5-50-51.6-24.3 51.6-24.3-27.5-50.1 56.1 10.8 7.1-56.7L256 92.1l39.1-41.7 7.1 56.7 56.1-10.8-27.5 50.1z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#D80027",
    cx: 257.4,
    cy: 170.7,
    r: 71.6
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M214.2 170.7c-2.1 0-4.1.1-6.2.3.1 12 4.4 22.9 11.6 31.5 3.8-10.3 9.5-19.6 16.7-27.7-6.9-2.7-14.3-4.1-22.1-4.1zm26.6 46.5c5.2 1.9 10.8 2.9 16.6 2.9 5.8 0 11.4-1 16.6-2.9-2.8-11.1-8.7-21-16.6-28.8-7.9 7.8-13.8 17.7-16.6 28.8zm59.4-71.2c-8.5-14.8-24.5-24.7-42.8-24.7-18.3 0-34.2 9.9-42.8 24.7 15.6.1 30.2 4.3 42.8 11.6 12.6-7.3 27.2-11.6 42.8-11.6zm-21.7 28.8c7.2 8 12.9 17.4 16.7 27.7 7.2-8.5 11.5-19.5 11.6-31.5-2-.2-4.1-.3-6.2-.3-7.7 0-15.2 1.4-22.1 4.1z",
    fill: "#FFDA44"
  }));
}, BV = function(t) {
  var n = t.title, r = B(t, QO);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M303.5 196.6v-17.8h-11.9v-23.7l-11.9-11.9-11.8 11.9v-23.8L256 119.5l-11.9 11.8v23.8l-11.8-11.9-11.9 11.9v23.7h-11.9v17.8h-11.9v17.8h118.8v-17.8z"
  }));
}, IV = function(t) {
  var n = t.title, r = B(t, eN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 300"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#CE1126",
    d: "M0 0h450v300H0V0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FCD116"
  }, /* @__PURE__ */ o.createElement("circle", {
    cx: 227.6,
    cy: 161.2,
    r: 56.2
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m254.1 73.4-23.7 26 28.6 6.5zm-51.5.2-4.8 33.1 28.5-8zm94.3 26.7-34.7 8.5 20.1 23.7zm-138.3-1.8 15.5 32.7 20.2-22.7zm159 45.3-34.4-9.9 5.6 29.5zm-182-2.6 31.9 19.8 5.2-27.7z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#003F87",
    d: "M0 175h450v125H0V175z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 267c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21z"
  }), /* @__PURE__ */ o.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FCD116",
    d: "m183.2 48.3-1.1-5.3 22.4-3.7s-30.1-7.1-40-10.7c-14.3-5.1-16.3-12.1-16.3-12.1s44.7 11 64.8 11c4.3 0 12.8 10.7 12.8 10.7s14.8-14.9 21.9-15.4c32.1-2.3 66.6-6.4 66.6-6.4s-10 6.7-16 8.5c-16.2 4.9-50.6 11.7-50.6 11.7l-4.8 7.5H277l-14.4 4.3 7.4 6.9s-7.8-4.1-18.1-2.1c-7.1 1.3-15.4 6-22.9 8-18.7 4.8-29.9-12.8-29.9-12.8l-15.9-.1z"
  }));
}, TV = function(t) {
  var n = t.title, r = B(t, tN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v85.5H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513V171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 171h513v85.5H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M256.5 171 0 342V0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M68.6 170.7c0-24.9 17.5-45.6 40.8-50.7-3.6-.8-7.3-1.2-11.1-1.2-28.7 0-51.9 23.3-51.9 51.9s23.3 51.9 51.9 51.9c3.8 0 7.5-.4 11.1-1.2-23.3-5.1-40.8-25.9-40.8-50.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m108.9 126.1 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.3h8.9zm0 22.3 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m108.9 170.7 2.7 8.5h9l-7.3 5.2 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.2h8.9zm0 22.2 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z"
  })));
}, VV = function(t) {
  var n = t.title, r = B(t, nN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M512 0H0v342"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M307.7 0 0 194.5V342h206.9L513 148.5V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M513 0H385.2L0 249.4V341l126.2 1L513 91.6z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m141.1 187 31.2 24 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.3-22.2zM310.6 70.8l31.2 23.9 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.4-22.2z",
    fill: "#FFF"
  }));
}, ZV = function(t) {
  var n = t.title, r = B(t, rN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#91DC5A",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v57.188H0zm0 284.1h513v57.177H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 79.9h513v181.582H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 190.33,
    cy: 171,
    r: 65.668
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "m190.3 105 14.8 45.3h47.7l-38.6 28.1 14.8 45.5-38.7-28.2-38.6 28.1 14.8-45.4-38.6-28.1h47.7z"
  }));
}, $V = function(t) {
  var n = t.title, r = B(t, iN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h900v600H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    transform: "rotate(-56.31)"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M-75 228.3H75m-150 37.5H75m-150 37.5H75m-150 475H75m-150 37.5H75m-150 37.5H75",
    stroke: "#000",
    strokeWidth: 25
  }), /* @__PURE__ */ o.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 12.5,
    d: "M0 753.3v125"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#ca163a",
    cy: 540.8,
    r: 150
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0e4896",
    d: "M0 390.8c-41.4 0-75 33.6-75 75s33.6 75 75 75 75 33.6 75 75-33.6 75-75 75c-82.8 0-150-67.2-150-150s67.2-150 150-150z"
  })), /* @__PURE__ */ o.createElement("path", {
    d: "m231.56 535.73-83.205-124.808M262.76 514.928l-83.205-124.807m114.407 104.006-83.205-124.808m478.43-138.675-83.205-124.807M720.39 209.843 637.184 85.036m114.407 104.006L668.386 64.234",
    stroke: "#000",
    strokeWidth: 25
  }), /* @__PURE__ */ o.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 12.5,
    d: "m205.6 462.897 31.202-20.8m389.981-259.989 36.444-24.296m31.202-20.801 31.202-20.801"
  }));
}, WV = function(t) {
  var n = t.title, r = B(t, lN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M167 227.6 0 341.3V0l167 113.8z"
  }));
}, GV = function(t) {
  var n = t.title, r = B(t, oN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#6DA544",
    cx: 384,
    cy: 96.5,
    r: 29.7
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M332.1 89H436v44.5H332.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M435.9 170.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M332.1 200.3V230h15.6c9.4 9.2 22.2 14.8 36.3 14.8 14.1 0 27-5.7 36.3-14.8h15.6v-29.7H332.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M332.1 126.1v44.5c0 39.8 51.9 51.9 51.9 51.9s51.9-12.2 51.9-51.9v-44.5H332.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M384 149.9c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9zm0-41.6c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9z",
    fill: "#F3F3F3"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0v22.6l-46.1 30.7H256v64h-46.1L256 148v22.7h-22.6l-73.4-49v49H96v-49l-73.4 49H0V148l46.1-30.7H0v-64h46.1L0 22.6V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176zM0 170.7v-15.1l57.4-38.3H80zm256 0v-15.1l-57.4-38.3H176z"
  })));
}, UV = function(t) {
  var n = t.title, r = B(t, aN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#36B6CC",
    d: "M0 0h513v342H0V0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFD400",
    cx: 256.5,
    cy: 170.9,
    r: 68.4
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFD400",
    d: "m256.5 251.5-27.9 41.7-7.1-49.7-43.2 25.5 15.2-47.8-50 4.2 34.4-36.5-46.9-18 46.8-18-34.4-36.5 50 4.2-15.2-47.8 43.2 25.4 7.1-49.7 27.9 41.7 27.9-41.7 7.1 49.7 43.2-25.4-15.2 47.8 50-4.2-34.3 36.6 46.8 17.9-46.8 18 34.4 36.5-50-4.2 15.2 47.8-43.2-25.4-7.1 49.7c0-.1-27.9-41.8-27.9-41.8zm0-.8c44.1 0 79.9-35.8 79.9-79.9S300.6 91 256.5 91s-79.9 35.8-79.9 79.9 35.8 79.8 79.9 79.8zM22.8 28.3c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V28.3zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V74zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm22.8-22.8c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7V245c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V188zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V96.8zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V51.2z"
  }));
}, jV = function(t) {
  var n = t.title, r = B(t, sN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 .1h513v90.7H0zm0 251.2h513V342H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 65.9
  }));
}, KV = function(t) {
  var n = t.title, r = B(t, cN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 .2h513v90.7H0zm.5 251.1H513V342H.5z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M290.3 193.5 256 130.7l-34.3 62.8h25.7v17.2h17.2v-17.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#14AF5A",
    d: "M241.3 213.1c4.4-4.4 4.4-11.6-.1-16l4.7 4.7c-5.2-4.7-12.2-6.6-19.1-5.3l-23.5 5.9c-6.1 1.5-6.8-.4-1.8-4.2l27.1-20.3c5.1-3.8 4.2-6.9-2.3-6.9h-11c-6.4 0-7-2.3-1.5-5.1l25.3-12.7c5.6-2.8 5.1-5.1-1.5-5.1h-11c-6.4 0-7.4-3.1-2.3-6.9l27.1-20.3c5.6-3.8 12.9-3.8 18.5 0l27.1 20.3c5.1 3.8 4.2 6.9-2.3 6.9h-11c-6.4 0-7 2.3-1.5 5.1l25.3 12.7c5.6 2.8 5.1 5.1-1.5 5.1h-11c-6.4 0-7.4 3.1-2.3 6.9l27.1 20.3c5.1 3.8 4.4 5.7-1.8 4.2l-23.5-5.9c-6.8-1.3-13.9.6-19.1 5.3l4.7-4.7c-4.4 4.4-4.5 11.5-.1 16l6.8 6.8c4.4 4.4 3.1 8-3.3 8h-45.8c-6.2 0-7.7-3.6-3.3-8 .1.1 6.9-6.8 6.9-6.8z"
  }));
}, YV = function(t) {
  var n = t.title, r = B(t, dN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#55B2FF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#F3F3F3",
    d: "M148.5 298.1h216l-108-254.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#333",
    d: "m186 272.7 70.5-160.3L327 272.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M148.5 298.1h216l-108-101.7z"
  }));
}, qV = function(t) {
  var n = t.title, r = B(t, uN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M149.3 98.1c0-14-11.3-25.3-25.3-25.3-6.5 0-12.4 2.4-16.9 6.4V64.4h8.4V47.5h-8.4v-8.4H90.3v8.4h-8.4v16.9h8.4v14.9c-4.5-4-10.4-6.4-16.9-6.4-14 0-25.3 11.3-25.3 25.3 0 7.5 3.3 14.2 8.4 18.8v14.9h84.3V117c5.3-4.7 8.5-11.5 8.5-18.9z"
  }));
}, XV = function(t) {
  var n = t.title, r = B(t, fN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M222.6 22.3h267.1v296.8H222.6z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M22.3 22.3h200.3v296.8H22.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M200.3 0h22.3v342h-22.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M22.3 22.3h89v296.8h-89z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF9811",
    d: "M111.3 22.3h89v296.8h-89z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M368.2 156.8c-1.4-2 0-37.9 0-37.9.9-7.4.1-8.4 1-11.4.9-2.9 5.4-11.6 5.4-11.6s-6-2.3-10.3-.6c-4.3 1.7-24.7-7.5-31.2 3.4-4.4 7-23.6 16.2-24.6 14-1-2.2-5.9-5-6.9-2.9s-.7 13.9 0 16c.8 2.6 9.8 2 12.3 3.1 3.7 1.8 12.2 8.2 11.9 10.7-.3 2.5-22.5-6-24.2-4.5-1.4 1.2-1.9 13.2-.4 15 1.8 2.1 23.4 5.6 25 7.5 1.6 1.9-13.1 7.4-12.3 25 .7 14.7 8 17.4 8 17.4s-2.4 3.6-7.8 3.1c-6.2-.6-27.4-17.7-27.4-17.7s-3.5-109 3.6-121.4c4.9-8.5-22.7 10.1-22.7 50.8V151c0 6.6-1.4 22.4 2.6 34 0 0-.4 46.9 1.5 49.6s12.7 2.2 14.8 0 0-30 0-30c7.7.2 18.3 17.5 32.5 16.4 20.6-1.6 28.7-9.9 34.3-5 8.1 7.1 5.5 23.2.4 31.5-2.2 3.5-14.3 4.7-15.7 7.6-1.4 2.9.5 5.4.5 5.4h29.7s1.4-20.5 2.7-26.1c1.3-5.7-.6-10.7 5.9-10.4 23.5 1.1 39.8-15.3 45.5-8 3.2 4.1 5.6 29.9 3.3 33.3-2.2 3.4-13.8 2.8-15.2 6.7-1.4 4 .8 4.4.8 4.4h29.7s-.4-21.2 2.5-27.7 4.9-10.4 9.3-17.2c4.4-6.8 11.3-15.7 11.3-36.2 0-14.2-8.1-22.8-8.1-22.8H417c-14.1.2-47.4 2.3-48.8.3zm-136-124.5c10.7-10.6 20.2-2.7 22.2 2.1 1.9 4.8 2.1 8.2 2.8 13.6.9 6.9 4.9 14 4.9 14s-7.1-3.8-14.7-4.2c-4.7-.3-9-.6-13.6-2.5-5.7-2.3-11.7-12.9-1.6-23zm248.4-.1c10.7 10.6 2.8 20.2-2 22.2s-8.2 2.1-13.6 2.8c-6.9.9-14 5-14 5s3.7-7.1 4.2-14.7c.3-4.7.6-9.1 2.4-13.6 2.2-5.7 12.8-11.8 23-1.7zm.1 276.9c-10.7 10.6-20.2 2.6-22.2-2.2-1.9-4.8-2.1-8.2-2.7-13.6-.8-6.9-4.9-14.1-4.9-14.1s7 3.8 14.7 4.3c4.7.3 9 .6 13.6 2.5 5.7 2.4 11.7 13.1 1.5 23.1zm-248.2-.1c-10.6-10.7-2.7-20.2 2.1-22.2 4.8-1.9 8.2-2.1 13.6-2.8 6.9-.9 14-4.9 14-4.9s-3.8 7.1-4.2 14.7c-.3 4.7-.6 9-2.5 13.6-2.3 5.7-12.9 11.8-23 1.6z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "none",
    stroke: "#FFDA44",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    d: "M446.9 162.4s7.5-2.6 8.4-16.1c.6-8.6-19.8-16-39-11.5-19.7 4.6-34-3.1-34-14.6 0-22.9 29.7-16.2 38.9-11.3 9.1 4.9 29.7 23.5 35.1 9.4"
  }));
}, JV = function(t) {
  var n = t.title, r = B(t, hN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v31.1H0zm0 62.2h513v31.1H0zm0 62.3h513v31.1H0zm0 62.3h513v31.1H0zm0 62.5h513v31.1H0zm0 61.6h513V342H0z",
    fill: "#bf0a30"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#002868",
    d: "M0 0h155.6v155.6H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m77.8 30.2 10.7 32.9h34.6l-28 20.4 10.7 32.9-28-20.3-28 20.3 10.7-32.9-28-20.4h34.6z"
  }));
}, QV = function(t) {
  var n = t.title, r = B(t, pN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 227.6h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m245.2 171 7.7-23.1c2-5.9 5.1-6 7.1 0l7.7 23.1 19.4 29.1c1.7 2.6 1.3 6.3-1.2 8 0 0-6.9 8-29.5 8s-29.5-8-29.5-8c-2.4-2-2.9-5.4-1.2-8l19.5-29.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M256.5 171c-12.5 0-22.6-10.1-22.6-22.6 0-12.5 10.1-22.6 22.6-22.6s22.6 10.1 22.6 22.6c0 12.5-10.2 22.6-22.6 22.6zm0 0c6.2 0 11.3-16.3 11.3-22.6 0-6.2-5.1-11.3-11.3-11.3-6.2 0-11.3 5.1-11.3 11.3 0 6.3 5 22.6 11.3 22.6z"
  }));
}, eZ = function(t) {
  var n = t.title, r = B(t, mN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 228h513v114H0z"
  }));
}, tZ = function(t) {
  var n = t.title, r = B(t, vN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 228h513v114H0z"
  }));
}, nZ = function(t) {
  var n = t.title, r = B(t, gN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    className: "prefix__st1",
    d: "M0 0h513v127.6H0zm0 214.4h513V342H0z",
    fill: "#A2001D"
  }));
}, rZ = function(t) {
  var n = t.title, r = B(t, LN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m281.4 150.7 9 12.3 14.5-4.7-9 12.4 9 12.3-14.5-4.7-9 12.3v-15.2l-14.5-4.7 14.5-4.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M257 201.5c-17 0-30.9-13.8-30.9-30.9s13.8-30.9 30.9-30.9c5.3 0 10.3 1.3 14.7 3.7-6.9-6.7-16.2-10.8-26.6-10.8-21 0-38 17-38 38s17 38 38 38c10.3 0 19.7-4.1 26.6-10.8-4.4 2.4-9.4 3.7-14.7 3.7z"
  })));
}, iZ = function(t) {
  var n = t.title, r = B(t, wN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 .3V342h513V.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#20661B",
    d: "M359.8 148.9h-73.3l-22.7-69.7-22.7 69.7h-73.3l59.3 43.1-22.7 69.7 59.3-43.1 59.3 43.1-22.5-69.7 59.3-43.1zm-116.1 37.7 7.7-23.6h24.8l7.7 23.6-20.1 14.6-20.1-14.6zm27.9-37.7H256l7.8-24 7.8 24zm24.3 29-4.8-14.9h25.3l-20.5 14.9zM236.6 163l-4.8 14.9-20.5-14.9h25.3zm-5.3 61.8 7.8-24 12.6 9.2-20.4 14.8zm44.5-14.9 12.6-9.2 7.8 24-20.4-14.8z"
  }));
}, lZ = function(t) {
  var n = t.title, r = B(t, MN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h512v341.333H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#c70000",
    d: "M0 85.333h512V256H0z"
  }));
}, oZ = function(t) {
  var n = t.title, r = B(t, xN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#AF7F59",
    d: "M206.2 129.1h33.2L256 79.3l16.6 49.8h33.2v99.6L256 262l-49.8-33.2v-99.7zm33.2 33.3v49.8h33.2v-49.8h-33.2z"
  }));
}, aZ = function(t) {
  var n = t.title, r = B(t, bN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#E6BE53",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E01D24",
    d: "M20 20h473v302H20z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#E6BE53",
    d: "M248.5 112.9c4.4 4.4 11.6 4.4 16 0l-4.7 4.7 22.7-22.7c4.9-4.5 12.1-5.6 18.2-2.8l2.1 1c5.7 2.9 6.7 8.7 2.3 13.1l4.7-4.7-22.8 22.8c-4.5 4.9-5.6 12.1-2.8 18.2l1 2.1c2.9 5.7 5.1 15.4 5.1 21.6v-11.3c0 6.2 4.4 9.1 10.2 6.2l2.1-1c5.7-2.9 6.7-8.7 2.3-13.1l4.7 4.7c-4.4-4.4-4.4-11.6 0-16l-4.7 4.7c5.2-5.5 9.6-11.6 13.1-18.2l1-2.1c2.9-5.7 6.3-15.1 7.9-21.2l5.8-23.3c1.5-6 5.9-6.8 9.6-1.8l20.2 26.9c3.8 5.1 6.9 14 6.9 20.6v22.4c0 6.3-2.2 15.8-5.1 21.7l-1 2.1c-3.5 6.6-7.9 12.7-13.1 18.2l-6.8 6.8c-5.4 5.2-11.5 9.6-18.2 13.1l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.2 0-6.9 2.2-1.1 5.1l2.1 1c5.7 2.9 13.8 8.7 18.2 13.1l-4.7-4.7c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L339 226c4.6 4.9 5.7 12.1 2.9 18.2l-1 2.1c-2.9 5.7-10.4 10.2-16.4 10.2-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.5-3.6-11.8-8.9-15.4-15.4l-1-2.1c-2.9-5.7-8.7-6.7-13.1-2.3l4.7-4.7c-4.4 4.7-5.2 11.8-1.8 17.3l10.3 15.4c3.4 5.1 2 12.1-3.1 15.5L266 284.4c-5.7 3.4-12.8 3.4-18.6 0L232 274.1c-5.1-3.4-6.5-10.3-3.1-15.5l10.3-15.4c3.4-5.5 2.6-12.6-1.8-17.3l4.7 4.7c-4.4-4.4-10.2-3.6-13.1 2.3l-1 2.1c-2.9 5.7-9.5 12.4-15.4 15.4l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.9-.3-13.1-4.2-16.4-10.2l-1-2.1c-2.8-6.1-1.6-13.3 2.9-18.2l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L181 226c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c5.5-5.2 11.6-9.6 18.2-13.1l2.1-1c5.7-2.9 5-5.1-1.1-5.1-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.6-3.5-12.7-7.9-18.2-13.1l-6.8-6.8c-5.2-5.4-9.6-11.5-13.1-18.2l-1-2.1c-3.1-6.8-4.9-14.2-5.1-21.7V121c0-6.3 3.1-15.6 6.9-20.6l20.2-26.9c3.8-5.1 8.1-4.3 9.6 1.8l5.8 23.3c2 7.3 4.6 14.4 7.9 21.2l1 2.1c2.9 5.7 8.7 13.8 13.1 18.2l-4.7-4.7c4.4 4.4 4.4 11.6 0 16l4.7-4.7c-4.4 4.4-3.6 10.2 2.3 13.1l2.1 1c5.7 2.9 10.2 0 10.2-6.2v11.3c0-6.2 2.2-15.7 5.1-21.6l1-2.1c2.8-6.1 1.7-13.2-2.8-18.2l-22.7-22.7 4.7 4.7c-4.4-4.4-3.6-10.2 2.3-13.1l2.1-1c6.1-2.8 13.2-1.7 18.2 2.8l22.7 22.7-4.8-4.5zm-18-40.7c-4.4-4.4-3.2-9.5 2.8-11.5l12.4-4.2c6-2 15.5-2 21.5 0l12.4 4.2c6 2 7.2 7.1 2.8 11.5l-6.8 6.8c-5.3 4.7-12.1 7.5-19.2 7.9-6.2 0-14.8-3.5-19.2-7.9.1 0-6.7-6.8-6.7-6.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#215F90",
    d: "M233.9 200.2c0 6.2 1.7 6.4 4.2.5 0 0 7.1-23.2 18.4-23.2 11.3 0 18.6 23.6 18.6 23.6 2.2 5.7 4 5.3 4-1.1v-11.2c0-18.7-10.1-33.9-22.6-33.9-12.5 0-22.6 15.2-22.6 33.9v11.4z"
  }));
}, sZ = function(t) {
  var n = t.title, r = B(t, yN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108 72"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h108v72H0z",
    fill: "#003787"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h108L60 48v24H48V48z",
    fill: "#fff"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 54,
    cy: 30,
    r: 8,
    fill: "#f9d90f"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M44 30h20L54 48z",
    fill: "#fff"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M54 48 38 33h32z",
    fill: "#cf142b"
  }));
}, cZ = function(t) {
  var n = t.title, r = B(t, CN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M512 426.666V85.329H0v341.337h512z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M512 85.331H0v170.666h512V85.331z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h181.793v341.337H0z"
  }));
}, dZ = function(t) {
  var n = t.title, r = B(t, EN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#1E509C",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M513 176.1V81.3L0 342l513-165.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#F18D36",
    d: "M513 0v81.3L0 342 513 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m126.7 99.3-7.8-54.1-7.7 54.1-20.8-23.7 10.7 31.6-31.5-10.7 23.6 20.8-54.1 7.7 54.1 7.7-23.6 20.8 31.5-10.7-10.7 31.6 20.8-23.7 7.7 54.1 7.8-54.1 20.7 23.7-10.6-31.6 31.5 10.7-23.6-20.8 54-7.7-54-7.7 23.6-20.8-31.5 10.7 10.6-31.6z"
  }));
}, uZ = function(t) {
  var n = t.title, r = B(t, FN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M383.875 426.662 256 252.286l26.827 174.376zM133.565 85.33 256 252.286 230.314 85.33zm95.606 341.332L256 252.286 128.124 426.662zM0 85.33V212.9l256 39.386L28.333 85.33zm0 341.332h18.212L256 252.286 0 291.67zm256-174.376L512 212.9V85.33h-28.331zM281.686 85.33 256 252.286 378.434 85.33zM512 426.662V291.671l-256-39.385 237.787 174.376z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 256,
    cy: 252.29,
    r: 59.359
  })), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFDA44",
    cx: 256,
    cy: 252.29,
    r: 44.522
  }));
}, fZ = function(t) {
  var n = t.title, r = B(t, zN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
}, hZ = function(t) {
  var n = t.title, r = B(t, AN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M384 227.261h-97.783L256 134.265l-30.217 92.997H128l79.108 57.475-30.217 92.998L256 320.925l79.108 56.81-30.217-92.998L384 227.261z"
  }));
}, pZ = function(t) {
  var n = t.title, r = B(t, SN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#095FAD",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M342 0h171v342H342zM0 0h171v342H0z",
    fill: "#BE1229"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M108.3 166.3h14.8v74.2h-14.8zm-59.4 0h14.8v74.2H48.9z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 86,
    cy: 203.4,
    r: 14.8
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M71.2 225.7h29.7v14.8H71.2zm0-59.4h29.7v14.8H71.2z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 86,
    cy: 144,
    r: 14.8
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M76.3 123.9h19.5L86 108.3z"
  })));
}, mZ = function(t) {
  var n = t.title, r = B(t, kN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#00745a",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M285.682 248.878c-4.19 0-8.166.836-11.861 2.164 2.023-4.509 3.379-9.527 3.379-14.885 0-21.201-21.201-37.101-21.201-37.101s-21.201 15.901-21.201 37.101c0 5.357 1.356 10.375 3.379 14.885-3.693-1.328-7.671-2.164-11.861-2.164-21.201 0-37.101 21.201-37.101 21.201s15.901 21.201 37.101 21.201c12.429 0 23.031-7.286 29.682-13.315 6.65 6.03 17.251 13.315 29.682 13.315 21.201 0 37.101-21.201 37.101-21.201s-15.899-21.201-37.099-21.201z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m256 152.111 4.38 13.476h14.171l-11.464 8.332 4.376 13.476-11.463-8.33-11.463 8.33 4.376-13.476-11.464-8.332h14.171zm-53.888 23.572 8.425 7.585 9.818-5.667-4.61 10.355 8.423 7.588-11.274-1.185-4.611 10.355-2.358-11.088-11.275-1.185 9.818-5.669zm-39.45 39.449 11.09 2.358 5.668-9.818 1.186 11.274 11.089 2.358-10.357 4.61 1.186 11.274-7.587-8.423-10.357 4.61 5.669-9.818zm147.227-39.449-8.425 7.585-9.818-5.667 4.611 10.355-8.425 7.588 11.275-1.185 4.61 10.355 2.359-11.088 11.275-1.185-9.818-5.669zm39.449 39.449-11.089 2.358-5.669-9.818-1.186 11.274-11.088 2.358 10.357 4.61-1.185 11.274 7.586-8.423 10.357 4.61-5.669-9.818z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M256 350.642c16.84 0 32.363-5.619 44.816-15.073h-89.63c12.451 9.454 27.974 15.073 44.814 15.073zm-68.023-44.522a74.138 74.138 0 0 0 8.85 15.073h118.345a74.13 74.13 0 0 0 8.85-15.073H187.977z",
    fill: "#FFF"
  }));
}, vZ = function(t) {
  var n = t.title, r = B(t, DN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0071BC",
    d: "M0 0h750v500H0V0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 1.9
  }, /* @__PURE__ */ o.createElement("circle", {
    cx: 375,
    cy: 245,
    r: 225,
    fill: "#fff"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 375,
    cy: 245,
    r: 165,
    fill: "#0071BC"
  })), /* @__PURE__ */ o.createElement("g", {
    stroke: "#000"
  }, /* @__PURE__ */ o.createElement("path", {
    fill: "#8C8A8C",
    strokeWidth: 1.9,
    d: "M444.7 450c.7 11-7.8 20-18.8 20H323.6c-11 0-19.5-9-19-20l16.7-325c.6-11 10-20 21-20h61.4c11 0 20.5 9 21.2 20l19.8 325z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    strokeWidth: 2,
    strokeLinejoin: "round",
    d: "m373 114 30 93h97l-78 56 29 92-78-56-78 57 30-93-79-57h97l30-92z"
  })));
}, gZ = function(t) {
  var n = t.title, r = B(t, RN);
  return /* @__PURE__ */ o.createElement("svg", N({
    viewBox: "0 0 900 600",
    xmlns: "http://www.w3.org/2000/svg"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#231f1e",
    d: "M0 0h900v600H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00a650",
    d: "M0 0h900v300H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ef1923",
    d: "m0 0 450 300L0 600z"
  }));
}, LZ = function(t) {
  var n = t.title, r = B(t, _N);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 100 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#006233",
    d: "M0 100h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#cd2a3e",
    d: "M0 100h513v46H0zm0 296h513v46H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ffc400",
    d: "M256 298.851c-45.956 0-84.348-32.298-93.767-75.429A96.288 96.288 0 0 0 160 243.994c0 53.02 42.979 96 96 96s96-42.98 96-96c0-7.066-.785-13.942-2.233-20.572-9.419 43.131-47.811 75.429-93.767 75.429z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ffc400",
    d: "m255.999 171.994 8.935 27.502h28.918l-23.394 16.996 8.936 27.503-23.395-16.998-23.394 16.998 8.937-27.503-23.394-16.996h28.915z"
  }));
}, wZ = function(t) {
  var n = t.title, r = B(t, PN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#1B4991",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00A2B8",
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M318.2 106.7v106.5c0 51.9 67.8 67.8 67.8 67.8s67.8-15.9 67.8-67.8V106.7H318.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A35023",
    d: "M319.7 212.7c0 50.8 66.3 66.3 66.3 66.3s66.3-15.6 66.3-66.3H319.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M415.1 155.1h-19.4v-19.4h-19.4v19.4H357v19.4h19.3v58.1h19.4v-58.1h19.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z"
  }));
}, MZ = function(t) {
  var n = t.title, r = B(t, HN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#C31B28",
    d: "M256 0h256.5v342H256z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ACABB1",
    stroke: "#C31B28",
    strokeWidth: 2,
    d: "M101.2 68.2V33H66v35.2H30.8v35.2H66v35.2h35.2v-35.2h35.2V68.2z"
  }));
}, xZ = function(t) {
  var n = t.title, r = B(t, ON);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#f7ce00",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#e32737",
    d: "M0 85.331h512v85.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#191f6a",
    d: "M0 170.657h512v85.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00a04e",
    d: "M0 341.331h512v85.337H0z"
  }));
}, bZ = function(t) {
  var n = t.title, r = B(t, NN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#d01920",
    d: "M0 85.331h512v341.333H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#017c3b",
    d: "M144.696 174.375h222.609v163.25H144.696z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M283.484 304.226c-26.637 0-48.232-21.594-48.232-48.232s21.594-48.232 48.232-48.232c8.306 0 16.12 2.1 22.943 5.797-10.703-10.467-25.341-16.927-41.494-16.927-32.784 0-59.362 26.577-59.362 59.362s26.578 59.362 59.362 59.362c16.154 0 30.791-6.461 41.494-16.927-6.822 3.698-14.636 5.797-22.943 5.797z"
  }));
}, yZ = function(t) {
  var n = t.title, r = B(t, BN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#272727",
    d: "M0 0h512v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#e40112",
    d: "M0 114h512v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#07893f",
    d: "M0 228h512v114H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#e40112",
    cx: 256,
    cy: 125,
    r: 95
  }));
}, CZ = function(t) {
  var n = t.title, r = B(t, IN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#dc2339",
    d: "M342 0H0v341.3h513V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#11865d",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M171 0h171v342H171z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#8C9157",
    d: "M195.8 171.2c0 21.6 11.5 41.7 30.3 52.5 5.8 3.4 13.2 1.4 16.6-4.4 3.4-5.8 1.4-13.2-4.4-16.6-11.3-6.5-18.2-18.5-18.2-31.5 0-6.7-5.4-12.1-12.1-12.1-6.7 0-12.2 5.4-12.2 12.1zm93.4 51.1c17.5-11.1 28-30.4 28-51.1 0-6.7-5.4-12.1-12.1-12.1s-12.1 5.4-12.1 12.1c0 12.4-6.3 24-16.8 30.7-5.7 3.5-7.5 10.9-4.1 16.7s10.9 7.5 16.7 4.1c0-.2.2-.3.4-.4z"
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#C59262",
    cx: 256.5,
    cy: 159.1,
    rx: 24.3,
    ry: 36.4
  }));
}, EZ = function(t) {
  var n = t.title, r = B(t, TN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0zm0 48.9h513V171H0zm0 48.8h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0z",
    fill: "#c00"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#006",
    d: "M0 0h256.5v195.4H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M153.3 42.1C122.6 30.7 88.5 46.3 77.1 77s4.2 64.8 34.9 76.2c13.3 5 28 5 41.4 0-30.7 24.5-75.4 19.6-100-11.1s-19.6-75.4 11.1-100c26-20.7 62.9-20.7 88.8 0zm26.7 75-20.6 23.3 5.4-30.6-31-1.6 27.3-14.9L143 68l28.6 12 8.4-29.9 8.4 29.9L217 68l-18 25.4 27.3 14.9-31 1.6 5.4 30.6-20.7-23.4z",
    fill: "#fc0"
  }));
}, FZ = function(t) {
  var n = t.title, r = B(t, VN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f4d900",
    d: "M0 323.333h513v104H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#006d66",
    d: "M0 85.333h513v104H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 204.333h513v104H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#cb0f31",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#f4d900",
    d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
  }));
}, zZ = function(t) {
  var n = t.title, r = B(t, ZN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.337h512"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m187.737 189.212-22.741 10.696 12.11 22.024-24.693-4.724-3.129 24.945-17.199-18.347-17.2 18.347-3.129-24.945-24.693 4.723 12.109-22.023-22.739-10.696 22.74-10.697-12.11-22.022 24.693 4.722 3.13-24.944 17.199 18.347 17.2-18.347 3.128 24.944 24.693-4.722-12.108 22.024z"
  }));
}, AZ = function(t) {
  var n = t.title, r = B(t, $N);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 426.7"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#009543",
    d: "M0 293h640v133.7H0V293z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ED4135",
    d: "M0 132h640v161.3H0V132z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0035AD",
    d: "M0 0h640v133.3H0V0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FAE600",
    stroke: "#000",
    strokeWidth: 5.3,
    cx: 240,
    cy: 213.3,
    r: 157.3
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m307.9 354.5-31.8 12-36.1 4.2-37.8-2.4-35.9-15.5s28.6-29.3 40.7-33.5c8.6-3 22.4-3.7 22.4-3.7V122l-.3-66H246l-.5 67.5v191.7s15.3 1.2 22.1 4.1c11.3 4.9 40.3 35.2 40.3 35.2z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m212.727 102.375 42.955-21.418 5.577 11.187-42.955 21.417z"
  }), /* @__PURE__ */ o.createElement("ellipse", {
    cx: 237.8,
    cy: 280.5,
    rx: 16.8,
    ry: 26.5
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 237.4,
    cy: 143.4,
    r: 20.9
  }), /* @__PURE__ */ o.createElement("ellipse", {
    cx: 238.4,
    cy: 211.1,
    rx: 19.9,
    ry: 12.1
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M213.8 177h47v10h-47zm0 57h47v10h-47z"
  }));
}, SZ = function(t) {
  var n = t.title, r = B(t, WN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#e05206",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0db02b",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#e05206",
    cx: 256,
    cy: 256,
    r: 32
  }));
}, kZ = function(t) {
  var n = t.title, r = B(t, GN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.5 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.5h171v342H0zm342 0h171v342H342zm-38 226.495-48-152.001-48 152.001h36v39.999h24v-39.999z",
    fill: "#007b23"
  }));
}, DZ = function(t) {
  var n = t.title, r = B(t, UN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.5 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.5h171v342H0zm342 0h171v342H342z",
    fill: "#007b23"
  }));
}, RZ = function(t) {
  var n = t.title, r = B(t, jN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#338AF3"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M256 214.447c-22.949 0-41.553 18.603-41.553 41.553S233.05 297.553 256 297.553c22.949 0 41.553-18.603 41.553-41.553S278.949 214.447 256 214.447zm0 65.298c-13.114 0-23.745-10.631-23.745-23.745s10.631-23.745 23.745-23.745 23.745 10.631 23.745 23.745-10.631 23.745-23.745 23.745z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M276.563 261.936 256 256l-20.563 5.936-6.855 11.873h54.836z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "m256 226.32-13.709 23.744L256 256l13.709-5.936z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M235.437 261.936h41.126l-6.854-11.872h-27.418z"
  }));
}, _Z = function(t) {
  var n = t.title, r = B(t, KN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#cd1f2a",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1d4185",
    d: "M0 228h513v114H0z"
  }));
}, PZ = function(t) {
  var n = t.title, r = B(t, YN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
  }));
}, HZ = function(t) {
  var n = t.title, r = B(t, qN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.337l280.419 174.75H87.61l183.576 166.576z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M244.769 249.888 10.199 103.71v312.754h234.57L61.193 249.888z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m98.003 324.433-14.589-6.863 7.77-14.13-15.844 3.03-2.008-16.005-11.035 11.772-11.036-11.772-2.008 16.005-15.843-3.031 7.77 14.131-14.591 6.863 14.591 6.862-7.77 14.13 15.844-3.029 2.007 16.004 11.036-11.772L73.332 358.4l2.008-16.004 15.843 3.03-7.769-14.13zm-9.735-132.771-10.612-4.991 5.651-10.278-11.523 2.205-1.461-11.641-8.026 8.561-8.026-8.561-1.46 11.641-11.525-2.205 5.652 10.278-10.613 4.991 25.972 5.194z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M93.462 191.662c0 17.212-13.953 31.165-31.165 31.165s-31.165-13.953-31.165-31.165"
  })));
}, OZ = function(t) {
  var n = t.title, r = B(t, XN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 239.994h512v32H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m174.802 341.329-19.124 8.996 10.184 18.521-20.767-3.973-2.631 20.978L128 370.422l-14.465 15.429-2.63-20.978-20.767 3.973 10.183-18.521-19.123-8.996 19.124-8.995-10.184-18.52 20.766 3.971 2.632-20.978L128 312.236l14.465-15.429 2.63 20.978 20.767-3.971-10.183 18.521z"
  }));
}, NZ = function(t) {
  var n = t.title, r = B(t, JN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h256v170.663H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80z"
  })), /* @__PURE__ */ o.createElement("path", {
    d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M256 85.329v15.083l-57.377 38.251H176z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.329v15.083l57.377 38.251H80z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M256 85.329v15.083l-57.377 38.251H176z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 255.997v-15.082l57.377-38.252H80z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 233.376v-30.713h46.069zm96 22.618v-48.912l-73.372 48.912z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M256 255.997v-15.082l-57.377-38.252H176z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#2E52B2"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M256 233.376v-30.713h-46.069zm-96 22.618v-48.912l73.372 48.912z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 128,
    cy: 170.66,
    r: 22.627
  })), /* @__PURE__ */ o.createElement("path", {
    d: "m128 154.663 3.97 12.222h12.854l-10.398 7.556 3.971 12.222L128 179.109l-10.398 7.554 3.972-12.222-10.398-7.556h12.853zm0 65.14 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm0-117.334 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm69.931 58.667 2.365 7.277h7.653l-6.192 4.499 2.365 7.279-6.191-4.498-6.191 4.498 2.365-7.279-6.191-4.499h7.652zm-139.862 0 2.364 7.277h7.653l-6.191 4.499 2.364 7.279-6.19-4.498-6.191 4.498 2.365-7.279-6.192-4.499h7.653z",
    fill: "#FFDA44"
  }));
}, BZ = function(t) {
  var n = t.title, r = B(t, QN);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m425.301 233.745 3.388 10.428h10.963l-8.87 6.444 3.388 10.427-8.869-6.444-8.871 6.444 3.388-10.427-8.87-6.444h10.963zm-39.194 75.072 5.083 15.642h16.445l-13.305 9.667 5.082 15.64-13.305-9.667-13.305 9.667 5.083-15.64-13.305-9.667h16.445zm1.481-122.846 4.236 13.036h13.704l-11.088 8.054 4.235 13.034-11.087-8.056-11.088 8.056 4.235-13.034-11.087-8.054h13.704zm-37.712 47.32 5.082 15.641h16.446l-13.306 9.666 5.084 15.641-13.306-9.666-13.305 9.666 5.082-15.641-13.305-9.666h16.445z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256.003 85.329v30.564l-45.178 25.088h45.178v59.359H196.89l59.113 32.846v22.806h-26.69l-73.484-40.826v40.826h-55.652v-48.573l-87.429 48.573H.003v-30.553l45.168-25.099H.003v-59.359h59.103L.003 108.147V85.329h26.68l73.494 40.838V85.329h55.652v48.573l87.43-48.573z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.334H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915zm-83.98 0L0 240.259v15.739l100.174-55.654z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915zm83.98 0L256 101.068V85.33l-100.174 55.653z",
    fill: "#D80027"
  }));
}, IZ = function(t) {
  var n = t.title, r = B(t, eB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M138 0h377v114H138z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#4A7C3A",
    d: "M138 230h377v114H138z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 10,
    strokeMiterlimit: 2
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M40.3 35.2s37.1 48 50.8 54.5c13.7 6.5 17.1 5.7 17.1 5.7"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M100 35.2S62.9 80.6 53.3 87.6c-9.6 7-18.7 7.8-18.7 7.8m17.1-30.1h37.9M70.7 35.2v30.1"
  })));
}, TZ = function(t) {
  var n = t.title, r = B(t, tB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M256 256v170.663H0V256h256z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337V256H256V85.337h256z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "m128 123.034 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L128 195.813l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "m384 293.697 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L384 366.476l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
  }));
}, VZ = function(t) {
  var n = t.title, r = B(t, nB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.331h170.663v341.337H0zm341.337 0H512v341.337H341.337z",
    fill: "#D80027"
  }));
}, ZZ = function(t) {
  var n = t.title, r = B(t, rB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M293.991 256c0 20.982-17.01 33.243-37.992 33.243S218.008 276.982 218.008 256s17.01-37.992 37.992-37.992 37.991 17.01 37.991 37.992z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M293.991 256c0 20.982-17.01 37.992-37.992 37.992s-37.992-17.01-37.992-37.992"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M232.259 246.506h9.498v19h-9.498zm37.988 0h9.498v19h-9.498zm-19-14.247h9.498v33.243h-9.498z",
    fill: "#D80027"
  }));
}, $Z = function(t) {
  var n = t.title, r = B(t, iB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M0 85.33h512v341.332"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m204.631 326.488 2.762 8.504h8.941l-7.233 5.255 2.763 8.502-7.233-5.254-7.233 5.254 2.762-8.502-7.233-5.255h8.94zm-22.834-81.622 4.605 14.172h14.901l-12.056 8.757 4.605 14.172-12.055-8.759-12.055 8.759 4.606-14.172-12.056-8.757h14.901zm0 103.883 4.604 14.173h14.902l-12.057 8.757 4.606 14.173-12.055-8.759-12.055 8.759 4.604-14.173-12.054-8.757h14.899zm43.566-66.782 4.606 14.172h14.901l-12.056 8.758 4.605 14.172-12.056-8.759-12.054 8.759 4.606-14.172-12.056-8.758h14.901zm-87.133 0 4.606 14.172h14.899l-12.054 8.758 4.603 14.172-12.054-8.759-12.055 8.759 4.605-14.172-12.055-8.758h14.9z",
    fill: "#FFF"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M376.526 204.163c-7.628-7.628-17.538-12.133-28.189-12.908l31.88-24.795c-12.698-12.698-29.714-18.431-46.319-17.218a44.31 44.31 0 0 0-11.396-19.511l-12.593 25.186a18.47 18.47 0 0 0-3.148-4.197c-7.245-7.245-18.991-7.244-26.234 0s-7.245 18.99 0 26.234a18.536 18.536 0 0 0 4.197 3.148l-25.186 12.593a44.303 44.303 0 0 0 19.519 11.399c-1.217 16.606 4.511 33.619 17.209 46.317L324.12 214.6a11.053 11.053 0 0 1 7.807-3.202c2.973 0 5.768 1.158 7.87 3.26a11.055 11.055 0 0 1 3.26 7.87c0 2.974-1.158 5.768-3.26 7.87l10.494 10.494c4.905-4.905 7.607-11.428 7.607-18.364 0-5.675-1.81-11.071-5.153-15.534a29.492 29.492 0 0 1 13.288 7.662c11.573 11.572 11.573 30.403 0 41.975l10.494 10.494c8.409-8.409 13.039-19.59 13.039-31.481-.001-11.892-4.632-23.072-13.04-31.481z"
  }));
}, WZ = function(t) {
  var n = t.title, r = B(t, lB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M512 85.337V256H256L0 85.337z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M512 256v170.663H0L256 256z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m161.908 256-27.288-12.835 14.532-26.428-29.632 5.668-3.755-29.933-20.64 22.015-20.639-22.015-3.755 29.933-29.631-5.669 14.531 26.428L28.343 256l27.288 12.835L41.1 295.263l29.633-5.668 3.753 29.933 20.639-22.015 20.64 22.015 3.755-29.933 29.631 5.669-14.532-26.427zM21.789 117.607l9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.694-14.809-4.932-9.268 12.559.117-15.608-14.809-4.934 14.88-4.712zm0 235.923 9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.695-14.809-4.933-9.268 12.558.117-15.607-14.809-4.934 14.88-4.712zm188.606-117.961-9.081 12.695-14.879-4.713 9.268 12.559-9.081 12.696 14.809-4.933 9.268 12.558-.117-15.607 14.809-4.934-14.88-4.713z",
    fill: "#FFDA44"
  }));
}, GZ = function(t) {
  var n = t.title, r = B(t, oB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m393.508 170.516 17.512 18.875 23.363-10.821-12.541 22.487 17.513 18.876-25.263-4.978-12.539 22.488-3.073-25.564-25.263-4.978 23.363-10.82z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.343h512v341.326H0z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#01411c",
    d: "M128 85.331h384v341.337H128z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M361.909 298.793c-31.037 22.426-74.378 15.446-96.804-15.592-22.427-31.038-15.446-74.379 15.593-96.804 9.677-6.992 20.55-11.125 31.613-12.563-21.283-3.183-43.777 1.613-62.598 15.211-38.2 27.602-46.792 80.944-19.191 119.145 27.601 38.199 80.944 46.792 119.145 19.189 18.82-13.598 30.436-33.448 34.096-54.655-4.839 10.05-12.176 19.076-21.854 26.069zm-1.329-125.904 17.484 18.842 23.322-10.802-12.519 22.447 17.483 18.844-25.219-4.968-12.519 22.45-3.067-25.521-25.22-4.969 23.323-10.802z",
    fill: "#FFF"
  }));
}, UZ = function(t) {
  var n = t.title, r = B(t, aB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512V256H0z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 256h512v170.663H0z"
  }));
}, jZ = function(t) {
  var n = t.title, r = B(t, sB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00318A",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, KZ = function(t) {
  var n = t.title, r = B(t, cB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ACABB1",
    d: "M400.696 219.822 384 225.387l-16.696-5.565-5.565-13.913 5.565-13.913h33.392l-5.566 13.913z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M345.043 219.822v61.217c0 29.821 38.957 38.957 38.957 38.957s38.957-9.137 38.957-38.957v-61.217h-77.914z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M348.555 295.541C358.131 313.927 384 319.996 384 319.996s25.869-6.069 35.445-24.455L384 236.518l-35.445 59.023z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M422.957 280.421 384 219.822l-38.957 60.599v.618c0 5.518 1.337 10.328 3.512 14.503L384 240.405l35.445 55.137c2.175-4.175 3.512-8.983 3.512-14.503v-.618z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
    fill: "#D80027"
  }));
}, YZ = function(t) {
  var n = t.title, r = B(t, dB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512V153.6H0zm0 136.526h512v68.263H0zM0 358.4h512v68.263H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
  }));
}, qZ = function(t) {
  var n = t.title, r = B(t, uB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#268024",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#e4312b",
    d: "M256 256.006 0 426.668V85.331z"
  }));
}, XZ = function(t) {
  var n = t.title, r = B(t, fB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M196.641 85.337v341.326H0V85.337z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFDA44",
    cx: 196.641,
    cy: 256,
    r: 64
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M160.638 224v40.001c0 19.882 16.118 36 36 36s36-16.118 36-36V224h-72z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M196.638 276c-6.617 0-12-5.383-12-12v-16h24.001v16c-.001 6.616-5.385 12-12.001 12z"
  }));
}, JZ = function(t) {
  var n = t.title, r = B(t, hB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFDA44",
    cx: 218.902,
    cy: 255.994,
    r: 74.207
  }));
}, QZ = function(t) {
  var n = t.title, r = B(t, pB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "m289.579 216.738-12.592 12.592c5.37 5.372 8.693 12.792 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.112-5.316-24.985-13.91-33.579z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m256 232.51 4.421 13.605h14.304l-11.573 8.408 4.421 13.604L256 259.719l-11.573 8.408 4.421-13.604-11.573-8.408h14.304z"
  }));
}, e$ = function(t) {
  var n = t.title, r = B(t, mB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#751A46",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0v342h150.3l37.7-19.6-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19 37.7-18.9-37.7-19 37.7-19-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19L188 57l-37.7-19L188 19.1 150.3 0z"
  }));
}, t$ = function(t) {
  var n = t.title, r = B(t, vB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00318A",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, n$ = function(t) {
  var n = t.title, r = B(t, gB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
}, r$ = function(t) {
  var n = t.title, r = B(t, LB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 312.882h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M129.468 181.793v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.356 256 266.929v-85.136H129.468z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M155.634 196.634h74.201v-29.681l-14.841 7.42-22.261-22.26-22.259 22.26-14.84-7.42zm85.526 82.148-48.231-48.231-48.231 48.231 15.741 15.74 32.49-32.49 32.49 32.49z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M241.16 233.734h-22.504a14.74 14.74 0 0 0 2.001-7.418c0-8.196-6.645-14.84-14.84-14.84-5.663 0-10.581 3.172-13.083 7.836-2.502-4.663-7.421-7.836-13.083-7.836-8.195 0-14.84 6.644-14.84 14.84 0 2.706.736 5.235 2.001 7.418h-22.114c0 8.196 7.139 14.84 15.334 14.84h-.494c0 8.196 6.644 14.84 14.84 14.84 0 7.257 5.211 13.286 12.094 14.576l-11.694 26.401a48.075 48.075 0 0 0 18.149 3.544 48.079 48.079 0 0 0 18.149-3.544l-11.694-26.401c6.883-1.29 12.094-7.319 12.094-14.576 8.196 0 14.84-6.644 14.84-14.84h-.494c8.199 0 15.338-6.644 15.338-14.84z"
  }));
}, i$ = function(t) {
  var n = t.title, r = B(t, wB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.33v341.332h512V85.33z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 312.884h512v113.775H0z"
  }));
}, l$ = function(t) {
  var n = t.title, r = B(t, MB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 255.994h512v81.619H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 337.614h512v89.043H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m278.261 185.209 20.844 9.804-11.099 20.186 22.632-4.33 2.868 22.865 15.765-16.816 15.766 16.816 2.867-22.865 22.633 4.33-11.099-20.186 20.843-9.804-20.844-9.805 11.1-20.185-22.633 4.329-2.868-22.864-15.765 16.816-15.766-16.816-2.867 22.864-22.634-4.329 11.1 20.187z"
  }));
}, o$ = function(t) {
  var n = t.title, r = B(t, xB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#055e1c",
    d: "M0 85.333h512v341.333H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M183.548 289.386c0 12.295 9.731 22.261 21.736 22.261h65.208c0 10.244 8.11 18.551 18.114 18.551h21.736c10.004 0 18.114-8.306 18.114-18.551v-22.261H183.548zm146.716-107.595v51.942c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942h-21.735zm-155.773 51.943c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942H174.49v51.942z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M297.661 181.788h21.736v51.942h-21.736zm-32.604 29.685c0 2.046-1.625 3.71-3.623 3.71-1.998 0-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 2.046-1.625 3.71-3.623 3.71s-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 14.32 11.376 25.971 25.358 25.971 5.385 0 10.38-1.733 14.491-4.677 4.11 2.944 9.106 4.677 14.491 4.677 1.084 0 2.15-.078 3.2-.215-1.54 6.499-7.255 11.345-14.068 11.345v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.943h-21.736l.002 29.682z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M207.093 248.57h32.601v22.261h-32.601z"
  })));
}, a$ = function(t) {
  var n = t.title, r = B(t, bB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.329h512"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 396.494v30.169h45.255L512 115.499v-30.17h-45.255z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m85.688 108.787 5.12 15.756h16.566l-13.403 9.737 5.12 15.757-13.403-9.738-13.405 9.738 5.12-15.757L64 124.543h16.567zm84.624 0 5.121 15.756H192l-13.403 9.737 5.12 15.757-13.405-9.738-13.403 9.738 5.12-15.757-13.403-9.737h16.566zm-84.624 82.502 5.12 15.756h16.566l-13.403 9.738 5.12 15.757-13.403-9.739-13.405 9.739 5.12-15.757L64 207.045h16.567zm84.624 0 5.121 15.756H192l-13.403 9.738 5.12 15.757-13.405-9.739-13.403 9.739 5.12-15.757-13.403-9.738h16.566zM128 150.037l5.12 15.756h16.568l-13.405 9.738 5.12 15.758L128 181.55l-13.403 9.739 5.12-15.758-13.405-9.738h16.568z",
    fill: "#FFF"
  }));
}, s$ = function(t) {
  var n = t.title, r = B(t, yB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M235.454 85.337 0 426.663 427.345 85.337z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M512 329.393 0 426.663h512z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337h-84.655L0 426.663l512-204.512z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337v341.326L235.454 85.337z"
  }));
}, c$ = function(t) {
  var n = t.title, r = B(t, CB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 426.668V85.331l256 170.675z"
  }));
}, d$ = function(t) {
  var n = t.title, r = B(t, EB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M192 85.33h-64v138.666H0v64h128v138.666h64V287.996h320v-64H192z"
  }));
}, u$ = function(t) {
  var n = t.title, r = B(t, FB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512V256H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M83.478 170.666c0-24.865 17.476-45.637 40.812-50.734a52.059 52.059 0 0 0-11.13-1.208c-28.688 0-51.942 23.254-51.942 51.941s23.255 51.942 51.942 51.942c3.822 0 7.543-.425 11.13-1.208-23.336-5.095-40.812-25.867-40.812-50.733zm66.783-48.231 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m121.344 144.696 3.683 11.337h11.921l-9.645 7.007 3.684 11.337-9.643-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921zm57.834 0 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.685-11.337-9.645-7.007h11.921zm-11.131 33.391 3.684 11.337h11.921l-9.644 7.007 3.684 11.337-9.645-7.006-9.643 7.006 3.684-11.337-9.644-7.007h11.92zm-35.573 0 3.683 11.337h11.921l-9.644 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.684-11.337-9.644-7.007h11.92z"
  })));
}, f$ = function(t) {
  var n = t.title, r = B(t, zB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#29DBFF",
    d: "M449 139.7c-.1 44.4-7.2 92.1-65 114.9-57.8-22.8-64.9-70.5-65-114.9h130z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ffda44",
    d: "M449 139.7c0-16.7-.9-32.9-.5-47.1C426.9 83 398.4 81 383.9 81s-42.9 2-64.6 11.6c.4 14.2-.5 30.4-.5 47.1H449z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#BF521B",
    d: "m369.5 204.5.3 10.3-12.8.2 4.9 13.2h-17.3c-18-20.2-23.4-42.4-24.9-68.1l9.1-9.7 8.3 14.3 10.8-12.8 7 7.8.8 15.7 13.8 29.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#474747",
    d: "m436.6 192.5-8.6 18.3h-47l-29.2-19.5 25.7 10.5h25.1l3.7-6.5 7.2.2 2-3z"
  }));
}, h$ = function(t) {
  var n = t.title, r = B(t, AB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 199.112h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l14.848 14.837 29.674-22.261 29.685 22.261 14.837-14.837z"
  }));
}, p$ = function(t) {
  var n = t.title, r = B(t, SB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
  }));
}, m$ = function(t) {
  var n = t.title, r = B(t, kB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 196.641h512v118.717H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 315.359h512v111.304H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M129.468 181.799v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.362 256 266.935v-85.136H129.468z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M146.126 184.294v81.941c0 5.472 1.215 10.64 3.623 15.485h85.97c2.408-4.844 3.623-10.012 3.623-15.485v-81.941h-93.216z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M221.301 241.427h-21.425v-14.283h14.284v-14.283h-14.284v-14.284h-14.283v14.284h-14.282v14.283h14.282v14.283h-21.426v14.284h21.426v14.283h14.283v-14.283h21.425z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M169.232 301.658c9.204 5.783 18.66 9.143 23.502 10.636 4.842-1.494 14.298-4.852 23.502-10.636 9.282-5.833 15.79-12.506 19.484-19.939a24.878 24.878 0 0 0-14.418-4.583c-1.956 0-3.856.232-5.682.657-3.871-8.796-12.658-14.94-22.884-14.94-10.227 0-19.013 6.144-22.884 14.94a25.048 25.048 0 0 0-5.682-.657 24.88 24.88 0 0 0-14.418 4.583c3.691 7.433 10.198 14.106 19.48 19.939z"
  }));
}, v$ = function(t) {
  var n = t.title, r = B(t, DB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 312.888h512v113.775H0z"
  }));
}, g$ = function(t) {
  var n = t.title, r = B(t, RB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.34h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M512 85.334v166.69L0 256.175V85.334z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M323.744 203.099 256 270.843l-67.744-67.744a81.156 81.156 0 0 0-13.879 45.483v22.261c0 35.744 23.097 66.193 55.148 77.213-4.277 8.385-3.556 18.848 2.712 26.671l24.258-19.439 24.258 19.439c6.342-7.915 7.011-18.534 2.564-26.968 31.614-11.261 54.308-41.485 54.308-76.916v-22.261a81.174 81.174 0 0 0-13.881-45.483z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M256 330.206c-32.732 0-59.362-26.63-59.362-59.362v-22.261c0-32.733 26.63-59.363 59.362-59.363s59.362 26.63 59.362 59.362v22.261c0 32.733-26.63 59.363-59.362 59.363z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M293.101 270.843v-22.261c0-20.458-16.643-37.101-37.101-37.101s-37.101 16.643-37.101 37.101v22.261L256 278.264l37.101-7.421z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M218.899 270.843c0 20.458 16.643 37.101 37.101 37.101s37.101-16.643 37.101-37.101h-74.202z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M300.522 189.22c0-12.295-9.966-22.261-22.261-22.261a22.173 22.173 0 0 0-14.84 5.672v-13.093h7.421v-14.84h-7.421v-7.421h-14.84v7.421h-7.421v14.84h7.421v13.093a22.177 22.177 0 0 0-14.841-5.672c-12.295 0-22.261 9.966-22.261 22.261 0 6.591 2.867 12.512 7.421 16.589v13.093h74.203v-13.093c4.552-4.077 7.419-9.997 7.419-16.589z"
  }));
}, L$ = function(t) {
  var n = t.title, r = B(t, _B);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M330.207 85.331H512v341.337H330.207z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.331h181.793v341.337H0zm255.999 111.301 14.733 45.347h47.685l-38.576 28.029 14.734 45.348-38.576-28.026-38.577 28.026 14.737-45.348-38.576-28.029h47.681z",
    fill: "#496E2D"
  }));
}, w$ = function(t) {
  var n = t.title, r = B(t, PB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m256 157.273 22.663 69.748H352l-59.332 43.106 22.664 69.749L256 296.769l-59.332 43.107 22.664-69.749L160 227.021h73.337z"
  }));
}, M$ = function(t) {
  var n = t.title, r = B(t, HB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M0 196.636h512v118.728H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 352.462h512v74.207H0zM0 85.331h512v74.207H0z",
    fill: "#6DA544"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m256.742 218.003 9.43 29.021h30.518L272 264.963l9.431 29.023-24.689-17.937-24.689 17.937 9.431-29.023-24.69-17.939h30.518z"
  }));
}, x$ = function(t) {
  var n = t.title, r = B(t, OB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 322.783h512v103.88H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v104.515H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M0 210.877h512v89.656H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m73.178 209.188 20.831 29.067 34.084-10.83-21.207 28.795 20.83 29.069-33.939-11.271-21.208 28.794.234-35.762-33.94-11.273 34.083-10.83z"
  }));
}, b$ = function(t) {
  var n = t.title, r = B(t, NB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#6DA544"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m302.049 226.318 7.368 22.674h23.842l-19.288 14.016 7.366 22.674-19.288-14.015-19.287 14.015 7.366-22.674-19.288-14.016h23.842zm74.203 0 7.367 22.674h23.842l-19.288 14.016 7.367 22.674-19.288-14.015-19.288 14.015 7.367-22.674-19.288-14.016h23.842z"
  }));
}, y$ = function(t) {
  var n = t.title, r = B(t, BB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M228.582 261.936 256 214.447l27.418 47.489z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M291.616 277.616 256 295.425l-35.616-17.809v-23.744h71.232z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m289.579 216.485-12.592 12.592c5.37 5.372 8.693 12.791 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.114-5.316-24.987-13.91-33.579z"
  }));
}, C$ = function(t) {
  var n = t.title, r = B(t, IB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M512 85.331v166.69L0 256.173V85.331z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M59.621 256a59.546 59.546 0 0 0-.193 4.57c0 32.821 26.607 59.429 59.429 59.429s59.429-26.607 59.429-59.429c0-1.539-.078-3.061-.193-4.57H59.621z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 118.862,
    cy: 210.287,
    r: 18.286
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M77.715 205.714v59.429c0 31.494 41.144 41.143 41.144 41.143s41.144-9.649 41.144-41.143v-59.429H77.715z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M118.877 287.148c-7.632-2.746-22.876-9.767-22.876-22.006v-41.144h45.715v41.144c-.001 12.28-15.244 19.283-22.839 22.006z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#F3F3F3",
    d: "M128.001 246.856v-9.142l-9.144-4.571-9.142 4.571v9.142l-4.571 4.573v18.285h27.428v-18.285z"
  }));
}, E$ = function(t) {
  var n = t.title, r = B(t, TB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h900v600H0z",
    fill: "#0f0f0f"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h900v400H0z",
    fill: "#fff"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h900v200H0z",
    fill: "#047a3f"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m176.26 375 48.738-150 48.738 150-127.6-92.705h157.72M626.256 375l48.738-150 48.738 150-127.6-92.705h157.72M401.252 375l48.738-150 48.738 150-127.6-92.705h157.72",
    fill: "#ce1126"
  }));
}, F$ = function(t) {
  var n = t.title, r = B(t, VB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#2B5DEA",
    d: "M0 0h900v600H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDF29",
    d: "M0 100h900v400H0V100z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D70000",
    d: "M0 150h900v300H0V150z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M450 171.4v257.2c114.3 0 171.4-85.7 214.3-128.6-42.9-42.9-100-128.6-214.3-128.6z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M450 171.4c-100 0-171.4 85.7-214.3 128.6C278.6 342.9 350 428.6 450 428.6V171.4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M346.3 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M477.8 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
  }));
}, z$ = function(t) {
  var n = t.title, r = B(t, ZB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#29DBFF",
    d: "M448.9 169.5c0 9.6-.3 29.6-1.4 39.2-4.1 34.9-23.5 68.8-62.1 85.9-45.3-17.9-60.8-51-64.9-85.9-1.1-9.6-1.5-19.4-1.5-29l.3-47.1h129.2l.4 36.9z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M447.5 208.7c-.2 1.6-.4 3.3-.6 4.9-4.8 33.1-22.9 65.4-61.5 81-43.2-17-59.4-47.9-64.2-81-.2-1.6-.4-3.2-.6-4.9"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#29DBFF",
    d: "m385.4 251.7-22.9-43h45.8z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m385.4 165.8-22.9 42.9h45.8z"
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#FFBE57",
    cx: 474.8,
    cy: 236.8,
    rx: 16.8,
    ry: 43.3
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#FFBE57",
    cx: 295.3,
    cy: 236.8,
    rx: 16.8,
    ry: 43.3
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m385.4 31.5-33.4 44h68.5zM315.5 280s33.8 29.5 69.9 29.5 67.1-29.5 67.1-29.5l8.5 14.6S439.2 326 385.4 326 307 294.6 307 294.6l8.5-14.6z"
  }), /* @__PURE__ */ o.createElement("ellipse", {
    fill: "#A5A5A5",
    cx: 386.3,
    cy: 104.3,
    rx: 34.3,
    ry: 23.3
  }));
}, A$ = function(t) {
  var n = t.title, r = B(t, $B);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M332.058 191.996v78.221c0 38.103 51.942 49.779 51.942 49.779s51.942-11.675 51.942-49.779v-78.221H332.058z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF9811",
    d: "M376.579 220.44c0 7.855-6.644 28.445-14.84 28.445s-14.84-20.589-14.84-28.445c0-7.856 14.84-14.222 14.84-14.222s14.84 6.367 14.84 14.222z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#A2001D",
    d: "M415.961 235.93c2.394-5.6 4.257-13.785 4.257-17.86 0-6.546-8.904-11.852-8.904-11.852s-8.904 5.306-8.904 11.852c0 4.075 1.862 12.26 4.257 17.86l-5.141 11.123a26.898 26.898 0 0 0 9.788 1.831c3.463 0 6.766-.654 9.788-1.831l-5.141-11.123z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M372.87 270.217s-7.421 14.222-7.421 28.445h37.101c0-14.222-7.421-28.445-7.421-28.445l-11.13-7.111-11.129 7.111z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M395.13 270.217v-3.555c0-5.891-4.983-10.666-11.13-10.666-6.147 0-11.13 4.776-11.13 10.666v3.555h22.26z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
    fill: "#D80027"
  }));
}, S$ = function(t) {
  var n = t.title, r = B(t, WB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
}, k$ = function(t) {
  var n = t.title, r = B(t, GB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h21v15H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0A388A",
    d: "M0 0h22.5v15H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h11.3v7.5H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M7.1 0h3.6v7H7.1V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0A388A",
    d: "M0 0h3.6v7H0V0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M3.6 0h3.6v7H3.6V0zm10.9 6h5L19 7h-1.5v.5h1l-.5 1h-.5V10h-1V7H15l-.5-1zm4 2.5 1 1.5h-2l1-1.5zm-3 0 1 1.5h-2l1-1.5zm1.5 3L16 10h2l-1 1.5zM20 8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-6 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm1 4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm4 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-2 1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5z"
  }));
}, D$ = function(t) {
  var n = t.title, r = B(t, UB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512V153.6H0zM0 358.4h512v68.263H0zm0-136.537h512v68.263H0z",
    fill: "#496E2D"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h204.054v204.054H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m102.026 133.938 13.26 40.812h42.916l-34.718 25.226 13.26 40.814-34.718-25.224-34.719 25.224 13.263-40.814-34.718-25.226h42.913z"
  }));
}, R$ = function(t) {
  var n = t.title, r = B(t, jB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h512V426.66H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 194.056h512v123.882H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.334h512v54.522H0zm0 286.809h512v54.522H0z",
    fill: "#D80027"
  }));
}, _$ = function(t) {
  var n = t.title, r = B(t, KB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M226.318 300.522h59.364v-25.23l-11.873 5.937L256 263.421l-17.809 17.808-11.873-5.937zm-33.963-29.682 2.763 8.504h8.94l-7.233 5.255 2.763 8.502-7.233-5.255-7.234 5.255 2.763-8.502-7.233-5.255h8.94zm8.566-29.68 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm24.488-22.261 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm94.236 51.941-2.763 8.504h-8.94l7.233 5.255-2.763 8.502 7.233-5.255 7.234 5.255-2.763-8.502 7.233-5.255h-8.94zm-8.566-29.68-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zm-24.488-22.261-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zM256 207.767l2.763 8.503h8.941l-7.234 5.256 2.763 8.502-7.233-5.254-7.233 5.254 2.763-8.502-7.234-5.256h8.941z",
    fill: "#FFDA44"
  }));
}, P$ = function(t) {
  var n = t.title, r = B(t, YB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m210.715 174.377 3.684 11.338h11.919l-9.643 7.006 3.684 11.337-9.644-7.007-9.644 7.007 3.684-11.337-9.645-7.006h11.921zm-93.899 107.594 4.605 14.172h14.9l-12.055 8.757 4.606 14.173-12.056-8.76-12.055 8.76 4.604-14.173-12.054-8.757h14.899zm27.88-162.292 4.604 14.172h14.901l-12.056 8.758 4.606 14.171-12.055-8.759-12.056 8.759 4.606-14.171-12.055-8.758h14.9zm-75.157 55.652 4.604 14.172h14.9l-12.055 8.758 4.606 14.171-12.055-8.758-12.056 8.758 4.606-14.171-12.055-8.758h14.9z",
    fill: "#FFF"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M483.386 354.503H117.801s109.234-88.562 310.593-220.938c.001 0-88.443 128.935 54.992 220.938zm-365.585 11.586c-11.177 0-11.195 17.37 0 17.37h365.585c11.177 0 11.195-17.37 0-17.37H117.801z",
    fill: "#FFDA44"
  }));
}, H$ = function(t) {
  var n = t.title, r = B(t, qB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M256 256 0 90.691v44.242L155.826 256 0 377.067v44.242z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 90.691v330.618L189.217 256z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m44.184 213.36 24.912 23.577 30.121-16.41-14.723 30.98 24.911 23.575-34.012-4.43L60.67 301.63l-6.296-33.716-34.012-4.43 30.119-16.408z"
  }));
}, O$ = function(t) {
  var n = t.title, r = B(t, XB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M357.208 183.679c8.397-23.404-1.036-48.858-21.281-61.536a52.131 52.131 0 0 1 10.884 2.621c27.002 9.688 41.038 39.428 31.35 66.431s-39.428 41.038-66.431 31.35a52.182 52.182 0 0 1-10.069-4.895c23.686 3.084 47.15-10.566 55.547-33.971zm-46.571-67.95-7.297 9.427-11.22-4.026 6.712 9.852-7.296 9.427 11.443-3.338 6.712 9.852.361-11.914 11.444-3.339-11.221-4.025z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m330.338 146.448-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.443-3.339 6.712 9.853.36-11.915 11.445-3.34-11.221-4.024zM275.9 126.916l-7.296 9.427-11.219-4.024 6.711 9.851-7.296 9.426 11.443-3.338 6.712 9.852.361-11.915 11.444-3.337-11.221-4.027zm-.799 35.189-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.444-3.338 6.711 9.852.362-11.915 11.443-3.338-11.22-4.026zm33.484 12.013-7.296 9.427-11.22-4.026 6.712 9.853-7.297 9.426 11.444-3.338 6.712 9.852.36-11.915 11.443-3.338-11.219-4.025z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M83.478 85.337h89.043v341.326H83.478z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m117.458 175.191-14.908-11.105v-15.705l14.908-11.105h21.084l14.908 11.105v15.705l-14.908 11.105z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M128 137.276h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.105v-8.012H128z",
    fill: "#FF9811"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m117.458 374.725-14.908-11.106v-15.704l14.908-11.105h21.084l14.908 11.105v15.704l-14.908 11.106z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M128 336.81h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.106v-8.011H128z",
    fill: "#FF9811"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m117.458 274.957-14.908-11.105v-15.703l14.908-11.106h21.084l14.908 11.106v15.703l-14.908 11.105zm36.513 24.434h-6.493v-6.493h-11.411l-8.068-8.068-8.067 8.068h-11.41v6.493h-6.493v12.986h6.493v6.492h11.41l8.068 8.069 8.068-8.069h11.41v-6.492h6.493zm0-99.768h-6.493v-6.492h-11.411l-8.068-8.069-8.067 8.069h-11.41v6.492h-6.493v12.986h6.493v6.492h11.41l8.068 8.07 8.068-8.07h11.41v-6.492h6.493z",
    fill: "#496E2D"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M120.576 248.576h14.84v14.84h-14.84z"
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 128,
    cy: 206.113,
    r: 7.421
  }), /* @__PURE__ */ o.createElement("circle", {
    cx: 128,
    cy: 305.887,
    r: 7.421
  })));
}, N$ = function(t) {
  var n = t.title, r = B(t, JB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 256,
    cy: 255.994,
    r: 96
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "m267.826 219.291 16.47 22.695 26.673-8.649-16.496 22.676 16.468 22.695-26.664-8.681-16.495 22.676.017-28.04-26.664-8.682 26.674-8.648z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M277.818 312.724c-31.33 0-56.727-25.397-56.727-56.727s25.397-56.727 56.727-56.727c9.769 0 18.96 2.47 26.985 6.819-12.589-12.31-29.804-19.909-48.803-19.909-38.558 0-69.818 31.259-69.818 69.818s31.26 69.818 69.818 69.818c18.999 0 36.215-7.599 48.803-19.909-8.026 4.347-17.216 6.817-26.985 6.817z"
  })));
}, B$ = function(t) {
  var n = t.title, r = B(t, QB);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h256v170.663H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M141.357 157.303V130.59h-26.714v26.713H87.93v26.713h26.713v26.713h26.714v-26.713h26.713v-26.713z"
  }));
}, I$ = function(t) {
  var n = t.title, r = B(t, eI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#E30A17",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M259.7 118.6c-13.1-9.5-29-14.6-45.3-14.5-40.8 0-73.8 30.8-73.8 68.9s33.1 68.9 73.8 68.9c17.1 0 32.9-5.4 45.3-14.5-30 38.6-85.7 45.6-124.3 15.5s-45.6-85.7-15.5-124.3 85.7-45.6 124.3-15.5c5.8 4.5 11 9.8 15.5 15.5zm39.9 65.8-18.1 21.9 1.2-28.4-26.4-10.4 27.3-7.6 1.8-28.3 15.6 23.7 27.5-7.1-17.5 22 15.3 23.9-26.7-9.7z"
  }));
}, T$ = function(t) {
  var n = t.title, r = B(t, tI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m6.066 85.337 207.961 212.636 131.584 128.69h160.323L297.973 214.027 166.389 85.337z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M43.364 85.337 384.69 426.663h83.946L127.31 85.337z"
  }));
}, V$ = function(t) {
  var n = t.title, r = B(t, nI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h900v600H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00B2EE",
    d: "M0 300h450V0h450v600H0V300z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m345.3 480.9 29.4 90.6-77.1-56H393l-77.1 56 29.4-90.6zM706.4 340l29.4 90.6-77.1-56H754l-77.1 56 29.5-90.6zm106.4-78.5 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm0-224.1 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M449.9 0v206.3h-81l81 54V300h-39.7l-129-85.9V300H168.7v-85.9L39.7 300H0v-39.7l81-54H0V93.8h81L0 39.9V0h39.7l129 85.9V0h112.5v85.9L410.2 0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M253.1 0h-56.3v122H0v56.2h196.8V300h56.3V178.2h196.8V122H253.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M449.9 39.9v53.9h-81z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 300v-19.3l109.9-74.4h39.7L12.8 300zM12.8.1l136.8 93.7h-39.7L0 19.4V.1zm437.1.1v19.3L340 93.8h-39.7L437.1.2zM437.1 300l-136.8-93.7H340l109.9 74.4V300z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m719.9 131.6 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM584 187.7l29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm30 242.9 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM488 332l29.4 90.6-77.1-56h95.3l-77.1 56L488 332zm0 132 29.4 90.6-77.1-56h95.3l-77.1 56L488 464z"
  }));
}, Z$ = function(t) {
  var n = t.title, r = B(t, rI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h256V256H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M186.435 170.669 162.558 181.9l12.714 23.125-25.927-4.961-3.286 26.192L128 206.993l-18.06 19.263-3.285-26.192-25.927 4.96 12.714-23.125-23.877-11.23 23.877-11.231-12.714-23.125 25.927 4.96 3.286-26.192L128 134.344l18.06-19.263 3.285 26.192 25.928-4.96-12.715 23.125z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#0052B4",
    cx: 128,
    cy: 170.674,
    r: 29.006
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M128 190.06c-10.692 0-19.391-8.7-19.391-19.391 0-10.692 8.7-19.391 19.391-19.391 10.692 0 19.391 8.7 19.391 19.391 0 10.691-8.699 19.391-19.391 19.391z"
  }));
}, $$ = function(t) {
  var n = t.title, r = B(t, iI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 426.663V85.337h512"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
  }));
}, W$ = function(t) {
  var n = t.title, r = B(t, lI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512V256H0z"
  }));
}, G$ = function(t) {
  var n = t.title, r = B(t, oI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#232323",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 56.9h512v56.9H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D32300",
    d: "M0 113.8h512v56.9H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 227.6h512v56.9H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D32300",
    d: "M0 284.4h512v56.9H0z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FFF",
    cx: 256,
    cy: 170.7,
    r: 80.7
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M234.5 127.5c.9-1.4-19.6-2-19.6-2 1.7-2.5 18.4-10.5 18.4-10.5s-.9-6 2.7-9.8l-4.5-9.8s7-3.4 18.4-3.4 19.9 7 21 13.1l-6.4 3.4c-.1 4.7 1.7 11.6-4.3 17.3-5.9 5.7-8.3 6.9-8.5 18.8 0 3.9 2.3 8.2 8.8 11.7 17.4 9.3 38.6 28.2 44.6 33.9 6.1 5.7 5.1 19.2 2.6 25.2s-12.1 14.3-14.3 13.6c-2.2-.6 1.2-9.2-3.5-11.6 0 0-8.9-7.6-16.8.6s-.2 25.2 3.9 28c4.1 2.8 1.7 5-1.9 5H247c-3.8 0-5.4-2.3-1.9-5 7.6-3.8 12.4-15.3 7.4-20.3-4.9-4.9-18.3 1.5-21.5 6.3-2.8 2.8-8.8 3.6-12.9-1.4s-4.1-10.4-1.1-12.5c7-4.8 0 0 .1-.1 0 0 11.9-8.6 29.9-9 3.9 0 4.8-2.2 2.2-4.8 0 0-30.9-27.4-28.1-44.2 3-18.3 20-26.3 13.4-32.5-1.3-1.8 0 0 0 0z"
  }));
}, U$ = function(t) {
  var n = t.title, r = B(t, aI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h256.5v184.1H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
    fill: "#FFF"
  }));
}, j$ = function(t) {
  var n = t.title, r = B(t, sI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h256.5v184.1H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
    fill: "#FFF"
  }));
}, K$ = function(t) {
  var n = t.title, r = B(t, cI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 38h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z",
    fill: "#0038a8"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h256.5v190H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FED443",
    d: "m128.3 138.7-15.1 22.6-3.8-26.9L86 148.2l8.2-25.9-27.2 2.2 18.6-19.8L60.3 95l25.4-9.7L67 65.5l27.1 2.3-8.2-25.9 23.4 13.8 3.9-26.9 15.1 22.6 15.1-22.6 3.8 26.9 23.4-13.8-8.2 25.9 27.1-2.2-18.6 19.8 25.4 9.7-25.4 9.7 18.6 19.8-27.1-2.2 8.2 25.9-23.4-13.8-3.9 26.9-15-22.7zm0-.5c23.9.9 44-17.6 44.9-41.5.9-23.9-17.6-44-41.5-44.9h-3.4c-23.9.8-42.6 20.8-41.8 44.6.6 22.8 19 41.1 41.8 41.8zm0-10.6c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.3 34-34 34z"
  }));
}, Y$ = function(t) {
  var n = t.title, r = B(t, dI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M0 322.783h512v103.88H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v104.515H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 210.877h512v89.656H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v104.515H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M188.688 137.589c0-15.984 11.234-29.339 26.236-32.614a33.531 33.531 0 0 0-7.155-.777c-18.442 0-33.391 14.949-33.391 33.391s14.949 33.391 33.391 33.391c2.458 0 4.85-.273 7.155-.777-15.002-3.275-26.236-16.63-26.236-32.614zm45.97 15.177 2.261 6.957h7.315l-5.918 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.261-6.956-5.918-4.301h7.315zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm23.347 0 2.26 6.957h7.315l-5.917 4.301 2.26 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.918-4.301h7.315zm23.347 0 2.262 6.957h7.315l-5.919 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.262-6.956-5.919-4.301h7.314zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm-70.042-24.284 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm23.347 0 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.299-5.918 4.299 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm-46.695-24.284 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.3-5.918 4.3 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.917-4.3h7.314z",
    fill: "#FFF"
  }));
}, q$ = function(t) {
  var n = t.title, r = B(t, uI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 85.331h256v341.337H256z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ACABB1",
    d: "m321.353 233.837 32.073 42.43c-5.053 7.651-5.026 17.961.817 25.692 7.414 9.807 21.374 11.748 31.182 4.335 9.807-7.414 11.748-21.374 4.334-31.182-5.843-7.731-15.756-10.568-24.495-7.795l-49.988-66.129-11.838 8.949-17.759 13.424 17.899 23.677 17.775-13.401zm46.175 48.78a7.421 7.421 0 1 1 8.95 11.84 7.421 7.421 0 0 1-8.95-11.84z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m376.367 247.24 17.899-23.677-17.759-13.424-11.838-8.949-49.988 66.129c-8.74-2.775-18.651.063-24.495 7.795-7.414 9.808-5.473 23.768 4.334 31.182 9.808 7.414 23.768 5.473 31.182-4.335 5.845-7.731 5.871-18.041.817-25.692l32.073-42.43 17.775 13.401zm-62.504 45.771a7.42 7.42 0 1 1-11.84-8.95 7.42 7.42 0 0 1 11.84 8.95z"
  }));
}, X$ = function(t) {
  var n = t.title, r = B(t, fI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M341.337 85.331H512v341.337H341.337zM214.261 283.82l-33.393-50.086 33.392-50.087 33.392 50.087zm83.478 0-33.391-50.086 33.391-50.087 33.393 50.087zM256 350.603l-33.391-50.087L256 250.429l33.391 50.087z",
    fill: "#6DA544"
  }));
}, J$ = function(t) {
  var n = t.title, r = B(t, hI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFCE00",
    d: "M0 0h22.5v5H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#203899",
    d: "M0 5h22.5v5H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D82B2B",
    d: "M0 10h22.5v5H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "m12.13 5.38.14.46.45.14-.39.27.01.48-.38-.29-.45.15.15-.44-.28-.38h.47zm-1.77 0 .27.39h.47l-.28.38.15.45-.45-.16-.38.28.01-.47-.39-.28.45-.13zm3.44.56-.01.48.39.27-.46.14-.14.45-.27-.38h-.48l.29-.38-.15-.45.45.16zm-5.11.02.4.27.44-.18-.13.46.3.36-.47.02-.26.4-.16-.44-.46-.12.37-.3zm6.55 1.17-.2.44.25.4-.47-.05-.31.36-.1-.46-.43-.18.41-.24.03-.47.35.31zm.19 1.12.21.43.47.07-.34.33.08.46-.42-.22-.42.22.08-.46-.34-.33.47-.07zM7 8.2l.21.43.47.06-.34.33.08.47L7 9.27l-.42.22.08-.47-.34-.33.47-.06zm.31-1.15.45.14.38-.29v.48l.39.26-.45.15-.13.46-.28-.38-.47.01.27-.38z"
  }));
}, Q$ = function(t) {
  var n = t.title, r = B(t, pI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M256 85.334V202.66h-46.069L256 233.38v22.617h-22.628L160 207.078v48.919H96v-48.919l-73.372 48.919H0V233.38l46.069-30.72H0v-64h46.069L0 107.951V85.334h22.628L96 134.241V85.334h64v48.907l73.372-48.907z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 107.951v30.712h-46.069z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#2E52B2",
    d: "M256 107.951v30.712h-46.069z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 255.997v-15.082l57.377-38.252H80zm256 0v-15.082l-57.377-38.252H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m384 259.706-46.129 46.129c8.645 16.675 26.051 28.074 46.129 28.074s37.484-11.4 46.129-28.074L384 259.706z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M332.058 178.084v81.624c.001 39.759 51.942 51.941 51.942 51.941s51.941-12.182 51.942-51.942v-81.623H332.058z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M372.87 215.181h22.261v59.359H372.87z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#A2001D",
    cx: 384,
    cy: 215.181,
    r: 11.13
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M346.902 192.92h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84zm59.359-66.783h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84z",
    fill: "#FFDA44"
  }));
}, eW = function(t) {
  var n = t.title, r = B(t, mI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1583C4",
    d: "m397.7 166.3-51 97.7c-1.1 2-.3 4.5 1.8 5.6 2 1.1 4.5.3 5.6-1.8l51-97.7c1-2.1.1-4.6-2-5.5-2-.9-4.3-.2-5.4 1.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1583C4",
    d: "m404.9 188-57.8 75.4c-1.3 1.9-.8 4.5 1.1 5.8 1.7 1.2 4.1.9 5.5-.7l57.8-75.4c1.4-1.8 1.1-4.4-.8-5.8-1.8-1.5-4.4-1.1-5.8.7z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1583C4",
    d: "m379 181.3-32.5 83.1c-.8 2.1.2 4.6 2.4 5.4 2.1.8 4.6-.2 5.4-2.4l32.5-83.1c.7-2.2-.4-4.5-2.6-5.3-2.1-.6-4.3.4-5.2 2.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#409347",
    d: "M122.1 171.9c.4 1.7 1.2 4.7 2.2 8.5 1.7 6.4 3.6 12.8 5.6 18.7 2.3 6.9 14.7 31.4 20.2 39.1 6.9 9.7 14.1 19.3 21.5 28.6 1.6 1.9 4.5 2.1 6.4.5 1.8-1.6 2.1-4.3.7-6.2-7.3-9.2-14.4-18.6-21.2-28.2-4.2-5.8-17.2-31.1-19-36.7-2.9-8.7-5.4-17.6-7.6-26.5-.5-2.4-2.9-4-5.3-3.5s-4 2.9-3.5 5.3c-.1.2 0 .3 0 .4z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFD836",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M297.1 114.9S279.5 42.8 261 42.8c-6.9 0-11.9-.6-15.4 6.4-.9 1.7-20.7-1.6-19.1 20.8.5 6.9 1.1-9.8 14.9-3.4 6.3 3-16.4 48.2-16.4 48.2h72.1z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m466.1 48.4-90.9 22c-75.3 18.3-42.1 44.4-42.1 44.4l-72.1 12-72.1-12s33.2-26.1-42.1-44.4l-90.9-22C43.1 45.3 38.1 51.8 45.3 63c0 0 106.6 104 126.8 112 20.2 8.1 40.8 0 40.8 0s-14.9 8.7-24 24c-9.2 15.3-4.6 34.7-38.9 40.2-5.5 6.6-5 14 2.9 19.9 7.9 5.8 72.1-48.1 72.1-48.1s-24 24.4-24 36.1c0 5.1 44.1 53.8 60.1 53.8s60.1-48.7 60.1-53.8c0-11.7-24-36.1-24-36.1s64.2 53.9 72.1 48.1 11.4-19.3 2.8-19.9c-28-1.8-29.7-24.9-38.9-40.2-9.2-15.3-24-24-24-24s20.6 8.1 40.8 0S476.7 63 476.7 63c7.2-11.2 2.3-17.7-10.6-14.6z"
  })), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M201.3 111.8v80.3c0 45.7 59.7 59.7 59.7 59.7s59.7-14 59.7-59.7v-80.3H201.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M225.2 137.7V235c8.2 6 17 10.2 23.9 12.9V137.7h-23.9zm71.6 0V235c-8.2 6-17 10.2-23.9 12.9V137.7h23.9z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M201.3 111.8h119.4v37.9H201.3z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#1583C4",
    d: "m60.1 210.5-21.9-58.1H15.7l31.8 80.8h25.2l31.5-80.8H81.7zm391.4-58.6h18.9v81.7h-18.9z"
  }));
}, tW = function(t) {
  var n = t.title, r = B(t, vI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M196.641 85.337H0v341.326h512V85.337z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m256 157.279 22.663 69.747H352l-59.332 43.106 22.664 69.749L256 296.774l-59.332 43.107 22.664-69.749L160 227.026h73.337z"
  }));
}, nW = function(t) {
  var n = t.title, r = B(t, gI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#6DA544",
    d: "M512 256v170.663H0L215.185 256z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337V256H215.185L0 85.337z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M221.001 239.304 26.868 85.337H8.956l208.168 165.098H512v-11.131zM8.956 426.663h17.912l194.133-153.967H512v-11.131H217.124zM0 92.44v14.206L188.317 256 0 405.354v14.205L206.229 256z"
  }), /* @__PURE__ */ o.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M8.956 85.337H0v7.103L206.229 256 0 419.559v7.104h8.956l208.168-165.098H512v-11.13H217.124z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M63.718 292.382v-14.295c14.265 0 25.87-11.606 25.87-25.869 0-10.092-8.211-18.303-18.304-18.303-6.875 0-12.469 5.593-12.469 12.469 0 4.397 3.577 7.974 7.974 7.974a4.514 4.514 0 0 0 4.508-4.508h14.295c0 10.368-8.435 18.804-18.802 18.804-12.279-.002-22.269-9.993-22.269-22.271 0-14.758 12.006-26.764 26.764-26.764 17.975 0 32.599 14.623 32.599 32.599 0 22.145-18.018 40.164-40.166 40.164z"
  })));
}, rW = function(t) {
  var n = t.title, r = B(t, LI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80B30",
    d: "M0 0h150v100H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#00318A",
    d: "M0 0h20v44.33H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M20 0h20v44.33H20z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M0 44.33h62.75V0"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M108.08 43.29 87.96 23.17h40.25l-20.13 20.12zm-6.7 6.71L81.25 29.88v40.25L101.38 50zm6.7 6.71L87.96 76.83h40.25l-20.13-20.12zm6.71-6.71 20.13-20.13v40.25L114.79 50z"
  }));
}, iW = function(t) {
  var n = t.title, r = B(t, wI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h256v170.663H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m165.483 181.79 2.764 8.504h8.939l-7.232 5.254 2.763 8.503-7.234-5.255-7.233 5.255 2.763-8.503-7.233-5.254h8.94zm-44.904-66.783 4.606 14.173h14.9l-12.055 8.757 4.605 14.171-12.056-8.758-12.054 8.758 4.605-14.171-12.056-8.757h14.901zm44.522 14.841 4.606 14.172h14.9l-12.055 8.757 4.604 14.173-12.055-8.76-12.054 8.76 4.604-14.173-12.055-8.757h14.9zm-35.192 59.363 4.606 14.172h14.9l-12.055 8.758 4.604 14.171-12.055-8.759-12.054 8.759 4.604-14.171-12.055-8.758h14.9zm-39.01-37.103 4.605 14.173h14.9l-12.055 8.757 4.604 14.173-12.054-8.76-12.055 8.76 4.604-14.173-12.055-8.757h14.9z",
    fill: "#FFF"
  }));
}, lW = function(t) {
  var n = t.title, r = B(t, MI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.33"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.34H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "m220.72 42.63 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.36-15.9 8.36 3.03-17.7-12.86-12.54 17.78-2.58zm70.56-.06 7.95 16.1 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59zm62.08 11.36 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.87-12.54 17.78-2.58zm63.01 18.3 7.95 16.11 17.77 2.59-12.86 12.53 3.04 17.71-15.9-8.36-15.9 8.36 3.03-17.71-12.86-12.53 17.78-2.59zm-257.73-18.3 7.95 16.11 17.78 2.58-12.87 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.86-12.54 17.77-2.58zm-63.01 18.3 7.95 16.11 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59z",
    fill: "#FFF"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m217.53 259.33-27.22-13.61-27.22-54.43h27.22l27.22-27.22 13.61-27.22 27.22-13.61 13.61 13.61 27.22 13.61v13.61l13.61 13.61 40.83 27.22L340 245.73l-40.83 40.83-13.61-27.22-40.83 27.22v27.22l-13.61-13.61-13.59-40.84z"
  }));
}, oW = function(t) {
  var n = t.title, r = B(t, xI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 312.888h512v113.775H0z"
  }));
}, aW = function(t) {
  var n = t.title, r = B(t, bI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 0h90v60H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    stroke: "#7f7f7f",
    strokeWidth: 0.25,
    fill: "#ABABAB",
    d: "M75.6 39.6c-1.1.7 0 1.8-.6 1.9-.6.1-1.5-1.4-.2-2.5 1.6-1.5 5.8 0 5.9 4.3 0 2.2-.9 6.8-7.2 6.8-7.6 0-11.4-5.7-11.4-11.4 0-4.8 3.7-13.5 6.5-14.6 3.1-1.2 6.7-3.5 6.8-5 0-.5-1.4-.1-3.3.9-3.1 1.7-6.6 2.5-6.6 1.4s2.9-3.1 4-4.6c1.2-1.6.9-5.5 3-5.5 7.6 0 9.9 7.7 7 11.7-1.9 2.6 4.3 1 4.3 1s0 5.3-3.2 7.3c-3 1.8-4.8 3.9-4.8 3.9s.2-4.6-.5-3.9c-.6.7-11.1 4.5-10.3 12 .3 3 4.5 5.4 8.5 5.2s5.7-2.4 5.8-4.9c.1-3.9-3-4.4-3.7-4zm-64.9 4c.1 2.5 1.8 4.7 5.8 4.9s8.2-2.2 8.5-5.2c.8-7.5-9.7-11.3-10.3-12-.7-.7-.5 3.9-.5 3.9s-1.8-2.1-4.8-3.9c-3.2-2-3.2-7.3-3.2-7.3s6.2 1.6 4.3-1c-2.9-4-.6-11.7 7-11.7 2.1 0 1.8 3.9 3 5.5 1.1 1.5 4 3.5 4 4.6s-3.5.3-6.6-1.4c-1.9-1-3.3-1.4-3.3-.9.1 1.5 3.7 3.8 6.8 5 2.8 1.1 6.5 9.8 6.5 14.6 0 5.7-3.8 11.4-11.4 11.4-6.3 0-7.2-4.6-7.2-6.8.1-4.3 4.3-5.8 5.9-4.3 1.2 1.1.4 2.7-.2 2.5-.6-.1.6-1.2-.6-1.9-.6-.4-3.7.1-3.7 4z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#DE393A",
    d: "M31 28.8v14c0 1.9 2.1 1.6 2.1 1.6h9.3c1.2 0 2.6 2.3 2.6 2.3s1.4-2.3 2.5-2.3h9.6s2 .2 2-1.8V28.7H31z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#3951A3",
    d: "M31 13.1h28v15.7H31z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M50.1 16.5c-.4 2.4-2.5 4.2-5.1 4.2-2.5 0-4.6-1.8-5.1-4.2-.5.9-.8 1.9-.8 3 0 3.3 2.6 5.9 5.9 5.9 3.3 0 5.9-2.6 5.9-5.9 0-1.1-.3-2.1-.8-3z"
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FEE05F",
    cx: 39.1,
    cy: 36.5,
    r: 3
  }), /* @__PURE__ */ o.createElement("circle", {
    fill: "#FEE05F",
    cx: 50.9,
    cy: 36.5,
    r: 3
  }));
}, sW = function(t) {
  var n = t.title, r = B(t, yI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M114.024 256.001 0 141.926v228.17z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#ffb915",
    d: "M161.192 256 0 94.7v47.226l114.024 114.075L0 370.096v47.138z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#007847",
    d: "M509.833 289.391c.058-.44.804-.878 2.167-1.318v-65.464H222.602L85.33 85.337H0V94.7L161.192 256 0 417.234v9.429h85.33l137.272-137.272h287.231z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#000c8a",
    d: "M503.181 322.783H236.433l-103.881 103.88H512v-103.88z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#e1392d",
    d: "M503.181 189.217H512V85.337H132.552l103.881 103.88z"
  }));
}, cW = function(t) {
  var n = t.title, r = B(t, CI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF9811",
    d: "M490.668 195.476h-48c0-8.836-7.164-16-16-16s-16 7.164-16 16h-48c0 8.836 7.697 16 16.533 16h-.533c0 8.836 7.162 16 16 16 0 8.836 7.162 16 16 16h32c8.836 0 16-7.164 16-16 8.836 0 16-7.164 16-16h-.533c8.837 0 16.533-7.164 16.533-16z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "M341.337 255.994h56.888v170.663h-56.888z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FF9811",
    d: "M455.112 255.994H512v170.663h-56.888z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M398.225 255.994h56.888v170.663h-56.888z"
  }));
}, dW = function(t) {
  var n = t.title, r = B(t, EI);
  return /* @__PURE__ */ o.createElement("svg", N({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), n && /* @__PURE__ */ o.createElement("title", null, n), /* @__PURE__ */ o.createElement("path", {
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 134.196h512v48.868H0zm0 195.472h512v48.868H0z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#057f44",
    d: "M0 85.333h512v48.868H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M0 183.069h512v48.868H0zm0 97.737h512v48.868H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#057f44",
    d: "M0 378.542h512v48.128H0z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFF",
    d: "M276.992 255.996 106.329 426.659H0V85.333h106.329z"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M256 255.996 85.334 426.662h20.987l170.667-170.666L106.321 85.33H85.334z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#D80027",
    d: "m102.465 202.57 13.259 40.812h42.917l-34.718 25.226 13.26 40.814-34.718-25.224-34.72 25.224 13.262-40.814-34.718-25.226h42.915z"
  }), /* @__PURE__ */ o.createElement("path", {
    fill: "#FFDA44",
    d: "m138.94 259.335-34.559-12.243s-2.553-23.955-2.708-24.766c-1.173-6.18-6.603-10.851-13.123-10.851-7.376 0-13.357 5.98-13.357 13.357 0 1.223.178 2.402.486 3.528l-9.689 9.755h17.229c0 17.882-13.344 17.882-13.344 35.691l7.402 17.809h44.522l7.422-17.809h-.004a17.782 17.782 0 0 0 1.381-5.231c6.397-2.589 8.342-9.24 8.342-9.24z"
  }));
};
const pf = {
  AC: zI,
  AD: AI,
  AE: SI,
  AF: kI,
  AG: DI,
  AI: RI,
  AL: _I,
  AM: PI,
  AO: HI,
  AQ: OI,
  AR: NI,
  AS: BI,
  AT: II,
  AU: TI,
  AW: VI,
  AX: ZI,
  AZ: $I,
  BA: WI,
  BB: GI,
  BD: UI,
  BE: jI,
  BF: KI,
  BG: YI,
  BH: qI,
  BI: XI,
  BJ: JI,
  BL: QI,
  BM: eT,
  BN: tT,
  BO: nT,
  BQ: rT,
  BR: iT,
  BS: lT,
  BT: oT,
  BV: aT,
  BW: sT,
  BY: cT,
  BZ: dT,
  CA: uT,
  CC: fT,
  CD: hT,
  CF: pT,
  CG: mT,
  CH: vT,
  CI: gT,
  CK: LT,
  CL: wT,
  CM: MT,
  CN: xT,
  CO: bT,
  CR: yT,
  CU: CT,
  CV: ET,
  CW: FT,
  CX: zT,
  CY: AT,
  CZ: ST,
  DE: kT,
  DJ: DT,
  DK: RT,
  DM: _T,
  DO: PT,
  DZ: HT,
  EC: OT,
  EE: NT,
  EG: BT,
  EH: IT,
  ER: TT,
  ES: VT,
  ET: ZT,
  EU: $T,
  FI: WT,
  FJ: GT,
  FK: UT,
  FM: jT,
  FO: KT,
  FR: YT,
  GA: qT,
  GB: XT,
  GD: JT,
  GE: QT,
  GF: eV,
  GG: tV,
  GH: nV,
  GI: rV,
  GL: iV,
  GM: lV,
  GN: oV,
  GP: aV,
  GQ: sV,
  GR: cV,
  GS: dV,
  GT: uV,
  GU: fV,
  GW: hV,
  GY: pV,
  HK: mV,
  HM: vV,
  HN: gV,
  HR: LV,
  HT: wV,
  HU: MV,
  IC: xV,
  ID: bV,
  IE: yV,
  IL: CV,
  IM: EV,
  IN: FV,
  IO: zV,
  IQ: AV,
  IR: SV,
  IS: kV,
  IT: DV,
  JE: RV,
  JM: _V,
  JO: PV,
  JP: HV,
  KE: OV,
  KG: NV,
  KH: BV,
  KI: IV,
  KM: TV,
  KN: VV,
  KP: ZV,
  KR: $V,
  KW: WV,
  KY: GV,
  KZ: UV,
  LA: jV,
  LB: KV,
  LC: YV,
  LI: qV,
  LK: XV,
  LR: JV,
  LS: QV,
  LT: eZ,
  LU: tZ,
  LV: nZ,
  LY: rZ,
  MA: iZ,
  MC: lZ,
  MD: oZ,
  ME: aZ,
  MF: sZ,
  MG: cZ,
  MH: dZ,
  MK: uZ,
  ML: fZ,
  MM: hZ,
  MN: pZ,
  MO: mZ,
  MP: vZ,
  MQ: gZ,
  MR: LZ,
  MS: wZ,
  MT: MZ,
  MU: xZ,
  MV: bZ,
  MW: yZ,
  MX: CZ,
  MY: EZ,
  MZ: FZ,
  NA: zZ,
  NC: AZ,
  NE: SZ,
  NF: kZ,
  NG: DZ,
  NI: RZ,
  NL: _Z,
  NO: PZ,
  NP: HZ,
  NR: OZ,
  NU: NZ,
  NZ: BZ,
  OM: IZ,
  PA: TZ,
  PE: VZ,
  PF: ZZ,
  PG: $Z,
  PH: WZ,
  PK: GZ,
  PL: UZ,
  PM: jZ,
  PN: KZ,
  PR: YZ,
  PS: qZ,
  PT: XZ,
  PW: JZ,
  PY: QZ,
  QA: e$,
  RE: t$,
  RO: n$,
  RS: r$,
  RU: i$,
  RW: l$,
  SA: o$,
  SB: a$,
  SC: s$,
  SD: c$,
  SE: d$,
  SG: u$,
  SH: f$,
  SI: h$,
  SJ: p$,
  SK: m$,
  SL: v$,
  SM: g$,
  SN: L$,
  SO: w$,
  SR: M$,
  SS: x$,
  ST: b$,
  SV: y$,
  SX: C$,
  SY: E$,
  SZ: F$,
  TA: z$,
  TC: A$,
  TD: S$,
  TF: k$,
  TG: D$,
  TH: R$,
  TJ: _$,
  TK: P$,
  TL: H$,
  TM: O$,
  TN: N$,
  TO: B$,
  TR: I$,
  TT: T$,
  TV: V$,
  TW: Z$,
  TZ: $$,
  UA: W$,
  UG: G$,
  UM: U$,
  US: j$,
  UY: K$,
  UZ: Y$,
  VA: q$,
  VC: X$,
  VE: J$,
  VG: Q$,
  VI: eW,
  VN: tW,
  VU: nW,
  WF: rW,
  WS: iW,
  XK: lW,
  YE: oW,
  YT: aW,
  ZA: sW,
  ZM: cW,
  ZW: dW
}, pX = (e) => Object.keys(pf).includes(e), Mi = ({ country: e, ...t }) => {
  const n = pf[e];
  return /* @__PURE__ */ u("div", { className: "inline-flex shrink-0", children: /* @__PURE__ */ u("div", { className: S("inline-flex h-3 overflow-hidden rounded-xs border border-neutral-200"), children: /* @__PURE__ */ u(n, {}) }) });
};
Mi.displayName = "Flag";
const mf = O2({}), uW = Ye("grid gap-4", {
  variants: {
    col: {
      1: "grid-cols-1",
      2: "grid-cols-2",
      3: "grid-cols-3",
      4: "grid-cols-4",
      5: "grid-cols-5",
      6: "grid-cols-6",
      7: "grid-cols-7",
      8: "grid-cols-8",
      9: "grid-cols-9",
      10: "grid-cols-10",
      11: "grid-cols-11",
      12: "grid-cols-12",
      subgrid: "grid-cols-subgrid"
    },
    gap: {
      0: "gap-0",
      2: "gap-2",
      4: "gap-4",
      8: "gap-8",
      12: "gap-12",
      16: "gap-16",
      24: "gap-24"
    },
    breakpoint: {
      sm: "max-sm:grid-cols-1",
      md: "max-md:grid-cols-1",
      lg: "max-lg:grid-cols-1",
      xl: "max-xl:grid-cols-1"
    }
  },
  defaultVariants: {
    col: 1,
    gap: 4
  }
}), fW = Ye("", {
  variants: {
    span: {
      1: "col-span-1",
      2: "col-span-2",
      3: "col-span-3",
      4: "col-span-4",
      5: "col-span-5",
      6: "col-span-6",
      7: "col-span-7",
      8: "col-span-8",
      9: "col-span-9",
      10: "col-span-10",
      11: "col-span-11",
      12: "col-span-12",
      full: "col-span-full"
    },
    breakpoint: {
      sm: "max-sm:col-span-1",
      md: "max-md:col-span-1",
      lg: "max-lg:col-span-1",
      xl: "max-xl:col-span-1"
    }
  },
  defaultVariants: {
    span: 1
  }
}), hW = ({ children: e, col: t, gap: n, breakpoint: r, ...i }) => /* @__PURE__ */ u("div", { className: S(uW({ col: t, gap: n, breakpoint: r })), ...i, children: /* @__PURE__ */ u(
  mf.Provider,
  {
    value: {
      breakpoint: r ?? void 0
    },
    children: e
  }
) });
hW.displayName = "Grid";
const pW = ({ span: e, children: t, ...n }) => {
  const { breakpoint: r } = pt(mf);
  return /* @__PURE__ */ u("div", { className: S(fW({ span: e, breakpoint: r })), ...n, children: t });
};
pW.displayName = "GridItem";
const V3 = W(
  ({ icon: e, label: t, size: n = "sm", color: r = "default", ...i }, a) => /* @__PURE__ */ u(
    "button",
    {
      type: "button",
      ref: a,
      className: S(
        "flex w-fit shrink-0 grow-0 transition-all duration-500",
        "focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-hidden",
        "hover:opacity-80",
        "disabled:cursor-not-allowed disabled:opacity-50"
      ),
      ...i,
      "aria-label": t,
      onClick: i.onClick,
      children: /* @__PURE__ */ u(Re, { name: e, size: n, color: r })
    }
  )
);
V3.displayName = "IconButton";
const mW = ({ value: e, children: t, ...n }) => /* @__PURE__ */ V("div", { className: S("relative w-fit"), ...n, children: [
  e ? /* @__PURE__ */ u(
    "span",
    {
      className: S(
        "translate bg-indicator-background text-indicator-text pointer-events-none absolute -top-1 -right-1 z-20 flex items-center justify-center rounded-full text-[9px] select-none",
        {
          "h-2 min-w-2": typeof e == "boolean",
          "h-3.5 min-w-3.5 px-1": typeof e != "boolean"
        }
      ),
      children: e
    }
  ) : null,
  t
] });
mW.displayName = "Indicator";
const vf = ({ children: e, ...t }) => /* @__PURE__ */ u(
  "kbd",
  {
    className: S(
      "bg-keyboard-background text-keyboard-text pointer-events-none rounded-md px-2 py-1 font-mono text-xs select-none"
    ),
    ...t,
    children: e
  }
);
vf.displayName = "Keyboard";
const vW = Ye("flex", {
  variants: {
    /**
     * Size of the label-value
     */
    size: {
      xs: "text-xs",
      sm: "text-sm"
    },
    /**
     * The orientation of the label and value
     */
    orientation: {
      horizontal: "flex-row gap-4 items-center",
      vertical: "flex-col gap-2"
    }
  },
  defaultVariants: {
    size: "sm",
    orientation: "vertical"
  }
}), d2 = ({
  prefix: e,
  size: t = "sm",
  orientation: n = "vertical",
  label: r,
  value: i,
  truncate: a,
  placeholder: c,
  ...d
}) => {
  const f = !i && !r && c, p = f ? c : "";
  return /* @__PURE__ */ u("div", { ...d, children: /* @__PURE__ */ V("div", { className: S("flex items-center gap-8"), children: [
    e ? /* @__PURE__ */ u("div", { className: S("flex"), children: e }) : null,
    /* @__PURE__ */ V(
      "div",
      {
        className: S(vW({ size: t, orientation: n }), {
          "gap-0": f
        }),
        children: [
          /* @__PURE__ */ u("div", { className: S("text-labelvalue-label"), children: r }),
          /* @__PURE__ */ u(
            "div",
            {
              className: S("text-labelvalue", {
                "max-w-32 truncate [&_*]:truncate": a
              }),
              children: i || p
            }
          )
        ]
      }
    )
  ] }) });
};
d2.displayName = "LabelValue";
const gW = Ye(
  "cursor-pointer text-start  hover:underline focus-visible:ring-ring focus-visible:outline-hidden focus-visible:ring-2",
  {
    variants: {
      variant: {
        default: "text-link-default-text decoration-link-hover-border hover:text-link-hover-text",
        negative: "text-link-negative-text decoration-link-negative-border hover:text-link-negative-text"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), gf = W(
  ({ as: e = "a", href: t, target: n, rel: r, onClick: i, children: a, asChild: c, variant: d = "default", ...f }, p) => /* @__PURE__ */ u(
    c ? Ei : e,
    {
      ...f,
      role: "link",
      className: S(gW({ variant: d })),
      href: t,
      target: n,
      rel: r,
      onClick: i,
      ref: p,
      children: a
    }
  )
);
gf.displayName = "Link";
const LW = Ye(S("flex flex-col"), {
  variants: {
    variant: {
      none: "list-none",
      unordered: "list-disc ml-4",
      ordered: "list-decimal ml-4"
    }
  },
  defaultVariants: {
    variant: "none"
  }
}), wW = ({ variant: e = "none", ...t }) => /* @__PURE__ */ u(e === "ordered" ? "ol" : "ul", { ...t, role: "list", className: S(LW({ variant: e })) });
wW.displayName = "List";
const MW = Ye(S("w-full flex items-center p-2 gap-8 group"), {
  variants: {
    variant: {
      default: "text-list-default-text",
      selected: "bg-list-selected-background text-list-selected-text",
      negative: "bg-list-negative-background text-list-negative-text"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), xW = Ye(S("flex", "group-hover:text-list-hover-icon"), {
  variants: {
    variant: {
      default: "text-list-default-icon",
      selected: "text-list-selected-icon",
      negative: "text-list-negative-icon"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), bW = W(
  ({ icon: e, variant: t = "default", href: n, target: r, rel: i, disabled: a, onClick: c, children: d, asChild: f, ...p }, m) => /* @__PURE__ */ u("li", { ref: m, children: /* @__PURE__ */ u(
    f ? Ei : !a && n ? "a" : !a && c ? "button" : "div",
    {
      ...p,
      className: S(
        MW({ variant: t }),
        "focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-hidden",
        {
          "hover:bg-list-hover-background hover:text-list-hover-text": !a && (c || n),
          "bg-list-disabled-background text-list-disabled-text cursor-not-allowed": a
        }
      ),
      href: a ? void 0 : n,
      target: r,
      rel: i,
      disabled: a,
      onClick: () => {
        a || c == null || c();
      },
      children: /* @__PURE__ */ V(me, { children: [
        e ? /* @__PURE__ */ u("span", { className: S(xW({ variant: t })), children: /* @__PURE__ */ u(Re, { name: e, size: "sm" }) }) : null,
        d
      ] })
    }
  ) })
);
bW.displayName = "ListItem";
function xi(e) {
  "@babel/helpers - typeof";
  return xi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xi(e);
}
function yW(e, t) {
  if (xi(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (xi(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function CW(e) {
  var t = yW(e, "string");
  return xi(t) == "symbol" ? t : t + "";
}
function le(e, t, n) {
  return (t = CW(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Lf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ia, _d;
function EW() {
  if (_d) return Ia;
  _d = 1;
  var e = process.env.NODE_ENV, t = function(r, i, a, c, d, f, p, m) {
    if (e !== "production" && i === void 0)
      throw new Error("invariant requires an error message argument");
    if (!r) {
      var v;
      if (i === void 0)
        v = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var g = [a, c, d, f, p, m], w = 0;
        v = new Error(i.replace(/%s/g, function() {
          return g[w++];
        })), v.name = "Invariant Violation";
      }
      throw v.framesToPop = 1, v;
    }
  };
  return Ia = t, Ia;
}
var FW = EW(), Dt = /* @__PURE__ */ Lf(FW), $e = O2(null);
function zW() {
  Dt(!!pt, "useGoogleMap is React hook and requires React version 16.8+");
  var e = pt($e);
  return Dt(!!e, "useGoogleMap needs a GoogleMap available up in the tree"), e;
}
function AW(e, t, n) {
  return Object.keys(e).reduce(function(i, a) {
    return t(i, e[a], a);
  }, n);
}
function SW(e, t) {
  Object.keys(e).forEach((n) => t(e[n], n));
}
function kW(e, t, n, r) {
  var i = {}, a = (c, d) => {
    var f = n[d];
    f !== t[d] && (i[d] = f, c(r, f));
  };
  return SW(e, a), i;
}
function DW(e, t, n) {
  var r = AW(n, function(a, c, d) {
    return typeof e[d] == "function" && a.push(google.maps.event.addListener(t, c, e[d])), a;
  }, []);
  return r;
}
function RW(e) {
  google.maps.event.removeListener(e);
}
function Je() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  e.forEach(RW);
}
function Ke(e) {
  var {
    updaterMap: t,
    eventMap: n,
    prevProps: r,
    nextProps: i,
    instance: a
  } = e, c = DW(i, a, n);
  return kW(t, r, i, a), c;
}
var Pd = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMapTypeIdChanged: "maptypeid_changed",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseDown: "mousedown",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onTilesLoaded: "tilesloaded",
  onBoundsChanged: "bounds_changed",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onHeadingChanged: "heading_changed",
  onIdle: "idle",
  onProjectionChanged: "projection_changed",
  onResize: "resize",
  onTiltChanged: "tilt_changed",
  onZoomChanged: "zoom_changed"
}, Hd = {
  extraMapTypes(e, t) {
    t.forEach(function(r, i) {
      e.mapTypes.set(String(i), r);
    });
  },
  center(e, t) {
    e.setCenter(t);
  },
  clickableIcons(e, t) {
    e.setClickableIcons(t);
  },
  heading(e, t) {
    e.setHeading(t);
  },
  mapTypeId(e, t) {
    e.setMapTypeId(t);
  },
  options(e, t) {
    e.setOptions(t);
  },
  streetView(e, t) {
    e.setStreetView(t);
  },
  tilt(e, t) {
    e.setTilt(t);
  },
  zoom(e, t) {
    e.setZoom(t);
  }
};
function _W(e) {
  var {
    children: t,
    options: n,
    id: r,
    mapContainerStyle: i,
    mapContainerClassName: a,
    center: c,
    // clickableIcons,
    // extraMapTypes,
    // heading,
    // mapTypeId,
    onClick: d,
    onDblClick: f,
    onDrag: p,
    onDragEnd: m,
    onDragStart: v,
    onMouseMove: g,
    onMouseOut: w,
    onMouseOver: x,
    onMouseDown: b,
    onMouseUp: y,
    onRightClick: E,
    // onMapTypeIdChanged,
    // onTilesLoaded,
    // onBoundsChanged,
    onCenterChanged: z,
    // onHeadingChanged,
    // onIdle,
    // onProjectionChanged,
    // onResize,
    // onTiltChanged,
    // onZoomChanged,
    onLoad: k,
    onUnmount: R
  } = e, [F, _] = q(null), P = It(null), [O, Z] = q(null), [te, Y] = q(null), [X, re] = q(null), [ee, de] = q(null), [ae, ge] = q(null), [K, J] = q(null), [he, ve] = q(null), [Q, ie] = q(null), [pe, U] = q(null), [Me, Le] = q(null), [xe, Ee] = q(null), [ye, Be] = q(null);
  return T(() => {
    n && F !== null && F.setOptions(n);
  }, [F, n]), T(() => {
    F !== null && typeof c < "u" && F.setCenter(c);
  }, [F, c]), T(() => {
    F && f && (te !== null && google.maps.event.removeListener(te), Y(google.maps.event.addListener(F, "dblclick", f)));
  }, [f]), T(() => {
    F && m && (X !== null && google.maps.event.removeListener(X), re(google.maps.event.addListener(F, "dragend", m)));
  }, [m]), T(() => {
    F && v && (ee !== null && google.maps.event.removeListener(ee), de(google.maps.event.addListener(F, "dragstart", v)));
  }, [v]), T(() => {
    F && b && (ae !== null && google.maps.event.removeListener(ae), ge(google.maps.event.addListener(F, "mousedown", b)));
  }, [b]), T(() => {
    F && g && (K !== null && google.maps.event.removeListener(K), J(google.maps.event.addListener(F, "mousemove", g)));
  }, [g]), T(() => {
    F && w && (he !== null && google.maps.event.removeListener(he), ve(google.maps.event.addListener(F, "mouseout", w)));
  }, [w]), T(() => {
    F && x && (Q !== null && google.maps.event.removeListener(Q), ie(google.maps.event.addListener(F, "mouseover", x)));
  }, [x]), T(() => {
    F && y && (pe !== null && google.maps.event.removeListener(pe), U(google.maps.event.addListener(F, "mouseup", y)));
  }, [y]), T(() => {
    F && E && (Me !== null && google.maps.event.removeListener(Me), Le(google.maps.event.addListener(F, "rightclick", E)));
  }, [E]), T(() => {
    F && d && (xe !== null && google.maps.event.removeListener(xe), Ee(google.maps.event.addListener(F, "click", d)));
  }, [d]), T(() => {
    F && p && (ye !== null && google.maps.event.removeListener(ye), Be(google.maps.event.addListener(F, "drag", p)));
  }, [p]), T(() => {
    F && z && (O !== null && google.maps.event.removeListener(O), Z(google.maps.event.addListener(F, "center_changed", z)));
  }, [d]), T(() => {
    var ft = P.current === null ? null : new google.maps.Map(P.current, n);
    return _(ft), ft !== null && k && k(ft), () => {
      ft !== null && R && R(ft);
    };
  }, []), u("div", {
    id: r,
    ref: P,
    style: i,
    className: a,
    children: u($e.Provider, {
      value: F,
      children: F !== null ? t : null
    })
  });
}
Rt(_W);
class PW extends gt {
  constructor() {
    super(...arguments), le(this, "state", {
      map: null
    }), le(this, "registeredEvents", []), le(this, "mapRef", null), le(this, "getInstance", () => this.mapRef === null ? null : new google.maps.Map(this.mapRef, this.props.options)), le(this, "panTo", (t) => {
      var n = this.getInstance();
      n && n.panTo(t);
    }), le(this, "setMapCallback", () => {
      this.state.map !== null && this.props.onLoad && this.props.onLoad(this.state.map);
    }), le(this, "getRef", (t) => {
      this.mapRef = t;
    });
  }
  componentDidMount() {
    var t = this.getInstance();
    this.registeredEvents = Ke({
      updaterMap: Hd,
      eventMap: Pd,
      prevProps: {},
      nextProps: this.props,
      instance: t
    }), this.setState(function() {
      return {
        map: t
      };
    }, this.setMapCallback);
  }
  componentDidUpdate(t) {
    this.state.map !== null && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: Hd,
      eventMap: Pd,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.map
    }));
  }
  componentWillUnmount() {
    this.state.map !== null && (this.props.onUnmount && this.props.onUnmount(this.state.map), Je(this.registeredEvents));
  }
  render() {
    return u("div", {
      id: this.props.id,
      ref: this.getRef,
      style: this.props.mapContainerStyle,
      className: this.props.mapContainerClassName,
      children: u($e.Provider, {
        value: this.state.map,
        children: this.state.map !== null ? this.props.children : null
      })
    });
  }
}
function Od(e, t, n, r, i, a, c) {
  try {
    var d = e[a](c), f = d.value;
  } catch (p) {
    return void n(p);
  }
  d.done ? t(f) : Promise.resolve(f).then(r, i);
}
function wf(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, i) {
      var a = e.apply(t, n);
      function c(f) {
        Od(a, r, i, c, d, "next", f);
      }
      function d(f) {
        Od(a, r, i, c, d, "throw", f);
      }
      c(void 0);
    });
  };
}
function Mf(e) {
  var {
    googleMapsApiKey: t,
    googleMapsClientId: n,
    version: r = "weekly",
    language: i,
    region: a,
    libraries: c,
    channel: d,
    mapIds: f,
    authReferrerPolicy: p,
    apiUrl: m = "https://maps.googleapis.com"
  } = e, v = [];
  return Dt(t && n || !(t && n), "You need to specify either googleMapsApiKey or googleMapsClientId for @react-google-maps/api load script to work. You cannot use both at the same time."), t ? v.push("key=".concat(t)) : n && v.push("client=".concat(n)), r && v.push("v=".concat(r)), i && v.push("language=".concat(i)), a && v.push("region=".concat(a)), c && c.length && v.push("libraries=".concat(c.sort().join(","))), d && v.push("channel=".concat(d)), f && f.length && v.push("map_ids=".concat(f.join(","))), p && v.push("auth_referrer_policy=".concat(p)), v.push("loading=async"), v.push("callback=initMap"), "".concat(m, "/maps/api/js?").concat(v.join("&"));
}
var ir = typeof document < "u";
function xf(e) {
  var {
    url: t,
    id: n,
    nonce: r
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } = e;
  return ir ? new Promise(function(a, c) {
    var d = document.getElementById(n), f = window;
    if (d) {
      var p = d.getAttribute("data-state");
      if (d.src === t && p !== "error") {
        if (p === "ready")
          return a(n);
        var m = f.initMap, v = d.onerror;
        f.initMap = function() {
          m && m(), a(n);
        }, d.onerror = function(w) {
          v && v(w), c(w);
        };
        return;
      } else
        d.remove();
    }
    var g = document.createElement("script");
    g.type = "text/javascript", g.src = t, g.id = n, g.async = !0, g.nonce = r || "", g.onerror = function(x) {
      g.setAttribute("data-state", "error"), c(x);
    }, f.initMap = function() {
      g.setAttribute("data-state", "ready"), a(n);
    }, document.head.appendChild(g);
  }).catch((i) => {
    throw console.error("injectScript error: ", i), i;
  }) : Promise.reject(new Error("document is undefined"));
}
function Nd(e) {
  var t = e.href;
  return t && (t.indexOf("https://fonts.googleapis.com/css?family=Roboto") === 0 || t.indexOf("https://fonts.googleapis.com/css?family=Google+Sans+Text") === 0) ? !0 : (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    e.tagName.toLowerCase() === "style" && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    e.styleSheet && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    e.styleSheet.cssText && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    e.styleSheet.cssText.replace(`\r
`, "").indexOf(".gm-style") === 0 ? (e.styleSheet.cssText = "", !0) : (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      e.tagName.toLowerCase() === "style" && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      e.innerHTML && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      e.innerHTML.replace(`\r
`, "").indexOf(".gm-style") === 0 ? (e.innerHTML = "", !0) : (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        e.tagName.toLowerCase() === "style" && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        !e.styleSheet && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        !e.innerHTML
      )
    )
  );
}
function Z3() {
  var e = document.getElementsByTagName("head")[0];
  if (e) {
    var t = e.insertBefore.bind(e);
    e.insertBefore = function(i, a) {
      return Nd(i) || Reflect.apply(t, e, [i, a]), i;
    };
    var n = e.appendChild.bind(e);
    e.appendChild = function(i) {
      return Nd(i) || Reflect.apply(n, e, [i]), i;
    };
  }
}
var ti = !1;
function bf() {
  return u("div", {
    children: "Loading..."
  });
}
var bi = {
  id: "script-loader",
  version: "weekly"
};
class HW extends gt {
  constructor() {
    super(...arguments), le(this, "check", null), le(this, "state", {
      loaded: !1
    }), le(this, "cleanupCallback", () => {
      delete window.google.maps, this.injectScript();
    }), le(this, "isCleaningUp", /* @__PURE__ */ wf(function* () {
      function t(n) {
        if (!ti)
          n();
        else if (ir)
          var r = window.setInterval(function() {
            ti || (window.clearInterval(r), n());
          }, 1);
      }
      return new Promise(t);
    })), le(this, "cleanup", () => {
      ti = !0;
      var t = document.getElementById(this.props.id);
      t && t.parentNode && t.parentNode.removeChild(t), Array.prototype.slice.call(document.getElementsByTagName("script")).filter(function(r) {
        return typeof r.src == "string" && r.src.includes("maps.googleapis");
      }).forEach(function(r) {
        r.parentNode && r.parentNode.removeChild(r);
      }), Array.prototype.slice.call(document.getElementsByTagName("link")).filter(function(r) {
        return r.href === "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Google+Sans";
      }).forEach(function(r) {
        r.parentNode && r.parentNode.removeChild(r);
      }), Array.prototype.slice.call(document.getElementsByTagName("style")).filter(function(r) {
        return r.innerText !== void 0 && r.innerText.length > 0 && r.innerText.includes(".gm-");
      }).forEach(function(r) {
        r.parentNode && r.parentNode.removeChild(r);
      });
    }), le(this, "injectScript", () => {
      this.props.preventGoogleFontsLoading && Z3(), Dt(!!this.props.id, 'LoadScript requires "id" prop to be a string: %s', this.props.id);
      var t = {
        id: this.props.id,
        nonce: this.props.nonce,
        url: Mf(this.props)
      };
      xf(t).then(() => {
        this.props.onLoad && this.props.onLoad(), this.setState(function() {
          return {
            loaded: !0
          };
        });
      }).catch((n) => {
        this.props.onError && this.props.onError(n), console.error(`
          There has been an Error with loading Google Maps API script, please check that you provided correct google API key (`.concat(this.props.googleMapsApiKey || "-", ") or Client ID (").concat(this.props.googleMapsClientId || "-", `) to <LoadScript />
          Otherwise it is a Network issue.
        `));
      });
    }), le(this, "getRef", (t) => {
      this.check = t;
    });
  }
  componentDidMount() {
    if (ir) {
      if (window.google && window.google.maps && !ti) {
        console.error("google api is already presented");
        return;
      }
      this.isCleaningUp().then(this.injectScript).catch(function(n) {
        console.error("Error at injecting script after cleaning up: ", n);
      });
    }
  }
  componentDidUpdate(t) {
    this.props.libraries !== t.libraries && console.warn("Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables"), ir && t.language !== this.props.language && (this.cleanup(), this.setState(function() {
      return {
        loaded: !1
      };
    }, this.cleanupCallback));
  }
  componentWillUnmount() {
    if (ir) {
      this.cleanup();
      var t = () => {
        this.check || (delete window.google, ti = !1);
      };
      window.setTimeout(t, 1), this.props.onUnmount && this.props.onUnmount();
    }
  }
  render() {
    return V(me, {
      children: [u("div", {
        ref: this.getRef
      }), this.state.loaded ? this.props.children : this.props.loadingElement || u(bf, {})]
    });
  }
}
le(HW, "defaultProps", bi);
function OW(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.includes(r)) continue;
    n[r] = e[r];
  }
  return n;
}
function $3(e, t) {
  if (e == null) return {};
  var n, r, i = OW(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++) n = a[r], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
  }
  return i;
}
var Bd;
function NW(e) {
  var {
    id: t = bi.id,
    version: n = bi.version,
    nonce: r,
    googleMapsApiKey: i,
    googleMapsClientId: a,
    language: c,
    region: d,
    libraries: f,
    preventGoogleFontsLoading: p,
    channel: m,
    mapIds: v,
    authReferrerPolicy: g,
    apiUrl: w = "https://maps.googleapis.com"
  } = e, x = It(!1), [b, y] = q(!1), [E, z] = q(void 0);
  T(function() {
    return x.current = !0, () => {
      x.current = !1;
    };
  }, []), T(function() {
    ir && p && Z3();
  }, [p]), T(function() {
    b && Dt(!!window.google, "useLoadScript was marked as loaded, but window.google is not present. Something went wrong.");
  }, [b]);
  var k = Mf({
    version: n,
    googleMapsApiKey: i,
    googleMapsClientId: a,
    language: c,
    region: d,
    libraries: f,
    channel: m,
    mapIds: v,
    authReferrerPolicy: g,
    apiUrl: w
  });
  T(function() {
    if (!ir)
      return;
    function _() {
      x.current && (y(!0), Bd = k);
    }
    if (window.google && window.google.maps && Bd === k) {
      _();
      return;
    }
    xf({
      id: t,
      url: k,
      nonce: r
    }).then(_).catch(function(O) {
      x.current && z(O), console.warn(`
        There has been an Error with loading Google Maps API script, please check that you provided correct google API key (`.concat(i || "-", ") or Client ID (").concat(a || "-", `)
        Otherwise it is a Network issue.
      `)), console.error(O);
    });
  }, [t, k, r]);
  var R = It(void 0);
  return T(function() {
    R.current && f !== R.current && console.warn("Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables"), R.current = f;
  }, [f]), {
    isLoaded: b,
    loadError: E,
    url: k
  };
}
var BW = ["loadingElement", "onLoad", "onError", "onUnmount", "children"], IW = u(bf, {});
function TW(e) {
  var {
    loadingElement: t,
    onLoad: n,
    onError: r,
    onUnmount: i,
    children: a
  } = e, c = $3(e, BW), {
    isLoaded: d,
    loadError: f
  } = NW(c);
  return T(function() {
    d && typeof n == "function" && n();
  }, [d, n]), T(function() {
    f && typeof r == "function" && r(f);
  }, [f, r]), T(function() {
    return () => {
      i && i();
    };
  }, [i]), d ? a : t || IW;
}
Rt(TW);
function VW(e, t, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(c) {
      c(a);
    });
  }
  return new (n || (n = Promise))(function(a, c) {
    function d(m) {
      try {
        p(r.next(m));
      } catch (v) {
        c(v);
      }
    }
    function f(m) {
      try {
        p(r.throw(m));
      } catch (v) {
        c(v);
      }
    }
    function p(m) {
      m.done ? a(m.value) : i(m.value).then(d, f);
    }
    p((r = r.apply(e, [])).next());
  });
}
function ZW(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $W = function e(t, n) {
  if (t === n) return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    if (t.constructor !== n.constructor) return !1;
    var r, i, a;
    if (Array.isArray(t)) {
      if (r = t.length, r != n.length) return !1;
      for (i = r; i-- !== 0; ) if (!e(t[i], n[i])) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
    if (a = Object.keys(t), r = a.length, r !== Object.keys(n).length) return !1;
    for (i = r; i-- !== 0; ) if (!Object.prototype.hasOwnProperty.call(n, a[i])) return !1;
    for (i = r; i-- !== 0; ) {
      var c = a[i];
      if (!e(t[c], n[c])) return !1;
    }
    return !0;
  }
  return t !== t && n !== n;
}, WW = /* @__PURE__ */ ZW($W), Id = "__googleMapsScriptId", p1;
(function(e) {
  e[e.INITIALIZED = 0] = "INITIALIZED", e[e.LOADING = 1] = "LOADING", e[e.SUCCESS = 2] = "SUCCESS", e[e.FAILURE = 3] = "FAILURE";
})(p1 || (p1 = {}));
class Dr {
  /**
   * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
   * using this library, instead the defaults are set by the Google Maps
   * JavaScript API server.
   *
   * ```
   * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
   * ```
   */
  constructor(t) {
    var {
      apiKey: n,
      authReferrerPolicy: r,
      channel: i,
      client: a,
      id: c = Id,
      language: d,
      libraries: f = [],
      mapIds: p,
      nonce: m,
      region: v,
      retries: g = 3,
      url: w = "https://maps.googleapis.com/maps/api/js",
      version: x
    } = t;
    if (this.callbacks = [], this.done = !1, this.loading = !1, this.errors = [], this.apiKey = n, this.authReferrerPolicy = r, this.channel = i, this.client = a, this.id = c || Id, this.language = d, this.libraries = f, this.mapIds = p, this.nonce = m, this.region = v, this.retries = g, this.url = w, this.version = x, Dr.instance) {
      if (!WW(this.options, Dr.instance.options))
        throw new Error("Loader must not be called again with different options. ".concat(JSON.stringify(this.options), " !== ").concat(JSON.stringify(Dr.instance.options)));
      return Dr.instance;
    }
    Dr.instance = this;
  }
  get options() {
    return {
      version: this.version,
      apiKey: this.apiKey,
      channel: this.channel,
      client: this.client,
      id: this.id,
      libraries: this.libraries,
      language: this.language,
      region: this.region,
      mapIds: this.mapIds,
      nonce: this.nonce,
      url: this.url,
      authReferrerPolicy: this.authReferrerPolicy
    };
  }
  get status() {
    return this.errors.length ? p1.FAILURE : this.done ? p1.SUCCESS : this.loading ? p1.LOADING : p1.INITIALIZED;
  }
  get failed() {
    return this.done && !this.loading && this.errors.length >= this.retries + 1;
  }
  /**
   * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
   *
   * @ignore
   * @deprecated
   */
  createUrl() {
    var t = this.url;
    return t += "?callback=__googleMapsCallback&loading=async", this.apiKey && (t += "&key=".concat(this.apiKey)), this.channel && (t += "&channel=".concat(this.channel)), this.client && (t += "&client=".concat(this.client)), this.libraries.length > 0 && (t += "&libraries=".concat(this.libraries.join(","))), this.language && (t += "&language=".concat(this.language)), this.region && (t += "&region=".concat(this.region)), this.version && (t += "&v=".concat(this.version)), this.mapIds && (t += "&map_ids=".concat(this.mapIds.join(","))), this.authReferrerPolicy && (t += "&auth_referrer_policy=".concat(this.authReferrerPolicy)), t;
  }
  deleteScript() {
    var t = document.getElementById(this.id);
    t && t.remove();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   * @deprecated, use importLibrary() instead.
   */
  load() {
    return this.loadPromise();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   *
   * @ignore
   * @deprecated, use importLibrary() instead.
   */
  loadPromise() {
    return new Promise((t, n) => {
      this.loadCallback((r) => {
        r ? n(r.error) : t(window.google);
      });
    });
  }
  importLibrary(t) {
    return this.execute(), google.maps.importLibrary(t);
  }
  /**
   * Load the Google Maps JavaScript API script with a callback.
   * @deprecated, use importLibrary() instead.
   */
  loadCallback(t) {
    this.callbacks.push(t), this.execute();
  }
  /**
   * Set the script on document.
   */
  setScript() {
    var t, n;
    if (document.getElementById(this.id)) {
      this.callback();
      return;
    }
    var r = {
      key: this.apiKey,
      channel: this.channel,
      client: this.client,
      libraries: this.libraries.length && this.libraries,
      v: this.version,
      mapIds: this.mapIds,
      language: this.language,
      region: this.region,
      authReferrerPolicy: this.authReferrerPolicy
    };
    Object.keys(r).forEach(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (a) => !r[a] && delete r[a]
    ), !((n = (t = window == null ? void 0 : window.google) === null || t === void 0 ? void 0 : t.maps) === null || n === void 0) && n.importLibrary || ((a) => {
      var c, d, f, p = "The Google Maps JavaScript API", m = "google", v = "importLibrary", g = "__ib__", w = document, x = window;
      x = x[m] || (x[m] = {});
      var b = x.maps || (x.maps = {}), y = /* @__PURE__ */ new Set(), E = new URLSearchParams(), z = () => (
        // @ts-ignore
        c || (c = new Promise((k, R) => VW(this, void 0, void 0, function* () {
          var F;
          yield d = w.createElement("script"), d.id = this.id, E.set("libraries", [...y] + "");
          for (f in a) E.set(f.replace(/[A-Z]/g, (_) => "_" + _[0].toLowerCase()), a[f]);
          E.set("callback", m + ".maps." + g), d.src = this.url + "?" + E, b[g] = k, d.onerror = () => c = R(Error(p + " could not load.")), d.nonce = this.nonce || ((F = w.querySelector("script[nonce]")) === null || F === void 0 ? void 0 : F.nonce) || "", w.head.append(d);
        })))
      );
      b[v] ? console.warn(p + " only loads once. Ignoring:", a) : b[v] = function(k) {
        for (var R = arguments.length, F = new Array(R > 1 ? R - 1 : 0), _ = 1; _ < R; _++)
          F[_ - 1] = arguments[_];
        return y.add(k) && z().then(() => b[v](k, ...F));
      };
    })(r);
    var i = this.libraries.map((a) => this.importLibrary(a));
    i.length || i.push(this.importLibrary("core")), Promise.all(i).then(() => this.callback(), (a) => {
      var c = new ErrorEvent("error", {
        error: a
      });
      this.loadErrorCallback(c);
    });
  }
  /**
   * Reset the loader state.
   */
  reset() {
    this.deleteScript(), this.done = !1, this.loading = !1, this.errors = [], this.onerrorEvent = null;
  }
  resetIfRetryingFailed() {
    this.failed && this.reset();
  }
  loadErrorCallback(t) {
    if (this.errors.push(t), this.errors.length <= this.retries) {
      var n = this.errors.length * Math.pow(2, this.errors.length);
      console.error("Failed to load Google Maps script, retrying in ".concat(n, " ms.")), setTimeout(() => {
        this.deleteScript(), this.setScript();
      }, n);
    } else
      this.onerrorEvent = t, this.callback();
  }
  callback() {
    this.done = !0, this.loading = !1, this.callbacks.forEach((t) => {
      t(this.onerrorEvent);
    }), this.callbacks = [];
  }
  execute() {
    if (this.resetIfRetryingFailed(), !this.loading)
      if (this.done)
        this.callback();
      else {
        if (window.google && window.google.maps && window.google.maps.version) {
          console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. This may result in undesirable behavior as options and script parameters may not match."), this.callback();
          return;
        }
        this.loading = !0, this.setScript();
      }
  }
}
var GW = ["maps"];
function UW(e) {
  var {
    id: t = bi.id,
    version: n = bi.version,
    nonce: r,
    googleMapsApiKey: i,
    // googleMapsClientId,
    language: a,
    region: c,
    libraries: d = GW,
    preventGoogleFontsLoading: f,
    // channel,
    mapIds: p,
    authReferrerPolicy: m
  } = e, v = It(!1), [g, w] = q(!1), [x, b] = q(void 0);
  T(function() {
    return v.current = !0, () => {
      v.current = !1;
    };
  }, []);
  var y = Ut(() => new Dr({
    id: t,
    apiKey: i,
    version: n,
    libraries: d,
    language: a || "en",
    region: c || "US",
    mapIds: p || [],
    nonce: r || "",
    authReferrerPolicy: m || "origin"
  }), [t, i, n, d, a, c, p, r, m]);
  T(function() {
    g || y.load().then(() => {
      v.current && w(!0);
    }).catch((k) => {
      b(k);
    });
  }, []), T(() => {
    ir && f && Z3();
  }, [f]);
  var E = It();
  return T(() => {
    E.current && d !== E.current && console.warn("Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables"), E.current = d;
  }, [d]), {
    isLoaded: g,
    loadError: x
  };
}
function Td(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Td(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Td(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Vd = {}, Zd = {
  options(e, t) {
    e.setOptions(t);
  }
};
function jW(e) {
  var {
    options: t,
    onLoad: n,
    onUnmount: r
  } = e, i = pt($e), [a, c] = q(null);
  return T(() => {
    a !== null && a.setMap(i);
  }, [i]), T(() => {
    t && a !== null && a.setOptions(t);
  }, [a, t]), T(() => {
    var d = new google.maps.TrafficLayer(sl(sl({}, t), {}, {
      map: i
    }));
    return c(d), n && n(d), () => {
      a !== null && (r && r(a), a.setMap(null));
    };
  }, []), null;
}
Rt(jW);
class KW extends gt {
  constructor() {
    super(...arguments), le(this, "state", {
      trafficLayer: null
    }), le(this, "setTrafficLayerCallback", () => {
      this.state.trafficLayer !== null && this.props.onLoad && this.props.onLoad(this.state.trafficLayer);
    }), le(this, "registeredEvents", []);
  }
  componentDidMount() {
    var t = new google.maps.TrafficLayer(sl(sl({}, this.props.options), {}, {
      map: this.context
    }));
    this.registeredEvents = Ke({
      updaterMap: Zd,
      eventMap: Vd,
      prevProps: {},
      nextProps: this.props,
      instance: t
    }), this.setState(function() {
      return {
        trafficLayer: t
      };
    }, this.setTrafficLayerCallback);
  }
  componentDidUpdate(t) {
    this.state.trafficLayer !== null && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: Zd,
      eventMap: Vd,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.trafficLayer
    }));
  }
  componentWillUnmount() {
    this.state.trafficLayer !== null && (this.props.onUnmount && this.props.onUnmount(this.state.trafficLayer), Je(this.registeredEvents), this.state.trafficLayer.setMap(null));
  }
  render() {
    return null;
  }
}
le(KW, "contextType", $e);
function YW(e) {
  var {
    onLoad: t,
    onUnmount: n
  } = e, r = pt($e), [i, a] = q(null);
  return T(() => {
    i !== null && i.setMap(r);
  }, [r]), T(() => {
    var c = new google.maps.BicyclingLayer();
    return a(c), c.setMap(r), t && t(c), () => {
      c !== null && (n && n(c), c.setMap(null));
    };
  }, []), null;
}
Rt(YW);
class qW extends gt {
  constructor() {
    super(...arguments), le(this, "state", {
      bicyclingLayer: null
    }), le(this, "setBicyclingLayerCallback", () => {
      this.state.bicyclingLayer !== null && (this.state.bicyclingLayer.setMap(this.context), this.props.onLoad && this.props.onLoad(this.state.bicyclingLayer));
    });
  }
  componentDidMount() {
    var t = new google.maps.BicyclingLayer();
    this.setState(() => ({
      bicyclingLayer: t
    }), this.setBicyclingLayerCallback);
  }
  componentWillUnmount() {
    this.state.bicyclingLayer !== null && (this.props.onUnmount && this.props.onUnmount(this.state.bicyclingLayer), this.state.bicyclingLayer.setMap(null));
  }
  render() {
    return null;
  }
}
le(qW, "contextType", $e);
function XW(e) {
  var {
    onLoad: t,
    onUnmount: n
  } = e, r = pt($e), [i, a] = q(null);
  return T(() => {
    i !== null && i.setMap(r);
  }, [r]), T(() => {
    var c = new google.maps.TransitLayer();
    return a(c), c.setMap(r), t && t(c), () => {
      i !== null && (n && n(i), i.setMap(null));
    };
  }, []), null;
}
Rt(XW);
class JW extends gt {
  constructor() {
    super(...arguments), le(this, "state", {
      transitLayer: null
    }), le(this, "setTransitLayerCallback", () => {
      this.state.transitLayer !== null && (this.state.transitLayer.setMap(this.context), this.props.onLoad && this.props.onLoad(this.state.transitLayer));
    });
  }
  componentDidMount() {
    var t = new google.maps.TransitLayer();
    this.setState(function() {
      return {
        transitLayer: t
      };
    }, this.setTransitLayerCallback);
  }
  componentWillUnmount() {
    this.state.transitLayer !== null && (this.props.onUnmount && this.props.onUnmount(this.state.transitLayer), this.state.transitLayer.setMap(null));
  }
  render() {
    return null;
  }
}
le(JW, "contextType", $e);
function $d(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function cl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $d(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $d(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Wd = {
  onCircleComplete: "circlecomplete",
  onMarkerComplete: "markercomplete",
  onOverlayComplete: "overlaycomplete",
  onPolygonComplete: "polygoncomplete",
  onPolylineComplete: "polylinecomplete",
  onRectangleComplete: "rectanglecomplete"
}, Gd = {
  drawingMode(e, t) {
    e.setDrawingMode(t);
  },
  options(e, t) {
    e.setOptions(t);
  }
};
function QW(e) {
  var {
    options: t,
    drawingMode: n,
    onCircleComplete: r,
    onMarkerComplete: i,
    onOverlayComplete: a,
    onPolygonComplete: c,
    onPolylineComplete: d,
    onRectangleComplete: f,
    onLoad: p,
    onUnmount: m
  } = e, v = pt($e), [g, w] = q(null), [x, b] = q(null), [y, E] = q(null), [z, k] = q(null), [R, F] = q(null), [_, P] = q(null), [O, Z] = q(null);
  return T(() => {
    g !== null && g.setMap(v);
  }, [v]), T(() => {
    t && g !== null && g.setOptions(t);
  }, [g, t]), T(() => {
    g !== null && g.setDrawingMode(n ?? null);
  }, [g, n]), T(() => {
    g && r && (x !== null && google.maps.event.removeListener(x), b(google.maps.event.addListener(g, "circlecomplete", r)));
  }, [g, r]), T(() => {
    g && i && (y !== null && google.maps.event.removeListener(y), E(google.maps.event.addListener(g, "markercomplete", i)));
  }, [g, i]), T(() => {
    g && a && (z !== null && google.maps.event.removeListener(z), k(google.maps.event.addListener(g, "overlaycomplete", a)));
  }, [g, a]), T(() => {
    g && c && (R !== null && google.maps.event.removeListener(R), F(google.maps.event.addListener(g, "polygoncomplete", c)));
  }, [g, c]), T(() => {
    g && d && (_ !== null && google.maps.event.removeListener(_), P(google.maps.event.addListener(g, "polylinecomplete", d)));
  }, [g, d]), T(() => {
    g && f && (O !== null && google.maps.event.removeListener(O), Z(google.maps.event.addListener(g, "rectanglecomplete", f)));
  }, [g, f]), T(() => {
    Dt(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
    var te = new google.maps.drawing.DrawingManager(cl(cl({}, t), {}, {
      map: v
    }));
    return n && te.setDrawingMode(n), r && b(google.maps.event.addListener(te, "circlecomplete", r)), i && E(google.maps.event.addListener(te, "markercomplete", i)), a && k(google.maps.event.addListener(te, "overlaycomplete", a)), c && F(google.maps.event.addListener(te, "polygoncomplete", c)), d && P(google.maps.event.addListener(te, "polylinecomplete", d)), f && Z(google.maps.event.addListener(te, "rectanglecomplete", f)), w(te), p && p(te), () => {
      g !== null && (x && google.maps.event.removeListener(x), y && google.maps.event.removeListener(y), z && google.maps.event.removeListener(z), R && google.maps.event.removeListener(R), _ && google.maps.event.removeListener(_), O && google.maps.event.removeListener(O), m && m(g), g.setMap(null));
    };
  }, []), null;
}
Rt(QW);
class eG extends gt {
  constructor(t) {
    super(t), le(this, "registeredEvents", []), le(this, "state", {
      drawingManager: null
    }), le(this, "setDrawingManagerCallback", () => {
      this.state.drawingManager !== null && this.props.onLoad && this.props.onLoad(this.state.drawingManager);
    }), Dt(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
  }
  componentDidMount() {
    var t = new google.maps.drawing.DrawingManager(cl(cl({}, this.props.options), {}, {
      map: this.context
    }));
    this.registeredEvents = Ke({
      updaterMap: Gd,
      eventMap: Wd,
      prevProps: {},
      nextProps: this.props,
      instance: t
    }), this.setState(function() {
      return {
        drawingManager: t
      };
    }, this.setDrawingManagerCallback);
  }
  componentDidUpdate(t) {
    this.state.drawingManager !== null && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: Gd,
      eventMap: Wd,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.drawingManager
    }));
  }
  componentWillUnmount() {
    this.state.drawingManager !== null && (this.props.onUnmount && this.props.onUnmount(this.state.drawingManager), Je(this.registeredEvents), this.state.drawingManager.setMap(null));
  }
  render() {
    return null;
  }
}
le(eG, "contextType", $e);
function Ud(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function g1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ud(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ud(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var jd = {
  onAnimationChanged: "animation_changed",
  onClick: "click",
  onClickableChanged: "clickable_changed",
  onCursorChanged: "cursor_changed",
  onDblClick: "dblclick",
  onDrag: "drag",
  onDragEnd: "dragend",
  onDraggableChanged: "draggable_changed",
  onDragStart: "dragstart",
  onFlatChanged: "flat_changed",
  onIconChanged: "icon_changed",
  onMouseDown: "mousedown",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onPositionChanged: "position_changed",
  onRightClick: "rightclick",
  onShapeChanged: "shape_changed",
  onTitleChanged: "title_changed",
  onVisibleChanged: "visible_changed",
  onZindexChanged: "zindex_changed"
}, Kd = {
  animation(e, t) {
    e.setAnimation(t);
  },
  clickable(e, t) {
    e.setClickable(t);
  },
  cursor(e, t) {
    e.setCursor(t);
  },
  draggable(e, t) {
    e.setDraggable(t);
  },
  icon(e, t) {
    e.setIcon(t);
  },
  label(e, t) {
    e.setLabel(t);
  },
  map(e, t) {
    e.setMap(t);
  },
  opacity(e, t) {
    e.setOpacity(t);
  },
  options(e, t) {
    e.setOptions(t);
  },
  position(e, t) {
    e.setPosition(t);
  },
  shape(e, t) {
    e.setShape(t);
  },
  title(e, t) {
    e.setTitle(t);
  },
  visible(e, t) {
    e.setVisible(t);
  },
  zIndex(e, t) {
    e.setZIndex(t);
  }
}, dl = {};
function tG(e) {
  var {
    position: t,
    options: n,
    clusterer: r,
    noClustererRedraw: i,
    children: a,
    draggable: c,
    visible: d,
    animation: f,
    clickable: p,
    cursor: m,
    icon: v,
    label: g,
    opacity: w,
    shape: x,
    title: b,
    zIndex: y,
    onClick: E,
    onDblClick: z,
    onDrag: k,
    onDragEnd: R,
    onDragStart: F,
    onMouseOut: _,
    onMouseOver: P,
    onMouseUp: O,
    onMouseDown: Z,
    onRightClick: te,
    onClickableChanged: Y,
    onCursorChanged: X,
    onAnimationChanged: re,
    onDraggableChanged: ee,
    onFlatChanged: de,
    onIconChanged: ae,
    onPositionChanged: ge,
    onShapeChanged: K,
    onTitleChanged: J,
    onVisibleChanged: he,
    onZindexChanged: ve,
    onLoad: Q,
    onUnmount: ie
  } = e, pe = pt($e), [U, Me] = q(null), [Le, xe] = q(null), [Ee, ye] = q(null), [Be, ft] = q(null), [Et, Lt] = q(null), [je, B2] = q(null), [_t, m2] = q(null), [cn, qn] = q(null), [Pt, On] = q(null), [dn, I2] = q(null), [Xn, Gr] = q(null), [En, Nn] = q(null), [Jn, T2] = q(null), [Qn, V2] = q(null), [e2, Z2] = q(null), [t2, v2] = q(null), [n2, Lr] = q(null), [Ie, ot] = q(null), [nt, nn] = q(null), [Ht, g2] = q(null), [wt, Xt] = q(null), [qe, Ur] = q(null);
  T(() => {
    U !== null && U.setMap(pe);
  }, [pe]), T(() => {
    typeof n < "u" && U !== null && U.setOptions(n);
  }, [U, n]), T(() => {
    typeof c < "u" && U !== null && U.setDraggable(c);
  }, [U, c]), T(() => {
    t && U !== null && U.setPosition(t);
  }, [U, t]), T(() => {
    typeof d < "u" && U !== null && U.setVisible(d);
  }, [U, d]), T(() => {
    U == null || U.setAnimation(f);
  }, [U, f]), T(() => {
    U && p !== void 0 && U.setClickable(p);
  }, [U, p]), T(() => {
    U && m !== void 0 && U.setCursor(m);
  }, [U, m]), T(() => {
    U && v !== void 0 && U.setIcon(v);
  }, [U, v]), T(() => {
    U && g !== void 0 && U.setLabel(g);
  }, [U, g]), T(() => {
    U && w !== void 0 && U.setOpacity(w);
  }, [U, w]), T(() => {
    U && x !== void 0 && U.setShape(x);
  }, [U, x]), T(() => {
    U && b !== void 0 && U.setTitle(b);
  }, [U, b]), T(() => {
    U && y !== void 0 && U.setZIndex(y);
  }, [U, y]), T(() => {
    U && z && (Le !== null && google.maps.event.removeListener(Le), xe(google.maps.event.addListener(U, "dblclick", z)));
  }, [z]), T(() => {
    U && R && (Ee !== null && google.maps.event.removeListener(Ee), ye(google.maps.event.addListener(U, "dragend", R)));
  }, [R]), T(() => {
    U && F && (Be !== null && google.maps.event.removeListener(Be), ft(google.maps.event.addListener(U, "dragstart", F)));
  }, [F]), T(() => {
    U && Z && (Et !== null && google.maps.event.removeListener(Et), Lt(google.maps.event.addListener(U, "mousedown", Z)));
  }, [Z]), T(() => {
    U && _ && (je !== null && google.maps.event.removeListener(je), B2(google.maps.event.addListener(U, "mouseout", _)));
  }, [_]), T(() => {
    U && P && (_t !== null && google.maps.event.removeListener(_t), m2(google.maps.event.addListener(U, "mouseover", P)));
  }, [P]), T(() => {
    U && O && (cn !== null && google.maps.event.removeListener(cn), qn(google.maps.event.addListener(U, "mouseup", O)));
  }, [O]), T(() => {
    U && te && (Pt !== null && google.maps.event.removeListener(Pt), On(google.maps.event.addListener(U, "rightclick", te)));
  }, [te]), T(() => {
    U && E && (dn !== null && google.maps.event.removeListener(dn), I2(google.maps.event.addListener(U, "click", E)));
  }, [E]), T(() => {
    U && k && (Xn !== null && google.maps.event.removeListener(Xn), Gr(google.maps.event.addListener(U, "drag", k)));
  }, [k]), T(() => {
    U && Y && (En !== null && google.maps.event.removeListener(En), Nn(google.maps.event.addListener(U, "clickable_changed", Y)));
  }, [Y]), T(() => {
    U && X && (Jn !== null && google.maps.event.removeListener(Jn), T2(google.maps.event.addListener(U, "cursor_changed", X)));
  }, [X]), T(() => {
    U && re && (Qn !== null && google.maps.event.removeListener(Qn), V2(google.maps.event.addListener(U, "animation_changed", re)));
  }, [re]), T(() => {
    U && ee && (e2 !== null && google.maps.event.removeListener(e2), Z2(google.maps.event.addListener(U, "draggable_changed", ee)));
  }, [ee]), T(() => {
    U && de && (t2 !== null && google.maps.event.removeListener(t2), v2(google.maps.event.addListener(U, "flat_changed", de)));
  }, [de]), T(() => {
    U && ae && (n2 !== null && google.maps.event.removeListener(n2), Lr(google.maps.event.addListener(U, "icon_changed", ae)));
  }, [ae]), T(() => {
    U && ge && (Ie !== null && google.maps.event.removeListener(Ie), ot(google.maps.event.addListener(U, "position_changed", ge)));
  }, [ge]), T(() => {
    U && K && (nt !== null && google.maps.event.removeListener(nt), nn(google.maps.event.addListener(U, "shape_changed", K)));
  }, [K]), T(() => {
    U && J && (Ht !== null && google.maps.event.removeListener(Ht), g2(google.maps.event.addListener(U, "title_changed", J)));
  }, [J]), T(() => {
    U && he && (wt !== null && google.maps.event.removeListener(wt), Xt(google.maps.event.addListener(U, "visible_changed", he)));
  }, [he]), T(() => {
    U && ve && (qe !== null && google.maps.event.removeListener(qe), Ur(google.maps.event.addListener(U, "zindex_changed", ve)));
  }, [ve]), T(() => {
    var L2 = g1(g1(g1({}, n || dl), r ? dl : {
      map: pe
    }), {}, {
      position: t
    }), _e = new google.maps.Marker(L2);
    return r ? r.addMarker(_e, !!i) : _e.setMap(pe), t && _e.setPosition(t), typeof d < "u" && _e.setVisible(d), typeof c < "u" && _e.setDraggable(c), typeof p < "u" && _e.setClickable(p), typeof m == "string" && _e.setCursor(m), v && _e.setIcon(v), typeof g < "u" && _e.setLabel(g), typeof w < "u" && _e.setOpacity(w), x && _e.setShape(x), typeof b == "string" && _e.setTitle(b), typeof y == "number" && _e.setZIndex(y), z && xe(google.maps.event.addListener(_e, "dblclick", z)), R && ye(google.maps.event.addListener(_e, "dragend", R)), F && ft(google.maps.event.addListener(_e, "dragstart", F)), Z && Lt(google.maps.event.addListener(_e, "mousedown", Z)), _ && B2(google.maps.event.addListener(_e, "mouseout", _)), P && m2(google.maps.event.addListener(_e, "mouseover", P)), O && qn(google.maps.event.addListener(_e, "mouseup", O)), te && On(google.maps.event.addListener(_e, "rightclick", te)), E && I2(google.maps.event.addListener(_e, "click", E)), k && Gr(google.maps.event.addListener(_e, "drag", k)), Y && Nn(google.maps.event.addListener(_e, "clickable_changed", Y)), X && T2(google.maps.event.addListener(_e, "cursor_changed", X)), re && V2(google.maps.event.addListener(_e, "animation_changed", re)), ee && Z2(google.maps.event.addListener(_e, "draggable_changed", ee)), de && v2(google.maps.event.addListener(_e, "flat_changed", de)), ae && Lr(google.maps.event.addListener(_e, "icon_changed", ae)), ge && ot(google.maps.event.addListener(_e, "position_changed", ge)), K && nn(google.maps.event.addListener(_e, "shape_changed", K)), J && g2(google.maps.event.addListener(_e, "title_changed", J)), he && Xt(google.maps.event.addListener(_e, "visible_changed", he)), ve && Ur(google.maps.event.addListener(_e, "zindex_changed", ve)), Me(_e), Q && Q(_e), () => {
      Le !== null && google.maps.event.removeListener(Le), Ee !== null && google.maps.event.removeListener(Ee), Be !== null && google.maps.event.removeListener(Be), Et !== null && google.maps.event.removeListener(Et), je !== null && google.maps.event.removeListener(je), _t !== null && google.maps.event.removeListener(_t), cn !== null && google.maps.event.removeListener(cn), Pt !== null && google.maps.event.removeListener(Pt), dn !== null && google.maps.event.removeListener(dn), En !== null && google.maps.event.removeListener(En), Jn !== null && google.maps.event.removeListener(Jn), Qn !== null && google.maps.event.removeListener(Qn), e2 !== null && google.maps.event.removeListener(e2), t2 !== null && google.maps.event.removeListener(t2), n2 !== null && google.maps.event.removeListener(n2), Ie !== null && google.maps.event.removeListener(Ie), Ht !== null && google.maps.event.removeListener(Ht), wt !== null && google.maps.event.removeListener(wt), qe !== null && google.maps.event.removeListener(qe), ie && ie(_e), r ? r.removeMarker(_e, !!i) : _e && _e.setMap(null);
    };
  }, []);
  var P1 = Ut(() => a ? jt.map(a, (L2) => {
    if (!L6(L2))
      return L2;
    var _e = L2;
    return w6(_e, {
      anchor: U
    });
  }) : null, [a, U]);
  return u(me, {
    children: P1
  }) || null;
}
var nG = Rt(tG);
class rG extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []);
  }
  componentDidMount() {
    var t = this;
    return wf(function* () {
      var n = g1(g1(g1({}, t.props.options || dl), t.props.clusterer ? dl : {
        map: t.context
      }), {}, {
        position: t.props.position
      });
      t.marker = new google.maps.Marker(n), t.props.clusterer ? t.props.clusterer.addMarker(t.marker, !!t.props.noClustererRedraw) : t.marker.setMap(t.context), t.registeredEvents = Ke({
        updaterMap: Kd,
        eventMap: jd,
        prevProps: {},
        nextProps: t.props,
        instance: t.marker
      }), t.props.onLoad && t.props.onLoad(t.marker);
    })();
  }
  componentDidUpdate(t) {
    this.marker && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: Kd,
      eventMap: jd,
      prevProps: t,
      nextProps: this.props,
      instance: this.marker
    }));
  }
  componentWillUnmount() {
    this.marker && (this.props.onUnmount && this.props.onUnmount(this.marker), Je(this.registeredEvents), this.props.clusterer ? this.props.clusterer.removeMarker(this.marker, !!this.props.noClustererRedraw) : this.marker && this.marker.setMap(null));
  }
  render() {
    var t = this.props.children ? jt.map(this.props.children, (n) => {
      if (!L6(n))
        return n;
      var r = n;
      return w6(r, {
        anchor: this.marker
      });
    }) : null;
    return t || null;
  }
}
le(rG, "contextType", $e);
var iG = (
  /** @class */
  function() {
    function e(t, n) {
      t.getClusterer().extend(e, google.maps.OverlayView), this.cluster = t, this.clusterClassName = this.cluster.getClusterer().getClusterClass(), this.className = this.clusterClassName, this.styles = n, this.center = void 0, this.div = null, this.sums = null, this.visible = !1, this.boundsChangedListener = null, this.url = "", this.height = 0, this.width = 0, this.anchorText = [0, 0], this.anchorIcon = [0, 0], this.textColor = "black", this.textSize = 11, this.textDecoration = "none", this.fontWeight = "bold", this.fontStyle = "normal", this.fontFamily = "Arial,sans-serif", this.backgroundPosition = "0 0", this.cMouseDownInCluster = null, this.cDraggingMapByCluster = null, this.timeOut = null, this.setMap(t.getMap()), this.onBoundsChanged = this.onBoundsChanged.bind(this), this.onMouseDown = this.onMouseDown.bind(this), this.onClick = this.onClick.bind(this), this.onMouseOver = this.onMouseOver.bind(this), this.onMouseOut = this.onMouseOut.bind(this), this.onAdd = this.onAdd.bind(this), this.onRemove = this.onRemove.bind(this), this.draw = this.draw.bind(this), this.hide = this.hide.bind(this), this.show = this.show.bind(this), this.useStyle = this.useStyle.bind(this), this.setCenter = this.setCenter.bind(this), this.getPosFromLatLng = this.getPosFromLatLng.bind(this);
    }
    return e.prototype.onBoundsChanged = function() {
      this.cDraggingMapByCluster = this.cMouseDownInCluster;
    }, e.prototype.onMouseDown = function() {
      this.cMouseDownInCluster = !0, this.cDraggingMapByCluster = !1;
    }, e.prototype.onClick = function(t) {
      if (this.cMouseDownInCluster = !1, !this.cDraggingMapByCluster) {
        var n = this.cluster.getClusterer();
        if (google.maps.event.trigger(n, "click", this.cluster), google.maps.event.trigger(n, "clusterclick", this.cluster), n.getZoomOnClick()) {
          var r = n.getMaxZoom(), i = this.cluster.getBounds(), a = n.getMap();
          a !== null && "fitBounds" in a && a.fitBounds(i), this.timeOut = window.setTimeout(function() {
            var c = n.getMap();
            if (c !== null) {
              "fitBounds" in c && c.fitBounds(i);
              var d = c.getZoom() || 0;
              r !== null && d > r && c.setZoom(r + 1);
            }
          }, 100);
        }
        t.cancelBubble = !0, t.stopPropagation && t.stopPropagation();
      }
    }, e.prototype.onMouseOver = function() {
      google.maps.event.trigger(this.cluster.getClusterer(), "mouseover", this.cluster);
    }, e.prototype.onMouseOut = function() {
      google.maps.event.trigger(this.cluster.getClusterer(), "mouseout", this.cluster);
    }, e.prototype.onAdd = function() {
      var t;
      this.div = document.createElement("div"), this.div.className = this.className, this.visible && this.show(), (t = this.getPanes()) === null || t === void 0 || t.overlayMouseTarget.appendChild(this.div);
      var n = this.getMap();
      n !== null && (this.boundsChangedListener = google.maps.event.addListener(n, "bounds_changed", this.onBoundsChanged), this.div.addEventListener("mousedown", this.onMouseDown), this.div.addEventListener("click", this.onClick), this.div.addEventListener("mouseover", this.onMouseOver), this.div.addEventListener("mouseout", this.onMouseOut));
    }, e.prototype.onRemove = function() {
      this.div && this.div.parentNode && (this.hide(), this.boundsChangedListener !== null && google.maps.event.removeListener(this.boundsChangedListener), this.div.removeEventListener("mousedown", this.onMouseDown), this.div.removeEventListener("click", this.onClick), this.div.removeEventListener("mouseover", this.onMouseOver), this.div.removeEventListener("mouseout", this.onMouseOut), this.div.parentNode.removeChild(this.div), this.timeOut !== null && (window.clearTimeout(this.timeOut), this.timeOut = null), this.div = null);
    }, e.prototype.draw = function() {
      if (this.visible && this.div !== null && this.center) {
        var t = this.getPosFromLatLng(this.center);
        this.div.style.top = t !== null ? "".concat(t.y, "px") : "0", this.div.style.left = t !== null ? "".concat(t.x, "px") : "0";
      }
    }, e.prototype.hide = function() {
      this.div && (this.div.style.display = "none"), this.visible = !1;
    }, e.prototype.show = function() {
      var t, n, r, i, a, c;
      if (this.div && this.center) {
        var d = this.sums === null || typeof this.sums.title > "u" || this.sums.title === "" ? this.cluster.getClusterer().getTitle() : this.sums.title, f = this.backgroundPosition.split(" "), p = parseInt(((t = f[0]) === null || t === void 0 ? void 0 : t.replace(/^\s+|\s+$/g, "")) || "0", 10), m = parseInt(((n = f[1]) === null || n === void 0 ? void 0 : n.replace(/^\s+|\s+$/g, "")) || "0", 10), v = this.getPosFromLatLng(this.center);
        this.div.className = this.className, this.div.setAttribute("style", "cursor: pointer; position: absolute; top: ".concat(v !== null ? "".concat(v.y, "px") : "0", "; left: ").concat(v !== null ? "".concat(v.x, "px") : "0", "; width: ").concat(this.width, "px; height: ").concat(this.height, "px; "));
        var g = document.createElement("img");
        g.alt = d, g.src = this.url, g.width = this.width, g.height = this.height, g.setAttribute("style", "position: absolute; top: ".concat(m, "px; left: ").concat(p, "px")), this.cluster.getClusterer().enableRetinaIcons || (g.style.clip = "rect(-".concat(m, "px, -").concat(p + this.width, "px, -").concat(m + this.height, ", -").concat(p, ")"));
        var w = document.createElement("div");
        w.setAttribute("style", "position: absolute; top: ".concat(this.anchorText[0], "px; left: ").concat(this.anchorText[1], "px; color: ").concat(this.textColor, "; font-size: ").concat(this.textSize, "px; font-family: ").concat(this.fontFamily, "; font-weight: ").concat(this.fontWeight, "; fontStyle: ").concat(this.fontStyle, "; text-decoration: ").concat(this.textDecoration, "; text-align: center; width: ").concat(this.width, "px; line-height: ").concat(this.height, "px")), !((r = this.sums) === null || r === void 0) && r.text && (w.innerText = "".concat((i = this.sums) === null || i === void 0 ? void 0 : i.text)), !((a = this.sums) === null || a === void 0) && a.html && (w.innerHTML = "".concat((c = this.sums) === null || c === void 0 ? void 0 : c.html)), this.div.innerHTML = "", this.div.appendChild(g), this.div.appendChild(w), this.div.title = d, this.div.style.display = "";
      }
      this.visible = !0;
    }, e.prototype.useStyle = function(t) {
      this.sums = t;
      var n = this.cluster.getClusterer().getStyles(), r = n[Math.min(n.length - 1, Math.max(0, t.index - 1))];
      r && (this.url = r.url, this.height = r.height, this.width = r.width, r.className && (this.className = "".concat(this.clusterClassName, " ").concat(r.className)), this.anchorText = r.anchorText || [0, 0], this.anchorIcon = r.anchorIcon || [this.height / 2, this.width / 2], this.textColor = r.textColor || "black", this.textSize = r.textSize || 11, this.textDecoration = r.textDecoration || "none", this.fontWeight = r.fontWeight || "bold", this.fontStyle = r.fontStyle || "normal", this.fontFamily = r.fontFamily || "Arial,sans-serif", this.backgroundPosition = r.backgroundPosition || "0 0");
    }, e.prototype.setCenter = function(t) {
      this.center = t;
    }, e.prototype.getPosFromLatLng = function(t) {
      var n = this.getProjection().fromLatLngToDivPixel(t);
      return n !== null && (n.x -= this.anchorIcon[1], n.y -= this.anchorIcon[0]), n;
    }, e;
  }()
), lG = (
  /** @class */
  function() {
    function e(t) {
      this.markerClusterer = t, this.map = this.markerClusterer.getMap(), this.gridSize = this.markerClusterer.getGridSize(), this.minClusterSize = this.markerClusterer.getMinimumClusterSize(), this.averageCenter = this.markerClusterer.getAverageCenter(), this.markers = [], this.center = void 0, this.bounds = null, this.clusterIcon = new iG(this, this.markerClusterer.getStyles()), this.getSize = this.getSize.bind(this), this.getMarkers = this.getMarkers.bind(this), this.getCenter = this.getCenter.bind(this), this.getMap = this.getMap.bind(this), this.getClusterer = this.getClusterer.bind(this), this.getBounds = this.getBounds.bind(this), this.remove = this.remove.bind(this), this.addMarker = this.addMarker.bind(this), this.isMarkerInClusterBounds = this.isMarkerInClusterBounds.bind(this), this.calculateBounds = this.calculateBounds.bind(this), this.updateIcon = this.updateIcon.bind(this), this.isMarkerAlreadyAdded = this.isMarkerAlreadyAdded.bind(this);
    }
    return e.prototype.getSize = function() {
      return this.markers.length;
    }, e.prototype.getMarkers = function() {
      return this.markers;
    }, e.prototype.getCenter = function() {
      return this.center;
    }, e.prototype.getMap = function() {
      return this.map;
    }, e.prototype.getClusterer = function() {
      return this.markerClusterer;
    }, e.prototype.getBounds = function() {
      for (var t = new google.maps.LatLngBounds(this.center, this.center), n = this.getMarkers(), r = 0, i = n; r < i.length; r++) {
        var a = i[r], c = a.getPosition();
        c && t.extend(c);
      }
      return t;
    }, e.prototype.remove = function() {
      this.clusterIcon.setMap(null), this.markers = [], delete this.markers;
    }, e.prototype.addMarker = function(t) {
      var n;
      if (this.isMarkerAlreadyAdded(t))
        return !1;
      if (this.center) {
        if (this.averageCenter) {
          var r = t.getPosition();
          if (r) {
            var i = this.markers.length + 1;
            this.center = new google.maps.LatLng((this.center.lat() * (i - 1) + r.lat()) / i, (this.center.lng() * (i - 1) + r.lng()) / i), this.calculateBounds();
          }
        }
      } else {
        var r = t.getPosition();
        r && (this.center = r, this.calculateBounds());
      }
      t.isAdded = !0, this.markers.push(t);
      var a = this.markers.length, c = this.markerClusterer.getMaxZoom(), d = (n = this.map) === null || n === void 0 ? void 0 : n.getZoom();
      if (c !== null && typeof d < "u" && d > c)
        t.getMap() !== this.map && t.setMap(this.map);
      else if (a < this.minClusterSize)
        t.getMap() !== this.map && t.setMap(this.map);
      else if (a === this.minClusterSize)
        for (var f = 0, p = this.markers; f < p.length; f++) {
          var m = p[f];
          m.setMap(null);
        }
      else
        t.setMap(null);
      return !0;
    }, e.prototype.isMarkerInClusterBounds = function(t) {
      if (this.bounds !== null) {
        var n = t.getPosition();
        if (n)
          return this.bounds.contains(n);
      }
      return !1;
    }, e.prototype.calculateBounds = function() {
      this.bounds = this.markerClusterer.getExtendedBounds(new google.maps.LatLngBounds(this.center, this.center));
    }, e.prototype.updateIcon = function() {
      var t, n = this.markers.length, r = this.markerClusterer.getMaxZoom(), i = (t = this.map) === null || t === void 0 ? void 0 : t.getZoom();
      if (r !== null && typeof i < "u" && i > r) {
        this.clusterIcon.hide();
        return;
      }
      if (n < this.minClusterSize) {
        this.clusterIcon.hide();
        return;
      }
      this.center && this.clusterIcon.setCenter(this.center), this.clusterIcon.useStyle(this.markerClusterer.getCalculator()(this.markers, this.markerClusterer.getStyles().length)), this.clusterIcon.show();
    }, e.prototype.isMarkerAlreadyAdded = function(t) {
      if (this.markers.includes)
        return this.markers.includes(t);
      for (var n = 0; n < this.markers.length; n++)
        if (t === this.markers[n])
          return !0;
      return !1;
    }, e;
  }()
);
function oG(e, t) {
  var n = e.length, r = n.toString().length, i = Math.min(r, t);
  return {
    text: n.toString(),
    index: i,
    title: ""
  };
}
var aG = 2e3, sG = 500, cG = "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m", dG = "png", uG = [53, 56, 66, 78, 90], fG = "cluster", yf = (
  /** @class */
  function() {
    function e(t, n, r) {
      n === void 0 && (n = []), r === void 0 && (r = {}), this.getMinimumClusterSize = this.getMinimumClusterSize.bind(this), this.setMinimumClusterSize = this.setMinimumClusterSize.bind(this), this.getEnableRetinaIcons = this.getEnableRetinaIcons.bind(this), this.setEnableRetinaIcons = this.setEnableRetinaIcons.bind(this), this.addToClosestCluster = this.addToClosestCluster.bind(this), this.getImageExtension = this.getImageExtension.bind(this), this.setImageExtension = this.setImageExtension.bind(this), this.getExtendedBounds = this.getExtendedBounds.bind(this), this.getAverageCenter = this.getAverageCenter.bind(this), this.setAverageCenter = this.setAverageCenter.bind(this), this.getTotalClusters = this.getTotalClusters.bind(this), this.fitMapToMarkers = this.fitMapToMarkers.bind(this), this.getIgnoreHidden = this.getIgnoreHidden.bind(this), this.setIgnoreHidden = this.setIgnoreHidden.bind(this), this.getClusterClass = this.getClusterClass.bind(this), this.setClusterClass = this.setClusterClass.bind(this), this.getTotalMarkers = this.getTotalMarkers.bind(this), this.getZoomOnClick = this.getZoomOnClick.bind(this), this.setZoomOnClick = this.setZoomOnClick.bind(this), this.getBatchSizeIE = this.getBatchSizeIE.bind(this), this.setBatchSizeIE = this.setBatchSizeIE.bind(this), this.createClusters = this.createClusters.bind(this), this.onZoomChanged = this.onZoomChanged.bind(this), this.getImageSizes = this.getImageSizes.bind(this), this.setImageSizes = this.setImageSizes.bind(this), this.getCalculator = this.getCalculator.bind(this), this.setCalculator = this.setCalculator.bind(this), this.removeMarkers = this.removeMarkers.bind(this), this.resetViewport = this.resetViewport.bind(this), this.getImagePath = this.getImagePath.bind(this), this.setImagePath = this.setImagePath.bind(this), this.pushMarkerTo = this.pushMarkerTo.bind(this), this.removeMarker = this.removeMarker.bind(this), this.clearMarkers = this.clearMarkers.bind(this), this.setupStyles = this.setupStyles.bind(this), this.getGridSize = this.getGridSize.bind(this), this.setGridSize = this.setGridSize.bind(this), this.getClusters = this.getClusters.bind(this), this.getMaxZoom = this.getMaxZoom.bind(this), this.setMaxZoom = this.setMaxZoom.bind(this), this.getMarkers = this.getMarkers.bind(this), this.addMarkers = this.addMarkers.bind(this), this.getStyles = this.getStyles.bind(this), this.setStyles = this.setStyles.bind(this), this.addMarker = this.addMarker.bind(this), this.onRemove = this.onRemove.bind(this), this.getTitle = this.getTitle.bind(this), this.setTitle = this.setTitle.bind(this), this.repaint = this.repaint.bind(this), this.onIdle = this.onIdle.bind(this), this.redraw = this.redraw.bind(this), this.onAdd = this.onAdd.bind(this), this.draw = this.draw.bind(this), this.extend = this.extend.bind(this), this.extend(e, google.maps.OverlayView), this.markers = [], this.clusters = [], this.listeners = [], this.activeMap = null, this.ready = !1, this.gridSize = r.gridSize || 60, this.minClusterSize = r.minimumClusterSize || 2, this.maxZoom = r.maxZoom || null, this.styles = r.styles || [], this.title = r.title || "", this.zoomOnClick = !0, r.zoomOnClick !== void 0 && (this.zoomOnClick = r.zoomOnClick), this.averageCenter = !1, r.averageCenter !== void 0 && (this.averageCenter = r.averageCenter), this.ignoreHidden = !1, r.ignoreHidden !== void 0 && (this.ignoreHidden = r.ignoreHidden), this.enableRetinaIcons = !1, r.enableRetinaIcons !== void 0 && (this.enableRetinaIcons = r.enableRetinaIcons), this.imagePath = r.imagePath || cG, this.imageExtension = r.imageExtension || dG, this.imageSizes = r.imageSizes || uG, this.calculator = r.calculator || oG, this.batchSize = r.batchSize || aG, this.batchSizeIE = r.batchSizeIE || sG, this.clusterClass = r.clusterClass || fG, navigator.userAgent.toLowerCase().indexOf("msie") !== -1 && (this.batchSize = this.batchSizeIE), this.timerRefStatic = null, this.setupStyles(), this.addMarkers(n, !0), this.setMap(t);
    }
    return e.prototype.onZoomChanged = function() {
      var t, n;
      this.resetViewport(!1), (((t = this.getMap()) === null || t === void 0 ? void 0 : t.getZoom()) === (this.get("minZoom") || 0) || ((n = this.getMap()) === null || n === void 0 ? void 0 : n.getZoom()) === this.get("maxZoom")) && google.maps.event.trigger(this, "idle");
    }, e.prototype.onIdle = function() {
      this.redraw();
    }, e.prototype.onAdd = function() {
      var t = this.getMap();
      this.activeMap = t, this.ready = !0, this.repaint(), t !== null && (this.listeners = [google.maps.event.addListener(t, "zoom_changed", this.onZoomChanged), google.maps.event.addListener(t, "idle", this.onIdle)]);
    }, e.prototype.onRemove = function() {
      for (var t = 0, n = this.markers; t < n.length; t++) {
        var r = n[t];
        r.getMap() !== this.activeMap && r.setMap(this.activeMap);
      }
      for (var i = 0, a = this.clusters; i < a.length; i++) {
        var c = a[i];
        c.remove();
      }
      this.clusters = [];
      for (var d = 0, f = this.listeners; d < f.length; d++) {
        var p = f[d];
        google.maps.event.removeListener(p);
      }
      this.listeners = [], this.activeMap = null, this.ready = !1;
    }, e.prototype.draw = function() {
    }, e.prototype.getMap = function() {
      return null;
    }, e.prototype.getPanes = function() {
      return null;
    }, e.prototype.getProjection = function() {
      return {
        fromContainerPixelToLatLng: function() {
          return null;
        },
        fromDivPixelToLatLng: function() {
          return null;
        },
        fromLatLngToContainerPixel: function() {
          return null;
        },
        fromLatLngToDivPixel: function() {
          return null;
        },
        getVisibleRegion: function() {
          return null;
        },
        getWorldWidth: function() {
          return 0;
        }
      };
    }, e.prototype.setMap = function() {
    }, e.prototype.addListener = function() {
      return {
        remove: function() {
        }
      };
    }, e.prototype.bindTo = function() {
    }, e.prototype.get = function() {
    }, e.prototype.notify = function() {
    }, e.prototype.set = function() {
    }, e.prototype.setValues = function() {
    }, e.prototype.unbind = function() {
    }, e.prototype.unbindAll = function() {
    }, e.prototype.setupStyles = function() {
      if (!(this.styles.length > 0))
        for (var t = 0; t < this.imageSizes.length; t++)
          this.styles.push({
            url: "".concat(this.imagePath + (t + 1), ".").concat(this.imageExtension),
            height: this.imageSizes[t] || 0,
            width: this.imageSizes[t] || 0
          });
    }, e.prototype.fitMapToMarkers = function() {
      for (var t = this.getMarkers(), n = new google.maps.LatLngBounds(), r = 0, i = t; r < i.length; r++) {
        var a = i[r], c = a.getPosition();
        c && n.extend(c);
      }
      var d = this.getMap();
      d !== null && "fitBounds" in d && d.fitBounds(n);
    }, e.prototype.getGridSize = function() {
      return this.gridSize;
    }, e.prototype.setGridSize = function(t) {
      this.gridSize = t;
    }, e.prototype.getMinimumClusterSize = function() {
      return this.minClusterSize;
    }, e.prototype.setMinimumClusterSize = function(t) {
      this.minClusterSize = t;
    }, e.prototype.getMaxZoom = function() {
      return this.maxZoom;
    }, e.prototype.setMaxZoom = function(t) {
      this.maxZoom = t;
    }, e.prototype.getStyles = function() {
      return this.styles;
    }, e.prototype.setStyles = function(t) {
      this.styles = t;
    }, e.prototype.getTitle = function() {
      return this.title;
    }, e.prototype.setTitle = function(t) {
      this.title = t;
    }, e.prototype.getZoomOnClick = function() {
      return this.zoomOnClick;
    }, e.prototype.setZoomOnClick = function(t) {
      this.zoomOnClick = t;
    }, e.prototype.getAverageCenter = function() {
      return this.averageCenter;
    }, e.prototype.setAverageCenter = function(t) {
      this.averageCenter = t;
    }, e.prototype.getIgnoreHidden = function() {
      return this.ignoreHidden;
    }, e.prototype.setIgnoreHidden = function(t) {
      this.ignoreHidden = t;
    }, e.prototype.getEnableRetinaIcons = function() {
      return this.enableRetinaIcons;
    }, e.prototype.setEnableRetinaIcons = function(t) {
      this.enableRetinaIcons = t;
    }, e.prototype.getImageExtension = function() {
      return this.imageExtension;
    }, e.prototype.setImageExtension = function(t) {
      this.imageExtension = t;
    }, e.prototype.getImagePath = function() {
      return this.imagePath;
    }, e.prototype.setImagePath = function(t) {
      this.imagePath = t;
    }, e.prototype.getImageSizes = function() {
      return this.imageSizes;
    }, e.prototype.setImageSizes = function(t) {
      this.imageSizes = t;
    }, e.prototype.getCalculator = function() {
      return this.calculator;
    }, e.prototype.setCalculator = function(t) {
      this.calculator = t;
    }, e.prototype.getBatchSizeIE = function() {
      return this.batchSizeIE;
    }, e.prototype.setBatchSizeIE = function(t) {
      this.batchSizeIE = t;
    }, e.prototype.getClusterClass = function() {
      return this.clusterClass;
    }, e.prototype.setClusterClass = function(t) {
      this.clusterClass = t;
    }, e.prototype.getMarkers = function() {
      return this.markers;
    }, e.prototype.getTotalMarkers = function() {
      return this.markers.length;
    }, e.prototype.getClusters = function() {
      return this.clusters;
    }, e.prototype.getTotalClusters = function() {
      return this.clusters.length;
    }, e.prototype.addMarker = function(t, n) {
      this.pushMarkerTo(t), n || this.redraw();
    }, e.prototype.addMarkers = function(t, n) {
      for (var r in t)
        if (Object.prototype.hasOwnProperty.call(t, r)) {
          var i = t[r];
          i && this.pushMarkerTo(i);
        }
      n || this.redraw();
    }, e.prototype.pushMarkerTo = function(t) {
      var n = this;
      t.getDraggable() && google.maps.event.addListener(t, "dragend", function() {
        n.ready && (t.isAdded = !1, n.repaint());
      }), t.isAdded = !1, this.markers.push(t);
    }, e.prototype.removeMarker_ = function(t) {
      var n = -1;
      if (this.markers.indexOf)
        n = this.markers.indexOf(t);
      else
        for (var r = 0; r < this.markers.length; r++)
          if (t === this.markers[r]) {
            n = r;
            break;
          }
      return n === -1 ? !1 : (t.setMap(null), this.markers.splice(n, 1), !0);
    }, e.prototype.removeMarker = function(t, n) {
      var r = this.removeMarker_(t);
      return !n && r && this.repaint(), r;
    }, e.prototype.removeMarkers = function(t, n) {
      for (var r = !1, i = 0, a = t; i < a.length; i++) {
        var c = a[i];
        r = r || this.removeMarker_(c);
      }
      return !n && r && this.repaint(), r;
    }, e.prototype.clearMarkers = function() {
      this.resetViewport(!0), this.markers = [];
    }, e.prototype.repaint = function() {
      var t = this.clusters.slice();
      this.clusters = [], this.resetViewport(!1), this.redraw(), setTimeout(function() {
        for (var r = 0, i = t; r < i.length; r++) {
          var a = i[r];
          a.remove();
        }
      }, 0);
    }, e.prototype.getExtendedBounds = function(t) {
      var n = this.getProjection(), r = n.fromLatLngToDivPixel(
        // Turn the bounds into latlng.
        new google.maps.LatLng(t.getNorthEast().lat(), t.getNorthEast().lng())
      );
      r !== null && (r.x += this.gridSize, r.y -= this.gridSize);
      var i = n.fromLatLngToDivPixel(
        // Turn the bounds into latlng.
        new google.maps.LatLng(t.getSouthWest().lat(), t.getSouthWest().lng())
      );
      if (i !== null && (i.x -= this.gridSize, i.y += this.gridSize), r !== null) {
        var a = n.fromDivPixelToLatLng(r);
        a !== null && t.extend(a);
      }
      if (i !== null) {
        var c = n.fromDivPixelToLatLng(i);
        c !== null && t.extend(c);
      }
      return t;
    }, e.prototype.redraw = function() {
      this.createClusters(0);
    }, e.prototype.resetViewport = function(t) {
      for (var n = 0, r = this.clusters; n < r.length; n++) {
        var i = r[n];
        i.remove();
      }
      this.clusters = [];
      for (var a = 0, c = this.markers; a < c.length; a++) {
        var d = c[a];
        d.isAdded = !1, t && d.setMap(null);
      }
    }, e.prototype.distanceBetweenPoints = function(t, n) {
      var r = 6371, i = (n.lat() - t.lat()) * Math.PI / 180, a = (n.lng() - t.lng()) * Math.PI / 180, c = Math.sin(i / 2) * Math.sin(i / 2) + Math.cos(t.lat() * Math.PI / 180) * Math.cos(n.lat() * Math.PI / 180) * Math.sin(a / 2) * Math.sin(a / 2);
      return r * (2 * Math.atan2(Math.sqrt(c), Math.sqrt(1 - c)));
    }, e.prototype.isMarkerInBounds = function(t, n) {
      var r = t.getPosition();
      return r ? n.contains(r) : !1;
    }, e.prototype.addToClosestCluster = function(t) {
      for (var n, r = 4e4, i = null, a = 0, c = this.clusters; a < c.length; a++) {
        var d = c[a];
        n = d;
        var f = n.getCenter(), p = t.getPosition();
        if (f && p) {
          var m = this.distanceBetweenPoints(f, p);
          m < r && (r = m, i = n);
        }
      }
      i && i.isMarkerInClusterBounds(t) ? i.addMarker(t) : (n = new lG(this), n.addMarker(t), this.clusters.push(n));
    }, e.prototype.createClusters = function(t) {
      var n = this;
      if (this.ready) {
        t === 0 && (google.maps.event.trigger(this, "clusteringbegin", this), this.timerRefStatic !== null && (window.clearTimeout(this.timerRefStatic), delete this.timerRefStatic));
        for (var r = this.getMap(), i = r !== null && ("getBounds" in r) ? r.getBounds() : null, a = (r == null ? void 0 : r.getZoom()) || 0, c = a > 3 ? new google.maps.LatLngBounds(i == null ? void 0 : i.getSouthWest(), i == null ? void 0 : i.getNorthEast()) : new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625)), d = this.getExtendedBounds(c), f = Math.min(t + this.batchSize, this.markers.length), p = t; p < f; p++) {
          var m = this.markers[p];
          m && !m.isAdded && this.isMarkerInBounds(m, d) && (!this.ignoreHidden || this.ignoreHidden && m.getVisible()) && this.addToClosestCluster(m);
        }
        if (f < this.markers.length)
          this.timerRefStatic = window.setTimeout(function() {
            n.createClusters(f);
          }, 0);
        else {
          this.timerRefStatic = null, google.maps.event.trigger(this, "clusteringend", this);
          for (var v = 0, g = this.clusters; v < g.length; v++) {
            var w = g[v];
            w.updateIcon();
          }
        }
      }
    }, e.prototype.extend = function(t, n) {
      return (function(i) {
        for (var a in i.prototype) {
          var c = a;
          this.prototype[c] = i.prototype[c];
        }
        return this;
      }).apply(t, [n]);
    }, e;
  }()
);
function Yd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function hG(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Yd(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Yd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Pn = {
  onClick: "click",
  onClusteringBegin: "clusteringbegin",
  onClusteringEnd: "clusteringend",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover"
}, rt = {
  averageCenter(e, t) {
    e.setAverageCenter(t);
  },
  batchSizeIE(e, t) {
    e.setBatchSizeIE(t);
  },
  calculator(e, t) {
    e.setCalculator(t);
  },
  clusterClass(e, t) {
    e.setClusterClass(t);
  },
  enableRetinaIcons(e, t) {
    e.setEnableRetinaIcons(t);
  },
  gridSize(e, t) {
    e.setGridSize(t);
  },
  ignoreHidden(e, t) {
    e.setIgnoreHidden(t);
  },
  imageExtension(e, t) {
    e.setImageExtension(t);
  },
  imagePath(e, t) {
    e.setImagePath(t);
  },
  imageSizes(e, t) {
    e.setImageSizes(t);
  },
  maxZoom(e, t) {
    e.setMaxZoom(t);
  },
  minimumClusterSize(e, t) {
    e.setMinimumClusterSize(t);
  },
  styles(e, t) {
    e.setStyles(t);
  },
  title(e, t) {
    e.setTitle(t);
  },
  zoomOnClick(e, t) {
    e.setZoomOnClick(t);
  }
}, pG = {};
function mG(e) {
  var {
    children: t,
    options: n,
    averageCenter: r,
    batchSizeIE: i,
    calculator: a,
    clusterClass: c,
    enableRetinaIcons: d,
    gridSize: f,
    ignoreHidden: p,
    imageExtension: m,
    imagePath: v,
    imageSizes: g,
    maxZoom: w,
    minimumClusterSize: x,
    styles: b,
    title: y,
    zoomOnClick: E,
    onClick: z,
    onClusteringBegin: k,
    onClusteringEnd: R,
    onMouseOver: F,
    onMouseOut: _,
    onLoad: P,
    onUnmount: O
  } = e, [Z, te] = q(null), Y = pt($e), [X, re] = q(null), [ee, de] = q(null), [ae, ge] = q(null), [K, J] = q(null), [he, ve] = q(null);
  return T(() => {
    Z && _ && (K !== null && google.maps.event.removeListener(K), J(google.maps.event.addListener(Z, Pn.onMouseOut, _)));
  }, [_]), T(() => {
    Z && F && (he !== null && google.maps.event.removeListener(he), ve(google.maps.event.addListener(Z, Pn.onMouseOver, F)));
  }, [F]), T(() => {
    Z && z && (X !== null && google.maps.event.removeListener(X), re(google.maps.event.addListener(Z, Pn.onClick, z)));
  }, [z]), T(() => {
    Z && k && (ee !== null && google.maps.event.removeListener(ee), de(google.maps.event.addListener(Z, Pn.onClusteringBegin, k)));
  }, [k]), T(() => {
    Z && R && (ae !== null && google.maps.event.removeListener(ae), de(google.maps.event.addListener(Z, Pn.onClusteringEnd, R)));
  }, [R]), T(() => {
    typeof r < "u" && Z !== null && rt.averageCenter(Z, r);
  }, [Z, r]), T(() => {
    typeof i < "u" && Z !== null && rt.batchSizeIE(Z, i);
  }, [Z, i]), T(() => {
    typeof a < "u" && Z !== null && rt.calculator(Z, a);
  }, [Z, a]), T(() => {
    typeof c < "u" && Z !== null && rt.clusterClass(Z, c);
  }, [Z, c]), T(() => {
    typeof d < "u" && Z !== null && rt.enableRetinaIcons(Z, d);
  }, [Z, d]), T(() => {
    typeof f < "u" && Z !== null && rt.gridSize(Z, f);
  }, [Z, f]), T(() => {
    typeof p < "u" && Z !== null && rt.ignoreHidden(Z, p);
  }, [Z, p]), T(() => {
    typeof m < "u" && Z !== null && rt.imageExtension(Z, m);
  }, [Z, m]), T(() => {
    typeof v < "u" && Z !== null && rt.imagePath(Z, v);
  }, [Z, v]), T(() => {
    typeof g < "u" && Z !== null && rt.imageSizes(Z, g);
  }, [Z, g]), T(() => {
    typeof w < "u" && Z !== null && rt.maxZoom(Z, w);
  }, [Z, w]), T(() => {
    typeof x < "u" && Z !== null && rt.minimumClusterSize(Z, x);
  }, [Z, x]), T(() => {
    typeof b < "u" && Z !== null && rt.styles(Z, b);
  }, [Z, b]), T(() => {
    typeof y < "u" && Z !== null && rt.title(Z, y);
  }, [Z, y]), T(() => {
    typeof E < "u" && Z !== null && rt.zoomOnClick(Z, E);
  }, [Z, E]), T(() => {
    if (Y) {
      var Q = hG({}, n || pG), ie = new yf(Y, [], Q);
      return r && rt.averageCenter(ie, r), i && rt.batchSizeIE(ie, i), a && rt.calculator(ie, a), c && rt.clusterClass(ie, c), d && rt.enableRetinaIcons(ie, d), f && rt.gridSize(ie, f), p && rt.ignoreHidden(ie, p), m && rt.imageExtension(ie, m), v && rt.imagePath(ie, v), g && rt.imageSizes(ie, g), w && rt.maxZoom(ie, w), x && rt.minimumClusterSize(ie, x), b && rt.styles(ie, b), y && rt.title(ie, y), E && rt.zoomOnClick(ie, E), _ && J(google.maps.event.addListener(ie, Pn.onMouseOut, _)), F && ve(google.maps.event.addListener(ie, Pn.onMouseOver, F)), z && re(google.maps.event.addListener(ie, Pn.onClick, z)), k && de(google.maps.event.addListener(ie, Pn.onClusteringBegin, k)), R && ge(google.maps.event.addListener(ie, Pn.onClusteringEnd, R)), te(ie), P && P(ie), () => {
        K !== null && google.maps.event.removeListener(K), he !== null && google.maps.event.removeListener(he), X !== null && google.maps.event.removeListener(X), ee !== null && google.maps.event.removeListener(ee), ae !== null && google.maps.event.removeListener(ae), O && O(ie);
      };
    }
  }, []), Z !== null && t(Z) || null;
}
Rt(mG);
class vG extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []), le(this, "state", {
      markerClusterer: null
    }), le(this, "setClustererCallback", () => {
      this.state.markerClusterer !== null && this.props.onLoad && this.props.onLoad(this.state.markerClusterer);
    });
  }
  componentDidMount() {
    if (this.context) {
      var t = new yf(this.context, [], this.props.options);
      this.registeredEvents = Ke({
        updaterMap: rt,
        eventMap: Pn,
        prevProps: {},
        nextProps: this.props,
        instance: t
      }), this.setState(() => ({
        markerClusterer: t
      }), this.setClustererCallback);
    }
  }
  componentDidUpdate(t) {
    this.state.markerClusterer && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: rt,
      eventMap: Pn,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.markerClusterer
    }));
  }
  componentWillUnmount() {
    this.state.markerClusterer !== null && (this.props.onUnmount && this.props.onUnmount(this.state.markerClusterer), Je(this.registeredEvents), this.state.markerClusterer.setMap(null));
  }
  render() {
    return this.state.markerClusterer !== null ? this.props.children(this.state.markerClusterer) : null;
  }
}
le(vG, "contextType", $e);
function qd(e) {
  e.cancelBubble = !0, e.stopPropagation && e.stopPropagation();
}
var Cf = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {}), this.getCloseClickHandler = this.getCloseClickHandler.bind(this), this.closeClickHandler = this.closeClickHandler.bind(this), this.createInfoBoxDiv = this.createInfoBoxDiv.bind(this), this.addClickHandler = this.addClickHandler.bind(this), this.getCloseBoxImg = this.getCloseBoxImg.bind(this), this.getBoxWidths = this.getBoxWidths.bind(this), this.setBoxStyle = this.setBoxStyle.bind(this), this.setPosition = this.setPosition.bind(this), this.getPosition = this.getPosition.bind(this), this.setOptions = this.setOptions.bind(this), this.setContent = this.setContent.bind(this), this.setVisible = this.setVisible.bind(this), this.getContent = this.getContent.bind(this), this.getVisible = this.getVisible.bind(this), this.setZIndex = this.setZIndex.bind(this), this.getZIndex = this.getZIndex.bind(this), this.onRemove = this.onRemove.bind(this), this.panBox = this.panBox.bind(this), this.extend = this.extend.bind(this), this.close = this.close.bind(this), this.draw = this.draw.bind(this), this.show = this.show.bind(this), this.hide = this.hide.bind(this), this.open = this.open.bind(this), this.extend(e, google.maps.OverlayView), this.content = t.content || "", this.disableAutoPan = t.disableAutoPan || !1, this.maxWidth = t.maxWidth || 0, this.pixelOffset = t.pixelOffset || new google.maps.Size(0, 0), this.position = t.position || new google.maps.LatLng(0, 0), this.zIndex = t.zIndex || null, this.boxClass = t.boxClass || "infoBox", this.boxStyle = t.boxStyle || {}, this.closeBoxMargin = t.closeBoxMargin || "2px", this.closeBoxURL = t.closeBoxURL || "http://www.google.com/intl/en_us/mapfiles/close.gif", t.closeBoxURL === "" && (this.closeBoxURL = ""), this.infoBoxClearance = t.infoBoxClearance || new google.maps.Size(1, 1), typeof t.visible > "u" && (typeof t.isHidden > "u" ? t.visible = !0 : t.visible = !t.isHidden), this.isHidden = !t.visible, this.alignBottom = t.alignBottom || !1, this.pane = t.pane || "floatPane", this.enableEventPropagation = t.enableEventPropagation || !1, this.div = null, this.closeListener = null, this.moveListener = null, this.mapListener = null, this.contextListener = null, this.eventListeners = null, this.fixedWidthSet = null;
    }
    return e.prototype.createInfoBoxDiv = function() {
      var t = this, n = function(m) {
        m.returnValue = !1, m.preventDefault && m.preventDefault(), t.enableEventPropagation || qd(m);
      };
      if (!this.div) {
        this.div = document.createElement("div"), this.setBoxStyle(), typeof this.content == "string" ? this.div.innerHTML = this.getCloseBoxImg() + this.content : (this.div.innerHTML = this.getCloseBoxImg(), this.div.appendChild(this.content));
        var r = this.getPanes();
        if (r !== null && r[this.pane].appendChild(this.div), this.addClickHandler(), this.div.style.width)
          this.fixedWidthSet = !0;
        else if (this.maxWidth !== 0 && this.div.offsetWidth > this.maxWidth)
          this.div.style.width = this.maxWidth + "px", this.fixedWidthSet = !0;
        else {
          var i = this.getBoxWidths();
          this.div.style.width = this.div.offsetWidth - i.left - i.right + "px", this.fixedWidthSet = !1;
        }
        if (this.panBox(this.disableAutoPan), !this.enableEventPropagation) {
          this.eventListeners = [];
          for (var a = ["mousedown", "mouseover", "mouseout", "mouseup", "click", "dblclick", "touchstart", "touchend", "touchmove"], c = 0, d = a; c < d.length; c++) {
            var f = d[c];
            this.eventListeners.push(google.maps.event.addListener(this.div, f, qd));
          }
          this.eventListeners.push(google.maps.event.addListener(this.div, "mouseover", function() {
            t.div && (t.div.style.cursor = "default");
          }));
        }
        this.contextListener = google.maps.event.addListener(this.div, "contextmenu", n), google.maps.event.trigger(this, "domready");
      }
    }, e.prototype.getCloseBoxImg = function() {
      var t = "";
      return this.closeBoxURL !== "" && (t = '<img alt=""', t += ' aria-hidden="true"', t += " src='" + this.closeBoxURL + "'", t += " align=right", t += " style='", t += " position: relative;", t += " cursor: pointer;", t += " margin: " + this.closeBoxMargin + ";", t += "'>"), t;
    }, e.prototype.addClickHandler = function() {
      this.closeListener = this.div && this.div.firstChild && this.closeBoxURL !== "" ? google.maps.event.addListener(this.div.firstChild, "click", this.getCloseClickHandler()) : null;
    }, e.prototype.closeClickHandler = function(t) {
      t.cancelBubble = !0, t.stopPropagation && t.stopPropagation(), google.maps.event.trigger(this, "closeclick"), this.close();
    }, e.prototype.getCloseClickHandler = function() {
      return this.closeClickHandler;
    }, e.prototype.panBox = function(t) {
      if (this.div && !t) {
        var n = this.getMap();
        if (n instanceof google.maps.Map) {
          var r = 0, i = 0, a = n.getBounds();
          a && !a.contains(this.position) && n.setCenter(this.position);
          var c = n.getDiv(), d = c.offsetWidth, f = c.offsetHeight, p = this.pixelOffset.width, m = this.pixelOffset.height, v = this.div.offsetWidth, g = this.div.offsetHeight, w = this.infoBoxClearance.width, x = this.infoBoxClearance.height, b = this.getProjection(), y = b.fromLatLngToContainerPixel(this.position);
          y !== null && (y.x < -p + w ? r = y.x + p - w : y.x + v + p + w > d && (r = y.x + v + p + w - d), this.alignBottom ? y.y < -m + x + g ? i = y.y + m - x - g : y.y + m + x > f && (i = y.y + m + x - f) : y.y < -m + x ? i = y.y + m - x : y.y + g + m + x > f && (i = y.y + g + m + x - f)), r === 0 && i === 0 || n.panBy(r, i);
        }
      }
    }, e.prototype.setBoxStyle = function() {
      if (this.div) {
        this.div.className = this.boxClass, this.div.style.cssText = "";
        var t = this.boxStyle;
        for (var n in t)
          Object.prototype.hasOwnProperty.call(t, n) && (this.div.style[n] = t[n]);
        if (this.div.style.webkitTransform = "translateZ(0)", typeof this.div.style.opacity < "u" && this.div.style.opacity !== "") {
          var r = parseFloat(this.div.style.opacity || "");
          this.div.style.msFilter = '"progid:DXImageTransform.Microsoft.Alpha(Opacity=' + r * 100 + ')"', this.div.style.filter = "alpha(opacity=" + r * 100 + ")";
        }
        this.div.style.position = "absolute", this.div.style.visibility = "hidden", this.zIndex !== null && (this.div.style.zIndex = this.zIndex + ""), this.div.style.overflow || (this.div.style.overflow = "auto");
      }
    }, e.prototype.getBoxWidths = function() {
      var t = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      };
      if (!this.div)
        return t;
      if (document.defaultView) {
        var n = this.div.ownerDocument, r = n && n.defaultView ? n.defaultView.getComputedStyle(this.div, "") : null;
        r && (t.top = parseInt(r.borderTopWidth || "", 10) || 0, t.bottom = parseInt(r.borderBottomWidth || "", 10) || 0, t.left = parseInt(r.borderLeftWidth || "", 10) || 0, t.right = parseInt(r.borderRightWidth || "", 10) || 0);
      } else if (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        document.documentElement.currentStyle
      ) {
        var i = this.div.currentStyle;
        i && (t.top = parseInt(i.borderTopWidth || "", 10) || 0, t.bottom = parseInt(i.borderBottomWidth || "", 10) || 0, t.left = parseInt(i.borderLeftWidth || "", 10) || 0, t.right = parseInt(i.borderRightWidth || "", 10) || 0);
      }
      return t;
    }, e.prototype.onRemove = function() {
      this.div && this.div.parentNode && (this.div.parentNode.removeChild(this.div), this.div = null);
    }, e.prototype.draw = function() {
      if (this.createInfoBoxDiv(), this.div) {
        var t = this.getProjection(), n = t.fromLatLngToDivPixel(this.position);
        n !== null && (this.div.style.left = n.x + this.pixelOffset.width + "px", this.alignBottom ? this.div.style.bottom = -(n.y + this.pixelOffset.height) + "px" : this.div.style.top = n.y + this.pixelOffset.height + "px"), this.isHidden ? this.div.style.visibility = "hidden" : this.div.style.visibility = "visible";
      }
    }, e.prototype.setOptions = function(t) {
      t === void 0 && (t = {}), typeof t.boxClass < "u" && (this.boxClass = t.boxClass, this.setBoxStyle()), typeof t.boxStyle < "u" && (this.boxStyle = t.boxStyle, this.setBoxStyle()), typeof t.content < "u" && this.setContent(t.content), typeof t.disableAutoPan < "u" && (this.disableAutoPan = t.disableAutoPan), typeof t.maxWidth < "u" && (this.maxWidth = t.maxWidth), typeof t.pixelOffset < "u" && (this.pixelOffset = t.pixelOffset), typeof t.alignBottom < "u" && (this.alignBottom = t.alignBottom), typeof t.position < "u" && this.setPosition(t.position), typeof t.zIndex < "u" && this.setZIndex(t.zIndex), typeof t.closeBoxMargin < "u" && (this.closeBoxMargin = t.closeBoxMargin), typeof t.closeBoxURL < "u" && (this.closeBoxURL = t.closeBoxURL), typeof t.infoBoxClearance < "u" && (this.infoBoxClearance = t.infoBoxClearance), typeof t.isHidden < "u" && (this.isHidden = t.isHidden), typeof t.visible < "u" && (this.isHidden = !t.visible), typeof t.enableEventPropagation < "u" && (this.enableEventPropagation = t.enableEventPropagation), this.div && this.draw();
    }, e.prototype.setContent = function(t) {
      this.content = t, this.div && (this.closeListener && (google.maps.event.removeListener(this.closeListener), this.closeListener = null), this.fixedWidthSet || (this.div.style.width = ""), typeof t == "string" ? this.div.innerHTML = this.getCloseBoxImg() + t : (this.div.innerHTML = this.getCloseBoxImg(), this.div.appendChild(t)), this.fixedWidthSet || (this.div.style.width = this.div.offsetWidth + "px", typeof t == "string" ? this.div.innerHTML = this.getCloseBoxImg() + t : (this.div.innerHTML = this.getCloseBoxImg(), this.div.appendChild(t))), this.addClickHandler()), google.maps.event.trigger(this, "content_changed");
    }, e.prototype.setPosition = function(t) {
      this.position = t, this.div && this.draw(), google.maps.event.trigger(this, "position_changed");
    }, e.prototype.setVisible = function(t) {
      this.isHidden = !t, this.div && (this.div.style.visibility = this.isHidden ? "hidden" : "visible");
    }, e.prototype.setZIndex = function(t) {
      this.zIndex = t, this.div && (this.div.style.zIndex = t + ""), google.maps.event.trigger(this, "zindex_changed");
    }, e.prototype.getContent = function() {
      return this.content;
    }, e.prototype.getPosition = function() {
      return this.position;
    }, e.prototype.getZIndex = function() {
      return this.zIndex;
    }, e.prototype.getVisible = function() {
      var t = this.getMap();
      return typeof t > "u" || t === null ? !1 : !this.isHidden;
    }, e.prototype.show = function() {
      this.isHidden = !1, this.div && (this.div.style.visibility = "visible");
    }, e.prototype.hide = function() {
      this.isHidden = !0, this.div && (this.div.style.visibility = "hidden");
    }, e.prototype.open = function(t, n) {
      var r = this;
      n && (this.position = n.getPosition(), this.moveListener = google.maps.event.addListener(n, "position_changed", function() {
        var i = n.getPosition();
        r.setPosition(i);
      }), this.mapListener = google.maps.event.addListener(n, "map_changed", function() {
        r.setMap(n.map);
      })), this.setMap(t), this.div && this.panBox();
    }, e.prototype.close = function() {
      if (this.closeListener && (google.maps.event.removeListener(this.closeListener), this.closeListener = null), this.eventListeners) {
        for (var t = 0, n = this.eventListeners; t < n.length; t++) {
          var r = n[t];
          google.maps.event.removeListener(r);
        }
        this.eventListeners = null;
      }
      this.moveListener && (google.maps.event.removeListener(this.moveListener), this.moveListener = null), this.mapListener && (google.maps.event.removeListener(this.mapListener), this.mapListener = null), this.contextListener && (google.maps.event.removeListener(this.contextListener), this.contextListener = null), this.setMap(null);
    }, e.prototype.extend = function(t, n) {
      return (function(i) {
        for (var a in i.prototype)
          Object.prototype.hasOwnProperty.call(this, a) || (this.prototype[a] = i.prototype[a]);
        return this;
      }).apply(t, [n]);
    }, e;
  }()
), gG = ["position"], LG = ["position"];
function Xd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ul(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xd(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Jd = {
  onCloseClick: "closeclick",
  onContentChanged: "content_changed",
  onDomReady: "domready",
  onPositionChanged: "position_changed",
  onZindexChanged: "zindex_changed"
}, Qd = {
  options(e, t) {
    e.setOptions(t);
  },
  position(e, t) {
    t instanceof google.maps.LatLng ? e.setPosition(t) : e.setPosition(new google.maps.LatLng(t.lat, t.lng));
  },
  visible(e, t) {
    e.setVisible(t);
  },
  zIndex(e, t) {
    e.setZIndex(t);
  }
}, wG = {};
function MG(e) {
  var {
    children: t,
    anchor: n,
    options: r,
    position: i,
    zIndex: a,
    onCloseClick: c,
    onDomReady: d,
    onContentChanged: f,
    onPositionChanged: p,
    onZindexChanged: m,
    onLoad: v,
    onUnmount: g
  } = e, w = pt($e), [x, b] = q(null), [y, E] = q(null), [z, k] = q(null), [R, F] = q(null), [_, P] = q(null), [O, Z] = q(null), te = It(null);
  return T(() => {
    w && x !== null && (x.close(), n ? x.open(w, n) : x.getPosition() && x.open(w));
  }, [w, x, n]), T(() => {
    r && x !== null && x.setOptions(r);
  }, [x, r]), T(() => {
    if (i && x !== null) {
      var Y = i instanceof google.maps.LatLng ? i : (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        new google.maps.LatLng(i.lat, i.lng)
      );
      x.setPosition(Y);
    }
  }, [i]), T(() => {
    typeof a == "number" && x !== null && x.setZIndex(a);
  }, [a]), T(() => {
    x && c && (y !== null && google.maps.event.removeListener(y), E(google.maps.event.addListener(x, "closeclick", c)));
  }, [c]), T(() => {
    x && d && (z !== null && google.maps.event.removeListener(z), k(google.maps.event.addListener(x, "domready", d)));
  }, [d]), T(() => {
    x && f && (R !== null && google.maps.event.removeListener(R), F(google.maps.event.addListener(x, "content_changed", f)));
  }, [f]), T(() => {
    x && p && (_ !== null && google.maps.event.removeListener(_), P(google.maps.event.addListener(x, "position_changed", p)));
  }, [p]), T(() => {
    x && m && (O !== null && google.maps.event.removeListener(O), Z(google.maps.event.addListener(x, "zindex_changed", m)));
  }, [m]), T(() => {
    if (w) {
      var Y = r || wG, {
        position: X
      } = Y, re = $3(Y, gG), ee;
      X && !(X instanceof google.maps.LatLng) && (ee = new google.maps.LatLng(X.lat, X.lng));
      var de = new Cf(ul(ul({}, re), ee ? {
        position: ee
      } : {}));
      te.current = document.createElement("div"), b(de), c && E(google.maps.event.addListener(de, "closeclick", c)), d && k(google.maps.event.addListener(de, "domready", d)), f && F(google.maps.event.addListener(de, "content_changed", f)), p && P(google.maps.event.addListener(de, "position_changed", p)), m && Z(google.maps.event.addListener(de, "zindex_changed", m)), de.setContent(te.current), n ? de.open(w, n) : de.getPosition() ? de.open(w) : Dt(!1, "You must provide either an anchor or a position prop for <InfoBox>."), v && v(de);
    }
    return () => {
      x !== null && (y && google.maps.event.removeListener(y), R && google.maps.event.removeListener(R), z && google.maps.event.removeListener(z), _ && google.maps.event.removeListener(_), O && google.maps.event.removeListener(O), g && g(x), x.close());
    };
  }, []), te.current ? yl(jt.only(t), te.current) : null;
}
Rt(MG);
class xG extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []), le(this, "containerElement", null), le(this, "state", {
      infoBox: null
    }), le(this, "open", (t, n) => {
      n ? this.context !== null && t.open(this.context, n) : t.getPosition() ? this.context !== null && t.open(this.context) : Dt(!1, "You must provide either an anchor or a position prop for <InfoBox>.");
    }), le(this, "setInfoBoxCallback", () => {
      this.state.infoBox !== null && this.containerElement !== null && (this.state.infoBox.setContent(this.containerElement), this.open(this.state.infoBox, this.props.anchor), this.props.onLoad && this.props.onLoad(this.state.infoBox));
    });
  }
  componentDidMount() {
    var t = this.props.options || {}, {
      position: n
    } = t, r = $3(t, LG), i;
    n && !(n instanceof google.maps.LatLng) && (i = new google.maps.LatLng(n.lat, n.lng));
    var a = new Cf(ul(ul({}, r), i ? {
      position: i
    } : {}));
    this.containerElement = document.createElement("div"), this.registeredEvents = Ke({
      updaterMap: Qd,
      eventMap: Jd,
      prevProps: {},
      nextProps: this.props,
      instance: a
    }), this.setState({
      infoBox: a
    }, this.setInfoBoxCallback);
  }
  componentDidUpdate(t) {
    var {
      infoBox: n
    } = this.state;
    n !== null && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: Qd,
      eventMap: Jd,
      prevProps: t,
      nextProps: this.props,
      instance: n
    }));
  }
  componentWillUnmount() {
    var {
      onUnmount: t
    } = this.props, {
      infoBox: n
    } = this.state;
    n !== null && (t && t(n), Je(this.registeredEvents), n.close());
  }
  render() {
    return this.containerElement ? yl(jt.only(this.props.children), this.containerElement) : null;
  }
}
le(xG, "contextType", $e);
var Ta, eu;
function bG() {
  return eu || (eu = 1, Ta = function e(t, n) {
    if (t === n) return !0;
    if (t && n && typeof t == "object" && typeof n == "object") {
      if (t.constructor !== n.constructor) return !1;
      var r, i, a;
      if (Array.isArray(t)) {
        if (r = t.length, r != n.length) return !1;
        for (i = r; i-- !== 0; ) if (!e(t[i], n[i])) return !1;
        return !0;
      }
      if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
      if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
      if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
      if (a = Object.keys(t), r = a.length, r !== Object.keys(n).length) return !1;
      for (i = r; i-- !== 0; ) if (!Object.prototype.hasOwnProperty.call(n, a[i])) return !1;
      for (i = r; i-- !== 0; ) {
        var c = a[i];
        if (!e(t[c], n[c])) return !1;
      }
      return !0;
    }
    return t !== t && n !== n;
  }), Ta;
}
var yG = bG(), tu = /* @__PURE__ */ Lf(yG), nu = [Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array], Va = 1, ni = 8;
class W3 {
  /**
   * Creates an index from raw `ArrayBuffer` data.
   * @param {ArrayBuffer} data
   */
  static from(t) {
    if (!(t instanceof ArrayBuffer))
      throw new Error("Data must be an instance of ArrayBuffer.");
    var [n, r] = new Uint8Array(t, 0, 2);
    if (n !== 219)
      throw new Error("Data does not appear to be in a KDBush format.");
    var i = r >> 4;
    if (i !== Va)
      throw new Error("Got v".concat(i, " data when expected v").concat(Va, "."));
    var a = nu[r & 15];
    if (!a)
      throw new Error("Unrecognized array type.");
    var [c] = new Uint16Array(t, 2, 1), [d] = new Uint32Array(t, 4, 1);
    return new W3(d, c, a, t);
  }
  /**
   * Creates an index that will hold a given number of items.
   * @param {number} numItems
   * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
   * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
   * @param {ArrayBuffer} [data] (For internal use only)
   */
  constructor(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 64, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Float64Array, i = arguments.length > 3 ? arguments[3] : void 0;
    if (isNaN(t) || t < 0) throw new Error("Unpexpected numItems value: ".concat(t, "."));
    this.numItems = +t, this.nodeSize = Math.min(Math.max(+n, 2), 65535), this.ArrayType = r, this.IndexArrayType = t < 65536 ? Uint16Array : Uint32Array;
    var a = nu.indexOf(this.ArrayType), c = t * 2 * this.ArrayType.BYTES_PER_ELEMENT, d = t * this.IndexArrayType.BYTES_PER_ELEMENT, f = (8 - d % 8) % 8;
    if (a < 0)
      throw new Error("Unexpected typed array class: ".concat(r, "."));
    i && i instanceof ArrayBuffer ? (this.data = i, this.ids = new this.IndexArrayType(this.data, ni, t), this.coords = new this.ArrayType(this.data, ni + d + f, t * 2), this._pos = t * 2, this._finished = !0) : (this.data = new ArrayBuffer(ni + c + d + f), this.ids = new this.IndexArrayType(this.data, ni, t), this.coords = new this.ArrayType(this.data, ni + d + f, t * 2), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([219, (Va << 4) + a]), new Uint16Array(this.data, 2, 1)[0] = n, new Uint32Array(this.data, 4, 1)[0] = t);
  }
  /**
   * Add a point to the index.
   * @param {number} x
   * @param {number} y
   * @returns {number} An incremental index associated with the added item (starting from `0`).
   */
  add(t, n) {
    var r = this._pos >> 1;
    return this.ids[r] = r, this.coords[this._pos++] = t, this.coords[this._pos++] = n, r;
  }
  /**
   * Perform indexing of the added points.
   */
  finish() {
    var t = this._pos >> 1;
    if (t !== this.numItems)
      throw new Error("Added ".concat(t, " items when expected ").concat(this.numItems, "."));
    return bs(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
  }
  /**
   * Search the index for items within a given bounding box.
   * @param {number} minX
   * @param {number} minY
   * @param {number} maxX
   * @param {number} maxY
   * @returns {number[]} An array of indices correponding to the found items.
   */
  range(t, n, r, i) {
    if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
    for (var {
      ids: a,
      coords: c,
      nodeSize: d
    } = this, f = [0, a.length - 1, 0], p = []; f.length; ) {
      var m = f.pop() || 0, v = f.pop() || 0, g = f.pop() || 0;
      if (v - g <= d) {
        for (var w = g; w <= v; w++) {
          var x = c[2 * w], b = c[2 * w + 1];
          x >= t && x <= r && b >= n && b <= i && p.push(a[w]);
        }
        continue;
      }
      var y = g + v >> 1, E = c[2 * y], z = c[2 * y + 1];
      E >= t && E <= r && z >= n && z <= i && p.push(a[y]), (m === 0 ? t <= E : n <= z) && (f.push(g), f.push(y - 1), f.push(1 - m)), (m === 0 ? r >= E : i >= z) && (f.push(y + 1), f.push(v), f.push(1 - m));
    }
    return p;
  }
  /**
   * Search the index for items within a given radius.
   * @param {number} qx
   * @param {number} qy
   * @param {number} r Query radius.
   * @returns {number[]} An array of indices correponding to the found items.
   */
  within(t, n, r) {
    if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
    for (var {
      ids: i,
      coords: a,
      nodeSize: c
    } = this, d = [0, i.length - 1, 0], f = [], p = r * r; d.length; ) {
      var m = d.pop() || 0, v = d.pop() || 0, g = d.pop() || 0;
      if (v - g <= c) {
        for (var w = g; w <= v; w++)
          ru(a[2 * w], a[2 * w + 1], t, n) <= p && f.push(i[w]);
        continue;
      }
      var x = g + v >> 1, b = a[2 * x], y = a[2 * x + 1];
      ru(b, y, t, n) <= p && f.push(i[x]), (m === 0 ? t - r <= b : n - r <= y) && (d.push(g), d.push(x - 1), d.push(1 - m)), (m === 0 ? t + r >= b : n + r >= y) && (d.push(x + 1), d.push(v), d.push(1 - m));
    }
    return f;
  }
}
function bs(e, t, n, r, i, a) {
  if (!(i - r <= n)) {
    var c = r + i >> 1;
    Ef(e, t, c, r, i, a), bs(e, t, n, r, c - 1, 1 - a), bs(e, t, n, c + 1, i, 1 - a);
  }
}
function Ef(e, t, n, r, i, a) {
  for (; i > r; ) {
    if (i - r > 600) {
      var c = i - r + 1, d = n - r + 1, f = Math.log(c), p = 0.5 * Math.exp(2 * f / 3), m = 0.5 * Math.sqrt(f * p * (c - p) / c) * (d - c / 2 < 0 ? -1 : 1), v = Math.max(r, Math.floor(n - d * p / c + m)), g = Math.min(i, Math.floor(n + (c - d) * p / c + m));
      Ef(e, t, n, v, g, a);
    }
    var w = t[2 * n + a], x = r, b = i;
    for (ri(e, t, r, n), t[2 * i + a] > w && ri(e, t, r, i); x < b; ) {
      for (ri(e, t, x, b), x++, b--; t[2 * x + a] < w; ) x++;
      for (; t[2 * b + a] > w; ) b--;
    }
    t[2 * r + a] === w ? ri(e, t, r, b) : (b++, ri(e, t, b, i)), b <= n && (r = b + 1), n <= b && (i = b - 1);
  }
}
function ri(e, t, n, r) {
  Za(e, n, r), Za(t, 2 * n, 2 * r), Za(t, 2 * n + 1, 2 * r + 1);
}
function Za(e, t, n) {
  var r = e[t];
  e[t] = e[n], e[n] = r;
}
function ru(e, t, n, r) {
  var i = e - n, a = t - r;
  return i * i + a * a;
}
var CG = {
  minZoom: 0,
  // min zoom to generate clusters on
  maxZoom: 16,
  // max zoom level to cluster the points on
  minPoints: 2,
  // minimum points to form a cluster
  radius: 40,
  // cluster radius in pixels
  extent: 512,
  // tile extent (radius is calculated relative to it)
  nodeSize: 64,
  // size of the KD-tree leaf node, affects performance
  log: !1,
  // whether to log timing info
  // whether to generate numeric ids for input features (in vector tiles)
  generateId: !1,
  // a reduce function for calculating custom cluster properties
  reduce: null,
  // (accumulated, props) => { accumulated.sum += props.sum; }
  // properties to use for individual points when running the reducer
  map: (e) => e
  // props => ({sum: props.my_value})
}, iu = Math.fround || /* @__PURE__ */ ((e) => (t) => (e[0] = +t, e[0]))(new Float32Array(1)), Sr = 2, rr = 3, $a = 4, tr = 5, Ff = 6;
class EG {
  constructor(t) {
    this.options = Object.assign(Object.create(CG), t), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
  }
  load(t) {
    var {
      log: n,
      minZoom: r,
      maxZoom: i
    } = this.options;
    n && console.time("total time");
    var a = "prepare ".concat(t.length, " points");
    n && console.time(a), this.points = t;
    for (var c = [], d = 0; d < t.length; d++) {
      var f = t[d];
      if (f.geometry) {
        var [p, m] = f.geometry.coordinates, v = iu(V0(p)), g = iu(Z0(m));
        c.push(
          v,
          g,
          // projected point coordinates
          1 / 0,
          // the last zoom the point was processed at
          d,
          // index of the source feature in the original input array
          -1,
          // parent cluster id
          1
          // number of points in a cluster
        ), this.options.reduce && c.push(0);
      }
    }
    var w = this.trees[i + 1] = this._createTree(c);
    n && console.timeEnd(a);
    for (var x = i; x >= r; x--) {
      var b = +Date.now();
      w = this.trees[x] = this._createTree(this._cluster(w, x)), n && console.log("z%d: %d clusters in %dms", x, w.numItems, +Date.now() - b);
    }
    return n && console.timeEnd("total time"), this;
  }
  getClusters(t, n) {
    var r = ((t[0] + 180) % 360 + 360) % 360 - 180, i = Math.max(-90, Math.min(90, t[1])), a = t[2] === 180 ? 180 : ((t[2] + 180) % 360 + 360) % 360 - 180, c = Math.max(-90, Math.min(90, t[3]));
    if (t[2] - t[0] >= 360)
      r = -180, a = 180;
    else if (r > a) {
      var d = this.getClusters([r, i, 180, c], n), f = this.getClusters([-180, i, a, c], n);
      return d.concat(f);
    }
    var p = this.trees[this._limitZoom(n)], m = p.range(V0(r), Z0(c), V0(a), Z0(i)), v = p.data, g = [];
    for (var w of m) {
      var x = this.stride * w;
      g.push(v[x + tr] > 1 ? lu(v, x, this.clusterProps) : this.points[v[x + rr]]);
    }
    return g;
  }
  getChildren(t) {
    var n = this._getOriginId(t), r = this._getOriginZoom(t), i = "No cluster with the specified id.", a = this.trees[r];
    if (!a) throw new Error(i);
    var c = a.data;
    if (n * this.stride >= c.length) throw new Error(i);
    var d = this.options.radius / (this.options.extent * Math.pow(2, r - 1)), f = c[n * this.stride], p = c[n * this.stride + 1], m = a.within(f, p, d), v = [];
    for (var g of m) {
      var w = g * this.stride;
      c[w + $a] === t && v.push(c[w + tr] > 1 ? lu(c, w, this.clusterProps) : this.points[c[w + rr]]);
    }
    if (v.length === 0) throw new Error(i);
    return v;
  }
  getLeaves(t, n, r) {
    n = n || 10, r = r || 0;
    var i = [];
    return this._appendLeaves(i, t, n, r, 0), i;
  }
  getTile(t, n, r) {
    var i = this.trees[this._limitZoom(t)], a = Math.pow(2, t), {
      extent: c,
      radius: d
    } = this.options, f = d / c, p = (r - f) / a, m = (r + 1 + f) / a, v = {
      features: []
    };
    return this._addTileFeatures(i.range((n - f) / a, p, (n + 1 + f) / a, m), i.data, n, r, a, v), n === 0 && this._addTileFeatures(i.range(1 - f / a, p, 1, m), i.data, a, r, a, v), n === a - 1 && this._addTileFeatures(i.range(0, p, f / a, m), i.data, -1, r, a, v), v.features.length ? v : null;
  }
  getClusterExpansionZoom(t) {
    for (var n = this._getOriginZoom(t) - 1; n <= this.options.maxZoom; ) {
      var r = this.getChildren(t);
      if (n++, r.length !== 1) break;
      t = r[0].properties.cluster_id;
    }
    return n;
  }
  _appendLeaves(t, n, r, i, a) {
    var c = this.getChildren(n);
    for (var d of c) {
      var f = d.properties;
      if (f && f.cluster ? a + f.point_count <= i ? a += f.point_count : a = this._appendLeaves(t, f.cluster_id, r, i, a) : a < i ? a++ : t.push(d), t.length === r) break;
    }
    return a;
  }
  _createTree(t) {
    for (var n = new W3(t.length / this.stride | 0, this.options.nodeSize, Float32Array), r = 0; r < t.length; r += this.stride) n.add(t[r], t[r + 1]);
    return n.finish(), n.data = t, n;
  }
  _addTileFeatures(t, n, r, i, a, c) {
    for (var d of t) {
      var f = d * this.stride, p = n[f + tr] > 1, m = void 0, v = void 0, g = void 0;
      if (p)
        m = zf(n, f, this.clusterProps), v = n[f], g = n[f + 1];
      else {
        var w = this.points[n[f + rr]];
        m = w.properties;
        var [x, b] = w.geometry.coordinates;
        v = V0(x), g = Z0(b);
      }
      var y = {
        type: 1,
        geometry: [[Math.round(this.options.extent * (v * a - r)), Math.round(this.options.extent * (g * a - i))]],
        tags: m
      }, E = void 0;
      p || this.options.generateId ? E = n[f + rr] : E = this.points[n[f + rr]].id, E !== void 0 && (y.id = E), c.features.push(y);
    }
  }
  _limitZoom(t) {
    return Math.max(this.options.minZoom, Math.min(Math.floor(+t), this.options.maxZoom + 1));
  }
  _cluster(t, n) {
    for (var {
      radius: r,
      extent: i,
      reduce: a,
      minPoints: c
    } = this.options, d = r / (i * Math.pow(2, n)), f = t.data, p = [], m = this.stride, v = 0; v < f.length; v += m)
      if (!(f[v + Sr] <= n)) {
        f[v + Sr] = n;
        var g = f[v], w = f[v + 1], x = t.within(f[v], f[v + 1], d), b = f[v + tr], y = b;
        for (var E of x) {
          var z = E * m;
          f[z + Sr] > n && (y += f[z + tr]);
        }
        if (y > b && y >= c) {
          var k = g * b, R = w * b, F = void 0, _ = -1, P = ((v / m | 0) << 5) + (n + 1) + this.points.length;
          for (var O of x) {
            var Z = O * m;
            if (!(f[Z + Sr] <= n)) {
              f[Z + Sr] = n;
              var te = f[Z + tr];
              k += f[Z] * te, R += f[Z + 1] * te, f[Z + $a] = P, a && (F || (F = this._map(f, v, !0), _ = this.clusterProps.length, this.clusterProps.push(F)), a(F, this._map(f, Z)));
            }
          }
          f[v + $a] = P, p.push(k / y, R / y, 1 / 0, P, -1, y), a && p.push(_);
        } else {
          for (var Y = 0; Y < m; Y++) p.push(f[v + Y]);
          if (y > 1)
            for (var X of x) {
              var re = X * m;
              if (!(f[re + Sr] <= n)) {
                f[re + Sr] = n;
                for (var ee = 0; ee < m; ee++) p.push(f[re + ee]);
              }
            }
        }
      }
    return p;
  }
  // get index of the point from which the cluster originated
  _getOriginId(t) {
    return t - this.points.length >> 5;
  }
  // get zoom of the point from which the cluster originated
  _getOriginZoom(t) {
    return (t - this.points.length) % 32;
  }
  _map(t, n, r) {
    if (t[n + tr] > 1) {
      var i = this.clusterProps[t[n + Ff]];
      return r ? Object.assign({}, i) : i;
    }
    var a = this.points[t[n + rr]].properties, c = this.options.map(a);
    return r && c === a ? Object.assign({}, c) : c;
  }
}
function lu(e, t, n) {
  return {
    type: "Feature",
    id: e[t + rr],
    properties: zf(e, t, n),
    geometry: {
      type: "Point",
      coordinates: [FG(e[t]), zG(e[t + 1])]
    }
  };
}
function zf(e, t, n) {
  var r = e[t + tr], i = r >= 1e4 ? "".concat(Math.round(r / 1e3), "k") : r >= 1e3 ? "".concat(Math.round(r / 100) / 10, "k") : r, a = e[t + Ff], c = a === -1 ? {} : Object.assign({}, n[a]);
  return Object.assign(c, {
    cluster: !0,
    cluster_id: e[t + rr],
    point_count: r,
    point_count_abbreviated: i
  });
}
function V0(e) {
  return e / 360 + 0.5;
}
function Z0(e) {
  var t = Math.sin(e * Math.PI / 180), n = 0.5 - 0.25 * Math.log((1 + t) / (1 - t)) / Math.PI;
  return n < 0 ? 0 : n > 1 ? 1 : n;
}
function FG(e) {
  return (e - 0.5) * 360;
}
function zG(e) {
  var t = (180 - e * 360) * Math.PI / 180;
  return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function AG(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
    t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
class wn {
  static isAdvancedMarkerAvailable(t) {
    return google.maps.marker && t.getMapCapabilities().isAdvancedMarkersAvailable === !0;
  }
  static isAdvancedMarker(t) {
    return google.maps.marker && t instanceof google.maps.marker.AdvancedMarkerElement;
  }
  static setMap(t, n) {
    this.isAdvancedMarker(t) ? t.map = n : t.setMap(n);
  }
  static getPosition(t) {
    if (this.isAdvancedMarker(t)) {
      if (t.position) {
        if (t.position instanceof google.maps.LatLng)
          return t.position;
        if (t.position.lat && t.position.lng)
          return new google.maps.LatLng(t.position.lat, t.position.lng);
      }
      return new google.maps.LatLng(null);
    }
    return t.getPosition();
  }
  static getVisible(t) {
    return this.isAdvancedMarker(t) ? !0 : t.getVisible();
  }
}
class ys {
  constructor(t) {
    var {
      markers: n,
      position: r
    } = t;
    this.markers = n, r && (r instanceof google.maps.LatLng ? this._position = r : this._position = new google.maps.LatLng(r));
  }
  get bounds() {
    if (!(this.markers.length === 0 && !this._position)) {
      var t = new google.maps.LatLngBounds(this._position, this._position);
      for (var n of this.markers)
        t.extend(wn.getPosition(n));
      return t;
    }
  }
  get position() {
    return this._position || this.bounds.getCenter();
  }
  /**
   * Get the count of **visible** markers.
   */
  get count() {
    return this.markers.filter((t) => wn.getVisible(t)).length;
  }
  /**
   * Add a marker to the cluster.
   */
  push(t) {
    this.markers.push(t);
  }
  /**
   * Cleanup references and remove marker from map.
   */
  delete() {
    this.marker && (wn.setMap(this.marker, null), this.marker = void 0), this.markers.length = 0;
  }
}
class SG {
  constructor(t) {
    var {
      maxZoom: n = 16
    } = t;
    this.maxZoom = n;
  }
  /**
   * Helper function to bypass clustering based upon some map state such as
   * zoom, number of markers, etc.
   *
   * ```typescript
   *  cluster({markers, map}: AlgorithmInput): Cluster[] {
   *    if (shouldBypassClustering(map)) {
   *      return this.noop({markers})
   *    }
   * }
   * ```
   */
  noop(t) {
    var {
      markers: n
    } = t;
    return kG(n);
  }
}
var kG = (e) => {
  var t = e.map((n) => new ys({
    position: wn.getPosition(n),
    markers: [n]
  }));
  return t;
};
class DG extends SG {
  constructor(t) {
    var {
      maxZoom: n,
      radius: r = 60
    } = t, i = AG(t, ["maxZoom", "radius"]);
    super({
      maxZoom: n
    }), this.state = {
      zoom: -1
    }, this.superCluster = new EG(Object.assign({
      maxZoom: this.maxZoom,
      radius: r
    }, i));
  }
  calculate(t) {
    var n = !1, r = {
      zoom: t.map.getZoom()
    };
    if (!tu(t.markers, this.markers)) {
      n = !0, this.markers = [...t.markers];
      var i = this.markers.map((a) => {
        var c = wn.getPosition(a), d = [c.lng(), c.lat()];
        return {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: d
          },
          properties: {
            marker: a
          }
        };
      });
      this.superCluster.load(i);
    }
    return n || (this.state.zoom <= this.maxZoom || r.zoom <= this.maxZoom) && (n = !tu(this.state, r)), this.state = r, n && (this.clusters = this.cluster(t)), {
      clusters: this.clusters,
      changed: n
    };
  }
  cluster(t) {
    var {
      map: n
    } = t;
    return this.superCluster.getClusters([-180, -90, 180, 90], Math.round(n.getZoom())).map((r) => this.transformCluster(r));
  }
  transformCluster(t) {
    var {
      geometry: {
        coordinates: [n, r]
      },
      properties: i
    } = t;
    if (i.cluster)
      return new ys({
        markers: this.superCluster.getLeaves(i.cluster_id, 1 / 0).map((c) => c.properties.marker),
        position: {
          lat: r,
          lng: n
        }
      });
    var a = i.marker;
    return new ys({
      markers: [a],
      position: wn.getPosition(a)
    });
  }
}
class RG {
  constructor(t, n) {
    this.markers = {
      sum: t.length
    };
    var r = n.map((a) => a.count), i = r.reduce((a, c) => a + c, 0);
    this.clusters = {
      count: n.length,
      markers: {
        mean: i / n.length,
        sum: i,
        min: Math.min(...r),
        max: Math.max(...r)
      }
    };
  }
}
class _G {
  /**
   * The default render function for the library used by {@link MarkerClusterer}.
   *
   * Currently set to use the following:
   *
   * ```typescript
   * // change color if this cluster has more markers than the mean cluster
   * const color =
   *   count > Math.max(10, stats.clusters.markers.mean)
   *     ? "#ff0000"
   *     : "#0000ff";
   *
   * // create svg url with fill color
   * const svg = window.btoa(`
   * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
   *   <circle cx="120" cy="120" opacity=".6" r="70" />
   *   <circle cx="120" cy="120" opacity=".3" r="90" />
   *   <circle cx="120" cy="120" opacity=".2" r="110" />
   *   <circle cx="120" cy="120" opacity=".1" r="130" />
   * </svg>`);
   *
   * // create marker using svg icon
   * return new google.maps.Marker({
   *   position,
   *   icon: {
   *     url: `data:image/svg+xml;base64,${svg}`,
   *     scaledSize: new google.maps.Size(45, 45),
   *   },
   *   label: {
   *     text: String(count),
   *     color: "rgba(255,255,255,0.9)",
   *     fontSize: "12px",
   *   },
   *   // adjust zIndex to be above other markers
   *   zIndex: 1000 + count,
   * });
   * ```
   */
  render(t, n, r) {
    var {
      count: i,
      position: a
    } = t, c = i > Math.max(10, n.clusters.markers.mean) ? "#ff0000" : "#0000ff", d = '<svg fill="'.concat(c, `" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">`).concat(i, `</text>
</svg>`), f = "Cluster of ".concat(i, " markers"), p = Number(google.maps.Marker.MAX_ZINDEX) + i;
    if (wn.isAdvancedMarkerAvailable(r)) {
      var m = new DOMParser(), v = m.parseFromString(d, "image/svg+xml").documentElement;
      v.setAttribute("transform", "translate(0 25)");
      var g = {
        map: r,
        position: a,
        zIndex: p,
        title: f,
        content: v
      };
      return new google.maps.marker.AdvancedMarkerElement(g);
    }
    var w = {
      position: a,
      zIndex: p,
      title: f,
      icon: {
        url: "data:image/svg+xml;base64,".concat(btoa(d)),
        anchor: new google.maps.Point(25, 25)
      }
    };
    return new google.maps.Marker(w);
  }
}
function PG(e, t) {
  for (var n in t.prototype)
    e.prototype[n] = t.prototype[n];
}
class G3 {
  constructor() {
    PG(G3, google.maps.OverlayView);
  }
}
var ui;
(function(e) {
  e.CLUSTERING_BEGIN = "clusteringbegin", e.CLUSTERING_END = "clusteringend", e.CLUSTER_CLICK = "click";
})(ui || (ui = {}));
var HG = (e, t, n) => {
  n.fitBounds(t.bounds);
};
class OG extends G3 {
  constructor(t) {
    var {
      map: n,
      markers: r = [],
      algorithmOptions: i = {},
      algorithm: a = new DG(i),
      renderer: c = new _G(),
      onClusterClick: d = HG
    } = t;
    super(), this.markers = [...r], this.clusters = [], this.algorithm = a, this.renderer = c, this.onClusterClick = d, n && this.setMap(n);
  }
  addMarker(t, n) {
    this.markers.includes(t) || (this.markers.push(t), n || this.render());
  }
  addMarkers(t, n) {
    t.forEach((r) => {
      this.addMarker(r, !0);
    }), n || this.render();
  }
  removeMarker(t, n) {
    var r = this.markers.indexOf(t);
    return r === -1 ? !1 : (wn.setMap(t, null), this.markers.splice(r, 1), n || this.render(), !0);
  }
  removeMarkers(t, n) {
    var r = !1;
    return t.forEach((i) => {
      r = this.removeMarker(i, !0) || r;
    }), r && !n && this.render(), r;
  }
  clearMarkers(t) {
    this.markers.length = 0, t || this.render();
  }
  /**
   * Recalculates and draws all the marker clusters.
   */
  render() {
    var t = this.getMap();
    if (t instanceof google.maps.Map && t.getProjection()) {
      google.maps.event.trigger(this, ui.CLUSTERING_BEGIN, this);
      var {
        clusters: n,
        changed: r
      } = this.algorithm.calculate({
        markers: this.markers,
        map: t,
        mapCanvasProjection: this.getProjection()
      });
      if (r || r == null) {
        var i = /* @__PURE__ */ new Set();
        for (var a of n)
          a.markers.length == 1 && i.add(a.markers[0]);
        var c = [];
        for (var d of this.clusters)
          d.marker != null && (d.markers.length == 1 ? i.has(d.marker) || wn.setMap(d.marker, null) : c.push(d.marker));
        this.clusters = n, this.renderClusters(), requestAnimationFrame(() => c.forEach((f) => wn.setMap(f, null)));
      }
      google.maps.event.trigger(this, ui.CLUSTERING_END, this);
    }
  }
  onAdd() {
    this.idleListener = this.getMap().addListener("idle", this.render.bind(this)), this.render();
  }
  onRemove() {
    google.maps.event.removeListener(this.idleListener), this.reset();
  }
  reset() {
    this.markers.forEach((t) => wn.setMap(t, null)), this.clusters.forEach((t) => t.delete()), this.clusters = [];
  }
  renderClusters() {
    var t = new RG(this.markers, this.clusters), n = this.getMap();
    this.clusters.forEach((r) => {
      r.markers.length === 1 ? r.marker = r.markers[0] : (r.marker = this.renderer.render(r, t, n), r.markers.forEach((i) => wn.setMap(i, null)), this.onClusterClick && r.marker.addListener(
        "click",
        /* istanbul ignore next */
        (i) => {
          google.maps.event.trigger(this, ui.CLUSTER_CLICK, r), this.onClusterClick(i, r, n);
        }
      )), wn.setMap(r.marker, n);
    });
  }
}
function ou(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function au(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ou(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ou(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function NG(e) {
  var t = zW(), [n, r] = q(null);
  return T(() => {
    if (t && n === null) {
      var i = new OG(au(au({}, e), {}, {
        map: t
      }));
      r(i);
    }
  }, [t]), n;
}
function BG(e) {
  var {
    children: t,
    options: n
  } = e, r = NG(n);
  return r !== null ? t(r) : null;
}
Rt(BG);
var su = {
  onCloseClick: "closeclick",
  onContentChanged: "content_changed",
  onDomReady: "domready",
  onPositionChanged: "position_changed",
  onZindexChanged: "zindex_changed"
}, cu = {
  options(e, t) {
    e.setOptions(t);
  },
  position(e, t) {
    e.setPosition(t);
  },
  zIndex(e, t) {
    e.setZIndex(t);
  }
};
function IG(e) {
  var {
    children: t,
    anchor: n,
    options: r,
    position: i,
    zIndex: a,
    onCloseClick: c,
    onDomReady: d,
    onContentChanged: f,
    onPositionChanged: p,
    onZindexChanged: m,
    onLoad: v,
    onUnmount: g
  } = e, w = pt($e), [x, b] = q(null), [y, E] = q(null), [z, k] = q(null), [R, F] = q(null), [_, P] = q(null), [O, Z] = q(null), te = It(null);
  return T(() => {
    x !== null && (x.close(), n ? x.open(w, n) : x.getPosition() && x.open(w));
  }, [w, x, n]), T(() => {
    r && x !== null && x.setOptions(r);
  }, [x, r]), T(() => {
    i && x !== null && x.setPosition(i);
  }, [i]), T(() => {
    typeof a == "number" && x !== null && x.setZIndex(a);
  }, [a]), T(() => {
    x && c && (y !== null && google.maps.event.removeListener(y), E(google.maps.event.addListener(x, "closeclick", c)));
  }, [c]), T(() => {
    x && d && (z !== null && google.maps.event.removeListener(z), k(google.maps.event.addListener(x, "domready", d)));
  }, [d]), T(() => {
    x && f && (R !== null && google.maps.event.removeListener(R), F(google.maps.event.addListener(x, "content_changed", f)));
  }, [f]), T(() => {
    x && p && (_ !== null && google.maps.event.removeListener(_), P(google.maps.event.addListener(x, "position_changed", p)));
  }, [p]), T(() => {
    x && m && (O !== null && google.maps.event.removeListener(O), Z(google.maps.event.addListener(x, "zindex_changed", m)));
  }, [m]), T(() => {
    var Y = new google.maps.InfoWindow(r);
    return b(Y), te.current = document.createElement("div"), c && E(google.maps.event.addListener(Y, "closeclick", c)), d && k(google.maps.event.addListener(Y, "domready", d)), f && F(google.maps.event.addListener(Y, "content_changed", f)), p && P(google.maps.event.addListener(Y, "position_changed", p)), m && Z(google.maps.event.addListener(Y, "zindex_changed", m)), Y.setContent(te.current), i && Y.setPosition(i), a && Y.setZIndex(a), n ? Y.open(w, n) : Y.getPosition() ? Y.open(w) : Dt(!1, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>."), v && v(Y), () => {
      y && google.maps.event.removeListener(y), R && google.maps.event.removeListener(R), z && google.maps.event.removeListener(z), _ && google.maps.event.removeListener(_), O && google.maps.event.removeListener(O), g && g(Y), Y.close();
    };
  }, []), te.current ? yl(jt.only(t), te.current) : null;
}
var TG = Rt(IG);
class VG extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []), le(this, "containerElement", null), le(this, "state", {
      infoWindow: null
    }), le(this, "open", (t, n) => {
      n ? t.open(this.context, n) : t.getPosition() ? t.open(this.context) : Dt(!1, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
    }), le(this, "setInfoWindowCallback", () => {
      this.state.infoWindow !== null && this.containerElement !== null && (this.state.infoWindow.setContent(this.containerElement), this.open(this.state.infoWindow, this.props.anchor), this.props.onLoad && this.props.onLoad(this.state.infoWindow));
    });
  }
  componentDidMount() {
    var t = new google.maps.InfoWindow(this.props.options);
    this.containerElement = document.createElement("div"), this.registeredEvents = Ke({
      updaterMap: cu,
      eventMap: su,
      prevProps: {},
      nextProps: this.props,
      instance: t
    }), this.setState(() => ({
      infoWindow: t
    }), this.setInfoWindowCallback);
  }
  componentDidUpdate(t) {
    this.state.infoWindow !== null && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: cu,
      eventMap: su,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.infoWindow
    }));
  }
  componentWillUnmount() {
    this.state.infoWindow !== null && (Je(this.registeredEvents), this.props.onUnmount && this.props.onUnmount(this.state.infoWindow), this.state.infoWindow.close());
  }
  render() {
    return this.containerElement ? yl(jt.only(this.props.children), this.containerElement) : null;
  }
}
le(VG, "contextType", $e);
function du(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? du(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : du(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var uu = {
  onClick: "click",
  onDblClick: "dblclick",
  onDrag: "drag",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick"
}, fu = {
  draggable(e, t) {
    e.setDraggable(t);
  },
  editable(e, t) {
    e.setEditable(t);
  },
  map(e, t) {
    e.setMap(t);
  },
  options(e, t) {
    e.setOptions(t);
  },
  path(e, t) {
    e.setPath(t);
  },
  visible(e, t) {
    e.setVisible(t);
  }
}, ZG = {};
function $G(e) {
  var {
    options: t,
    draggable: n,
    editable: r,
    visible: i,
    path: a,
    onDblClick: c,
    onDragEnd: d,
    onDragStart: f,
    onMouseDown: p,
    onMouseMove: m,
    onMouseOut: v,
    onMouseOver: g,
    onMouseUp: w,
    onRightClick: x,
    onClick: b,
    onDrag: y,
    onLoad: E,
    onUnmount: z
  } = e, k = pt($e), [R, F] = q(null), [_, P] = q(null), [O, Z] = q(null), [te, Y] = q(null), [X, re] = q(null), [ee, de] = q(null), [ae, ge] = q(null), [K, J] = q(null), [he, ve] = q(null), [Q, ie] = q(null), [pe, U] = q(null), [Me, Le] = q(null);
  return T(() => {
    R !== null && R.setMap(k);
  }, [k]), T(() => {
    typeof t < "u" && R !== null && R.setOptions(t);
  }, [R, t]), T(() => {
    typeof n < "u" && R !== null && R.setDraggable(n);
  }, [R, n]), T(() => {
    typeof r < "u" && R !== null && R.setEditable(r);
  }, [R, r]), T(() => {
    typeof i < "u" && R !== null && R.setVisible(i);
  }, [R, i]), T(() => {
    typeof a < "u" && R !== null && R.setPath(a);
  }, [R, a]), T(() => {
    R && c && (_ !== null && google.maps.event.removeListener(_), P(google.maps.event.addListener(R, "dblclick", c)));
  }, [c]), T(() => {
    R && d && (O !== null && google.maps.event.removeListener(O), Z(google.maps.event.addListener(R, "dragend", d)));
  }, [d]), T(() => {
    R && f && (te !== null && google.maps.event.removeListener(te), Y(google.maps.event.addListener(R, "dragstart", f)));
  }, [f]), T(() => {
    R && p && (X !== null && google.maps.event.removeListener(X), re(google.maps.event.addListener(R, "mousedown", p)));
  }, [p]), T(() => {
    R && m && (ee !== null && google.maps.event.removeListener(ee), de(google.maps.event.addListener(R, "mousemove", m)));
  }, [m]), T(() => {
    R && v && (ae !== null && google.maps.event.removeListener(ae), ge(google.maps.event.addListener(R, "mouseout", v)));
  }, [v]), T(() => {
    R && g && (K !== null && google.maps.event.removeListener(K), J(google.maps.event.addListener(R, "mouseover", g)));
  }, [g]), T(() => {
    R && w && (he !== null && google.maps.event.removeListener(he), ve(google.maps.event.addListener(R, "mouseup", w)));
  }, [w]), T(() => {
    R && x && (Q !== null && google.maps.event.removeListener(Q), ie(google.maps.event.addListener(R, "rightclick", x)));
  }, [x]), T(() => {
    R && b && (pe !== null && google.maps.event.removeListener(pe), U(google.maps.event.addListener(R, "click", b)));
  }, [b]), T(() => {
    R && y && (Me !== null && google.maps.event.removeListener(Me), Le(google.maps.event.addListener(R, "drag", y)));
  }, [y]), T(() => {
    var xe = new google.maps.Polyline(fl(fl({}, t || ZG), {}, {
      map: k
    }));
    return a && xe.setPath(a), typeof i < "u" && xe.setVisible(i), typeof r < "u" && xe.setEditable(r), typeof n < "u" && xe.setDraggable(n), c && P(google.maps.event.addListener(xe, "dblclick", c)), d && Z(google.maps.event.addListener(xe, "dragend", d)), f && Y(google.maps.event.addListener(xe, "dragstart", f)), p && re(google.maps.event.addListener(xe, "mousedown", p)), m && de(google.maps.event.addListener(xe, "mousemove", m)), v && ge(google.maps.event.addListener(xe, "mouseout", v)), g && J(google.maps.event.addListener(xe, "mouseover", g)), w && ve(google.maps.event.addListener(xe, "mouseup", w)), x && ie(google.maps.event.addListener(xe, "rightclick", x)), b && U(google.maps.event.addListener(xe, "click", b)), y && Le(google.maps.event.addListener(xe, "drag", y)), F(xe), E && E(xe), () => {
      _ !== null && google.maps.event.removeListener(_), O !== null && google.maps.event.removeListener(O), te !== null && google.maps.event.removeListener(te), X !== null && google.maps.event.removeListener(X), ee !== null && google.maps.event.removeListener(ee), ae !== null && google.maps.event.removeListener(ae), K !== null && google.maps.event.removeListener(K), he !== null && google.maps.event.removeListener(he), Q !== null && google.maps.event.removeListener(Q), pe !== null && google.maps.event.removeListener(pe), z && z(xe), xe.setMap(null);
    };
  }, []), null;
}
Rt($G);
class WG extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []), le(this, "state", {
      polyline: null
    }), le(this, "setPolylineCallback", () => {
      this.state.polyline !== null && this.props.onLoad && this.props.onLoad(this.state.polyline);
    });
  }
  componentDidMount() {
    var t = new google.maps.Polyline(fl(fl({}, this.props.options), {}, {
      map: this.context
    }));
    this.registeredEvents = Ke({
      updaterMap: fu,
      eventMap: uu,
      prevProps: {},
      nextProps: this.props,
      instance: t
    }), this.setState(function() {
      return {
        polyline: t
      };
    }, this.setPolylineCallback);
  }
  componentDidUpdate(t) {
    this.state.polyline !== null && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: fu,
      eventMap: uu,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.polyline
    }));
  }
  componentWillUnmount() {
    this.state.polyline !== null && (this.props.onUnmount && this.props.onUnmount(this.state.polyline), Je(this.registeredEvents), this.state.polyline.setMap(null));
  }
  render() {
    return null;
  }
}
le(WG, "contextType", $e);
function hu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function pu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hu(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : hu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var mu = {
  onClick: "click",
  onDblClick: "dblclick",
  onDrag: "drag",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick"
}, vu = {
  draggable(e, t) {
    e.setDraggable(t);
  },
  editable(e, t) {
    e.setEditable(t);
  },
  map(e, t) {
    e.setMap(t);
  },
  options(e, t) {
    e.setOptions(t);
  },
  path(e, t) {
    e.setPath(t);
  },
  paths(e, t) {
    e.setPaths(t);
  },
  visible(e, t) {
    e.setVisible(t);
  }
};
function GG(e) {
  var {
    options: t,
    draggable: n,
    editable: r,
    visible: i,
    path: a,
    paths: c,
    onDblClick: d,
    onDragEnd: f,
    onDragStart: p,
    onMouseDown: m,
    onMouseMove: v,
    onMouseOut: g,
    onMouseOver: w,
    onMouseUp: x,
    onRightClick: b,
    onClick: y,
    onDrag: E,
    onLoad: z,
    onUnmount: k,
    onEdit: R
  } = e, F = pt($e), [_, P] = q(null), [O, Z] = q(null), [te, Y] = q(null), [X, re] = q(null), [ee, de] = q(null), [ae, ge] = q(null), [K, J] = q(null), [he, ve] = q(null), [Q, ie] = q(null), [pe, U] = q(null), [Me, Le] = q(null), [xe, Ee] = q(null);
  return T(() => {
    _ !== null && _.setMap(F);
  }, [F]), T(() => {
    typeof t < "u" && _ !== null && _.setOptions(t);
  }, [_, t]), T(() => {
    typeof n < "u" && _ !== null && _.setDraggable(n);
  }, [_, n]), T(() => {
    typeof r < "u" && _ !== null && _.setEditable(r);
  }, [_, r]), T(() => {
    typeof i < "u" && _ !== null && _.setVisible(i);
  }, [_, i]), T(() => {
    typeof a < "u" && _ !== null && _.setPath(a);
  }, [_, a]), T(() => {
    typeof c < "u" && _ !== null && _.setPaths(c);
  }, [_, c]), T(() => {
    _ && typeof d == "function" && (O !== null && google.maps.event.removeListener(O), Z(google.maps.event.addListener(_, "dblclick", d)));
  }, [d]), T(() => {
    _ && (google.maps.event.addListener(_.getPath(), "insert_at", () => {
      R == null || R(_);
    }), google.maps.event.addListener(_.getPath(), "set_at", () => {
      R == null || R(_);
    }), google.maps.event.addListener(_.getPath(), "remove_at", () => {
      R == null || R(_);
    }));
  }, [_, R]), T(() => {
    _ && typeof f == "function" && (te !== null && google.maps.event.removeListener(te), Y(google.maps.event.addListener(_, "dragend", f)));
  }, [f]), T(() => {
    _ && typeof p == "function" && (X !== null && google.maps.event.removeListener(X), re(google.maps.event.addListener(_, "dragstart", p)));
  }, [p]), T(() => {
    _ && typeof m == "function" && (ee !== null && google.maps.event.removeListener(ee), de(google.maps.event.addListener(_, "mousedown", m)));
  }, [m]), T(() => {
    _ && typeof v == "function" && (ae !== null && google.maps.event.removeListener(ae), ge(google.maps.event.addListener(_, "mousemove", v)));
  }, [v]), T(() => {
    _ && typeof g == "function" && (K !== null && google.maps.event.removeListener(K), J(google.maps.event.addListener(_, "mouseout", g)));
  }, [g]), T(() => {
    _ && typeof w == "function" && (he !== null && google.maps.event.removeListener(he), ve(google.maps.event.addListener(_, "mouseover", w)));
  }, [w]), T(() => {
    _ && typeof x == "function" && (Q !== null && google.maps.event.removeListener(Q), ie(google.maps.event.addListener(_, "mouseup", x)));
  }, [x]), T(() => {
    _ && typeof b == "function" && (pe !== null && google.maps.event.removeListener(pe), U(google.maps.event.addListener(_, "rightclick", b)));
  }, [b]), T(() => {
    _ && typeof y == "function" && (Me !== null && google.maps.event.removeListener(Me), Le(google.maps.event.addListener(_, "click", y)));
  }, [y]), T(() => {
    _ && typeof E == "function" && (xe !== null && google.maps.event.removeListener(xe), Ee(google.maps.event.addListener(_, "drag", E)));
  }, [E]), T(() => {
    var ye = new google.maps.Polygon(pu(pu({}, t), {}, {
      map: F
    }));
    return a && ye.setPath(a), c && ye.setPaths(c), typeof i < "u" && ye.setVisible(i), typeof r < "u" && ye.setEditable(r), typeof n < "u" && ye.setDraggable(n), d && Z(google.maps.event.addListener(ye, "dblclick", d)), f && Y(google.maps.event.addListener(ye, "dragend", f)), p && re(google.maps.event.addListener(ye, "dragstart", p)), m && de(google.maps.event.addListener(ye, "mousedown", m)), v && ge(google.maps.event.addListener(ye, "mousemove", v)), g && J(google.maps.event.addListener(ye, "mouseout", g)), w && ve(google.maps.event.addListener(ye, "mouseover", w)), x && ie(google.maps.event.addListener(ye, "mouseup", x)), b && U(google.maps.event.addListener(ye, "rightclick", b)), y && Le(google.maps.event.addListener(ye, "click", y)), E && Ee(google.maps.event.addListener(ye, "drag", E)), P(ye), z && z(ye), () => {
      O !== null && google.maps.event.removeListener(O), te !== null && google.maps.event.removeListener(te), X !== null && google.maps.event.removeListener(X), ee !== null && google.maps.event.removeListener(ee), ae !== null && google.maps.event.removeListener(ae), K !== null && google.maps.event.removeListener(K), he !== null && google.maps.event.removeListener(he), Q !== null && google.maps.event.removeListener(Q), pe !== null && google.maps.event.removeListener(pe), Me !== null && google.maps.event.removeListener(Me), k && k(ye), ye.setMap(null);
    };
  }, []), null;
}
Rt(GG);
class UG extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []);
  }
  componentDidMount() {
    var t = this.props.options || {};
    this.polygon = new google.maps.Polygon(t), this.polygon.setMap(this.context), this.registeredEvents = Ke({
      updaterMap: vu,
      eventMap: mu,
      prevProps: {},
      nextProps: this.props,
      instance: this.polygon
    }), this.props.onLoad && this.props.onLoad(this.polygon);
  }
  componentDidUpdate(t) {
    this.polygon && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: vu,
      eventMap: mu,
      prevProps: t,
      nextProps: this.props,
      instance: this.polygon
    }));
  }
  componentWillUnmount() {
    this.polygon && (this.props.onUnmount && this.props.onUnmount(this.polygon), Je(this.registeredEvents), this.polygon && this.polygon.setMap(null));
  }
  render() {
    return null;
  }
}
le(UG, "contextType", $e);
function gu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function hl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gu(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Lu = {
  onBoundsChanged: "bounds_changed",
  onClick: "click",
  onDblClick: "dblclick",
  onDrag: "drag",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick"
}, wu = {
  bounds(e, t) {
    e.setBounds(t);
  },
  draggable(e, t) {
    e.setDraggable(t);
  },
  editable(e, t) {
    e.setEditable(t);
  },
  map(e, t) {
    e.setMap(t);
  },
  options(e, t) {
    e.setOptions(t);
  },
  visible(e, t) {
    e.setVisible(t);
  }
};
function jG(e) {
  var {
    options: t,
    bounds: n,
    draggable: r,
    editable: i,
    visible: a,
    onDblClick: c,
    onDragEnd: d,
    onDragStart: f,
    onMouseDown: p,
    onMouseMove: m,
    onMouseOut: v,
    onMouseOver: g,
    onMouseUp: w,
    onRightClick: x,
    onClick: b,
    onDrag: y,
    onBoundsChanged: E,
    onLoad: z,
    onUnmount: k
  } = e, R = pt($e), [F, _] = q(null), [P, O] = q(null), [Z, te] = q(null), [Y, X] = q(null), [re, ee] = q(null), [de, ae] = q(null), [ge, K] = q(null), [J, he] = q(null), [ve, Q] = q(null), [ie, pe] = q(null), [U, Me] = q(null), [Le, xe] = q(null), [Ee, ye] = q(null);
  return T(() => {
    F !== null && F.setMap(R);
  }, [R]), T(() => {
    typeof t < "u" && F !== null && F.setOptions(t);
  }, [F, t]), T(() => {
    typeof r < "u" && F !== null && F.setDraggable(r);
  }, [F, r]), T(() => {
    typeof i < "u" && F !== null && F.setEditable(i);
  }, [F, i]), T(() => {
    typeof a < "u" && F !== null && F.setVisible(a);
  }, [F, a]), T(() => {
    typeof n < "u" && F !== null && F.setBounds(n);
  }, [F, n]), T(() => {
    F && c && (P !== null && google.maps.event.removeListener(P), O(google.maps.event.addListener(F, "dblclick", c)));
  }, [c]), T(() => {
    F && d && (Z !== null && google.maps.event.removeListener(Z), te(google.maps.event.addListener(F, "dragend", d)));
  }, [d]), T(() => {
    F && f && (Y !== null && google.maps.event.removeListener(Y), X(google.maps.event.addListener(F, "dragstart", f)));
  }, [f]), T(() => {
    F && p && (re !== null && google.maps.event.removeListener(re), ee(google.maps.event.addListener(F, "mousedown", p)));
  }, [p]), T(() => {
    F && m && (de !== null && google.maps.event.removeListener(de), ae(google.maps.event.addListener(F, "mousemove", m)));
  }, [m]), T(() => {
    F && v && (ge !== null && google.maps.event.removeListener(ge), K(google.maps.event.addListener(F, "mouseout", v)));
  }, [v]), T(() => {
    F && g && (J !== null && google.maps.event.removeListener(J), he(google.maps.event.addListener(F, "mouseover", g)));
  }, [g]), T(() => {
    F && w && (ve !== null && google.maps.event.removeListener(ve), Q(google.maps.event.addListener(F, "mouseup", w)));
  }, [w]), T(() => {
    F && x && (ie !== null && google.maps.event.removeListener(ie), pe(google.maps.event.addListener(F, "rightclick", x)));
  }, [x]), T(() => {
    F && b && (U !== null && google.maps.event.removeListener(U), Me(google.maps.event.addListener(F, "click", b)));
  }, [b]), T(() => {
    F && y && (Le !== null && google.maps.event.removeListener(Le), xe(google.maps.event.addListener(F, "drag", y)));
  }, [y]), T(() => {
    F && E && (Ee !== null && google.maps.event.removeListener(Ee), ye(google.maps.event.addListener(F, "bounds_changed", E)));
  }, [E]), T(() => {
    var Be = new google.maps.Rectangle(hl(hl({}, t), {}, {
      map: R
    }));
    return typeof a < "u" && Be.setVisible(a), typeof i < "u" && Be.setEditable(i), typeof r < "u" && Be.setDraggable(r), typeof n < "u" && Be.setBounds(n), c && O(google.maps.event.addListener(Be, "dblclick", c)), d && te(google.maps.event.addListener(Be, "dragend", d)), f && X(google.maps.event.addListener(Be, "dragstart", f)), p && ee(google.maps.event.addListener(Be, "mousedown", p)), m && ae(google.maps.event.addListener(Be, "mousemove", m)), v && K(google.maps.event.addListener(Be, "mouseout", v)), g && he(google.maps.event.addListener(Be, "mouseover", g)), w && Q(google.maps.event.addListener(Be, "mouseup", w)), x && pe(google.maps.event.addListener(Be, "rightclick", x)), b && Me(google.maps.event.addListener(Be, "click", b)), y && xe(google.maps.event.addListener(Be, "drag", y)), E && ye(google.maps.event.addListener(Be, "bounds_changed", E)), _(Be), z && z(Be), () => {
      P !== null && google.maps.event.removeListener(P), Z !== null && google.maps.event.removeListener(Z), Y !== null && google.maps.event.removeListener(Y), re !== null && google.maps.event.removeListener(re), de !== null && google.maps.event.removeListener(de), ge !== null && google.maps.event.removeListener(ge), J !== null && google.maps.event.removeListener(J), ve !== null && google.maps.event.removeListener(ve), ie !== null && google.maps.event.removeListener(ie), U !== null && google.maps.event.removeListener(U), Le !== null && google.maps.event.removeListener(Le), Ee !== null && google.maps.event.removeListener(Ee), k && k(Be), Be.setMap(null);
    };
  }, []), null;
}
Rt(jG);
class KG extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []), le(this, "state", {
      rectangle: null
    }), le(this, "setRectangleCallback", () => {
      this.state.rectangle !== null && this.props.onLoad && this.props.onLoad(this.state.rectangle);
    });
  }
  componentDidMount() {
    var t = new google.maps.Rectangle(hl(hl({}, this.props.options), {}, {
      map: this.context
    }));
    this.registeredEvents = Ke({
      updaterMap: wu,
      eventMap: Lu,
      prevProps: {},
      nextProps: this.props,
      instance: t
    }), this.setState(function() {
      return {
        rectangle: t
      };
    }, this.setRectangleCallback);
  }
  componentDidUpdate(t) {
    this.state.rectangle !== null && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: wu,
      eventMap: Lu,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.rectangle
    }));
  }
  componentWillUnmount() {
    this.state.rectangle !== null && (this.props.onUnmount && this.props.onUnmount(this.state.rectangle), Je(this.registeredEvents), this.state.rectangle.setMap(null));
  }
  render() {
    return null;
  }
}
le(KG, "contextType", $e);
function Mu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function pl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mu(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var xu = {
  onCenterChanged: "center_changed",
  onRadiusChanged: "radius_changed",
  onClick: "click",
  onDblClick: "dblclick",
  onDrag: "drag",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick"
}, bu = {
  center(e, t) {
    e.setCenter(t);
  },
  draggable(e, t) {
    e.setDraggable(t);
  },
  editable(e, t) {
    e.setEditable(t);
  },
  map(e, t) {
    e.setMap(t);
  },
  options(e, t) {
    e.setOptions(t);
  },
  radius(e, t) {
    e.setRadius(t);
  },
  visible(e, t) {
    e.setVisible(t);
  }
}, YG = {};
function qG(e) {
  var {
    options: t,
    center: n,
    radius: r,
    draggable: i,
    editable: a,
    visible: c,
    onDblClick: d,
    onDragEnd: f,
    onDragStart: p,
    onMouseDown: m,
    onMouseMove: v,
    onMouseOut: g,
    onMouseOver: w,
    onMouseUp: x,
    onRightClick: b,
    onClick: y,
    onDrag: E,
    onCenterChanged: z,
    onRadiusChanged: k,
    onLoad: R,
    onUnmount: F
  } = e, _ = pt($e), [P, O] = q(null), [Z, te] = q(null), [Y, X] = q(null), [re, ee] = q(null), [de, ae] = q(null), [ge, K] = q(null), [J, he] = q(null), [ve, Q] = q(null), [ie, pe] = q(null), [U, Me] = q(null), [Le, xe] = q(null), [Ee, ye] = q(null), [Be, ft] = q(null), [Et, Lt] = q(null);
  return T(() => {
    P !== null && P.setMap(_);
  }, [_]), T(() => {
    typeof t < "u" && P !== null && P.setOptions(t);
  }, [P, t]), T(() => {
    typeof i < "u" && P !== null && P.setDraggable(i);
  }, [P, i]), T(() => {
    typeof a < "u" && P !== null && P.setEditable(a);
  }, [P, a]), T(() => {
    typeof c < "u" && P !== null && P.setVisible(c);
  }, [P, c]), T(() => {
    typeof r == "number" && P !== null && P.setRadius(r);
  }, [P, r]), T(() => {
    typeof n < "u" && P !== null && P.setCenter(n);
  }, [P, n]), T(() => {
    P && d && (Z !== null && google.maps.event.removeListener(Z), te(google.maps.event.addListener(P, "dblclick", d)));
  }, [d]), T(() => {
    P && f && (Y !== null && google.maps.event.removeListener(Y), X(google.maps.event.addListener(P, "dragend", f)));
  }, [f]), T(() => {
    P && p && (re !== null && google.maps.event.removeListener(re), ee(google.maps.event.addListener(P, "dragstart", p)));
  }, [p]), T(() => {
    P && m && (de !== null && google.maps.event.removeListener(de), ae(google.maps.event.addListener(P, "mousedown", m)));
  }, [m]), T(() => {
    P && v && (ge !== null && google.maps.event.removeListener(ge), K(google.maps.event.addListener(P, "mousemove", v)));
  }, [v]), T(() => {
    P && g && (J !== null && google.maps.event.removeListener(J), he(google.maps.event.addListener(P, "mouseout", g)));
  }, [g]), T(() => {
    P && w && (ve !== null && google.maps.event.removeListener(ve), Q(google.maps.event.addListener(P, "mouseover", w)));
  }, [w]), T(() => {
    P && x && (ie !== null && google.maps.event.removeListener(ie), pe(google.maps.event.addListener(P, "mouseup", x)));
  }, [x]), T(() => {
    P && b && (U !== null && google.maps.event.removeListener(U), Me(google.maps.event.addListener(P, "rightclick", b)));
  }, [b]), T(() => {
    P && y && (Le !== null && google.maps.event.removeListener(Le), xe(google.maps.event.addListener(P, "click", y)));
  }, [y]), T(() => {
    P && E && (Ee !== null && google.maps.event.removeListener(Ee), ye(google.maps.event.addListener(P, "drag", E)));
  }, [E]), T(() => {
    P && z && (Be !== null && google.maps.event.removeListener(Be), ft(google.maps.event.addListener(P, "center_changed", z)));
  }, [y]), T(() => {
    P && k && (Et !== null && google.maps.event.removeListener(Et), Lt(google.maps.event.addListener(P, "radius_changed", k)));
  }, [k]), T(() => {
    var je = new google.maps.Circle(pl(pl({}, t || YG), {}, {
      map: _
    }));
    return typeof r == "number" && je.setRadius(r), typeof n < "u" && je.setCenter(n), typeof r == "number" && je.setRadius(r), typeof c < "u" && je.setVisible(c), typeof a < "u" && je.setEditable(a), typeof i < "u" && je.setDraggable(i), d && te(google.maps.event.addListener(je, "dblclick", d)), f && X(google.maps.event.addListener(je, "dragend", f)), p && ee(google.maps.event.addListener(je, "dragstart", p)), m && ae(google.maps.event.addListener(je, "mousedown", m)), v && K(google.maps.event.addListener(je, "mousemove", v)), g && he(google.maps.event.addListener(je, "mouseout", g)), w && Q(google.maps.event.addListener(je, "mouseover", w)), x && pe(google.maps.event.addListener(je, "mouseup", x)), b && Me(google.maps.event.addListener(je, "rightclick", b)), y && xe(google.maps.event.addListener(je, "click", y)), E && ye(google.maps.event.addListener(je, "drag", E)), z && ft(google.maps.event.addListener(je, "center_changed", z)), k && Lt(google.maps.event.addListener(je, "radius_changed", k)), O(je), R && R(je), () => {
      Z !== null && google.maps.event.removeListener(Z), Y !== null && google.maps.event.removeListener(Y), re !== null && google.maps.event.removeListener(re), de !== null && google.maps.event.removeListener(de), ge !== null && google.maps.event.removeListener(ge), J !== null && google.maps.event.removeListener(J), ve !== null && google.maps.event.removeListener(ve), ie !== null && google.maps.event.removeListener(ie), U !== null && google.maps.event.removeListener(U), Le !== null && google.maps.event.removeListener(Le), Be !== null && google.maps.event.removeListener(Be), Et !== null && google.maps.event.removeListener(Et), F && F(je), je.setMap(null);
    };
  }, []), null;
}
Rt(qG);
class XG extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []), le(this, "state", {
      circle: null
    }), le(this, "setCircleCallback", () => {
      this.state.circle !== null && this.props.onLoad && this.props.onLoad(this.state.circle);
    });
  }
  componentDidMount() {
    var t = new google.maps.Circle(pl(pl({}, this.props.options), {}, {
      map: this.context
    }));
    this.registeredEvents = Ke({
      updaterMap: bu,
      eventMap: xu,
      prevProps: {},
      nextProps: this.props,
      instance: t
    }), this.setState(function() {
      return {
        circle: t
      };
    }, this.setCircleCallback);
  }
  componentDidUpdate(t) {
    this.state.circle !== null && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: bu,
      eventMap: xu,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.circle
    }));
  }
  componentWillUnmount() {
    if (this.state.circle !== null) {
      var t;
      this.props.onUnmount && this.props.onUnmount(this.state.circle), Je(this.registeredEvents), (t = this.state.circle) === null || t === void 0 || t.setMap(null);
    }
  }
  render() {
    return null;
  }
}
le(XG, "contextType", $e);
function yu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ml(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yu(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Cu = {
  onClick: "click",
  onDblClick: "dblclick",
  onMouseDown: "mousedown",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onAddFeature: "addfeature",
  onRemoveFeature: "removefeature",
  onRemoveProperty: "removeproperty",
  onSetGeometry: "setgeometry",
  onSetProperty: "setproperty"
}, Eu = {
  add(e, t) {
    e.add(t);
  },
  addgeojson(e, t, n) {
    e.addGeoJson(t, n);
  },
  contains(e, t) {
    e.contains(t);
  },
  foreach(e, t) {
    e.forEach(t);
  },
  loadgeojson(e, t, n, r) {
    e.loadGeoJson(t, n, r);
  },
  overridestyle(e, t, n) {
    e.overrideStyle(t, n);
  },
  remove(e, t) {
    e.remove(t);
  },
  revertstyle(e, t) {
    e.revertStyle(t);
  },
  controlposition(e, t) {
    e.setControlPosition(t);
  },
  controls(e, t) {
    e.setControls(t);
  },
  drawingmode(e, t) {
    e.setDrawingMode(t);
  },
  map(e, t) {
    e.setMap(t);
  },
  style(e, t) {
    e.setStyle(t);
  },
  togeojson(e, t) {
    e.toGeoJson(t);
  }
};
function JG(e) {
  var {
    options: t,
    onClick: n,
    onDblClick: r,
    onMouseDown: i,
    onMouseMove: a,
    onMouseOut: c,
    onMouseOver: d,
    onMouseUp: f,
    onRightClick: p,
    onAddFeature: m,
    onRemoveFeature: v,
    onRemoveProperty: g,
    onSetGeometry: w,
    onSetProperty: x,
    onLoad: b,
    onUnmount: y
  } = e, E = pt($e), [z, k] = q(null), [R, F] = q(null), [_, P] = q(null), [O, Z] = q(null), [te, Y] = q(null), [X, re] = q(null), [ee, de] = q(null), [ae, ge] = q(null), [K, J] = q(null), [he, ve] = q(null), [Q, ie] = q(null), [pe, U] = q(null), [Me, Le] = q(null), [xe, Ee] = q(null);
  return T(() => {
    z !== null && z.setMap(E);
  }, [E]), T(() => {
    z && r && (R !== null && google.maps.event.removeListener(R), F(google.maps.event.addListener(z, "dblclick", r)));
  }, [r]), T(() => {
    z && i && (_ !== null && google.maps.event.removeListener(_), P(google.maps.event.addListener(z, "mousedown", i)));
  }, [i]), T(() => {
    z && a && (O !== null && google.maps.event.removeListener(O), Z(google.maps.event.addListener(z, "mousemove", a)));
  }, [a]), T(() => {
    z && c && (te !== null && google.maps.event.removeListener(te), Y(google.maps.event.addListener(z, "mouseout", c)));
  }, [c]), T(() => {
    z && d && (X !== null && google.maps.event.removeListener(X), re(google.maps.event.addListener(z, "mouseover", d)));
  }, [d]), T(() => {
    z && f && (ee !== null && google.maps.event.removeListener(ee), de(google.maps.event.addListener(z, "mouseup", f)));
  }, [f]), T(() => {
    z && p && (ae !== null && google.maps.event.removeListener(ae), ge(google.maps.event.addListener(z, "rightclick", p)));
  }, [p]), T(() => {
    z && n && (K !== null && google.maps.event.removeListener(K), J(google.maps.event.addListener(z, "click", n)));
  }, [n]), T(() => {
    z && m && (he !== null && google.maps.event.removeListener(he), ve(google.maps.event.addListener(z, "addfeature", m)));
  }, [m]), T(() => {
    z && v && (Q !== null && google.maps.event.removeListener(Q), ie(google.maps.event.addListener(z, "removefeature", v)));
  }, [v]), T(() => {
    z && g && (pe !== null && google.maps.event.removeListener(pe), U(google.maps.event.addListener(z, "removeproperty", g)));
  }, [g]), T(() => {
    z && w && (Me !== null && google.maps.event.removeListener(Me), Le(google.maps.event.addListener(z, "setgeometry", w)));
  }, [w]), T(() => {
    z && x && (xe !== null && google.maps.event.removeListener(xe), Ee(google.maps.event.addListener(z, "setproperty", x)));
  }, [x]), T(() => {
    if (E !== null) {
      var ye = new google.maps.Data(ml(ml({}, t), {}, {
        map: E
      }));
      r && F(google.maps.event.addListener(ye, "dblclick", r)), i && P(google.maps.event.addListener(ye, "mousedown", i)), a && Z(google.maps.event.addListener(ye, "mousemove", a)), c && Y(google.maps.event.addListener(ye, "mouseout", c)), d && re(google.maps.event.addListener(ye, "mouseover", d)), f && de(google.maps.event.addListener(ye, "mouseup", f)), p && ge(google.maps.event.addListener(ye, "rightclick", p)), n && J(google.maps.event.addListener(ye, "click", n)), m && ve(google.maps.event.addListener(ye, "addfeature", m)), v && ie(google.maps.event.addListener(ye, "removefeature", v)), g && U(google.maps.event.addListener(ye, "removeproperty", g)), w && Le(google.maps.event.addListener(ye, "setgeometry", w)), x && Ee(google.maps.event.addListener(ye, "setproperty", x)), k(ye), b && b(ye);
    }
    return () => {
      z && (R !== null && google.maps.event.removeListener(R), _ !== null && google.maps.event.removeListener(_), O !== null && google.maps.event.removeListener(O), te !== null && google.maps.event.removeListener(te), X !== null && google.maps.event.removeListener(X), ee !== null && google.maps.event.removeListener(ee), ae !== null && google.maps.event.removeListener(ae), K !== null && google.maps.event.removeListener(K), he !== null && google.maps.event.removeListener(he), Q !== null && google.maps.event.removeListener(Q), pe !== null && google.maps.event.removeListener(pe), Me !== null && google.maps.event.removeListener(Me), xe !== null && google.maps.event.removeListener(xe), y && y(z), z.setMap(null));
    };
  }, []), null;
}
Rt(JG);
class QG extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []), le(this, "state", {
      data: null
    }), le(this, "setDataCallback", () => {
      this.state.data !== null && this.props.onLoad && this.props.onLoad(this.state.data);
    });
  }
  componentDidMount() {
    if (this.context !== null) {
      var t = new google.maps.Data(ml(ml({}, this.props.options), {}, {
        map: this.context
      }));
      this.registeredEvents = Ke({
        updaterMap: Eu,
        eventMap: Cu,
        prevProps: {},
        nextProps: this.props,
        instance: t
      }), this.setState(() => ({
        data: t
      }), this.setDataCallback);
    }
  }
  componentDidUpdate(t) {
    this.state.data !== null && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: Eu,
      eventMap: Cu,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.data
    }));
  }
  componentWillUnmount() {
    this.state.data !== null && (this.props.onUnmount && this.props.onUnmount(this.state.data), Je(this.registeredEvents), this.state.data && this.state.data.setMap(null));
  }
  render() {
    return null;
  }
}
le(QG, "contextType", $e);
function Fu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function zu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fu(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Fu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Au = {
  onClick: "click",
  onDefaultViewportChanged: "defaultviewport_changed",
  onStatusChanged: "status_changed"
}, Su = {
  options(e, t) {
    e.setOptions(t);
  },
  url(e, t) {
    e.setUrl(t);
  },
  zIndex(e, t) {
    e.setZIndex(t);
  }
};
class eU extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []), le(this, "state", {
      kmlLayer: null
    }), le(this, "setKmlLayerCallback", () => {
      this.state.kmlLayer !== null && this.props.onLoad && this.props.onLoad(this.state.kmlLayer);
    });
  }
  componentDidMount() {
    var t = new google.maps.KmlLayer(zu(zu({}, this.props.options), {}, {
      map: this.context
    }));
    this.registeredEvents = Ke({
      updaterMap: Su,
      eventMap: Au,
      prevProps: {},
      nextProps: this.props,
      instance: t
    }), this.setState(function() {
      return {
        kmlLayer: t
      };
    }, this.setKmlLayerCallback);
  }
  componentDidUpdate(t) {
    this.state.kmlLayer !== null && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: Su,
      eventMap: Au,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.kmlLayer
    }));
  }
  componentWillUnmount() {
    this.state.kmlLayer !== null && (this.props.onUnmount && this.props.onUnmount(this.state.kmlLayer), Je(this.registeredEvents), this.state.kmlLayer.setMap(null));
  }
  render() {
    return null;
  }
}
le(eU, "contextType", $e);
function Af(e, t) {
  return typeof t == "function" ? t(e.offsetWidth, e.offsetHeight) : {
    x: 0,
    y: 0
  };
}
function tU(e, t) {
  return new t(e.lat, e.lng);
}
function nU(e, t) {
  return new t(new google.maps.LatLng(e.ne.lat, e.ne.lng), new google.maps.LatLng(e.sw.lat, e.sw.lng));
}
function rU(e, t, n) {
  return e instanceof t ? e : n(e, t);
}
function iU(e, t, n) {
  return e instanceof t ? e : n(e, t);
}
function lU(e, t, n) {
  var r = e && e.fromLatLngToDivPixel(n.getNorthEast()), i = e && e.fromLatLngToDivPixel(n.getSouthWest());
  return r && i ? {
    left: "".concat(i.x + t.x, "px"),
    top: "".concat(r.y + t.y, "px"),
    width: "".concat(r.x - i.x - t.x, "px"),
    height: "".concat(i.y - r.y - t.y, "px")
  } : {
    left: "-9999px",
    top: "-9999px"
  };
}
function oU(e, t, n) {
  var r = e && e.fromLatLngToDivPixel(n);
  if (r) {
    var {
      x: i,
      y: a
    } = r;
    return {
      left: "".concat(i + t.x, "px"),
      top: "".concat(a + t.y, "px")
    };
  }
  return {
    left: "-9999px",
    top: "-9999px"
  };
}
function Sf(e, t, n, r) {
  return n !== void 0 ? lU(e, t, iU(n, google.maps.LatLngBounds, nU)) : oU(e, t, rU(r, google.maps.LatLng, tU));
}
function aU(e, t) {
  return e.left === t.left && e.top === t.top && e.width === t.height && e.height === t.height;
}
function ku(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sU(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ku(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ku(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function cU(e, t, n, r, i) {
  class a extends google.maps.OverlayView {
    constructor(d, f, p, m) {
      super(), this.container = d, this.pane = f, this.position = p, this.bounds = m;
    }
    onAdd() {
      var d, f = (d = this.getPanes()) === null || d === void 0 ? void 0 : d[this.pane];
      f == null || f.appendChild(this.container);
    }
    draw() {
      var d = this.getProjection(), f = sU({}, this.container ? Af(this.container, i) : {
        x: 0,
        y: 0
      }), p = Sf(d, f, this.bounds, this.position);
      for (var [m, v] of Object.entries(p))
        this.container.style[m] = v;
    }
    onRemove() {
      this.container.parentNode !== null && this.container.parentNode.removeChild(this.container);
    }
  }
  return new a(e, t, n, r);
}
function Du(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function dU(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Du(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Du(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ru(e) {
  if (!e)
    return "";
  var t = e instanceof google.maps.LatLng ? e : new google.maps.LatLng(e.lat, e.lng);
  return t + "";
}
function _u(e) {
  if (!e)
    return "";
  var t = e instanceof google.maps.LatLngBounds ? e : new google.maps.LatLngBounds(new google.maps.LatLng(e.south, e.east), new google.maps.LatLng(e.north, e.west));
  return t + "";
}
function uU(e) {
  var {
    position: t,
    bounds: n,
    mapPaneName: r,
    zIndex: i,
    onLoad: a,
    onUnmount: c,
    getPixelPositionOffset: d,
    children: f
  } = e, p = pt($e), m = Ut(() => {
    var g = document.createElement("div");
    return g.style.position = "absolute", g;
  }, []), v = Ut(() => cU(m, r, t, n, d), [m, r, t, n]);
  return T(() => (a == null || a(v), v == null || v.setMap(p), () => {
    c == null || c(v), v == null || v.setMap(null);
  }), [p, v]), T(() => {
    m.style.zIndex = "".concat(i);
  }, [i, m]), b1.createPortal(f, m);
}
Rt(uU);
class _1 extends gt {
  constructor(t) {
    super(t), le(this, "state", {
      paneEl: null,
      containerStyle: {
        // set initial position
        position: "absolute"
      }
    }), le(this, "updatePane", () => {
      var r = this.props.mapPaneName, i = this.overlayView.getPanes();
      Dt(!!r, "OverlayView requires props.mapPaneName but got %s", r), i ? this.setState({
        paneEl: i[r]
      }) : this.setState({
        paneEl: null
      });
    }), le(this, "onAdd", () => {
      var r, i;
      this.updatePane(), (r = (i = this.props).onLoad) === null || r === void 0 || r.call(i, this.overlayView);
    }), le(this, "onPositionElement", () => {
      var r = this.overlayView.getProjection(), i = dU({
        x: 0,
        y: 0
      }, this.containerRef.current ? Af(this.containerRef.current, this.props.getPixelPositionOffset) : {}), a = Sf(r, i, this.props.bounds, this.props.position);
      if (!aU(a, {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        left: this.state.containerStyle.left,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        top: this.state.containerStyle.top,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        width: this.state.containerStyle.width,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        height: this.state.containerStyle.height
      })) {
        var c, d, f, p;
        this.setState({
          containerStyle: {
            top: (c = a.top) !== null && c !== void 0 ? c : 0,
            left: (d = a.left) !== null && d !== void 0 ? d : 0,
            width: (f = a.width) !== null && f !== void 0 ? f : 0,
            height: (p = a.height) !== null && p !== void 0 ? p : 0,
            position: "absolute"
          }
        });
      }
    }), le(this, "draw", () => {
      this.onPositionElement();
    }), le(this, "onRemove", () => {
      var r, i;
      this.setState(() => ({
        paneEl: null
      })), (r = (i = this.props).onUnmount) === null || r === void 0 || r.call(i, this.overlayView);
    }), this.containerRef = Is();
    var n = new google.maps.OverlayView();
    n.onAdd = this.onAdd, n.draw = this.draw, n.onRemove = this.onRemove, this.overlayView = n;
  }
  componentDidMount() {
    this.overlayView.setMap(this.context);
  }
  componentDidUpdate(t) {
    var n = Ru(t.position), r = Ru(this.props.position), i = _u(t.bounds), a = _u(this.props.bounds);
    (n !== r || i !== a) && this.overlayView.draw(), t.mapPaneName !== this.props.mapPaneName && this.updatePane();
  }
  componentWillUnmount() {
    this.overlayView.setMap(null);
  }
  render() {
    var t = this.state.paneEl;
    return t ? b1.createPortal(u("div", {
      ref: this.containerRef,
      style: this.state.containerStyle,
      children: jt.only(this.props.children)
    }), t) : null;
  }
}
le(_1, "FLOAT_PANE", "floatPane");
le(_1, "MAP_PANE", "mapPane");
le(_1, "MARKER_LAYER", "markerLayer");
le(_1, "OVERLAY_LAYER", "overlayLayer");
le(_1, "OVERLAY_MOUSE_TARGET", "overlayMouseTarget");
le(_1, "contextType", $e);
function fU() {
}
function Pu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Hu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pu(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Ou = {
  onDblClick: "dblclick",
  onClick: "click"
}, Nu = {
  opacity(e, t) {
    e.setOpacity(t);
  }
};
function hU(e) {
  var {
    url: t,
    bounds: n,
    options: r,
    visible: i
  } = e, a = pt($e), c = new google.maps.LatLngBounds(new google.maps.LatLng(n.south, n.west), new google.maps.LatLng(n.north, n.east)), d = Ut(() => new google.maps.GroundOverlay(t, c, r), []);
  return T(() => {
    d !== null && d.setMap(a);
  }, [a]), T(() => {
    typeof t < "u" && d !== null && (d.set("url", t), d.setMap(a));
  }, [d, t]), T(() => {
    typeof i < "u" && d !== null && d.setOpacity(i ? 1 : 0);
  }, [d, i]), T(() => {
    var f = new google.maps.LatLngBounds(new google.maps.LatLng(n.south, n.west), new google.maps.LatLng(n.north, n.east));
    typeof n < "u" && d !== null && (d.set("bounds", f), d.setMap(a));
  }, [d, n]), null;
}
Rt(hU);
class kf extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []), le(this, "state", {
      groundOverlay: null
    }), le(this, "setGroundOverlayCallback", () => {
      this.state.groundOverlay !== null && this.props.onLoad && this.props.onLoad(this.state.groundOverlay);
    });
  }
  componentDidMount() {
    Dt(!!this.props.url || !!this.props.bounds, "For GroundOverlay, url and bounds are passed in to constructor and are immutable after instantiated. This is the behavior of Google Maps JavaScript API v3 ( See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay) Hence, use the corresponding two props provided by `react-google-maps-api`, url and bounds. In some cases, you'll need the GroundOverlay component to reflect the changes of url and bounds. You can leverage the React's key property to remount the component. Typically, just `key={url}` would serve your need. See https://github.com/tomchentw/react-google-maps/issues/655");
    var t = new google.maps.GroundOverlay(this.props.url, this.props.bounds, Hu(Hu({}, this.props.options), {}, {
      map: this.context
    }));
    this.registeredEvents = Ke({
      updaterMap: Nu,
      eventMap: Ou,
      prevProps: {},
      nextProps: this.props,
      instance: t
    }), this.setState(function() {
      return {
        groundOverlay: t
      };
    }, this.setGroundOverlayCallback);
  }
  componentDidUpdate(t) {
    this.state.groundOverlay !== null && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: Nu,
      eventMap: Ou,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.groundOverlay
    }));
  }
  componentWillUnmount() {
    this.state.groundOverlay && (this.props.onUnmount && this.props.onUnmount(this.state.groundOverlay), this.state.groundOverlay.setMap(null));
  }
  render() {
    return null;
  }
}
le(kf, "defaultProps", {
  onLoad: fU
});
le(kf, "contextType", $e);
function Bu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function vl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Bu(Object(n), !0).forEach(function(r) {
      le(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Bu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Iu = {}, Tu = {
  data(e, t) {
    e.setData(t);
  },
  map(e, t) {
    e.setMap(t);
  },
  options(e, t) {
    e.setOptions(t);
  }
};
function pU(e) {
  var {
    data: t,
    onLoad: n,
    onUnmount: r,
    options: i
  } = e, a = pt($e), [c, d] = q(null);
  return T(() => {
    google.maps.visualization || Dt(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} in useJsApiScript? %s', google.maps.visualization);
  }, []), T(() => {
    Dt(!!t, "data property is required in HeatmapLayer %s", t);
  }, [t]), T(() => {
    c !== null && c.setMap(a);
  }, [a]), T(() => {
    i && c !== null && c.setOptions(i);
  }, [c, i]), T(() => {
    var f = new google.maps.visualization.HeatmapLayer(vl(vl({}, i), {}, {
      data: t,
      map: a
    }));
    return d(f), n && n(f), () => {
      c !== null && (r && r(c), c.setMap(null));
    };
  }, []), null;
}
Rt(pU);
class mU extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []), le(this, "state", {
      heatmapLayer: null
    }), le(this, "setHeatmapLayerCallback", () => {
      this.state.heatmapLayer !== null && this.props.onLoad && this.props.onLoad(this.state.heatmapLayer);
    });
  }
  componentDidMount() {
    Dt(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} to <LoadScript />? %s', google.maps.visualization), Dt(!!this.props.data, "data property is required in HeatmapLayer %s", this.props.data);
    var t = new google.maps.visualization.HeatmapLayer(vl(vl({}, this.props.options), {}, {
      data: this.props.data,
      map: this.context
    }));
    this.registeredEvents = Ke({
      updaterMap: Tu,
      eventMap: Iu,
      prevProps: {},
      nextProps: this.props,
      instance: t
    }), this.setState(function() {
      return {
        heatmapLayer: t
      };
    }, this.setHeatmapLayerCallback);
  }
  componentDidUpdate(t) {
    Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: Tu,
      eventMap: Iu,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.heatmapLayer
    });
  }
  componentWillUnmount() {
    this.state.heatmapLayer !== null && (this.props.onUnmount && this.props.onUnmount(this.state.heatmapLayer), Je(this.registeredEvents), this.state.heatmapLayer.setMap(null));
  }
  render() {
    return null;
  }
}
le(mU, "contextType", $e);
var Vu = {
  onCloseClick: "closeclick",
  onPanoChanged: "pano_changed",
  onPositionChanged: "position_changed",
  onPovChanged: "pov_changed",
  onResize: "resize",
  onStatusChanged: "status_changed",
  onVisibleChanged: "visible_changed",
  onZoomChanged: "zoom_changed"
}, Zu = {
  register(e, t, n) {
    e.registerPanoProvider(t, n);
  },
  links(e, t) {
    e.setLinks(t);
  },
  motionTracking(e, t) {
    e.setMotionTracking(t);
  },
  options(e, t) {
    e.setOptions(t);
  },
  pano(e, t) {
    e.setPano(t);
  },
  position(e, t) {
    e.setPosition(t);
  },
  pov(e, t) {
    e.setPov(t);
  },
  visible(e, t) {
    e.setVisible(t);
  },
  zoom(e, t) {
    e.setZoom(t);
  }
};
class vU extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []), le(this, "state", {
      streetViewPanorama: null
    }), le(this, "setStreetViewPanoramaCallback", () => {
      this.state.streetViewPanorama !== null && this.props.onLoad && this.props.onLoad(this.state.streetViewPanorama);
    });
  }
  componentDidMount() {
    var t, n, r = (t = (n = this.context) === null || n === void 0 ? void 0 : n.getStreetView()) !== null && t !== void 0 ? t : null;
    this.registeredEvents = Ke({
      updaterMap: Zu,
      eventMap: Vu,
      prevProps: {},
      nextProps: this.props,
      instance: r
    }), this.setState(() => ({
      streetViewPanorama: r
    }), this.setStreetViewPanoramaCallback);
  }
  componentDidUpdate(t) {
    this.state.streetViewPanorama !== null && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: Zu,
      eventMap: Vu,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.streetViewPanorama
    }));
  }
  componentWillUnmount() {
    this.state.streetViewPanorama !== null && (this.props.onUnmount && this.props.onUnmount(this.state.streetViewPanorama), Je(this.registeredEvents), this.state.streetViewPanorama.setVisible(!1));
  }
  render() {
    return null;
  }
}
le(vU, "contextType", $e);
class gU extends gt {
  constructor() {
    super(...arguments), le(this, "state", {
      streetViewService: null
    }), le(this, "setStreetViewServiceCallback", () => {
      this.state.streetViewService !== null && this.props.onLoad && this.props.onLoad(this.state.streetViewService);
    });
  }
  componentDidMount() {
    var t = new google.maps.StreetViewService();
    this.setState(function() {
      return {
        streetViewService: t
      };
    }, this.setStreetViewServiceCallback);
  }
  componentWillUnmount() {
    this.state.streetViewService !== null && this.props.onUnmount && this.props.onUnmount(this.state.streetViewService);
  }
  render() {
    return null;
  }
}
le(gU, "contextType", $e);
var $u = {
  onDirectionsChanged: "directions_changed"
}, Wu = {
  directions(e, t) {
    e.setDirections(t);
  },
  map(e, t) {
    e.setMap(t);
  },
  options(e, t) {
    e.setOptions(t);
  },
  panel(e, t) {
    e.setPanel(t);
  },
  routeIndex(e, t) {
    e.setRouteIndex(t);
  }
};
class LU extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []), le(this, "state", {
      directionsRenderer: null
    }), le(this, "setDirectionsRendererCallback", () => {
      this.state.directionsRenderer !== null && (this.state.directionsRenderer.setMap(this.context), this.props.onLoad && this.props.onLoad(this.state.directionsRenderer));
    });
  }
  componentDidMount() {
    var t = new google.maps.DirectionsRenderer(this.props.options);
    this.registeredEvents = Ke({
      updaterMap: Wu,
      eventMap: $u,
      prevProps: {},
      nextProps: this.props,
      instance: t
    }), this.setState(function() {
      return {
        directionsRenderer: t
      };
    }, this.setDirectionsRendererCallback);
  }
  componentDidUpdate(t) {
    this.state.directionsRenderer !== null && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: Wu,
      eventMap: $u,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.directionsRenderer
    }));
  }
  componentWillUnmount() {
    this.state.directionsRenderer !== null && (this.props.onUnmount && this.props.onUnmount(this.state.directionsRenderer), Je(this.registeredEvents), this.state.directionsRenderer && this.state.directionsRenderer.setMap(null));
  }
  render() {
    return null;
  }
}
le(LU, "contextType", $e);
var Gu = {
  onPlacesChanged: "places_changed"
}, Uu = {
  bounds(e, t) {
    e.setBounds(t);
  }
};
class wU extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []), le(this, "containerElement", Is()), le(this, "state", {
      searchBox: null
    }), le(this, "setSearchBoxCallback", () => {
      this.state.searchBox !== null && this.props.onLoad && this.props.onLoad(this.state.searchBox);
    });
  }
  componentDidMount() {
    if (Dt(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places), this.containerElement !== null && this.containerElement.current !== null) {
      var t = this.containerElement.current.querySelector("input");
      if (t !== null) {
        var n = new google.maps.places.SearchBox(t, this.props.options);
        this.registeredEvents = Ke({
          updaterMap: Uu,
          eventMap: Gu,
          prevProps: {},
          nextProps: this.props,
          instance: n
        }), this.setState(function() {
          return {
            searchBox: n
          };
        }, this.setSearchBoxCallback);
      }
    }
  }
  componentDidUpdate(t) {
    this.state.searchBox !== null && (Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: Uu,
      eventMap: Gu,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.searchBox
    }));
  }
  componentWillUnmount() {
    this.state.searchBox !== null && (this.props.onUnmount && this.props.onUnmount(this.state.searchBox), Je(this.registeredEvents));
  }
  render() {
    return u("div", {
      ref: this.containerElement,
      children: jt.only(this.props.children)
    });
  }
}
le(wU, "contextType", $e);
var ju = {
  onPlaceChanged: "place_changed"
}, Ku = {
  bounds(e, t) {
    e.setBounds(t);
  },
  restrictions(e, t) {
    e.setComponentRestrictions(t);
  },
  fields(e, t) {
    e.setFields(t);
  },
  options(e, t) {
    e.setOptions(t);
  },
  types(e, t) {
    e.setTypes(t);
  }
};
class Df extends gt {
  constructor() {
    super(...arguments), le(this, "registeredEvents", []), le(this, "containerElement", Is()), le(this, "state", {
      autocomplete: null
    }), le(this, "setAutocompleteCallback", () => {
      this.state.autocomplete !== null && this.props.onLoad && this.props.onLoad(this.state.autocomplete);
    });
  }
  componentDidMount() {
    var t;
    Dt(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);
    var n = (t = this.containerElement.current) === null || t === void 0 ? void 0 : t.querySelector("input");
    if (n) {
      var r = new google.maps.places.Autocomplete(n, this.props.options);
      this.registeredEvents = Ke({
        updaterMap: Ku,
        eventMap: ju,
        prevProps: {},
        nextProps: this.props,
        instance: r
      }), this.setState(() => ({
        autocomplete: r
      }), this.setAutocompleteCallback);
    }
  }
  componentDidUpdate(t) {
    Je(this.registeredEvents), this.registeredEvents = Ke({
      updaterMap: Ku,
      eventMap: ju,
      prevProps: t,
      nextProps: this.props,
      instance: this.state.autocomplete
    });
  }
  componentWillUnmount() {
    this.state.autocomplete !== null && Je(this.registeredEvents);
  }
  render() {
    return u("div", {
      ref: this.containerElement,
      className: this.props.className,
      children: jt.only(this.props.children)
    });
  }
}
le(Df, "defaultProps", {
  className: ""
});
le(Df, "contextType", $e);
const MU = Ye(S("w-full"), {
  variants: { size: { sm: "h-32", md: "h-64", lg: "h-96" } },
  defaultVariants: { size: "md" }
}), xU = "33e6f190b45988f3", Rf = ({
  size: e,
  longitude: t,
  latitude: n,
  zoom: r = 8,
  markers: i = [],
  readOnly: a,
  apiKey: c,
  fitMarkers: d = !0,
  maxZoom: f = 15,
  language: p = "en",
  onPositionChange: m,
  onZoomChange: v,
  onReady: g,
  ...w
}) => {
  const [x, b] = q(null), y = It(null), E = It(!0), z = It(a), k = Ut(
    () => t !== void 0 && n !== void 0 ? { lat: n, lng: t } : { lat: 0, lng: 0 },
    []
  ), [R, F] = q(k), { isLoaded: _ } = UW({
    id: "google-map-script",
    googleMapsApiKey: c || void 0 || "",
    language: p
  });
  T(() => {
    if (t !== void 0 && n !== void 0) {
      const re = { lat: n, lng: t };
      F(re), y.current && !d && y.current.panTo(re);
    }
  }, [n, t, d]), T(() => {
    y.current && r && !d && y.current.setZoom(r);
  }, [r, d]);
  const P = Ft(() => {
    if (!_ || !y.current || !i || i.length === 0) return;
    const re = new google.maps.LatLngBounds();
    let ee = !1;
    if (i.forEach((de) => {
      de.latitude !== void 0 && de.longitude !== void 0 && (re.extend({ lat: de.latitude, lng: de.longitude }), ee = !0);
    }), !!ee)
      if (y.current.setCenter(re.getCenter()), i.length === 1)
        y.current.setZoom(r);
      else {
        y.current.fitBounds(re);
        const de = y.current.getZoom();
        de && de > f && y.current.setZoom(f);
      }
  }, [_, i, r, f]);
  T(() => {
    d && (E.current || z.current === a) && (P(), E.current = !1), z.current = a;
  }, [i, d, P, a]);
  const O = Ft(
    (re) => {
      y.current = re, d && P(), g && g(), E.current = !1;
    },
    [g, d, P]
  ), Z = Ft(() => {
    y.current = null;
  }, []), te = Ft(() => {
    if (y.current && m) {
      const re = y.current.getCenter();
      re && m(re.lng(), re.lat());
    }
  }, [m]), Y = Ft(() => {
    y.current && v && v(y.current.getZoom() || r);
  }, [v, r]), X = Ut(() => {
    const re = {
      disableDefaultUI: a,
      zoomControl: !a,
      scrollwheel: !a,
      mapTypeControl: !1,
      streetViewControl: !1,
      draggable: !a,
      disableDoubleClickZoom: a,
      keyboardShortcuts: !a,
      mapId: xU
    };
    return _ && window.google && (re.zoomControlOptions = { position: google.maps.ControlPosition.RIGHT_CENTER }), re;
  }, [a, _]);
  return _ ? /* @__PURE__ */ u("div", { className: MU({ size: e }), children: /* @__PURE__ */ u(
    PW,
    {
      mapContainerStyle: { width: "100%", height: "100%" },
      options: X,
      onLoad: O,
      onUnmount: Z,
      onCenterChanged: te,
      onZoomChanged: Y,
      zoom: r,
      center: R,
      ...w,
      children: i.map((re, ee) => /* @__PURE__ */ u(
        nG,
        {
          position: { lat: re.latitude, lng: re.longitude },
          onClick: a ? void 0 : () => re.title && b(ee),
          clickable: !a,
          icon: re.iconUrl ? { url: re.iconUrl, scaledSize: new window.google.maps.Size(32, 32) } : void 0,
          children: x === ee && re.title && /* @__PURE__ */ u(TG, { onCloseClick: () => b(null), children: /* @__PURE__ */ V(me, { children: [
            /* @__PURE__ */ u(tt, { variant: "body-bold", children: re.title }),
            re.content && /* @__PURE__ */ u("div", { className: "mt-1", children: /* @__PURE__ */ u(tt, { variant: "body", children: re.content }) })
          ] }) })
        },
        `${re.latitude}-${re.longitude}`
      ))
    }
  ) }) : null;
};
Rf.displayName = "MapContainer";
const bU = W(({ onClick: e, ...t }, n) => /* @__PURE__ */ u(
  "div",
  {
    ref: n,
    className: S("relative z-10 flex", { "cursor-pointer [&_*]:cursor-pointer": e }),
    onClick: e,
    children: /* @__PURE__ */ u(Rf, { ...t })
  }
));
bU.displayName = "Map";
const U3 = W(({ label: e, disabled: t, role: n, onRemove: r, ...i }, a) => /* @__PURE__ */ V(
  "div",
  {
    ...i,
    ...n && { role: n },
    ...n === "option" && { "aria-selected": !1 },
    "aria-disabled": t,
    ref: a,
    className: S(
      "bg-badge-default-background text-badge-default-text flex h-5 w-fit cursor-default items-center gap-4 rounded-full p-2 text-xs whitespace-nowrap",
      {
        "bg-badge-disabled-background text-badge-disabled-text cursor-not-allowed": t
      }
    ),
    children: [
      e,
      /* @__PURE__ */ u(V3, { onClick: r, size: "xs", icon: "Close", label: "Close", disabled: t })
    ]
  }
));
U3.displayName = "Badge";
var Yu = 1, yU = 0.9, CU = 0.8, EU = 0.17, Wa = 0.1, Ga = 0.999, FU = 0.9999, zU = 0.99, AU = /[\\\/_+.#"@\[\(\{&]/, SU = /[\\\/_+.#"@\[\(\{&]/g, kU = /[\s-]/, _f = /[\s-]/g;
function Cs(e, t, n, r, i, a, c) {
  if (a === t.length) return i === e.length ? Yu : zU;
  var d = `${i},${a}`;
  if (c[d] !== void 0) return c[d];
  for (var f = r.charAt(a), p = n.indexOf(f, i), m = 0, v, g, w, x; p >= 0; ) v = Cs(e, t, n, r, p + 1, a + 1, c), v > m && (p === i ? v *= Yu : AU.test(e.charAt(p - 1)) ? (v *= CU, w = e.slice(i, p - 1).match(SU), w && i > 0 && (v *= Math.pow(Ga, w.length))) : kU.test(e.charAt(p - 1)) ? (v *= yU, x = e.slice(i, p - 1).match(_f), x && i > 0 && (v *= Math.pow(Ga, x.length))) : (v *= EU, i > 0 && (v *= Math.pow(Ga, p - i))), e.charAt(p) !== t.charAt(a) && (v *= FU)), (v < Wa && n.charAt(p - 1) === r.charAt(a + 1) || r.charAt(a + 1) === r.charAt(a) && n.charAt(p - 1) !== r.charAt(a)) && (g = Cs(e, t, n, r, p + 1, a + 2, c), g * Wa > v && (v = g * Wa)), v > m && (m = v), p = n.indexOf(f, p + 1);
  return c[d] = m, m;
}
function qu(e) {
  return e.toLowerCase().replace(_f, " ");
}
function DU(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, Cs(e, t, qu(e), qu(t), 0, 0, {});
}
function ar(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function Xu(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Nr(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const a = Xu(i, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const a = r[i];
          typeof a == "function" ? a() : Xu(e[i], null);
        }
      };
  };
}
function Wr(...e) {
  return M.useCallback(Nr(...e), e);
}
function RU(e, t) {
  const n = M.createContext(t), r = (a) => {
    const { children: c, ...d } = a, f = M.useMemo(() => d, Object.values(d));
    return /* @__PURE__ */ u(n.Provider, { value: f, children: c });
  };
  r.displayName = e + "Provider";
  function i(a) {
    const c = M.useContext(n);
    if (c) return c;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [r, i];
}
function _U(e, t = []) {
  let n = [];
  function r(a, c) {
    const d = M.createContext(c), f = n.length;
    n = [...n, c];
    const p = (v) => {
      var E;
      const { scope: g, children: w, ...x } = v, b = ((E = g == null ? void 0 : g[e]) == null ? void 0 : E[f]) || d, y = M.useMemo(() => x, Object.values(x));
      return /* @__PURE__ */ u(b.Provider, { value: y, children: w });
    };
    p.displayName = a + "Provider";
    function m(v, g) {
      var b;
      const w = ((b = g == null ? void 0 : g[e]) == null ? void 0 : b[f]) || d, x = M.useContext(w);
      if (x) return x;
      if (c !== void 0) return c;
      throw new Error(`\`${v}\` must be used within \`${a}\``);
    }
    return [p, m];
  }
  const i = () => {
    const a = n.map((c) => M.createContext(c));
    return function(d) {
      const f = (d == null ? void 0 : d[e]) || a;
      return M.useMemo(
        () => ({ [`__scope${e}`]: { ...d, [e]: f } }),
        [d, f]
      );
    };
  };
  return i.scopeName = e, [r, PU(i, ...t)];
}
function PU(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(a) {
      const c = r.reduce((d, { useScope: f, scopeName: p }) => {
        const v = f(a)[`__scope${p}`];
        return { ...d, ...v };
      }, {});
      return M.useMemo(() => ({ [`__scope${t.scopeName}`]: c }), [c]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var gl = globalThis != null && globalThis.document ? M.useLayoutEffect : () => {
}, HU = M.useId || (() => {
}), OU = 0;
function _2(e) {
  const [t, n] = M.useState(HU());
  return gl(() => {
    n((r) => r ?? String(OU++));
  }, [e]), t ? `radix-${t}` : "";
}
function Br(e) {
  const t = M.useRef(e);
  return M.useEffect(() => {
    t.current = e;
  }), M.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function NU({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, i] = BU({ defaultProp: t, onChange: n }), a = e !== void 0, c = a ? e : r, d = Br(n), f = M.useCallback(
    (p) => {
      if (a) {
        const v = typeof p == "function" ? p(e) : p;
        v !== e && d(v);
      } else
        i(p);
    },
    [a, e, i, d]
  );
  return [c, f];
}
function BU({
  defaultProp: e,
  onChange: t
}) {
  const n = M.useState(e), [r] = n, i = M.useRef(r), a = Br(t);
  return M.useEffect(() => {
    i.current !== r && (a(r), i.current = r);
  }, [r, i, a]), n;
}
var j3 = M.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = M.Children.toArray(n), a = i.find(TU);
  if (a) {
    const c = a.props.children, d = i.map((f) => f === a ? M.Children.count(c) > 1 ? M.Children.only(null) : M.isValidElement(c) ? c.props.children : null : f);
    return /* @__PURE__ */ u(Es, { ...r, ref: t, children: M.isValidElement(c) ? M.cloneElement(c, void 0, d) : null });
  }
  return /* @__PURE__ */ u(Es, { ...r, ref: t, children: n });
});
j3.displayName = "Slot";
var Es = M.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (M.isValidElement(n)) {
    const i = ZU(n), a = VU(r, n.props);
    return n.type !== M.Fragment && (a.ref = t ? Nr(t, i) : i), M.cloneElement(n, a);
  }
  return M.Children.count(n) > 1 ? M.Children.only(null) : null;
});
Es.displayName = "SlotClone";
var IU = ({ children: e }) => /* @__PURE__ */ u(me, { children: e });
function TU(e) {
  return M.isValidElement(e) && e.type === IU;
}
function VU(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? i && a ? n[r] = (...d) => {
      a(...d), i(...d);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...a } : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function ZU(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var $U = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Vt = $U.reduce((e, t) => {
  const n = M.forwardRef((r, i) => {
    const { asChild: a, ...c } = r, d = a ? j3 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ u(d, { ...c, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function WU(e, t) {
  e && b1.flushSync(() => e.dispatchEvent(t));
}
function GU(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Br(e);
  M.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var UU = "DismissableLayer", Fs = "dismissableLayer.update", jU = "dismissableLayer.pointerDownOutside", KU = "dismissableLayer.focusOutside", Ju, Pf = M.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Hf = M.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: a,
      onInteractOutside: c,
      onDismiss: d,
      ...f
    } = e, p = M.useContext(Pf), [m, v] = M.useState(null), g = (m == null ? void 0 : m.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, w] = M.useState({}), x = Wr(t, (P) => v(P)), b = Array.from(p.layers), [y] = [...p.layersWithOutsidePointerEventsDisabled].slice(-1), E = b.indexOf(y), z = m ? b.indexOf(m) : -1, k = p.layersWithOutsidePointerEventsDisabled.size > 0, R = z >= E, F = XU((P) => {
      const O = P.target, Z = [...p.branches].some((te) => te.contains(O));
      !R || Z || (i == null || i(P), c == null || c(P), P.defaultPrevented || d == null || d());
    }, g), _ = JU((P) => {
      const O = P.target;
      [...p.branches].some((te) => te.contains(O)) || (a == null || a(P), c == null || c(P), P.defaultPrevented || d == null || d());
    }, g);
    return GU((P) => {
      z === p.layers.size - 1 && (r == null || r(P), !P.defaultPrevented && d && (P.preventDefault(), d()));
    }, g), M.useEffect(() => {
      if (m)
        return n && (p.layersWithOutsidePointerEventsDisabled.size === 0 && (Ju = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), p.layersWithOutsidePointerEventsDisabled.add(m)), p.layers.add(m), Qu(), () => {
          n && p.layersWithOutsidePointerEventsDisabled.size === 1 && (g.body.style.pointerEvents = Ju);
        };
    }, [m, g, n, p]), M.useEffect(() => () => {
      m && (p.layers.delete(m), p.layersWithOutsidePointerEventsDisabled.delete(m), Qu());
    }, [m, p]), M.useEffect(() => {
      const P = () => w({});
      return document.addEventListener(Fs, P), () => document.removeEventListener(Fs, P);
    }, []), /* @__PURE__ */ u(
      Vt.div,
      {
        ...f,
        ref: x,
        style: {
          pointerEvents: k ? R ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: ar(e.onFocusCapture, _.onFocusCapture),
        onBlurCapture: ar(e.onBlurCapture, _.onBlurCapture),
        onPointerDownCapture: ar(
          e.onPointerDownCapture,
          F.onPointerDownCapture
        )
      }
    );
  }
);
Hf.displayName = UU;
var YU = "DismissableLayerBranch", qU = M.forwardRef((e, t) => {
  const n = M.useContext(Pf), r = M.useRef(null), i = Wr(t, r);
  return M.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ u(Vt.div, { ...e, ref: i });
});
qU.displayName = YU;
function XU(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Br(e), r = M.useRef(!1), i = M.useRef(() => {
  });
  return M.useEffect(() => {
    const a = (d) => {
      if (d.target && !r.current) {
        let f = function() {
          Of(
            jU,
            n,
            p,
            { discrete: !0 }
          );
        };
        const p = { originalEvent: d };
        d.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = f, t.addEventListener("click", i.current, { once: !0 })) : f();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, c = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(c), t.removeEventListener("pointerdown", a), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function JU(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Br(e), r = M.useRef(!1);
  return M.useEffect(() => {
    const i = (a) => {
      a.target && !r.current && Of(KU, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Qu() {
  const e = new CustomEvent(Fs);
  document.dispatchEvent(e);
}
function Of(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? WU(i, a) : i.dispatchEvent(a);
}
var Ua = "focusScope.autoFocusOnMount", ja = "focusScope.autoFocusOnUnmount", e6 = { bubbles: !1, cancelable: !0 }, QU = "FocusScope", Nf = M.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: a,
    ...c
  } = e, [d, f] = M.useState(null), p = Br(i), m = Br(a), v = M.useRef(null), g = Wr(t, (b) => f(b)), w = M.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  M.useEffect(() => {
    if (r) {
      let b = function(k) {
        if (w.paused || !d) return;
        const R = k.target;
        d.contains(R) ? v.current = R : nr(v.current, { select: !0 });
      }, y = function(k) {
        if (w.paused || !d) return;
        const R = k.relatedTarget;
        R !== null && (d.contains(R) || nr(v.current, { select: !0 }));
      }, E = function(k) {
        if (document.activeElement === document.body)
          for (const F of k)
            F.removedNodes.length > 0 && nr(d);
      };
      document.addEventListener("focusin", b), document.addEventListener("focusout", y);
      const z = new MutationObserver(E);
      return d && z.observe(d, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", b), document.removeEventListener("focusout", y), z.disconnect();
      };
    }
  }, [r, d, w.paused]), M.useEffect(() => {
    if (d) {
      n6.add(w);
      const b = document.activeElement;
      if (!d.contains(b)) {
        const E = new CustomEvent(Ua, e6);
        d.addEventListener(Ua, p), d.dispatchEvent(E), E.defaultPrevented || (ej(lj(Bf(d)), { select: !0 }), document.activeElement === b && nr(d));
      }
      return () => {
        d.removeEventListener(Ua, p), setTimeout(() => {
          const E = new CustomEvent(ja, e6);
          d.addEventListener(ja, m), d.dispatchEvent(E), E.defaultPrevented || nr(b ?? document.body, { select: !0 }), d.removeEventListener(ja, m), n6.remove(w);
        }, 0);
      };
    }
  }, [d, p, m, w]);
  const x = M.useCallback(
    (b) => {
      if (!n && !r || w.paused) return;
      const y = b.key === "Tab" && !b.altKey && !b.ctrlKey && !b.metaKey, E = document.activeElement;
      if (y && E) {
        const z = b.currentTarget, [k, R] = tj(z);
        k && R ? !b.shiftKey && E === R ? (b.preventDefault(), n && nr(k, { select: !0 })) : b.shiftKey && E === k && (b.preventDefault(), n && nr(R, { select: !0 })) : E === z && b.preventDefault();
      }
    },
    [n, r, w.paused]
  );
  return /* @__PURE__ */ u(Vt.div, { tabIndex: -1, ...c, ref: g, onKeyDown: x });
});
Nf.displayName = QU;
function ej(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (nr(r, { select: t }), document.activeElement !== n) return;
}
function tj(e) {
  const t = Bf(e), n = t6(t, e), r = t6(t.reverse(), e);
  return [n, r];
}
function Bf(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function t6(e, t) {
  for (const n of e)
    if (!nj(n, { upTo: t })) return n;
}
function nj(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function rj(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function nr(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && rj(e) && t && e.select();
  }
}
var n6 = ij();
function ij() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = r6(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = r6(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function r6(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function lj(e) {
  return e.filter((t) => t.tagName !== "A");
}
var oj = "Portal", If = M.forwardRef((e, t) => {
  var d;
  const { container: n, ...r } = e, [i, a] = M.useState(!1);
  gl(() => a(!0), []);
  const c = n || i && ((d = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : d.body);
  return c ? M6.createPortal(/* @__PURE__ */ u(Vt.div, { ...r, ref: t }), c) : null;
});
If.displayName = oj;
function aj(e, t) {
  return M.useReducer((n, r) => t[n][r] ?? n, e);
}
var to = (e) => {
  const { present: t, children: n } = e, r = sj(t), i = typeof n == "function" ? n({ present: r.isPresent }) : M.Children.only(n), a = Wr(r.ref, cj(i));
  return typeof n == "function" || r.isPresent ? M.cloneElement(i, { ref: a }) : null;
};
to.displayName = "Presence";
function sj(e) {
  const [t, n] = M.useState(), r = M.useRef({}), i = M.useRef(e), a = M.useRef("none"), c = e ? "mounted" : "unmounted", [d, f] = aj(c, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return M.useEffect(() => {
    const p = $0(r.current);
    a.current = d === "mounted" ? p : "none";
  }, [d]), gl(() => {
    const p = r.current, m = i.current;
    if (m !== e) {
      const g = a.current, w = $0(p);
      e ? f("MOUNT") : w === "none" || (p == null ? void 0 : p.display) === "none" ? f("UNMOUNT") : f(m && g !== w ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, f]), gl(() => {
    if (t) {
      let p;
      const m = t.ownerDocument.defaultView ?? window, v = (w) => {
        const b = $0(r.current).includes(w.animationName);
        if (w.target === t && b && (f("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", p = m.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, g = (w) => {
        w.target === t && (a.current = $0(r.current));
      };
      return t.addEventListener("animationstart", g), t.addEventListener("animationcancel", v), t.addEventListener("animationend", v), () => {
        m.clearTimeout(p), t.removeEventListener("animationstart", g), t.removeEventListener("animationcancel", v), t.removeEventListener("animationend", v);
      };
    } else
      f("ANIMATION_END");
  }, [t, f]), {
    isPresent: ["mounted", "unmountSuspended"].includes(d),
    ref: M.useCallback((p) => {
      p && (r.current = getComputedStyle(p)), n(p);
    }, [])
  };
}
function $0(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function cj(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Ka = 0;
function dj() {
  M.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? i6()), document.body.insertAdjacentElement("beforeend", e[1] ?? i6()), Ka++, () => {
      Ka === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Ka--;
    };
  }, []);
}
function i6() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var K3 = "Dialog", [Tf, mX] = _U(K3), [uj, Yn] = Tf(K3), Vf = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: a,
    modal: c = !0
  } = e, d = M.useRef(null), f = M.useRef(null), [p = !1, m] = NU({
    prop: r,
    defaultProp: i,
    onChange: a
  });
  return /* @__PURE__ */ u(
    uj,
    {
      scope: t,
      triggerRef: d,
      contentRef: f,
      contentId: _2(),
      titleId: _2(),
      descriptionId: _2(),
      open: p,
      onOpenChange: m,
      onOpenToggle: M.useCallback(() => m((v) => !v), [m]),
      modal: c,
      children: n
    }
  );
};
Vf.displayName = K3;
var Zf = "DialogTrigger", fj = M.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Yn(Zf, n), a = Wr(t, i.triggerRef);
    return /* @__PURE__ */ u(
      Vt.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": X3(i.open),
        ...r,
        ref: a,
        onClick: ar(e.onClick, i.onOpenToggle)
      }
    );
  }
);
fj.displayName = Zf;
var Y3 = "DialogPortal", [hj, $f] = Tf(Y3, {
  forceMount: void 0
}), Wf = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, a = Yn(Y3, t);
  return /* @__PURE__ */ u(hj, { scope: t, forceMount: n, children: M.Children.map(r, (c) => /* @__PURE__ */ u(to, { present: n || a.open, children: /* @__PURE__ */ u(If, { asChild: !0, container: i, children: c }) })) });
};
Wf.displayName = Y3;
var Ll = "DialogOverlay", Gf = M.forwardRef(
  (e, t) => {
    const n = $f(Ll, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = Yn(Ll, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ u(to, { present: r || a.open, children: /* @__PURE__ */ u(pj, { ...i, ref: t }) }) : null;
  }
);
Gf.displayName = Ll;
var pj = M.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Yn(Ll, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ u(Si, { as: j3, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ u(
        Vt.div,
        {
          "data-state": X3(i.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Ir = "DialogContent", Uf = M.forwardRef(
  (e, t) => {
    const n = $f(Ir, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = Yn(Ir, e.__scopeDialog);
    return /* @__PURE__ */ u(to, { present: r || a.open, children: a.modal ? /* @__PURE__ */ u(mj, { ...i, ref: t }) : /* @__PURE__ */ u(vj, { ...i, ref: t }) });
  }
);
Uf.displayName = Ir;
var mj = M.forwardRef(
  (e, t) => {
    const n = Yn(Ir, e.__scopeDialog), r = M.useRef(null), i = Wr(t, n.contentRef, r);
    return M.useEffect(() => {
      const a = r.current;
      if (a) return Hl(a);
    }, []), /* @__PURE__ */ u(
      jf,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ar(e.onCloseAutoFocus, (a) => {
          var c;
          a.preventDefault(), (c = n.triggerRef.current) == null || c.focus();
        }),
        onPointerDownOutside: ar(e.onPointerDownOutside, (a) => {
          const c = a.detail.originalEvent, d = c.button === 0 && c.ctrlKey === !0;
          (c.button === 2 || d) && a.preventDefault();
        }),
        onFocusOutside: ar(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), vj = M.forwardRef(
  (e, t) => {
    const n = Yn(Ir, e.__scopeDialog), r = M.useRef(!1), i = M.useRef(!1);
    return /* @__PURE__ */ u(
      jf,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var c, d;
          (c = e.onCloseAutoFocus) == null || c.call(e, a), a.defaultPrevented || (r.current || (d = n.triggerRef.current) == null || d.focus(), a.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (a) => {
          var f, p;
          (f = e.onInteractOutside) == null || f.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const c = a.target;
          ((p = n.triggerRef.current) == null ? void 0 : p.contains(c)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && i.current && a.preventDefault();
        }
      }
    );
  }
), jf = M.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, ...c } = e, d = Yn(Ir, n), f = M.useRef(null), p = Wr(t, f);
    return dj(), /* @__PURE__ */ V(me, { children: [
      /* @__PURE__ */ u(
        Nf,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ u(
            Hf,
            {
              role: "dialog",
              id: d.contentId,
              "aria-describedby": d.descriptionId,
              "aria-labelledby": d.titleId,
              "data-state": X3(d.open),
              ...c,
              ref: p,
              onDismiss: () => d.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ V(me, { children: [
        /* @__PURE__ */ u(Mj, { titleId: d.titleId }),
        /* @__PURE__ */ u(bj, { contentRef: f, descriptionId: d.descriptionId })
      ] })
    ] });
  }
), q3 = "DialogTitle", gj = M.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Yn(q3, n);
    return /* @__PURE__ */ u(Vt.h2, { id: i.titleId, ...r, ref: t });
  }
);
gj.displayName = q3;
var Kf = "DialogDescription", Lj = M.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Yn(Kf, n);
    return /* @__PURE__ */ u(Vt.p, { id: i.descriptionId, ...r, ref: t });
  }
);
Lj.displayName = Kf;
var Yf = "DialogClose", wj = M.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = Yn(Yf, n);
    return /* @__PURE__ */ u(
      Vt.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: ar(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
wj.displayName = Yf;
function X3(e) {
  return e ? "open" : "closed";
}
var qf = "DialogTitleWarning", [vX, Xf] = RU(qf, {
  contentName: Ir,
  titleName: q3,
  docsSlug: "dialog"
}), Mj = ({ titleId: e }) => {
  const t = Xf(qf), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return M.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, xj = "DialogDescriptionWarning", bj = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Xf(xj).contentName}}.`;
  return M.useEffect(() => {
    var a;
    const i = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, yj = Vf, Cj = Wf, Ej = Gf, Fj = Uf, ii = '[cmdk-group=""]', Ya = '[cmdk-group-items=""]', zj = '[cmdk-group-heading=""]', Jf = '[cmdk-item=""]', l6 = `${Jf}:not([aria-disabled="true"])`, zs = "cmdk-item-select", f1 = "data-value", Aj = (e, t, n) => DU(e, t, n), Qf = M.createContext(void 0), Bi = () => M.useContext(Qf), eh = M.createContext(void 0), J3 = () => M.useContext(eh), th = M.createContext(void 0), nh = M.forwardRef((e, t) => {
  let n = h1(() => {
    var Q, ie;
    return { search: "", value: (ie = (Q = e.value) != null ? Q : e.defaultValue) != null ? ie : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = h1(() => /* @__PURE__ */ new Set()), i = h1(() => /* @__PURE__ */ new Map()), a = h1(() => /* @__PURE__ */ new Map()), c = h1(() => /* @__PURE__ */ new Set()), d = rh(e), { label: f, children: p, value: m, onValueChange: v, filter: g, shouldFilter: w, loop: x, disablePointerSelection: b = !1, vimBindings: y = !0, ...E } = e, z = _2(), k = _2(), R = _2(), F = M.useRef(null), _ = Ij();
  Tr(() => {
    if (m !== void 0) {
      let Q = m.trim();
      n.current.value = Q, P.emit();
    }
  }, [m]), Tr(() => {
    _(6, re);
  }, []);
  let P = M.useMemo(() => ({ subscribe: (Q) => (c.current.add(Q), () => c.current.delete(Q)), snapshot: () => n.current, setState: (Q, ie, pe) => {
    var U, Me, Le, xe;
    if (!Object.is(n.current[Q], ie)) {
      if (n.current[Q] = ie, Q === "search") X(), te(), _(1, Y);
      else if (Q === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let Ee = document.getElementById(R);
          Ee ? Ee.focus() : (U = document.getElementById(z)) == null || U.focus();
        }
        if (_(7, () => {
          var Ee;
          n.current.selectedItemId = (Ee = ee()) == null ? void 0 : Ee.id, P.emit();
        }), pe || _(5, re), ((Me = d.current) == null ? void 0 : Me.value) !== void 0) {
          let Ee = ie ?? "";
          (xe = (Le = d.current).onValueChange) == null || xe.call(Le, Ee);
          return;
        }
      }
      P.emit();
    }
  }, emit: () => {
    c.current.forEach((Q) => Q());
  } }), []), O = M.useMemo(() => ({ value: (Q, ie, pe) => {
    var U;
    ie !== ((U = a.current.get(Q)) == null ? void 0 : U.value) && (a.current.set(Q, { value: ie, keywords: pe }), n.current.filtered.items.set(Q, Z(ie, pe)), _(2, () => {
      te(), P.emit();
    }));
  }, item: (Q, ie) => (r.current.add(Q), ie && (i.current.has(ie) ? i.current.get(ie).add(Q) : i.current.set(ie, /* @__PURE__ */ new Set([Q]))), _(3, () => {
    X(), te(), n.current.value || Y(), P.emit();
  }), () => {
    a.current.delete(Q), r.current.delete(Q), n.current.filtered.items.delete(Q);
    let pe = ee();
    _(4, () => {
      X(), (pe == null ? void 0 : pe.getAttribute("id")) === Q && Y(), P.emit();
    });
  }), group: (Q) => (i.current.has(Q) || i.current.set(Q, /* @__PURE__ */ new Set()), () => {
    a.current.delete(Q), i.current.delete(Q);
  }), filter: () => d.current.shouldFilter, label: f || e["aria-label"], getDisablePointerSelection: () => d.current.disablePointerSelection, listId: z, inputId: R, labelId: k, listInnerRef: F }), []);
  function Z(Q, ie) {
    var pe, U;
    let Me = (U = (pe = d.current) == null ? void 0 : pe.filter) != null ? U : Aj;
    return Q ? Me(Q, n.current.search, ie) : 0;
  }
  function te() {
    if (!n.current.search || d.current.shouldFilter === !1) return;
    let Q = n.current.filtered.items, ie = [];
    n.current.filtered.groups.forEach((U) => {
      let Me = i.current.get(U), Le = 0;
      Me.forEach((xe) => {
        let Ee = Q.get(xe);
        Le = Math.max(Ee, Le);
      }), ie.push([U, Le]);
    });
    let pe = F.current;
    de().sort((U, Me) => {
      var Le, xe;
      let Ee = U.getAttribute("id"), ye = Me.getAttribute("id");
      return ((Le = Q.get(ye)) != null ? Le : 0) - ((xe = Q.get(Ee)) != null ? xe : 0);
    }).forEach((U) => {
      let Me = U.closest(Ya);
      Me ? Me.appendChild(U.parentElement === Me ? U : U.closest(`${Ya} > *`)) : pe.appendChild(U.parentElement === pe ? U : U.closest(`${Ya} > *`));
    }), ie.sort((U, Me) => Me[1] - U[1]).forEach((U) => {
      var Me;
      let Le = (Me = F.current) == null ? void 0 : Me.querySelector(`${ii}[${f1}="${encodeURIComponent(U[0])}"]`);
      Le == null || Le.parentElement.appendChild(Le);
    });
  }
  function Y() {
    let Q = de().find((pe) => pe.getAttribute("aria-disabled") !== "true"), ie = Q == null ? void 0 : Q.getAttribute(f1);
    P.setState("value", ie || void 0);
  }
  function X() {
    var Q, ie, pe, U;
    if (!n.current.search || d.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let Me = 0;
    for (let Le of r.current) {
      let xe = (ie = (Q = a.current.get(Le)) == null ? void 0 : Q.value) != null ? ie : "", Ee = (U = (pe = a.current.get(Le)) == null ? void 0 : pe.keywords) != null ? U : [], ye = Z(xe, Ee);
      n.current.filtered.items.set(Le, ye), ye > 0 && Me++;
    }
    for (let [Le, xe] of i.current) for (let Ee of xe) if (n.current.filtered.items.get(Ee) > 0) {
      n.current.filtered.groups.add(Le);
      break;
    }
    n.current.filtered.count = Me;
  }
  function re() {
    var Q, ie, pe;
    let U = ee();
    U && (((Q = U.parentElement) == null ? void 0 : Q.firstChild) === U && ((pe = (ie = U.closest(ii)) == null ? void 0 : ie.querySelector(zj)) == null || pe.scrollIntoView({ block: "nearest" })), U.scrollIntoView({ block: "nearest" }));
  }
  function ee() {
    var Q;
    return (Q = F.current) == null ? void 0 : Q.querySelector(`${Jf}[aria-selected="true"]`);
  }
  function de() {
    var Q;
    return Array.from(((Q = F.current) == null ? void 0 : Q.querySelectorAll(l6)) || []);
  }
  function ae(Q) {
    let ie = de()[Q];
    ie && P.setState("value", ie.getAttribute(f1));
  }
  function ge(Q) {
    var ie;
    let pe = ee(), U = de(), Me = U.findIndex((xe) => xe === pe), Le = U[Me + Q];
    (ie = d.current) != null && ie.loop && (Le = Me + Q < 0 ? U[U.length - 1] : Me + Q === U.length ? U[0] : U[Me + Q]), Le && P.setState("value", Le.getAttribute(f1));
  }
  function K(Q) {
    let ie = ee(), pe = ie == null ? void 0 : ie.closest(ii), U;
    for (; pe && !U; ) pe = Q > 0 ? Nj(pe, ii) : Bj(pe, ii), U = pe == null ? void 0 : pe.querySelector(l6);
    U ? P.setState("value", U.getAttribute(f1)) : ge(Q);
  }
  let J = () => ae(de().length - 1), he = (Q) => {
    Q.preventDefault(), Q.metaKey ? J() : Q.altKey ? K(1) : ge(1);
  }, ve = (Q) => {
    Q.preventDefault(), Q.metaKey ? ae(0) : Q.altKey ? K(-1) : ge(-1);
  };
  return M.createElement(Vt.div, { ref: t, tabIndex: -1, ...E, "cmdk-root": "", onKeyDown: (Q) => {
    var ie;
    (ie = E.onKeyDown) == null || ie.call(E, Q);
    let pe = Q.nativeEvent.isComposing || Q.keyCode === 229;
    if (!(Q.defaultPrevented || pe)) switch (Q.key) {
      case "n":
      case "j": {
        y && Q.ctrlKey && he(Q);
        break;
      }
      case "ArrowDown": {
        he(Q);
        break;
      }
      case "p":
      case "k": {
        y && Q.ctrlKey && ve(Q);
        break;
      }
      case "ArrowUp": {
        ve(Q);
        break;
      }
      case "Home": {
        Q.preventDefault(), ae(0);
        break;
      }
      case "End": {
        Q.preventDefault(), J();
        break;
      }
      case "Enter": {
        Q.preventDefault();
        let U = ee();
        if (U) {
          let Me = new Event(zs);
          U.dispatchEvent(Me);
        }
      }
    }
  } }, M.createElement("label", { "cmdk-label": "", htmlFor: O.inputId, id: O.labelId, style: Vj }, f), no(e, (Q) => M.createElement(eh.Provider, { value: P }, M.createElement(Qf.Provider, { value: O }, Q))));
}), Sj = M.forwardRef((e, t) => {
  var n, r;
  let i = _2(), a = M.useRef(null), c = M.useContext(th), d = Bi(), f = rh(e), p = (r = (n = f.current) == null ? void 0 : n.forceMount) != null ? r : c == null ? void 0 : c.forceMount;
  Tr(() => {
    if (!p) return d.item(i, c == null ? void 0 : c.id);
  }, [p]);
  let m = ih(i, a, [e.value, e.children, a], e.keywords), v = J3(), g = fr((_) => _.value && _.value === m.current), w = fr((_) => p || d.filter() === !1 ? !0 : _.search ? _.filtered.items.get(i) > 0 : !0);
  M.useEffect(() => {
    let _ = a.current;
    if (!(!_ || e.disabled)) return _.addEventListener(zs, x), () => _.removeEventListener(zs, x);
  }, [w, e.onSelect, e.disabled]);
  function x() {
    var _, P;
    b(), (P = (_ = f.current).onSelect) == null || P.call(_, m.current);
  }
  function b() {
    v.setState("value", m.current, !0);
  }
  if (!w) return null;
  let { disabled: y, value: E, onSelect: z, forceMount: k, keywords: R, ...F } = e;
  return M.createElement(Vt.div, { ref: Nr(a, t), ...F, id: i, "cmdk-item": "", role: "option", "aria-disabled": !!y, "aria-selected": !!g, "data-disabled": !!y, "data-selected": !!g, onPointerMove: y || d.getDisablePointerSelection() ? void 0 : b, onClick: y ? void 0 : x }, e.children);
}), kj = M.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: i, ...a } = e, c = _2(), d = M.useRef(null), f = M.useRef(null), p = _2(), m = Bi(), v = fr((w) => i || m.filter() === !1 ? !0 : w.search ? w.filtered.groups.has(c) : !0);
  Tr(() => m.group(c), []), ih(c, d, [e.value, e.heading, f]);
  let g = M.useMemo(() => ({ id: c, forceMount: i }), [i]);
  return M.createElement(Vt.div, { ref: Nr(d, t), ...a, "cmdk-group": "", role: "presentation", hidden: v ? void 0 : !0 }, n && M.createElement("div", { ref: f, "cmdk-group-heading": "", "aria-hidden": !0, id: p }, n), no(e, (w) => M.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? p : void 0 }, M.createElement(th.Provider, { value: g }, w))));
}), Dj = M.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, i = M.useRef(null), a = fr((c) => !c.search);
  return !n && !a ? null : M.createElement(Vt.div, { ref: Nr(i, t), ...r, "cmdk-separator": "", role: "separator" });
}), Rj = M.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, i = e.value != null, a = J3(), c = fr((p) => p.search), d = fr((p) => p.selectedItemId), f = Bi();
  return M.useEffect(() => {
    e.value != null && a.setState("search", e.value);
  }, [e.value]), M.createElement(Vt.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": f.listId, "aria-labelledby": f.labelId, "aria-activedescendant": d, id: f.inputId, type: "text", value: i ? e.value : c, onChange: (p) => {
    i || a.setState("search", p.target.value), n == null || n(p.target.value);
  } });
}), _j = M.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...i } = e, a = M.useRef(null), c = M.useRef(null), d = fr((p) => p.selectedItemId), f = Bi();
  return M.useEffect(() => {
    if (c.current && a.current) {
      let p = c.current, m = a.current, v, g = new ResizeObserver(() => {
        v = requestAnimationFrame(() => {
          let w = p.offsetHeight;
          m.style.setProperty("--cmdk-list-height", w.toFixed(1) + "px");
        });
      });
      return g.observe(p), () => {
        cancelAnimationFrame(v), g.unobserve(p);
      };
    }
  }, []), M.createElement(Vt.div, { ref: Nr(a, t), ...i, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": d, "aria-label": r, id: f.listId }, no(e, (p) => M.createElement("div", { ref: Nr(c, f.listInnerRef), "cmdk-list-sizer": "" }, p)));
}), Pj = M.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: i, contentClassName: a, container: c, ...d } = e;
  return M.createElement(yj, { open: n, onOpenChange: r }, M.createElement(Cj, { container: c }, M.createElement(Ej, { "cmdk-overlay": "", className: i }), M.createElement(Fj, { "aria-label": e.label, "cmdk-dialog": "", className: a }, M.createElement(nh, { ref: t, ...d }))));
}), Hj = M.forwardRef((e, t) => fr((n) => n.filtered.count === 0) ? M.createElement(Vt.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), Oj = M.forwardRef((e, t) => {
  let { progress: n, children: r, label: i = "Loading...", ...a } = e;
  return M.createElement(Vt.div, { ref: t, ...a, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": i }, no(e, (c) => M.createElement("div", { "aria-hidden": !0 }, c)));
}), gr = Object.assign(nh, { List: _j, Item: Sj, Input: Rj, Group: kj, Separator: Dj, Dialog: Pj, Empty: Hj, Loading: Oj });
function Nj(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function Bj(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function rh(e) {
  let t = M.useRef(e);
  return Tr(() => {
    t.current = e;
  }), t;
}
var Tr = typeof window > "u" ? M.useEffect : M.useLayoutEffect;
function h1(e) {
  let t = M.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function fr(e) {
  let t = J3(), n = () => e(t.snapshot());
  return M.useSyncExternalStore(t.subscribe, n, n);
}
function ih(e, t, n, r = []) {
  let i = M.useRef(), a = Bi();
  return Tr(() => {
    var c;
    let d = (() => {
      var p;
      for (let m of n) {
        if (typeof m == "string") return m.trim();
        if (typeof m == "object" && "current" in m) return m.current ? (p = m.current.textContent) == null ? void 0 : p.trim() : i.current;
      }
    })(), f = r.map((p) => p.trim());
    a.value(e, d, f), (c = t.current) == null || c.setAttribute(f1, d), i.current = d;
  }), i;
}
var Ij = () => {
  let [e, t] = M.useState(), n = h1(() => /* @__PURE__ */ new Map());
  return Tr(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, i) => {
    n.current.set(r, i), t({});
  };
};
function Tj(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function no({ asChild: e, children: t }, n) {
  return e && M.isValidElement(t) ? M.cloneElement(Tj(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var Vj = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const Zj = O3;
Zj.displayName = "Spotlight";
const $j = N3;
$j.displayName = "SpotlightTrigger";
const lh = B3;
lh.displayName = "SpotlightPortal";
const oh = W(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  I3,
  {
    ref: n,
    className: S(
      "bg-overlay-background fixed inset-0 z-40 opacity-80",
      "data-[state=open]:animate-in data-[state=open]:fade-in-0",
      "data-[state=closed]:animate-out data-[state=closed]:fade-out-0"
    ),
    ...t
  }
));
oh.displayName = "SpotlightOverlay";
const Wj = W(({ children: e, ...t }, n) => /* @__PURE__ */ V(lh, { children: [
  /* @__PURE__ */ u(oh, {}),
  /* @__PURE__ */ V(
    T3,
    {
      ref: n,
      className: S(
        "fixed top-[50%] left-[50%] z-40 flex w-[90vw] translate-x-[-50%] translate-y-[-50%] duration-200",
        "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%]"
      ),
      ...t,
      children: [
        /* @__PURE__ */ V(x8, { children: [
          /* @__PURE__ */ u(sf, {}),
          /* @__PURE__ */ u(cf, {})
        ] }),
        /* @__PURE__ */ u("div", { className: S("relative mx-auto flex w-full max-w-screen-lg flex-col gap-16 rounded-md shadow-lg"), children: e })
      ]
    }
  )
] }));
Wj.displayName = "SpotlightContent";
const Q3 = W(
  ({ className: e, seamless: t, ...n }, r) => /* @__PURE__ */ u(
    gr,
    {
      ref: r,
      className: S("bg-spotlight-body-background text-spotlight-body-text flex h-full w-full flex-col rounded-md", {
        "border-spotlight-body-border border": !t
      }),
      ...n
    }
  )
);
Q3.displayName = "SpotlightPanel";
const e5 = W((e, t) => /* @__PURE__ */ u(gr.Loading, { ref: t, className: "py-6 text-center text-sm", ...e }));
e5.displayName = "SpotlightLoading";
const Gj = ({ children: e, ...t }) => /* @__PURE__ */ V(
  "div",
  {
    className: "[&_[cmdk-group-heading]]:text-typography-muted [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group]]:px-2 [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5",
    ...t,
    children: [
      /* @__PURE__ */ u("div", { className: "text-spotlight-body-icon flex", children: /* @__PURE__ */ u(Re, { name: "MagnifyingLens" }) }),
      e
    ]
  }
);
Gj.displayName = "SpotlightDialog";
const t5 = W(({ className: e, ...t }, n) => /* @__PURE__ */ V("div", { className: "border-spotlight-body-border relative border-b", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ u("div", { className: "text-spotlight-body-icon pointer-events-none absolute top-1/2 left-3 flex h-4 w-4 -translate-y-1/2", children: /* @__PURE__ */ u(Re, { name: "MagnifyingLens" }) }),
  /* @__PURE__ */ u(
    gr.Input,
    {
      ref: n,
      className: S(
        "placeholder:text-typography-muted flex h-11 w-full rounded-md bg-transparent p-3 pl-10 text-sm outline-hidden disabled:cursor-not-allowed disabled:opacity-50"
      ),
      ...t
    }
  )
] }));
t5.displayName = "SpotlightInput";
const Uj = ({ children: e }) => /* @__PURE__ */ u("div", { className: S("flex"), children: e });
Uj.displayName = "SpotlightSplit";
const n5 = W(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  gr.List,
  {
    ref: n,
    className: S("max-h-[300px] w-full overflow-x-hidden overflow-y-auto"),
    ...t
  }
));
n5.displayName = "SpotlightList";
const jj = ({ children: e }) => /* @__PURE__ */ u("div", { className: S("border-spotlight-body-border flex w-full border-l"), children: e });
jj.displayName = "SpotlightSub";
const r5 = W((e, t) => /* @__PURE__ */ u(gr.Empty, { ref: t, className: "py-6 text-center text-sm", ...e }));
r5.displayName = "SpotlightEmpty";
const wl = W(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  gr.Group,
  {
    ref: n,
    className: S(
      "[&_[cmdk-group-heading]]:text-typography-muted [&_[cmdk-group-heading]]:cursor-default [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium",
      e
    ),
    ...t
  }
));
wl.displayName = "SpotlightGroup";
const Kj = W(({ className: e, ...t }, n) => /* @__PURE__ */ u(gr.Separator, { ref: n, className: S("bg-border-default -mx-1 h-px", e), ...t }));
Kj.displayName = "SpotlightSeparator";
const Ml = W(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  gr.Item,
  {
    ref: n,
    className: S(
      "text-list-default-text group flex w-full cursor-pointer items-center gap-8 p-2 text-sm select-none",
      "hover:bg-list-hover-background hover:text-list-hover-text",
      "focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-hidden",
      "data-[selected=true]:bg-list-selected-background data-[selected=true]:text-list-selected-text",
      "data-[disabled=true]:bg-list-disabled-background data-[disabled=true]:text-list-disabled-text data-[disabled=true]:pointer-events-none data-[disabled=true]:cursor-not-allowed"
    ),
    ...t
  }
));
Ml.displayName = "SpotlightItem";
const Yj = ({ className: e, ...t }) => /* @__PURE__ */ u("span", { className: S("text-typography-muted ml-auto text-xs tracking-widest"), ...t });
Yj.displayName = "SpotlightShortcut";
const qj = ({ children: e }) => /* @__PURE__ */ u(
  "div",
  {
    className: S(
      "bg-spotlight-footer-background text-spotlight-footer-text flex h-8 justify-end gap-8 rounded-b-md p-2 text-xs"
    ),
    children: e
  }
);
qj.displayName = "SpotlightFooter";
const ah = 3;
function Xj({
  badgeRefs: e,
  containerWidth: t,
  defaultMaxVisible: n = ah
}) {
  if (t <= 0)
    return Math.min(1, n);
  let r = 0;
  for (let i = 0; i < e.length; i++) {
    const a = e[i];
    if (a && (r += a.offsetWidth + 8, r > t))
      return Math.max(i, 1);
  }
  return n;
}
const Jj = (e) => {
  const t = parseFloat(getComputedStyle(e).paddingLeft) || 0, n = parseFloat(getComputedStyle(e).paddingRight) || 0, r = e.offsetWidth - t - n;
  return Math.max(r, 0);
}, Qj = W(
  ({
    id: e,
    placeholder: t,
    label: n,
    value: r = [],
    onChange: i,
    items: a = [],
    state: c,
    disabled: d,
    required: f,
    searchable: p,
    hint: m,
    onSearchValueChange: v,
    loading: g = !1,
    renderLabel: w
  }, x) => {
    const [b, y] = q(!1), E = It(null), z = It([]), k = Math.min(ah, a.length), [R, F] = q(k), [_, P] = q(!1), O = Ut(() => a.filter((X) => r.includes(X.value)), [a, r]), Z = Ut(() => a.filter((X) => !r.includes(X.value)), [a, r]), te = (X) => {
      i == null || i(
        r.find((re) => re === X) ? r.filter((re) => re !== X) : r.concat(X)
      );
    }, Y = Tx(
      (X) => {
        if (!E.current) return () => {
        };
        let re = null;
        if (typeof ResizeObserver < "u")
          return re = new ResizeObserver(X), re.observe(E.current), () => {
            re && re.disconnect();
          };
        {
          const ee = () => X();
          return window.addEventListener("resize", ee), () => {
            window.removeEventListener("resize", ee);
          };
        }
      },
      () => E.current ? Jj(E.current) : 0,
      () => 0
      // getServerSnapshot: return default value for SSR
    );
    return J0(() => {
      O.length > 0 && Y > 0 ? (F(k), P(!0)) : O.length === 0 && (F(k), P(!1));
    }, [O.length, Y]), J0(() => {
      if (_ && E.current && z.current.length > 0 && O.length > 0) {
        const X = Xj({
          badgeRefs: z.current,
          containerWidth: Y,
          defaultMaxVisible: k
        });
        F((re) => re !== X ? X : re);
      }
      _ && P(!1);
    }, [_, Y, O.length]), /* @__PURE__ */ V("div", { className: "flex flex-col gap-2", children: [
      n ? /* @__PURE__ */ u(jn, { htmlFor: e, required: f, children: n }) : null,
      /* @__PURE__ */ V(Zr, { open: b, onOpenChange: y, children: [
        /* @__PURE__ */ u(R1, { children: /* @__PURE__ */ V(
          "button",
          {
            id: e,
            className: S(
              "border-multiselect-default-border text-multiselect-default-text bg-multiselect-default-background group flex inline-flex h-8 w-full items-center justify-between gap-4 rounded-md border px-2 py-2 text-sm shadow-xs transition-colors",
              "focus-visible:border-multiselect-active-border focus-visible:bg-multiselect-active-background focus-visible:ring-select-active-border focus-visible:ring-offset-select-active-border focus-visible:outline-hidden",
              {
                "bg-multiselect-negative-background border-multiselect-negative-border text-multiselect-negative-typography text-multiselect-negative-text focus-visible:text-multiselect-negative-text": c === "negative",
                "bg-multiselect-disabled-background border-multiselect-disabled-border text-multiselect-disabled-typography text-multiselect-disabled-text cursor-not-allowed": d,
                "bg-multiselect-selected-background border-multiselect-selected-border text-multiselect-selected-typography text-multiselect-selected-text": r.length > 0,
                "bg-multiselect-open-background border-multiselect-open-border text-multiselect-open-text": b,
                "hover:bg-multiselect-hover-background hover:border-multiselect-hover-border hover:text-multiselect-hover-text": !b
              }
            ),
            "aria-controls": `${e}-listbox`,
            "aria-expanded": b,
            role: p ? "combobox" : "button",
            disabled: d,
            "aria-label": n,
            ref: E,
            children: [
              /* @__PURE__ */ u("input", { type: "hidden", defaultValue: r, ref: x }),
              r.length > 0 ? /* @__PURE__ */ V("div", { className: "flex items-center gap-8 overflow-hidden", children: [
                O.slice(0, R).map((X, re) => /* @__PURE__ */ u(
                  U3,
                  {
                    "data-testid": "multiselect-badge",
                    ref: (ee) => {
                      z.current[re] = ee;
                    },
                    label: X.label,
                    onRemove: (ee) => {
                      ee.stopPropagation(), i == null || i(r.filter((de) => de !== X.value));
                    }
                  },
                  X.value
                )),
                r.length - R > 0 && /* @__PURE__ */ V(tt, { "data-testid": "badge-overflow-indicator", variant: "small", children: [
                  "+",
                  r.length - R
                ] })
              ] }) : /* @__PURE__ */ u(
                "div",
                {
                  className: S("text-multiselect-default-placeholder text-sm", {
                    "text-select-negative-typography text-select-negative-text focus-visible:text-select-negative-text": c === "negative"
                  }),
                  children: t
                }
              ),
              r.length > 0 ? /* @__PURE__ */ u(
                "div",
                {
                  className: S("text-multiselect-default-icon flex", "group-hover:text-multiselect-hover-icon", {
                    "text-multiselect-negative-icon": c === "negative",
                    "text-multiselect-disabled-icon": d
                  }),
                  onClick: () => i == null ? void 0 : i([]),
                  "aria-label": "Clear selection",
                  children: /* @__PURE__ */ u(Re, { size: "xs", name: "Close" })
                }
              ) : /* @__PURE__ */ u(
                "div",
                {
                  className: S("text-multiselect-default-icon flex", "group-hover:text-multiselect-hover-icon", {
                    "text-multiselect-negative-icon": c === "negative",
                    "text-multiselect-disabled-icon": d
                  }),
                  children: /* @__PURE__ */ u(Re, { size: "xs", name: "ChevronDown" })
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ u($r, { className: "w-full min-w-60 p-0", align: "start", children: /* @__PURE__ */ V(Q3, { seamless: !0, children: [
          p && /* @__PURE__ */ u(t5, { placeholder: "Search", onValueChange: v }),
          /* @__PURE__ */ u(n5, { id: `${e}-listbox`, role: "listbox", children: g ? /* @__PURE__ */ u(e5, { children: "Loading..." }) : /* @__PURE__ */ V(me, { children: [
            /* @__PURE__ */ u(r5, { children: "No item found." }),
            Z.length > 0 && /* @__PURE__ */ u(wl, { heading: "Suggestions", children: Z.map(
              (X) => w ? w(X.value) : /* @__PURE__ */ V(
                Ml,
                {
                  value: X.value,
                  keywords: [X.label, ...X.keywords || []],
                  onSelect: te,
                  children: [
                    /* @__PURE__ */ u(Rr, { checked: !1, label: "" }),
                    X.label
                  ]
                },
                X.value
              )
            ) }),
            O.length > 0 && /* @__PURE__ */ u(wl, { heading: "Selected", children: O.map(
              (X) => w ? w(X.value) : /* @__PURE__ */ V(
                Ml,
                {
                  value: X.value,
                  keywords: [X.label, ...X.keywords || []],
                  onSelect: te,
                  children: [
                    /* @__PURE__ */ u(Rr, { checked: !0, label: "" }),
                    X == null ? void 0 : X.label
                  ]
                },
                X.value
              )
            ) })
          ] }) })
        ] }) })
      ] }),
      m && /* @__PURE__ */ u(
        "div",
        {
          className: S("text-hint-default-text text-xs", {
            "text-hint-negative-text": c === "negative"
          }),
          children: m
        }
      )
    ] });
  }
);
Qj.displayName = "MultiSelect";
const sh = W(({ className: e, ...t }, n) => /* @__PURE__ */ u("nav", { ref: n, className: S("flex w-fit"), ...t }));
sh.displayName = "Pagination";
const ch = W(({ className: e, ...t }, n) => /* @__PURE__ */ u("ul", { ref: n, className: S("flex flex-row items-center gap-2"), ...t }));
ch.displayName = "PaginationContent";
const X0 = W(({ className: e, ...t }, n) => /* @__PURE__ */ u("li", { ref: n, ...t }));
X0.displayName = "PaginationItem";
const dh = ({ className: e, active: t, size: n = "default", ...r }) => /* @__PURE__ */ u(
  "button",
  {
    "aria-current": t ? "page" : void 0,
    className: S(
      "text-button-ghost-default-text flex h-6 w-6 items-center justify-center gap-4 rounded-md border border-transparent text-center select-none",
      "hover:border-button-ghost-default-text",
      {
        "border-button-ghost-default-text pointer-events-none": t,
        "cursor-pointer": !t
      }
    ),
    ...r
  }
);
dh.displayName = "PaginationLink";
const uh = ({ className: e, ...t }) => /* @__PURE__ */ V(
  "button",
  {
    "aria-label": "Go to previous page",
    size: "default",
    className: S(
      "text-button-ghost-default-text flex h-6 cursor-pointer items-center justify-center gap-4 rounded-md border border-transparent px-1 select-none",
      "hover:border-button-ghost-default-text"
    ),
    ...t,
    children: [
      /* @__PURE__ */ u(Re, { name: "ChevronLeft", size: "xs" }),
      /* @__PURE__ */ u("span", { children: "Previous" })
    ]
  }
);
uh.displayName = "PaginationPrevious";
const fh = ({ className: e, ...t }) => /* @__PURE__ */ V(
  "button",
  {
    "aria-label": "Go to next page",
    size: "default",
    className: S(
      "text-button-ghost-default-text flex h-6 cursor-pointer items-center justify-center gap-4 rounded-md border border-transparent px-1 select-none",
      "hover:border-button-ghost-default-text"
    ),
    ...t,
    children: [
      /* @__PURE__ */ u("span", { children: "Next" }),
      /* @__PURE__ */ u(Re, { name: "ChevronRight", size: "xs" })
    ]
  }
);
fh.displayName = "PaginationNext";
const hh = ({ className: e, ...t }) => /* @__PURE__ */ V(
  "span",
  {
    "aria-hidden": !0,
    className: S(
      "text-button-ghost-default-text flex h-6 w-4 items-center justify-center gap-4 rounded-md border border-transparent"
    ),
    ...t,
    children: [
      "…",
      /* @__PURE__ */ u("span", { className: "sr-only", children: "More pages" })
    ]
  }
);
hh.displayName = "PaginationEllipsis";
var i5 = "Progress", l5 = 100, [eK, gX] = Tt(i5), [tK, nK] = eK(i5), ph = M.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: n,
      value: r = null,
      max: i,
      getValueLabel: a = rK,
      ...c
    } = e;
    (i || i === 0) && !o6(i) && console.error(iK(`${i}`, "Progress"));
    const d = o6(i) ? i : l5;
    r !== null && !a6(r, d) && console.error(lK(`${r}`, "Progress"));
    const f = a6(r, d) ? r : null, p = xl(f) ? a(f, d) : void 0;
    return /* @__PURE__ */ u(tK, { scope: n, value: f, max: d, children: /* @__PURE__ */ u(
      ke.div,
      {
        "aria-valuemax": d,
        "aria-valuemin": 0,
        "aria-valuenow": xl(f) ? f : void 0,
        "aria-valuetext": p,
        role: "progressbar",
        "data-state": gh(f, d),
        "data-value": f ?? void 0,
        "data-max": d,
        ...c,
        ref: t
      }
    ) });
  }
);
ph.displayName = i5;
var mh = "ProgressIndicator", vh = M.forwardRef(
  (e, t) => {
    const { __scopeProgress: n, ...r } = e, i = nK(mh, n);
    return /* @__PURE__ */ u(
      ke.div,
      {
        "data-state": gh(i.value, i.max),
        "data-value": i.value ?? void 0,
        "data-max": i.max,
        ...r,
        ref: t
      }
    );
  }
);
vh.displayName = mh;
function rK(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function gh(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function xl(e) {
  return typeof e == "number";
}
function o6(e) {
  return xl(e) && !isNaN(e) && e > 0;
}
function a6(e, t) {
  return xl(e) && !isNaN(e) && e <= t && e >= 0;
}
function iK(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${l5}\`.`;
}
function lK(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${l5} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var oK = ph, aK = vh;
const sK = W(({ className: e, value: t, ...n }, r) => /* @__PURE__ */ u(
  oK,
  {
    ref: r,
    className: S("bg-progress-background relative h-1 w-full max-w-52 overflow-hidden rounded-full"),
    ...n,
    children: /* @__PURE__ */ u(
      aK,
      {
        className: "bg-progress-indicator h-full w-full flex-1 transition-all",
        style: { transform: `translateX(-${100 - (t || 0)}%)` }
      }
    )
  }
));
sK.displayName = "Progress";
var ci = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var cK = ci.exports, s6;
function dK() {
  return s6 || (s6 = 1, function(e, t) {
    (function() {
      var n, r = "4.17.21", i = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", c = "Expected a function", d = "Invalid `variable` option passed into `_.template`", f = "__lodash_hash_undefined__", p = 500, m = "__lodash_placeholder__", v = 1, g = 2, w = 4, x = 1, b = 2, y = 1, E = 2, z = 4, k = 8, R = 16, F = 32, _ = 64, P = 128, O = 256, Z = 512, te = 30, Y = "...", X = 800, re = 16, ee = 1, de = 2, ae = 3, ge = 1 / 0, K = 9007199254740991, J = 17976931348623157e292, he = NaN, ve = 4294967295, Q = ve - 1, ie = ve >>> 1, pe = [
        ["ary", P],
        ["bind", y],
        ["bindKey", E],
        ["curry", k],
        ["curryRight", R],
        ["flip", Z],
        ["partial", F],
        ["partialRight", _],
        ["rearg", O]
      ], U = "[object Arguments]", Me = "[object Array]", Le = "[object AsyncFunction]", xe = "[object Boolean]", Ee = "[object Date]", ye = "[object DOMException]", Be = "[object Error]", ft = "[object Function]", Et = "[object GeneratorFunction]", Lt = "[object Map]", je = "[object Number]", B2 = "[object Null]", _t = "[object Object]", m2 = "[object Promise]", cn = "[object Proxy]", qn = "[object RegExp]", Pt = "[object Set]", On = "[object String]", dn = "[object Symbol]", I2 = "[object Undefined]", Xn = "[object WeakMap]", Gr = "[object WeakSet]", En = "[object ArrayBuffer]", Nn = "[object DataView]", Jn = "[object Float32Array]", T2 = "[object Float64Array]", Qn = "[object Int8Array]", V2 = "[object Int16Array]", e2 = "[object Int32Array]", Z2 = "[object Uint8Array]", t2 = "[object Uint8ClampedArray]", v2 = "[object Uint16Array]", n2 = "[object Uint32Array]", Lr = /\b__p \+= '';/g, Ie = /\b(__p \+=) '' \+/g, ot = /(__e\(.*?\)|\b__t\)) \+\n'';/g, nt = /&(?:amp|lt|gt|quot|#39);/g, nn = /[&<>"']/g, Ht = RegExp(nt.source), g2 = RegExp(nn.source), wt = /<%-([\s\S]+?)%>/g, Xt = /<%([\s\S]+?)%>/g, qe = /<%=([\s\S]+?)%>/g, Ur = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, P1 = /^\w*$/, L2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, _e = /[\\^$.*+?()[\]{}|]/g, H1 = RegExp(_e.source), so = /^\s+/, Lp = /\s/, wp = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Mp = /\{\n\/\* \[wrapped with (.+)\] \*/, xp = /,? & /, bp = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, yp = /[()=,{}\[\]\/\s]/, Cp = /\\(\\)?/g, Ep = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, p5 = /\w*$/, Fp = /^[-+]0x[0-9a-f]+$/i, zp = /^0b[01]+$/i, Ap = /^\[object .+?Constructor\]$/, Sp = /^0o[0-7]+$/i, kp = /^(?:0|[1-9]\d*)$/, Dp = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Vi = /($^)/, Rp = /['\n\r\u2028\u2029\\]/g, Zi = "\\ud800-\\udfff", _p = "\\u0300-\\u036f", Pp = "\\ufe20-\\ufe2f", Hp = "\\u20d0-\\u20ff", m5 = _p + Pp + Hp, v5 = "\\u2700-\\u27bf", g5 = "a-z\\xdf-\\xf6\\xf8-\\xff", Op = "\\xac\\xb1\\xd7\\xf7", Np = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Bp = "\\u2000-\\u206f", Ip = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", L5 = "A-Z\\xc0-\\xd6\\xd8-\\xde", w5 = "\\ufe0e\\ufe0f", M5 = Op + Np + Bp + Ip, co = "['’]", Tp = "[" + Zi + "]", x5 = "[" + M5 + "]", $i = "[" + m5 + "]", b5 = "\\d+", Vp = "[" + v5 + "]", y5 = "[" + g5 + "]", C5 = "[^" + Zi + M5 + b5 + v5 + g5 + L5 + "]", uo = "\\ud83c[\\udffb-\\udfff]", Zp = "(?:" + $i + "|" + uo + ")", E5 = "[^" + Zi + "]", fo = "(?:\\ud83c[\\udde6-\\uddff]){2}", ho = "[\\ud800-\\udbff][\\udc00-\\udfff]", jr = "[" + L5 + "]", F5 = "\\u200d", z5 = "(?:" + y5 + "|" + C5 + ")", $p = "(?:" + jr + "|" + C5 + ")", A5 = "(?:" + co + "(?:d|ll|m|re|s|t|ve))?", S5 = "(?:" + co + "(?:D|LL|M|RE|S|T|VE))?", k5 = Zp + "?", D5 = "[" + w5 + "]?", Wp = "(?:" + F5 + "(?:" + [E5, fo, ho].join("|") + ")" + D5 + k5 + ")*", Gp = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Up = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", R5 = D5 + k5 + Wp, jp = "(?:" + [Vp, fo, ho].join("|") + ")" + R5, Kp = "(?:" + [E5 + $i + "?", $i, fo, ho, Tp].join("|") + ")", Yp = RegExp(co, "g"), qp = RegExp($i, "g"), po = RegExp(uo + "(?=" + uo + ")|" + Kp + R5, "g"), Xp = RegExp([
        jr + "?" + y5 + "+" + A5 + "(?=" + [x5, jr, "$"].join("|") + ")",
        $p + "+" + S5 + "(?=" + [x5, jr + z5, "$"].join("|") + ")",
        jr + "?" + z5 + "+" + A5,
        jr + "+" + S5,
        Up,
        Gp,
        b5,
        jp
      ].join("|"), "g"), Jp = RegExp("[" + F5 + Zi + m5 + w5 + "]"), Qp = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, em = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], tm = -1, mt = {};
      mt[Jn] = mt[T2] = mt[Qn] = mt[V2] = mt[e2] = mt[Z2] = mt[t2] = mt[v2] = mt[n2] = !0, mt[U] = mt[Me] = mt[En] = mt[xe] = mt[Nn] = mt[Ee] = mt[Be] = mt[ft] = mt[Lt] = mt[je] = mt[_t] = mt[qn] = mt[Pt] = mt[On] = mt[Xn] = !1;
      var ht = {};
      ht[U] = ht[Me] = ht[En] = ht[Nn] = ht[xe] = ht[Ee] = ht[Jn] = ht[T2] = ht[Qn] = ht[V2] = ht[e2] = ht[Lt] = ht[je] = ht[_t] = ht[qn] = ht[Pt] = ht[On] = ht[dn] = ht[Z2] = ht[t2] = ht[v2] = ht[n2] = !0, ht[Be] = ht[ft] = ht[Xn] = !1;
      var nm = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, rm = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, im = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, lm = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, om = parseFloat, am = parseInt, _5 = typeof R0 == "object" && R0 && R0.Object === Object && R0, sm = typeof self == "object" && self && self.Object === Object && self, Nt = _5 || sm || Function("return this")(), mo = t && !t.nodeType && t, wr = mo && !0 && e && !e.nodeType && e, P5 = wr && wr.exports === mo, vo = P5 && _5.process, Fn = function() {
        try {
          var G = wr && wr.require && wr.require("util").types;
          return G || vo && vo.binding && vo.binding("util");
        } catch {
        }
      }(), H5 = Fn && Fn.isArrayBuffer, O5 = Fn && Fn.isDate, N5 = Fn && Fn.isMap, B5 = Fn && Fn.isRegExp, I5 = Fn && Fn.isSet, T5 = Fn && Fn.isTypedArray;
      function un(G, oe, ne) {
        switch (ne.length) {
          case 0:
            return G.call(oe);
          case 1:
            return G.call(oe, ne[0]);
          case 2:
            return G.call(oe, ne[0], ne[1]);
          case 3:
            return G.call(oe, ne[0], ne[1], ne[2]);
        }
        return G.apply(oe, ne);
      }
      function cm(G, oe, ne, Ce) {
        for (var Te = -1, it = G == null ? 0 : G.length; ++Te < it; ) {
          var zt = G[Te];
          oe(Ce, zt, ne(zt), G);
        }
        return Ce;
      }
      function zn(G, oe) {
        for (var ne = -1, Ce = G == null ? 0 : G.length; ++ne < Ce && oe(G[ne], ne, G) !== !1; )
          ;
        return G;
      }
      function dm(G, oe) {
        for (var ne = G == null ? 0 : G.length; ne-- && oe(G[ne], ne, G) !== !1; )
          ;
        return G;
      }
      function V5(G, oe) {
        for (var ne = -1, Ce = G == null ? 0 : G.length; ++ne < Ce; )
          if (!oe(G[ne], ne, G))
            return !1;
        return !0;
      }
      function $2(G, oe) {
        for (var ne = -1, Ce = G == null ? 0 : G.length, Te = 0, it = []; ++ne < Ce; ) {
          var zt = G[ne];
          oe(zt, ne, G) && (it[Te++] = zt);
        }
        return it;
      }
      function Wi(G, oe) {
        var ne = G == null ? 0 : G.length;
        return !!ne && Kr(G, oe, 0) > -1;
      }
      function go(G, oe, ne) {
        for (var Ce = -1, Te = G == null ? 0 : G.length; ++Ce < Te; )
          if (ne(oe, G[Ce]))
            return !0;
        return !1;
      }
      function vt(G, oe) {
        for (var ne = -1, Ce = G == null ? 0 : G.length, Te = Array(Ce); ++ne < Ce; )
          Te[ne] = oe(G[ne], ne, G);
        return Te;
      }
      function W2(G, oe) {
        for (var ne = -1, Ce = oe.length, Te = G.length; ++ne < Ce; )
          G[Te + ne] = oe[ne];
        return G;
      }
      function Lo(G, oe, ne, Ce) {
        var Te = -1, it = G == null ? 0 : G.length;
        for (Ce && it && (ne = G[++Te]); ++Te < it; )
          ne = oe(ne, G[Te], Te, G);
        return ne;
      }
      function um(G, oe, ne, Ce) {
        var Te = G == null ? 0 : G.length;
        for (Ce && Te && (ne = G[--Te]); Te--; )
          ne = oe(ne, G[Te], Te, G);
        return ne;
      }
      function wo(G, oe) {
        for (var ne = -1, Ce = G == null ? 0 : G.length; ++ne < Ce; )
          if (oe(G[ne], ne, G))
            return !0;
        return !1;
      }
      var fm = Mo("length");
      function hm(G) {
        return G.split("");
      }
      function pm(G) {
        return G.match(bp) || [];
      }
      function Z5(G, oe, ne) {
        var Ce;
        return ne(G, function(Te, it, zt) {
          if (oe(Te, it, zt))
            return Ce = it, !1;
        }), Ce;
      }
      function Gi(G, oe, ne, Ce) {
        for (var Te = G.length, it = ne + (Ce ? 1 : -1); Ce ? it-- : ++it < Te; )
          if (oe(G[it], it, G))
            return it;
        return -1;
      }
      function Kr(G, oe, ne) {
        return oe === oe ? Fm(G, oe, ne) : Gi(G, $5, ne);
      }
      function mm(G, oe, ne, Ce) {
        for (var Te = ne - 1, it = G.length; ++Te < it; )
          if (Ce(G[Te], oe))
            return Te;
        return -1;
      }
      function $5(G) {
        return G !== G;
      }
      function W5(G, oe) {
        var ne = G == null ? 0 : G.length;
        return ne ? bo(G, oe) / ne : he;
      }
      function Mo(G) {
        return function(oe) {
          return oe == null ? n : oe[G];
        };
      }
      function xo(G) {
        return function(oe) {
          return G == null ? n : G[oe];
        };
      }
      function G5(G, oe, ne, Ce, Te) {
        return Te(G, function(it, zt, ut) {
          ne = Ce ? (Ce = !1, it) : oe(ne, it, zt, ut);
        }), ne;
      }
      function vm(G, oe) {
        var ne = G.length;
        for (G.sort(oe); ne--; )
          G[ne] = G[ne].value;
        return G;
      }
      function bo(G, oe) {
        for (var ne, Ce = -1, Te = G.length; ++Ce < Te; ) {
          var it = oe(G[Ce]);
          it !== n && (ne = ne === n ? it : ne + it);
        }
        return ne;
      }
      function yo(G, oe) {
        for (var ne = -1, Ce = Array(G); ++ne < G; )
          Ce[ne] = oe(ne);
        return Ce;
      }
      function gm(G, oe) {
        return vt(oe, function(ne) {
          return [ne, G[ne]];
        });
      }
      function U5(G) {
        return G && G.slice(0, q5(G) + 1).replace(so, "");
      }
      function fn(G) {
        return function(oe) {
          return G(oe);
        };
      }
      function Co(G, oe) {
        return vt(oe, function(ne) {
          return G[ne];
        });
      }
      function O1(G, oe) {
        return G.has(oe);
      }
      function j5(G, oe) {
        for (var ne = -1, Ce = G.length; ++ne < Ce && Kr(oe, G[ne], 0) > -1; )
          ;
        return ne;
      }
      function K5(G, oe) {
        for (var ne = G.length; ne-- && Kr(oe, G[ne], 0) > -1; )
          ;
        return ne;
      }
      function Lm(G, oe) {
        for (var ne = G.length, Ce = 0; ne--; )
          G[ne] === oe && ++Ce;
        return Ce;
      }
      var wm = xo(nm), Mm = xo(rm);
      function xm(G) {
        return "\\" + lm[G];
      }
      function bm(G, oe) {
        return G == null ? n : G[oe];
      }
      function Yr(G) {
        return Jp.test(G);
      }
      function ym(G) {
        return Qp.test(G);
      }
      function Cm(G) {
        for (var oe, ne = []; !(oe = G.next()).done; )
          ne.push(oe.value);
        return ne;
      }
      function Eo(G) {
        var oe = -1, ne = Array(G.size);
        return G.forEach(function(Ce, Te) {
          ne[++oe] = [Te, Ce];
        }), ne;
      }
      function Y5(G, oe) {
        return function(ne) {
          return G(oe(ne));
        };
      }
      function G2(G, oe) {
        for (var ne = -1, Ce = G.length, Te = 0, it = []; ++ne < Ce; ) {
          var zt = G[ne];
          (zt === oe || zt === m) && (G[ne] = m, it[Te++] = ne);
        }
        return it;
      }
      function Ui(G) {
        var oe = -1, ne = Array(G.size);
        return G.forEach(function(Ce) {
          ne[++oe] = Ce;
        }), ne;
      }
      function Em(G) {
        var oe = -1, ne = Array(G.size);
        return G.forEach(function(Ce) {
          ne[++oe] = [Ce, Ce];
        }), ne;
      }
      function Fm(G, oe, ne) {
        for (var Ce = ne - 1, Te = G.length; ++Ce < Te; )
          if (G[Ce] === oe)
            return Ce;
        return -1;
      }
      function zm(G, oe, ne) {
        for (var Ce = ne + 1; Ce--; )
          if (G[Ce] === oe)
            return Ce;
        return Ce;
      }
      function qr(G) {
        return Yr(G) ? Sm(G) : fm(G);
      }
      function Bn(G) {
        return Yr(G) ? km(G) : hm(G);
      }
      function q5(G) {
        for (var oe = G.length; oe-- && Lp.test(G.charAt(oe)); )
          ;
        return oe;
      }
      var Am = xo(im);
      function Sm(G) {
        for (var oe = po.lastIndex = 0; po.test(G); )
          ++oe;
        return oe;
      }
      function km(G) {
        return G.match(po) || [];
      }
      function Dm(G) {
        return G.match(Xp) || [];
      }
      var Rm = function G(oe) {
        oe = oe == null ? Nt : Xr.defaults(Nt.Object(), oe, Xr.pick(Nt, em));
        var ne = oe.Array, Ce = oe.Date, Te = oe.Error, it = oe.Function, zt = oe.Math, ut = oe.Object, Fo = oe.RegExp, _m = oe.String, An = oe.TypeError, ji = ne.prototype, Pm = it.prototype, Jr = ut.prototype, Ki = oe["__core-js_shared__"], Yi = Pm.toString, at = Jr.hasOwnProperty, Hm = 0, X5 = function() {
          var l = /[^.]+$/.exec(Ki && Ki.keys && Ki.keys.IE_PROTO || "");
          return l ? "Symbol(src)_1." + l : "";
        }(), qi = Jr.toString, Om = Yi.call(ut), Nm = Nt._, Bm = Fo(
          "^" + Yi.call(at).replace(_e, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Xi = P5 ? oe.Buffer : n, U2 = oe.Symbol, Ji = oe.Uint8Array, J5 = Xi ? Xi.allocUnsafe : n, Qi = Y5(ut.getPrototypeOf, ut), Q5 = ut.create, ec = Jr.propertyIsEnumerable, e0 = ji.splice, tc = U2 ? U2.isConcatSpreadable : n, N1 = U2 ? U2.iterator : n, Mr = U2 ? U2.toStringTag : n, t0 = function() {
          try {
            var l = Er(ut, "defineProperty");
            return l({}, "", {}), l;
          } catch {
          }
        }(), Im = oe.clearTimeout !== Nt.clearTimeout && oe.clearTimeout, Tm = Ce && Ce.now !== Nt.Date.now && Ce.now, Vm = oe.setTimeout !== Nt.setTimeout && oe.setTimeout, n0 = zt.ceil, r0 = zt.floor, zo = ut.getOwnPropertySymbols, Zm = Xi ? Xi.isBuffer : n, nc = oe.isFinite, $m = ji.join, Wm = Y5(ut.keys, ut), At = zt.max, Zt = zt.min, Gm = Ce.now, Um = oe.parseInt, rc = zt.random, jm = ji.reverse, Ao = Er(oe, "DataView"), B1 = Er(oe, "Map"), So = Er(oe, "Promise"), Qr = Er(oe, "Set"), I1 = Er(oe, "WeakMap"), T1 = Er(ut, "create"), i0 = I1 && new I1(), e1 = {}, Km = Fr(Ao), Ym = Fr(B1), qm = Fr(So), Xm = Fr(Qr), Jm = Fr(I1), l0 = U2 ? U2.prototype : n, V1 = l0 ? l0.valueOf : n, ic = l0 ? l0.toString : n;
        function A(l) {
          if (bt(l) && !Ve(l) && !(l instanceof Qe)) {
            if (l instanceof Sn)
              return l;
            if (at.call(l, "__wrapped__"))
              return l4(l);
          }
          return new Sn(l);
        }
        var t1 = /* @__PURE__ */ function() {
          function l() {
          }
          return function(s) {
            if (!Mt(s))
              return {};
            if (Q5)
              return Q5(s);
            l.prototype = s;
            var h = new l();
            return l.prototype = n, h;
          };
        }();
        function o0() {
        }
        function Sn(l, s) {
          this.__wrapped__ = l, this.__actions__ = [], this.__chain__ = !!s, this.__index__ = 0, this.__values__ = n;
        }
        A.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: wt,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Xt,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: qe,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: A
          }
        }, A.prototype = o0.prototype, A.prototype.constructor = A, Sn.prototype = t1(o0.prototype), Sn.prototype.constructor = Sn;
        function Qe(l) {
          this.__wrapped__ = l, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = ve, this.__views__ = [];
        }
        function Qm() {
          var l = new Qe(this.__wrapped__);
          return l.__actions__ = rn(this.__actions__), l.__dir__ = this.__dir__, l.__filtered__ = this.__filtered__, l.__iteratees__ = rn(this.__iteratees__), l.__takeCount__ = this.__takeCount__, l.__views__ = rn(this.__views__), l;
        }
        function ev() {
          if (this.__filtered__) {
            var l = new Qe(this);
            l.__dir__ = -1, l.__filtered__ = !0;
          } else
            l = this.clone(), l.__dir__ *= -1;
          return l;
        }
        function tv() {
          var l = this.__wrapped__.value(), s = this.__dir__, h = Ve(l), L = s < 0, C = h ? l.length : 0, D = hg(0, C, this.__views__), I = D.start, $ = D.end, j = $ - I, se = L ? $ : I - 1, ce = this.__iteratees__, ue = ce.length, we = 0, Ae = Zt(j, this.__takeCount__);
          if (!h || !L && C == j && Ae == j)
            return Ac(l, this.__actions__);
          var Pe = [];
          e:
            for (; j-- && we < Ae; ) {
              se += s;
              for (var We = -1, He = l[se]; ++We < ue; ) {
                var Xe = ce[We], et = Xe.iteratee, mn = Xe.type, en = et(He);
                if (mn == de)
                  He = en;
                else if (!en) {
                  if (mn == ee)
                    continue e;
                  break e;
                }
              }
              Pe[we++] = He;
            }
          return Pe;
        }
        Qe.prototype = t1(o0.prototype), Qe.prototype.constructor = Qe;
        function xr(l) {
          var s = -1, h = l == null ? 0 : l.length;
          for (this.clear(); ++s < h; ) {
            var L = l[s];
            this.set(L[0], L[1]);
          }
        }
        function nv() {
          this.__data__ = T1 ? T1(null) : {}, this.size = 0;
        }
        function rv(l) {
          var s = this.has(l) && delete this.__data__[l];
          return this.size -= s ? 1 : 0, s;
        }
        function iv(l) {
          var s = this.__data__;
          if (T1) {
            var h = s[l];
            return h === f ? n : h;
          }
          return at.call(s, l) ? s[l] : n;
        }
        function lv(l) {
          var s = this.__data__;
          return T1 ? s[l] !== n : at.call(s, l);
        }
        function ov(l, s) {
          var h = this.__data__;
          return this.size += this.has(l) ? 0 : 1, h[l] = T1 && s === n ? f : s, this;
        }
        xr.prototype.clear = nv, xr.prototype.delete = rv, xr.prototype.get = iv, xr.prototype.has = lv, xr.prototype.set = ov;
        function w2(l) {
          var s = -1, h = l == null ? 0 : l.length;
          for (this.clear(); ++s < h; ) {
            var L = l[s];
            this.set(L[0], L[1]);
          }
        }
        function av() {
          this.__data__ = [], this.size = 0;
        }
        function sv(l) {
          var s = this.__data__, h = a0(s, l);
          if (h < 0)
            return !1;
          var L = s.length - 1;
          return h == L ? s.pop() : e0.call(s, h, 1), --this.size, !0;
        }
        function cv(l) {
          var s = this.__data__, h = a0(s, l);
          return h < 0 ? n : s[h][1];
        }
        function dv(l) {
          return a0(this.__data__, l) > -1;
        }
        function uv(l, s) {
          var h = this.__data__, L = a0(h, l);
          return L < 0 ? (++this.size, h.push([l, s])) : h[L][1] = s, this;
        }
        w2.prototype.clear = av, w2.prototype.delete = sv, w2.prototype.get = cv, w2.prototype.has = dv, w2.prototype.set = uv;
        function M2(l) {
          var s = -1, h = l == null ? 0 : l.length;
          for (this.clear(); ++s < h; ) {
            var L = l[s];
            this.set(L[0], L[1]);
          }
        }
        function fv() {
          this.size = 0, this.__data__ = {
            hash: new xr(),
            map: new (B1 || w2)(),
            string: new xr()
          };
        }
        function hv(l) {
          var s = w0(this, l).delete(l);
          return this.size -= s ? 1 : 0, s;
        }
        function pv(l) {
          return w0(this, l).get(l);
        }
        function mv(l) {
          return w0(this, l).has(l);
        }
        function vv(l, s) {
          var h = w0(this, l), L = h.size;
          return h.set(l, s), this.size += h.size == L ? 0 : 1, this;
        }
        M2.prototype.clear = fv, M2.prototype.delete = hv, M2.prototype.get = pv, M2.prototype.has = mv, M2.prototype.set = vv;
        function br(l) {
          var s = -1, h = l == null ? 0 : l.length;
          for (this.__data__ = new M2(); ++s < h; )
            this.add(l[s]);
        }
        function gv(l) {
          return this.__data__.set(l, f), this;
        }
        function Lv(l) {
          return this.__data__.has(l);
        }
        br.prototype.add = br.prototype.push = gv, br.prototype.has = Lv;
        function In(l) {
          var s = this.__data__ = new w2(l);
          this.size = s.size;
        }
        function wv() {
          this.__data__ = new w2(), this.size = 0;
        }
        function Mv(l) {
          var s = this.__data__, h = s.delete(l);
          return this.size = s.size, h;
        }
        function xv(l) {
          return this.__data__.get(l);
        }
        function bv(l) {
          return this.__data__.has(l);
        }
        function yv(l, s) {
          var h = this.__data__;
          if (h instanceof w2) {
            var L = h.__data__;
            if (!B1 || L.length < i - 1)
              return L.push([l, s]), this.size = ++h.size, this;
            h = this.__data__ = new M2(L);
          }
          return h.set(l, s), this.size = h.size, this;
        }
        In.prototype.clear = wv, In.prototype.delete = Mv, In.prototype.get = xv, In.prototype.has = bv, In.prototype.set = yv;
        function lc(l, s) {
          var h = Ve(l), L = !h && zr(l), C = !h && !L && X2(l), D = !h && !L && !C && l1(l), I = h || L || C || D, $ = I ? yo(l.length, _m) : [], j = $.length;
          for (var se in l)
            (s || at.call(l, se)) && !(I && // Safari 9 has enumerable `arguments.length` in strict mode.
            (se == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            C && (se == "offset" || se == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            D && (se == "buffer" || se == "byteLength" || se == "byteOffset") || // Skip index properties.
            C2(se, j))) && $.push(se);
          return $;
        }
        function oc(l) {
          var s = l.length;
          return s ? l[To(0, s - 1)] : n;
        }
        function Cv(l, s) {
          return M0(rn(l), yr(s, 0, l.length));
        }
        function Ev(l) {
          return M0(rn(l));
        }
        function ko(l, s, h) {
          (h !== n && !Tn(l[s], h) || h === n && !(s in l)) && x2(l, s, h);
        }
        function Z1(l, s, h) {
          var L = l[s];
          (!(at.call(l, s) && Tn(L, h)) || h === n && !(s in l)) && x2(l, s, h);
        }
        function a0(l, s) {
          for (var h = l.length; h--; )
            if (Tn(l[h][0], s))
              return h;
          return -1;
        }
        function Fv(l, s, h, L) {
          return j2(l, function(C, D, I) {
            s(L, C, h(C), I);
          }), L;
        }
        function ac(l, s) {
          return l && i2(s, Ot(s), l);
        }
        function zv(l, s) {
          return l && i2(s, on(s), l);
        }
        function x2(l, s, h) {
          s == "__proto__" && t0 ? t0(l, s, {
            configurable: !0,
            enumerable: !0,
            value: h,
            writable: !0
          }) : l[s] = h;
        }
        function Do(l, s) {
          for (var h = -1, L = s.length, C = ne(L), D = l == null; ++h < L; )
            C[h] = D ? n : ua(l, s[h]);
          return C;
        }
        function yr(l, s, h) {
          return l === l && (h !== n && (l = l <= h ? l : h), s !== n && (l = l >= s ? l : s)), l;
        }
        function kn(l, s, h, L, C, D) {
          var I, $ = s & v, j = s & g, se = s & w;
          if (h && (I = C ? h(l, L, C, D) : h(l)), I !== n)
            return I;
          if (!Mt(l))
            return l;
          var ce = Ve(l);
          if (ce) {
            if (I = mg(l), !$)
              return rn(l, I);
          } else {
            var ue = $t(l), we = ue == ft || ue == Et;
            if (X2(l))
              return Dc(l, $);
            if (ue == _t || ue == U || we && !C) {
              if (I = j || we ? {} : qc(l), !$)
                return j ? ig(l, zv(I, l)) : rg(l, ac(I, l));
            } else {
              if (!ht[ue])
                return C ? l : {};
              I = vg(l, ue, $);
            }
          }
          D || (D = new In());
          var Ae = D.get(l);
          if (Ae)
            return Ae;
          D.set(l, I), E4(l) ? l.forEach(function(He) {
            I.add(kn(He, s, h, He, l, D));
          }) : y4(l) && l.forEach(function(He, Xe) {
            I.set(Xe, kn(He, s, h, Xe, l, D));
          });
          var Pe = se ? j ? Xo : qo : j ? on : Ot, We = ce ? n : Pe(l);
          return zn(We || l, function(He, Xe) {
            We && (Xe = He, He = l[Xe]), Z1(I, Xe, kn(He, s, h, Xe, l, D));
          }), I;
        }
        function Av(l) {
          var s = Ot(l);
          return function(h) {
            return sc(h, l, s);
          };
        }
        function sc(l, s, h) {
          var L = h.length;
          if (l == null)
            return !L;
          for (l = ut(l); L--; ) {
            var C = h[L], D = s[C], I = l[C];
            if (I === n && !(C in l) || !D(I))
              return !1;
          }
          return !0;
        }
        function cc(l, s, h) {
          if (typeof l != "function")
            throw new An(c);
          return Y1(function() {
            l.apply(n, h);
          }, s);
        }
        function $1(l, s, h, L) {
          var C = -1, D = Wi, I = !0, $ = l.length, j = [], se = s.length;
          if (!$)
            return j;
          h && (s = vt(s, fn(h))), L ? (D = go, I = !1) : s.length >= i && (D = O1, I = !1, s = new br(s));
          e:
            for (; ++C < $; ) {
              var ce = l[C], ue = h == null ? ce : h(ce);
              if (ce = L || ce !== 0 ? ce : 0, I && ue === ue) {
                for (var we = se; we--; )
                  if (s[we] === ue)
                    continue e;
                j.push(ce);
              } else D(s, ue, L) || j.push(ce);
            }
          return j;
        }
        var j2 = Oc(r2), dc = Oc(_o, !0);
        function Sv(l, s) {
          var h = !0;
          return j2(l, function(L, C, D) {
            return h = !!s(L, C, D), h;
          }), h;
        }
        function s0(l, s, h) {
          for (var L = -1, C = l.length; ++L < C; ) {
            var D = l[L], I = s(D);
            if (I != null && ($ === n ? I === I && !pn(I) : h(I, $)))
              var $ = I, j = D;
          }
          return j;
        }
        function kv(l, s, h, L) {
          var C = l.length;
          for (h = Ze(h), h < 0 && (h = -h > C ? 0 : C + h), L = L === n || L > C ? C : Ze(L), L < 0 && (L += C), L = h > L ? 0 : z4(L); h < L; )
            l[h++] = s;
          return l;
        }
        function uc(l, s) {
          var h = [];
          return j2(l, function(L, C, D) {
            s(L, C, D) && h.push(L);
          }), h;
        }
        function Bt(l, s, h, L, C) {
          var D = -1, I = l.length;
          for (h || (h = Lg), C || (C = []); ++D < I; ) {
            var $ = l[D];
            s > 0 && h($) ? s > 1 ? Bt($, s - 1, h, L, C) : W2(C, $) : L || (C[C.length] = $);
          }
          return C;
        }
        var Ro = Nc(), fc = Nc(!0);
        function r2(l, s) {
          return l && Ro(l, s, Ot);
        }
        function _o(l, s) {
          return l && fc(l, s, Ot);
        }
        function c0(l, s) {
          return $2(s, function(h) {
            return E2(l[h]);
          });
        }
        function Cr(l, s) {
          s = Y2(s, l);
          for (var h = 0, L = s.length; l != null && h < L; )
            l = l[l2(s[h++])];
          return h && h == L ? l : n;
        }
        function hc(l, s, h) {
          var L = s(l);
          return Ve(l) ? L : W2(L, h(l));
        }
        function Jt(l) {
          return l == null ? l === n ? I2 : B2 : Mr && Mr in ut(l) ? fg(l) : Eg(l);
        }
        function Po(l, s) {
          return l > s;
        }
        function Dv(l, s) {
          return l != null && at.call(l, s);
        }
        function Rv(l, s) {
          return l != null && s in ut(l);
        }
        function _v(l, s, h) {
          return l >= Zt(s, h) && l < At(s, h);
        }
        function Ho(l, s, h) {
          for (var L = h ? go : Wi, C = l[0].length, D = l.length, I = D, $ = ne(D), j = 1 / 0, se = []; I--; ) {
            var ce = l[I];
            I && s && (ce = vt(ce, fn(s))), j = Zt(ce.length, j), $[I] = !h && (s || C >= 120 && ce.length >= 120) ? new br(I && ce) : n;
          }
          ce = l[0];
          var ue = -1, we = $[0];
          e:
            for (; ++ue < C && se.length < j; ) {
              var Ae = ce[ue], Pe = s ? s(Ae) : Ae;
              if (Ae = h || Ae !== 0 ? Ae : 0, !(we ? O1(we, Pe) : L(se, Pe, h))) {
                for (I = D; --I; ) {
                  var We = $[I];
                  if (!(We ? O1(We, Pe) : L(l[I], Pe, h)))
                    continue e;
                }
                we && we.push(Pe), se.push(Ae);
              }
            }
          return se;
        }
        function Pv(l, s, h, L) {
          return r2(l, function(C, D, I) {
            s(L, h(C), D, I);
          }), L;
        }
        function W1(l, s, h) {
          s = Y2(s, l), l = e4(l, s);
          var L = l == null ? l : l[l2(Rn(s))];
          return L == null ? n : un(L, l, h);
        }
        function pc(l) {
          return bt(l) && Jt(l) == U;
        }
        function Hv(l) {
          return bt(l) && Jt(l) == En;
        }
        function Ov(l) {
          return bt(l) && Jt(l) == Ee;
        }
        function G1(l, s, h, L, C) {
          return l === s ? !0 : l == null || s == null || !bt(l) && !bt(s) ? l !== l && s !== s : Nv(l, s, h, L, G1, C);
        }
        function Nv(l, s, h, L, C, D) {
          var I = Ve(l), $ = Ve(s), j = I ? Me : $t(l), se = $ ? Me : $t(s);
          j = j == U ? _t : j, se = se == U ? _t : se;
          var ce = j == _t, ue = se == _t, we = j == se;
          if (we && X2(l)) {
            if (!X2(s))
              return !1;
            I = !0, ce = !1;
          }
          if (we && !ce)
            return D || (D = new In()), I || l1(l) ? jc(l, s, h, L, C, D) : dg(l, s, j, h, L, C, D);
          if (!(h & x)) {
            var Ae = ce && at.call(l, "__wrapped__"), Pe = ue && at.call(s, "__wrapped__");
            if (Ae || Pe) {
              var We = Ae ? l.value() : l, He = Pe ? s.value() : s;
              return D || (D = new In()), C(We, He, h, L, D);
            }
          }
          return we ? (D || (D = new In()), ug(l, s, h, L, C, D)) : !1;
        }
        function Bv(l) {
          return bt(l) && $t(l) == Lt;
        }
        function Oo(l, s, h, L) {
          var C = h.length, D = C, I = !L;
          if (l == null)
            return !D;
          for (l = ut(l); C--; ) {
            var $ = h[C];
            if (I && $[2] ? $[1] !== l[$[0]] : !($[0] in l))
              return !1;
          }
          for (; ++C < D; ) {
            $ = h[C];
            var j = $[0], se = l[j], ce = $[1];
            if (I && $[2]) {
              if (se === n && !(j in l))
                return !1;
            } else {
              var ue = new In();
              if (L)
                var we = L(se, ce, j, l, s, ue);
              if (!(we === n ? G1(ce, se, x | b, L, ue) : we))
                return !1;
            }
          }
          return !0;
        }
        function mc(l) {
          if (!Mt(l) || Mg(l))
            return !1;
          var s = E2(l) ? Bm : Ap;
          return s.test(Fr(l));
        }
        function Iv(l) {
          return bt(l) && Jt(l) == qn;
        }
        function Tv(l) {
          return bt(l) && $t(l) == Pt;
        }
        function Vv(l) {
          return bt(l) && F0(l.length) && !!mt[Jt(l)];
        }
        function vc(l) {
          return typeof l == "function" ? l : l == null ? an : typeof l == "object" ? Ve(l) ? wc(l[0], l[1]) : Lc(l) : B4(l);
        }
        function No(l) {
          if (!K1(l))
            return Wm(l);
          var s = [];
          for (var h in ut(l))
            at.call(l, h) && h != "constructor" && s.push(h);
          return s;
        }
        function Zv(l) {
          if (!Mt(l))
            return Cg(l);
          var s = K1(l), h = [];
          for (var L in l)
            L == "constructor" && (s || !at.call(l, L)) || h.push(L);
          return h;
        }
        function Bo(l, s) {
          return l < s;
        }
        function gc(l, s) {
          var h = -1, L = ln(l) ? ne(l.length) : [];
          return j2(l, function(C, D, I) {
            L[++h] = s(C, D, I);
          }), L;
        }
        function Lc(l) {
          var s = Qo(l);
          return s.length == 1 && s[0][2] ? Jc(s[0][0], s[0][1]) : function(h) {
            return h === l || Oo(h, l, s);
          };
        }
        function wc(l, s) {
          return ta(l) && Xc(s) ? Jc(l2(l), s) : function(h) {
            var L = ua(h, l);
            return L === n && L === s ? fa(h, l) : G1(s, L, x | b);
          };
        }
        function d0(l, s, h, L, C) {
          l !== s && Ro(s, function(D, I) {
            if (C || (C = new In()), Mt(D))
              $v(l, s, I, h, d0, L, C);
            else {
              var $ = L ? L(ra(l, I), D, I + "", l, s, C) : n;
              $ === n && ($ = D), ko(l, I, $);
            }
          }, on);
        }
        function $v(l, s, h, L, C, D, I) {
          var $ = ra(l, h), j = ra(s, h), se = I.get(j);
          if (se) {
            ko(l, h, se);
            return;
          }
          var ce = D ? D($, j, h + "", l, s, I) : n, ue = ce === n;
          if (ue) {
            var we = Ve(j), Ae = !we && X2(j), Pe = !we && !Ae && l1(j);
            ce = j, we || Ae || Pe ? Ve($) ? ce = $ : yt($) ? ce = rn($) : Ae ? (ue = !1, ce = Dc(j, !0)) : Pe ? (ue = !1, ce = Rc(j, !0)) : ce = [] : q1(j) || zr(j) ? (ce = $, zr($) ? ce = A4($) : (!Mt($) || E2($)) && (ce = qc(j))) : ue = !1;
          }
          ue && (I.set(j, ce), C(ce, j, L, D, I), I.delete(j)), ko(l, h, ce);
        }
        function Mc(l, s) {
          var h = l.length;
          if (h)
            return s += s < 0 ? h : 0, C2(s, h) ? l[s] : n;
        }
        function xc(l, s, h) {
          s.length ? s = vt(s, function(D) {
            return Ve(D) ? function(I) {
              return Cr(I, D.length === 1 ? D[0] : D);
            } : D;
          }) : s = [an];
          var L = -1;
          s = vt(s, fn(De()));
          var C = gc(l, function(D, I, $) {
            var j = vt(s, function(se) {
              return se(D);
            });
            return { criteria: j, index: ++L, value: D };
          });
          return vm(C, function(D, I) {
            return ng(D, I, h);
          });
        }
        function Wv(l, s) {
          return bc(l, s, function(h, L) {
            return fa(l, L);
          });
        }
        function bc(l, s, h) {
          for (var L = -1, C = s.length, D = {}; ++L < C; ) {
            var I = s[L], $ = Cr(l, I);
            h($, I) && U1(D, Y2(I, l), $);
          }
          return D;
        }
        function Gv(l) {
          return function(s) {
            return Cr(s, l);
          };
        }
        function Io(l, s, h, L) {
          var C = L ? mm : Kr, D = -1, I = s.length, $ = l;
          for (l === s && (s = rn(s)), h && ($ = vt(l, fn(h))); ++D < I; )
            for (var j = 0, se = s[D], ce = h ? h(se) : se; (j = C($, ce, j, L)) > -1; )
              $ !== l && e0.call($, j, 1), e0.call(l, j, 1);
          return l;
        }
        function yc(l, s) {
          for (var h = l ? s.length : 0, L = h - 1; h--; ) {
            var C = s[h];
            if (h == L || C !== D) {
              var D = C;
              C2(C) ? e0.call(l, C, 1) : $o(l, C);
            }
          }
          return l;
        }
        function To(l, s) {
          return l + r0(rc() * (s - l + 1));
        }
        function Uv(l, s, h, L) {
          for (var C = -1, D = At(n0((s - l) / (h || 1)), 0), I = ne(D); D--; )
            I[L ? D : ++C] = l, l += h;
          return I;
        }
        function Vo(l, s) {
          var h = "";
          if (!l || s < 1 || s > K)
            return h;
          do
            s % 2 && (h += l), s = r0(s / 2), s && (l += l);
          while (s);
          return h;
        }
        function Ge(l, s) {
          return ia(Qc(l, s, an), l + "");
        }
        function jv(l) {
          return oc(o1(l));
        }
        function Kv(l, s) {
          var h = o1(l);
          return M0(h, yr(s, 0, h.length));
        }
        function U1(l, s, h, L) {
          if (!Mt(l))
            return l;
          s = Y2(s, l);
          for (var C = -1, D = s.length, I = D - 1, $ = l; $ != null && ++C < D; ) {
            var j = l2(s[C]), se = h;
            if (j === "__proto__" || j === "constructor" || j === "prototype")
              return l;
            if (C != I) {
              var ce = $[j];
              se = L ? L(ce, j, $) : n, se === n && (se = Mt(ce) ? ce : C2(s[C + 1]) ? [] : {});
            }
            Z1($, j, se), $ = $[j];
          }
          return l;
        }
        var Cc = i0 ? function(l, s) {
          return i0.set(l, s), l;
        } : an, Yv = t0 ? function(l, s) {
          return t0(l, "toString", {
            configurable: !0,
            enumerable: !1,
            value: pa(s),
            writable: !0
          });
        } : an;
        function qv(l) {
          return M0(o1(l));
        }
        function Dn(l, s, h) {
          var L = -1, C = l.length;
          s < 0 && (s = -s > C ? 0 : C + s), h = h > C ? C : h, h < 0 && (h += C), C = s > h ? 0 : h - s >>> 0, s >>>= 0;
          for (var D = ne(C); ++L < C; )
            D[L] = l[L + s];
          return D;
        }
        function Xv(l, s) {
          var h;
          return j2(l, function(L, C, D) {
            return h = s(L, C, D), !h;
          }), !!h;
        }
        function u0(l, s, h) {
          var L = 0, C = l == null ? L : l.length;
          if (typeof s == "number" && s === s && C <= ie) {
            for (; L < C; ) {
              var D = L + C >>> 1, I = l[D];
              I !== null && !pn(I) && (h ? I <= s : I < s) ? L = D + 1 : C = D;
            }
            return C;
          }
          return Zo(l, s, an, h);
        }
        function Zo(l, s, h, L) {
          var C = 0, D = l == null ? 0 : l.length;
          if (D === 0)
            return 0;
          s = h(s);
          for (var I = s !== s, $ = s === null, j = pn(s), se = s === n; C < D; ) {
            var ce = r0((C + D) / 2), ue = h(l[ce]), we = ue !== n, Ae = ue === null, Pe = ue === ue, We = pn(ue);
            if (I)
              var He = L || Pe;
            else se ? He = Pe && (L || we) : $ ? He = Pe && we && (L || !Ae) : j ? He = Pe && we && !Ae && (L || !We) : Ae || We ? He = !1 : He = L ? ue <= s : ue < s;
            He ? C = ce + 1 : D = ce;
          }
          return Zt(D, Q);
        }
        function Ec(l, s) {
          for (var h = -1, L = l.length, C = 0, D = []; ++h < L; ) {
            var I = l[h], $ = s ? s(I) : I;
            if (!h || !Tn($, j)) {
              var j = $;
              D[C++] = I === 0 ? 0 : I;
            }
          }
          return D;
        }
        function Fc(l) {
          return typeof l == "number" ? l : pn(l) ? he : +l;
        }
        function hn(l) {
          if (typeof l == "string")
            return l;
          if (Ve(l))
            return vt(l, hn) + "";
          if (pn(l))
            return ic ? ic.call(l) : "";
          var s = l + "";
          return s == "0" && 1 / l == -1 / 0 ? "-0" : s;
        }
        function K2(l, s, h) {
          var L = -1, C = Wi, D = l.length, I = !0, $ = [], j = $;
          if (h)
            I = !1, C = go;
          else if (D >= i) {
            var se = s ? null : sg(l);
            if (se)
              return Ui(se);
            I = !1, C = O1, j = new br();
          } else
            j = s ? [] : $;
          e:
            for (; ++L < D; ) {
              var ce = l[L], ue = s ? s(ce) : ce;
              if (ce = h || ce !== 0 ? ce : 0, I && ue === ue) {
                for (var we = j.length; we--; )
                  if (j[we] === ue)
                    continue e;
                s && j.push(ue), $.push(ce);
              } else C(j, ue, h) || (j !== $ && j.push(ue), $.push(ce));
            }
          return $;
        }
        function $o(l, s) {
          return s = Y2(s, l), l = e4(l, s), l == null || delete l[l2(Rn(s))];
        }
        function zc(l, s, h, L) {
          return U1(l, s, h(Cr(l, s)), L);
        }
        function f0(l, s, h, L) {
          for (var C = l.length, D = L ? C : -1; (L ? D-- : ++D < C) && s(l[D], D, l); )
            ;
          return h ? Dn(l, L ? 0 : D, L ? D + 1 : C) : Dn(l, L ? D + 1 : 0, L ? C : D);
        }
        function Ac(l, s) {
          var h = l;
          return h instanceof Qe && (h = h.value()), Lo(s, function(L, C) {
            return C.func.apply(C.thisArg, W2([L], C.args));
          }, h);
        }
        function Wo(l, s, h) {
          var L = l.length;
          if (L < 2)
            return L ? K2(l[0]) : [];
          for (var C = -1, D = ne(L); ++C < L; )
            for (var I = l[C], $ = -1; ++$ < L; )
              $ != C && (D[C] = $1(D[C] || I, l[$], s, h));
          return K2(Bt(D, 1), s, h);
        }
        function Sc(l, s, h) {
          for (var L = -1, C = l.length, D = s.length, I = {}; ++L < C; ) {
            var $ = L < D ? s[L] : n;
            h(I, l[L], $);
          }
          return I;
        }
        function Go(l) {
          return yt(l) ? l : [];
        }
        function Uo(l) {
          return typeof l == "function" ? l : an;
        }
        function Y2(l, s) {
          return Ve(l) ? l : ta(l, s) ? [l] : i4(lt(l));
        }
        var Jv = Ge;
        function q2(l, s, h) {
          var L = l.length;
          return h = h === n ? L : h, !s && h >= L ? l : Dn(l, s, h);
        }
        var kc = Im || function(l) {
          return Nt.clearTimeout(l);
        };
        function Dc(l, s) {
          if (s)
            return l.slice();
          var h = l.length, L = J5 ? J5(h) : new l.constructor(h);
          return l.copy(L), L;
        }
        function jo(l) {
          var s = new l.constructor(l.byteLength);
          return new Ji(s).set(new Ji(l)), s;
        }
        function Qv(l, s) {
          var h = s ? jo(l.buffer) : l.buffer;
          return new l.constructor(h, l.byteOffset, l.byteLength);
        }
        function eg(l) {
          var s = new l.constructor(l.source, p5.exec(l));
          return s.lastIndex = l.lastIndex, s;
        }
        function tg(l) {
          return V1 ? ut(V1.call(l)) : {};
        }
        function Rc(l, s) {
          var h = s ? jo(l.buffer) : l.buffer;
          return new l.constructor(h, l.byteOffset, l.length);
        }
        function _c(l, s) {
          if (l !== s) {
            var h = l !== n, L = l === null, C = l === l, D = pn(l), I = s !== n, $ = s === null, j = s === s, se = pn(s);
            if (!$ && !se && !D && l > s || D && I && j && !$ && !se || L && I && j || !h && j || !C)
              return 1;
            if (!L && !D && !se && l < s || se && h && C && !L && !D || $ && h && C || !I && C || !j)
              return -1;
          }
          return 0;
        }
        function ng(l, s, h) {
          for (var L = -1, C = l.criteria, D = s.criteria, I = C.length, $ = h.length; ++L < I; ) {
            var j = _c(C[L], D[L]);
            if (j) {
              if (L >= $)
                return j;
              var se = h[L];
              return j * (se == "desc" ? -1 : 1);
            }
          }
          return l.index - s.index;
        }
        function Pc(l, s, h, L) {
          for (var C = -1, D = l.length, I = h.length, $ = -1, j = s.length, se = At(D - I, 0), ce = ne(j + se), ue = !L; ++$ < j; )
            ce[$] = s[$];
          for (; ++C < I; )
            (ue || C < D) && (ce[h[C]] = l[C]);
          for (; se--; )
            ce[$++] = l[C++];
          return ce;
        }
        function Hc(l, s, h, L) {
          for (var C = -1, D = l.length, I = -1, $ = h.length, j = -1, se = s.length, ce = At(D - $, 0), ue = ne(ce + se), we = !L; ++C < ce; )
            ue[C] = l[C];
          for (var Ae = C; ++j < se; )
            ue[Ae + j] = s[j];
          for (; ++I < $; )
            (we || C < D) && (ue[Ae + h[I]] = l[C++]);
          return ue;
        }
        function rn(l, s) {
          var h = -1, L = l.length;
          for (s || (s = ne(L)); ++h < L; )
            s[h] = l[h];
          return s;
        }
        function i2(l, s, h, L) {
          var C = !h;
          h || (h = {});
          for (var D = -1, I = s.length; ++D < I; ) {
            var $ = s[D], j = L ? L(h[$], l[$], $, h, l) : n;
            j === n && (j = l[$]), C ? x2(h, $, j) : Z1(h, $, j);
          }
          return h;
        }
        function rg(l, s) {
          return i2(l, ea(l), s);
        }
        function ig(l, s) {
          return i2(l, Kc(l), s);
        }
        function h0(l, s) {
          return function(h, L) {
            var C = Ve(h) ? cm : Fv, D = s ? s() : {};
            return C(h, l, De(L, 2), D);
          };
        }
        function n1(l) {
          return Ge(function(s, h) {
            var L = -1, C = h.length, D = C > 1 ? h[C - 1] : n, I = C > 2 ? h[2] : n;
            for (D = l.length > 3 && typeof D == "function" ? (C--, D) : n, I && Qt(h[0], h[1], I) && (D = C < 3 ? n : D, C = 1), s = ut(s); ++L < C; ) {
              var $ = h[L];
              $ && l(s, $, L, D);
            }
            return s;
          });
        }
        function Oc(l, s) {
          return function(h, L) {
            if (h == null)
              return h;
            if (!ln(h))
              return l(h, L);
            for (var C = h.length, D = s ? C : -1, I = ut(h); (s ? D-- : ++D < C) && L(I[D], D, I) !== !1; )
              ;
            return h;
          };
        }
        function Nc(l) {
          return function(s, h, L) {
            for (var C = -1, D = ut(s), I = L(s), $ = I.length; $--; ) {
              var j = I[l ? $ : ++C];
              if (h(D[j], j, D) === !1)
                break;
            }
            return s;
          };
        }
        function lg(l, s, h) {
          var L = s & y, C = j1(l);
          function D() {
            var I = this && this !== Nt && this instanceof D ? C : l;
            return I.apply(L ? h : this, arguments);
          }
          return D;
        }
        function Bc(l) {
          return function(s) {
            s = lt(s);
            var h = Yr(s) ? Bn(s) : n, L = h ? h[0] : s.charAt(0), C = h ? q2(h, 1).join("") : s.slice(1);
            return L[l]() + C;
          };
        }
        function r1(l) {
          return function(s) {
            return Lo(O4(H4(s).replace(Yp, "")), l, "");
          };
        }
        function j1(l) {
          return function() {
            var s = arguments;
            switch (s.length) {
              case 0:
                return new l();
              case 1:
                return new l(s[0]);
              case 2:
                return new l(s[0], s[1]);
              case 3:
                return new l(s[0], s[1], s[2]);
              case 4:
                return new l(s[0], s[1], s[2], s[3]);
              case 5:
                return new l(s[0], s[1], s[2], s[3], s[4]);
              case 6:
                return new l(s[0], s[1], s[2], s[3], s[4], s[5]);
              case 7:
                return new l(s[0], s[1], s[2], s[3], s[4], s[5], s[6]);
            }
            var h = t1(l.prototype), L = l.apply(h, s);
            return Mt(L) ? L : h;
          };
        }
        function og(l, s, h) {
          var L = j1(l);
          function C() {
            for (var D = arguments.length, I = ne(D), $ = D, j = i1(C); $--; )
              I[$] = arguments[$];
            var se = D < 3 && I[0] !== j && I[D - 1] !== j ? [] : G2(I, j);
            if (D -= se.length, D < h)
              return $c(
                l,
                s,
                p0,
                C.placeholder,
                n,
                I,
                se,
                n,
                n,
                h - D
              );
            var ce = this && this !== Nt && this instanceof C ? L : l;
            return un(ce, this, I);
          }
          return C;
        }
        function Ic(l) {
          return function(s, h, L) {
            var C = ut(s);
            if (!ln(s)) {
              var D = De(h, 3);
              s = Ot(s), h = function($) {
                return D(C[$], $, C);
              };
            }
            var I = l(s, h, L);
            return I > -1 ? C[D ? s[I] : I] : n;
          };
        }
        function Tc(l) {
          return y2(function(s) {
            var h = s.length, L = h, C = Sn.prototype.thru;
            for (l && s.reverse(); L--; ) {
              var D = s[L];
              if (typeof D != "function")
                throw new An(c);
              if (C && !I && L0(D) == "wrapper")
                var I = new Sn([], !0);
            }
            for (L = I ? L : h; ++L < h; ) {
              D = s[L];
              var $ = L0(D), j = $ == "wrapper" ? Jo(D) : n;
              j && na(j[0]) && j[1] == (P | k | F | O) && !j[4].length && j[9] == 1 ? I = I[L0(j[0])].apply(I, j[3]) : I = D.length == 1 && na(D) ? I[$]() : I.thru(D);
            }
            return function() {
              var se = arguments, ce = se[0];
              if (I && se.length == 1 && Ve(ce))
                return I.plant(ce).value();
              for (var ue = 0, we = h ? s[ue].apply(this, se) : ce; ++ue < h; )
                we = s[ue].call(this, we);
              return we;
            };
          });
        }
        function p0(l, s, h, L, C, D, I, $, j, se) {
          var ce = s & P, ue = s & y, we = s & E, Ae = s & (k | R), Pe = s & Z, We = we ? n : j1(l);
          function He() {
            for (var Xe = arguments.length, et = ne(Xe), mn = Xe; mn--; )
              et[mn] = arguments[mn];
            if (Ae)
              var en = i1(He), vn = Lm(et, en);
            if (L && (et = Pc(et, L, C, Ae)), D && (et = Hc(et, D, I, Ae)), Xe -= vn, Ae && Xe < se) {
              var Ct = G2(et, en);
              return $c(
                l,
                s,
                p0,
                He.placeholder,
                h,
                et,
                Ct,
                $,
                j,
                se - Xe
              );
            }
            var Vn = ue ? h : this, z2 = we ? Vn[l] : l;
            return Xe = et.length, $ ? et = Fg(et, $) : Pe && Xe > 1 && et.reverse(), ce && j < Xe && (et.length = j), this && this !== Nt && this instanceof He && (z2 = We || j1(z2)), z2.apply(Vn, et);
          }
          return He;
        }
        function Vc(l, s) {
          return function(h, L) {
            return Pv(h, l, s(L), {});
          };
        }
        function m0(l, s) {
          return function(h, L) {
            var C;
            if (h === n && L === n)
              return s;
            if (h !== n && (C = h), L !== n) {
              if (C === n)
                return L;
              typeof h == "string" || typeof L == "string" ? (h = hn(h), L = hn(L)) : (h = Fc(h), L = Fc(L)), C = l(h, L);
            }
            return C;
          };
        }
        function Ko(l) {
          return y2(function(s) {
            return s = vt(s, fn(De())), Ge(function(h) {
              var L = this;
              return l(s, function(C) {
                return un(C, L, h);
              });
            });
          });
        }
        function v0(l, s) {
          s = s === n ? " " : hn(s);
          var h = s.length;
          if (h < 2)
            return h ? Vo(s, l) : s;
          var L = Vo(s, n0(l / qr(s)));
          return Yr(s) ? q2(Bn(L), 0, l).join("") : L.slice(0, l);
        }
        function ag(l, s, h, L) {
          var C = s & y, D = j1(l);
          function I() {
            for (var $ = -1, j = arguments.length, se = -1, ce = L.length, ue = ne(ce + j), we = this && this !== Nt && this instanceof I ? D : l; ++se < ce; )
              ue[se] = L[se];
            for (; j--; )
              ue[se++] = arguments[++$];
            return un(we, C ? h : this, ue);
          }
          return I;
        }
        function Zc(l) {
          return function(s, h, L) {
            return L && typeof L != "number" && Qt(s, h, L) && (h = L = n), s = F2(s), h === n ? (h = s, s = 0) : h = F2(h), L = L === n ? s < h ? 1 : -1 : F2(L), Uv(s, h, L, l);
          };
        }
        function g0(l) {
          return function(s, h) {
            return typeof s == "string" && typeof h == "string" || (s = _n(s), h = _n(h)), l(s, h);
          };
        }
        function $c(l, s, h, L, C, D, I, $, j, se) {
          var ce = s & k, ue = ce ? I : n, we = ce ? n : I, Ae = ce ? D : n, Pe = ce ? n : D;
          s |= ce ? F : _, s &= ~(ce ? _ : F), s & z || (s &= -4);
          var We = [
            l,
            s,
            C,
            Ae,
            ue,
            Pe,
            we,
            $,
            j,
            se
          ], He = h.apply(n, We);
          return na(l) && t4(He, We), He.placeholder = L, n4(He, l, s);
        }
        function Yo(l) {
          var s = zt[l];
          return function(h, L) {
            if (h = _n(h), L = L == null ? 0 : Zt(Ze(L), 292), L && nc(h)) {
              var C = (lt(h) + "e").split("e"), D = s(C[0] + "e" + (+C[1] + L));
              return C = (lt(D) + "e").split("e"), +(C[0] + "e" + (+C[1] - L));
            }
            return s(h);
          };
        }
        var sg = Qr && 1 / Ui(new Qr([, -0]))[1] == ge ? function(l) {
          return new Qr(l);
        } : ga;
        function Wc(l) {
          return function(s) {
            var h = $t(s);
            return h == Lt ? Eo(s) : h == Pt ? Em(s) : gm(s, l(s));
          };
        }
        function b2(l, s, h, L, C, D, I, $) {
          var j = s & E;
          if (!j && typeof l != "function")
            throw new An(c);
          var se = L ? L.length : 0;
          if (se || (s &= -97, L = C = n), I = I === n ? I : At(Ze(I), 0), $ = $ === n ? $ : Ze($), se -= C ? C.length : 0, s & _) {
            var ce = L, ue = C;
            L = C = n;
          }
          var we = j ? n : Jo(l), Ae = [
            l,
            s,
            h,
            L,
            C,
            ce,
            ue,
            D,
            I,
            $
          ];
          if (we && yg(Ae, we), l = Ae[0], s = Ae[1], h = Ae[2], L = Ae[3], C = Ae[4], $ = Ae[9] = Ae[9] === n ? j ? 0 : l.length : At(Ae[9] - se, 0), !$ && s & (k | R) && (s &= -25), !s || s == y)
            var Pe = lg(l, s, h);
          else s == k || s == R ? Pe = og(l, s, $) : (s == F || s == (y | F)) && !C.length ? Pe = ag(l, s, h, L) : Pe = p0.apply(n, Ae);
          var We = we ? Cc : t4;
          return n4(We(Pe, Ae), l, s);
        }
        function Gc(l, s, h, L) {
          return l === n || Tn(l, Jr[h]) && !at.call(L, h) ? s : l;
        }
        function Uc(l, s, h, L, C, D) {
          return Mt(l) && Mt(s) && (D.set(s, l), d0(l, s, n, Uc, D), D.delete(s)), l;
        }
        function cg(l) {
          return q1(l) ? n : l;
        }
        function jc(l, s, h, L, C, D) {
          var I = h & x, $ = l.length, j = s.length;
          if ($ != j && !(I && j > $))
            return !1;
          var se = D.get(l), ce = D.get(s);
          if (se && ce)
            return se == s && ce == l;
          var ue = -1, we = !0, Ae = h & b ? new br() : n;
          for (D.set(l, s), D.set(s, l); ++ue < $; ) {
            var Pe = l[ue], We = s[ue];
            if (L)
              var He = I ? L(We, Pe, ue, s, l, D) : L(Pe, We, ue, l, s, D);
            if (He !== n) {
              if (He)
                continue;
              we = !1;
              break;
            }
            if (Ae) {
              if (!wo(s, function(Xe, et) {
                if (!O1(Ae, et) && (Pe === Xe || C(Pe, Xe, h, L, D)))
                  return Ae.push(et);
              })) {
                we = !1;
                break;
              }
            } else if (!(Pe === We || C(Pe, We, h, L, D))) {
              we = !1;
              break;
            }
          }
          return D.delete(l), D.delete(s), we;
        }
        function dg(l, s, h, L, C, D, I) {
          switch (h) {
            case Nn:
              if (l.byteLength != s.byteLength || l.byteOffset != s.byteOffset)
                return !1;
              l = l.buffer, s = s.buffer;
            case En:
              return !(l.byteLength != s.byteLength || !D(new Ji(l), new Ji(s)));
            case xe:
            case Ee:
            case je:
              return Tn(+l, +s);
            case Be:
              return l.name == s.name && l.message == s.message;
            case qn:
            case On:
              return l == s + "";
            case Lt:
              var $ = Eo;
            case Pt:
              var j = L & x;
              if ($ || ($ = Ui), l.size != s.size && !j)
                return !1;
              var se = I.get(l);
              if (se)
                return se == s;
              L |= b, I.set(l, s);
              var ce = jc($(l), $(s), L, C, D, I);
              return I.delete(l), ce;
            case dn:
              if (V1)
                return V1.call(l) == V1.call(s);
          }
          return !1;
        }
        function ug(l, s, h, L, C, D) {
          var I = h & x, $ = qo(l), j = $.length, se = qo(s), ce = se.length;
          if (j != ce && !I)
            return !1;
          for (var ue = j; ue--; ) {
            var we = $[ue];
            if (!(I ? we in s : at.call(s, we)))
              return !1;
          }
          var Ae = D.get(l), Pe = D.get(s);
          if (Ae && Pe)
            return Ae == s && Pe == l;
          var We = !0;
          D.set(l, s), D.set(s, l);
          for (var He = I; ++ue < j; ) {
            we = $[ue];
            var Xe = l[we], et = s[we];
            if (L)
              var mn = I ? L(et, Xe, we, s, l, D) : L(Xe, et, we, l, s, D);
            if (!(mn === n ? Xe === et || C(Xe, et, h, L, D) : mn)) {
              We = !1;
              break;
            }
            He || (He = we == "constructor");
          }
          if (We && !He) {
            var en = l.constructor, vn = s.constructor;
            en != vn && "constructor" in l && "constructor" in s && !(typeof en == "function" && en instanceof en && typeof vn == "function" && vn instanceof vn) && (We = !1);
          }
          return D.delete(l), D.delete(s), We;
        }
        function y2(l) {
          return ia(Qc(l, n, s4), l + "");
        }
        function qo(l) {
          return hc(l, Ot, ea);
        }
        function Xo(l) {
          return hc(l, on, Kc);
        }
        var Jo = i0 ? function(l) {
          return i0.get(l);
        } : ga;
        function L0(l) {
          for (var s = l.name + "", h = e1[s], L = at.call(e1, s) ? h.length : 0; L--; ) {
            var C = h[L], D = C.func;
            if (D == null || D == l)
              return C.name;
          }
          return s;
        }
        function i1(l) {
          var s = at.call(A, "placeholder") ? A : l;
          return s.placeholder;
        }
        function De() {
          var l = A.iteratee || ma;
          return l = l === ma ? vc : l, arguments.length ? l(arguments[0], arguments[1]) : l;
        }
        function w0(l, s) {
          var h = l.__data__;
          return wg(s) ? h[typeof s == "string" ? "string" : "hash"] : h.map;
        }
        function Qo(l) {
          for (var s = Ot(l), h = s.length; h--; ) {
            var L = s[h], C = l[L];
            s[h] = [L, C, Xc(C)];
          }
          return s;
        }
        function Er(l, s) {
          var h = bm(l, s);
          return mc(h) ? h : n;
        }
        function fg(l) {
          var s = at.call(l, Mr), h = l[Mr];
          try {
            l[Mr] = n;
            var L = !0;
          } catch {
          }
          var C = qi.call(l);
          return L && (s ? l[Mr] = h : delete l[Mr]), C;
        }
        var ea = zo ? function(l) {
          return l == null ? [] : (l = ut(l), $2(zo(l), function(s) {
            return ec.call(l, s);
          }));
        } : La, Kc = zo ? function(l) {
          for (var s = []; l; )
            W2(s, ea(l)), l = Qi(l);
          return s;
        } : La, $t = Jt;
        (Ao && $t(new Ao(new ArrayBuffer(1))) != Nn || B1 && $t(new B1()) != Lt || So && $t(So.resolve()) != m2 || Qr && $t(new Qr()) != Pt || I1 && $t(new I1()) != Xn) && ($t = function(l) {
          var s = Jt(l), h = s == _t ? l.constructor : n, L = h ? Fr(h) : "";
          if (L)
            switch (L) {
              case Km:
                return Nn;
              case Ym:
                return Lt;
              case qm:
                return m2;
              case Xm:
                return Pt;
              case Jm:
                return Xn;
            }
          return s;
        });
        function hg(l, s, h) {
          for (var L = -1, C = h.length; ++L < C; ) {
            var D = h[L], I = D.size;
            switch (D.type) {
              case "drop":
                l += I;
                break;
              case "dropRight":
                s -= I;
                break;
              case "take":
                s = Zt(s, l + I);
                break;
              case "takeRight":
                l = At(l, s - I);
                break;
            }
          }
          return { start: l, end: s };
        }
        function pg(l) {
          var s = l.match(Mp);
          return s ? s[1].split(xp) : [];
        }
        function Yc(l, s, h) {
          s = Y2(s, l);
          for (var L = -1, C = s.length, D = !1; ++L < C; ) {
            var I = l2(s[L]);
            if (!(D = l != null && h(l, I)))
              break;
            l = l[I];
          }
          return D || ++L != C ? D : (C = l == null ? 0 : l.length, !!C && F0(C) && C2(I, C) && (Ve(l) || zr(l)));
        }
        function mg(l) {
          var s = l.length, h = new l.constructor(s);
          return s && typeof l[0] == "string" && at.call(l, "index") && (h.index = l.index, h.input = l.input), h;
        }
        function qc(l) {
          return typeof l.constructor == "function" && !K1(l) ? t1(Qi(l)) : {};
        }
        function vg(l, s, h) {
          var L = l.constructor;
          switch (s) {
            case En:
              return jo(l);
            case xe:
            case Ee:
              return new L(+l);
            case Nn:
              return Qv(l, h);
            case Jn:
            case T2:
            case Qn:
            case V2:
            case e2:
            case Z2:
            case t2:
            case v2:
            case n2:
              return Rc(l, h);
            case Lt:
              return new L();
            case je:
            case On:
              return new L(l);
            case qn:
              return eg(l);
            case Pt:
              return new L();
            case dn:
              return tg(l);
          }
        }
        function gg(l, s) {
          var h = s.length;
          if (!h)
            return l;
          var L = h - 1;
          return s[L] = (h > 1 ? "& " : "") + s[L], s = s.join(h > 2 ? ", " : " "), l.replace(wp, `{
/* [wrapped with ` + s + `] */
`);
        }
        function Lg(l) {
          return Ve(l) || zr(l) || !!(tc && l && l[tc]);
        }
        function C2(l, s) {
          var h = typeof l;
          return s = s ?? K, !!s && (h == "number" || h != "symbol" && kp.test(l)) && l > -1 && l % 1 == 0 && l < s;
        }
        function Qt(l, s, h) {
          if (!Mt(h))
            return !1;
          var L = typeof s;
          return (L == "number" ? ln(h) && C2(s, h.length) : L == "string" && s in h) ? Tn(h[s], l) : !1;
        }
        function ta(l, s) {
          if (Ve(l))
            return !1;
          var h = typeof l;
          return h == "number" || h == "symbol" || h == "boolean" || l == null || pn(l) ? !0 : P1.test(l) || !Ur.test(l) || s != null && l in ut(s);
        }
        function wg(l) {
          var s = typeof l;
          return s == "string" || s == "number" || s == "symbol" || s == "boolean" ? l !== "__proto__" : l === null;
        }
        function na(l) {
          var s = L0(l), h = A[s];
          if (typeof h != "function" || !(s in Qe.prototype))
            return !1;
          if (l === h)
            return !0;
          var L = Jo(h);
          return !!L && l === L[0];
        }
        function Mg(l) {
          return !!X5 && X5 in l;
        }
        var xg = Ki ? E2 : wa;
        function K1(l) {
          var s = l && l.constructor, h = typeof s == "function" && s.prototype || Jr;
          return l === h;
        }
        function Xc(l) {
          return l === l && !Mt(l);
        }
        function Jc(l, s) {
          return function(h) {
            return h == null ? !1 : h[l] === s && (s !== n || l in ut(h));
          };
        }
        function bg(l) {
          var s = C0(l, function(L) {
            return h.size === p && h.clear(), L;
          }), h = s.cache;
          return s;
        }
        function yg(l, s) {
          var h = l[1], L = s[1], C = h | L, D = C < (y | E | P), I = L == P && h == k || L == P && h == O && l[7].length <= s[8] || L == (P | O) && s[7].length <= s[8] && h == k;
          if (!(D || I))
            return l;
          L & y && (l[2] = s[2], C |= h & y ? 0 : z);
          var $ = s[3];
          if ($) {
            var j = l[3];
            l[3] = j ? Pc(j, $, s[4]) : $, l[4] = j ? G2(l[3], m) : s[4];
          }
          return $ = s[5], $ && (j = l[5], l[5] = j ? Hc(j, $, s[6]) : $, l[6] = j ? G2(l[5], m) : s[6]), $ = s[7], $ && (l[7] = $), L & P && (l[8] = l[8] == null ? s[8] : Zt(l[8], s[8])), l[9] == null && (l[9] = s[9]), l[0] = s[0], l[1] = C, l;
        }
        function Cg(l) {
          var s = [];
          if (l != null)
            for (var h in ut(l))
              s.push(h);
          return s;
        }
        function Eg(l) {
          return qi.call(l);
        }
        function Qc(l, s, h) {
          return s = At(s === n ? l.length - 1 : s, 0), function() {
            for (var L = arguments, C = -1, D = At(L.length - s, 0), I = ne(D); ++C < D; )
              I[C] = L[s + C];
            C = -1;
            for (var $ = ne(s + 1); ++C < s; )
              $[C] = L[C];
            return $[s] = h(I), un(l, this, $);
          };
        }
        function e4(l, s) {
          return s.length < 2 ? l : Cr(l, Dn(s, 0, -1));
        }
        function Fg(l, s) {
          for (var h = l.length, L = Zt(s.length, h), C = rn(l); L--; ) {
            var D = s[L];
            l[L] = C2(D, h) ? C[D] : n;
          }
          return l;
        }
        function ra(l, s) {
          if (!(s === "constructor" && typeof l[s] == "function") && s != "__proto__")
            return l[s];
        }
        var t4 = r4(Cc), Y1 = Vm || function(l, s) {
          return Nt.setTimeout(l, s);
        }, ia = r4(Yv);
        function n4(l, s, h) {
          var L = s + "";
          return ia(l, gg(L, zg(pg(L), h)));
        }
        function r4(l) {
          var s = 0, h = 0;
          return function() {
            var L = Gm(), C = re - (L - h);
            if (h = L, C > 0) {
              if (++s >= X)
                return arguments[0];
            } else
              s = 0;
            return l.apply(n, arguments);
          };
        }
        function M0(l, s) {
          var h = -1, L = l.length, C = L - 1;
          for (s = s === n ? L : s; ++h < s; ) {
            var D = To(h, C), I = l[D];
            l[D] = l[h], l[h] = I;
          }
          return l.length = s, l;
        }
        var i4 = bg(function(l) {
          var s = [];
          return l.charCodeAt(0) === 46 && s.push(""), l.replace(L2, function(h, L, C, D) {
            s.push(C ? D.replace(Cp, "$1") : L || h);
          }), s;
        });
        function l2(l) {
          if (typeof l == "string" || pn(l))
            return l;
          var s = l + "";
          return s == "0" && 1 / l == -1 / 0 ? "-0" : s;
        }
        function Fr(l) {
          if (l != null) {
            try {
              return Yi.call(l);
            } catch {
            }
            try {
              return l + "";
            } catch {
            }
          }
          return "";
        }
        function zg(l, s) {
          return zn(pe, function(h) {
            var L = "_." + h[0];
            s & h[1] && !Wi(l, L) && l.push(L);
          }), l.sort();
        }
        function l4(l) {
          if (l instanceof Qe)
            return l.clone();
          var s = new Sn(l.__wrapped__, l.__chain__);
          return s.__actions__ = rn(l.__actions__), s.__index__ = l.__index__, s.__values__ = l.__values__, s;
        }
        function Ag(l, s, h) {
          (h ? Qt(l, s, h) : s === n) ? s = 1 : s = At(Ze(s), 0);
          var L = l == null ? 0 : l.length;
          if (!L || s < 1)
            return [];
          for (var C = 0, D = 0, I = ne(n0(L / s)); C < L; )
            I[D++] = Dn(l, C, C += s);
          return I;
        }
        function Sg(l) {
          for (var s = -1, h = l == null ? 0 : l.length, L = 0, C = []; ++s < h; ) {
            var D = l[s];
            D && (C[L++] = D);
          }
          return C;
        }
        function kg() {
          var l = arguments.length;
          if (!l)
            return [];
          for (var s = ne(l - 1), h = arguments[0], L = l; L--; )
            s[L - 1] = arguments[L];
          return W2(Ve(h) ? rn(h) : [h], Bt(s, 1));
        }
        var Dg = Ge(function(l, s) {
          return yt(l) ? $1(l, Bt(s, 1, yt, !0)) : [];
        }), Rg = Ge(function(l, s) {
          var h = Rn(s);
          return yt(h) && (h = n), yt(l) ? $1(l, Bt(s, 1, yt, !0), De(h, 2)) : [];
        }), _g = Ge(function(l, s) {
          var h = Rn(s);
          return yt(h) && (h = n), yt(l) ? $1(l, Bt(s, 1, yt, !0), n, h) : [];
        });
        function Pg(l, s, h) {
          var L = l == null ? 0 : l.length;
          return L ? (s = h || s === n ? 1 : Ze(s), Dn(l, s < 0 ? 0 : s, L)) : [];
        }
        function Hg(l, s, h) {
          var L = l == null ? 0 : l.length;
          return L ? (s = h || s === n ? 1 : Ze(s), s = L - s, Dn(l, 0, s < 0 ? 0 : s)) : [];
        }
        function Og(l, s) {
          return l && l.length ? f0(l, De(s, 3), !0, !0) : [];
        }
        function Ng(l, s) {
          return l && l.length ? f0(l, De(s, 3), !0) : [];
        }
        function Bg(l, s, h, L) {
          var C = l == null ? 0 : l.length;
          return C ? (h && typeof h != "number" && Qt(l, s, h) && (h = 0, L = C), kv(l, s, h, L)) : [];
        }
        function o4(l, s, h) {
          var L = l == null ? 0 : l.length;
          if (!L)
            return -1;
          var C = h == null ? 0 : Ze(h);
          return C < 0 && (C = At(L + C, 0)), Gi(l, De(s, 3), C);
        }
        function a4(l, s, h) {
          var L = l == null ? 0 : l.length;
          if (!L)
            return -1;
          var C = L - 1;
          return h !== n && (C = Ze(h), C = h < 0 ? At(L + C, 0) : Zt(C, L - 1)), Gi(l, De(s, 3), C, !0);
        }
        function s4(l) {
          var s = l == null ? 0 : l.length;
          return s ? Bt(l, 1) : [];
        }
        function Ig(l) {
          var s = l == null ? 0 : l.length;
          return s ? Bt(l, ge) : [];
        }
        function Tg(l, s) {
          var h = l == null ? 0 : l.length;
          return h ? (s = s === n ? 1 : Ze(s), Bt(l, s)) : [];
        }
        function Vg(l) {
          for (var s = -1, h = l == null ? 0 : l.length, L = {}; ++s < h; ) {
            var C = l[s];
            L[C[0]] = C[1];
          }
          return L;
        }
        function c4(l) {
          return l && l.length ? l[0] : n;
        }
        function Zg(l, s, h) {
          var L = l == null ? 0 : l.length;
          if (!L)
            return -1;
          var C = h == null ? 0 : Ze(h);
          return C < 0 && (C = At(L + C, 0)), Kr(l, s, C);
        }
        function $g(l) {
          var s = l == null ? 0 : l.length;
          return s ? Dn(l, 0, -1) : [];
        }
        var Wg = Ge(function(l) {
          var s = vt(l, Go);
          return s.length && s[0] === l[0] ? Ho(s) : [];
        }), Gg = Ge(function(l) {
          var s = Rn(l), h = vt(l, Go);
          return s === Rn(h) ? s = n : h.pop(), h.length && h[0] === l[0] ? Ho(h, De(s, 2)) : [];
        }), Ug = Ge(function(l) {
          var s = Rn(l), h = vt(l, Go);
          return s = typeof s == "function" ? s : n, s && h.pop(), h.length && h[0] === l[0] ? Ho(h, n, s) : [];
        });
        function jg(l, s) {
          return l == null ? "" : $m.call(l, s);
        }
        function Rn(l) {
          var s = l == null ? 0 : l.length;
          return s ? l[s - 1] : n;
        }
        function Kg(l, s, h) {
          var L = l == null ? 0 : l.length;
          if (!L)
            return -1;
          var C = L;
          return h !== n && (C = Ze(h), C = C < 0 ? At(L + C, 0) : Zt(C, L - 1)), s === s ? zm(l, s, C) : Gi(l, $5, C, !0);
        }
        function Yg(l, s) {
          return l && l.length ? Mc(l, Ze(s)) : n;
        }
        var qg = Ge(d4);
        function d4(l, s) {
          return l && l.length && s && s.length ? Io(l, s) : l;
        }
        function Xg(l, s, h) {
          return l && l.length && s && s.length ? Io(l, s, De(h, 2)) : l;
        }
        function Jg(l, s, h) {
          return l && l.length && s && s.length ? Io(l, s, n, h) : l;
        }
        var Qg = y2(function(l, s) {
          var h = l == null ? 0 : l.length, L = Do(l, s);
          return yc(l, vt(s, function(C) {
            return C2(C, h) ? +C : C;
          }).sort(_c)), L;
        });
        function eL(l, s) {
          var h = [];
          if (!(l && l.length))
            return h;
          var L = -1, C = [], D = l.length;
          for (s = De(s, 3); ++L < D; ) {
            var I = l[L];
            s(I, L, l) && (h.push(I), C.push(L));
          }
          return yc(l, C), h;
        }
        function la(l) {
          return l == null ? l : jm.call(l);
        }
        function tL(l, s, h) {
          var L = l == null ? 0 : l.length;
          return L ? (h && typeof h != "number" && Qt(l, s, h) ? (s = 0, h = L) : (s = s == null ? 0 : Ze(s), h = h === n ? L : Ze(h)), Dn(l, s, h)) : [];
        }
        function nL(l, s) {
          return u0(l, s);
        }
        function rL(l, s, h) {
          return Zo(l, s, De(h, 2));
        }
        function iL(l, s) {
          var h = l == null ? 0 : l.length;
          if (h) {
            var L = u0(l, s);
            if (L < h && Tn(l[L], s))
              return L;
          }
          return -1;
        }
        function lL(l, s) {
          return u0(l, s, !0);
        }
        function oL(l, s, h) {
          return Zo(l, s, De(h, 2), !0);
        }
        function aL(l, s) {
          var h = l == null ? 0 : l.length;
          if (h) {
            var L = u0(l, s, !0) - 1;
            if (Tn(l[L], s))
              return L;
          }
          return -1;
        }
        function sL(l) {
          return l && l.length ? Ec(l) : [];
        }
        function cL(l, s) {
          return l && l.length ? Ec(l, De(s, 2)) : [];
        }
        function dL(l) {
          var s = l == null ? 0 : l.length;
          return s ? Dn(l, 1, s) : [];
        }
        function uL(l, s, h) {
          return l && l.length ? (s = h || s === n ? 1 : Ze(s), Dn(l, 0, s < 0 ? 0 : s)) : [];
        }
        function fL(l, s, h) {
          var L = l == null ? 0 : l.length;
          return L ? (s = h || s === n ? 1 : Ze(s), s = L - s, Dn(l, s < 0 ? 0 : s, L)) : [];
        }
        function hL(l, s) {
          return l && l.length ? f0(l, De(s, 3), !1, !0) : [];
        }
        function pL(l, s) {
          return l && l.length ? f0(l, De(s, 3)) : [];
        }
        var mL = Ge(function(l) {
          return K2(Bt(l, 1, yt, !0));
        }), vL = Ge(function(l) {
          var s = Rn(l);
          return yt(s) && (s = n), K2(Bt(l, 1, yt, !0), De(s, 2));
        }), gL = Ge(function(l) {
          var s = Rn(l);
          return s = typeof s == "function" ? s : n, K2(Bt(l, 1, yt, !0), n, s);
        });
        function LL(l) {
          return l && l.length ? K2(l) : [];
        }
        function wL(l, s) {
          return l && l.length ? K2(l, De(s, 2)) : [];
        }
        function ML(l, s) {
          return s = typeof s == "function" ? s : n, l && l.length ? K2(l, n, s) : [];
        }
        function oa(l) {
          if (!(l && l.length))
            return [];
          var s = 0;
          return l = $2(l, function(h) {
            if (yt(h))
              return s = At(h.length, s), !0;
          }), yo(s, function(h) {
            return vt(l, Mo(h));
          });
        }
        function u4(l, s) {
          if (!(l && l.length))
            return [];
          var h = oa(l);
          return s == null ? h : vt(h, function(L) {
            return un(s, n, L);
          });
        }
        var xL = Ge(function(l, s) {
          return yt(l) ? $1(l, s) : [];
        }), bL = Ge(function(l) {
          return Wo($2(l, yt));
        }), yL = Ge(function(l) {
          var s = Rn(l);
          return yt(s) && (s = n), Wo($2(l, yt), De(s, 2));
        }), CL = Ge(function(l) {
          var s = Rn(l);
          return s = typeof s == "function" ? s : n, Wo($2(l, yt), n, s);
        }), EL = Ge(oa);
        function FL(l, s) {
          return Sc(l || [], s || [], Z1);
        }
        function zL(l, s) {
          return Sc(l || [], s || [], U1);
        }
        var AL = Ge(function(l) {
          var s = l.length, h = s > 1 ? l[s - 1] : n;
          return h = typeof h == "function" ? (l.pop(), h) : n, u4(l, h);
        });
        function f4(l) {
          var s = A(l);
          return s.__chain__ = !0, s;
        }
        function SL(l, s) {
          return s(l), l;
        }
        function x0(l, s) {
          return s(l);
        }
        var kL = y2(function(l) {
          var s = l.length, h = s ? l[0] : 0, L = this.__wrapped__, C = function(D) {
            return Do(D, l);
          };
          return s > 1 || this.__actions__.length || !(L instanceof Qe) || !C2(h) ? this.thru(C) : (L = L.slice(h, +h + (s ? 1 : 0)), L.__actions__.push({
            func: x0,
            args: [C],
            thisArg: n
          }), new Sn(L, this.__chain__).thru(function(D) {
            return s && !D.length && D.push(n), D;
          }));
        });
        function DL() {
          return f4(this);
        }
        function RL() {
          return new Sn(this.value(), this.__chain__);
        }
        function _L() {
          this.__values__ === n && (this.__values__ = F4(this.value()));
          var l = this.__index__ >= this.__values__.length, s = l ? n : this.__values__[this.__index__++];
          return { done: l, value: s };
        }
        function PL() {
          return this;
        }
        function HL(l) {
          for (var s, h = this; h instanceof o0; ) {
            var L = l4(h);
            L.__index__ = 0, L.__values__ = n, s ? C.__wrapped__ = L : s = L;
            var C = L;
            h = h.__wrapped__;
          }
          return C.__wrapped__ = l, s;
        }
        function OL() {
          var l = this.__wrapped__;
          if (l instanceof Qe) {
            var s = l;
            return this.__actions__.length && (s = new Qe(this)), s = s.reverse(), s.__actions__.push({
              func: x0,
              args: [la],
              thisArg: n
            }), new Sn(s, this.__chain__);
          }
          return this.thru(la);
        }
        function NL() {
          return Ac(this.__wrapped__, this.__actions__);
        }
        var BL = h0(function(l, s, h) {
          at.call(l, h) ? ++l[h] : x2(l, h, 1);
        });
        function IL(l, s, h) {
          var L = Ve(l) ? V5 : Sv;
          return h && Qt(l, s, h) && (s = n), L(l, De(s, 3));
        }
        function TL(l, s) {
          var h = Ve(l) ? $2 : uc;
          return h(l, De(s, 3));
        }
        var VL = Ic(o4), ZL = Ic(a4);
        function $L(l, s) {
          return Bt(b0(l, s), 1);
        }
        function WL(l, s) {
          return Bt(b0(l, s), ge);
        }
        function GL(l, s, h) {
          return h = h === n ? 1 : Ze(h), Bt(b0(l, s), h);
        }
        function h4(l, s) {
          var h = Ve(l) ? zn : j2;
          return h(l, De(s, 3));
        }
        function p4(l, s) {
          var h = Ve(l) ? dm : dc;
          return h(l, De(s, 3));
        }
        var UL = h0(function(l, s, h) {
          at.call(l, h) ? l[h].push(s) : x2(l, h, [s]);
        });
        function jL(l, s, h, L) {
          l = ln(l) ? l : o1(l), h = h && !L ? Ze(h) : 0;
          var C = l.length;
          return h < 0 && (h = At(C + h, 0)), z0(l) ? h <= C && l.indexOf(s, h) > -1 : !!C && Kr(l, s, h) > -1;
        }
        var KL = Ge(function(l, s, h) {
          var L = -1, C = typeof s == "function", D = ln(l) ? ne(l.length) : [];
          return j2(l, function(I) {
            D[++L] = C ? un(s, I, h) : W1(I, s, h);
          }), D;
        }), YL = h0(function(l, s, h) {
          x2(l, h, s);
        });
        function b0(l, s) {
          var h = Ve(l) ? vt : gc;
          return h(l, De(s, 3));
        }
        function qL(l, s, h, L) {
          return l == null ? [] : (Ve(s) || (s = s == null ? [] : [s]), h = L ? n : h, Ve(h) || (h = h == null ? [] : [h]), xc(l, s, h));
        }
        var XL = h0(function(l, s, h) {
          l[h ? 0 : 1].push(s);
        }, function() {
          return [[], []];
        });
        function JL(l, s, h) {
          var L = Ve(l) ? Lo : G5, C = arguments.length < 3;
          return L(l, De(s, 4), h, C, j2);
        }
        function QL(l, s, h) {
          var L = Ve(l) ? um : G5, C = arguments.length < 3;
          return L(l, De(s, 4), h, C, dc);
        }
        function ew(l, s) {
          var h = Ve(l) ? $2 : uc;
          return h(l, E0(De(s, 3)));
        }
        function tw(l) {
          var s = Ve(l) ? oc : jv;
          return s(l);
        }
        function nw(l, s, h) {
          (h ? Qt(l, s, h) : s === n) ? s = 1 : s = Ze(s);
          var L = Ve(l) ? Cv : Kv;
          return L(l, s);
        }
        function rw(l) {
          var s = Ve(l) ? Ev : qv;
          return s(l);
        }
        function iw(l) {
          if (l == null)
            return 0;
          if (ln(l))
            return z0(l) ? qr(l) : l.length;
          var s = $t(l);
          return s == Lt || s == Pt ? l.size : No(l).length;
        }
        function lw(l, s, h) {
          var L = Ve(l) ? wo : Xv;
          return h && Qt(l, s, h) && (s = n), L(l, De(s, 3));
        }
        var ow = Ge(function(l, s) {
          if (l == null)
            return [];
          var h = s.length;
          return h > 1 && Qt(l, s[0], s[1]) ? s = [] : h > 2 && Qt(s[0], s[1], s[2]) && (s = [s[0]]), xc(l, Bt(s, 1), []);
        }), y0 = Tm || function() {
          return Nt.Date.now();
        };
        function aw(l, s) {
          if (typeof s != "function")
            throw new An(c);
          return l = Ze(l), function() {
            if (--l < 1)
              return s.apply(this, arguments);
          };
        }
        function m4(l, s, h) {
          return s = h ? n : s, s = l && s == null ? l.length : s, b2(l, P, n, n, n, n, s);
        }
        function v4(l, s) {
          var h;
          if (typeof s != "function")
            throw new An(c);
          return l = Ze(l), function() {
            return --l > 0 && (h = s.apply(this, arguments)), l <= 1 && (s = n), h;
          };
        }
        var aa = Ge(function(l, s, h) {
          var L = y;
          if (h.length) {
            var C = G2(h, i1(aa));
            L |= F;
          }
          return b2(l, L, s, h, C);
        }), g4 = Ge(function(l, s, h) {
          var L = y | E;
          if (h.length) {
            var C = G2(h, i1(g4));
            L |= F;
          }
          return b2(s, L, l, h, C);
        });
        function L4(l, s, h) {
          s = h ? n : s;
          var L = b2(l, k, n, n, n, n, n, s);
          return L.placeholder = L4.placeholder, L;
        }
        function w4(l, s, h) {
          s = h ? n : s;
          var L = b2(l, R, n, n, n, n, n, s);
          return L.placeholder = w4.placeholder, L;
        }
        function M4(l, s, h) {
          var L, C, D, I, $, j, se = 0, ce = !1, ue = !1, we = !0;
          if (typeof l != "function")
            throw new An(c);
          s = _n(s) || 0, Mt(h) && (ce = !!h.leading, ue = "maxWait" in h, D = ue ? At(_n(h.maxWait) || 0, s) : D, we = "trailing" in h ? !!h.trailing : we);
          function Ae(Ct) {
            var Vn = L, z2 = C;
            return L = C = n, se = Ct, I = l.apply(z2, Vn), I;
          }
          function Pe(Ct) {
            return se = Ct, $ = Y1(Xe, s), ce ? Ae(Ct) : I;
          }
          function We(Ct) {
            var Vn = Ct - j, z2 = Ct - se, I4 = s - Vn;
            return ue ? Zt(I4, D - z2) : I4;
          }
          function He(Ct) {
            var Vn = Ct - j, z2 = Ct - se;
            return j === n || Vn >= s || Vn < 0 || ue && z2 >= D;
          }
          function Xe() {
            var Ct = y0();
            if (He(Ct))
              return et(Ct);
            $ = Y1(Xe, We(Ct));
          }
          function et(Ct) {
            return $ = n, we && L ? Ae(Ct) : (L = C = n, I);
          }
          function mn() {
            $ !== n && kc($), se = 0, L = j = C = $ = n;
          }
          function en() {
            return $ === n ? I : et(y0());
          }
          function vn() {
            var Ct = y0(), Vn = He(Ct);
            if (L = arguments, C = this, j = Ct, Vn) {
              if ($ === n)
                return Pe(j);
              if (ue)
                return kc($), $ = Y1(Xe, s), Ae(j);
            }
            return $ === n && ($ = Y1(Xe, s)), I;
          }
          return vn.cancel = mn, vn.flush = en, vn;
        }
        var sw = Ge(function(l, s) {
          return cc(l, 1, s);
        }), cw = Ge(function(l, s, h) {
          return cc(l, _n(s) || 0, h);
        });
        function dw(l) {
          return b2(l, Z);
        }
        function C0(l, s) {
          if (typeof l != "function" || s != null && typeof s != "function")
            throw new An(c);
          var h = function() {
            var L = arguments, C = s ? s.apply(this, L) : L[0], D = h.cache;
            if (D.has(C))
              return D.get(C);
            var I = l.apply(this, L);
            return h.cache = D.set(C, I) || D, I;
          };
          return h.cache = new (C0.Cache || M2)(), h;
        }
        C0.Cache = M2;
        function E0(l) {
          if (typeof l != "function")
            throw new An(c);
          return function() {
            var s = arguments;
            switch (s.length) {
              case 0:
                return !l.call(this);
              case 1:
                return !l.call(this, s[0]);
              case 2:
                return !l.call(this, s[0], s[1]);
              case 3:
                return !l.call(this, s[0], s[1], s[2]);
            }
            return !l.apply(this, s);
          };
        }
        function uw(l) {
          return v4(2, l);
        }
        var fw = Jv(function(l, s) {
          s = s.length == 1 && Ve(s[0]) ? vt(s[0], fn(De())) : vt(Bt(s, 1), fn(De()));
          var h = s.length;
          return Ge(function(L) {
            for (var C = -1, D = Zt(L.length, h); ++C < D; )
              L[C] = s[C].call(this, L[C]);
            return un(l, this, L);
          });
        }), sa = Ge(function(l, s) {
          var h = G2(s, i1(sa));
          return b2(l, F, n, s, h);
        }), x4 = Ge(function(l, s) {
          var h = G2(s, i1(x4));
          return b2(l, _, n, s, h);
        }), hw = y2(function(l, s) {
          return b2(l, O, n, n, n, s);
        });
        function pw(l, s) {
          if (typeof l != "function")
            throw new An(c);
          return s = s === n ? s : Ze(s), Ge(l, s);
        }
        function mw(l, s) {
          if (typeof l != "function")
            throw new An(c);
          return s = s == null ? 0 : At(Ze(s), 0), Ge(function(h) {
            var L = h[s], C = q2(h, 0, s);
            return L && W2(C, L), un(l, this, C);
          });
        }
        function vw(l, s, h) {
          var L = !0, C = !0;
          if (typeof l != "function")
            throw new An(c);
          return Mt(h) && (L = "leading" in h ? !!h.leading : L, C = "trailing" in h ? !!h.trailing : C), M4(l, s, {
            leading: L,
            maxWait: s,
            trailing: C
          });
        }
        function gw(l) {
          return m4(l, 1);
        }
        function Lw(l, s) {
          return sa(Uo(s), l);
        }
        function ww() {
          if (!arguments.length)
            return [];
          var l = arguments[0];
          return Ve(l) ? l : [l];
        }
        function Mw(l) {
          return kn(l, w);
        }
        function xw(l, s) {
          return s = typeof s == "function" ? s : n, kn(l, w, s);
        }
        function bw(l) {
          return kn(l, v | w);
        }
        function yw(l, s) {
          return s = typeof s == "function" ? s : n, kn(l, v | w, s);
        }
        function Cw(l, s) {
          return s == null || sc(l, s, Ot(s));
        }
        function Tn(l, s) {
          return l === s || l !== l && s !== s;
        }
        var Ew = g0(Po), Fw = g0(function(l, s) {
          return l >= s;
        }), zr = pc(/* @__PURE__ */ function() {
          return arguments;
        }()) ? pc : function(l) {
          return bt(l) && at.call(l, "callee") && !ec.call(l, "callee");
        }, Ve = ne.isArray, zw = H5 ? fn(H5) : Hv;
        function ln(l) {
          return l != null && F0(l.length) && !E2(l);
        }
        function yt(l) {
          return bt(l) && ln(l);
        }
        function Aw(l) {
          return l === !0 || l === !1 || bt(l) && Jt(l) == xe;
        }
        var X2 = Zm || wa, Sw = O5 ? fn(O5) : Ov;
        function kw(l) {
          return bt(l) && l.nodeType === 1 && !q1(l);
        }
        function Dw(l) {
          if (l == null)
            return !0;
          if (ln(l) && (Ve(l) || typeof l == "string" || typeof l.splice == "function" || X2(l) || l1(l) || zr(l)))
            return !l.length;
          var s = $t(l);
          if (s == Lt || s == Pt)
            return !l.size;
          if (K1(l))
            return !No(l).length;
          for (var h in l)
            if (at.call(l, h))
              return !1;
          return !0;
        }
        function Rw(l, s) {
          return G1(l, s);
        }
        function _w(l, s, h) {
          h = typeof h == "function" ? h : n;
          var L = h ? h(l, s) : n;
          return L === n ? G1(l, s, n, h) : !!L;
        }
        function ca(l) {
          if (!bt(l))
            return !1;
          var s = Jt(l);
          return s == Be || s == ye || typeof l.message == "string" && typeof l.name == "string" && !q1(l);
        }
        function Pw(l) {
          return typeof l == "number" && nc(l);
        }
        function E2(l) {
          if (!Mt(l))
            return !1;
          var s = Jt(l);
          return s == ft || s == Et || s == Le || s == cn;
        }
        function b4(l) {
          return typeof l == "number" && l == Ze(l);
        }
        function F0(l) {
          return typeof l == "number" && l > -1 && l % 1 == 0 && l <= K;
        }
        function Mt(l) {
          var s = typeof l;
          return l != null && (s == "object" || s == "function");
        }
        function bt(l) {
          return l != null && typeof l == "object";
        }
        var y4 = N5 ? fn(N5) : Bv;
        function Hw(l, s) {
          return l === s || Oo(l, s, Qo(s));
        }
        function Ow(l, s, h) {
          return h = typeof h == "function" ? h : n, Oo(l, s, Qo(s), h);
        }
        function Nw(l) {
          return C4(l) && l != +l;
        }
        function Bw(l) {
          if (xg(l))
            throw new Te(a);
          return mc(l);
        }
        function Iw(l) {
          return l === null;
        }
        function Tw(l) {
          return l == null;
        }
        function C4(l) {
          return typeof l == "number" || bt(l) && Jt(l) == je;
        }
        function q1(l) {
          if (!bt(l) || Jt(l) != _t)
            return !1;
          var s = Qi(l);
          if (s === null)
            return !0;
          var h = at.call(s, "constructor") && s.constructor;
          return typeof h == "function" && h instanceof h && Yi.call(h) == Om;
        }
        var da = B5 ? fn(B5) : Iv;
        function Vw(l) {
          return b4(l) && l >= -9007199254740991 && l <= K;
        }
        var E4 = I5 ? fn(I5) : Tv;
        function z0(l) {
          return typeof l == "string" || !Ve(l) && bt(l) && Jt(l) == On;
        }
        function pn(l) {
          return typeof l == "symbol" || bt(l) && Jt(l) == dn;
        }
        var l1 = T5 ? fn(T5) : Vv;
        function Zw(l) {
          return l === n;
        }
        function $w(l) {
          return bt(l) && $t(l) == Xn;
        }
        function Ww(l) {
          return bt(l) && Jt(l) == Gr;
        }
        var Gw = g0(Bo), Uw = g0(function(l, s) {
          return l <= s;
        });
        function F4(l) {
          if (!l)
            return [];
          if (ln(l))
            return z0(l) ? Bn(l) : rn(l);
          if (N1 && l[N1])
            return Cm(l[N1]());
          var s = $t(l), h = s == Lt ? Eo : s == Pt ? Ui : o1;
          return h(l);
        }
        function F2(l) {
          if (!l)
            return l === 0 ? l : 0;
          if (l = _n(l), l === ge || l === -1 / 0) {
            var s = l < 0 ? -1 : 1;
            return s * J;
          }
          return l === l ? l : 0;
        }
        function Ze(l) {
          var s = F2(l), h = s % 1;
          return s === s ? h ? s - h : s : 0;
        }
        function z4(l) {
          return l ? yr(Ze(l), 0, ve) : 0;
        }
        function _n(l) {
          if (typeof l == "number")
            return l;
          if (pn(l))
            return he;
          if (Mt(l)) {
            var s = typeof l.valueOf == "function" ? l.valueOf() : l;
            l = Mt(s) ? s + "" : s;
          }
          if (typeof l != "string")
            return l === 0 ? l : +l;
          l = U5(l);
          var h = zp.test(l);
          return h || Sp.test(l) ? am(l.slice(2), h ? 2 : 8) : Fp.test(l) ? he : +l;
        }
        function A4(l) {
          return i2(l, on(l));
        }
        function jw(l) {
          return l ? yr(Ze(l), -9007199254740991, K) : l === 0 ? l : 0;
        }
        function lt(l) {
          return l == null ? "" : hn(l);
        }
        var Kw = n1(function(l, s) {
          if (K1(s) || ln(s)) {
            i2(s, Ot(s), l);
            return;
          }
          for (var h in s)
            at.call(s, h) && Z1(l, h, s[h]);
        }), S4 = n1(function(l, s) {
          i2(s, on(s), l);
        }), A0 = n1(function(l, s, h, L) {
          i2(s, on(s), l, L);
        }), Yw = n1(function(l, s, h, L) {
          i2(s, Ot(s), l, L);
        }), qw = y2(Do);
        function Xw(l, s) {
          var h = t1(l);
          return s == null ? h : ac(h, s);
        }
        var Jw = Ge(function(l, s) {
          l = ut(l);
          var h = -1, L = s.length, C = L > 2 ? s[2] : n;
          for (C && Qt(s[0], s[1], C) && (L = 1); ++h < L; )
            for (var D = s[h], I = on(D), $ = -1, j = I.length; ++$ < j; ) {
              var se = I[$], ce = l[se];
              (ce === n || Tn(ce, Jr[se]) && !at.call(l, se)) && (l[se] = D[se]);
            }
          return l;
        }), Qw = Ge(function(l) {
          return l.push(n, Uc), un(k4, n, l);
        });
        function eM(l, s) {
          return Z5(l, De(s, 3), r2);
        }
        function tM(l, s) {
          return Z5(l, De(s, 3), _o);
        }
        function nM(l, s) {
          return l == null ? l : Ro(l, De(s, 3), on);
        }
        function rM(l, s) {
          return l == null ? l : fc(l, De(s, 3), on);
        }
        function iM(l, s) {
          return l && r2(l, De(s, 3));
        }
        function lM(l, s) {
          return l && _o(l, De(s, 3));
        }
        function oM(l) {
          return l == null ? [] : c0(l, Ot(l));
        }
        function aM(l) {
          return l == null ? [] : c0(l, on(l));
        }
        function ua(l, s, h) {
          var L = l == null ? n : Cr(l, s);
          return L === n ? h : L;
        }
        function sM(l, s) {
          return l != null && Yc(l, s, Dv);
        }
        function fa(l, s) {
          return l != null && Yc(l, s, Rv);
        }
        var cM = Vc(function(l, s, h) {
          s != null && typeof s.toString != "function" && (s = qi.call(s)), l[s] = h;
        }, pa(an)), dM = Vc(function(l, s, h) {
          s != null && typeof s.toString != "function" && (s = qi.call(s)), at.call(l, s) ? l[s].push(h) : l[s] = [h];
        }, De), uM = Ge(W1);
        function Ot(l) {
          return ln(l) ? lc(l) : No(l);
        }
        function on(l) {
          return ln(l) ? lc(l, !0) : Zv(l);
        }
        function fM(l, s) {
          var h = {};
          return s = De(s, 3), r2(l, function(L, C, D) {
            x2(h, s(L, C, D), L);
          }), h;
        }
        function hM(l, s) {
          var h = {};
          return s = De(s, 3), r2(l, function(L, C, D) {
            x2(h, C, s(L, C, D));
          }), h;
        }
        var pM = n1(function(l, s, h) {
          d0(l, s, h);
        }), k4 = n1(function(l, s, h, L) {
          d0(l, s, h, L);
        }), mM = y2(function(l, s) {
          var h = {};
          if (l == null)
            return h;
          var L = !1;
          s = vt(s, function(D) {
            return D = Y2(D, l), L || (L = D.length > 1), D;
          }), i2(l, Xo(l), h), L && (h = kn(h, v | g | w, cg));
          for (var C = s.length; C--; )
            $o(h, s[C]);
          return h;
        });
        function vM(l, s) {
          return D4(l, E0(De(s)));
        }
        var gM = y2(function(l, s) {
          return l == null ? {} : Wv(l, s);
        });
        function D4(l, s) {
          if (l == null)
            return {};
          var h = vt(Xo(l), function(L) {
            return [L];
          });
          return s = De(s), bc(l, h, function(L, C) {
            return s(L, C[0]);
          });
        }
        function LM(l, s, h) {
          s = Y2(s, l);
          var L = -1, C = s.length;
          for (C || (C = 1, l = n); ++L < C; ) {
            var D = l == null ? n : l[l2(s[L])];
            D === n && (L = C, D = h), l = E2(D) ? D.call(l) : D;
          }
          return l;
        }
        function wM(l, s, h) {
          return l == null ? l : U1(l, s, h);
        }
        function MM(l, s, h, L) {
          return L = typeof L == "function" ? L : n, l == null ? l : U1(l, s, h, L);
        }
        var R4 = Wc(Ot), _4 = Wc(on);
        function xM(l, s, h) {
          var L = Ve(l), C = L || X2(l) || l1(l);
          if (s = De(s, 4), h == null) {
            var D = l && l.constructor;
            C ? h = L ? new D() : [] : Mt(l) ? h = E2(D) ? t1(Qi(l)) : {} : h = {};
          }
          return (C ? zn : r2)(l, function(I, $, j) {
            return s(h, I, $, j);
          }), h;
        }
        function bM(l, s) {
          return l == null ? !0 : $o(l, s);
        }
        function yM(l, s, h) {
          return l == null ? l : zc(l, s, Uo(h));
        }
        function CM(l, s, h, L) {
          return L = typeof L == "function" ? L : n, l == null ? l : zc(l, s, Uo(h), L);
        }
        function o1(l) {
          return l == null ? [] : Co(l, Ot(l));
        }
        function EM(l) {
          return l == null ? [] : Co(l, on(l));
        }
        function FM(l, s, h) {
          return h === n && (h = s, s = n), h !== n && (h = _n(h), h = h === h ? h : 0), s !== n && (s = _n(s), s = s === s ? s : 0), yr(_n(l), s, h);
        }
        function zM(l, s, h) {
          return s = F2(s), h === n ? (h = s, s = 0) : h = F2(h), l = _n(l), _v(l, s, h);
        }
        function AM(l, s, h) {
          if (h && typeof h != "boolean" && Qt(l, s, h) && (s = h = n), h === n && (typeof s == "boolean" ? (h = s, s = n) : typeof l == "boolean" && (h = l, l = n)), l === n && s === n ? (l = 0, s = 1) : (l = F2(l), s === n ? (s = l, l = 0) : s = F2(s)), l > s) {
            var L = l;
            l = s, s = L;
          }
          if (h || l % 1 || s % 1) {
            var C = rc();
            return Zt(l + C * (s - l + om("1e-" + ((C + "").length - 1))), s);
          }
          return To(l, s);
        }
        var SM = r1(function(l, s, h) {
          return s = s.toLowerCase(), l + (h ? P4(s) : s);
        });
        function P4(l) {
          return ha(lt(l).toLowerCase());
        }
        function H4(l) {
          return l = lt(l), l && l.replace(Dp, wm).replace(qp, "");
        }
        function kM(l, s, h) {
          l = lt(l), s = hn(s);
          var L = l.length;
          h = h === n ? L : yr(Ze(h), 0, L);
          var C = h;
          return h -= s.length, h >= 0 && l.slice(h, C) == s;
        }
        function DM(l) {
          return l = lt(l), l && g2.test(l) ? l.replace(nn, Mm) : l;
        }
        function RM(l) {
          return l = lt(l), l && H1.test(l) ? l.replace(_e, "\\$&") : l;
        }
        var _M = r1(function(l, s, h) {
          return l + (h ? "-" : "") + s.toLowerCase();
        }), PM = r1(function(l, s, h) {
          return l + (h ? " " : "") + s.toLowerCase();
        }), HM = Bc("toLowerCase");
        function OM(l, s, h) {
          l = lt(l), s = Ze(s);
          var L = s ? qr(l) : 0;
          if (!s || L >= s)
            return l;
          var C = (s - L) / 2;
          return v0(r0(C), h) + l + v0(n0(C), h);
        }
        function NM(l, s, h) {
          l = lt(l), s = Ze(s);
          var L = s ? qr(l) : 0;
          return s && L < s ? l + v0(s - L, h) : l;
        }
        function BM(l, s, h) {
          l = lt(l), s = Ze(s);
          var L = s ? qr(l) : 0;
          return s && L < s ? v0(s - L, h) + l : l;
        }
        function IM(l, s, h) {
          return h || s == null ? s = 0 : s && (s = +s), Um(lt(l).replace(so, ""), s || 0);
        }
        function TM(l, s, h) {
          return (h ? Qt(l, s, h) : s === n) ? s = 1 : s = Ze(s), Vo(lt(l), s);
        }
        function VM() {
          var l = arguments, s = lt(l[0]);
          return l.length < 3 ? s : s.replace(l[1], l[2]);
        }
        var ZM = r1(function(l, s, h) {
          return l + (h ? "_" : "") + s.toLowerCase();
        });
        function $M(l, s, h) {
          return h && typeof h != "number" && Qt(l, s, h) && (s = h = n), h = h === n ? ve : h >>> 0, h ? (l = lt(l), l && (typeof s == "string" || s != null && !da(s)) && (s = hn(s), !s && Yr(l)) ? q2(Bn(l), 0, h) : l.split(s, h)) : [];
        }
        var WM = r1(function(l, s, h) {
          return l + (h ? " " : "") + ha(s);
        });
        function GM(l, s, h) {
          return l = lt(l), h = h == null ? 0 : yr(Ze(h), 0, l.length), s = hn(s), l.slice(h, h + s.length) == s;
        }
        function UM(l, s, h) {
          var L = A.templateSettings;
          h && Qt(l, s, h) && (s = n), l = lt(l), s = A0({}, s, L, Gc);
          var C = A0({}, s.imports, L.imports, Gc), D = Ot(C), I = Co(C, D), $, j, se = 0, ce = s.interpolate || Vi, ue = "__p += '", we = Fo(
            (s.escape || Vi).source + "|" + ce.source + "|" + (ce === qe ? Ep : Vi).source + "|" + (s.evaluate || Vi).source + "|$",
            "g"
          ), Ae = "//# sourceURL=" + (at.call(s, "sourceURL") ? (s.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++tm + "]") + `
`;
          l.replace(we, function(He, Xe, et, mn, en, vn) {
            return et || (et = mn), ue += l.slice(se, vn).replace(Rp, xm), Xe && ($ = !0, ue += `' +
__e(` + Xe + `) +
'`), en && (j = !0, ue += `';
` + en + `;
__p += '`), et && (ue += `' +
((__t = (` + et + `)) == null ? '' : __t) +
'`), se = vn + He.length, He;
          }), ue += `';
`;
          var Pe = at.call(s, "variable") && s.variable;
          if (!Pe)
            ue = `with (obj) {
` + ue + `
}
`;
          else if (yp.test(Pe))
            throw new Te(d);
          ue = (j ? ue.replace(Lr, "") : ue).replace(Ie, "$1").replace(ot, "$1;"), ue = "function(" + (Pe || "obj") + `) {
` + (Pe ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + ($ ? ", __e = _.escape" : "") + (j ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ue + `return __p
}`;
          var We = N4(function() {
            return it(D, Ae + "return " + ue).apply(n, I);
          });
          if (We.source = ue, ca(We))
            throw We;
          return We;
        }
        function jM(l) {
          return lt(l).toLowerCase();
        }
        function KM(l) {
          return lt(l).toUpperCase();
        }
        function YM(l, s, h) {
          if (l = lt(l), l && (h || s === n))
            return U5(l);
          if (!l || !(s = hn(s)))
            return l;
          var L = Bn(l), C = Bn(s), D = j5(L, C), I = K5(L, C) + 1;
          return q2(L, D, I).join("");
        }
        function qM(l, s, h) {
          if (l = lt(l), l && (h || s === n))
            return l.slice(0, q5(l) + 1);
          if (!l || !(s = hn(s)))
            return l;
          var L = Bn(l), C = K5(L, Bn(s)) + 1;
          return q2(L, 0, C).join("");
        }
        function XM(l, s, h) {
          if (l = lt(l), l && (h || s === n))
            return l.replace(so, "");
          if (!l || !(s = hn(s)))
            return l;
          var L = Bn(l), C = j5(L, Bn(s));
          return q2(L, C).join("");
        }
        function JM(l, s) {
          var h = te, L = Y;
          if (Mt(s)) {
            var C = "separator" in s ? s.separator : C;
            h = "length" in s ? Ze(s.length) : h, L = "omission" in s ? hn(s.omission) : L;
          }
          l = lt(l);
          var D = l.length;
          if (Yr(l)) {
            var I = Bn(l);
            D = I.length;
          }
          if (h >= D)
            return l;
          var $ = h - qr(L);
          if ($ < 1)
            return L;
          var j = I ? q2(I, 0, $).join("") : l.slice(0, $);
          if (C === n)
            return j + L;
          if (I && ($ += j.length - $), da(C)) {
            if (l.slice($).search(C)) {
              var se, ce = j;
              for (C.global || (C = Fo(C.source, lt(p5.exec(C)) + "g")), C.lastIndex = 0; se = C.exec(ce); )
                var ue = se.index;
              j = j.slice(0, ue === n ? $ : ue);
            }
          } else if (l.indexOf(hn(C), $) != $) {
            var we = j.lastIndexOf(C);
            we > -1 && (j = j.slice(0, we));
          }
          return j + L;
        }
        function QM(l) {
          return l = lt(l), l && Ht.test(l) ? l.replace(nt, Am) : l;
        }
        var ex = r1(function(l, s, h) {
          return l + (h ? " " : "") + s.toUpperCase();
        }), ha = Bc("toUpperCase");
        function O4(l, s, h) {
          return l = lt(l), s = h ? n : s, s === n ? ym(l) ? Dm(l) : pm(l) : l.match(s) || [];
        }
        var N4 = Ge(function(l, s) {
          try {
            return un(l, n, s);
          } catch (h) {
            return ca(h) ? h : new Te(h);
          }
        }), tx = y2(function(l, s) {
          return zn(s, function(h) {
            h = l2(h), x2(l, h, aa(l[h], l));
          }), l;
        });
        function nx(l) {
          var s = l == null ? 0 : l.length, h = De();
          return l = s ? vt(l, function(L) {
            if (typeof L[1] != "function")
              throw new An(c);
            return [h(L[0]), L[1]];
          }) : [], Ge(function(L) {
            for (var C = -1; ++C < s; ) {
              var D = l[C];
              if (un(D[0], this, L))
                return un(D[1], this, L);
            }
          });
        }
        function rx(l) {
          return Av(kn(l, v));
        }
        function pa(l) {
          return function() {
            return l;
          };
        }
        function ix(l, s) {
          return l == null || l !== l ? s : l;
        }
        var lx = Tc(), ox = Tc(!0);
        function an(l) {
          return l;
        }
        function ma(l) {
          return vc(typeof l == "function" ? l : kn(l, v));
        }
        function ax(l) {
          return Lc(kn(l, v));
        }
        function sx(l, s) {
          return wc(l, kn(s, v));
        }
        var cx = Ge(function(l, s) {
          return function(h) {
            return W1(h, l, s);
          };
        }), dx = Ge(function(l, s) {
          return function(h) {
            return W1(l, h, s);
          };
        });
        function va(l, s, h) {
          var L = Ot(s), C = c0(s, L);
          h == null && !(Mt(s) && (C.length || !L.length)) && (h = s, s = l, l = this, C = c0(s, Ot(s)));
          var D = !(Mt(h) && "chain" in h) || !!h.chain, I = E2(l);
          return zn(C, function($) {
            var j = s[$];
            l[$] = j, I && (l.prototype[$] = function() {
              var se = this.__chain__;
              if (D || se) {
                var ce = l(this.__wrapped__), ue = ce.__actions__ = rn(this.__actions__);
                return ue.push({ func: j, args: arguments, thisArg: l }), ce.__chain__ = se, ce;
              }
              return j.apply(l, W2([this.value()], arguments));
            });
          }), l;
        }
        function ux() {
          return Nt._ === this && (Nt._ = Nm), this;
        }
        function ga() {
        }
        function fx(l) {
          return l = Ze(l), Ge(function(s) {
            return Mc(s, l);
          });
        }
        var hx = Ko(vt), px = Ko(V5), mx = Ko(wo);
        function B4(l) {
          return ta(l) ? Mo(l2(l)) : Gv(l);
        }
        function vx(l) {
          return function(s) {
            return l == null ? n : Cr(l, s);
          };
        }
        var gx = Zc(), Lx = Zc(!0);
        function La() {
          return [];
        }
        function wa() {
          return !1;
        }
        function wx() {
          return {};
        }
        function Mx() {
          return "";
        }
        function xx() {
          return !0;
        }
        function bx(l, s) {
          if (l = Ze(l), l < 1 || l > K)
            return [];
          var h = ve, L = Zt(l, ve);
          s = De(s), l -= ve;
          for (var C = yo(L, s); ++h < l; )
            s(h);
          return C;
        }
        function yx(l) {
          return Ve(l) ? vt(l, l2) : pn(l) ? [l] : rn(i4(lt(l)));
        }
        function Cx(l) {
          var s = ++Hm;
          return lt(l) + s;
        }
        var Ex = m0(function(l, s) {
          return l + s;
        }, 0), Fx = Yo("ceil"), zx = m0(function(l, s) {
          return l / s;
        }, 1), Ax = Yo("floor");
        function Sx(l) {
          return l && l.length ? s0(l, an, Po) : n;
        }
        function kx(l, s) {
          return l && l.length ? s0(l, De(s, 2), Po) : n;
        }
        function Dx(l) {
          return W5(l, an);
        }
        function Rx(l, s) {
          return W5(l, De(s, 2));
        }
        function _x(l) {
          return l && l.length ? s0(l, an, Bo) : n;
        }
        function Px(l, s) {
          return l && l.length ? s0(l, De(s, 2), Bo) : n;
        }
        var Hx = m0(function(l, s) {
          return l * s;
        }, 1), Ox = Yo("round"), Nx = m0(function(l, s) {
          return l - s;
        }, 0);
        function Bx(l) {
          return l && l.length ? bo(l, an) : 0;
        }
        function Ix(l, s) {
          return l && l.length ? bo(l, De(s, 2)) : 0;
        }
        return A.after = aw, A.ary = m4, A.assign = Kw, A.assignIn = S4, A.assignInWith = A0, A.assignWith = Yw, A.at = qw, A.before = v4, A.bind = aa, A.bindAll = tx, A.bindKey = g4, A.castArray = ww, A.chain = f4, A.chunk = Ag, A.compact = Sg, A.concat = kg, A.cond = nx, A.conforms = rx, A.constant = pa, A.countBy = BL, A.create = Xw, A.curry = L4, A.curryRight = w4, A.debounce = M4, A.defaults = Jw, A.defaultsDeep = Qw, A.defer = sw, A.delay = cw, A.difference = Dg, A.differenceBy = Rg, A.differenceWith = _g, A.drop = Pg, A.dropRight = Hg, A.dropRightWhile = Og, A.dropWhile = Ng, A.fill = Bg, A.filter = TL, A.flatMap = $L, A.flatMapDeep = WL, A.flatMapDepth = GL, A.flatten = s4, A.flattenDeep = Ig, A.flattenDepth = Tg, A.flip = dw, A.flow = lx, A.flowRight = ox, A.fromPairs = Vg, A.functions = oM, A.functionsIn = aM, A.groupBy = UL, A.initial = $g, A.intersection = Wg, A.intersectionBy = Gg, A.intersectionWith = Ug, A.invert = cM, A.invertBy = dM, A.invokeMap = KL, A.iteratee = ma, A.keyBy = YL, A.keys = Ot, A.keysIn = on, A.map = b0, A.mapKeys = fM, A.mapValues = hM, A.matches = ax, A.matchesProperty = sx, A.memoize = C0, A.merge = pM, A.mergeWith = k4, A.method = cx, A.methodOf = dx, A.mixin = va, A.negate = E0, A.nthArg = fx, A.omit = mM, A.omitBy = vM, A.once = uw, A.orderBy = qL, A.over = hx, A.overArgs = fw, A.overEvery = px, A.overSome = mx, A.partial = sa, A.partialRight = x4, A.partition = XL, A.pick = gM, A.pickBy = D4, A.property = B4, A.propertyOf = vx, A.pull = qg, A.pullAll = d4, A.pullAllBy = Xg, A.pullAllWith = Jg, A.pullAt = Qg, A.range = gx, A.rangeRight = Lx, A.rearg = hw, A.reject = ew, A.remove = eL, A.rest = pw, A.reverse = la, A.sampleSize = nw, A.set = wM, A.setWith = MM, A.shuffle = rw, A.slice = tL, A.sortBy = ow, A.sortedUniq = sL, A.sortedUniqBy = cL, A.split = $M, A.spread = mw, A.tail = dL, A.take = uL, A.takeRight = fL, A.takeRightWhile = hL, A.takeWhile = pL, A.tap = SL, A.throttle = vw, A.thru = x0, A.toArray = F4, A.toPairs = R4, A.toPairsIn = _4, A.toPath = yx, A.toPlainObject = A4, A.transform = xM, A.unary = gw, A.union = mL, A.unionBy = vL, A.unionWith = gL, A.uniq = LL, A.uniqBy = wL, A.uniqWith = ML, A.unset = bM, A.unzip = oa, A.unzipWith = u4, A.update = yM, A.updateWith = CM, A.values = o1, A.valuesIn = EM, A.without = xL, A.words = O4, A.wrap = Lw, A.xor = bL, A.xorBy = yL, A.xorWith = CL, A.zip = EL, A.zipObject = FL, A.zipObjectDeep = zL, A.zipWith = AL, A.entries = R4, A.entriesIn = _4, A.extend = S4, A.extendWith = A0, va(A, A), A.add = Ex, A.attempt = N4, A.camelCase = SM, A.capitalize = P4, A.ceil = Fx, A.clamp = FM, A.clone = Mw, A.cloneDeep = bw, A.cloneDeepWith = yw, A.cloneWith = xw, A.conformsTo = Cw, A.deburr = H4, A.defaultTo = ix, A.divide = zx, A.endsWith = kM, A.eq = Tn, A.escape = DM, A.escapeRegExp = RM, A.every = IL, A.find = VL, A.findIndex = o4, A.findKey = eM, A.findLast = ZL, A.findLastIndex = a4, A.findLastKey = tM, A.floor = Ax, A.forEach = h4, A.forEachRight = p4, A.forIn = nM, A.forInRight = rM, A.forOwn = iM, A.forOwnRight = lM, A.get = ua, A.gt = Ew, A.gte = Fw, A.has = sM, A.hasIn = fa, A.head = c4, A.identity = an, A.includes = jL, A.indexOf = Zg, A.inRange = zM, A.invoke = uM, A.isArguments = zr, A.isArray = Ve, A.isArrayBuffer = zw, A.isArrayLike = ln, A.isArrayLikeObject = yt, A.isBoolean = Aw, A.isBuffer = X2, A.isDate = Sw, A.isElement = kw, A.isEmpty = Dw, A.isEqual = Rw, A.isEqualWith = _w, A.isError = ca, A.isFinite = Pw, A.isFunction = E2, A.isInteger = b4, A.isLength = F0, A.isMap = y4, A.isMatch = Hw, A.isMatchWith = Ow, A.isNaN = Nw, A.isNative = Bw, A.isNil = Tw, A.isNull = Iw, A.isNumber = C4, A.isObject = Mt, A.isObjectLike = bt, A.isPlainObject = q1, A.isRegExp = da, A.isSafeInteger = Vw, A.isSet = E4, A.isString = z0, A.isSymbol = pn, A.isTypedArray = l1, A.isUndefined = Zw, A.isWeakMap = $w, A.isWeakSet = Ww, A.join = jg, A.kebabCase = _M, A.last = Rn, A.lastIndexOf = Kg, A.lowerCase = PM, A.lowerFirst = HM, A.lt = Gw, A.lte = Uw, A.max = Sx, A.maxBy = kx, A.mean = Dx, A.meanBy = Rx, A.min = _x, A.minBy = Px, A.stubArray = La, A.stubFalse = wa, A.stubObject = wx, A.stubString = Mx, A.stubTrue = xx, A.multiply = Hx, A.nth = Yg, A.noConflict = ux, A.noop = ga, A.now = y0, A.pad = OM, A.padEnd = NM, A.padStart = BM, A.parseInt = IM, A.random = AM, A.reduce = JL, A.reduceRight = QL, A.repeat = TM, A.replace = VM, A.result = LM, A.round = Ox, A.runInContext = G, A.sample = tw, A.size = iw, A.snakeCase = ZM, A.some = lw, A.sortedIndex = nL, A.sortedIndexBy = rL, A.sortedIndexOf = iL, A.sortedLastIndex = lL, A.sortedLastIndexBy = oL, A.sortedLastIndexOf = aL, A.startCase = WM, A.startsWith = GM, A.subtract = Nx, A.sum = Bx, A.sumBy = Ix, A.template = UM, A.times = bx, A.toFinite = F2, A.toInteger = Ze, A.toLength = z4, A.toLower = jM, A.toNumber = _n, A.toSafeInteger = jw, A.toString = lt, A.toUpper = KM, A.trim = YM, A.trimEnd = qM, A.trimStart = XM, A.truncate = JM, A.unescape = QM, A.uniqueId = Cx, A.upperCase = ex, A.upperFirst = ha, A.each = h4, A.eachRight = p4, A.first = c4, va(A, function() {
          var l = {};
          return r2(A, function(s, h) {
            at.call(A.prototype, h) || (l[h] = s);
          }), l;
        }(), { chain: !1 }), A.VERSION = r, zn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(l) {
          A[l].placeholder = A;
        }), zn(["drop", "take"], function(l, s) {
          Qe.prototype[l] = function(h) {
            h = h === n ? 1 : At(Ze(h), 0);
            var L = this.__filtered__ && !s ? new Qe(this) : this.clone();
            return L.__filtered__ ? L.__takeCount__ = Zt(h, L.__takeCount__) : L.__views__.push({
              size: Zt(h, ve),
              type: l + (L.__dir__ < 0 ? "Right" : "")
            }), L;
          }, Qe.prototype[l + "Right"] = function(h) {
            return this.reverse()[l](h).reverse();
          };
        }), zn(["filter", "map", "takeWhile"], function(l, s) {
          var h = s + 1, L = h == ee || h == ae;
          Qe.prototype[l] = function(C) {
            var D = this.clone();
            return D.__iteratees__.push({
              iteratee: De(C, 3),
              type: h
            }), D.__filtered__ = D.__filtered__ || L, D;
          };
        }), zn(["head", "last"], function(l, s) {
          var h = "take" + (s ? "Right" : "");
          Qe.prototype[l] = function() {
            return this[h](1).value()[0];
          };
        }), zn(["initial", "tail"], function(l, s) {
          var h = "drop" + (s ? "" : "Right");
          Qe.prototype[l] = function() {
            return this.__filtered__ ? new Qe(this) : this[h](1);
          };
        }), Qe.prototype.compact = function() {
          return this.filter(an);
        }, Qe.prototype.find = function(l) {
          return this.filter(l).head();
        }, Qe.prototype.findLast = function(l) {
          return this.reverse().find(l);
        }, Qe.prototype.invokeMap = Ge(function(l, s) {
          return typeof l == "function" ? new Qe(this) : this.map(function(h) {
            return W1(h, l, s);
          });
        }), Qe.prototype.reject = function(l) {
          return this.filter(E0(De(l)));
        }, Qe.prototype.slice = function(l, s) {
          l = Ze(l);
          var h = this;
          return h.__filtered__ && (l > 0 || s < 0) ? new Qe(h) : (l < 0 ? h = h.takeRight(-l) : l && (h = h.drop(l)), s !== n && (s = Ze(s), h = s < 0 ? h.dropRight(-s) : h.take(s - l)), h);
        }, Qe.prototype.takeRightWhile = function(l) {
          return this.reverse().takeWhile(l).reverse();
        }, Qe.prototype.toArray = function() {
          return this.take(ve);
        }, r2(Qe.prototype, function(l, s) {
          var h = /^(?:filter|find|map|reject)|While$/.test(s), L = /^(?:head|last)$/.test(s), C = A[L ? "take" + (s == "last" ? "Right" : "") : s], D = L || /^find/.test(s);
          C && (A.prototype[s] = function() {
            var I = this.__wrapped__, $ = L ? [1] : arguments, j = I instanceof Qe, se = $[0], ce = j || Ve(I), ue = function(Xe) {
              var et = C.apply(A, W2([Xe], $));
              return L && we ? et[0] : et;
            };
            ce && h && typeof se == "function" && se.length != 1 && (j = ce = !1);
            var we = this.__chain__, Ae = !!this.__actions__.length, Pe = D && !we, We = j && !Ae;
            if (!D && ce) {
              I = We ? I : new Qe(this);
              var He = l.apply(I, $);
              return He.__actions__.push({ func: x0, args: [ue], thisArg: n }), new Sn(He, we);
            }
            return Pe && We ? l.apply(this, $) : (He = this.thru(ue), Pe ? L ? He.value()[0] : He.value() : He);
          });
        }), zn(["pop", "push", "shift", "sort", "splice", "unshift"], function(l) {
          var s = ji[l], h = /^(?:push|sort|unshift)$/.test(l) ? "tap" : "thru", L = /^(?:pop|shift)$/.test(l);
          A.prototype[l] = function() {
            var C = arguments;
            if (L && !this.__chain__) {
              var D = this.value();
              return s.apply(Ve(D) ? D : [], C);
            }
            return this[h](function(I) {
              return s.apply(Ve(I) ? I : [], C);
            });
          };
        }), r2(Qe.prototype, function(l, s) {
          var h = A[s];
          if (h) {
            var L = h.name + "";
            at.call(e1, L) || (e1[L] = []), e1[L].push({ name: s, func: h });
          }
        }), e1[p0(n, E).name] = [{
          name: "wrapper",
          func: n
        }], Qe.prototype.clone = Qm, Qe.prototype.reverse = ev, Qe.prototype.value = tv, A.prototype.at = kL, A.prototype.chain = DL, A.prototype.commit = RL, A.prototype.next = _L, A.prototype.plant = HL, A.prototype.reverse = OL, A.prototype.toJSON = A.prototype.valueOf = A.prototype.value = NL, A.prototype.first = A.prototype.head, N1 && (A.prototype[N1] = PL), A;
      }, Xr = Rm();
      wr ? ((wr.exports = Xr)._ = Xr, mo._ = Xr) : Nt._ = Xr;
    }).call(cK);
  }(ci, ci.exports)), ci.exports;
}
var Lh = dK();
const uK = W(
  ({
    id: e,
    label: t,
    shortcut: n,
    onClick: r,
    /** autocomplete props */
    disabled: i,
    required: a,
    state: c,
    placeholder: d,
    searchonly: f,
    selectedItem: p,
    onSelect: m,
    onSearchValueChangeDebounceTime: v = 300,
    onSearchValueChange: g,
    loading: w,
    renderCustomItem: x,
    onClean: b,
    hint: y,
    /** end autocomplete props */
    items: E = [],
    customAction: z,
    loadingLabel: k = "Loading...",
    emptyLabel: R = "No item found.",
    ...F
  }, _) => {
    const [P, O] = q(null), [Z, te] = q(""), [Y, X] = q(!1), re = () => X(!0), ee = It(null), de = (J) => {
      J ? m == null || m(J) : (te(""), m == null || m(""), b == null || b());
      const he = document.getElementById(`${e}-input`);
      he && he.blur(), O(null), X(!1);
    }, ae = Ut(() => E.reduce(
      (he, ve) => (he[ve.group || ""] || (he[ve.group || ""] = []), he[ve.group || ""].push(ve), he),
      {}
    ), [E, Z]), ge = Ft(
      Lh.debounce((J) => {
        g == null || g(J);
      }, v),
      [g, v]
    );
    T(() => {
      ge(Z);
    }, [Z]), T(() => {
      Y || (te((p == null ? void 0 : p.label) || ""), P && O(null));
    }, [p]);
    const K = (J) => {
      if (J.key === "ArrowDown" || J.key === "ArrowUp") {
        J.preventDefault();
        const he = Object.values(ae).flat(), ve = he.findIndex((pe) => pe.value === (P == null ? void 0 : P.value)), Q = J.key === "ArrowDown" ? ve + 1 : ve - 1, ie = he[Q];
        if (ie) {
          O(ie);
          const pe = document.getElementById(ie == null ? void 0 : ie.value);
          pe && pe.scrollIntoView({
            block: "nearest",
            inline: "nearest",
            behavior: "smooth"
          });
        }
      }
      J.key === "Enter" && (P ? (J.preventDefault(), de(P.value)) : (J.preventDefault(), de(Z))), J.key === "Escape" && (J.preventDefault(), X(!1), O(null), de(""));
    };
    return f ? /* @__PURE__ */ u(
      Zr,
      {
        open: Y && !!Z,
        onOpenChange: () => {
          var J;
          (J = document.getElementById(`${e}-input`)) == null || J.focus();
        },
        children: /* @__PURE__ */ V("div", { className: "flex flex-col gap-2", children: [
          t ? /* @__PURE__ */ u(jn, { htmlFor: `${e}-input`, required: a, children: t }) : null,
          /* @__PURE__ */ V(
            "div",
            {
              className: S(
                "bg-spotlight-body-background text-spotlight-body-text border-spotlight-body-border relative flex h-full w-full flex-col rounded-md border"
              ),
              children: [
                /* @__PURE__ */ u(k9, { children: /* @__PURE__ */ V(
                  "div",
                  {
                    className: S(
                      "border-select-default-border text-select-default-text bg-select-default-background group inline-flex h-8 w-full items-center justify-between gap-4 rounded-md border px-2 py-1 text-sm shadow-xs transition-colors",
                      "focus-visible:text-select-active-text focus-visible:border-select-active-border focus-visible:bg-select-active-background focus-visible:ring-select-active-border focus-visible:ring-offset-select-active-border relative focus-visible:outline-hidden",
                      {
                        "bg-select-negative-background border-select-negative-border text-select-negative-typography text-select-negative-text focus-visible:text-select-negative-text": c === "negative",
                        "bg-select-disabled-background border-select-disabled-border text-select-disabled-typography text-select-disabled-text cursor-not-allowed": i,
                        "bg-select-selected-background border-select-selected-border text-select-selected-typography text-select-selected-text": p == null ? void 0 : p.value,
                        "bg-select-open-background border-select-open-border text-select-open-text": Y,
                        "hover:bg-select-hover-background hover:border-select-hover-border hover:text-select-hover-text": !Y,
                        "text-select-default-text border-b": Y && !!Z
                      }
                    ),
                    ref: ee,
                    children: [
                      /* @__PURE__ */ u("div", { className: "text-spotlight-body-icon pointer-events-none absolute top-1/2 left-3 flex h-4 w-4 -translate-y-1/2", children: /* @__PURE__ */ u(Re, { name: "MagnifyingLens" }) }),
                      /* @__PURE__ */ u(
                        "input",
                        {
                          role: "combobox",
                          className: S(
                            "placeholder:text-typography-muted flex h-8 w-full rounded-md bg-transparent p-3 pl-8 text-sm outline-hidden disabled:cursor-not-allowed disabled:opacity-50",
                            {
                              "placeholder:text-select-negative-text": c === "negative",
                              "placeholder:text-select-disabled-text": i,
                              "placeholder:text-typography-muted": !c && !i
                            }
                          ),
                          placeholder: d,
                          onChange: (J) => {
                            te(J.target.value);
                          },
                          id: `${e}-input`,
                          onKeyDown: K,
                          value: Z,
                          onFocus: re,
                          "aria-controls": `${e}-listbox`,
                          "aria-expanded": Y && !!Z,
                          "aria-activedescendant": P == null ? void 0 : P.value,
                          onBlur: () => {
                            X(!1), te((p == null ? void 0 : p.label) || "");
                          },
                          ref: _
                        }
                      ),
                      /* @__PURE__ */ u(
                        "div",
                        {
                          className: S("text-select-default-icon flex", "group-hover:text-select-hover-icon", {
                            "text-select-negative-icon": c === "negative",
                            "text-select-disabled-icon": i
                          }),
                          children: p != null && p.value ? /* @__PURE__ */ u(
                            "div",
                            {
                              className: S("text-multiselect-default-icon flex", "group-hover:text-multiselect-hover-icon", {
                                "text-multiselect-negative-icon": c === "negative",
                                "text-multiselect-disabled-icon": i
                              }),
                              role: "button",
                              tabIndex: 0,
                              onClick: () => de(""),
                              onKeyDown: (J) => {
                                J.key === "Enter" && de("");
                              },
                              "aria-label": "Clear selection",
                              children: /* @__PURE__ */ u(Re, { size: "xs", name: "Close" })
                            }
                          ) : null
                        }
                      )
                    ]
                  }
                ) }),
                /* @__PURE__ */ u(
                  $r,
                  {
                    autoFocus: !1,
                    popoverFooter: z,
                    onOpenAutoFocus: (J) => J.preventDefault(),
                    children: /* @__PURE__ */ u(
                      "div",
                      {
                        id: `${e}-listbox`,
                        role: "listbox",
                        className: S(
                          "max-h-[300px] w-full min-w-96 overflow-x-hidden overflow-y-auto rounded-md border border-t-0"
                        ),
                        children: w ? /* @__PURE__ */ u("div", { className: "py-6 text-center text-sm", children: k }) : E.length > 0 ? Object.entries(ae).map(([J, he]) => /* @__PURE__ */ V("div", { children: [
                          J ? /* @__PURE__ */ u(
                            "div",
                            {
                              role: "group",
                              "aria-label": J,
                              className: "text-typography-muted cursor-default px-2 py-1 text-xs font-medium",
                              children: J
                            }
                          ) : null,
                          he.map((ve) => /* @__PURE__ */ u(
                            "div",
                            {
                              role: "option",
                              id: ve.value,
                              "aria-disabled": ve.disabled,
                              "data-disabled": ve.disabled,
                              "aria-selected": ve.value === (p == null ? void 0 : p.value),
                              "data-selected": ve.value === (P == null ? void 0 : P.value),
                              className: S(
                                "text-list-default-text group flex w-full cursor-pointer items-center gap-8 p-2 text-sm select-none",
                                "hover:bg-list-hover-background hover:text-list-hover-text",
                                "focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-hidden",
                                "data-[selected=true]:bg-list-selected-background data-[selected=true]:text-list-selected-text",
                                "data-[disabled=true]:bg-list-disabled-background data-[disabled=true]:text-list-disabled-text data-[disabled=true]:pointer-events-none data-[disabled=true]:cursor-not-allowed"
                              ),
                              onMouseDown: (Q) => {
                                Q.stopPropagation();
                              },
                              onClick: () => {
                                de(ve.value);
                              },
                              children: x ? x(ve) : /* @__PURE__ */ V(me, { children: [
                                /* @__PURE__ */ u("div", { className: S("flex h-4 w-4 shrink-0"), children: ve.value === (p == null ? void 0 : p.value) ? /* @__PURE__ */ u(Re, { name: "Check" }) : null }),
                                /* @__PURE__ */ u("div", { children: ve.label })
                              ] })
                            },
                            ve.value
                          ))
                        ] }, J)) : /* @__PURE__ */ u("div", { className: "py-6 text-center text-sm", children: R })
                      }
                    )
                  }
                )
              ]
            }
          ),
          y && /* @__PURE__ */ u(
            "div",
            {
              className: S("text-hint-default-text text-xs", {
                "text-hint-negative-text": c === "negative"
              }),
              children: y
            }
          )
        ] })
      }
    ) : /* @__PURE__ */ V(
      "button",
      {
        ref: _,
        className: S(
          "bg-textfield-default-background border-textfield-default-border text-textfield-default-placeholder flex h-8 w-60 cursor-pointer items-center gap-8 rounded-md border p-2 text-sm whitespace-nowrap",
          "focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-hidden"
        ),
        ...F,
        onClick: r,
        children: [
          /* @__PURE__ */ u(Re, { size: "md", name: "MagnifyingLens" }),
          /* @__PURE__ */ u("span", { children: t }),
          n ? /* @__PURE__ */ u("span", { className: S("ml-auto flex gap-2"), children: n.split(/\s*\+\s*/).map((J) => /* @__PURE__ */ u(vf, { children: J }, J)) }) : null
        ]
      }
    );
  }
);
uK.displayName = "Search";
const fK = W(
  ({
    id: e,
    placeholder: t,
    searchPlaceholder: n = "Search",
    label: r,
    value: i,
    onChange: a,
    items: c = [],
    state: d,
    disabled: f,
    required: p,
    searchable: m,
    hint: v,
    /** autocomplete props */
    autocomplete: g,
    selectedItem: w,
    onSelect: x,
    onSearchValueChangeDebounceTime: b,
    onSearchValueChange: y,
    loading: E,
    /** end autocomplete props */
    renderCustomItem: z,
    customAction: k,
    loadingLabel: R = "Loading...",
    emptyLabel: F = "No item found."
  }, _) => {
    var de;
    const [P, O] = q(!1), [Z, te] = q(""), Y = (ae) => {
      x == null || x(ae), a == null || a(ae);
    }, X = Ut(() => (g || !Z ? c : c.filter(
      (K) => [K.label, ...K.keywords || []].some(
        (J) => J.toLowerCase().includes(Z.toLowerCase())
      )
    ).sort((K, J) => {
      const he = G4(K.label, Z), ve = G4(J.label, Z);
      return he < ve ? -1 : he > ve ? 1 : 0;
    })).reduce(
      (K, J) => (K[J.group || ""] || (K[J.group || ""] = []), K[J.group || ""].push(J), K),
      {}
    ), [g, c, Z]);
    T(() => {
      var ae, ge;
      (ge = (ae = document.querySelector("[cmdk-list]")) == null ? void 0 : ae.scrollTo) == null || ge.call(ae, { top: 0, behavior: "smooth" });
    }, [X, c]);
    const re = Ft(
      Lh.debounce((ae) => {
        y == null || y(ae);
      }, b),
      [y, b]
    ), ee = (ae) => {
      te(ae), g && (re == null || re(ae));
    };
    return T(() => {
      c.length == 0 && console.warn(
        "Select component is used without autocomplete and items are empty. Please provide items to the Select component."
      );
    }, []), /* @__PURE__ */ V("div", { className: "flex flex-col gap-2", children: [
      r ? /* @__PURE__ */ u(jn, { htmlFor: e, required: p, children: r }) : null,
      /* @__PURE__ */ V(Zr, { open: P, onOpenChange: O, children: [
        /* @__PURE__ */ u(R1, { children: /* @__PURE__ */ V(
          "button",
          {
            id: e,
            className: S(
              "border-select-default-border text-select-default-text bg-select-default-background group inline-flex h-8 w-full items-center justify-between gap-4 rounded-md border px-2 py-1 text-sm shadow-xs transition-colors",
              "focus-visible:text-select-active-text focus-visible:border-select-active-border focus-visible:bg-select-active-background focus-visible:ring-select-active-border focus-visible:ring-offset-select-active-border focus-visible:outline-hidden",
              {
                "bg-select-negative-background border-select-negative-border text-select-negative-typography text-select-negative-text focus-visible:text-select-negative-text": d === "negative",
                "bg-select-disabled-background border-select-disabled-border text-select-disabled-typography text-select-disabled-text cursor-not-allowed": f,
                "bg-select-selected-background border-select-selected-border text-select-selected-typography text-select-selected-text": i || (w == null ? void 0 : w.value),
                "bg-select-open-background border-select-open-border text-select-open-text": P,
                "hover:bg-select-hover-background hover:border-select-hover-border hover:text-select-hover-text": !P
              }
            ),
            "aria-controls": `${e}-listbox`,
            "aria-expanded": P,
            role: m || g ? "combobox" : "button",
            disabled: f,
            "aria-label": r,
            children: [
              /* @__PURE__ */ u("div", { className: "truncate", children: ((de = c.find((ae) => ae.value === i)) == null ? void 0 : de.label) || (w == null ? void 0 : w.label) || t }),
              /* @__PURE__ */ u("input", { type: "hidden", defaultValue: i || (w == null ? void 0 : w.value), ref: _ }),
              /* @__PURE__ */ u(
                "div",
                {
                  className: S("text-select-default-icon flex", "group-hover:text-select-hover-icon", {
                    "text-select-negative-icon": d === "negative",
                    "text-select-disabled-icon": f
                  }),
                  children: i || w != null && w.value ? /* @__PURE__ */ u(
                    "div",
                    {
                      className: S("text-multiselect-default-icon flex", "group-hover:text-multiselect-hover-icon", {
                        "text-multiselect-negative-icon": d === "negative",
                        "text-multiselect-disabled-icon": f
                      }),
                      role: "button",
                      tabIndex: 0,
                      onClick: () => {
                        ee(""), Y == null || Y("");
                      },
                      onKeyDown: (ae) => {
                        ae.key === "Enter" && (ee(""), Y == null || Y(""));
                      },
                      "aria-label": "Clear selection",
                      children: /* @__PURE__ */ u(Re, { size: "xs", name: "Close" })
                    }
                  ) : /* @__PURE__ */ u(Re, { size: "xs", name: "ChevronDown" })
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ u(
          $r,
          {
            className: "border-spotlight-body-border w-full min-w-60 overflow-auto p-0",
            align: "start",
            popoverFooter: k,
            children: /* @__PURE__ */ V(Q3, { seamless: !0, shouldFilter: !1, children: [
              (m || g) && /* @__PURE__ */ u(
                t5,
                {
                  placeholder: n,
                  value: Z,
                  onValueChange: (ae) => {
                    ee(ae);
                  }
                }
              ),
              /* @__PURE__ */ u(n5, { id: `${e}-listbox`, role: "listbox", children: E ? /* @__PURE__ */ u(e5, { children: R }) : /* @__PURE__ */ V(me, { children: [
                /* @__PURE__ */ u(r5, { children: F }),
                Object.entries(X).map(([ae, ge]) => /* @__PURE__ */ u(wl, { heading: ae, children: ge.map((K) => /* @__PURE__ */ u(
                  Ml,
                  {
                    value: K.value,
                    keywords: [K.label, ...K.keywords || []],
                    onSelect: (J) => {
                      Y == null || Y(J), O(!1), ee("");
                    },
                    disabled: K.disabled,
                    children: z ? z(K) : /* @__PURE__ */ V(me, { children: [
                      /* @__PURE__ */ u("div", { className: S("flex h-4 w-4 shrink-0"), children: K.value === (w == null ? void 0 : w.value) || K.value === i ? /* @__PURE__ */ u(Re, { name: "Check" }) : null }),
                      /* @__PURE__ */ u("div", { children: K.label })
                    ] })
                  },
                  K.value
                )) }, ae))
              ] }) })
            ] })
          }
        )
      ] }),
      v && /* @__PURE__ */ u(
        "div",
        {
          className: S("text-hint-default-text text-xs", {
            "text-hint-negative-text": d === "negative"
          }),
          children: v
        }
      )
    ] });
  }
);
fK.displayName = "Select";
const hK = O3;
hK.displayName = "Sheet";
const pK = N3;
pK.displayName = "SheetTrigger";
const wh = B3;
wh.displayName = "SheetPortal";
const mK = Ql;
mK.displayName = "SheetClose";
const Mh = W(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  I3,
  {
    ref: n,
    className: S(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 bg-overlay-background fixed inset-0 z-50 opacity-80"
    ),
    ...t
  }
));
Mh.displayName = "SheetOverlay";
const vK = Ye(
  "flex flex-col gap-16 fixed z-50 bg-dialog-background p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), gK = W(
  ({ side: e = "right", className: t, children: n, ...r }, i) => /* @__PURE__ */ V(wh, { children: [
    /* @__PURE__ */ u(Mh, {}),
    /* @__PURE__ */ V(T3, { ref: i, className: S(vK({ side: e })), ...r, children: [
      n,
      /* @__PURE__ */ V(Ql, { className: "ring-offset-background focus-visible:ring-ring data-[state=open]:bg-secondary absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none", children: [
        /* @__PURE__ */ u(Re, { name: "Close" }),
        /* @__PURE__ */ u("span", { className: "sr-only", children: "Close" })
      ] })
    ] })
  ] })
);
gK.displayName = "SheetContent";
const LK = ({ className: e, ...t }) => /* @__PURE__ */ u("div", { className: S("mt-auto flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2"), ...t });
LK.displayName = "SheetFooter";
const wK = Ye("bg-skeleton-default-background animate-pulse rounded-md w-32 h-8 max-w-full", {
  variants: {
    variant: {
      badge: "w-24 h-4 rounded-xs",
      button: "w-24 h-8",
      card: "w-64 h-40",
      avatar: "w-8 h-8 rounded-full",
      icon: "w-8 h-8"
    }
  },
  defaultVariants: {
    variant: "badge"
  }
}), MK = ({ variant: e, ...t }) => /* @__PURE__ */ u("div", { className: S(wK({ variant: e })), ...t });
MK.displayName = "Skeleton";
const xK = Ye("animate-spin", {
  variants: {
    /**
     * Size of the spinner
     * @default default
     * @type small | default | large
     */
    size: {
      xs: "h-4 w-4",
      sm: "h-6 w-6",
      md: "h-8 w-8",
      lg: "h-10 w-10"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), bK = ({ className: e, size: t, ...n }) => /* @__PURE__ */ u("svg", { className: S("text-spinner-border", xK({ size: t })), viewBox: "0 0 16 16", fill: "none", ...n, children: /* @__PURE__ */ u(
  "path",
  {
    d: "M15 8C15 9.61949 14.4385 11.1889 13.4111 12.4408C12.3837 13.6926 10.954 14.5496 9.36563 14.8655C7.77726 15.1814 6.12848 14.9369 4.70022 14.1734C3.27196 13.41 2.15259 12.175 1.53284 10.6788C0.913093 9.18257 0.831305 7.51776 1.30142 5.96801C1.77153 4.41826 2.76445 3.07945 4.11101 2.17971C5.45756 1.27997 7.07443 0.87497 8.68612 1.03371C10.2978 1.19244 11.8046 1.9051 12.9497 3.05025",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }
) });
bK.displayName = "Spinner";
const c6 = Ye(
  "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        primary: Ms.primary,
        "outline-primary": Ms["outline-primary"]
      },
      size: {
        default: "h-8 px-3 py-2",
        sm: "h-6 px-3 py-1",
        lg: "h-9 px-3 py-2"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "default"
    }
  }
), yK = W(
  ({ className: e, variant: t = "primary", buttonTitle: n, menuItems: r = [], ...i }, a) => r.length ? /* @__PURE__ */ V("div", { className: "flex", children: [
    /* @__PURE__ */ u(
      "button",
      {
        className: S(c6({ variant: t }), "border-r-default-normal rounded-none rounded-l-md border-r"),
        ...i,
        ref: a,
        children: n
      }
    ),
    /* @__PURE__ */ u("div", { children: /* @__PURE__ */ V(Il, { children: [
      /* @__PURE__ */ u(Tl, { asChild: !0, children: /* @__PURE__ */ u("button", { className: S(c6({ variant: t }), "rounded-none rounded-r-md"), children: /* @__PURE__ */ u(Re, { size: "sm", name: "ChevronDown" }) }) }),
      /* @__PURE__ */ u(Vl, { align: "start", className: "m-0 mt-1 rounded-t-sm p-0 *:rounded-none *:p-0", children: r.map((c, d) => /* @__PURE__ */ u(b3, { className: "*:w-full *:rounded-none", children: c }, d)) })
    ] }) })
  ] }) : /* @__PURE__ */ u(E3, { ...i, ref: a, children: n })
);
yK.displayName = "SplitButton";
const CK = Ye("flex flex-col", {
  variants: {
    gap: {
      0: "gap-0",
      2: "gap-2",
      4: "gap-4",
      8: "gap-8",
      12: "gap-12",
      16: "gap-16",
      24: "gap-24"
    },
    x: {
      start: "items-start",
      center: "items-center",
      end: "items-end",
      stretch: "items-stretch"
    },
    fullWidth: {
      true: "w-full"
    },
    fullHeight: {
      true: "h-full"
    }
  },
  defaultVariants: {
    gap: 0,
    x: "stretch"
  }
}), yi = ({ children: e, gap: t = 0, x: n = "stretch", fullHeight: r, fullWidth: i, ...a }) => /* @__PURE__ */ u(
  "div",
  {
    className: S(CK({ gap: t, x: n, fullHeight: r, fullWidth: i }), {
      "[&>.card_+_.card]:border-t-0": t === 0
    }),
    ...a,
    children: e
  }
);
yi.displayName = "Stack";
const xh = O2({
  index: -1,
  total: 0
}), EK = (e) => {
  switch (e) {
    case "completed":
      return "Check";
    default:
      return null;
  }
}, FK = ({ children: e, ...t }) => /* @__PURE__ */ u("div", { className: S("flex w-full justify-between"), ...t, children: jt.map(e, (n, r) => /* @__PURE__ */ V(
  xh.Provider,
  {
    value: {
      index: r,
      total: jt.count(e)
    },
    children: [
      n,
      r !== jt.count(e) - 1 ? /* @__PURE__ */ u(
        "div",
        {
          className: S(
            "my-auto h-0.5 min-w-4 flex-1 rounded-xs max-md:min-w-1",
            "[[data-state=completed]+&]:bg-stepper-active-border",
            "[[data-state=active]+&]:bg-stepper-default-border",
            "[[data-state=upcoming]+&]:bg-stepper-default-border"
          ),
          role: "separator"
        }
      ) : null
    ]
  }
)) });
FK.displayName = "Stepper";
const zK = ({ label: e, state: t, disabled: n, onClick: r }) => {
  const { index: i } = pt(xh), a = EK(t);
  return /* @__PURE__ */ u("div", { className: S("flex w-full max-w-fit"), "data-state": t, children: /* @__PURE__ */ V(
    "button",
    {
      className: S(
        "border-stepper-default-border text-stepper-default-text flex max-w-40 items-center rounded-full border px-3 py-2 text-sm font-normal",
        "max-md:p-2 max-sm:p-1",
        "focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-hidden",
        {
          "cursor-pointer": !n,
          "cursor-not-allowed": n,
          "border-stepper-active-border text-stepper-active-text border": t === "active",
          "border-stepper-done-border text-stepper-done-text border": t === "completed"
        }
      ),
      disabled: n,
      onClick: () => {
        n || r == null || r();
      },
      children: [
        /* @__PURE__ */ u(
          "div",
          {
            className: S(
              "text-md stepper- border-stepper-default-border text-stepper-default-text mr-1 flex h-4 w-4 items-center justify-center rounded-full border p-2",
              "max-sm:mr-0",
              {
                "bg-stepper-done-icon text-stepper-active-text border-stepper-active-border border": t === "active",
                "bg-stepper-done-background text-stepper-done-icon": t === "completed"
              }
            ),
            children: a ? /* @__PURE__ */ u(Re, { size: "xs", name: a }) : /* @__PURE__ */ u(tt, { variant: "tiny", children: i + 1 })
          }
        ),
        /* @__PURE__ */ u("div", { className: S("max-h-[2rem] overflow-hidden text-xs text-ellipsis", "max-sm:hidden"), children: e })
      ]
    }
  ) });
};
zK.displayName = "StepperItem";
var ro = "Switch", [AK, LX] = Tt(ro), [SK, kK] = AK(ro), bh = M.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: i,
      defaultChecked: a,
      required: c,
      disabled: d,
      value: f = "on",
      onCheckedChange: p,
      form: m,
      ...v
    } = e, [g, w] = M.useState(null), x = ct(t, (k) => w(k)), b = M.useRef(!1), y = g ? m || !!g.closest("form") : !0, [E, z] = Kt({
      prop: i,
      defaultProp: a ?? !1,
      onChange: p,
      caller: ro
    });
    return /* @__PURE__ */ V(SK, { scope: n, checked: E, disabled: d, children: [
      /* @__PURE__ */ u(
        ke.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": E,
          "aria-required": c,
          "data-state": Fh(E),
          "data-disabled": d ? "" : void 0,
          disabled: d,
          value: f,
          ...v,
          ref: x,
          onClick: be(e.onClick, (k) => {
            z((R) => !R), y && (b.current = k.isPropagationStopped(), b.current || k.stopPropagation());
          })
        }
      ),
      y && /* @__PURE__ */ u(
        Eh,
        {
          control: g,
          bubbles: !b.current,
          name: r,
          value: f,
          checked: E,
          required: c,
          disabled: d,
          form: m,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
bh.displayName = ro;
var yh = "SwitchThumb", Ch = M.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, i = kK(yh, n);
    return /* @__PURE__ */ u(
      ke.span,
      {
        "data-state": Fh(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
Ch.displayName = yh;
var DK = "SwitchBubbleInput", Eh = M.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    ...i
  }, a) => {
    const c = M.useRef(null), d = ct(c, a), f = i9(n), p = a3(t);
    return M.useEffect(() => {
      const m = c.current;
      if (!m) return;
      const v = window.HTMLInputElement.prototype, w = Object.getOwnPropertyDescriptor(
        v,
        "checked"
      ).set;
      if (f !== n && w) {
        const x = new Event("click", { bubbles: r });
        w.call(m, n), m.dispatchEvent(x);
      }
    }, [f, n, r]), /* @__PURE__ */ u(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...i,
        tabIndex: -1,
        ref: d,
        style: {
          ...i.style,
          ...p,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Eh.displayName = DK;
function Fh(e) {
  return e ? "checked" : "unchecked";
}
var RK = bh, _K = Ch;
const PK = W(({ children: e, ...t }, n) => /* @__PURE__ */ V("div", { className: S("flex flex-col gap-12"), children: [
  /* @__PURE__ */ V("label", { htmlFor: t.id, className: S("relative flex items-center gap-8"), children: [
    /* @__PURE__ */ u(
      RK,
      {
        className: S(
          "peer-focus-visible:ring-ring data-[state=checked]:bg-switch-on-default-background data-[state=unchecked]:bg-switch-off-disabled-background peer inline-flex h-4 w-7 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors peer-focus-visible:ring-2 peer-focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed",
          {
            "bg-switch-off-disabled-background": t.disabled,
            "bg-switch-on-default-background": t.checked,
            "bg-switch-on-disabled-background": t.checked && t.disabled
          }
        ),
        onCheckedChange: t.onCheckedChange,
        ref: n,
        ...t,
        children: /* @__PURE__ */ u(
          _K,
          {
            className: S(
              "bg-switch-off-default-icon pointer-events-none block h-3 w-3 rounded-full shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-3 data-[state=unchecked]:translate-x-0",
              {
                "bg-switch-off-disabled-icon": t.disabled,
                "bg-switch-on-default-icon": t.checked,
                "bg-switch-on-disabled-icon": t.checked && t.disabled
              }
            )
          }
        )
      }
    ),
    t.label ? /* @__PURE__ */ V(
      "div",
      {
        className: S("text-switch-off-default-text cursor-pointer text-sm", {
          "text-switch-off-disabled-text": t.disabled,
          "text-switch-on-default-text": t.checked,
          "text-switch-on-disabled-text": t.checked && t.disabled
        }),
        children: [
          t.required ? /* @__PURE__ */ u("span", { className: S("text-label-required mr-1"), "aria-hidden": "true", children: "*" }) : null,
          t.label
        ]
      }
    ) : null
  ] }),
  e ? /* @__PURE__ */ u("div", { className: S("pl-9"), children: e }) : null
] }));
PK.displayName = "Switch";
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function lr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Cn(e, t) {
  return (n) => {
    t.setState((r) => ({
      ...r,
      [e]: lr(n, r[e])
    }));
  };
}
function io(e) {
  return e instanceof Function;
}
function HK(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "number");
}
function OK(e, t) {
  const n = [], r = (i) => {
    i.forEach((a) => {
      n.push(a);
      const c = t(a);
      c != null && c.length && r(c);
    });
  };
  return r(e), n;
}
function Oe(e, t, n) {
  let r = [], i;
  return (a) => {
    let c;
    n.key && n.debug && (c = Date.now());
    const d = e(a);
    if (!(d.length !== r.length || d.some((m, v) => r[v] !== m)))
      return i;
    r = d;
    let p;
    if (n.key && n.debug && (p = Date.now()), i = t(...d), n == null || n.onChange == null || n.onChange(i), n.key && n.debug && n != null && n.debug()) {
      const m = Math.round((Date.now() - c) * 100) / 100, v = Math.round((Date.now() - p) * 100) / 100, g = v / 16, w = (x, b) => {
        for (x = String(x); x.length < b; )
          x = " " + x;
        return x;
      };
      console.info(`%c⏱ ${w(v, 5)} /${w(m, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * g, 120))}deg 100% 31%);`, n == null ? void 0 : n.key);
    }
    return i;
  };
}
function Ne(e, t, n, r) {
  return {
    debug: () => {
      var i;
      return (i = e == null ? void 0 : e.debugAll) != null ? i : e[t];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: r
  };
}
function NK(e, t, n, r) {
  const i = () => {
    var c;
    return (c = a.getValue()) != null ? c : e.options.renderFallbackValue;
  }, a = {
    id: `${t.id}_${n.id}`,
    row: t,
    column: n,
    getValue: () => t.getValue(r),
    renderValue: i,
    getContext: Oe(() => [e, n, t, a], (c, d, f, p) => ({
      table: c,
      column: d,
      row: f,
      cell: p,
      getValue: p.getValue,
      renderValue: p.renderValue
    }), Ne(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((c) => {
    c.createCell == null || c.createCell(a, n, t, e);
  }, {}), a;
}
function BK(e, t, n, r) {
  var i, a;
  const d = {
    ...e._getDefaultColumnDef(),
    ...t
  }, f = d.accessorKey;
  let p = (i = (a = d.id) != null ? a : f ? typeof String.prototype.replaceAll == "function" ? f.replaceAll(".", "_") : f.replace(/\./g, "_") : void 0) != null ? i : typeof d.header == "string" ? d.header : void 0, m;
  if (d.accessorFn ? m = d.accessorFn : f && (f.includes(".") ? m = (g) => {
    let w = g;
    for (const b of f.split(".")) {
      var x;
      w = (x = w) == null ? void 0 : x[b], process.env.NODE_ENV !== "production" && w === void 0 && console.warn(`"${b}" in deeply nested key "${f}" returned undefined.`);
    }
    return w;
  } : m = (g) => g[d.accessorKey]), !p)
    throw process.env.NODE_ENV !== "production" ? new Error(d.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let v = {
    id: `${String(p)}`,
    accessorFn: m,
    parent: r,
    depth: n,
    columnDef: d,
    columns: [],
    getFlatColumns: Oe(() => [!0], () => {
      var g;
      return [v, ...(g = v.columns) == null ? void 0 : g.flatMap((w) => w.getFlatColumns())];
    }, Ne(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: Oe(() => [e._getOrderColumnsFn()], (g) => {
      var w;
      if ((w = v.columns) != null && w.length) {
        let x = v.columns.flatMap((b) => b.getLeafColumns());
        return g(x);
      }
      return [v];
    }, Ne(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const g of e._features)
    g.createColumn == null || g.createColumn(v, e);
  return v;
}
const Wt = "debugHeaders";
function d6(e, t, n) {
  var r;
  let a = {
    id: (r = n.id) != null ? r : t.id,
    column: t,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const c = [], d = (f) => {
        f.subHeaders && f.subHeaders.length && f.subHeaders.map(d), c.push(f);
      };
      return d(a), c;
    },
    getContext: () => ({
      table: e,
      header: a,
      column: t
    })
  };
  return e._features.forEach((c) => {
    c.createHeader == null || c.createHeader(a, e);
  }), a;
}
const IK = {
  createTable: (e) => {
    e.getHeaderGroups = Oe(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, i) => {
      var a, c;
      const d = (a = r == null ? void 0 : r.map((v) => n.find((g) => g.id === v)).filter(Boolean)) != null ? a : [], f = (c = i == null ? void 0 : i.map((v) => n.find((g) => g.id === v)).filter(Boolean)) != null ? c : [], p = n.filter((v) => !(r != null && r.includes(v.id)) && !(i != null && i.includes(v.id)));
      return W0(t, [...d, ...p, ...f], e);
    }, Ne(e.options, Wt, "getHeaderGroups")), e.getCenterHeaderGroups = Oe(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r, i) => (n = n.filter((a) => !(r != null && r.includes(a.id)) && !(i != null && i.includes(a.id))), W0(t, n, e, "center")), Ne(e.options, Wt, "getCenterHeaderGroups")), e.getLeftHeaderGroups = Oe(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (t, n, r) => {
      var i;
      const a = (i = r == null ? void 0 : r.map((c) => n.find((d) => d.id === c)).filter(Boolean)) != null ? i : [];
      return W0(t, a, e, "left");
    }, Ne(e.options, Wt, "getLeftHeaderGroups")), e.getRightHeaderGroups = Oe(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (t, n, r) => {
      var i;
      const a = (i = r == null ? void 0 : r.map((c) => n.find((d) => d.id === c)).filter(Boolean)) != null ? i : [];
      return W0(t, a, e, "right");
    }, Ne(e.options, Wt, "getRightHeaderGroups")), e.getFooterGroups = Oe(() => [e.getHeaderGroups()], (t) => [...t].reverse(), Ne(e.options, Wt, "getFooterGroups")), e.getLeftFooterGroups = Oe(() => [e.getLeftHeaderGroups()], (t) => [...t].reverse(), Ne(e.options, Wt, "getLeftFooterGroups")), e.getCenterFooterGroups = Oe(() => [e.getCenterHeaderGroups()], (t) => [...t].reverse(), Ne(e.options, Wt, "getCenterFooterGroups")), e.getRightFooterGroups = Oe(() => [e.getRightHeaderGroups()], (t) => [...t].reverse(), Ne(e.options, Wt, "getRightFooterGroups")), e.getFlatHeaders = Oe(() => [e.getHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Ne(e.options, Wt, "getFlatHeaders")), e.getLeftFlatHeaders = Oe(() => [e.getLeftHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Ne(e.options, Wt, "getLeftFlatHeaders")), e.getCenterFlatHeaders = Oe(() => [e.getCenterHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Ne(e.options, Wt, "getCenterFlatHeaders")), e.getRightFlatHeaders = Oe(() => [e.getRightHeaderGroups()], (t) => t.map((n) => n.headers).flat(), Ne(e.options, Wt, "getRightFlatHeaders")), e.getCenterLeafHeaders = Oe(() => [e.getCenterFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Ne(e.options, Wt, "getCenterLeafHeaders")), e.getLeftLeafHeaders = Oe(() => [e.getLeftFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Ne(e.options, Wt, "getLeftLeafHeaders")), e.getRightLeafHeaders = Oe(() => [e.getRightFlatHeaders()], (t) => t.filter((n) => {
      var r;
      return !((r = n.subHeaders) != null && r.length);
    }), Ne(e.options, Wt, "getRightLeafHeaders")), e.getLeafHeaders = Oe(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (t, n, r) => {
      var i, a, c, d, f, p;
      return [...(i = (a = t[0]) == null ? void 0 : a.headers) != null ? i : [], ...(c = (d = n[0]) == null ? void 0 : d.headers) != null ? c : [], ...(f = (p = r[0]) == null ? void 0 : p.headers) != null ? f : []].map((m) => m.getLeafHeaders()).flat();
    }, Ne(e.options, Wt, "getLeafHeaders"));
  }
};
function W0(e, t, n, r) {
  var i, a;
  let c = 0;
  const d = function(g, w) {
    w === void 0 && (w = 1), c = Math.max(c, w), g.filter((x) => x.getIsVisible()).forEach((x) => {
      var b;
      (b = x.columns) != null && b.length && d(x.columns, w + 1);
    }, 0);
  };
  d(e);
  let f = [];
  const p = (g, w) => {
    const x = {
      depth: w,
      id: [r, `${w}`].filter(Boolean).join("_"),
      headers: []
    }, b = [];
    g.forEach((y) => {
      const E = [...b].reverse()[0], z = y.column.depth === x.depth;
      let k, R = !1;
      if (z && y.column.parent ? k = y.column.parent : (k = y.column, R = !0), E && (E == null ? void 0 : E.column) === k)
        E.subHeaders.push(y);
      else {
        const F = d6(n, k, {
          id: [r, w, k.id, y == null ? void 0 : y.id].filter(Boolean).join("_"),
          isPlaceholder: R,
          placeholderId: R ? `${b.filter((_) => _.column === k).length}` : void 0,
          depth: w,
          index: b.length
        });
        F.subHeaders.push(y), b.push(F);
      }
      x.headers.push(y), y.headerGroup = x;
    }), f.push(x), w > 0 && p(b, w - 1);
  }, m = t.map((g, w) => d6(n, g, {
    depth: c,
    index: w
  }));
  p(m, c - 1), f.reverse();
  const v = (g) => g.filter((x) => x.column.getIsVisible()).map((x) => {
    let b = 0, y = 0, E = [0];
    x.subHeaders && x.subHeaders.length ? (E = [], v(x.subHeaders).forEach((k) => {
      let {
        colSpan: R,
        rowSpan: F
      } = k;
      b += R, E.push(F);
    })) : b = 1;
    const z = Math.min(...E);
    return y = y + z, x.colSpan = b, x.rowSpan = y, {
      colSpan: b,
      rowSpan: y
    };
  });
  return v((i = (a = f[0]) == null ? void 0 : a.headers) != null ? i : []), f;
}
const TK = (e, t, n, r, i, a, c) => {
  let d = {
    id: t,
    index: r,
    original: n,
    depth: i,
    parentId: c,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (f) => {
      if (d._valuesCache.hasOwnProperty(f))
        return d._valuesCache[f];
      const p = e.getColumn(f);
      if (p != null && p.accessorFn)
        return d._valuesCache[f] = p.accessorFn(d.original, r), d._valuesCache[f];
    },
    getUniqueValues: (f) => {
      if (d._uniqueValuesCache.hasOwnProperty(f))
        return d._uniqueValuesCache[f];
      const p = e.getColumn(f);
      if (p != null && p.accessorFn)
        return p.columnDef.getUniqueValues ? (d._uniqueValuesCache[f] = p.columnDef.getUniqueValues(d.original, r), d._uniqueValuesCache[f]) : (d._uniqueValuesCache[f] = [d.getValue(f)], d._uniqueValuesCache[f]);
    },
    renderValue: (f) => {
      var p;
      return (p = d.getValue(f)) != null ? p : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => OK(d.subRows, (f) => f.subRows),
    getParentRow: () => d.parentId ? e.getRow(d.parentId, !0) : void 0,
    getParentRows: () => {
      let f = [], p = d;
      for (; ; ) {
        const m = p.getParentRow();
        if (!m) break;
        f.push(m), p = m;
      }
      return f.reverse();
    },
    getAllCells: Oe(() => [e.getAllLeafColumns()], (f) => f.map((p) => NK(e, d, p, p.id)), Ne(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: Oe(() => [d.getAllCells()], (f) => f.reduce((p, m) => (p[m.column.id] = m, p), {}), Ne(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let f = 0; f < e._features.length; f++) {
    const p = e._features[f];
    p == null || p.createRow == null || p.createRow(d, e);
  }
  return d;
}, VK = {
  createColumn: (e, t) => {
    e._getFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : t.getPreFilteredRowModel(), e._getFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, zh = (e, t, n) => {
  var r, i;
  const a = n == null || (r = n.toString()) == null ? void 0 : r.toLowerCase();
  return !!(!((i = e.getValue(t)) == null || (i = i.toString()) == null || (i = i.toLowerCase()) == null) && i.includes(a));
};
zh.autoRemove = (e) => $n(e);
const Ah = (e, t, n) => {
  var r;
  return !!(!((r = e.getValue(t)) == null || (r = r.toString()) == null) && r.includes(n));
};
Ah.autoRemove = (e) => $n(e);
const Sh = (e, t, n) => {
  var r;
  return ((r = e.getValue(t)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === (n == null ? void 0 : n.toLowerCase());
};
Sh.autoRemove = (e) => $n(e);
const kh = (e, t, n) => {
  var r;
  return (r = e.getValue(t)) == null ? void 0 : r.includes(n);
};
kh.autoRemove = (e) => $n(e);
const Dh = (e, t, n) => !n.some((r) => {
  var i;
  return !((i = e.getValue(t)) != null && i.includes(r));
});
Dh.autoRemove = (e) => $n(e) || !(e != null && e.length);
const Rh = (e, t, n) => n.some((r) => {
  var i;
  return (i = e.getValue(t)) == null ? void 0 : i.includes(r);
});
Rh.autoRemove = (e) => $n(e) || !(e != null && e.length);
const _h = (e, t, n) => e.getValue(t) === n;
_h.autoRemove = (e) => $n(e);
const Ph = (e, t, n) => e.getValue(t) == n;
Ph.autoRemove = (e) => $n(e);
const o5 = (e, t, n) => {
  let [r, i] = n;
  const a = e.getValue(t);
  return a >= r && a <= i;
};
o5.resolveFilterValue = (e) => {
  let [t, n] = e, r = typeof t != "number" ? parseFloat(t) : t, i = typeof n != "number" ? parseFloat(n) : n, a = t === null || Number.isNaN(r) ? -1 / 0 : r, c = n === null || Number.isNaN(i) ? 1 / 0 : i;
  if (a > c) {
    const d = a;
    a = c, c = d;
  }
  return [a, c];
};
o5.autoRemove = (e) => $n(e) || $n(e[0]) && $n(e[1]);
const S2 = {
  includesString: zh,
  includesStringSensitive: Ah,
  equalsString: Sh,
  arrIncludes: kh,
  arrIncludesAll: Dh,
  arrIncludesSome: Rh,
  equals: _h,
  weakEquals: Ph,
  inNumberRange: o5
};
function $n(e) {
  return e == null || e === "";
}
const ZK = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: Cn("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, t) => {
    e.getAutoFilterFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      return typeof r == "string" ? S2.includesString : typeof r == "number" ? S2.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? S2.equals : Array.isArray(r) ? S2.arrIncludes : S2.weakEquals;
    }, e.getFilterFn = () => {
      var n, r;
      return io(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (n = (r = t.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? n : S2[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var n, r, i;
      return ((n = e.columnDef.enableColumnFilter) != null ? n : !0) && ((r = t.options.enableColumnFilters) != null ? r : !0) && ((i = t.options.enableFilters) != null ? i : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var n;
      return (n = t.getState().columnFilters) == null || (n = n.find((r) => r.id === e.id)) == null ? void 0 : n.value;
    }, e.getFilterIndex = () => {
      var n, r;
      return (n = (r = t.getState().columnFilters) == null ? void 0 : r.findIndex((i) => i.id === e.id)) != null ? n : -1;
    }, e.setFilterValue = (n) => {
      t.setColumnFilters((r) => {
        const i = e.getFilterFn(), a = r == null ? void 0 : r.find((m) => m.id === e.id), c = lr(n, a ? a.value : void 0);
        if (u6(i, c, e)) {
          var d;
          return (d = r == null ? void 0 : r.filter((m) => m.id !== e.id)) != null ? d : [];
        }
        const f = {
          id: e.id,
          value: c
        };
        if (a) {
          var p;
          return (p = r == null ? void 0 : r.map((m) => m.id === e.id ? f : m)) != null ? p : [];
        }
        return r != null && r.length ? [...r, f] : [f];
      });
    };
  },
  createRow: (e, t) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (t) => {
      const n = e.getAllLeafColumns(), r = (i) => {
        var a;
        return (a = lr(t, i)) == null ? void 0 : a.filter((c) => {
          const d = n.find((f) => f.id === c.id);
          if (d) {
            const f = d.getFilterFn();
            if (u6(f, c.value, d))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (t) => {
      var n, r;
      e.setColumnFilters(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? n : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function u6(e, t, n) {
  return (e && e.autoRemove ? e.autoRemove(t, n) : !1) || typeof t > "u" || typeof t == "string" && !t;
}
const $K = (e, t, n) => n.reduce((r, i) => {
  const a = i.getValue(e);
  return r + (typeof a == "number" ? a : 0);
}, 0), WK = (e, t, n) => {
  let r;
  return n.forEach((i) => {
    const a = i.getValue(e);
    a != null && (r > a || r === void 0 && a >= a) && (r = a);
  }), r;
}, GK = (e, t, n) => {
  let r;
  return n.forEach((i) => {
    const a = i.getValue(e);
    a != null && (r < a || r === void 0 && a >= a) && (r = a);
  }), r;
}, UK = (e, t, n) => {
  let r, i;
  return n.forEach((a) => {
    const c = a.getValue(e);
    c != null && (r === void 0 ? c >= c && (r = i = c) : (r > c && (r = c), i < c && (i = c)));
  }), [r, i];
}, jK = (e, t) => {
  let n = 0, r = 0;
  if (t.forEach((i) => {
    let a = i.getValue(e);
    a != null && (a = +a) >= a && (++n, r += a);
  }), n) return r / n;
}, KK = (e, t) => {
  if (!t.length)
    return;
  const n = t.map((a) => a.getValue(e));
  if (!HK(n))
    return;
  if (n.length === 1)
    return n[0];
  const r = Math.floor(n.length / 2), i = n.sort((a, c) => a - c);
  return n.length % 2 !== 0 ? i[r] : (i[r - 1] + i[r]) / 2;
}, YK = (e, t) => Array.from(new Set(t.map((n) => n.getValue(e))).values()), qK = (e, t) => new Set(t.map((n) => n.getValue(e))).size, XK = (e, t) => t.length, qa = {
  sum: $K,
  min: WK,
  max: GK,
  extent: UK,
  mean: jK,
  median: KK,
  unique: YK,
  uniqueCount: qK,
  count: XK
}, JK = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var t, n;
      return (t = (n = e.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? t : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: Cn("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, t) => {
    e.toggleGrouping = () => {
      t.setGrouping((n) => n != null && n.includes(e.id) ? n.filter((r) => r !== e.id) : [...n ?? [], e.id]);
    }, e.getCanGroup = () => {
      var n, r;
      return ((n = e.columnDef.enableGrouping) != null ? n : !0) && ((r = t.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.includes(e.id);
    }, e.getGroupedIndex = () => {
      var n;
      return (n = t.getState().grouping) == null ? void 0 : n.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const n = e.getCanGroup();
      return () => {
        n && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const n = t.getCoreRowModel().flatRows[0], r = n == null ? void 0 : n.getValue(e.id);
      if (typeof r == "number")
        return qa.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return qa.extent;
    }, e.getAggregationFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return io(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (n = (r = t.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? n : qa[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (t) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(t), e.resetGrouping = (t) => {
      var n, r;
      e.setGrouping(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.grouping) != null ? n : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, t) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (n) => {
      if (e._groupingValuesCache.hasOwnProperty(n))
        return e._groupingValuesCache[n];
      const r = t.getColumn(n);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[n] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[n]) : e.getValue(n);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, t, n, r) => {
    e.getIsGrouped = () => t.getIsGrouped() && t.id === n.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && t.getIsGrouped(), e.getIsAggregated = () => {
      var i;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((i = n.subRows) != null && i.length);
    };
  }
};
function QK(e, t, n) {
  if (!(t != null && t.length) || !n)
    return e;
  const r = e.filter((a) => !t.includes(a.id));
  return n === "remove" ? r : [...t.map((a) => e.find((c) => c.id === a)).filter(Boolean), ...r];
}
const eY = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: Cn("columnOrder", e)
  }),
  createColumn: (e, t) => {
    e.getIndex = Oe((n) => [fi(t, n)], (n) => n.findIndex((r) => r.id === e.id), Ne(t.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (n) => {
      var r;
      return ((r = fi(t, n)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (n) => {
      var r;
      const i = fi(t, n);
      return ((r = i[i.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (t) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(t), e.resetColumnOrder = (t) => {
      var n;
      e.setColumnOrder(t ? [] : (n = e.initialState.columnOrder) != null ? n : []);
    }, e._getOrderColumnsFn = Oe(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (t, n, r) => (i) => {
      let a = [];
      if (!(t != null && t.length))
        a = i;
      else {
        const c = [...t], d = [...i];
        for (; d.length && c.length; ) {
          const f = c.shift(), p = d.findIndex((m) => m.id === f);
          p > -1 && a.push(d.splice(p, 1)[0]);
        }
        a = [...a, ...d];
      }
      return QK(a, n, r);
    }, Ne(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, Xa = () => ({
  left: [],
  right: []
}), tY = {
  getInitialState: (e) => ({
    columnPinning: Xa(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: Cn("columnPinning", e)
  }),
  createColumn: (e, t) => {
    e.pin = (n) => {
      const r = e.getLeafColumns().map((i) => i.id).filter(Boolean);
      t.setColumnPinning((i) => {
        var a, c;
        if (n === "right") {
          var d, f;
          return {
            left: ((d = i == null ? void 0 : i.left) != null ? d : []).filter((v) => !(r != null && r.includes(v))),
            right: [...((f = i == null ? void 0 : i.right) != null ? f : []).filter((v) => !(r != null && r.includes(v))), ...r]
          };
        }
        if (n === "left") {
          var p, m;
          return {
            left: [...((p = i == null ? void 0 : i.left) != null ? p : []).filter((v) => !(r != null && r.includes(v))), ...r],
            right: ((m = i == null ? void 0 : i.right) != null ? m : []).filter((v) => !(r != null && r.includes(v)))
          };
        }
        return {
          left: ((a = i == null ? void 0 : i.left) != null ? a : []).filter((v) => !(r != null && r.includes(v))),
          right: ((c = i == null ? void 0 : i.right) != null ? c : []).filter((v) => !(r != null && r.includes(v)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var i, a, c;
      return ((i = r.columnDef.enablePinning) != null ? i : !0) && ((a = (c = t.options.enableColumnPinning) != null ? c : t.options.enablePinning) != null ? a : !0);
    }), e.getIsPinned = () => {
      const n = e.getLeafColumns().map((d) => d.id), {
        left: r,
        right: i
      } = t.getState().columnPinning, a = n.some((d) => r == null ? void 0 : r.includes(d)), c = n.some((d) => i == null ? void 0 : i.includes(d));
      return a ? "left" : c ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const i = e.getIsPinned();
      return i ? (n = (r = t.getState().columnPinning) == null || (r = r[i]) == null ? void 0 : r.indexOf(e.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (e, t) => {
    e.getCenterVisibleCells = Oe(() => [e._getAllVisibleCells(), t.getState().columnPinning.left, t.getState().columnPinning.right], (n, r, i) => {
      const a = [...r ?? [], ...i ?? []];
      return n.filter((c) => !a.includes(c.column.id));
    }, Ne(t.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = Oe(() => [e._getAllVisibleCells(), t.getState().columnPinning.left], (n, r) => (r ?? []).map((a) => n.find((c) => c.column.id === a)).filter(Boolean).map((a) => ({
      ...a,
      position: "left"
    })), Ne(t.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = Oe(() => [e._getAllVisibleCells(), t.getState().columnPinning.right], (n, r) => (r ?? []).map((a) => n.find((c) => c.column.id === a)).filter(Boolean).map((a) => ({
      ...a,
      position: "right"
    })), Ne(t.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (t) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(t), e.resetColumnPinning = (t) => {
      var n, r;
      return e.setColumnPinning(t ? Xa() : (n = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? n : Xa());
    }, e.getIsSomeColumnsPinned = (t) => {
      var n;
      const r = e.getState().columnPinning;
      if (!t) {
        var i, a;
        return !!((i = r.left) != null && i.length || (a = r.right) != null && a.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e.getLeftLeafColumns = Oe(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (t, n) => (n ?? []).map((r) => t.find((i) => i.id === r)).filter(Boolean), Ne(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = Oe(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (t, n) => (n ?? []).map((r) => t.find((i) => i.id === r)).filter(Boolean), Ne(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = Oe(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (t, n, r) => {
      const i = [...n ?? [], ...r ?? []];
      return t.filter((a) => !i.includes(a.id));
    }, Ne(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function nY(e) {
  return e || (typeof document < "u" ? document : null);
}
const G0 = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, Ja = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), rY = {
  getDefaultColumnDef: () => G0,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: Ja(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: Cn("columnSizing", e),
    onColumnSizingInfoChange: Cn("columnSizingInfo", e)
  }),
  createColumn: (e, t) => {
    e.getSize = () => {
      var n, r, i;
      const a = t.getState().columnSizing[e.id];
      return Math.min(Math.max((n = e.columnDef.minSize) != null ? n : G0.minSize, (r = a ?? e.columnDef.size) != null ? r : G0.size), (i = e.columnDef.maxSize) != null ? i : G0.maxSize);
    }, e.getStart = Oe((n) => [n, fi(t, n), t.getState().columnSizing], (n, r) => r.slice(0, e.getIndex(n)).reduce((i, a) => i + a.getSize(), 0), Ne(t.options, "debugColumns", "getStart")), e.getAfter = Oe((n) => [n, fi(t, n), t.getState().columnSizing], (n, r) => r.slice(e.getIndex(n) + 1).reduce((i, a) => i + a.getSize(), 0), Ne(t.options, "debugColumns", "getAfter")), e.resetSize = () => {
      t.setColumnSizing((n) => {
        let {
          [e.id]: r,
          ...i
        } = n;
        return i;
      });
    }, e.getCanResize = () => {
      var n, r;
      return ((n = e.columnDef.enableResizing) != null ? n : !0) && ((r = t.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => t.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, t) => {
    e.getSize = () => {
      let n = 0;
      const r = (i) => {
        if (i.subHeaders.length)
          i.subHeaders.forEach(r);
        else {
          var a;
          n += (a = i.column.getSize()) != null ? a : 0;
        }
      };
      return r(e), n;
    }, e.getStart = () => {
      if (e.index > 0) {
        const n = e.headerGroup.headers[e.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, e.getResizeHandler = (n) => {
      const r = t.getColumn(e.column.id), i = r == null ? void 0 : r.getCanResize();
      return (a) => {
        if (!r || !i || (a.persist == null || a.persist(), Qa(a) && a.touches && a.touches.length > 1))
          return;
        const c = e.getSize(), d = e ? e.getLeafHeaders().map((E) => [E.column.id, E.column.getSize()]) : [[r.id, r.getSize()]], f = Qa(a) ? Math.round(a.touches[0].clientX) : a.clientX, p = {}, m = (E, z) => {
          typeof z == "number" && (t.setColumnSizingInfo((k) => {
            var R, F;
            const _ = t.options.columnResizeDirection === "rtl" ? -1 : 1, P = (z - ((R = k == null ? void 0 : k.startOffset) != null ? R : 0)) * _, O = Math.max(P / ((F = k == null ? void 0 : k.startSize) != null ? F : 0), -0.999999);
            return k.columnSizingStart.forEach((Z) => {
              let [te, Y] = Z;
              p[te] = Math.round(Math.max(Y + Y * O, 0) * 100) / 100;
            }), {
              ...k,
              deltaOffset: P,
              deltaPercentage: O
            };
          }), (t.options.columnResizeMode === "onChange" || E === "end") && t.setColumnSizing((k) => ({
            ...k,
            ...p
          })));
        }, v = (E) => m("move", E), g = (E) => {
          m("end", E), t.setColumnSizingInfo((z) => ({
            ...z,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, w = nY(n), x = {
          moveHandler: (E) => v(E.clientX),
          upHandler: (E) => {
            w == null || w.removeEventListener("mousemove", x.moveHandler), w == null || w.removeEventListener("mouseup", x.upHandler), g(E.clientX);
          }
        }, b = {
          moveHandler: (E) => (E.cancelable && (E.preventDefault(), E.stopPropagation()), v(E.touches[0].clientX), !1),
          upHandler: (E) => {
            var z;
            w == null || w.removeEventListener("touchmove", b.moveHandler), w == null || w.removeEventListener("touchend", b.upHandler), E.cancelable && (E.preventDefault(), E.stopPropagation()), g((z = E.touches[0]) == null ? void 0 : z.clientX);
          }
        }, y = iY() ? {
          passive: !1
        } : !1;
        Qa(a) ? (w == null || w.addEventListener("touchmove", b.moveHandler, y), w == null || w.addEventListener("touchend", b.upHandler, y)) : (w == null || w.addEventListener("mousemove", x.moveHandler, y), w == null || w.addEventListener("mouseup", x.upHandler, y)), t.setColumnSizingInfo((E) => ({
          ...E,
          startOffset: f,
          startSize: c,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: d,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (t) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(t), e.setColumnSizingInfo = (t) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(t), e.resetColumnSizing = (t) => {
      var n;
      e.setColumnSizing(t ? {} : (n = e.initialState.columnSizing) != null ? n : {});
    }, e.resetHeaderSizeInfo = (t) => {
      var n;
      e.setColumnSizingInfo(t ? Ja() : (n = e.initialState.columnSizingInfo) != null ? n : Ja());
    }, e.getTotalSize = () => {
      var t, n;
      return (t = (n = e.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? t : 0;
    }, e.getLeftTotalSize = () => {
      var t, n;
      return (t = (n = e.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? t : 0;
    }, e.getCenterTotalSize = () => {
      var t, n;
      return (t = (n = e.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? t : 0;
    }, e.getRightTotalSize = () => {
      var t, n;
      return (t = (n = e.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? t : 0;
    };
  }
};
let U0 = null;
function iY() {
  if (typeof U0 == "boolean") return U0;
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, t), window.removeEventListener("test", n);
  } catch {
    e = !1;
  }
  return U0 = e, U0;
}
function Qa(e) {
  return e.type === "touchstart";
}
const lY = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: Cn("columnVisibility", e)
  }),
  createColumn: (e, t) => {
    e.toggleVisibility = (n) => {
      e.getCanHide() && t.setColumnVisibility((r) => ({
        ...r,
        [e.id]: n ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var n, r;
      const i = e.columns;
      return (n = i.length ? i.some((a) => a.getIsVisible()) : (r = t.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? n : !0;
    }, e.getCanHide = () => {
      var n, r;
      return ((n = e.columnDef.enableHiding) != null ? n : !0) && ((r = t.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (n) => {
      e.toggleVisibility == null || e.toggleVisibility(n.target.checked);
    };
  },
  createRow: (e, t) => {
    e._getAllVisibleCells = Oe(() => [e.getAllCells(), t.getState().columnVisibility], (n) => n.filter((r) => r.column.getIsVisible()), Ne(t.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = Oe(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (n, r, i) => [...n, ...r, ...i], Ne(t.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const t = (n, r) => Oe(() => [r(), r().filter((i) => i.getIsVisible()).map((i) => i.id).join("_")], (i) => i.filter((a) => a.getIsVisible == null ? void 0 : a.getIsVisible()), Ne(e.options, "debugColumns", n));
    e.getVisibleFlatColumns = t("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = t("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = t("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = t("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = t("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (n) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(n), e.resetColumnVisibility = (n) => {
      var r;
      e.setColumnVisibility(n ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (n) => {
      var r;
      n = (r = n) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((i, a) => ({
        ...i,
        [a.id]: n || !(a.getCanHide != null && a.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var r;
      e.toggleAllColumnsVisible((r = n.target) == null ? void 0 : r.checked);
    };
  }
};
function fi(e, t) {
  return t ? t === "center" ? e.getCenterVisibleLeafColumns() : t === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const oY = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, aY = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: Cn("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (t) => {
      var n;
      const r = (n = e.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[t.id]) == null ? void 0 : n.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, t) => {
    e.getCanGlobalFilter = () => {
      var n, r, i, a;
      return ((n = e.columnDef.enableGlobalFilter) != null ? n : !0) && ((r = t.options.enableGlobalFilter) != null ? r : !0) && ((i = t.options.enableFilters) != null ? i : !0) && ((a = t.options.getColumnCanGlobalFilter == null ? void 0 : t.options.getColumnCanGlobalFilter(e)) != null ? a : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => S2.includesString, e.getGlobalFilterFn = () => {
      var t, n;
      const {
        globalFilterFn: r
      } = e.options;
      return io(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (t = (n = e.options.filterFns) == null ? void 0 : n[r]) != null ? t : S2[r];
    }, e.setGlobalFilter = (t) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(t);
    }, e.resetGlobalFilter = (t) => {
      e.setGlobalFilter(t ? void 0 : e.initialState.globalFilter);
    };
  }
}, sY = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: Cn("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetExpanded = () => {
      var r, i;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (i = e.options.autoResetAll) != null ? i : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetExpanded(), n = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var i, a;
      e.setExpanded(r ? {} : (i = (a = e.initialState) == null ? void 0 : a.expanded) != null ? i : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((i) => !i.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((a) => {
        const c = a.split(".");
        r = Math.max(r, c.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, t) => {
    e.toggleExpanded = (n) => {
      t.setExpanded((r) => {
        var i;
        const a = r === !0 ? !0 : !!(r != null && r[e.id]);
        let c = {};
        if (r === !0 ? Object.keys(t.getRowModel().rowsById).forEach((d) => {
          c[d] = !0;
        }) : c = r, n = (i = n) != null ? i : !a, !a && n)
          return {
            ...c,
            [e.id]: !0
          };
        if (a && !n) {
          const {
            [e.id]: d,
            ...f
          } = c;
          return f;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var n;
      const r = t.getState().expanded;
      return !!((n = t.options.getIsRowExpanded == null ? void 0 : t.options.getIsRowExpanded(e)) != null ? n : r === !0 || r != null && r[e.id]);
    }, e.getCanExpand = () => {
      var n, r, i;
      return (n = t.options.getRowCanExpand == null ? void 0 : t.options.getRowCanExpand(e)) != null ? n : ((r = t.options.enableExpanding) != null ? r : !0) && !!((i = e.subRows) != null && i.length);
    }, e.getIsAllParentsExpanded = () => {
      let n = !0, r = e;
      for (; n && r.parentId; )
        r = t.getRow(r.parentId, !0), n = r.getIsExpanded();
      return n;
    }, e.getToggleExpandedHandler = () => {
      const n = e.getCanExpand();
      return () => {
        n && e.toggleExpanded();
      };
    };
  }
}, As = 0, Ss = 10, es = () => ({
  pageIndex: As,
  pageSize: Ss
}), cY = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...es(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: Cn("pagination", e)
  }),
  createTable: (e) => {
    let t = !1, n = !1;
    e._autoResetPageIndex = () => {
      var r, i;
      if (!t) {
        e._queue(() => {
          t = !0;
        });
        return;
      }
      if ((r = (i = e.options.autoResetAll) != null ? i : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (n) return;
        n = !0, e._queue(() => {
          e.resetPageIndex(), n = !1;
        });
      }
    }, e.setPagination = (r) => {
      const i = (a) => lr(r, a);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(i);
    }, e.resetPagination = (r) => {
      var i;
      e.setPagination(r ? es() : (i = e.initialState.pagination) != null ? i : es());
    }, e.setPageIndex = (r) => {
      e.setPagination((i) => {
        let a = lr(r, i.pageIndex);
        const c = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return a = Math.max(0, Math.min(a, c)), {
          ...i,
          pageIndex: a
        };
      });
    }, e.resetPageIndex = (r) => {
      var i, a;
      e.setPageIndex(r ? As : (i = (a = e.initialState) == null || (a = a.pagination) == null ? void 0 : a.pageIndex) != null ? i : As);
    }, e.resetPageSize = (r) => {
      var i, a;
      e.setPageSize(r ? Ss : (i = (a = e.initialState) == null || (a = a.pagination) == null ? void 0 : a.pageSize) != null ? i : Ss);
    }, e.setPageSize = (r) => {
      e.setPagination((i) => {
        const a = Math.max(1, lr(r, i.pageSize)), c = i.pageSize * i.pageIndex, d = Math.floor(c / a);
        return {
          ...i,
          pageIndex: d,
          pageSize: a
        };
      });
    }, e.setPageCount = (r) => e.setPagination((i) => {
      var a;
      let c = lr(r, (a = e.options.pageCount) != null ? a : -1);
      return typeof c == "number" && (c = Math.max(-1, c)), {
        ...i,
        pageCount: c
      };
    }), e.getPageOptions = Oe(() => [e.getPageCount()], (r) => {
      let i = [];
      return r && r > 0 && (i = [...new Array(r)].fill(null).map((a, c) => c)), i;
    }, Ne(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, i = e.getPageCount();
      return i === -1 ? !0 : i === 0 ? !1 : r < i - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, ts = () => ({
  top: [],
  bottom: []
}), dY = {
  getInitialState: (e) => ({
    rowPinning: ts(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: Cn("rowPinning", e)
  }),
  createRow: (e, t) => {
    e.pin = (n, r, i) => {
      const a = r ? e.getLeafRows().map((f) => {
        let {
          id: p
        } = f;
        return p;
      }) : [], c = i ? e.getParentRows().map((f) => {
        let {
          id: p
        } = f;
        return p;
      }) : [], d = /* @__PURE__ */ new Set([...c, e.id, ...a]);
      t.setRowPinning((f) => {
        var p, m;
        if (n === "bottom") {
          var v, g;
          return {
            top: ((v = f == null ? void 0 : f.top) != null ? v : []).filter((b) => !(d != null && d.has(b))),
            bottom: [...((g = f == null ? void 0 : f.bottom) != null ? g : []).filter((b) => !(d != null && d.has(b))), ...Array.from(d)]
          };
        }
        if (n === "top") {
          var w, x;
          return {
            top: [...((w = f == null ? void 0 : f.top) != null ? w : []).filter((b) => !(d != null && d.has(b))), ...Array.from(d)],
            bottom: ((x = f == null ? void 0 : f.bottom) != null ? x : []).filter((b) => !(d != null && d.has(b)))
          };
        }
        return {
          top: ((p = f == null ? void 0 : f.top) != null ? p : []).filter((b) => !(d != null && d.has(b))),
          bottom: ((m = f == null ? void 0 : f.bottom) != null ? m : []).filter((b) => !(d != null && d.has(b)))
        };
      });
    }, e.getCanPin = () => {
      var n;
      const {
        enableRowPinning: r,
        enablePinning: i
      } = t.options;
      return typeof r == "function" ? r(e) : (n = r ?? i) != null ? n : !0;
    }, e.getIsPinned = () => {
      const n = [e.id], {
        top: r,
        bottom: i
      } = t.getState().rowPinning, a = n.some((d) => r == null ? void 0 : r.includes(d)), c = n.some((d) => i == null ? void 0 : i.includes(d));
      return a ? "top" : c ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var n, r;
      const i = e.getIsPinned();
      if (!i) return -1;
      const a = (n = i === "top" ? t.getTopRows() : t.getBottomRows()) == null ? void 0 : n.map((c) => {
        let {
          id: d
        } = c;
        return d;
      });
      return (r = a == null ? void 0 : a.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (t) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(t), e.resetRowPinning = (t) => {
      var n, r;
      return e.setRowPinning(t ? ts() : (n = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? n : ts());
    }, e.getIsSomeRowsPinned = (t) => {
      var n;
      const r = e.getState().rowPinning;
      if (!t) {
        var i, a;
        return !!((i = r.top) != null && i.length || (a = r.bottom) != null && a.length);
      }
      return !!((n = r[t]) != null && n.length);
    }, e._getPinnedRows = (t, n, r) => {
      var i;
      return ((i = e.options.keepPinnedRows) == null || i ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((c) => {
          const d = e.getRow(c, !0);
          return d.getIsAllParentsExpanded() ? d : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((c) => t.find((d) => d.id === c))
      )).filter(Boolean).map((c) => ({
        ...c,
        position: r
      }));
    }, e.getTopRows = Oe(() => [e.getRowModel().rows, e.getState().rowPinning.top], (t, n) => e._getPinnedRows(t, n, "top"), Ne(e.options, "debugRows", "getTopRows")), e.getBottomRows = Oe(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (t, n) => e._getPinnedRows(t, n, "bottom"), Ne(e.options, "debugRows", "getBottomRows")), e.getCenterRows = Oe(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (t, n, r) => {
      const i = /* @__PURE__ */ new Set([...n ?? [], ...r ?? []]);
      return t.filter((a) => !i.has(a.id));
    }, Ne(e.options, "debugRows", "getCenterRows"));
  }
}, uY = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: Cn("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (t) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(t), e.resetRowSelection = (t) => {
      var n;
      return e.setRowSelection(t ? {} : (n = e.initialState.rowSelection) != null ? n : {});
    }, e.toggleAllRowsSelected = (t) => {
      e.setRowSelection((n) => {
        t = typeof t < "u" ? t : !e.getIsAllRowsSelected();
        const r = {
          ...n
        }, i = e.getPreGroupedRowModel().flatRows;
        return t ? i.forEach((a) => {
          a.getCanSelect() && (r[a.id] = !0);
        }) : i.forEach((a) => {
          delete r[a.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (t) => e.setRowSelection((n) => {
      const r = typeof t < "u" ? t : !e.getIsAllPageRowsSelected(), i = {
        ...n
      };
      return e.getRowModel().rows.forEach((a) => {
        ks(i, a.id, r, !0, e);
      }), i;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = Oe(() => [e.getState().rowSelection, e.getCoreRowModel()], (t, n) => Object.keys(t).length ? ns(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Ne(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = Oe(() => [e.getState().rowSelection, e.getFilteredRowModel()], (t, n) => Object.keys(t).length ? ns(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Ne(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = Oe(() => [e.getState().rowSelection, e.getSortedRowModel()], (t, n) => Object.keys(t).length ? ns(e, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Ne(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const t = e.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = e.getState();
      let r = !!(t.length && Object.keys(n).length);
      return r && t.some((i) => i.getCanSelect() && !n[i.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows.filter((i) => i.getCanSelect()), {
        rowSelection: n
      } = e.getState();
      let r = !!t.length;
      return r && t.some((i) => !n[i.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var t;
      const n = Object.keys((t = e.getState().rowSelection) != null ? t : {}).length;
      return n > 0 && n < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const t = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : t.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (t) => {
      e.toggleAllRowsSelected(t.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (t) => {
      e.toggleAllPageRowsSelected(t.target.checked);
    };
  },
  createRow: (e, t) => {
    e.toggleSelected = (n, r) => {
      const i = e.getIsSelected();
      t.setRowSelection((a) => {
        var c;
        if (n = typeof n < "u" ? n : !i, e.getCanSelect() && i === n)
          return a;
        const d = {
          ...a
        };
        return ks(d, e.id, n, (c = r == null ? void 0 : r.selectChildren) != null ? c : !0, t), d;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return a5(e, n);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Ds(e, n) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = t.getState();
      return Ds(e, n) === "all";
    }, e.getCanSelect = () => {
      var n;
      return typeof t.options.enableRowSelection == "function" ? t.options.enableRowSelection(e) : (n = t.options.enableRowSelection) != null ? n : !0;
    }, e.getCanSelectSubRows = () => {
      var n;
      return typeof t.options.enableSubRowSelection == "function" ? t.options.enableSubRowSelection(e) : (n = t.options.enableSubRowSelection) != null ? n : !0;
    }, e.getCanMultiSelect = () => {
      var n;
      return typeof t.options.enableMultiRowSelection == "function" ? t.options.enableMultiRowSelection(e) : (n = t.options.enableMultiRowSelection) != null ? n : !0;
    }, e.getToggleSelectedHandler = () => {
      const n = e.getCanSelect();
      return (r) => {
        var i;
        n && e.toggleSelected((i = r.target) == null ? void 0 : i.checked);
      };
    };
  }
}, ks = (e, t, n, r, i) => {
  var a;
  const c = i.getRow(t, !0);
  n ? (c.getCanMultiSelect() || Object.keys(e).forEach((d) => delete e[d]), c.getCanSelect() && (e[t] = !0)) : delete e[t], r && (a = c.subRows) != null && a.length && c.getCanSelectSubRows() && c.subRows.forEach((d) => ks(e, d.id, n, r, i));
};
function ns(e, t) {
  const n = e.getState().rowSelection, r = [], i = {}, a = function(c, d) {
    return c.map((f) => {
      var p;
      const m = a5(f, n);
      if (m && (r.push(f), i[f.id] = f), (p = f.subRows) != null && p.length && (f = {
        ...f,
        subRows: a(f.subRows)
      }), m)
        return f;
    }).filter(Boolean);
  };
  return {
    rows: a(t.rows),
    flatRows: r,
    rowsById: i
  };
}
function a5(e, t) {
  var n;
  return (n = t[e.id]) != null ? n : !1;
}
function Ds(e, t, n) {
  var r;
  if (!((r = e.subRows) != null && r.length)) return !1;
  let i = !0, a = !1;
  return e.subRows.forEach((c) => {
    if (!(a && !i) && (c.getCanSelect() && (a5(c, t) ? a = !0 : i = !1), c.subRows && c.subRows.length)) {
      const d = Ds(c, t);
      d === "all" ? a = !0 : (d === "some" && (a = !0), i = !1);
    }
  }), i ? "all" : a ? "some" : !1;
}
const Rs = /([0-9]+)/gm, fY = (e, t, n) => Hh(hr(e.getValue(n)).toLowerCase(), hr(t.getValue(n)).toLowerCase()), hY = (e, t, n) => Hh(hr(e.getValue(n)), hr(t.getValue(n))), pY = (e, t, n) => s5(hr(e.getValue(n)).toLowerCase(), hr(t.getValue(n)).toLowerCase()), mY = (e, t, n) => s5(hr(e.getValue(n)), hr(t.getValue(n))), vY = (e, t, n) => {
  const r = e.getValue(n), i = t.getValue(n);
  return r > i ? 1 : r < i ? -1 : 0;
}, gY = (e, t, n) => s5(e.getValue(n), t.getValue(n));
function s5(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function hr(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function Hh(e, t) {
  const n = e.split(Rs).filter(Boolean), r = t.split(Rs).filter(Boolean);
  for (; n.length && r.length; ) {
    const i = n.shift(), a = r.shift(), c = parseInt(i, 10), d = parseInt(a, 10), f = [c, d].sort();
    if (isNaN(f[0])) {
      if (i > a)
        return 1;
      if (a > i)
        return -1;
      continue;
    }
    if (isNaN(f[1]))
      return isNaN(c) ? -1 : 1;
    if (c > d)
      return 1;
    if (d > c)
      return -1;
  }
  return n.length - r.length;
}
const li = {
  alphanumeric: fY,
  alphanumericCaseSensitive: hY,
  text: pY,
  textCaseSensitive: mY,
  datetime: vY,
  basic: gY
}, LY = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: Cn("sorting", e),
    isMultiSortEvent: (t) => t.shiftKey
  }),
  createColumn: (e, t) => {
    e.getAutoSortingFn = () => {
      const n = t.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const i of n) {
        const a = i == null ? void 0 : i.getValue(e.id);
        if (Object.prototype.toString.call(a) === "[object Date]")
          return li.datetime;
        if (typeof a == "string" && (r = !0, a.split(Rs).length > 1))
          return li.alphanumeric;
      }
      return r ? li.text : li.basic;
    }, e.getAutoSortDir = () => {
      const n = t.getFilteredRowModel().flatRows[0];
      return typeof (n == null ? void 0 : n.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var n, r;
      if (!e)
        throw new Error();
      return io(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (n = (r = t.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? n : li[e.columnDef.sortingFn];
    }, e.toggleSorting = (n, r) => {
      const i = e.getNextSortingOrder(), a = typeof n < "u" && n !== null;
      t.setSorting((c) => {
        const d = c == null ? void 0 : c.find((w) => w.id === e.id), f = c == null ? void 0 : c.findIndex((w) => w.id === e.id);
        let p = [], m, v = a ? n : i === "desc";
        if (c != null && c.length && e.getCanMultiSort() && r ? d ? m = "toggle" : m = "add" : c != null && c.length && f !== c.length - 1 ? m = "replace" : d ? m = "toggle" : m = "replace", m === "toggle" && (a || i || (m = "remove")), m === "add") {
          var g;
          p = [...c, {
            id: e.id,
            desc: v
          }], p.splice(0, p.length - ((g = t.options.maxMultiSortColCount) != null ? g : Number.MAX_SAFE_INTEGER));
        } else m === "toggle" ? p = c.map((w) => w.id === e.id ? {
          ...w,
          desc: v
        } : w) : m === "remove" ? p = c.filter((w) => w.id !== e.id) : p = [{
          id: e.id,
          desc: v
        }];
        return p;
      });
    }, e.getFirstSortDir = () => {
      var n, r;
      return ((n = (r = e.columnDef.sortDescFirst) != null ? r : t.options.sortDescFirst) != null ? n : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (n) => {
      var r, i;
      const a = e.getFirstSortDir(), c = e.getIsSorted();
      return c ? c !== a && ((r = t.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(n && (i = t.options.enableMultiRemove) != null) || i) ? !1 : c === "desc" ? "asc" : "desc" : a;
    }, e.getCanSort = () => {
      var n, r;
      return ((n = e.columnDef.enableSorting) != null ? n : !0) && ((r = t.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var n, r;
      return (n = (r = e.columnDef.enableMultiSort) != null ? r : t.options.enableMultiSort) != null ? n : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var n;
      const r = (n = t.getState().sorting) == null ? void 0 : n.find((i) => i.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var n, r;
      return (n = (r = t.getState().sorting) == null ? void 0 : r.findIndex((i) => i.id === e.id)) != null ? n : -1;
    }, e.clearSorting = () => {
      t.setSorting((n) => n != null && n.length ? n.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const n = e.getCanSort();
      return (r) => {
        n && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? t.options.isMultiSortEvent == null ? void 0 : t.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (t) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(t), e.resetSorting = (t) => {
      var n, r;
      e.setSorting(t ? [] : (n = (r = e.initialState) == null ? void 0 : r.sorting) != null ? n : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, wY = [
  IK,
  lY,
  eY,
  tY,
  VK,
  ZK,
  oY,
  //depends on ColumnFaceting
  aY,
  //depends on ColumnFiltering
  LY,
  JK,
  //depends on RowSorting
  sY,
  cY,
  dY,
  uY,
  rY
];
function MY(e) {
  var t, n;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [...wY, ...(t = e._features) != null ? t : []];
  let i = {
    _features: r
  };
  const a = i._features.reduce((g, w) => Object.assign(g, w.getDefaultOptions == null ? void 0 : w.getDefaultOptions(i)), {}), c = (g) => i.options.mergeOptions ? i.options.mergeOptions(a, g) : {
    ...a,
    ...g
  };
  let f = {
    ...{},
    ...(n = e.initialState) != null ? n : {}
  };
  i._features.forEach((g) => {
    var w;
    f = (w = g.getInitialState == null ? void 0 : g.getInitialState(f)) != null ? w : f;
  });
  const p = [];
  let m = !1;
  const v = {
    _features: r,
    options: {
      ...a,
      ...e
    },
    initialState: f,
    _queue: (g) => {
      p.push(g), m || (m = !0, Promise.resolve().then(() => {
        for (; p.length; )
          p.shift()();
        m = !1;
      }).catch((w) => setTimeout(() => {
        throw w;
      })));
    },
    reset: () => {
      i.setState(i.initialState);
    },
    setOptions: (g) => {
      const w = lr(g, i.options);
      i.options = c(w);
    },
    getState: () => i.options.state,
    setState: (g) => {
      i.options.onStateChange == null || i.options.onStateChange(g);
    },
    _getRowId: (g, w, x) => {
      var b;
      return (b = i.options.getRowId == null ? void 0 : i.options.getRowId(g, w, x)) != null ? b : `${x ? [x.id, w].join(".") : w}`;
    },
    getCoreRowModel: () => (i._getCoreRowModel || (i._getCoreRowModel = i.options.getCoreRowModel(i)), i._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => i.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (g, w) => {
      let x = (w ? i.getPrePaginationRowModel() : i.getRowModel()).rowsById[g];
      if (!x && (x = i.getCoreRowModel().rowsById[g], !x))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${g}`) : new Error();
      return x;
    },
    _getDefaultColumnDef: Oe(() => [i.options.defaultColumn], (g) => {
      var w;
      return g = (w = g) != null ? w : {}, {
        header: (x) => {
          const b = x.header.column.columnDef;
          return b.accessorKey ? b.accessorKey : b.accessorFn ? b.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (x) => {
          var b, y;
          return (b = (y = x.renderValue()) == null || y.toString == null ? void 0 : y.toString()) != null ? b : null;
        },
        ...i._features.reduce((x, b) => Object.assign(x, b.getDefaultColumnDef == null ? void 0 : b.getDefaultColumnDef()), {}),
        ...g
      };
    }, Ne(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => i.options.columns,
    getAllColumns: Oe(() => [i._getColumnDefs()], (g) => {
      const w = function(x, b, y) {
        return y === void 0 && (y = 0), x.map((E) => {
          const z = BK(i, E, y, b), k = E;
          return z.columns = k.columns ? w(k.columns, z, y + 1) : [], z;
        });
      };
      return w(g);
    }, Ne(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: Oe(() => [i.getAllColumns()], (g) => g.flatMap((w) => w.getFlatColumns()), Ne(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: Oe(() => [i.getAllFlatColumns()], (g) => g.reduce((w, x) => (w[x.id] = x, w), {}), Ne(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: Oe(() => [i.getAllColumns(), i._getOrderColumnsFn()], (g, w) => {
      let x = g.flatMap((b) => b.getLeafColumns());
      return w(x);
    }, Ne(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (g) => {
      const w = i._getAllFlatColumnsById()[g];
      return process.env.NODE_ENV !== "production" && !w && console.error(`[Table] Column with id '${g}' does not exist.`), w;
    }
  };
  Object.assign(i, v);
  for (let g = 0; g < i._features.length; g++) {
    const w = i._features[g];
    w == null || w.createTable == null || w.createTable(i);
  }
  return i;
}
function xY() {
  return (e) => Oe(() => [e.options.data], (t) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(i, a, c) {
      a === void 0 && (a = 0);
      const d = [];
      for (let p = 0; p < i.length; p++) {
        const m = TK(e, e._getRowId(i[p], p, c), i[p], p, a, void 0, c == null ? void 0 : c.id);
        if (n.flatRows.push(m), n.rowsById[m.id] = m, d.push(m), e.options.getSubRows) {
          var f;
          m.originalSubRows = e.options.getSubRows(i[p], p), (f = m.originalSubRows) != null && f.length && (m.subRows = r(m.originalSubRows, a + 1, m));
        }
      }
      return d;
    };
    return n.rows = r(t), n;
  }, Ne(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function bY(e) {
  const t = [], n = (r) => {
    var i;
    t.push(r), (i = r.subRows) != null && i.length && r.getIsExpanded() && r.subRows.forEach(n);
  };
  return e.rows.forEach(n), {
    rows: t,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function yY(e) {
  return (t) => Oe(() => [t.getState().pagination, t.getPrePaginationRowModel(), t.options.paginateExpandedRows ? void 0 : t.getState().expanded], (n, r) => {
    if (!r.rows.length)
      return r;
    const {
      pageSize: i,
      pageIndex: a
    } = n;
    let {
      rows: c,
      flatRows: d,
      rowsById: f
    } = r;
    const p = i * a, m = p + i;
    c = c.slice(p, m);
    let v;
    t.options.paginateExpandedRows ? v = {
      rows: c,
      flatRows: d,
      rowsById: f
    } : v = bY({
      rows: c,
      flatRows: d,
      rowsById: f
    }), v.flatRows = [];
    const g = (w) => {
      v.flatRows.push(w), w.subRows.length && w.subRows.forEach(g);
    };
    return v.rows.forEach(g), v;
  }, Ne(t.options, "debugTable", "getPaginationRowModel"));
}
function CY() {
  return (e) => Oe(() => [e.getState().sorting, e.getPreSortedRowModel()], (t, n) => {
    if (!n.rows.length || !(t != null && t.length))
      return n;
    const r = e.getState().sorting, i = [], a = r.filter((f) => {
      var p;
      return (p = e.getColumn(f.id)) == null ? void 0 : p.getCanSort();
    }), c = {};
    a.forEach((f) => {
      const p = e.getColumn(f.id);
      p && (c[f.id] = {
        sortUndefined: p.columnDef.sortUndefined,
        invertSorting: p.columnDef.invertSorting,
        sortingFn: p.getSortingFn()
      });
    });
    const d = (f) => {
      const p = f.map((m) => ({
        ...m
      }));
      return p.sort((m, v) => {
        for (let w = 0; w < a.length; w += 1) {
          var g;
          const x = a[w], b = c[x.id], y = b.sortUndefined, E = (g = x == null ? void 0 : x.desc) != null ? g : !1;
          let z = 0;
          if (y) {
            const k = m.getValue(x.id), R = v.getValue(x.id), F = k === void 0, _ = R === void 0;
            if (F || _) {
              if (y === "first") return F ? -1 : 1;
              if (y === "last") return F ? 1 : -1;
              z = F && _ ? 0 : F ? y : -y;
            }
          }
          if (z === 0 && (z = b.sortingFn(m, v, x.id)), z !== 0)
            return E && (z *= -1), b.invertSorting && (z *= -1), z;
        }
        return m.index - v.index;
      }), p.forEach((m) => {
        var v;
        i.push(m), (v = m.subRows) != null && v.length && (m.subRows = d(m.subRows));
      }), p;
    };
    return {
      rows: d(n.rows),
      flatRows: i,
      rowsById: n.rowsById
    };
  }, Ne(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function _s(e, t) {
  return e ? EY(e) ? /* @__PURE__ */ M.createElement(e, t) : e : null;
}
function EY(e) {
  return FY(e) || typeof e == "function" || zY(e);
}
function FY(e) {
  return typeof e == "function" && (() => {
    const t = Object.getPrototypeOf(e);
    return t.prototype && t.prototype.isReactComponent;
  })();
}
function zY(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function AY(e) {
  const t = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [n] = M.useState(() => ({
    current: MY(t)
  })), [r, i] = M.useState(() => n.current.initialState);
  return n.current.setOptions((a) => ({
    ...a,
    ...e,
    state: {
      ...r,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (c) => {
      i(c), e.onStateChange == null || e.onStateChange(c);
    }
  })), n.current;
}
function SY(e) {
  return e ? [{ id: e.id, desc: e.order === "desc" }] : [];
}
function kY(e) {
  if (e.length === 0)
    return console.warn("No sorting applied"), { id: "", order: "asc" };
  {
    const { id: n, desc: r } = e[0];
    return { id: n, order: r ? "desc" : "asc" };
  }
}
const Oh = W(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ u(
    "table",
    {
      ref: n,
      className: S("border-table-body-border w-full table-fixed border text-xs break-words"),
      ...t
    }
  ) })
);
Oh.displayName = "TableRoot";
const Nh = W(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u(
    "thead",
    {
      ref: n,
      className: S("bg-table-header-background text-table-header-text [&_tr]:border-t [&_tr:last-child]:border-b"),
      ...t
    }
  )
);
Nh.displayName = "TableHeader";
const Bh = W(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("tbody", { ref: n, className: S("text-table-body-text [&_tr]:border-t [&_tr:last-child]:border-b"), ...t })
);
Bh.displayName = "TableBody";
const Ih = W(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("tfoot", { ref: n, className: S("bg-table-hover-background text-table-hover-text"), ...t })
);
Ih.displayName = "TableFooter";
const Ci = W(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u(
    "tr",
    {
      ref: n,
      className: S(
        "border-table-body-border text-table-body-text transition-colors",
        "hover:bg-table-hover-background"
      ),
      ...t
    }
  )
);
Ci.displayName = "TableRow";
const Ps = W(
  ({ align: e, width: t, colSpan: n, ...r }, i) => /* @__PURE__ */ u(
    "th",
    {
      ref: i,
      className: S("h-7 px-4 text-left align-middle font-normal", "max-sm:w-32", {
        "text-left": e === "left",
        "text-center": e === "center",
        "text-right": e === "right"
      }),
      style: {
        width: typeof t == "number" ? `${t}px` : t
      },
      colSpan: n,
      ...r
    }
  )
);
Ps.displayName = "TableHead";
const c5 = W(
  ({ align: e, truncate: t, title: n, ...r }, i) => /* @__PURE__ */ u(
    "td",
    {
      ref: i,
      className: S("p-4 align-middle", {
        "text-left": e === "left",
        "text-center": e === "center",
        "text-right": e === "right",
        truncate: t
      }),
      title: n,
      ...r
    }
  )
);
c5.displayName = "TableCell";
const DY = W(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("caption", { ref: n, className: S("text-typography-muted mt-4 text-sm"), ...t })
);
DY.displayName = "TableCaption";
const f6 = (e, t, n) => /* @__PURE__ */ u(Ci, { "data-state": e.getIsSelected() && "selected", onClick: () => t == null ? void 0 : t(e), children: e.getVisibleCells().map((r) => {
  var i, a, c;
  return /* @__PURE__ */ u(
    c5,
    {
      onClick: () => {
        n == null || n(r);
      },
      align: ((i = r.column.columnDef.meta) == null ? void 0 : i.style.textAlign) || "left",
      truncate: (a = r.column.columnDef.meta) == null ? void 0 : a.style.truncate,
      ...(c = r.column.columnDef.meta) != null && c.style.truncate ? { title: r.getValue() } : {},
      children: _s(r.column.columnDef.cell, r.getContext())
    },
    r.id
  );
}) }, e.id), h6 = (e) => /* @__PURE__ */ u(Ci, { children: /* @__PURE__ */ u(c5, { colSpan: e.length, children: "No results." }) }), RY = (e) => ({ column: t, ...n }) => {
  var i;
  const r = t.getIsSorted();
  return /* @__PURE__ */ V(
    "button",
    {
      className: "flex items-center gap-4",
      "data-testid": `sort-${r}`,
      onClick: () => t.toggleSorting(r === "asc"),
      children: [
        /* @__PURE__ */ u(Re, { name: r ? r === "asc" ? "ArrowUp" : "ArrowDown" : "Sort" }),
        typeof e.header == "string" ? e.header : (i = e.header) == null ? void 0 : i.call(e, { column: t, ...n })
      ]
    }
  );
}, _Y = ({
  columns: e,
  data: t,
  footless: n,
  headless: r,
  hidableColumns: i,
  pageSize: a,
  customFooter: c,
  selectableRows: d,
  initialState: f,
  async: p,
  onChange: m,
  onRowClick: v,
  onCellClick: g,
  onRowSelectionChange: w
}) => {
  var _, P;
  const [x, b] = q(SY(f == null ? void 0 : f.sort)), [y, E] = q({}), [z, k] = q({}), R = e.map((O) => ({
    ...O,
    header: O.enableSorting ? RY(O) : O.header
  })), F = AY({
    data: t,
    columns: d ? [
      {
        id: "select",
        header: ({ table: O }) => /* @__PURE__ */ u(
          Rr,
          {
            id: "select-all",
            label: "",
            checked: O.getIsAllPageRowsSelected() ? !0 : O.getIsSomePageRowsSelected() ? "indeterminate" : !1,
            onCheckedChange: (Z) => O.toggleAllPageRowsSelected(!!Z),
            "aria-label": "Select all"
          }
        ),
        cell: ({ row: O }) => /* @__PURE__ */ u(
          Rr,
          {
            id: `select-${O.id}`,
            label: "",
            checked: O.getIsSelected(),
            onCheckedChange: (Z) => O.toggleSelected(!!Z),
            "aria-label": "Select row"
          }
        ),
        enableSorting: !1,
        enableHiding: !1
      },
      ...R
    ] : R,
    getCoreRowModel: xY(),
    getPaginationRowModel: yY(),
    getSortedRowModel: p ? void 0 : CY(),
    onColumnVisibilityChange: E,
    onRowSelectionChange: k,
    onSortingChange: (O) => {
      b(O);
      const Z = typeof O == "function" ? O(x) : O;
      m == null || m({
        sort: kY(Z)
      });
    },
    manualSorting: p,
    state: {
      sorting: x,
      columnVisibility: y,
      rowSelection: z
    }
  });
  return T(() => {
    a ? F.setPageSize(a) : F.setPageSize(t.length);
  }, [t.length, a, F]), T(() => {
    F.getAllColumns().forEach((O) => {
      O.getCanHide() && O.getIsVisible() === !1 && O.toggleVisibility(!0);
    });
  }, [i, F]), T(() => {
    w == null || w(F.getSelectedRowModel().rows);
  }, [z]), /* @__PURE__ */ V(yi, { gap: 16, children: [
    i ? /* @__PURE__ */ u(sr, { x: "end", children: /* @__PURE__ */ V(Il, { children: [
      /* @__PURE__ */ u(Tl, { asChild: !0, children: /* @__PURE__ */ u(E3, { variant: "outline-primary", className: "ml-auto", children: "Columns" }) }),
      /* @__PURE__ */ u(Vl, { align: "end", children: F.getAllColumns().filter((O) => O.getCanHide()).map((O) => /* @__PURE__ */ u(
        Rr,
        {
          id: O.id,
          label: O.id,
          checked: O.getIsVisible(),
          onCheckedChange: (Z) => O.toggleVisibility(!!Z)
        },
        O.id
      )) })
    ] }) }) : null,
    /* @__PURE__ */ V(Oh, { children: [
      r ? null : /* @__PURE__ */ u(Nh, { children: F.getHeaderGroups().map((O) => /* @__PURE__ */ u(Ci, { children: O.headers.map((Z) => {
        var te, Y;
        return /* @__PURE__ */ u(
          Ps,
          {
            align: ((te = Z.column.columnDef.meta) == null ? void 0 : te.style.textAlign) || "left",
            width: (Y = Z.column.columnDef.meta) == null ? void 0 : Y.style.width,
            children: Z.isPlaceholder ? null : _s(Z.column.columnDef.header, Z.getContext())
          },
          Z.id
        );
      }) }, O.id)) }),
      /* @__PURE__ */ u(Bh, { children: a ? (_ = F.getPaginationRowModel().rows) != null && _.length ? F.getPaginationRowModel().rows.map((O) => f6(O, v, g)) : h6(e) : (P = F.getRowModel().rows) != null && P.length ? F.getRowModel().rows.map((O) => f6(O, v, g)) : h6(e) }),
      n ? c : /* @__PURE__ */ u(Ih, { children: F.getFooterGroups().map((O) => /* @__PURE__ */ u(Ci, { children: O.headers.map((Z) => {
        var te, Y;
        return /* @__PURE__ */ u(
          Ps,
          {
            align: ((te = Z.column.columnDef.meta) == null ? void 0 : te.style.textAlign) || "left",
            width: (Y = Z.column.columnDef.meta) == null ? void 0 : Y.style.width,
            children: _s(Z.column.columnDef.footer, Z.getContext())
          },
          Z.id
        );
      }) }, O.id)) })
    ] }),
    a ? /* @__PURE__ */ u("div", { className: S("flex justify-end"), children: /* @__PURE__ */ u(sh, { children: /* @__PURE__ */ V(ch, { children: [
      /* @__PURE__ */ u(X0, { children: /* @__PURE__ */ u(uh, { onClick: () => F.previousPage(), disabled: !F.getCanPreviousPage() }) }),
      F.getPageOptions().map((O) => O < 1 || O > F.getPageCount() - 2 || O === F.getState().pagination.pageIndex || O === F.getState().pagination.pageIndex + 1 || O === F.getState().pagination.pageIndex - 1 ? /* @__PURE__ */ u(X0, { children: /* @__PURE__ */ u(
        dh,
        {
          className: "cursor-pointer",
          onClick: () => F.setPageIndex(O),
          active: F.getState().pagination.pageIndex === O,
          children: O + 1
        }
      ) }, O) : O === F.getState().pagination.pageIndex - 2 || O === F.getState().pagination.pageIndex + 2 ? /* @__PURE__ */ u(hh, {}, O) : null),
      /* @__PURE__ */ u(X0, { children: /* @__PURE__ */ u(fh, { onClick: () => F.nextPage(), disabled: !F.getCanNextPage() }) })
    ] }) }) }) : null
  ] });
};
_Y.displayName = "Table";
var lo = "Tabs", [PY, wX] = Tt(lo, [
  k1
]), Th = k1(), [HY, d5] = PY(lo), Vh = M.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: i,
      defaultValue: a,
      orientation: c = "horizontal",
      dir: d,
      activationMode: f = "automatic",
      ...p
    } = e, m = Fi(d), [v, g] = Kt({
      prop: r,
      onChange: i,
      defaultProp: a ?? "",
      caller: lo
    });
    return /* @__PURE__ */ u(
      HY,
      {
        scope: n,
        baseId: xn(),
        value: v,
        onValueChange: g,
        orientation: c,
        dir: m,
        activationMode: f,
        children: /* @__PURE__ */ u(
          ke.div,
          {
            dir: m,
            "data-orientation": c,
            ...p,
            ref: t
          }
        )
      }
    );
  }
);
Vh.displayName = lo;
var Zh = "TabsList", $h = M.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...i } = e, a = d5(Zh, n), c = Th(n);
    return /* @__PURE__ */ u(
      f3,
      {
        asChild: !0,
        ...c,
        orientation: a.orientation,
        dir: a.dir,
        loop: r,
        children: /* @__PURE__ */ u(
          ke.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...i,
            ref: t
          }
        )
      }
    );
  }
);
$h.displayName = Zh;
var Wh = "TabsTrigger", Gh = M.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: i = !1, ...a } = e, c = d5(Wh, n), d = Th(n), f = Kh(c.baseId, r), p = Yh(c.baseId, r), m = r === c.value;
    return /* @__PURE__ */ u(
      h3,
      {
        asChild: !0,
        ...d,
        focusable: !i,
        active: m,
        children: /* @__PURE__ */ u(
          ke.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": m,
            "aria-controls": p,
            "data-state": m ? "active" : "inactive",
            "data-disabled": i ? "" : void 0,
            disabled: i,
            id: f,
            ...a,
            ref: t,
            onMouseDown: be(e.onMouseDown, (v) => {
              !i && v.button === 0 && v.ctrlKey === !1 ? c.onValueChange(r) : v.preventDefault();
            }),
            onKeyDown: be(e.onKeyDown, (v) => {
              [" ", "Enter"].includes(v.key) && c.onValueChange(r);
            }),
            onFocus: be(e.onFocus, () => {
              const v = c.activationMode !== "manual";
              !m && !i && v && c.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
Gh.displayName = Wh;
var Uh = "TabsContent", jh = M.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: i, children: a, ...c } = e, d = d5(Uh, n), f = Kh(d.baseId, r), p = Yh(d.baseId, r), m = r === d.value, v = M.useRef(m);
    return M.useEffect(() => {
      const g = requestAnimationFrame(() => v.current = !1);
      return () => cancelAnimationFrame(g);
    }, []), /* @__PURE__ */ u(Yt, { present: i || m, children: ({ present: g }) => /* @__PURE__ */ u(
      ke.div,
      {
        "data-state": m ? "active" : "inactive",
        "data-orientation": d.orientation,
        role: "tabpanel",
        "aria-labelledby": f,
        hidden: !g,
        id: p,
        tabIndex: 0,
        ...c,
        ref: t,
        style: {
          ...e.style,
          animationDuration: v.current ? "0s" : void 0
        },
        children: g && a
      }
    ) });
  }
);
jh.displayName = Uh;
function Kh(e, t) {
  return `${e}-trigger-${t}`;
}
function Yh(e, t) {
  return `${e}-content-${t}`;
}
var OY = Vh, NY = $h, BY = Gh, IY = jh;
const TY = OY;
TY.displayName = "Tabs";
const VY = W(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  NY,
  {
    ref: n,
    className: S("text-typography-muted border-tabs-default-border flex items-center gap-16 border-b"),
    ...t
  }
));
VY.displayName = "TabsList";
const ZY = W(
  ({ className: e, icon: t, children: n, ...r }, i) => /* @__PURE__ */ V(
    BY,
    {
      ref: i,
      className: S(
        "group",
        "ring-offset-background text-tabs-default-typography relative flex inline-flex h-11 items-center justify-center gap-4 py-3 text-sm font-medium whitespace-nowrap transition-all",
        "hover:text-tabs-hover-typography",
        "focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden",
        {
          "disabled:border-tabs-disabled-border disabled:text-tabs-disabled-typography disabled:pointer-events-none": r.disabled
        },
        "data-[state=active]:text-tabs-active-typography",
        "data-[state=active]:after:bg-tabs-active-border data-[state=active]:after:absolute data-[state=active]:after:-bottom-px data-[state=active]:after:h-0.5 data-[state=active]:after:w-full data-[state=active]:after:rounded-sm"
      ),
      ...r,
      children: [
        t ? /* @__PURE__ */ u(
          "div",
          {
            className: S(
              "text-tabs-default-icon flex",
              "group-hover:text-tabs-hover-icon",
              {
                "text-tabs-disabled-typography": r.disabled
              },
              "group-data-[state=active]:text-tabs-active-icon"
            ),
            children: /* @__PURE__ */ u(Re, { name: t })
          }
        ) : null,
        /* @__PURE__ */ u("div", { children: n })
      ]
    }
  )
);
ZY.displayName = "TabsTrigger";
const $Y = W(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  IY,
  {
    ref: n,
    className: S(
      "ring-offset-background focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden"
    ),
    ...t
  }
));
$Y.displayName = "TabsContent";
const WY = "hover:bg-select-hover-background hover:border-select-hover-border  hover:[&>input]:bg-select-hover-background hover:[&>input]:border-none hover:[&>input]:placeholder:text-select-hover-placeholder", GY = "focus-visible:[&>input]:outline-hidden focus-visible:border-select-active-border focus:bg-select-active-background focus:[&>input]:bg-select-active-background", UY = W(
  ({ id: e, label: t, placeholder: n, hint: r, disabled: i, required: a, values: c, defaultValues: d, onChange: f, state: p }, m) => {
    const v = c != null, [g, w] = q(d ?? []), [x, b] = q(""), y = v ? c : g, E = (Y) => {
      i || (v || w(Y), f == null || f(Y));
    }, z = (Y) => {
      const X = Y.target.value;
      i || (X.includes(",") ? F(X) : b(X));
    }, k = (Y) => {
      switch (Y.key) {
        case "Enter":
          Y.preventDefault(), _(x);
          break;
        case "Backspace":
          !x && y.length && P(y.length - 1);
          break;
      }
    }, R = () => {
      _(x);
    }, F = (Y) => {
      if (i) return;
      const X = Y.split(",").map((re) => re.trim()).filter((re) => !(!re || y.includes(re)));
      X.length && (E([...y, ...X]), b(""));
    }, _ = (Y) => {
      if (i) return;
      const X = Y.trim();
      X && (y.includes(X) || (E([...y, X]), b("")));
    }, P = (Y) => {
      if (i || Y < 0 || Y >= y.length) return;
      const X = y.filter((re, ee) => ee !== Y);
      E(X);
    }, O = () => {
      i || E([]);
    }, Z = bl(), te = e ?? Z;
    return /* @__PURE__ */ V("div", { className: "flex flex-col gap-2", children: [
      t ? /* @__PURE__ */ u(jn, { htmlFor: te, required: a, children: t }) : null,
      /* @__PURE__ */ V(
        "div",
        {
          role: "group",
          "aria-label": t || "Tags input",
          "aria-disabled": i,
          "aria-required": a,
          className: S(
            "border-textarea-default-border bg-textarea-default-background [&>input]:placeholder:text-tagsinput-default-text flex w-full items-center justify-between gap-8 rounded-md border px-2 text-sm shadow-xs transition-colors",
            {
              "bg-select-disabled-background [&>input]:bg-select-disabled-background border-select-disabled-border text-select-disabled-typography text-select-disabled-text [&>input]:cursor-not-allowed": i,
              "bg-select-negative-background border-select-negative-border text-select-negative-text focus-visible:text-select-negative-text [&>input]:placeholder:text-select-negative-text": p === "negative"
            },
            WY,
            GY
          ),
          children: [
            y == null ? void 0 : y.map((Y, X) => /* @__PURE__ */ u(U3, { label: Y, onRemove: () => P(X), disabled: i, role: "option" }, X)),
            /* @__PURE__ */ u(
              "input",
              {
                id: te,
                ref: m,
                value: x,
                onKeyDown: k,
                onChange: z,
                className: S("w-full py-1 pr-2 text-sm"),
                placeholder: n,
                disabled: i,
                required: a,
                onBlur: R
              }
            ),
            !i && y.length > 0 && /* @__PURE__ */ u(
              V3,
              {
                onClick: O,
                icon: "Close",
                label: "Clear all tags",
                color: p === "negative" ? "negative" : "muted",
                size: "xs"
              }
            )
          ]
        }
      ),
      r && /* @__PURE__ */ u(
        "div",
        {
          className: S("text-hint-default-text text-xs", {
            "text-hint-negative-text": p === "negative"
          }),
          children: r
        }
      )
    ] });
  }
);
UY.displayName = "TagsInput";
const jY = "hover:bg-textarea-hover-background hover:border-textarea-hover-border hover:placeholder:text-textarea-hover-placeholder", KY = "focus-visible:outline-hidden focus-visible:border-textarea-active-border", YY = "disabled:cursor-not-allowed disabled:bg-textarea-disabled-background disabled:border-textarea-disabled-border disabled:text-textarea-disabled-typography hover:placeholder:text-textarea-disabled-placeholder", qY = W(
  ({
    id: e,
    value: t,
    state: n,
    hint: r,
    label: i,
    placeholder: a,
    disabled: c,
    required: d,
    maxLength: f,
    actions: p,
    onChange: m,
    ...v
  }, g) => {
    const w = bl(), x = e ?? w;
    return /* @__PURE__ */ V("div", { className: "flex flex-col gap-2", children: [
      i ? /* @__PURE__ */ u(jn, { htmlFor: x, required: d, children: i }) : null,
      /* @__PURE__ */ V("div", { className: S("relative w-full"), children: [
        /* @__PURE__ */ u("div", { className: S("w-full"), children: /* @__PURE__ */ u(
          "textarea",
          {
            ...v,
            id: x,
            "aria-label": i,
            className: S(
              "border-textarea-default-border resize-vertical bg-textarea-default-background flex h-16 min-h-16 w-full rounded-md border px-3 py-2 text-sm shadow-xs transition-colors",
              "placeholder:text-textarea-default-placeholder",
              jY,
              KY,
              YY,
              {
                "text-textarea-negative-typography border-textarea-negative-border bg-textarea-negative-background placeholder:text-textarea-negative-typography focus-visible:border-textarea-negative-border focus-visible:ring-textarea-negative-border": n === "negative",
                "h-20 pr-32": p
              }
            ),
            placeholder: a,
            disabled: c,
            required: d,
            ref: g,
            rows: 10,
            cols: 10,
            maxLength: f,
            value: t,
            onChange: m
          }
        ) }),
        p ? /* @__PURE__ */ u("div", { className: S("absolute right-2 bottom-2 flex gap-8"), children: p }) : null
      ] }),
      r && /* @__PURE__ */ u(
        "div",
        {
          className: S("text-hint-default-text text-xs", {
            "text-hint-negative-text": n === "negative"
          }),
          children: r
        }
      )
    ] });
  }
);
qY.displayName = "TextArea";
const XY = "hover:bg-textfield-hover-background hover:border-textfield-hover-border hover:placeholder:text-textfield-hover-placeholder", rs = "focus-visible:outline-hidden focus-visible:border-textfield-active-border", is = "disabled:cursor-not-allowed disabled:bg-textfield-disabled-background disabled:border-textfield-disabled-border disabled:text-textfield-disabled-typography hover:placeholder:text-textfield-disabled-placeholder", JY = W(
  ({ className: e, before: t, after: n, type: r, state: i, hint: a, label: c, disabled: d, ...f }, p) => {
    const m = bl(), v = f.id ?? m;
    return /* @__PURE__ */ V("div", { className: "flex flex-col gap-2", children: [
      c && /* @__PURE__ */ u(jn, { htmlFor: v, required: f.required, children: c }),
      /* @__PURE__ */ V("div", { className: S("relative w-full"), children: [
        t ? /* @__PURE__ */ u(
          "div",
          {
            className: S("absolute top-1/2 left-2 flex -translate-y-1/2 transform", rs, is, {
              "text-textfield-negative-typography": i === "negative"
            }),
            children: /* @__PURE__ */ u(Re, { size: "xs", name: t })
          }
        ) : null,
        /* @__PURE__ */ u(
          "input",
          {
            "aria-label": c,
            type: r,
            className: S(
              "border-textfield-default-border bg-textfield-default-background flex inline-flex h-8 w-full items-center justify-center rounded-md border px-3 py-1 text-sm tracking-tight whitespace-nowrap shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium",
              "placeholder:text-textfield-default-placeholder",
              XY,
              rs,
              is,
              {
                "pl-6": t,
                "pr-6": i || n,
                "pr-10": i && n,
                "text-textfield-negative-typography border-textfield-negative-border bg-textfield-negative-background placeholder:text-textfield-negative-typography focus-visible:border-textfield-negative-border focus-visible:ring-textfield-negative-border": i === "negative"
              }
            ),
            disabled: d,
            ref: p,
            ...f,
            id: v,
            ...f.autoComplete ? {} : { "data-1p-ignore": !0 }
          }
        ),
        i || n ? /* @__PURE__ */ V(
          "div",
          {
            className: S(
              "absolute top-1/2 right-2 flex -translate-y-1/2 transform gap-4",
              rs,
              is,
              {
                "text-textfield-negative-typography": i === "negative"
              }
            ),
            children: [
              i ? /* @__PURE__ */ u(Re, { size: "xs", name: "Warning" }) : null,
              n ? /* @__PURE__ */ u(Re, { size: "xs", name: n }) : null
            ]
          }
        ) : null
      ] }),
      a && /* @__PURE__ */ u(
        "div",
        {
          className: S("text-hint-default-text text-xs", {
            "text-hint-negative-text": i === "negative"
          }),
          children: a
        }
      )
    ] });
  }
);
JY.displayName = "TextField";
var u5 = "ToastProvider", [f5, QY, eq] = El("Toast"), [qh, MX] = Tt("Toast", [eq]), [tq, oo] = qh(u5), Xh = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: i = "right",
    swipeThreshold: a = 50,
    children: c
  } = e, [d, f] = M.useState(null), [p, m] = M.useState(0), v = M.useRef(!1), g = M.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${u5}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ u(f5.Provider, { scope: t, children: /* @__PURE__ */ u(
    tq,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: i,
      swipeThreshold: a,
      toastCount: p,
      viewport: d,
      onViewportChange: f,
      onToastAdd: M.useCallback(() => m((w) => w + 1), []),
      onToastRemove: M.useCallback(() => m((w) => w - 1), []),
      isFocusedToastEscapeKeyDownRef: v,
      isClosePausedRef: g,
      children: c
    }
  ) });
};
Xh.displayName = u5;
var Jh = "ToastViewport", nq = ["F8"], Hs = "toast.viewportPause", Os = "toast.viewportResume", Qh = M.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: r = nq,
      label: i = "Notifications ({hotkey})",
      ...a
    } = e, c = oo(Jh, n), d = QY(n), f = M.useRef(null), p = M.useRef(null), m = M.useRef(null), v = M.useRef(null), g = ct(t, v, c.onViewportChange), w = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), x = c.toastCount > 0;
    M.useEffect(() => {
      const y = (E) => {
        var k;
        r.length !== 0 && r.every((R) => E[R] || E.code === R) && ((k = v.current) == null || k.focus());
      };
      return document.addEventListener("keydown", y), () => document.removeEventListener("keydown", y);
    }, [r]), M.useEffect(() => {
      const y = f.current, E = v.current;
      if (x && y && E) {
        const z = () => {
          if (!c.isClosePausedRef.current) {
            const _ = new CustomEvent(Hs);
            E.dispatchEvent(_), c.isClosePausedRef.current = !0;
          }
        }, k = () => {
          if (c.isClosePausedRef.current) {
            const _ = new CustomEvent(Os);
            E.dispatchEvent(_), c.isClosePausedRef.current = !1;
          }
        }, R = (_) => {
          !y.contains(_.relatedTarget) && k();
        }, F = () => {
          y.contains(document.activeElement) || k();
        };
        return y.addEventListener("focusin", z), y.addEventListener("focusout", R), y.addEventListener("pointermove", z), y.addEventListener("pointerleave", F), window.addEventListener("blur", z), window.addEventListener("focus", k), () => {
          y.removeEventListener("focusin", z), y.removeEventListener("focusout", R), y.removeEventListener("pointermove", z), y.removeEventListener("pointerleave", F), window.removeEventListener("blur", z), window.removeEventListener("focus", k);
        };
      }
    }, [x, c.isClosePausedRef]);
    const b = M.useCallback(
      ({ tabbingDirection: y }) => {
        const z = d().map((k) => {
          const R = k.ref.current, F = [R, ...vq(R)];
          return y === "forwards" ? F : F.reverse();
        });
        return (y === "forwards" ? z.reverse() : z).flat();
      },
      [d]
    );
    return M.useEffect(() => {
      const y = v.current;
      if (y) {
        const E = (z) => {
          var F, _, P;
          const k = z.altKey || z.ctrlKey || z.metaKey;
          if (z.key === "Tab" && !k) {
            const O = document.activeElement, Z = z.shiftKey;
            if (z.target === y && Z) {
              (F = p.current) == null || F.focus();
              return;
            }
            const X = b({ tabbingDirection: Z ? "backwards" : "forwards" }), re = X.findIndex((ee) => ee === O);
            ls(X.slice(re + 1)) ? z.preventDefault() : Z ? (_ = p.current) == null || _.focus() : (P = m.current) == null || P.focus();
          }
        };
        return y.addEventListener("keydown", E), () => y.removeEventListener("keydown", E);
      }
    }, [d, b]), /* @__PURE__ */ V(
      DE,
      {
        ref: f,
        role: "region",
        "aria-label": i.replace("{hotkey}", w),
        tabIndex: -1,
        style: { pointerEvents: x ? void 0 : "none" },
        children: [
          x && /* @__PURE__ */ u(
            Ns,
            {
              ref: p,
              onFocusFromOutsideViewport: () => {
                const y = b({
                  tabbingDirection: "forwards"
                });
                ls(y);
              }
            }
          ),
          /* @__PURE__ */ u(f5.Slot, { scope: n, children: /* @__PURE__ */ u(ke.ol, { tabIndex: -1, ...a, ref: g }) }),
          x && /* @__PURE__ */ u(
            Ns,
            {
              ref: m,
              onFocusFromOutsideViewport: () => {
                const y = b({
                  tabbingDirection: "backwards"
                });
                ls(y);
              }
            }
          )
        ]
      }
    );
  }
);
Qh.displayName = Jh;
var ep = "ToastFocusProxy", Ns = M.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...i } = e, a = oo(ep, n);
    return /* @__PURE__ */ u(
      Zl,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...i,
        ref: t,
        style: { position: "fixed" },
        onFocus: (c) => {
          var p;
          const d = c.relatedTarget;
          !((p = a.viewport) != null && p.contains(d)) && r();
        }
      }
    );
  }
);
Ns.displayName = ep;
var Ii = "Toast", rq = "toast.swipeStart", iq = "toast.swipeMove", lq = "toast.swipeCancel", oq = "toast.swipeEnd", tp = M.forwardRef(
  (e, t) => {
    const { forceMount: n, open: r, defaultOpen: i, onOpenChange: a, ...c } = e, [d, f] = Kt({
      prop: r,
      defaultProp: i ?? !0,
      onChange: a,
      caller: Ii
    });
    return /* @__PURE__ */ u(Yt, { present: n || d, children: /* @__PURE__ */ u(
      cq,
      {
        open: d,
        ...c,
        ref: t,
        onClose: () => f(!1),
        onPause: tn(e.onPause),
        onResume: tn(e.onResume),
        onSwipeStart: be(e.onSwipeStart, (p) => {
          p.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: be(e.onSwipeMove, (p) => {
          const { x: m, y: v } = p.detail.delta;
          p.currentTarget.setAttribute("data-swipe", "move"), p.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${m}px`), p.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${v}px`);
        }),
        onSwipeCancel: be(e.onSwipeCancel, (p) => {
          p.currentTarget.setAttribute("data-swipe", "cancel"), p.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), p.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), p.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), p.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: be(e.onSwipeEnd, (p) => {
          const { x: m, y: v } = p.detail.delta;
          p.currentTarget.setAttribute("data-swipe", "end"), p.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), p.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), p.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${m}px`), p.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${v}px`), f(!1);
        })
      }
    ) });
  }
);
tp.displayName = Ii;
var [aq, sq] = qh(Ii, {
  onClose() {
  }
}), cq = M.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: i,
      open: a,
      onClose: c,
      onEscapeKeyDown: d,
      onPause: f,
      onResume: p,
      onSwipeStart: m,
      onSwipeMove: v,
      onSwipeCancel: g,
      onSwipeEnd: w,
      ...x
    } = e, b = oo(Ii, n), [y, E] = M.useState(null), z = ct(t, (ee) => E(ee)), k = M.useRef(null), R = M.useRef(null), F = i || b.duration, _ = M.useRef(0), P = M.useRef(F), O = M.useRef(0), { onToastAdd: Z, onToastRemove: te } = b, Y = tn(() => {
      var de;
      (y == null ? void 0 : y.contains(document.activeElement)) && ((de = b.viewport) == null || de.focus()), c();
    }), X = M.useCallback(
      (ee) => {
        !ee || ee === 1 / 0 || (window.clearTimeout(O.current), _.current = (/* @__PURE__ */ new Date()).getTime(), O.current = window.setTimeout(Y, ee));
      },
      [Y]
    );
    M.useEffect(() => {
      const ee = b.viewport;
      if (ee) {
        const de = () => {
          X(P.current), p == null || p();
        }, ae = () => {
          const ge = (/* @__PURE__ */ new Date()).getTime() - _.current;
          P.current = P.current - ge, window.clearTimeout(O.current), f == null || f();
        };
        return ee.addEventListener(Hs, ae), ee.addEventListener(Os, de), () => {
          ee.removeEventListener(Hs, ae), ee.removeEventListener(Os, de);
        };
      }
    }, [b.viewport, F, f, p, X]), M.useEffect(() => {
      a && !b.isClosePausedRef.current && X(F);
    }, [a, F, b.isClosePausedRef, X]), M.useEffect(() => (Z(), () => te()), [Z, te]);
    const re = M.useMemo(() => y ? ap(y) : null, [y]);
    return b.viewport ? /* @__PURE__ */ V(me, { children: [
      re && /* @__PURE__ */ u(
        dq,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: re
        }
      ),
      /* @__PURE__ */ u(aq, { scope: n, onClose: Y, children: b1.createPortal(
        /* @__PURE__ */ u(f5.ItemSlot, { scope: n, children: /* @__PURE__ */ u(
          kE,
          {
            asChild: !0,
            onEscapeKeyDown: be(d, () => {
              b.isFocusedToastEscapeKeyDownRef.current || Y(), b.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ u(
              ke.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": a ? "open" : "closed",
                "data-swipe-direction": b.swipeDirection,
                ...x,
                ref: z,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: be(e.onKeyDown, (ee) => {
                  ee.key === "Escape" && (d == null || d(ee.nativeEvent), ee.nativeEvent.defaultPrevented || (b.isFocusedToastEscapeKeyDownRef.current = !0, Y()));
                }),
                onPointerDown: be(e.onPointerDown, (ee) => {
                  ee.button === 0 && (k.current = { x: ee.clientX, y: ee.clientY });
                }),
                onPointerMove: be(e.onPointerMove, (ee) => {
                  if (!k.current) return;
                  const de = ee.clientX - k.current.x, ae = ee.clientY - k.current.y, ge = !!R.current, K = ["left", "right"].includes(b.swipeDirection), J = ["left", "up"].includes(b.swipeDirection) ? Math.min : Math.max, he = K ? J(0, de) : 0, ve = K ? 0 : J(0, ae), Q = ee.pointerType === "touch" ? 10 : 2, ie = { x: he, y: ve }, pe = { originalEvent: ee, delta: ie };
                  ge ? (R.current = ie, j0(iq, v, pe, {
                    discrete: !1
                  })) : p6(ie, b.swipeDirection, Q) ? (R.current = ie, j0(rq, m, pe, {
                    discrete: !1
                  }), ee.target.setPointerCapture(ee.pointerId)) : (Math.abs(de) > Q || Math.abs(ae) > Q) && (k.current = null);
                }),
                onPointerUp: be(e.onPointerUp, (ee) => {
                  const de = R.current, ae = ee.target;
                  if (ae.hasPointerCapture(ee.pointerId) && ae.releasePointerCapture(ee.pointerId), R.current = null, k.current = null, de) {
                    const ge = ee.currentTarget, K = { originalEvent: ee, delta: de };
                    p6(de, b.swipeDirection, b.swipeThreshold) ? j0(oq, w, K, {
                      discrete: !0
                    }) : j0(
                      lq,
                      g,
                      K,
                      {
                        discrete: !0
                      }
                    ), ge.addEventListener("click", (J) => J.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        b.viewport
      ) })
    ] }) : null;
  }
), dq = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, i = oo(Ii, t), [a, c] = M.useState(!1), [d, f] = M.useState(!1);
  return pq(() => c(!0)), M.useEffect(() => {
    const p = window.setTimeout(() => f(!0), 1e3);
    return () => window.clearTimeout(p);
  }, []), d ? null : /* @__PURE__ */ u(S1, { asChild: !0, children: /* @__PURE__ */ u(Zl, { ...r, children: a && /* @__PURE__ */ V(me, { children: [
    i.label,
    " ",
    n
  ] }) }) });
}, uq = "ToastTitle", np = M.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ u(ke.div, { ...r, ref: t });
  }
);
np.displayName = uq;
var fq = "ToastDescription", rp = M.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ u(ke.div, { ...r, ref: t });
  }
);
rp.displayName = fq;
var ip = "ToastAction", hq = M.forwardRef(
  (e, t) => {
    const { altText: n, ...r } = e;
    return n.trim() ? /* @__PURE__ */ u(op, { altText: n, asChild: !0, children: /* @__PURE__ */ u(h5, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${ip}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
hq.displayName = ip;
var lp = "ToastClose", h5 = M.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e, i = sq(lp, n);
    return /* @__PURE__ */ u(op, { asChild: !0, children: /* @__PURE__ */ u(
      ke.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: be(e.onClick, i.onClose)
      }
    ) });
  }
);
h5.displayName = lp;
var op = M.forwardRef((e, t) => {
  const { __scopeToast: n, altText: r, ...i } = e;
  return /* @__PURE__ */ u(
    ke.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...i,
      ref: t
    }
  );
});
function ap(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), mq(r)) {
      const i = r.ariaHidden || r.hidden || r.style.display === "none", a = r.dataset.radixToastAnnounceExclude === "";
      if (!i)
        if (a) {
          const c = r.dataset.radixToastAnnounceAlt;
          c && t.push(c);
        } else
          t.push(...ap(r));
    }
  }), t;
}
function j0(e, t, n, { discrete: r }) {
  const i = n.originalEvent.currentTarget, a = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? Ts(i, a) : i.dispatchEvent(a);
}
var p6 = (e, t, n = 0) => {
  const r = Math.abs(e.x), i = Math.abs(e.y), a = r > i;
  return t === "left" || t === "right" ? a && r > n : !a && i > n;
};
function pq(e = () => {
}) {
  const t = tn(e);
  yn(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function mq(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function vq(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function ls(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var gq = Xh, Lq = Qh, wq = tp, Mq = np, xq = rp, bq = h5;
const yq = Ye(S("group relative flex max-w-96 rounded-md border px-6 py-4 text-sm"), {
  variants: {
    variant: {
      muted: "bg-toast-muted-background border-toast-muted-border text-toast-muted-text",
      primary: "bg-toast-primary-background border-toast-primary-border text-toast-primary-text",
      negative: "bg-toast-negative-background border-toast-negative-border text-toast-negative-text",
      warning: "bg-toast-warning-background border-toast-warning-border text-toast-warning-text",
      positive: "bg-toast-success-background border-toast-success-border text-toast-success-text"
    }
  },
  defaultVariants: {
    variant: "muted"
  }
}), Cq = Ye("truncate", {
  variants: {
    variant: {
      muted: "text-toast-muted-title",
      primary: "text-toast-primary-title",
      negative: "text-toast-negative-title",
      warning: "text-toast-warning-title",
      positive: "text-toast-success-title"
    }
  },
  defaultVariants: {
    variant: "muted"
  }
}), Eq = Ye("text-xs truncate", {
  variants: {
    variant: {
      muted: "text-toast-muted-description",
      primary: "text-toast-primary-description",
      negative: "text-toast-negative-description",
      warning: "text-toast-warning-description",
      positive: "text-toast-success-description"
    }
  },
  defaultVariants: {
    variant: "muted"
  }
}), Fq = Ye(
  S(
    "flex mt-0.5 shrink-0",
    "absolute right-2 top-2 flex cursor-pointer opacity-0 transition-all",
    "focus-visible:ring-ring focus-visible:outline-hidden focus-visible:ring-2",
    "group-hover:text-toast-hover-icon group-hover:opacity-100",
    "group-focus-visible:opacity-100",
    "focus-visible:opacity-100"
  ),
  {
    variants: {
      variant: {
        muted: "text-toast-muted-icon",
        primary: "text-toast-primary-icon",
        negative: "text-toast-negative-icon",
        warning: "text-toast-warning-icon",
        positive: "text-toast-success-icon"
      }
    },
    defaultVariants: {
      variant: "muted"
    }
  }
), sp = ({
  variant: e,
  duration: t,
  open: n,
  title: r,
  description: i,
  action: a,
  onOpenChange: c,
  ...d
}) => /* @__PURE__ */ V(
  wq,
  {
    className: S(yq({ variant: e })),
    duration: t,
    open: n,
    onOpenChange: c,
    ...d,
    children: [
      /* @__PURE__ */ V("div", { className: S("flex max-w-64 min-w-0 gap-24", "md:max-w-96"), children: [
        /* @__PURE__ */ V("div", { className: S("flex min-w-0 flex-col gap-2"), children: [
          /* @__PURE__ */ u(Mq, { className: S(Cq({ variant: e })), children: r }),
          i ? /* @__PURE__ */ u(xq, { className: S(Eq({ variant: e })), children: i }) : null
        ] }),
        /* @__PURE__ */ u("div", { className: S("self-center"), children: a })
      ] }),
      /* @__PURE__ */ u(bq, { asChild: !0, children: /* @__PURE__ */ u("button", { className: S(Fq({ variant: e })), children: /* @__PURE__ */ u(Re, { name: "Close", size: "xs" }) }) })
    ]
  }
);
sp.displayName = "Toast";
const cp = O2(() => {
}), zq = ({ duration: e = 5e3, children: t }) => {
  const [n, r] = q([]), i = Ft((a) => {
    r((c) => [
      ...c,
      {
        id: String(Date.now()),
        props: a
      }
    ]);
  }, []);
  return /* @__PURE__ */ V(gq, { duration: e, swipeDirection: "right", children: [
    /* @__PURE__ */ V(cp.Provider, { value: i, children: [
      n.map(({ id: a, props: c }) => /* @__PURE__ */ u(
        sp,
        {
          ...c,
          open: !0,
          onOpenChange: (d) => {
            d || r((f) => f.filter((p) => p.id !== a));
          }
        },
        a
      )),
      t
    ] }),
    /* @__PURE__ */ u(
      Lq,
      {
        className: S("fixed right-0 bottom-0 left-0 z-20 m-0 flex flex-col items-center gap-4 p-6")
      }
    )
  ] });
};
zq.displayName = "ToastProvider";
const xX = () => pt(cp), dp = Ye(
  S(
    "bg-toggle-default-background text-toggle-default-icon border border-toggle-default-border flex items-center justify-center rounded-md text-sm transition-colors",
    "disabled:pointer-events-none disabled:opacity-50",
    "hover:bg-toggle-hover-background hover:text-toggle-hover-icon hover:border-toggle-hover-border",
    "data-[state=on]:bg-toggle-selected-background data-[state=on]:text-toggle-selected-icon data-[state=on]:border-toggle-selected-border"
  ),
  {
    variants: {
      /**
       * The size of the avatar consist of 4 sizes: sm, md, lg, xl
       * @default md
       * @type 'xs' |'sm' | 'md' | 'lg'
       **/
      size: {
        xs: "h-4 w-4",
        sm: "h-6 w-6",
        md: "h-8 w-8",
        lg: "h-10 w-10"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), Aq = W(
  ({ className: e, size: t, ...n }, r) => /* @__PURE__ */ u(qR, { ref: r, ...n, className: S(dp({ size: t })) })
);
Aq.displayName = "Toggle";
const Sq = W(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ u(
    M9,
    {
      ref: r,
      className: S("flex items-center justify-center"),
      ...n,
      orientation: "horizontal",
      children: t
    }
  )
);
Sq.displayName = "ToggleGroup";
const kq = W(
  ({ size: e, ...t }, n) => /* @__PURE__ */ u(
    x9,
    {
      ref: n,
      className: S(
        dp({ size: e }),
        "rounded-none",
        "[&:not(:first-child)]:border-l-0",
        "first:rounded-s-md",
        "last:rounded-e-md"
      ),
      ...t
    }
  )
);
kq.displayName = "ToggleGroupItem";
const Dq = W((e, t) => {
  const n = {
    "data-testid": e["data-testid"],
    "data-cy": e["data-cy"],
    "data-qa": e["data-qa"],
    "data-automation-id": e["data-automation-id"],
    "data-analytics-id": e["data-analytics-id"]
  };
  return T(() => {
    Object.entries(n).forEach(([r, i]) => {
      i && document.querySelectorAll(`[${r}="${i}"]`).length > 1 && console.warn(`Duplicate ID found for "${r}" = "${i}"`);
    });
  }, [n]), /* @__PURE__ */ u(Ei, { ref: t, ...n, ...e });
});
Dq.displayName = "Trackable";
const Rq = W(
  ({ icon: e = "Upload", label: t, description: n, accept: r, disabled: i, multiple: a, onChange: c, children: d, ...f }, p) => /* @__PURE__ */ V(
    "div",
    {
      className: S("relative overflow-hidden", {
        "w-fit": d
      }),
      children: [
        /* @__PURE__ */ u(
          "input",
          {
            type: "file",
            className: S("peer absolute inset-0 z-10 h-full w-full opacity-0", {
              "cursor-pointer": !i,
              "cursor-not-allowed": i
            }),
            accept: r,
            disabled: i,
            multiple: a,
            onChange: (m) => {
              const v = m.target.files;
              c(v ? Array.from(v) : null);
            },
            role: "input",
            ...f,
            ref: p
          }
        ),
        d || /* @__PURE__ */ V(
          "div",
          {
            className: S(
              "bg-upload-background border-upload-border relative flex items-center justify-center gap-8 overflow-hidden border border-2 border-dashed px-4 py-6",
              "peer-focus-visible:ring-ring peer-focus-visible:ring-2 peer-focus-visible:outline-hidden",
              {
                "cursor-pointer": !i,
                "cursor-not-allowed": i
              }
            ),
            children: [
              /* @__PURE__ */ u("div", { className: S("text-upload-icon flex"), children: /* @__PURE__ */ u(Re, { name: e, size: "lg" }) }),
              /* @__PURE__ */ V("div", { className: S("flex flex-col gap-2"), children: [
                /* @__PURE__ */ u("div", { className: S("text-upload-title text-sm"), children: t }),
                n ? /* @__PURE__ */ u("div", { className: S("text-upload-description text-xs"), children: n }) : null
              ] })
            ]
          }
        )
      ]
    }
  )
);
Rq.displayName = "Upload";
var _q = (e) => e.type === "checkbox", Pq = (e) => e instanceof Date, up = (e) => e == null;
const Hq = (e) => typeof e == "object";
var Ti = (e) => !up(e) && !Array.isArray(e) && Hq(e) && !Pq(e), Oq = (e) => Ti(e) && e.target ? _q(e.target) ? e.target.checked : e.target.value : e, Nq = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Bq = (e, t) => e.has(Nq(t)), Iq = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Ti(t) && t.hasOwnProperty("isPrototypeOf");
}, Tq = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function fp(e) {
  let t;
  const n = Array.isArray(e), r = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(Tq && (e instanceof Blob || r)) && (n || Ti(e)))
    if (t = n ? [] : {}, !n && !Iq(e))
      t = e;
    else
      for (const i in e)
        e.hasOwnProperty(i) && (t[i] = fp(e[i]));
  else
    return e;
  return t;
}
var hp = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Bs = (e) => e === void 0, sn = (e, t, n) => {
  if (!t || !Ti(e))
    return n;
  const r = hp(t.split(/[,[\].]+?/)).reduce((i, a) => up(i) ? i : i[a], e);
  return Bs(r) || r === e ? Bs(e[t]) ? n : e[t] : r;
}, os = (e) => typeof e == "boolean", Vq = (e) => /^\w*$/.test(e), Zq = (e) => hp(e.replace(/["|']|\]/g, "").split(/\.|\[/)), m6 = (e, t, n) => {
  let r = -1;
  const i = Vq(t) ? [t] : Zq(t), a = i.length, c = a - 1;
  for (; ++r < a; ) {
    const d = i[r];
    let f = n;
    if (r !== c) {
      const p = e[d];
      f = Ti(p) || Array.isArray(p) ? p : isNaN(+i[r + 1]) ? {} : [];
    }
    if (d === "__proto__" || d === "constructor" || d === "prototype")
      return;
    e[d] = f, e = e[d];
  }
};
const v6 = {
  BLUR: "blur",
  CHANGE: "change"
}, g6 = {
  all: "all"
}, pp = o.createContext(null), ao = () => o.useContext(pp), $q = (e) => {
  const { children: t, ...n } = e;
  return o.createElement(pp.Provider, { value: n }, t);
};
var Wq = (e, t, n, r = !0) => {
  const i = {
    defaultValues: t._defaultValues
  };
  for (const a in e)
    Object.defineProperty(i, a, {
      get: () => {
        const c = a;
        return t._proxyFormState[c] !== g6.all && (t._proxyFormState[c] = !r || g6.all), n && (n[c] = !0), e[c];
      }
    });
  return i;
};
const mp = typeof window < "u" ? M.useLayoutEffect : M.useEffect;
function Gq(e) {
  const t = ao(), { control: n = t.control, disabled: r, name: i, exact: a } = e || {}, [c, d] = o.useState(n._formState), f = o.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return mp(() => n._subscribe({
    name: i,
    formState: f.current,
    exact: a,
    callback: (p) => {
      !r && d({
        ...n._formState,
        ...p
      });
    }
  }), [i, r, a]), o.useEffect(() => {
    f.current.isValid && n._setValid(!0);
  }, [n]), o.useMemo(() => Wq(c, n, f.current, !1), [c, n]);
}
var Uq = (e) => typeof e == "string", jq = (e, t, n, r, i) => Uq(e) ? sn(n, e, i) : Array.isArray(e) ? e.map((a) => sn(n, a)) : n;
function Kq(e) {
  const t = ao(), { control: n = t.control, name: r, defaultValue: i, disabled: a, exact: c } = e || {}, d = o.useRef(i), [f, p] = o.useState(n._getWatch(r, d.current));
  return mp(() => n._subscribe({
    name: r,
    formState: {
      values: !0
    },
    exact: c,
    callback: (m) => !a && p(jq(r, n._names, m.values || n._formValues, !1, d.current))
  }), [r, n, a, c]), o.useEffect(() => n._removeUnmounted()), f;
}
function Yq(e) {
  const t = ao(), { name: n, disabled: r, control: i = t.control, shouldUnregister: a } = e, c = Bq(i._names.array, n), d = Kq({
    control: i,
    name: n,
    defaultValue: sn(i._formValues, n, sn(i._defaultValues, n, e.defaultValue)),
    exact: !0
  }), f = Gq({
    control: i,
    name: n,
    exact: !0
  }), p = o.useRef(e), m = o.useRef(i.register(n, {
    ...e.rules,
    value: d,
    ...os(e.disabled) ? { disabled: e.disabled } : {}
  })), v = o.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!sn(f.errors, n)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!sn(f.dirtyFields, n)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!sn(f.touchedFields, n)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!sn(f.validatingFields, n)
    },
    error: {
      enumerable: !0,
      get: () => sn(f.errors, n)
    }
  }), [f, n]), g = o.useCallback((y) => m.current.onChange({
    target: {
      value: Oq(y),
      name: n
    },
    type: v6.CHANGE
  }), [n]), w = o.useCallback(() => m.current.onBlur({
    target: {
      value: sn(i._formValues, n),
      name: n
    },
    type: v6.BLUR
  }), [n, i._formValues]), x = o.useCallback((y) => {
    const E = sn(i._fields, n);
    E && y && (E._f.ref = {
      focus: () => y.focus && y.focus(),
      select: () => y.select && y.select(),
      setCustomValidity: (z) => y.setCustomValidity(z),
      reportValidity: () => y.reportValidity()
    });
  }, [i._fields, n]), b = o.useMemo(() => ({
    name: n,
    value: d,
    ...os(r) || f.disabled ? { disabled: f.disabled || r } : {},
    onChange: g,
    onBlur: w,
    ref: x
  }), [n, r, f.disabled, g, w, x, d]);
  return o.useEffect(() => {
    const y = i._options.shouldUnregister || a;
    i.register(n, {
      ...p.current.rules,
      ...os(p.current.disabled) ? { disabled: p.current.disabled } : {}
    });
    const E = (z, k) => {
      const R = sn(i._fields, z);
      R && R._f && (R._f.mount = k);
    };
    if (E(n, !0), y) {
      const z = fp(sn(i._options.defaultValues, n));
      m6(i._defaultValues, n, z), Bs(sn(i._formValues, n)) && m6(i._formValues, n, z);
    }
    return !c && i.register(n), () => {
      (c ? y && !i._state.action : y) ? i.unregister(n) : E(n, !1);
    };
  }, [n, i, c, a]), o.useEffect(() => {
    i._setDisabledField({
      disabled: r,
      name: n
    });
  }, [r, n, i]), o.useMemo(() => ({
    field: b,
    formState: f,
    fieldState: v
  }), [b, f, v]);
}
const qq = (e) => e.render(Yq(e)), bX = $q, vp = O2({}), yX = ({
  ...e
}) => /* @__PURE__ */ u(vp.Provider, { value: { name: e.name }, children: /* @__PURE__ */ u(qq, { ...e }) }), Xq = () => {
  const e = pt(vp), t = pt(gp), { getFieldState: n, formState: r } = ao(), i = n(e.name, r);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: a } = t;
  return {
    id: a,
    name: e.name,
    formItemId: `${a}-form-item`,
    formDescriptionId: `${a}-form-item-description`,
    formMessageId: `${a}-form-item-message`,
    ...i
  };
}, gp = O2({}), Jq = W(({ className: e, ...t }, n) => {
  const r = bl();
  return /* @__PURE__ */ u(gp.Provider, { value: { id: r }, children: /* @__PURE__ */ u("div", { ref: n, className: S("space-y-2", e), ...t }) });
});
Jq.displayName = "FormItem";
const Qq = W(({ ...e }, t) => {
  const { error: n, formItemId: r, formDescriptionId: i, formMessageId: a } = Xq();
  return /* @__PURE__ */ u(
    Ei,
    {
      ref: t,
      id: r,
      "aria-describedby": n ? `${i} ${a}` : `${i}`,
      "aria-invalid": !!n,
      ...e
    }
  );
});
Qq.displayName = "FormControl";
export {
  RP as $,
  eE as A,
  E3 as B,
  Yl as C,
  q_ as D,
  uf as E,
  uP as F,
  fP as G,
  hP as H,
  pP as I,
  mP as J,
  vP as K,
  gP as L,
  Il as M,
  b3 as N,
  lS as O,
  oS as P,
  aS as Q,
  Tl as R,
  Vl as S,
  sS as T,
  cS as U,
  wP as V,
  xP as W,
  bP as X,
  SP as Y,
  kP as Z,
  DP as _,
  tE as a,
  rC as a$,
  _P as a0,
  PP as a1,
  HP as a2,
  OP as a3,
  NP as a4,
  BP as a5,
  IP as a6,
  TP as a7,
  VP as a8,
  pf as a9,
  ky as aA,
  Dy as aB,
  Ry as aC,
  _y as aD,
  Py as aE,
  Hy as aF,
  Oy as aG,
  Ny as aH,
  By as aI,
  Iy as aJ,
  Ty as aK,
  Vy as aL,
  Zy as aM,
  $y as aN,
  Wy as aO,
  Gy as aP,
  Uy as aQ,
  jy as aR,
  Ky as aS,
  Yy as aT,
  qy as aU,
  Xy as aV,
  Jy as aW,
  Qy as aX,
  eC as aY,
  tC as aZ,
  nC as a_,
  pX as aa,
  Mi as ab,
  hW as ac,
  pW as ad,
  sy as ae,
  cy as af,
  dy as ag,
  uy as ah,
  fy as ai,
  hy as aj,
  py as ak,
  my as al,
  vy as am,
  gy as an,
  Ly as ao,
  wy as ap,
  My as aq,
  xy as ar,
  by as as,
  yy as at,
  Cy as au,
  Ey as av,
  Fy as aw,
  zy as ax,
  Ay as ay,
  Sy as az,
  nE as b,
  bU as b$,
  iC as b0,
  lC as b1,
  oC as b2,
  aC as b3,
  sC as b4,
  cC as b5,
  dC as b6,
  uC as b7,
  fC as b8,
  hC as b9,
  TC as bA,
  VC as bB,
  ZC as bC,
  $C as bD,
  WC as bE,
  GC as bF,
  UC as bG,
  jC as bH,
  KC as bI,
  YC as bJ,
  qC as bK,
  XC as bL,
  JC as bM,
  QC as bN,
  G6 as bO,
  lX as bP,
  Re as bQ,
  V3 as bR,
  mW as bS,
  vf as bT,
  jn as bU,
  d2 as bV,
  gW as bW,
  gf as bX,
  wW as bY,
  bW as bZ,
  y9 as b_,
  pC as ba,
  mC as bb,
  vC as bc,
  gC as bd,
  LC as be,
  wC as bf,
  MC as bg,
  xC as bh,
  bC as bi,
  yC as bj,
  CC as bk,
  EC as bl,
  FC as bm,
  zC as bn,
  AC as bo,
  SC as bp,
  kC as bq,
  DC as br,
  RC as bs,
  _C as bt,
  PC as bu,
  HC as bv,
  OC as bw,
  NC as bx,
  BC as by,
  IC as bz,
  rE as c,
  qY as c$,
  Xj as c0,
  Qj as c1,
  sh as c2,
  ch as c3,
  X0 as c4,
  dh as c5,
  uh as c6,
  fh as c7,
  hh as c8,
  Zr as c9,
  Uj as cA,
  n5 as cB,
  jj as cC,
  r5 as cD,
  wl as cE,
  Kj as cF,
  Ml as cG,
  Yj as cH,
  qj as cI,
  yi as cJ,
  FK as cK,
  zK as cL,
  PK as cM,
  Oh as cN,
  Nh as cO,
  Bh as cP,
  Ih as cQ,
  Ci as cR,
  Ps as cS,
  c5 as cT,
  DY as cU,
  _Y as cV,
  TY as cW,
  VY as cX,
  ZY as cY,
  $Y as cZ,
  UY as c_,
  R1 as ca,
  $r as cb,
  sK as cc,
  hf as cd,
  uK as ce,
  fK as cf,
  eo as cg,
  hK as ch,
  pK as ci,
  wh as cj,
  mK as ck,
  Mh as cl,
  gK as cm,
  LK as cn,
  MK as co,
  bK as cp,
  yK as cq,
  Zj as cr,
  $j as cs,
  lh as ct,
  oh as cu,
  Wj as cv,
  Q3 as cw,
  e5 as cx,
  Gj as cy,
  t5 as cz,
  sE as d,
  JY as d0,
  sp as d1,
  zq as d2,
  xX as d3,
  dp as d4,
  Aq as d5,
  Sq as d6,
  kq as d7,
  Gl as d8,
  Ul as d9,
  D3 as dA,
  s2 as dB,
  F_ as dC,
  z_ as dD,
  A_ as dE,
  ei as dF,
  k_ as dG,
  R_ as dH,
  __ as dI,
  P_ as dJ,
  H_ as dK,
  O_ as dL,
  N_ as dM,
  jl as da,
  Dq as db,
  x_ as dc,
  tt as dd,
  Rq as de,
  Xq as df,
  bX as dg,
  Jq as dh,
  Qq as di,
  yX as dj,
  S as dk,
  i_ as dl,
  r_ as dm,
  o_ as dn,
  u_ as dp,
  f_ as dq,
  h_ as dr,
  p_ as ds,
  m_ as dt,
  v_ as du,
  g_ as dv,
  L_ as dw,
  w_ as dx,
  b_ as dy,
  C_ as dz,
  J6 as e,
  Q6 as f,
  e7 as g,
  PS as h,
  Hr as i,
  r9 as j,
  NR as k,
  BR as l,
  IR as m,
  TR as n,
  VR as o,
  Rr as p,
  YR as q,
  I_ as r,
  T_ as s,
  sr as t,
  X_ as u,
  J_ as v,
  sP as w,
  cP as x,
  df as y,
  dP as z
};
